/* eslint-disable */

export const AllTypesProps: Record<string,any> = {
	Query:{
		getContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactPage:{
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactPage:{
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactPage:{
			data:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactPageLocale:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactPageLocale:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactPageLocale:{
			data:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePageLocale:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePageLocale:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePageLocale:{
			data:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumItem:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumItem:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumItem:{
			data:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumList:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumList:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumList:{
			data:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoDefault:{
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoDefault:{
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoDefault:{
			data:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoDefaultLocale:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoDefaultLocale:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoDefaultLocale:{
			data:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBranches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBranches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBranches:{
			data:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGraphicDesigner:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGraphicDesigner:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGraphicDesigner:{
			data:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtwork:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtwork:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtwork:{
			data:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkLocale:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkLocale:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkLocale:{
			data:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDropDownItem:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDropDownItem:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDropDownItem:{
			data:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDropDownList:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDropDownList:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDropDownList:{
			data:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkItem:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkItem:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkItem:{
			data:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkList:{
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkList:{
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkList:{
			data:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelection:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelection:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelection:{
			data:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionItem:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionItem:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionItem:{
			data:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionList:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionList:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionList:{
			data:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionLocale:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionLocale:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionLocale:{
			data:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventItem:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventItem:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventItem:{
			data:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventList:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventList:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventList:{
			data:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBoxItem:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBoxItem:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBoxItem:{
			data:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBoxList:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBoxList:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBoxList:{
			data:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterForm:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterForm:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterForm:{
			data:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterTypeItem:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterTypeItem:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterTypeItem:{
			data:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterFormLocale:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterFormLocale:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterFormLocale:{
			data:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterSubscription:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterSubscription:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterSubscription:{
			data:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listChart:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateChart:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateChart:{
			data:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listChartData:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateChartData:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateChartData:{
			data:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployee:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployee:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployee:{
			data:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeItem:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeItem:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeItem:{
			data:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeList:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeList:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeList:{
			data:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeLocale:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeLocale:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeLocale:{
			data:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDefinitionItem:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDefinitionItem:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDefinitionItem:{
			data:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDefinitionList:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDefinitionList:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDefinitionList:{
			data:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLogoItem:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLogoItem:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLogoItem:{
			data:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLogoList:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLogoList:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLogoList:{
			data:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchema:{
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchema:{
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchema:{
			data:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchemaGroup:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchemaGroup:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchemaGroup:{
			data:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchemaGroupItem:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchemaGroupItem:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchemaGroupItem:{
			data:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactForm:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactForm:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactForm:{
			data:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactFormLocale:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactFormLocale:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactFormLocale:{
			data:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactSubscription:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactSubscription:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactSubscription:{
			data:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactTypeItem:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactTypeItem:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactTypeItem:{
			data:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	ContactPage:{
		locales:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"ContactPageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"ContactPageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"ContactPageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByAddressLink:{
			by:{
				type:"ContactPageLocalesByAddressLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	UUID: "String",
	One: "enum",
	ContactPageLocale:{
		root:{
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		addressLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactPageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactPageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	UUIDCondition:{
		and:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"UUIDCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"UUID",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OneCondition:{
		and:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"OneCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"One",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactPageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StringCondition:{
		and:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"StringCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"String",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contains:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWith:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		containsCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		startsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		endsWithCI:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"ContactPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePages:{
			type:"HomePageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pages:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seoDefaults:{
			type:"SeoDefaultLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelections:{
			type:"ArtworkSelectionLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForms:{
			type:"NewsletterFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"EmployeeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForms:{
			type:"ContactFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"GraphicDesignerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		developerLink:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FooterWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FooterWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ImageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	IntCondition:{
		and:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"IntCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Int",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GraphicDesignerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GraphicDesignerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GraphicDesignerWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		anchorLink:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkTypeCondition:{
		and:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"LinkTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"LinkTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"LinkType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkType: "enum",
	LinkableWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"ContactPageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ArtworkSelectionLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LinkableWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"BranchesWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HomePageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HomePageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HomePageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MediumListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeEmbed:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"MediumWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"MediumWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"MediumWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumTypeCondition:{
		and:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"MediumTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"MediumTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"MediumType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumType: "enum",
	VideoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"VideoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"VideoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FloatCondition:{
		and:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"FloatCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Float",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentBlockWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"DropDownListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ArtworkSelectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"EventListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"BoxListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ChartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"DefinitionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"LogoListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"StrategySchemaWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"EmployeeListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContactFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"NewsletterFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContentReferenceWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContentReferenceWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceTypeCondition:{
		and:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ContentReferenceTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ContentReferenceTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ContentReferenceType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceType: "enum",
	DropDownListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DropDownItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownType:{
			type:"DropDownTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"EmployeeListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DropDownListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DropDownListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DropDownListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DropDownListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DropDownItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DropDownItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DropDownItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownTypeCondition:{
		and:{
			type:"DropDownTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DropDownTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DropDownTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"DropDownType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"DropDownType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownType: "enum",
	EmployeeListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EmployeeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EmployeeListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EmployeeListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EmployeeListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EmployeeListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EmployeeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EmployeeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EmployeeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EmployeeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EmployeeWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EmployeeWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EmployeeWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EmployeeLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EmployeeLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EmployeeLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkSelectionLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkSelectionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkSelectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkSelectionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkSelectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkSelectionLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkSelectionLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkSelectionLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BooleanCondition:{
		and:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"BooleanCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Boolean",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkSelectionItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkSelectionListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkSelectionListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkSelectionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkSelectionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkSelectionItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkSelectionItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkSelectionItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"GalleryItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"GalleryItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EventItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EventListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"BooleanCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"EventLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"EventLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"EventLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTimeCondition:{
		and:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateTimeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"DateTime",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateTime: "String",
	BoxListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BoxItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BoxListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BoxListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BoxListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BoxListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BoxItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BoxItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BoxItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ChartTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ChartDataWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ChartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ChartWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ChartWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartTypeCondition:{
		and:{
			type:"ChartTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"ChartTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"ChartTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"ChartType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"ChartType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartType: "enum",
	ChartDataWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ChartWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"FloatCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ChartDataWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ChartDataWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ChartDataWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DateCondition:{
		and:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"DateCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"DateCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"Date",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Date: "String",
	DefinitionListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DefinitionItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DefinitionListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DefinitionListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DefinitionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DefinitionListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"DefinitionItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"DefinitionItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"DefinitionItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LogoItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LogoListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LogoListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LogoListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LogoListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"LogoItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"LogoItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"LogoItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputFirst:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputSecond:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputThird:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputFirst:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputSecond:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputThird:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsFirst:{
			type:"StrategySchemaGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsSecond:{
			type:"StrategySchemaGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StrategySchemaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StrategySchemaWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StrategySchemaWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StrategySchemaGroupItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StrategySchemaGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StrategySchemaGroupWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StrategySchemaGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		schema:{
			type:"StrategySchemaGroupWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"StrategySchemaGroupItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"StrategySchemaGroupItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"StrategySchemaGroupItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactFormLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactFormLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactSubscriptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContactFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactTypeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactTypeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactType:{
			type:"ContactTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ContactSubscriptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ContactSubscriptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ContactSubscriptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"FileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"FileWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"FileWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"NewsletterFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterFormWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterFormLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterFormLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterFormLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterSubscriptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterTypeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterTypeItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTimeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterType:{
			type:"NewsletterTypeItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"NewsletterSubscriptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"NewsletterSubscriptionWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"NewsletterSubscriptionWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		more:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"BranchesWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"BranchesWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"BranchesWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PageWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PageWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"RedirectWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"RedirectWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"PhotographerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"PhotographerWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"PhotographerWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkBreadcrumbParentLink:{
			type:"LinkableWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"HeaderLinkWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"HeaderLinkWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoDefaultWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoDefaultLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoDefaultLocaleWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoDefaultLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OneCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoDefaultLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"SeoDefaultWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"SeoDefaultWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"SeoDefaultWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Locale:{
		contactPages:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footers:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headers:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePages:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pages:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seoDefaults:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		events:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworks:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelections:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsletterForms:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		employees:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactForms:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactPagesByRoot:{
			by:{
				type:"LocaleContactPagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactPagesByLink:{
			by:{
				type:"LocaleContactPagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactPagesBySeo:{
			by:{
				type:"LocaleContactPagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactPagesByAddressLink:{
			by:{
				type:"LocaleContactPagesByAddressLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footersByRoot:{
			by:{
				type:"LocaleFootersByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		footersByDeveloperLink:{
			by:{
				type:"LocaleFootersByDeveloperLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersByRoot:{
			by:{
				type:"LocaleHeadersByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		headersByArtworkBreadcrumbParentLink:{
			by:{
				type:"LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePagesByRoot:{
			by:{
				type:"LocaleHomePagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePagesByContent:{
			by:{
				type:"LocaleHomePagesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePagesByLink:{
			by:{
				type:"LocaleHomePagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		homePagesBySeo:{
			by:{
				type:"LocaleHomePagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByRoot:{
			by:{
				type:"LocalePagesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByLink:{
			by:{
				type:"LocalePagesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesByContent:{
			by:{
				type:"LocalePagesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		pagesBySeo:{
			by:{
				type:"LocalePagesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seoDefaultsByRoot:{
			by:{
				type:"LocaleSeoDefaultsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seoDefaultsBySeo:{
			by:{
				type:"LocaleSeoDefaultsBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByRoot:{
			by:{
				type:"LocaleEventsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByImage:{
			by:{
				type:"LocaleEventsByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsBySeo:{
			by:{
				type:"LocaleEventsBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByLink:{
			by:{
				type:"LocaleEventsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventsByContent:{
			by:{
				type:"LocaleEventsByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworksByRoot:{
			by:{
				type:"LocaleArtworksByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworksByContent:{
			by:{
				type:"LocaleArtworksByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworksBySeo:{
			by:{
				type:"LocaleArtworksBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworksByLink:{
			by:{
				type:"LocaleArtworksByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelectionsByRoot:{
			by:{
				type:"LocaleArtworkSelectionsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelectionsBySeo:{
			by:{
				type:"LocaleArtworkSelectionsBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelectionsByLink:{
			by:{
				type:"LocaleArtworkSelectionsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsletterFormsByRoot:{
			by:{
				type:"LocaleNewsletterFormsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsletterFormsByItems:{
			by:{
				type:"LocaleNewsletterFormsByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		employeesByRoot:{
			by:{
				type:"LocaleEmployeesByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactFormsByRoot:{
			by:{
				type:"LocaleContactFormsByRootUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactFormsByItems:{
			by:{
				type:"LocaleContactFormsByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactPages:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooters:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaders:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePages:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePages:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoDefaults:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvents:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworks:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelections:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterForms:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployees:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactForms:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactPageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	OrderDirection: "enum",
	ContactPageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"ContactPageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ArtworkSelectionLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkSelectionListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		anchorLink:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocale:{
		root:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		graphicDesigners:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		developerLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		photographers:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGraphicDesigners:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographers:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Footer:{
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"FooterLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByDeveloperLink:{
			by:{
				type:"FooterLocalesByDeveloperLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	FooterLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		developerLink:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		headers:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePages:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		pages:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seoDefaults:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		events:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelections:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForms:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForms:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"StrategySchemaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsFirst:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsSecond:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkSelectionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		developerLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkBreadcrumbParentLink:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoDefaultUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocalesByDeveloperLinkUniqueWhere:{
		developerLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesigner:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Link:{
		internalLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Linkable:{
		homePage:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactPage:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		page:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		event:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artwork:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelection:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		redirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomePageLocale:{
		root:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		branches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBranches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HomePage:{
		locales:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		media:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"HomePageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"HomePageLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"HomePageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"HomePageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MediumList:{
		items:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MediumItem:{
		list:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		medium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Medium:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		video:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Video:{
		poster:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	MediumItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MediumListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"VideoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeEmbed:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Content:{
		blocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		blocksByReferences:{
			by:{
				type:"ContentBlocksByReferencesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBlocks:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentBlock:{
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		references:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByMedia:{
			by:{
				type:"ContentBlockReferencesByMediaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLink:{
			by:{
				type:"ContentBlockReferencesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByDropDownList:{
			by:{
				type:"ContentBlockReferencesByDropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByEventList:{
			by:{
				type:"ContentBlockReferencesByEventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByBoxList:{
			by:{
				type:"ContentBlockReferencesByBoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByChart:{
			by:{
				type:"ContentBlockReferencesByChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByDefinitionList:{
			by:{
				type:"ContentBlockReferencesByDefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByLogoList:{
			by:{
				type:"ContentBlockReferencesByLogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByStrategySchema:{
			by:{
				type:"ContentBlockReferencesByStrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		referencesByEmployeeList:{
			by:{
				type:"ContentBlockReferencesByEmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateReferences:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContentReference:{
		block:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		media:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		dropDownList:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkSelection:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		eventList:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		boxList:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		chart:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		definitionList:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logoList:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		strategySchema:{
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		employeeList:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		imageSecond:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactForm:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		newsletterForm:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DropDownList:{
		items:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		employees:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsByLink:{
			by:{
				type:"DropDownListItemsByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DropDownItem:{
		list:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DropDownItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DropDownListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"EmployeeListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeList:{
		items:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EmployeeItem:{
		list:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		employee:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Employee:{
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locales:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"EmployeeLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EmployeeLocale:{
		root:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EmployeeLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EmployeeListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListItemsByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelection:{
		locales:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworks:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"ArtworkSelectionLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"ArtworkSelectionLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"ArtworkSelectionLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkSelectionLocale:{
		root:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Seo:{
		ogImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkSelectionList:{
		items:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkSelectionItem:{
		list:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artwork:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Artwork:{
		locales:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		gallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"ArtworkLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"ArtworkLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"ArtworkLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"ArtworkLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkLocale:{
		root:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Gallery:{
		items:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItem:{
		list:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GalleryItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkSelectionListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventList:{
		items:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventItem:{
		list:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		event:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Event:{
		locales:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"EventLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByImage:{
			by:{
				type:"EventLocalesByImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"EventLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"EventLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"EventLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLocale:{
		root:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	EventLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EventListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxList:{
		items:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BoxItem:{
		list:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BoxItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BoxListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Chart:{
		items:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ChartData:{
		list:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ChartDataOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ChartOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionList:{
		items:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DefinitionItem:{
		list:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	DefinitionItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DefinitionListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoList:{
		items:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LogoItem:{
		list:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		image:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	LogoItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LogoListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchema:{
		itemsFirst:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsSecond:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StrategySchemaGroup:{
		items:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StrategySchemaGroupItem:{
		schema:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	StrategySchemaGroupItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		schema:{
			type:"StrategySchemaGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactForm:{
		locales:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"ContactFormLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByItems:{
			by:{
				type:"ContactFormLocalesByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactFormLocale:{
		root:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsBySubscriptions:{
			by:{
				type:"ContactFormLocaleItemsBySubscriptionsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactTypeItem:{
		subscriptions:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		list:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subscriptionsByFile:{
			by:{
				type:"ContactTypeItemSubscriptionsByFileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptions:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactSubscription:{
		file:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		contactType:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ContactSubscriptionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"FileOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactType:{
			type:"ContactTypeItemOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContactFormLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemSubscriptionsByFileUniqueWhere:{
		file:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleItemsBySubscriptionsUniqueWhere:{
		subscriptions:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocalesByItemsUniqueWhere:{
		items:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterForm:{
		locales:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"NewsletterFormLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByItems:{
			by:{
				type:"NewsletterFormLocalesByItemsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsletterFormLocale:{
		root:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		items:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		itemsBySubscriptions:{
			by:{
				type:"NewsletterFormLocaleItemsBySubscriptionsUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsletterTypeItem:{
		list:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		subscriptions:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSubscriptions:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsletterSubscription:{
		newsletterType:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	NewsletterSubscriptionOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterType:{
			type:"NewsletterTypeItemOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterFormLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleItemsBySubscriptionsUniqueWhere:{
		subscriptions:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocalesByItemsUniqueWhere:{
		items:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentBlockOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"MediumListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"DropDownListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ArtworkSelectionOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"EventListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"BoxListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ChartOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"DefinitionListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"LogoListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"StrategySchemaOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"EmployeeListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContactFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"NewsletterFormOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputFirst:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputSecond:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputThird:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputFirst:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputSecond:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputThird:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsFirst:{
			type:"StrategySchemaGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsSecond:{
			type:"StrategySchemaGroupOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByMediaUniqueWhere:{
		media:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByLinkUniqueWhere:{
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByDropDownListUniqueWhere:{
		dropDownList:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByEventListUniqueWhere:{
		eventList:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByBoxListUniqueWhere:{
		boxList:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByChartUniqueWhere:{
		chart:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByDefinitionListUniqueWhere:{
		definitionList:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByLogoListUniqueWhere:{
		logoList:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByStrategySchemaUniqueWhere:{
		strategySchema:{
			type:"StrategySchemaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockReferencesByEmployeeListUniqueWhere:{
		employeeList:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlocksByReferencesUniqueWhere:{
		references:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Branches:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	BranchesOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		more:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocale:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		root:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		content:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Page:{
		locales:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"PageLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLink:{
			by:{
				type:"PageLocalesByLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByContent:{
			by:{
				type:"PageLocalesByContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"PageLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Redirect:{
		link:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		target:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	GraphicDesignerOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Photographer:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	PhotographerOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocale:{
		root:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		links:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artworkBreadcrumbParentLink:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinks:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	Header:{
		locales:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		logo:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"HeaderLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByArtworkBreadcrumbParentLink:{
			by:{
				type:"HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkBreadcrumbParentLink:{
			type:"LinkableOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"ImageOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere:{
		artworkBreadcrumbParentLink:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLink:{
		link:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	HeaderLinkOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocale:{
		root:{
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		locale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		seo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SeoDefault:{
		locales:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesByLocale:{
			by:{
				type:"SeoDefaultLocalesByLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		localesBySeo:{
			by:{
				type:"SeoDefaultLocalesBySeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocales:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	SeoDefaultLocaleOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoDefaultOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"LocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactPagesByRootUniqueWhere:{
		root:{
			type:"ContactPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactPagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactPagesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactPagesByAddressLinkUniqueWhere:{
		addressLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFootersByRootUniqueWhere:{
		root:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleFootersByDeveloperLinkUniqueWhere:{
		developerLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersByRootUniqueWhere:{
		root:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere:{
		artworkBreadcrumbParentLink:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHomePagesByRootUniqueWhere:{
		root:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHomePagesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHomePagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleHomePagesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByRootUniqueWhere:{
		root:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocalePagesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSeoDefaultsByRootUniqueWhere:{
		root:{
			type:"SeoDefaultUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleSeoDefaultsBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByRootUniqueWhere:{
		root:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByImageUniqueWhere:{
		image:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEventsByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworksByRootUniqueWhere:{
		root:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworksByContentUniqueWhere:{
		content:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworksBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworksByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworkSelectionsByRootUniqueWhere:{
		root:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworkSelectionsBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleArtworkSelectionsByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleNewsletterFormsByRootUniqueWhere:{
		root:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleNewsletterFormsByItemsUniqueWhere:{
		items:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleEmployeesByRootUniqueWhere:{
		root:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactFormsByRootUniqueWhere:{
		root:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleContactFormsByItemsUniqueWhere:{
		items:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocalesByLocaleUniqueWhere:{
		locale:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocalesByLinkUniqueWhere:{
		link:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocalesBySeoUniqueWhere:{
		seo:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocalesByAddressLinkUniqueWhere:{
		addressLink:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactPageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageCreateLocalesEntityRelationInput:{
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleCreateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutContactPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutContactPagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateFootersEntityRelationInput:{
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleCreateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleCreateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleCreatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateGraphicDesignersEntityRelationInput:{
		connect:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GraphicDesignerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"GraphicDesignerCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkCreateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		anchorLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkCreateInternalLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateHomePageEntityRelationInput:{
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleCreateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"HomePageCreateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateMediaEntityRelationInput:{
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"MediumListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListCreateItemsEntityRelationInput:{
		connect:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemCreateMediumEntityRelationInput:{
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumCreateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeEmbed:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumCreateVideoEntityRelationInput:{
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoCreatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoCreatePosterEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHomePagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHomePagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateContactPagesEntityRelationInput:{
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleCreateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"ContactPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutContactPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutContactPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreatePageEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutPagesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateHeadersEntityRelationInput:{
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateLinksEntityRelationInput:{
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateHomePagesEntityRelationInput:{
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleCreateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		blocks:{
			type:"ContentCreateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentCreateBlocksEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateReferencesEntityRelationInput:{
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"ContentReferenceCreateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"ContentReferenceCreateDropDownListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ContentReferenceCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"ContentReferenceCreateEventListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"ContentReferenceCreateBoxListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ContentReferenceCreateChartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"ContentReferenceCreateDefinitionListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"ContentReferenceCreateLogoListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"ContentReferenceCreateStrategySchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"ContentReferenceCreateEmployeeListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ContentReferenceCreateImageSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContentReferenceCreateContactFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"ContentReferenceCreateNewsletterFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateMediaEntityRelationInput:{
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateDropDownListEntityRelationInput:{
		connect:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DropDownListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		dropDownType:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"DropDownListCreateEmployeesEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListCreateItemsEntityRelationInput:{
		connect:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DropDownItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListCreateEmployeesEntityRelationInput:{
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EmployeeListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListCreateItemsEntityRelationInput:{
		connect:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeItemCreateEmployeeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemCreateEmployeeEntityRelationInput:{
		connect:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EmployeeCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EmployeeCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeCreateLocalesEntityRelationInput:{
		connect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EmployeeLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEmployeesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEmployeesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreatePagesEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateContactPageEntityRelationInput:{
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleCreateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoCreateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoCreateOgImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateAddressLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateEventEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEventsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateSeoDefaultsEntityRelationInput:{
		connect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoDefaultLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"SeoDefaultUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateArtworksEntityRelationInput:{
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ArtworkCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ArtworkCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkCreateGalleryEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"GalleryCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryCreateItemsEntityRelationInput:{
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutArtworkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateArtworkSelectionEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkSelectionCreateArtworksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionCreateArtworksEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkSelectionListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListCreateItemsEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkSelectionItemCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemCreateArtworkEntityRelationInput:{
		connect:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"ArtworkCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ArtworkCreateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkCreateLocalesEntityRelationInput:{
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutArtworksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutArtworksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateEventsEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateArtworkEntityRelationInput:{
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableCreateRedirectEntityRelationInput:{
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateTargetEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateArtworkSelectionsEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutArtworkSelectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateNewsletterFormsEntityRelationInput:{
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleCreateItemsEntityRelationInput:{
		connect:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterTypeItemCreateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemCreateSubscriptionsEntityRelationInput:{
		connect:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionWithoutNewsletterTypeCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateEmployeesEntityRelationInput:{
		connect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EmployeeCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateContactFormsEntityRelationInput:{
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleCreateRootEntityRelationInput:{
		connect:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormWithoutLocalesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleCreateItemsEntityRelationInput:{
		connect:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactTypeItemCreateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemCreateSubscriptionsEntityRelationInput:{
		connect:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactSubscriptionWithoutContactTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionWithoutContactTypeCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"ContactSubscriptionCreateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionCreateFileEntityRelationInput:{
		connect:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutArtworkSelectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutArtworkSelectionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateArtworkSelectionEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkSelectionCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"ArtworkSelectionCreateArtworksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionCreateLocalesEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateEventListEntityRelationInput:{
		connect:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"EventListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListCreateItemsEntityRelationInput:{
		connect:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventItemCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemCreateEventEntityRelationInput:{
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EventCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventCreateLocalesEntityRelationInput:{
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBoxListEntityRelationInput:{
		connect:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"BoxListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListCreateItemsEntityRelationInput:{
		connect:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateChartEntityRelationInput:{
		connect:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ChartCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartCreateItemsEntityRelationInput:{
		connect:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartDataWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ChartDataCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateDefinitionListEntityRelationInput:{
		connect:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"DefinitionListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListCreateItemsEntityRelationInput:{
		connect:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateLogoListEntityRelationInput:{
		connect:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"LogoListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListCreateItemsEntityRelationInput:{
		connect:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"LogoItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateStrategySchemaEntityRelationInput:{
		connect:{
			type:"StrategySchemaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputFirst:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputSecond:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputThird:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputFirst:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputSecond:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputThird:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsFirst:{
			type:"StrategySchemaCreateItemsFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"StrategySchemaCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsSecond:{
			type:"StrategySchemaCreateItemsSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaCreateItemsFirstEntityRelationInput:{
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"StrategySchemaGroupCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupCreateItemsEntityRelationInput:{
		connect:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupItemWithoutSchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemWithoutSchemaCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaCreateLogoEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaCreateItemsSecondEntityRelationInput:{
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateEmployeeListEntityRelationInput:{
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateImageSecondEntityRelationInput:{
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateContactFormEntityRelationInput:{
		connect:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactFormCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormCreateLocalesEntityRelationInput:{
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutContactFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutContactFormsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateNewsletterFormEntityRelationInput:{
		connect:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"NewsletterFormCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormCreateLocalesEntityRelationInput:{
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutNewsletterFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutNewsletterFormsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableCreateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateSeoEntityRelationInput:{
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateBranchesEntityRelationInput:{
		connect:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BranchesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		more:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"BranchesCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateDeveloperLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreatePhotographersEntityRelationInput:{
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographerCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactPageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageUpdateLocalesEntityRelationInput:{
		create:{
			type:"ContactPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactPageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageUpdateLocalesRelationInput:{
		by:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleUpdateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutContactPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutContactPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutContactPagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFootersEntityRelationInput:{
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateFootersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertFootersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateFootersRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutLocaleUpdateInput:{
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleUpdateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleUpdateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleUpdatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ImageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		alt:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertRootRelationInput:{
		update:{
			type:"FooterWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateGraphicDesignersEntityRelationInput:{
		create:{
			type:"GraphicDesignerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleUpdateGraphicDesignersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertGraphicDesignersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateGraphicDesignersRelationInput:{
		by:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"GraphicDesignerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"GraphicDesignerUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GraphicDesignerUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInput:{
		type:{
			type:"LinkType",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		externalLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		internalLink:{
			type:"LinkUpdateInternalLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		anchorLink:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpdateInternalLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkUpsertInternalLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateHomePageEntityRelationInput:{
		create:{
			type:"HomePageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertHomePageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleUpdateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"HomePageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"HomePageUpdateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateMediaEntityRelationInput:{
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertMediaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListUpdateInput:{
		items:{
			type:"MediumListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListUpdateItemsEntityRelationInput:{
		create:{
			type:"MediumItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListUpdateItemsRelationInput:{
		by:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"MediumItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUpdateMediumEntityRelationInput:{
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumItemUpsertMediumRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateInput:{
		type:{
			type:"MediumType",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"MediumUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		video:{
			type:"MediumUpdateVideoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtubeEmbed:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpdateVideoEntityRelationInput:{
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumUpsertVideoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"VideoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdateInput:{
		src:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		width:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		height:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		duration:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		poster:{
			type:"VideoUpdatePosterEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpdatePosterEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"VideoUpsertPosterRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	VideoUpsertPosterRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumUpsertVideoRelationInput:{
		update:{
			type:"VideoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"VideoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUpsertMediumRelationInput:{
		update:{
			type:"MediumUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListUpsertItemsRelationInput:{
		by:{
			type:"MediumItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertMediaRelationInput:{
		update:{
			type:"MediumListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertRootRelationInput:{
		update:{
			type:"HomePageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutHomePagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutHomePagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHomePagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateContactPagesEntityRelationInput:{
		create:{
			type:"ContactPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateContactPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertContactPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateContactPagesRelationInput:{
		by:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleUpdateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"ContactPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactPageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpsertRootRelationInput:{
		update:{
			type:"ContactPageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutContactPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutContactPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutContactPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdatePageEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageWithoutLocalesUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertRootRelationInput:{
		update:{
			type:"PageWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutPagesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHeadersEntityRelationInput:{
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateHeadersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertHeadersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHeadersRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutLocaleUpdateInput:{
		root:{
			type:"HeaderLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertRootRelationInput:{
		update:{
			type:"HeaderWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateLinksEntityRelationInput:{
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleUpdateLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertLinksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HeaderLinkUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLinkUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLinkUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertLinksRelationInput:{
		by:{
			type:"HeaderLinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertHeadersRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHomePagesEntityRelationInput:{
		create:{
			type:"HomePageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateHomePagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertHomePagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateHomePagesRelationInput:{
		by:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HomePageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleUpdateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateInput:{
		blocks:{
			type:"ContentUpdateBlocksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentUpsertBlocksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpdateBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutContentUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesEntityRelationInput:{
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockUpdateReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertReferencesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceWithoutBlockUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"ContentReferenceUpdateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"ContentReferenceUpdateDropDownListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ContentReferenceUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"ContentReferenceUpdateEventListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"ContentReferenceUpdateBoxListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ContentReferenceUpdateChartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"ContentReferenceUpdateDefinitionListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"ContentReferenceUpdateLogoListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"ContentReferenceUpdateStrategySchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"ContentReferenceUpdateEmployeeListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ContentReferenceUpdateImageSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContentReferenceUpdateContactFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"ContentReferenceUpdateNewsletterFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateMediaEntityRelationInput:{
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertMediaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertMediaRelationInput:{
		update:{
			type:"MediumListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateDropDownListEntityRelationInput:{
		create:{
			type:"DropDownListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DropDownListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertDropDownListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpdateInput:{
		items:{
			type:"DropDownListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		dropDownType:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"DropDownListUpdateEmployeesEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpdateItemsEntityRelationInput:{
		create:{
			type:"DropDownItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DropDownListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DropDownListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpdateItemsRelationInput:{
		by:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"DropDownItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DropDownItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DropDownItemUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpsertItemsRelationInput:{
		by:{
			type:"DropDownItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DropDownItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpdateEmployeesEntityRelationInput:{
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DropDownListUpsertEmployeesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListUpdateInput:{
		items:{
			type:"EmployeeListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListUpdateItemsEntityRelationInput:{
		create:{
			type:"EmployeeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListUpdateItemsRelationInput:{
		by:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EmployeeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeItemUpdateEmployeeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUpdateEmployeeEntityRelationInput:{
		create:{
			type:"EmployeeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeItemUpsertEmployeeRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EmployeeUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"EmployeeUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpdateLocalesEntityRelationInput:{
		create:{
			type:"EmployeeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpdateLocalesRelationInput:{
		by:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EmployeeLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleWithoutRootUpdateInput:{
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EmployeeLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutEmployeesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutEmployeesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEmployeesUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdatePagesEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdatePagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertPagesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdatePagesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutPageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateContactPageEntityRelationInput:{
		create:{
			type:"ContactPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertContactPageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleUpdateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		description:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogTitle:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogDescription:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		noIndex:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		noFollow:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		ogImage:{
			type:"SeoUpdateOgImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpdateOgImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoUpsertOgImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoUpsertOgImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateAddressLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactPageLocaleUpsertAddressLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpsertAddressLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertContactPageRelationInput:{
		update:{
			type:"ContactPageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateEventEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertRootRelationInput:{
		update:{
			type:"EventWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutEventsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutEventsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSeoDefaultsEntityRelationInput:{
		create:{
			type:"SeoDefaultLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateSeoDefaultsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertSeoDefaultsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateSeoDefaultsRelationInput:{
		by:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SeoDefaultLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleWithoutLocaleUpdateInput:{
		root:{
			type:"SeoDefaultLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"SeoDefaultWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoDefaultWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoDefaultLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoDefaultUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpsertRootRelationInput:{
		update:{
			type:"SeoDefaultWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoDefaultLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertSeoDefaultsRelationInput:{
		by:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoDefaultLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateArtworksEntityRelationInput:{
		create:{
			type:"ArtworkLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateArtworksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertArtworksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateArtworksRelationInput:{
		by:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"ArtworkWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ArtworkUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ArtworkUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpdateGalleryEntityRelationInput:{
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkUpsertGalleryRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateInput:{
		items:{
			type:"GalleryUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsEntityRelationInput:{
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpdateItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryUpsertItemsRelationInput:{
		by:{
			type:"GalleryItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpsertGalleryRelationInput:{
		update:{
			type:"GalleryUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpsertRootRelationInput:{
		update:{
			type:"ArtworkWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutArtworkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutArtworkUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateArtworkSelectionEntityRelationInput:{
		create:{
			type:"ArtworkSelectionLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertArtworkSelectionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"ArtworkSelectionWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworks:{
			type:"ArtworkSelectionUpdateArtworksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpdateArtworksEntityRelationInput:{
		create:{
			type:"ArtworkSelectionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionUpsertArtworksRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListUpdateInput:{
		items:{
			type:"ArtworkSelectionListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListUpdateItemsEntityRelationInput:{
		create:{
			type:"ArtworkSelectionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListUpdateItemsRelationInput:{
		by:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkSelectionItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkSelectionItemUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUpdateArtworkEntityRelationInput:{
		create:{
			type:"ArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionItemUpsertArtworkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		image:{
			type:"ArtworkUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		gallery:{
			type:"ArtworkUpdateGalleryEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpdateLocalesEntityRelationInput:{
		create:{
			type:"ArtworkLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpdateLocalesRelationInput:{
		by:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutArtworksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutArtworksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutArtworksUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEventsEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateEventsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertEventsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEventsRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutEventUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateArtworkEntityRelationInput:{
		create:{
			type:"ArtworkLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertArtworkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleWithoutLinkUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertArtworkRelationInput:{
		update:{
			type:"ArtworkLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpdateRedirectEntityRelationInput:{
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LinkableUpsertRedirectRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"RedirectUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectWithoutLinkUpdateInput:{
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateTargetEntityRelationInput:{
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertTargetRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertTargetRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertRedirectRelationInput:{
		update:{
			type:"RedirectWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"RedirectWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutEventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutEventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertEventsRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateArtworkSelectionsEntityRelationInput:{
		create:{
			type:"ArtworkSelectionLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateArtworkSelectionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertArtworkSelectionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateArtworkSelectionsRelationInput:{
		by:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkSelectionLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutArtworkSelectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutArtworkSelectionUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutArtworkSelectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertArtworkSelectionsRelationInput:{
		by:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateNewsletterFormsEntityRelationInput:{
		create:{
			type:"NewsletterFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateNewsletterFormsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertNewsletterFormsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateNewsletterFormsRelationInput:{
		by:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"NewsletterFormLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutLocaleUpdateInput:{
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"NewsletterFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterFormLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpsertRootRelationInput:{
		update:{
			type:"NewsletterFormWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpdateItemsEntityRelationInput:{
		create:{
			type:"NewsletterTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormLocaleUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterFormLocaleUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpdateItemsRelationInput:{
		by:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"NewsletterTypeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterTypeItemUpdateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpdateSubscriptionsEntityRelationInput:{
		create:{
			type:"NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterTypeItemUpdateSubscriptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterTypeItemUpsertSubscriptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpdateSubscriptionsRelationInput:{
		by:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"NewsletterSubscriptionWithoutNewsletterTypeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionWithoutNewsletterTypeUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpsertSubscriptionsRelationInput:{
		by:{
			type:"NewsletterSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterSubscriptionWithoutNewsletterTypeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterSubscriptionWithoutNewsletterTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpsertItemsRelationInput:{
		by:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterTypeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertNewsletterFormsRelationInput:{
		by:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEmployeesEntityRelationInput:{
		create:{
			type:"EmployeeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateEmployeesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertEmployeesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateEmployeesRelationInput:{
		by:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EmployeeLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleWithoutLocaleUpdateInput:{
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"EmployeeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeWithoutLocalesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EmployeeUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUpsertRootRelationInput:{
		update:{
			type:"EmployeeWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertEmployeesRelationInput:{
		by:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateContactFormsEntityRelationInput:{
		create:{
			type:"ContactFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleUpdateContactFormsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LocaleUpsertContactFormsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateContactFormsRelationInput:{
		by:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactFormLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpdateRootEntityRelationInput:{
		create:{
			type:"ContactFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactFormLocaleUpsertRootRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormWithoutLocalesUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpsertRootRelationInput:{
		update:{
			type:"ContactFormWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpdateItemsEntityRelationInput:{
		create:{
			type:"ContactTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormLocaleUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactFormLocaleUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpdateItemsRelationInput:{
		by:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactTypeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactTypeItemUpdateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpdateSubscriptionsEntityRelationInput:{
		create:{
			type:"ContactSubscriptionWithoutContactTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactTypeItemUpdateSubscriptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactTypeItemUpsertSubscriptionsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpdateSubscriptionsRelationInput:{
		by:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactSubscriptionWithoutContactTypeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionWithoutContactTypeUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"ContactSubscriptionUpdateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUpdateFileEntityRelationInput:{
		create:{
			type:"FileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactSubscriptionUpsertFileRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FileUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FileUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		size:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUpsertFileRelationInput:{
		update:{
			type:"FileUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FileCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpsertSubscriptionsRelationInput:{
		by:{
			type:"ContactSubscriptionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactSubscriptionWithoutContactTypeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactSubscriptionWithoutContactTypeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpsertItemsRelationInput:{
		by:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactTypeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactTypeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertContactFormsRelationInput:{
		by:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutArtworksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutArtworksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkUpsertLocalesRelationInput:{
		by:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUpsertArtworkRelationInput:{
		update:{
			type:"ArtworkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListUpsertItemsRelationInput:{
		by:{
			type:"ArtworkSelectionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpsertArtworksRelationInput:{
		update:{
			type:"ArtworkSelectionListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpsertRootRelationInput:{
		update:{
			type:"ArtworkSelectionWithoutLocalesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionWithoutLocalesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutArtworkSelectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutArtworkSelectionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutArtworkSelectionsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutArtworkSelectionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutArtworkSelectionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertArtworkSelectionRelationInput:{
		update:{
			type:"ArtworkSelectionLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutArtworkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutArtworkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertArtworksRelationInput:{
		by:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutEventsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEventsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertEventRelationInput:{
		update:{
			type:"EventLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateContentEntityRelationInput:{
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertPagesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutEmployeesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutEmployeesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeUpsertLocalesRelationInput:{
		by:{
			type:"EmployeeLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUpsertEmployeeRelationInput:{
		update:{
			type:"EmployeeUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListUpsertItemsRelationInput:{
		by:{
			type:"EmployeeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListUpsertEmployeesRelationInput:{
		update:{
			type:"EmployeeListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertDropDownListRelationInput:{
		update:{
			type:"DropDownListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateArtworkSelectionEntityRelationInput:{
		create:{
			type:"ArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertArtworkSelectionRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ArtworkSelectionUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"ArtworkSelectionUpdateArtworksEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpdateLocalesEntityRelationInput:{
		create:{
			type:"ArtworkSelectionLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpdateLocalesRelationInput:{
		by:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkSelectionLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionUpsertLocalesRelationInput:{
		by:{
			type:"ArtworkSelectionLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertArtworkSelectionRelationInput:{
		update:{
			type:"ArtworkSelectionUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateEventListEntityRelationInput:{
		create:{
			type:"EventListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertEventListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListUpdateInput:{
		items:{
			type:"EventListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListUpdateItemsEntityRelationInput:{
		create:{
			type:"EventItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListUpdateItemsRelationInput:{
		by:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventItemUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUpdateEventEntityRelationInput:{
		create:{
			type:"EventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventItemUpsertEventRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateInput:{
		locales:{
			type:"EventUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateStart:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		dateFinish:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLocalesEntityRelationInput:{
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpdateLocalesRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"EventLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventUpsertLocalesRelationInput:{
		by:{
			type:"EventLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUpsertEventRelationInput:{
		update:{
			type:"EventUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListUpsertItemsRelationInput:{
		by:{
			type:"EventItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertEventListRelationInput:{
		update:{
			type:"EventListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBoxListEntityRelationInput:{
		create:{
			type:"BoxListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BoxListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBoxListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListUpdateInput:{
		items:{
			type:"BoxListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListUpdateItemsEntityRelationInput:{
		create:{
			type:"BoxItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BoxListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BoxListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListUpdateItemsRelationInput:{
		by:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BoxItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListUpsertItemsRelationInput:{
		by:{
			type:"BoxItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BoxItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBoxListRelationInput:{
		update:{
			type:"BoxListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateChartEntityRelationInput:{
		create:{
			type:"ChartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ChartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertChartRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartUpdateInput:{
		type:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ChartUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartUpdateItemsEntityRelationInput:{
		create:{
			type:"ChartDataWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ChartUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ChartUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartUpdateItemsRelationInput:{
		by:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ChartDataWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ChartDataUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ChartDataUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartUpsertItemsRelationInput:{
		by:{
			type:"ChartDataUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ChartDataWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartDataWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertChartRelationInput:{
		update:{
			type:"ChartUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateDefinitionListEntityRelationInput:{
		create:{
			type:"DefinitionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DefinitionListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertDefinitionListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListUpdateInput:{
		items:{
			type:"DefinitionListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListUpdateItemsEntityRelationInput:{
		create:{
			type:"DefinitionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DefinitionListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DefinitionListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListUpdateItemsRelationInput:{
		by:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"DefinitionItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListUpsertItemsRelationInput:{
		by:{
			type:"DefinitionItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DefinitionItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertDefinitionListRelationInput:{
		update:{
			type:"DefinitionListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateLogoListEntityRelationInput:{
		create:{
			type:"LogoListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LogoListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertLogoListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListUpdateInput:{
		items:{
			type:"LogoListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListUpdateItemsEntityRelationInput:{
		create:{
			type:"LogoItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LogoListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LogoListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListUpdateItemsRelationInput:{
		by:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"LogoItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"LogoItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LogoItemUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListUpsertItemsRelationInput:{
		by:{
			type:"LogoItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LogoItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertLogoListRelationInput:{
		update:{
			type:"LogoListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateStrategySchemaEntityRelationInput:{
		create:{
			type:"StrategySchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertStrategySchemaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StrategySchemaUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpdateInput:{
		inputFirst:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputSecond:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		inputThird:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputFirst:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputSecond:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		outputThird:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsFirst:{
			type:"StrategySchemaUpdateItemsFirstEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"StrategySchemaUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		itemsSecond:{
			type:"StrategySchemaUpdateItemsSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpdateItemsFirstEntityRelationInput:{
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StrategySchemaUpsertItemsFirstRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupUpdateInput:{
		items:{
			type:"StrategySchemaGroupUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupUpdateItemsEntityRelationInput:{
		create:{
			type:"StrategySchemaGroupItemWithoutSchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaGroupUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StrategySchemaGroupUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupUpdateItemsRelationInput:{
		by:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"StrategySchemaGroupItemWithoutSchemaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemWithoutSchemaUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupUpsertItemsRelationInput:{
		by:{
			type:"StrategySchemaGroupItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaGroupItemWithoutSchemaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupItemWithoutSchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpsertItemsFirstRelationInput:{
		update:{
			type:"StrategySchemaGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpdateLogoEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StrategySchemaUpsertLogoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpsertLogoRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpdateItemsSecondEntityRelationInput:{
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StrategySchemaUpsertItemsSecondRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaUpsertItemsSecondRelationInput:{
		update:{
			type:"StrategySchemaGroupUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertStrategySchemaRelationInput:{
		update:{
			type:"StrategySchemaUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateEmployeeListEntityRelationInput:{
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertEmployeeListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertEmployeeListRelationInput:{
		update:{
			type:"EmployeeListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateImageSecondEntityRelationInput:{
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertImageSecondRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ImageUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertImageSecondRelationInput:{
		update:{
			type:"ImageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ImageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateContactFormEntityRelationInput:{
		create:{
			type:"ContactFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertContactFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"ContactFormUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormUpdateLocalesEntityRelationInput:{
		create:{
			type:"ContactFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactFormUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormUpdateLocalesRelationInput:{
		by:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ContactFormLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutContactFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutContactFormsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactFormLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutContactFormsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutContactFormsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutContactFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormUpsertLocalesRelationInput:{
		by:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertContactFormRelationInput:{
		update:{
			type:"ContactFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateNewsletterFormEntityRelationInput:{
		create:{
			type:"NewsletterFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertNewsletterFormRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterFormUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"NewsletterFormUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormUpdateLocalesEntityRelationInput:{
		create:{
			type:"NewsletterFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterFormUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormUpdateLocalesRelationInput:{
		by:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"NewsletterFormLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutRootUpdateInput:{
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutNewsletterFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutNewsletterFormsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterFormLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutNewsletterFormsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutNewsletterFormsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutNewsletterFormsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormUpsertLocalesRelationInput:{
		by:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertNewsletterFormRelationInput:{
		update:{
			type:"NewsletterFormUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertReferencesRelationInput:{
		by:{
			type:"ContentReferenceUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentReferenceWithoutBlockUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentReferenceWithoutBlockCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentUpsertBlocksRelationInput:{
		by:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertContentRelationInput:{
		update:{
			type:"ContentUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutHomePageUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		redirect:{
			type:"LinkableUpdateRedirectEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutHomePageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutHomePageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateSeoEntityRelationInput:{
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertSeoRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertSeoRelationInput:{
		update:{
			type:"SeoUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateBranchesEntityRelationInput:{
		create:{
			type:"BranchesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageLocaleUpdateBranchesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageLocaleUpsertBranchesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateBranchesRelationInput:{
		by:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"BranchesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		more:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"BranchesUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BranchesUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BranchesUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertBranchesRelationInput:{
		by:{
			type:"BranchesUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BranchesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BranchesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertHomePagesRelationInput:{
		by:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertPageRelationInput:{
		update:{
			type:"PageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutContactPageUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutContactPageCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertContactPagesRelationInput:{
		by:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactPageLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutHomePagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHomePagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableUpsertHomePageRelationInput:{
		update:{
			type:"HomePageLocaleWithoutLinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutLinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkUpsertInternalLinkRelationInput:{
		update:{
			type:"LinkableUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GraphicDesignerUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertGraphicDesignersRelationInput:{
		by:{
			type:"GraphicDesignerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GraphicDesignerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GraphicDesignerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateDeveloperLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertDeveloperLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertDeveloperLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdatePhotographersEntityRelationInput:{
		create:{
			type:"PhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleUpdatePhotographersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertPhotographersRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdatePhotographersRelationInput:{
		by:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PhotographerUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PhotographerUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PhotographerUpsertLinkRelationInput:{
		update:{
			type:"LinkUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertPhotographersRelationInput:{
		by:{
			type:"PhotographerUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PhotographerUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PhotographerCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpsertFootersRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleWithoutLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutContactPagesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutContactPagesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageUpsertLocalesRelationInput:{
		by:{
			type:"ContactPageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactPageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactPageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleCreateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactPageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactPageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactPageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContactPageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ContactPageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databox:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		databoxNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		addressLink:{
			type:"ContactPageLocaleUpdateAddressLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		socialsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		openingHours:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		identificationsLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		ico:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dic:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phoneLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailLabel:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securities:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		securitiesNumber:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockCreateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockCreateContentEntityRelationInput:{
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		references:{
			type:"ContentBlockUpdateReferencesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpdateContentEntityRelationInput:{
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentBlockUpsertContentRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentWithoutBlocksUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockUpsertContentRelationInput:{
		update:{
			type:"ContentWithoutBlocksUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentWithoutBlocksCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceCreateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"ContentReferenceCreateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"ContentReferenceCreateDropDownListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ContentReferenceCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"ContentReferenceCreateEventListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"ContentReferenceCreateBoxListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ContentReferenceCreateChartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"ContentReferenceCreateDefinitionListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"ContentReferenceCreateLogoListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"ContentReferenceCreateStrategySchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"ContentReferenceCreateEmployeeListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ContentReferenceCreateImageSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContentReferenceCreateContactFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"ContentReferenceCreateNewsletterFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceCreateBlockEntityRelationInput:{
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateInput:{
		type:{
			type:"ContentReferenceType",
			array:false,
			arrayRequired:false,
			required:false
		},
		primaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		block:{
			type:"ContentReferenceUpdateBlockEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		media:{
			type:"ContentReferenceUpdateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ContentReferenceUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		secondaryText:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownList:{
			type:"ContentReferenceUpdateDropDownListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"ContentReferenceUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		eventList:{
			type:"ContentReferenceUpdateEventListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		boxList:{
			type:"ContentReferenceUpdateBoxListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		isVisible:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		chart:{
			type:"ContentReferenceUpdateChartEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		definitionList:{
			type:"ContentReferenceUpdateDefinitionListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		logoList:{
			type:"ContentReferenceUpdateLogoListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		strategySchema:{
			type:"ContentReferenceUpdateStrategySchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ContentReferenceUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employeeList:{
			type:"ContentReferenceUpdateEmployeeListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		imageSecond:{
			type:"ContentReferenceUpdateImageSecondEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactForm:{
			type:"ContentReferenceUpdateContactFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterForm:{
			type:"ContentReferenceUpdateNewsletterFormEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpdateBlockEntityRelationInput:{
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContentReferenceUpsertBlockRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContentBlockUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentBlockWithoutReferencesUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		json:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ContentBlockUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContentReferenceUpsertBlockRelationInput:{
		update:{
			type:"ContentBlockWithoutReferencesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContentBlockWithoutReferencesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterCreateLocalesEntityRelationInput:{
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleCreateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleCreateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleCreatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFootersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		logo:{
			type:"FooterUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"FooterUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLocalesEntityRelationInput:{
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpdateLocalesRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"FooterLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleWithoutRootUpdateInput:{
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleUpdateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleUpdateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleUpdatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutFootersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"FooterLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutFootersUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutFootersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutFootersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterUpsertLocalesRelationInput:{
		by:{
			type:"FooterLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"FooterLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"FooterLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleCreateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleCreateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleCreatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	FooterLocaleUpdateInput:{
		address:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		youtube:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		instagram:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		facebook:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesign:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"FooterLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"FooterLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		graphicDesigners:{
			type:"FooterLocaleUpdateGraphicDesignersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		developerLink:{
			type:"FooterLocaleUpdateDeveloperLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		development:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		linkedIn:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photography:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		photographers:{
			type:"FooterLocaleUpdatePhotographersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"HeaderCreateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderCreateLocalesEntityRelationInput:{
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHeadersCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HeaderUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		logo:{
			type:"HeaderUpdateLogoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLocalesEntityRelationInput:{
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpdateLocalesRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HeaderLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleWithoutRootUpdateInput:{
		locale:{
			type:"HeaderLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutHeadersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HeaderLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutHeadersUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutHeadersUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutHeadersCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderUpsertLocalesRelationInput:{
		by:{
			type:"HeaderLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HeaderLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HeaderLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HeaderLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleCreateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HeaderLocaleUpdateInput:{
		root:{
			type:"HeaderLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HeaderLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		links:{
			type:"HeaderLocaleUpdateLinksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkBreadcrumbParentLink:{
			type:"HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HomePageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		media:{
			type:"HomePageCreateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageCreateLocalesEntityRelationInput:{
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleCreateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"HomePageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		media:{
			type:"HomePageUpdateMediaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLocalesEntityRelationInput:{
		create:{
			type:"HomePageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"HomePageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpdateLocalesRelationInput:{
		by:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"HomePageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleUpdateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageUpsertLocalesRelationInput:{
		by:{
			type:"HomePageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"HomePageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"HomePageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleCreateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	HomePageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"HomePageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"HomePageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"HomePageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"HomePageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"HomePageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		branches:{
			type:"HomePageLocaleUpdateBranchesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleCreateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		seoDefaults:{
			type:"LocaleUpdateSeoDefaultsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MediumItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumItemCreateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemCreateListEntityRelationInput:{
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"MediumItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		medium:{
			type:"MediumItemUpdateMediumEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUpdateListEntityRelationInput:{
		create:{
			type:"MediumListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"MediumListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"MediumItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"MediumListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	MediumItemUpsertListRelationInput:{
		update:{
			type:"MediumListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"MediumListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"PageCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageCreateLocalesEntityRelationInput:{
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateInput:{
		locales:{
			type:"PageUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateLocalesEntityRelationInput:{
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"PageUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpdateLocalesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"PageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleWithoutRootUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageUpsertLocalesRelationInput:{
		by:{
			type:"PageLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"PageLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"PageLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	PageLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"PageLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"PageLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"PageLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"PageLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"PageLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoDefaultCreateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultCreateLocalesEntityRelationInput:{
		connect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleWithoutRootCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoDefaultLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleCreateLocaleEntityRelationInput:{
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSeoDefaultsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSeoDefaultsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleCreateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleCreateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleCreateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleCreateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleCreatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleCreateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleCreateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleCreateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleCreateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleCreateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleCreateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultUpdateInput:{
		unique:{
			type:"One",
			array:false,
			arrayRequired:false,
			required:false
		},
		locales:{
			type:"SeoDefaultUpdateLocalesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultUpdateLocalesEntityRelationInput:{
		create:{
			type:"SeoDefaultLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoDefaultUpdateLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoDefaultUpsertLocalesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultUpdateLocalesRelationInput:{
		by:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"SeoDefaultLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleWithoutRootUpdateInput:{
		locale:{
			type:"SeoDefaultLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpdateLocaleEntityRelationInput:{
		create:{
			type:"LocaleWithoutSeoDefaultsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LocaleWithoutSeoDefaultsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"SeoDefaultLocaleUpsertLocaleRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LocaleWithoutSeoDefaultsUpdateInput:{
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPages:{
			type:"LocaleUpdateContactPagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		footers:{
			type:"LocaleUpdateFootersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		headers:{
			type:"LocaleUpdateHeadersEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		homePages:{
			type:"LocaleUpdateHomePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		pages:{
			type:"LocaleUpdatePagesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		events:{
			type:"LocaleUpdateEventsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworks:{
			type:"LocaleUpdateArtworksEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		artworkSelections:{
			type:"LocaleUpdateArtworkSelectionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		newsletterForms:{
			type:"LocaleUpdateNewsletterFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		employees:{
			type:"LocaleUpdateEmployeesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		contactForms:{
			type:"LocaleUpdateContactFormsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpsertLocaleRelationInput:{
		update:{
			type:"LocaleWithoutSeoDefaultsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LocaleWithoutSeoDefaultsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultUpsertLocalesRelationInput:{
		by:{
			type:"SeoDefaultLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"SeoDefaultLocaleWithoutRootUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"SeoDefaultLocaleWithoutRootCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"SeoDefaultLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoDefaultLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	SeoDefaultLocaleUpdateInput:{
		root:{
			type:"SeoDefaultLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"SeoDefaultLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"SeoDefaultLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomain:{
		catalogues:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keys:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cataloguesByIdentifier:{
			by:{
				type:"TranslationDomainCataloguesByIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		cataloguesByValues:{
			by:{
				type:"TranslationDomainCataloguesByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keysByIdentifier:{
			by:{
				type:"TranslationDomainKeysByIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		keysByValues:{
			by:{
				type:"TranslationDomainKeysByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCatalogues:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateKeys:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationCatalogue:{
		domain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		identifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		fallback:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		values:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		valuesByKey:{
			by:{
				type:"TranslationCatalogueValuesByKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateValues:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationDomainWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationDomainWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationDomainWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationCatalogueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationCatalogueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationCataloguesIdentifierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationCataloguesIdentifierWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationCataloguesIdentifierWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationValueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationValueWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"StringCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"TranslationKeyWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"TranslationKeyWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"TranslationKeyWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationContentTypeCondition:{
		and:{
			type:"TranslationContentTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		or:{
			type:"TranslationContentTypeCondition",
			array:true,
			arrayRequired:false,
			required:true
		},
		not:{
			type:"TranslationContentTypeCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		null:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		isNull:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		eq:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		notEq:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		in:{
			type:"TranslationContentType",
			array:true,
			arrayRequired:false,
			required:true
		},
		notIn:{
			type:"TranslationContentType",
			array:true,
			arrayRequired:false,
			required:true
		},
		lt:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		lte:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gt:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		gte:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationContentType: "enum",
	TranslationCataloguesIdentifier:{
		catalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		catalogueByDomain:{
			by:{
				type:"TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		catalogueByValues:{
			by:{
				type:"TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationCatalogueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere:{
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValue:{
		catalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		key:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationKey:{
		domain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		values:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		valuesByCatalogue:{
			by:{
				type:"TranslationKeyValuesByCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateValues:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	TranslationValueOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCatalogueOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationKeyOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationDomainOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyValuesByCatalogueUniqueWhere:{
		catalogue:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueValuesByKeyUniqueWhere:{
		key:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCataloguesByIdentifierUniqueWhere:{
		identifier:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCataloguesByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainKeysByIdentifierUniqueWhere:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainKeysByValuesUniqueWhere:{
		values:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainCreateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		keys:{
			type:"TranslationDomainCreateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateCataloguesEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateIdentifierEntityRelationInput:{
		connect:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWithoutCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateFallbackEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateDomainEntityRelationInput:{
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutCataloguesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationDomainCreateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainCreateKeysEntityRelationInput:{
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutDomainCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateValuesEntityRelationInput:{
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutKeyCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueCreateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateCatalogueEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutValuesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueCreateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueCreateValuesEntityRelationInput:{
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutCatalogueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueCreateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateKeyEntityRelationInput:{
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutValuesCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateDomainEntityRelationInput:{
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutKeysCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainCreateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainUpdateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		keys:{
			type:"TranslationDomainUpdateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateCataloguesEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainUpdateCataloguesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationDomainUpsertCataloguesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateCataloguesRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationCatalogueWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutDomainUpdateInput:{
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateIdentifierEntityRelationInput:{
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertIdentifierRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCataloguesIdentifierUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierWithoutCatalogueUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertIdentifierRelationInput:{
		update:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCataloguesIdentifierWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateFallbackEntityRelationInput:{
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertFallbackRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateDomainEntityRelationInput:{
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainWithoutCataloguesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertDomainRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutCataloguesUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		keys:{
			type:"TranslationDomainUpdateKeysEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateKeysEntityRelationInput:{
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainUpdateKeysRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationDomainUpsertKeysRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpdateKeysRelationInput:{
		by:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationKeyWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutDomainUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateValuesEntityRelationInput:{
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyUpdateValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationKeyUpsertValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationValueWithoutKeyUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutKeyUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueUpdateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateCatalogueEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationValueUpsertCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutValuesUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"TranslationCatalogueUpdateIdentifierEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpsertCatalogueRelationInput:{
		update:{
			type:"TranslationCatalogueWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpsertValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationValueWithoutKeyUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutKeyCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpsertKeysRelationInput:{
		by:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertDomainRelationInput:{
		update:{
			type:"TranslationDomainWithoutCataloguesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutCataloguesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateValuesEntityRelationInput:{
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueUpdateValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCatalogueUpsertValuesRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpdateValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationValueWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueWithoutCatalogueUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueUpdateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateKeyEntityRelationInput:{
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationKeyWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationValueUpsertKeyRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationKeyUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyWithoutValuesUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateDomainEntityRelationInput:{
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationDomainWithoutKeysUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationKeyUpsertDomainRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationDomainUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainWithoutKeysUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogues:{
			type:"TranslationDomainUpdateCataloguesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpsertDomainRelationInput:{
		update:{
			type:"TranslationDomainWithoutKeysUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationDomainWithoutKeysCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpsertKeyRelationInput:{
		update:{
			type:"TranslationKeyWithoutValuesUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationKeyWithoutValuesCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertValuesRelationInput:{
		by:{
			type:"TranslationValueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationValueWithoutCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationValueWithoutCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueUpsertFallbackRelationInput:{
		update:{
			type:"TranslationCatalogueUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationDomainUpsertCataloguesRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutDomainUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutDomainCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput:{
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutIdentifierCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationCatalogueCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueCreateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateInput:{
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		code:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput:{
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCataloguesIdentifierUpdateCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"TranslationCataloguesIdentifierUpsertCatalogueRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpdateCatalogueRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"TranslationCatalogueWithoutIdentifierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCatalogueWithoutIdentifierUpdateInput:{
		domain:{
			type:"TranslationCatalogueUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		fallback:{
			type:"TranslationCatalogueUpdateFallbackEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationCatalogueUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationCataloguesIdentifierUpsertCatalogueRelationInput:{
		by:{
			type:"TranslationCatalogueUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"TranslationCatalogueWithoutIdentifierUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"TranslationCatalogueWithoutIdentifierCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyCreateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyCreateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationKeyUpdateInput:{
		identifier:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contentType:{
			type:"TranslationContentType",
			array:false,
			arrayRequired:false,
			required:false
		},
		note:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		domain:{
			type:"TranslationKeyUpdateDomainEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		values:{
			type:"TranslationKeyUpdateValuesEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueCreateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueCreateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	TranslationValueUpdateInput:{
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		catalogue:{
			type:"TranslationValueUpdateCatalogueEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"TranslationValueUpdateKeyEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EventLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EventLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"EventLocaleUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"EventLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"EventLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		venue:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		venueNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"EventLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		isDark:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleCreateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		label:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		leadParagraph:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		content:{
			type:"ArtworkLocaleUpdateContentEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artist:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DropDownItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DropDownItemCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemCreateListEntityRelationInput:{
		connect:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		dropDownType:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"DropDownListCreateEmployeesEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DropDownItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"DropDownItemUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUpdateListEntityRelationInput:{
		create:{
			type:"DropDownListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DropDownListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DropDownItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DropDownListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownListWithoutItemsUpdateInput:{
		dropDownType:{
			type:"DropDownType",
			array:false,
			arrayRequired:false,
			required:false
		},
		employees:{
			type:"DropDownListUpdateEmployeesEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DropDownItemUpsertListRelationInput:{
		update:{
			type:"DropDownListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DropDownListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItem:{
		list:{
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		artwork:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkList:{
		items:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateItems:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	ArtworkItemWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"IntCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkLocaleWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkItemWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListWhere:{
		id:{
			type:"UUIDCondition",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkItemWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		and:{
			type:"ArtworkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		or:{
			type:"ArtworkListWhere",
			array:true,
			arrayRequired:false,
			required:false
		},
		not:{
			type:"ArtworkListWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkListOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkLocaleOrderBy",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListOrderBy:{
		_random:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		_randomSeeded:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		id:{
			type:"OrderDirection",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkItemCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemCreateListEntityRelationInput:{
		connect:{
			type:"ArtworkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListUniqueWhere:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemCreateArtworkEntityRelationInput:{
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkItemUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUpdateListEntityRelationInput:{
		create:{
			type:"ArtworkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUpsertListRelationInput:{
		update:{
			type:"ArtworkListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUpdateArtworkEntityRelationInput:{
		create:{
			type:"ArtworkLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkItemUpsertArtworkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemUpsertArtworkRelationInput:{
		update:{
			type:"ArtworkLocaleUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkLocaleCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ArtworkListCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListCreateItemsEntityRelationInput:{
		connect:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemWithoutListCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkItemCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListUpdateInput:{
		items:{
			type:"ArtworkListUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListUpdateItemsEntityRelationInput:{
		create:{
			type:"ArtworkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkListUpdateItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkListUpsertItemsRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		alias:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListUpdateItemsRelationInput:{
		by:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		data:{
			type:"ArtworkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkItemWithoutListUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkItemUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkListUpsertItemsRelationInput:{
		by:{
			type:"ArtworkItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkItemWithoutListUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkItemWithoutListCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkSelectionItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkSelectionItemCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemCreateListEntityRelationInput:{
		connect:{
			type:"ArtworkSelectionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ArtworkSelectionItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"ArtworkSelectionItemUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUpdateListEntityRelationInput:{
		create:{
			type:"ArtworkSelectionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ArtworkSelectionListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ArtworkSelectionItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ArtworkSelectionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionItemUpsertListRelationInput:{
		update:{
			type:"ArtworkSelectionListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ArtworkSelectionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleCreateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ArtworkSelectionLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ArtworkSelectionLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ArtworkSelectionLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		seo:{
			type:"ArtworkSelectionLocaleUpdateSeoEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"ArtworkSelectionLocaleUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EventItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventItemCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemCreateListEntityRelationInput:{
		connect:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EventItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"EventItemUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUpdateListEntityRelationInput:{
		create:{
			type:"EventListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EventListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EventItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EventListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EventItemUpsertListRelationInput:{
		update:{
			type:"EventListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EventListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BoxItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemCreateListEntityRelationInput:{
		connect:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"BoxItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemUpdateListEntityRelationInput:{
		create:{
			type:"BoxListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"BoxListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"BoxItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"BoxListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	BoxItemUpsertListRelationInput:{
		update:{
			type:"BoxListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"BoxListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterTypeItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterTypeItemCreateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemCreateListEntityRelationInput:{
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterTypeItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"NewsletterTypeItemUpdateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpdateListEntityRelationInput:{
		create:{
			type:"NewsletterFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterFormLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterTypeItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleWithoutItemsUpdateInput:{
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemUpsertListRelationInput:{
		update:{
			type:"NewsletterFormLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterFormLocaleUpdateInput:{
		newsletterTypeNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		emailNote:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"NewsletterFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"NewsletterFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"NewsletterFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterType:{
			type:"NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput:{
		connect:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemWithoutSubscriptionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterTypeItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		newsletterType:{
			type:"NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput:{
		create:{
			type:"NewsletterTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"NewsletterTypeItemWithoutSubscriptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"NewsletterSubscriptionUpsertNewsletterTypeRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"NewsletterTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterTypeItemWithoutSubscriptionsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"NewsletterTypeItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	NewsletterSubscriptionUpsertNewsletterTypeRelationInput:{
		update:{
			type:"NewsletterTypeItemWithoutSubscriptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"NewsletterTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ChartDataCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ChartDataCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataCreateListEntityRelationInput:{
		connect:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		type:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ChartDataUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		date:{
			type:"Date",
			array:false,
			arrayRequired:false,
			required:false
		},
		number:{
			type:"Float",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"ChartDataUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUpdateListEntityRelationInput:{
		create:{
			type:"ChartWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ChartWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ChartDataUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ChartUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartWithoutItemsUpdateInput:{
		type:{
			type:"ChartType",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ChartDataUpsertListRelationInput:{
		update:{
			type:"ChartWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ChartWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EmployeeItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeItemCreateEmployeeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemCreateListEntityRelationInput:{
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"EmployeeItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		employee:{
			type:"EmployeeItemUpdateEmployeeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUpdateListEntityRelationInput:{
		create:{
			type:"EmployeeListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"EmployeeListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"EmployeeItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"EmployeeListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeItemUpsertListRelationInput:{
		update:{
			type:"EmployeeListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"EmployeeListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EmployeeLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	EmployeeLocaleUpdateInput:{
		position:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"EmployeeLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"EmployeeLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DefinitionItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemCreateListEntityRelationInput:{
		connect:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		key:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		value:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"DefinitionItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemUpdateListEntityRelationInput:{
		create:{
			type:"DefinitionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"DefinitionListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"DefinitionItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"DefinitionListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	DefinitionItemUpsertListRelationInput:{
		update:{
			type:"DefinitionListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"DefinitionListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LogoItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"LogoItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemCreateListEntityRelationInput:{
		connect:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"LogoItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"LogoItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUpdateListEntityRelationInput:{
		create:{
			type:"LogoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LogoListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"LogoItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LogoListUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoListWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LogoItemUpsertListRelationInput:{
		update:{
			type:"LogoListWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LogoListWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		schema:{
			type:"StrategySchemaGroupItemCreateSchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemCreateSchemaEntityRelationInput:{
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		text:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		schema:{
			type:"StrategySchemaGroupItemUpdateSchemaEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemUpdateSchemaEntityRelationInput:{
		create:{
			type:"StrategySchemaGroupWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"StrategySchemaGroupWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"StrategySchemaGroupItemUpsertSchemaRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"StrategySchemaGroupUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	StrategySchemaGroupItemUpsertSchemaRelationInput:{
		update:{
			type:"StrategySchemaGroupWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"StrategySchemaGroupWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		link:{
			type:"RedirectCreateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectCreateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectCreateLinkEntityRelationInput:{
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableCreateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableCreateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableCreatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableCreateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableCreateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableCreateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateInput:{
		link:{
			type:"RedirectUpdateLinkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		target:{
			type:"RedirectUpdateTargetEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpdateLinkEntityRelationInput:{
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"RedirectUpsertLinkRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"LinkableUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	LinkableWithoutRedirectUpdateInput:{
		url:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		homePage:{
			type:"LinkableUpdateHomePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactPage:{
			type:"LinkableUpdateContactPageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		page:{
			type:"LinkableUpdatePageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		event:{
			type:"LinkableUpdateEventEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artwork:{
			type:"LinkableUpdateArtworkEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		artworkSelection:{
			type:"LinkableUpdateArtworkSelectionEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	RedirectUpsertLinkRelationInput:{
		update:{
			type:"LinkableWithoutRedirectUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"LinkableWithoutRedirectCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemCreateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemCreateListEntityRelationInput:{
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"GalleryItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		image:{
			type:"GalleryItemUpdateImageEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpdateListEntityRelationInput:{
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"GalleryItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"GalleryUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryWithoutItemsUpdateInput:{
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	GalleryItemUpsertListRelationInput:{
		update:{
			type:"GalleryWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"GalleryWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleCreateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		items:{
			type:"ContactFormLocaleUpdateItemsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"ContactSubscriptionCreateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactType:{
			type:"ContactSubscriptionCreateContactTypeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionCreateContactTypeEntityRelationInput:{
		connect:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemWithoutSubscriptionsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContactTypeItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemCreateListEntityRelationInput:{
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutItemsCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleCreateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleCreateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUpdateInput:{
		createdAt:{
			type:"DateTime",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"ContactSubscriptionUpdateFileEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactType:{
			type:"ContactSubscriptionUpdateContactTypeEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUpdateContactTypeEntityRelationInput:{
		create:{
			type:"ContactTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactTypeItemWithoutSubscriptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactSubscriptionUpsertContactTypeRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactTypeItemUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		disconnect:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemWithoutSubscriptionsUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		list:{
			type:"ContactTypeItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpdateListEntityRelationInput:{
		create:{
			type:"ContactFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		update:{
			type:"ContactFormLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		upsert:{
			type:"ContactTypeItemUpsertListRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		connect:{
			type:"ContactFormLocaleUniqueWhere",
			array:false,
			arrayRequired:false,
			required:false
		},
		delete:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactFormLocaleWithoutItemsUpdateInput:{
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		name:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		phone:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		email:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		message:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		submit:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		successMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		genericErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		contactTypeErrorMessage:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		root:{
			type:"ContactFormLocaleUpdateRootEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		locale:{
			type:"ContactFormLocaleUpdateLocaleEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		file:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpsertListRelationInput:{
		update:{
			type:"ContactFormLocaleWithoutItemsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactFormLocaleWithoutItemsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactSubscriptionUpsertContactTypeRelationInput:{
		update:{
			type:"ContactTypeItemWithoutSubscriptionsUpdateInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		create:{
			type:"ContactTypeItemWithoutSubscriptionsCreateInput",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemCreateInput:{
		id:{
			type:"UUID",
			array:false,
			arrayRequired:false,
			required:false
		},
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactTypeItemCreateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		list:{
			type:"ContactTypeItemCreateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	ContactTypeItemUpdateInput:{
		order:{
			type:"Int",
			array:false,
			arrayRequired:false,
			required:false
		},
		title:{
			type:"String",
			array:false,
			arrayRequired:false,
			required:false
		},
		subscriptions:{
			type:"ContactTypeItemUpdateSubscriptionsEntityRelationInput",
			array:true,
			arrayRequired:false,
			required:true
		},
		list:{
			type:"ContactTypeItemUpdateListEntityRelationInput",
			array:false,
			arrayRequired:false,
			required:false
		},
		_dummy_field_:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	QueryTransaction:{
		getContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactPage:{
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactPage:{
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactPage:{
			data:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactPageLocale:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactPageLocale:{
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactPageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactPageLocale:{
			data:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContent:{
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentBlock:{
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentBlockOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContentReference:{
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContentReferenceOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooter:{
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFooterLocale:{
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FooterLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeader:{
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLink:{
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHeaderLocale:{
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HeaderLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePage:{
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listHomePageLocale:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateHomePageLocale:{
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"HomePageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateHomePageLocale:{
			data:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLink:{
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLinkable:{
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LinkableOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLocale:{
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMedium:{
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumItem:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumItem:{
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumItem:{
			data:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listMediumList:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateMediumList:{
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"MediumListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateMediumList:{
			data:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePage:{
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePageLocale:{
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PageLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoDefault:{
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoDefault:{
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoDefault:{
			data:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeoDefaultLocale:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeoDefaultLocale:{
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoDefaultLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeoDefaultLocale:{
			data:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateVideo:{
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"VideoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateImage:{
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ImageOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateSeo:{
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"SeoOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationDomain:{
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationDomainOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCatalogue:{
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCatalogueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationCataloguesIdentifier:{
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationCataloguesIdentifierOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationKey:{
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationKeyOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateTranslationValue:{
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"TranslationValueOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBranches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBranches:{
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BranchesOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBranches:{
			data:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGraphicDesigner:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGraphicDesigner:{
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GraphicDesignerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGraphicDesigner:{
			data:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEvent:{
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventLocale:{
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtwork:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtwork:{
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtwork:{
			data:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkLocale:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkLocale:{
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkLocale:{
			data:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDropDownItem:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDropDownItem:{
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDropDownItem:{
			data:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDropDownList:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDropDownList:{
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DropDownListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDropDownList:{
			data:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkItem:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkItem:{
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkItem:{
			data:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkList:{
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkList:{
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkList:{
			data:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelection:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelection:{
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelection:{
			data:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionItem:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionItem:{
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionItem:{
			data:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionList:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionList:{
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionList:{
			data:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listArtworkSelectionLocale:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateArtworkSelectionLocale:{
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ArtworkSelectionLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateArtworkSelectionLocale:{
			data:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventItem:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventItem:{
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventItem:{
			data:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEventList:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEventList:{
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EventListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEventList:{
			data:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBoxItem:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBoxItem:{
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBoxItem:{
			data:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listBoxList:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateBoxList:{
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"BoxListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateBoxList:{
			data:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterForm:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterForm:{
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterForm:{
			data:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterTypeItem:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterTypeItem:{
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterTypeItem:{
			data:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterFormLocale:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterFormLocale:{
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterFormLocale:{
			data:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listNewsletterSubscription:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateNewsletterSubscription:{
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"NewsletterSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateNewsletterSubscription:{
			data:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listChart:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateChart:{
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateChart:{
			data:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listChartData:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateChartData:{
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ChartDataOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateChartData:{
			data:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployee:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployee:{
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployee:{
			data:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeItem:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeItem:{
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeItem:{
			data:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeList:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeList:{
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeList:{
			data:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listEmployeeLocale:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateEmployeeLocale:{
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"EmployeeLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateEmployeeLocale:{
			data:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listPhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginatePhotographer:{
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"PhotographerOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreatePhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDefinitionItem:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDefinitionItem:{
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDefinitionItem:{
			data:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listDefinitionList:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateDefinitionList:{
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"DefinitionListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateDefinitionList:{
			data:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLogoItem:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLogoItem:{
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLogoItem:{
			data:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listLogoList:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateLogoList:{
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"LogoListOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateLogoList:{
			data:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchema:{
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchema:{
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchema:{
			data:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchemaGroup:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchemaGroup:{
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchemaGroup:{
			data:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listStrategySchemaGroupItem:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateStrategySchemaGroupItem:{
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"StrategySchemaGroupItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateStrategySchemaGroupItem:{
			data:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateRedirect:{
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"RedirectOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGallery:{
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateGalleryItem:{
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"GalleryItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactForm:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactForm:{
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactForm:{
			data:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactFormLocale:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactFormLocale:{
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactFormLocaleOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactFormLocale:{
			data:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactSubscription:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactSubscription:{
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactSubscriptionOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactSubscription:{
			data:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listContactTypeItem:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateContactTypeItem:{
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"ContactTypeItemOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateContactTypeItem:{
			data:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		getFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		listFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			offset:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			limit:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		paginateFile:{
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			orderBy:{
				type:"FileOrderBy",
				array:true,
				arrayRequired:false,
				required:true
			},
			skip:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			first:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		validateCreateFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		validateUpdateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	Mutation:{
		createContactPage:{
			data:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactPageLocale:{
			data:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePageLocale:{
			data:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumItem:{
			data:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumList:{
			data:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoDefault:{
			data:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoDefaultLocale:{
			data:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBranches:{
			data:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGraphicDesigner:{
			data:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtwork:{
			data:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkLocale:{
			data:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDropDownItem:{
			data:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDropDownList:{
			data:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkItem:{
			data:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkList:{
			data:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelection:{
			data:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionItem:{
			data:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionList:{
			data:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionLocale:{
			data:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventItem:{
			data:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventList:{
			data:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBoxItem:{
			data:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBoxList:{
			data:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterForm:{
			data:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterTypeItem:{
			data:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterFormLocale:{
			data:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterSubscription:{
			data:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createChart:{
			data:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createChartData:{
			data:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployee:{
			data:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeItem:{
			data:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeList:{
			data:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeLocale:{
			data:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDefinitionItem:{
			data:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDefinitionList:{
			data:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLogoItem:{
			data:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLogoList:{
			data:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchema:{
			data:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchemaGroup:{
			data:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchemaGroupItem:{
			data:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactForm:{
			data:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactFormLocale:{
			data:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactSubscription:{
			data:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactTypeItem:{
			data:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		transaction:{
			options:{
				type:"MutationTransactionOptions",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateUploadUrl:{
			contentType:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			},
			prefix:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		generateReadUrl:{
			objectKey:{
				type:"String",
				array:false,
				arrayRequired:false,
				required:true
			},
			expiration:{
				type:"Int",
				array:false,
				arrayRequired:false,
				required:false
			}
		}
	},
	_MutationErrorType: "enum",
	MutationTransaction:{
		createContactPage:{
			data:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactPage:{
			by:{
				type:"ContactPageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactPageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactPageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactPageLocale:{
			data:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactPageLocale:{
			by:{
				type:"ContactPageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactPageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactPageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactPageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContent:{
			data:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContent:{
			by:{
				type:"ContentUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentBlock:{
			data:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentBlock:{
			by:{
				type:"ContentBlockUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentBlockWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentBlockUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentBlockCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContentReference:{
			data:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContentReference:{
			by:{
				type:"ContentReferenceUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContentReferenceWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContentReferenceUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContentReferenceCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooter:{
			data:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooter:{
			by:{
				type:"FooterUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFooterLocale:{
			data:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFooterLocale:{
			by:{
				type:"FooterLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FooterLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FooterLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FooterLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeader:{
			data:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeader:{
			by:{
				type:"HeaderUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLink:{
			data:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLink:{
			by:{
				type:"HeaderLinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHeaderLocale:{
			data:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHeaderLocale:{
			by:{
				type:"HeaderLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HeaderLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HeaderLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HeaderLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePage:{
			data:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePage:{
			by:{
				type:"HomePageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createHomePageLocale:{
			data:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertHomePageLocale:{
			by:{
				type:"HomePageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"HomePageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"HomePageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"HomePageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLink:{
			data:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLink:{
			by:{
				type:"LinkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLinkable:{
			data:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLinkable:{
			by:{
				type:"LinkableUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LinkableWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LinkableUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LinkableCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLocale:{
			data:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLocale:{
			by:{
				type:"LocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMedium:{
			data:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMedium:{
			by:{
				type:"MediumUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumItem:{
			data:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumItem:{
			by:{
				type:"MediumItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createMediumList:{
			data:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertMediumList:{
			by:{
				type:"MediumListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"MediumListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"MediumListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"MediumListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPage:{
			data:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPage:{
			by:{
				type:"PageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPageLocale:{
			data:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPageLocale:{
			by:{
				type:"PageLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PageLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PageLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PageLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoDefault:{
			data:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoDefault:{
			by:{
				type:"SeoDefaultUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoDefaultUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoDefaultCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeoDefaultLocale:{
			data:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeoDefaultLocale:{
			by:{
				type:"SeoDefaultLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoDefaultLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoDefaultLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoDefaultLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createVideo:{
			data:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertVideo:{
			by:{
				type:"VideoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"VideoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"VideoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"VideoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createImage:{
			data:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertImage:{
			by:{
				type:"ImageUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ImageWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ImageUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ImageCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createSeo:{
			data:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertSeo:{
			by:{
				type:"SeoUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"SeoWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"SeoUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"SeoCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationDomain:{
			data:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationDomain:{
			by:{
				type:"TranslationDomainUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationDomainWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationDomainUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationDomainCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCatalogue:{
			data:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCatalogue:{
			by:{
				type:"TranslationCatalogueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCatalogueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCatalogueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCatalogueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationCataloguesIdentifier:{
			data:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationCataloguesIdentifier:{
			by:{
				type:"TranslationCataloguesIdentifierUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationCataloguesIdentifierWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationCataloguesIdentifierUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationCataloguesIdentifierCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationKey:{
			data:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationKey:{
			by:{
				type:"TranslationKeyUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationKeyWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationKeyUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationKeyCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createTranslationValue:{
			data:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertTranslationValue:{
			by:{
				type:"TranslationValueUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"TranslationValueWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"TranslationValueUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"TranslationValueCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBranches:{
			data:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBranches:{
			by:{
				type:"BranchesUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BranchesWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BranchesUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BranchesCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGraphicDesigner:{
			data:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGraphicDesigner:{
			by:{
				type:"GraphicDesignerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GraphicDesignerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GraphicDesignerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GraphicDesignerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEvent:{
			data:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEvent:{
			by:{
				type:"EventUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventLocale:{
			data:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventLocale:{
			by:{
				type:"EventLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtwork:{
			data:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtwork:{
			by:{
				type:"ArtworkUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkLocale:{
			data:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkLocale:{
			by:{
				type:"ArtworkLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDropDownItem:{
			data:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDropDownItem:{
			by:{
				type:"DropDownItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DropDownItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DropDownItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDropDownList:{
			data:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDropDownList:{
			by:{
				type:"DropDownListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DropDownListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DropDownListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DropDownListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkItem:{
			data:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkItem:{
			by:{
				type:"ArtworkItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkList:{
			data:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkList:{
			by:{
				type:"ArtworkListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelection:{
			data:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelection:{
			by:{
				type:"ArtworkSelectionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionItem:{
			data:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionItem:{
			by:{
				type:"ArtworkSelectionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionList:{
			data:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionList:{
			by:{
				type:"ArtworkSelectionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createArtworkSelectionLocale:{
			data:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertArtworkSelectionLocale:{
			by:{
				type:"ArtworkSelectionLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ArtworkSelectionLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ArtworkSelectionLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ArtworkSelectionLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventItem:{
			data:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventItem:{
			by:{
				type:"EventItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEventList:{
			data:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEventList:{
			by:{
				type:"EventListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EventListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EventListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EventListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBoxItem:{
			data:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBoxItem:{
			by:{
				type:"BoxItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BoxItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BoxItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createBoxList:{
			data:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertBoxList:{
			by:{
				type:"BoxListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"BoxListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"BoxListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"BoxListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterForm:{
			data:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterForm:{
			by:{
				type:"NewsletterFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterTypeItem:{
			data:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterTypeItem:{
			by:{
				type:"NewsletterTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterFormLocale:{
			data:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterFormLocale:{
			by:{
				type:"NewsletterFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createNewsletterSubscription:{
			data:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertNewsletterSubscription:{
			by:{
				type:"NewsletterSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"NewsletterSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"NewsletterSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"NewsletterSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createChart:{
			data:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertChart:{
			by:{
				type:"ChartUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ChartUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ChartCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createChartData:{
			data:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertChartData:{
			by:{
				type:"ChartDataUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ChartDataWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ChartDataUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ChartDataCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployee:{
			data:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployee:{
			by:{
				type:"EmployeeUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeItem:{
			data:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeItem:{
			by:{
				type:"EmployeeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeList:{
			data:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeList:{
			by:{
				type:"EmployeeListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createEmployeeLocale:{
			data:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertEmployeeLocale:{
			by:{
				type:"EmployeeLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"EmployeeLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"EmployeeLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"EmployeeLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createPhotographer:{
			data:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deletePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updatePhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertPhotographer:{
			by:{
				type:"PhotographerUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"PhotographerWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"PhotographerUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"PhotographerCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDefinitionItem:{
			data:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDefinitionItem:{
			by:{
				type:"DefinitionItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DefinitionItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DefinitionItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createDefinitionList:{
			data:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertDefinitionList:{
			by:{
				type:"DefinitionListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"DefinitionListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"DefinitionListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"DefinitionListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLogoItem:{
			data:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLogoItem:{
			by:{
				type:"LogoItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LogoItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LogoItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createLogoList:{
			data:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertLogoList:{
			by:{
				type:"LogoListUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"LogoListWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"LogoListUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"LogoListCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchema:{
			data:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchema:{
			by:{
				type:"StrategySchemaUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchemaGroup:{
			data:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchemaGroup:{
			by:{
				type:"StrategySchemaGroupUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaGroupUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaGroupCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createStrategySchemaGroupItem:{
			data:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertStrategySchemaGroupItem:{
			by:{
				type:"StrategySchemaGroupItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"StrategySchemaGroupItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"StrategySchemaGroupItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"StrategySchemaGroupItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createRedirect:{
			data:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertRedirect:{
			by:{
				type:"RedirectUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"RedirectWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"RedirectUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"RedirectCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGallery:{
			data:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGallery:{
			by:{
				type:"GalleryUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createGalleryItem:{
			data:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertGalleryItem:{
			by:{
				type:"GalleryItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"GalleryItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"GalleryItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"GalleryItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactForm:{
			data:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactForm:{
			by:{
				type:"ContactFormUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactFormUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactFormCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactFormLocale:{
			data:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactFormLocale:{
			by:{
				type:"ContactFormLocaleUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactFormLocaleWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactFormLocaleUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactFormLocaleCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactSubscription:{
			data:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactSubscription:{
			by:{
				type:"ContactSubscriptionUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactSubscriptionWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactSubscriptionUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactSubscriptionCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createContactTypeItem:{
			data:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertContactTypeItem:{
			by:{
				type:"ContactTypeItemUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"ContactTypeItemWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"ContactTypeItemUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"ContactTypeItemCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		createFile:{
			data:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		deleteFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			}
		},
		updateFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			data:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		},
		upsertFile:{
			by:{
				type:"FileUniqueWhere",
				array:false,
				arrayRequired:false,
				required:true
			},
			filter:{
				type:"FileWhere",
				array:false,
				arrayRequired:false,
				required:false
			},
			update:{
				type:"FileUpdateInput",
				array:false,
				arrayRequired:false,
				required:true
			},
			create:{
				type:"FileCreateInput",
				array:false,
				arrayRequired:false,
				required:true
			}
		}
	},
	MutationTransactionOptions:{
		deferForeignKeyConstraints:{
			type:"Boolean",
			array:false,
			arrayRequired:false,
			required:false
		}
	},
	Json: "String",
	_OnDeleteBehaviour: "enum",
	_RelationSide: "enum",
	_OrderByDirection: "enum"
}

export const ReturnTypes: Record<string,any> = {
	Query:{
		getContactPage:"ContactPage",
		listContactPage:"ContactPage",
		paginateContactPage:"ContactPageConnection",
		validateCreateContactPage:"_ValidationResult",
		validateUpdateContactPage:"_ValidationResult",
		getContactPageLocale:"ContactPageLocale",
		listContactPageLocale:"ContactPageLocale",
		paginateContactPageLocale:"ContactPageLocaleConnection",
		validateCreateContactPageLocale:"_ValidationResult",
		validateUpdateContactPageLocale:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getHomePageLocale:"HomePageLocale",
		listHomePageLocale:"HomePageLocale",
		paginateHomePageLocale:"HomePageLocaleConnection",
		validateCreateHomePageLocale:"_ValidationResult",
		validateUpdateHomePageLocale:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getSeoDefault:"SeoDefault",
		listSeoDefault:"SeoDefault",
		paginateSeoDefault:"SeoDefaultConnection",
		validateCreateSeoDefault:"_ValidationResult",
		validateUpdateSeoDefault:"_ValidationResult",
		getSeoDefaultLocale:"SeoDefaultLocale",
		listSeoDefaultLocale:"SeoDefaultLocale",
		paginateSeoDefaultLocale:"SeoDefaultLocaleConnection",
		validateCreateSeoDefaultLocale:"_ValidationResult",
		validateUpdateSeoDefaultLocale:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getBranches:"Branches",
		listBranches:"Branches",
		paginateBranches:"BranchesConnection",
		validateCreateBranches:"_ValidationResult",
		validateUpdateBranches:"_ValidationResult",
		getGraphicDesigner:"GraphicDesigner",
		listGraphicDesigner:"GraphicDesigner",
		paginateGraphicDesigner:"GraphicDesignerConnection",
		validateCreateGraphicDesigner:"_ValidationResult",
		validateUpdateGraphicDesigner:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getEventLocale:"EventLocale",
		listEventLocale:"EventLocale",
		paginateEventLocale:"EventLocaleConnection",
		validateCreateEventLocale:"_ValidationResult",
		validateUpdateEventLocale:"_ValidationResult",
		getArtwork:"Artwork",
		listArtwork:"Artwork",
		paginateArtwork:"ArtworkConnection",
		validateCreateArtwork:"_ValidationResult",
		validateUpdateArtwork:"_ValidationResult",
		getArtworkLocale:"ArtworkLocale",
		listArtworkLocale:"ArtworkLocale",
		paginateArtworkLocale:"ArtworkLocaleConnection",
		validateCreateArtworkLocale:"_ValidationResult",
		validateUpdateArtworkLocale:"_ValidationResult",
		getDropDownItem:"DropDownItem",
		listDropDownItem:"DropDownItem",
		paginateDropDownItem:"DropDownItemConnection",
		validateCreateDropDownItem:"_ValidationResult",
		validateUpdateDropDownItem:"_ValidationResult",
		getDropDownList:"DropDownList",
		listDropDownList:"DropDownList",
		paginateDropDownList:"DropDownListConnection",
		validateCreateDropDownList:"_ValidationResult",
		validateUpdateDropDownList:"_ValidationResult",
		getArtworkItem:"ArtworkItem",
		listArtworkItem:"ArtworkItem",
		paginateArtworkItem:"ArtworkItemConnection",
		validateCreateArtworkItem:"_ValidationResult",
		validateUpdateArtworkItem:"_ValidationResult",
		getArtworkList:"ArtworkList",
		listArtworkList:"ArtworkList",
		paginateArtworkList:"ArtworkListConnection",
		validateCreateArtworkList:"_ValidationResult",
		validateUpdateArtworkList:"_ValidationResult",
		getArtworkSelection:"ArtworkSelection",
		listArtworkSelection:"ArtworkSelection",
		paginateArtworkSelection:"ArtworkSelectionConnection",
		validateCreateArtworkSelection:"_ValidationResult",
		validateUpdateArtworkSelection:"_ValidationResult",
		getArtworkSelectionItem:"ArtworkSelectionItem",
		listArtworkSelectionItem:"ArtworkSelectionItem",
		paginateArtworkSelectionItem:"ArtworkSelectionItemConnection",
		validateCreateArtworkSelectionItem:"_ValidationResult",
		validateUpdateArtworkSelectionItem:"_ValidationResult",
		getArtworkSelectionList:"ArtworkSelectionList",
		listArtworkSelectionList:"ArtworkSelectionList",
		paginateArtworkSelectionList:"ArtworkSelectionListConnection",
		validateCreateArtworkSelectionList:"_ValidationResult",
		validateUpdateArtworkSelectionList:"_ValidationResult",
		getArtworkSelectionLocale:"ArtworkSelectionLocale",
		listArtworkSelectionLocale:"ArtworkSelectionLocale",
		paginateArtworkSelectionLocale:"ArtworkSelectionLocaleConnection",
		validateCreateArtworkSelectionLocale:"_ValidationResult",
		validateUpdateArtworkSelectionLocale:"_ValidationResult",
		getEventItem:"EventItem",
		listEventItem:"EventItem",
		paginateEventItem:"EventItemConnection",
		validateCreateEventItem:"_ValidationResult",
		validateUpdateEventItem:"_ValidationResult",
		getEventList:"EventList",
		listEventList:"EventList",
		paginateEventList:"EventListConnection",
		validateCreateEventList:"_ValidationResult",
		validateUpdateEventList:"_ValidationResult",
		getBoxItem:"BoxItem",
		listBoxItem:"BoxItem",
		paginateBoxItem:"BoxItemConnection",
		validateCreateBoxItem:"_ValidationResult",
		validateUpdateBoxItem:"_ValidationResult",
		getBoxList:"BoxList",
		listBoxList:"BoxList",
		paginateBoxList:"BoxListConnection",
		validateCreateBoxList:"_ValidationResult",
		validateUpdateBoxList:"_ValidationResult",
		getNewsletterForm:"NewsletterForm",
		listNewsletterForm:"NewsletterForm",
		paginateNewsletterForm:"NewsletterFormConnection",
		validateCreateNewsletterForm:"_ValidationResult",
		validateUpdateNewsletterForm:"_ValidationResult",
		getNewsletterTypeItem:"NewsletterTypeItem",
		listNewsletterTypeItem:"NewsletterTypeItem",
		paginateNewsletterTypeItem:"NewsletterTypeItemConnection",
		validateCreateNewsletterTypeItem:"_ValidationResult",
		validateUpdateNewsletterTypeItem:"_ValidationResult",
		getNewsletterFormLocale:"NewsletterFormLocale",
		listNewsletterFormLocale:"NewsletterFormLocale",
		paginateNewsletterFormLocale:"NewsletterFormLocaleConnection",
		validateCreateNewsletterFormLocale:"_ValidationResult",
		validateUpdateNewsletterFormLocale:"_ValidationResult",
		getNewsletterSubscription:"NewsletterSubscription",
		listNewsletterSubscription:"NewsletterSubscription",
		paginateNewsletterSubscription:"NewsletterSubscriptionConnection",
		validateCreateNewsletterSubscription:"_ValidationResult",
		validateUpdateNewsletterSubscription:"_ValidationResult",
		getChart:"Chart",
		listChart:"Chart",
		paginateChart:"ChartConnection",
		validateCreateChart:"_ValidationResult",
		validateUpdateChart:"_ValidationResult",
		getChartData:"ChartData",
		listChartData:"ChartData",
		paginateChartData:"ChartDataConnection",
		validateCreateChartData:"_ValidationResult",
		validateUpdateChartData:"_ValidationResult",
		getEmployee:"Employee",
		listEmployee:"Employee",
		paginateEmployee:"EmployeeConnection",
		validateCreateEmployee:"_ValidationResult",
		validateUpdateEmployee:"_ValidationResult",
		getEmployeeItem:"EmployeeItem",
		listEmployeeItem:"EmployeeItem",
		paginateEmployeeItem:"EmployeeItemConnection",
		validateCreateEmployeeItem:"_ValidationResult",
		validateUpdateEmployeeItem:"_ValidationResult",
		getEmployeeList:"EmployeeList",
		listEmployeeList:"EmployeeList",
		paginateEmployeeList:"EmployeeListConnection",
		validateCreateEmployeeList:"_ValidationResult",
		validateUpdateEmployeeList:"_ValidationResult",
		getEmployeeLocale:"EmployeeLocale",
		listEmployeeLocale:"EmployeeLocale",
		paginateEmployeeLocale:"EmployeeLocaleConnection",
		validateCreateEmployeeLocale:"_ValidationResult",
		validateUpdateEmployeeLocale:"_ValidationResult",
		getPhotographer:"Photographer",
		listPhotographer:"Photographer",
		paginatePhotographer:"PhotographerConnection",
		validateCreatePhotographer:"_ValidationResult",
		validateUpdatePhotographer:"_ValidationResult",
		getDefinitionItem:"DefinitionItem",
		listDefinitionItem:"DefinitionItem",
		paginateDefinitionItem:"DefinitionItemConnection",
		validateCreateDefinitionItem:"_ValidationResult",
		validateUpdateDefinitionItem:"_ValidationResult",
		getDefinitionList:"DefinitionList",
		listDefinitionList:"DefinitionList",
		paginateDefinitionList:"DefinitionListConnection",
		validateCreateDefinitionList:"_ValidationResult",
		validateUpdateDefinitionList:"_ValidationResult",
		getLogoItem:"LogoItem",
		listLogoItem:"LogoItem",
		paginateLogoItem:"LogoItemConnection",
		validateCreateLogoItem:"_ValidationResult",
		validateUpdateLogoItem:"_ValidationResult",
		getLogoList:"LogoList",
		listLogoList:"LogoList",
		paginateLogoList:"LogoListConnection",
		validateCreateLogoList:"_ValidationResult",
		validateUpdateLogoList:"_ValidationResult",
		getStrategySchema:"StrategySchema",
		listStrategySchema:"StrategySchema",
		paginateStrategySchema:"StrategySchemaConnection",
		validateCreateStrategySchema:"_ValidationResult",
		validateUpdateStrategySchema:"_ValidationResult",
		getStrategySchemaGroup:"StrategySchemaGroup",
		listStrategySchemaGroup:"StrategySchemaGroup",
		paginateStrategySchemaGroup:"StrategySchemaGroupConnection",
		validateCreateStrategySchemaGroup:"_ValidationResult",
		validateUpdateStrategySchemaGroup:"_ValidationResult",
		getStrategySchemaGroupItem:"StrategySchemaGroupItem",
		listStrategySchemaGroupItem:"StrategySchemaGroupItem",
		paginateStrategySchemaGroupItem:"StrategySchemaGroupItemConnection",
		validateCreateStrategySchemaGroupItem:"_ValidationResult",
		validateUpdateStrategySchemaGroupItem:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getContactForm:"ContactForm",
		listContactForm:"ContactForm",
		paginateContactForm:"ContactFormConnection",
		validateCreateContactForm:"_ValidationResult",
		validateUpdateContactForm:"_ValidationResult",
		getContactFormLocale:"ContactFormLocale",
		listContactFormLocale:"ContactFormLocale",
		paginateContactFormLocale:"ContactFormLocaleConnection",
		validateCreateContactFormLocale:"_ValidationResult",
		validateUpdateContactFormLocale:"_ValidationResult",
		getContactSubscription:"ContactSubscription",
		listContactSubscription:"ContactSubscription",
		paginateContactSubscription:"ContactSubscriptionConnection",
		validateCreateContactSubscription:"_ValidationResult",
		validateUpdateContactSubscription:"_ValidationResult",
		getContactTypeItem:"ContactTypeItem",
		listContactTypeItem:"ContactTypeItem",
		paginateContactTypeItem:"ContactTypeItemConnection",
		validateCreateContactTypeItem:"_ValidationResult",
		validateUpdateContactTypeItem:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult",
		transaction:"QueryTransaction",
		_info:"Info",
		schema:"_Schema",
		s3DummyQuery:"String"
	},
	ContactPage:{
		_meta:"ContactPageMeta",
		id:"UUID",
		unique:"One",
		locales:"ContactPageLocale",
		localesByLocale:"ContactPageLocale",
		localesByLink:"ContactPageLocale",
		localesBySeo:"ContactPageLocale",
		localesByAddressLink:"ContactPageLocale",
		paginateLocales:"ContactPageLocaleConnection"
	},
	ContactPageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	FieldMeta:{
		readable:"Boolean",
		updatable:"Boolean"
	},
	ContactPageLocale:{
		_meta:"ContactPageLocaleMeta",
		id:"UUID",
		title:"String",
		root:"ContactPage",
		locale:"Locale",
		link:"Linkable",
		seo:"Seo",
		address:"String",
		phone:"String",
		email:"String",
		youtube:"String",
		instagram:"String",
		facebook:"String",
		databox:"String",
		databoxNumber:"String",
		addressLink:"Link",
		socialsLabel:"String",
		openingHours:"String",
		identificationsLabel:"String",
		ico:"String",
		dic:"String",
		phoneLabel:"String",
		emailLabel:"String",
		linkedIn:"String",
		securities:"String",
		securitiesNumber:"String"
	},
	ContactPageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		address:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		youtube:"FieldMeta",
		instagram:"FieldMeta",
		facebook:"FieldMeta",
		databox:"FieldMeta",
		databoxNumber:"FieldMeta",
		addressLink:"FieldMeta",
		socialsLabel:"FieldMeta",
		openingHours:"FieldMeta",
		identificationsLabel:"FieldMeta",
		ico:"FieldMeta",
		dic:"FieldMeta",
		phoneLabel:"FieldMeta",
		emailLabel:"FieldMeta",
		linkedIn:"FieldMeta",
		securities:"FieldMeta",
		securitiesNumber:"FieldMeta"
	},
	Locale:{
		_meta:"LocaleMeta",
		id:"UUID",
		code:"String",
		label:"String",
		contactPages:"ContactPageLocale",
		footers:"FooterLocale",
		headers:"HeaderLocale",
		homePages:"HomePageLocale",
		pages:"PageLocale",
		seoDefaults:"SeoDefaultLocale",
		events:"EventLocale",
		artworks:"ArtworkLocale",
		artworkSelections:"ArtworkSelectionLocale",
		newsletterForms:"NewsletterFormLocale",
		employees:"EmployeeLocale",
		contactForms:"ContactFormLocale",
		contactPagesByRoot:"ContactPageLocale",
		contactPagesByLink:"ContactPageLocale",
		contactPagesBySeo:"ContactPageLocale",
		contactPagesByAddressLink:"ContactPageLocale",
		footersByRoot:"FooterLocale",
		footersByDeveloperLink:"FooterLocale",
		headersByRoot:"HeaderLocale",
		headersByArtworkBreadcrumbParentLink:"HeaderLocale",
		homePagesByRoot:"HomePageLocale",
		homePagesByContent:"HomePageLocale",
		homePagesByLink:"HomePageLocale",
		homePagesBySeo:"HomePageLocale",
		pagesByRoot:"PageLocale",
		pagesByLink:"PageLocale",
		pagesByContent:"PageLocale",
		pagesBySeo:"PageLocale",
		seoDefaultsByRoot:"SeoDefaultLocale",
		seoDefaultsBySeo:"SeoDefaultLocale",
		eventsByRoot:"EventLocale",
		eventsByImage:"EventLocale",
		eventsBySeo:"EventLocale",
		eventsByLink:"EventLocale",
		eventsByContent:"EventLocale",
		artworksByRoot:"ArtworkLocale",
		artworksByContent:"ArtworkLocale",
		artworksBySeo:"ArtworkLocale",
		artworksByLink:"ArtworkLocale",
		artworkSelectionsByRoot:"ArtworkSelectionLocale",
		artworkSelectionsBySeo:"ArtworkSelectionLocale",
		artworkSelectionsByLink:"ArtworkSelectionLocale",
		newsletterFormsByRoot:"NewsletterFormLocale",
		newsletterFormsByItems:"NewsletterFormLocale",
		employeesByRoot:"EmployeeLocale",
		contactFormsByRoot:"ContactFormLocale",
		contactFormsByItems:"ContactFormLocale",
		paginateContactPages:"ContactPageLocaleConnection",
		paginateFooters:"FooterLocaleConnection",
		paginateHeaders:"HeaderLocaleConnection",
		paginateHomePages:"HomePageLocaleConnection",
		paginatePages:"PageLocaleConnection",
		paginateSeoDefaults:"SeoDefaultLocaleConnection",
		paginateEvents:"EventLocaleConnection",
		paginateArtworks:"ArtworkLocaleConnection",
		paginateArtworkSelections:"ArtworkSelectionLocaleConnection",
		paginateNewsletterForms:"NewsletterFormLocaleConnection",
		paginateEmployees:"EmployeeLocaleConnection",
		paginateContactForms:"ContactFormLocaleConnection"
	},
	LocaleMeta:{
		id:"FieldMeta",
		code:"FieldMeta",
		label:"FieldMeta",
		contactPages:"FieldMeta",
		footers:"FieldMeta",
		headers:"FieldMeta",
		homePages:"FieldMeta",
		pages:"FieldMeta",
		seoDefaults:"FieldMeta",
		events:"FieldMeta",
		artworks:"FieldMeta",
		artworkSelections:"FieldMeta",
		newsletterForms:"FieldMeta",
		employees:"FieldMeta",
		contactForms:"FieldMeta"
	},
	FooterLocale:{
		_meta:"FooterLocaleMeta",
		id:"UUID",
		address:"String",
		phone:"String",
		email:"String",
		youtube:"String",
		instagram:"String",
		facebook:"String",
		graphicDesign:"String",
		root:"Footer",
		locale:"Locale",
		graphicDesigners:"GraphicDesigner",
		developerLink:"Link",
		development:"String",
		linkedIn:"String",
		photography:"String",
		photographers:"Photographer",
		paginateGraphicDesigners:"GraphicDesignerConnection",
		paginatePhotographers:"PhotographerConnection"
	},
	FooterLocaleMeta:{
		id:"FieldMeta",
		address:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		youtube:"FieldMeta",
		instagram:"FieldMeta",
		facebook:"FieldMeta",
		graphicDesign:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		graphicDesigners:"FieldMeta",
		developerLink:"FieldMeta",
		development:"FieldMeta",
		linkedIn:"FieldMeta",
		photography:"FieldMeta",
		photographers:"FieldMeta"
	},
	Footer:{
		_meta:"FooterMeta",
		id:"UUID",
		unique:"One",
		logo:"Image",
		locales:"FooterLocale",
		localesByLocale:"FooterLocale",
		localesByDeveloperLink:"FooterLocale",
		paginateLocales:"FooterLocaleConnection"
	},
	FooterMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		logo:"FieldMeta",
		locales:"FieldMeta"
	},
	Image:{
		_meta:"ImageMeta",
		id:"UUID",
		url:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		alt:"String"
	},
	ImageMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		alt:"FieldMeta"
	},
	FooterLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"FooterLocaleEdge"
	},
	PageInfo:{
		totalCount:"Int"
	},
	FooterLocaleEdge:{
		node:"FooterLocale"
	},
	GraphicDesigner:{
		_meta:"GraphicDesignerMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	GraphicDesignerMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	Link:{
		_meta:"LinkMeta",
		id:"UUID",
		type:"LinkType",
		title:"String",
		externalLink:"String",
		internalLink:"Linkable",
		anchorLink:"String"
	},
	LinkMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		externalLink:"FieldMeta",
		internalLink:"FieldMeta",
		anchorLink:"FieldMeta"
	},
	Linkable:{
		_meta:"LinkableMeta",
		id:"UUID",
		url:"String",
		homePage:"HomePageLocale",
		contactPage:"ContactPageLocale",
		page:"PageLocale",
		event:"EventLocale",
		artwork:"ArtworkLocale",
		artworkSelection:"ArtworkSelectionLocale",
		redirect:"Redirect"
	},
	LinkableMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		homePage:"FieldMeta",
		contactPage:"FieldMeta",
		page:"FieldMeta",
		event:"FieldMeta",
		artwork:"FieldMeta",
		artworkSelection:"FieldMeta",
		redirect:"FieldMeta"
	},
	HomePageLocale:{
		_meta:"HomePageLocaleMeta",
		id:"UUID",
		title:"String",
		root:"HomePage",
		locale:"Locale",
		content:"Content",
		link:"Linkable",
		seo:"Seo",
		branches:"Branches",
		leadParagraph:"String",
		paginateBranches:"BranchesConnection"
	},
	HomePageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		link:"FieldMeta",
		seo:"FieldMeta",
		branches:"FieldMeta",
		leadParagraph:"FieldMeta"
	},
	HomePage:{
		_meta:"HomePageMeta",
		id:"UUID",
		unique:"One",
		locales:"HomePageLocale",
		media:"MediumList",
		localesByLocale:"HomePageLocale",
		localesByContent:"HomePageLocale",
		localesByLink:"HomePageLocale",
		localesBySeo:"HomePageLocale",
		paginateLocales:"HomePageLocaleConnection"
	},
	HomePageMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		media:"FieldMeta"
	},
	MediumList:{
		_meta:"MediumListMeta",
		id:"UUID",
		items:"MediumItem",
		paginateItems:"MediumItemConnection"
	},
	MediumListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	MediumItem:{
		_meta:"MediumItemMeta",
		id:"UUID",
		order:"Int",
		list:"MediumList",
		medium:"Medium"
	},
	MediumItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		medium:"FieldMeta"
	},
	Medium:{
		_meta:"MediumMeta",
		id:"UUID",
		type:"MediumType",
		image:"Image",
		video:"Video",
		youtubeEmbed:"String"
	},
	MediumMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		image:"FieldMeta",
		video:"FieldMeta",
		youtubeEmbed:"FieldMeta"
	},
	Video:{
		_meta:"VideoMeta",
		id:"UUID",
		src:"String",
		width:"Int",
		height:"Int",
		size:"Int",
		type:"String",
		duration:"Float",
		poster:"Image"
	},
	VideoMeta:{
		id:"FieldMeta",
		src:"FieldMeta",
		width:"FieldMeta",
		height:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta",
		duration:"FieldMeta",
		poster:"FieldMeta"
	},
	MediumItemConnection:{
		pageInfo:"PageInfo",
		edges:"MediumItemEdge"
	},
	MediumItemEdge:{
		node:"MediumItem"
	},
	HomePageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageLocaleEdge"
	},
	HomePageLocaleEdge:{
		node:"HomePageLocale"
	},
	Content:{
		_meta:"ContentMeta",
		id:"UUID",
		blocks:"ContentBlock",
		blocksByReferences:"ContentBlock",
		paginateBlocks:"ContentBlockConnection"
	},
	ContentMeta:{
		id:"FieldMeta",
		blocks:"FieldMeta"
	},
	ContentBlock:{
		_meta:"ContentBlockMeta",
		id:"UUID",
		order:"Int",
		json:"String",
		content:"Content",
		references:"ContentReference",
		referencesByMedia:"ContentReference",
		referencesByLink:"ContentReference",
		referencesByDropDownList:"ContentReference",
		referencesByEventList:"ContentReference",
		referencesByBoxList:"ContentReference",
		referencesByChart:"ContentReference",
		referencesByDefinitionList:"ContentReference",
		referencesByLogoList:"ContentReference",
		referencesByStrategySchema:"ContentReference",
		referencesByEmployeeList:"ContentReference",
		paginateReferences:"ContentReferenceConnection"
	},
	ContentBlockMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		json:"FieldMeta",
		content:"FieldMeta",
		references:"FieldMeta"
	},
	ContentReference:{
		_meta:"ContentReferenceMeta",
		id:"UUID",
		type:"ContentReferenceType",
		primaryText:"String",
		block:"ContentBlock",
		media:"MediumList",
		link:"Link",
		secondaryText:"String",
		dropDownList:"DropDownList",
		artworkSelection:"ArtworkSelection",
		eventList:"EventList",
		boxList:"BoxList",
		isVisible:"Boolean",
		chart:"Chart",
		definitionList:"DefinitionList",
		logoList:"LogoList",
		strategySchema:"StrategySchema",
		image:"Image",
		employeeList:"EmployeeList",
		imageSecond:"Image",
		contactForm:"ContactForm",
		newsletterForm:"NewsletterForm"
	},
	ContentReferenceMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		primaryText:"FieldMeta",
		block:"FieldMeta",
		media:"FieldMeta",
		link:"FieldMeta",
		secondaryText:"FieldMeta",
		dropDownList:"FieldMeta",
		artworkSelection:"FieldMeta",
		eventList:"FieldMeta",
		boxList:"FieldMeta",
		isVisible:"FieldMeta",
		chart:"FieldMeta",
		definitionList:"FieldMeta",
		logoList:"FieldMeta",
		strategySchema:"FieldMeta",
		image:"FieldMeta",
		employeeList:"FieldMeta",
		imageSecond:"FieldMeta",
		contactForm:"FieldMeta",
		newsletterForm:"FieldMeta"
	},
	DropDownList:{
		_meta:"DropDownListMeta",
		id:"UUID",
		items:"DropDownItem",
		dropDownType:"DropDownType",
		employees:"EmployeeList",
		itemsByLink:"DropDownItem",
		paginateItems:"DropDownItemConnection"
	},
	DropDownListMeta:{
		id:"FieldMeta",
		items:"FieldMeta",
		dropDownType:"FieldMeta",
		employees:"FieldMeta"
	},
	DropDownItem:{
		_meta:"DropDownItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		text:"String",
		list:"DropDownList",
		link:"Link"
	},
	DropDownItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta",
		link:"FieldMeta"
	},
	EmployeeList:{
		_meta:"EmployeeListMeta",
		id:"UUID",
		items:"EmployeeItem",
		paginateItems:"EmployeeItemConnection"
	},
	EmployeeListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	EmployeeItem:{
		_meta:"EmployeeItemMeta",
		id:"UUID",
		order:"Int",
		list:"EmployeeList",
		employee:"Employee"
	},
	EmployeeItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		employee:"FieldMeta"
	},
	Employee:{
		_meta:"EmployeeMeta",
		id:"UUID",
		order:"Int",
		name:"String",
		image:"Image",
		locales:"EmployeeLocale",
		localesByLocale:"EmployeeLocale",
		paginateLocales:"EmployeeLocaleConnection"
	},
	EmployeeMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		name:"FieldMeta",
		image:"FieldMeta",
		locales:"FieldMeta"
	},
	EmployeeLocale:{
		_meta:"EmployeeLocaleMeta",
		id:"UUID",
		position:"String",
		text:"String",
		email:"String",
		phone:"String",
		root:"Employee",
		locale:"Locale"
	},
	EmployeeLocaleMeta:{
		id:"FieldMeta",
		position:"FieldMeta",
		text:"FieldMeta",
		email:"FieldMeta",
		phone:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta"
	},
	EmployeeLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeLocaleEdge"
	},
	EmployeeLocaleEdge:{
		node:"EmployeeLocale"
	},
	EmployeeItemConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeItemEdge"
	},
	EmployeeItemEdge:{
		node:"EmployeeItem"
	},
	DropDownItemConnection:{
		pageInfo:"PageInfo",
		edges:"DropDownItemEdge"
	},
	DropDownItemEdge:{
		node:"DropDownItem"
	},
	ArtworkSelection:{
		_meta:"ArtworkSelectionMeta",
		id:"UUID",
		order:"Int",
		locales:"ArtworkSelectionLocale",
		artworks:"ArtworkSelectionList",
		localesByLocale:"ArtworkSelectionLocale",
		localesBySeo:"ArtworkSelectionLocale",
		localesByLink:"ArtworkSelectionLocale",
		paginateLocales:"ArtworkSelectionLocaleConnection"
	},
	ArtworkSelectionMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta",
		artworks:"FieldMeta"
	},
	ArtworkSelectionLocale:{
		_meta:"ArtworkSelectionLocaleMeta",
		id:"UUID",
		title:"String",
		root:"ArtworkSelection",
		locale:"Locale",
		seo:"Seo",
		link:"Linkable"
	},
	ArtworkSelectionLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta"
	},
	Seo:{
		_meta:"SeoMeta",
		id:"UUID",
		title:"String",
		description:"String",
		ogTitle:"String",
		ogDescription:"String",
		noIndex:"Boolean",
		noFollow:"Boolean",
		ogImage:"Image"
	},
	SeoMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		description:"FieldMeta",
		ogTitle:"FieldMeta",
		ogDescription:"FieldMeta",
		noIndex:"FieldMeta",
		noFollow:"FieldMeta",
		ogImage:"FieldMeta"
	},
	ArtworkSelectionList:{
		_meta:"ArtworkSelectionListMeta",
		id:"UUID",
		items:"ArtworkSelectionItem",
		paginateItems:"ArtworkSelectionItemConnection"
	},
	ArtworkSelectionListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ArtworkSelectionItem:{
		_meta:"ArtworkSelectionItemMeta",
		id:"UUID",
		order:"Int",
		list:"ArtworkSelectionList",
		artwork:"Artwork"
	},
	ArtworkSelectionItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		artwork:"FieldMeta"
	},
	Artwork:{
		_meta:"ArtworkMeta",
		id:"UUID",
		order:"Int",
		locales:"ArtworkLocale",
		image:"Image",
		gallery:"Gallery",
		localesByLocale:"ArtworkLocale",
		localesByContent:"ArtworkLocale",
		localesBySeo:"ArtworkLocale",
		localesByLink:"ArtworkLocale",
		paginateLocales:"ArtworkLocaleConnection"
	},
	ArtworkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		locales:"FieldMeta",
		image:"FieldMeta",
		gallery:"FieldMeta"
	},
	ArtworkLocale:{
		_meta:"ArtworkLocaleMeta",
		id:"UUID",
		title:"String",
		label:"String",
		leadParagraph:"String",
		root:"Artwork",
		locale:"Locale",
		content:"Content",
		seo:"Seo",
		link:"Linkable",
		artist:"String"
	},
	ArtworkLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		label:"FieldMeta",
		leadParagraph:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		artist:"FieldMeta"
	},
	Gallery:{
		_meta:"GalleryMeta",
		id:"UUID",
		items:"GalleryItem",
		paginateItems:"GalleryItemConnection"
	},
	GalleryMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	GalleryItem:{
		_meta:"GalleryItemMeta",
		id:"UUID",
		order:"Int",
		list:"Gallery",
		image:"Image"
	},
	GalleryItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	GalleryItemConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryItemEdge"
	},
	GalleryItemEdge:{
		node:"GalleryItem"
	},
	ArtworkLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkLocaleEdge"
	},
	ArtworkLocaleEdge:{
		node:"ArtworkLocale"
	},
	ArtworkSelectionItemConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkSelectionItemEdge"
	},
	ArtworkSelectionItemEdge:{
		node:"ArtworkSelectionItem"
	},
	ArtworkSelectionLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkSelectionLocaleEdge"
	},
	ArtworkSelectionLocaleEdge:{
		node:"ArtworkSelectionLocale"
	},
	EventList:{
		_meta:"EventListMeta",
		id:"UUID",
		items:"EventItem",
		paginateItems:"EventItemConnection"
	},
	EventListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	EventItem:{
		_meta:"EventItemMeta",
		id:"UUID",
		order:"Int",
		list:"EventList",
		event:"Event"
	},
	EventItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		event:"FieldMeta"
	},
	Event:{
		_meta:"EventMeta",
		id:"UUID",
		locales:"EventLocale",
		order:"Int",
		dateStart:"DateTime",
		dateFinish:"DateTime",
		localesByLocale:"EventLocale",
		localesByImage:"EventLocale",
		localesBySeo:"EventLocale",
		localesByLink:"EventLocale",
		localesByContent:"EventLocale",
		paginateLocales:"EventLocaleConnection"
	},
	EventMeta:{
		id:"FieldMeta",
		locales:"FieldMeta",
		order:"FieldMeta",
		dateStart:"FieldMeta",
		dateFinish:"FieldMeta"
	},
	EventLocale:{
		_meta:"EventLocaleMeta",
		id:"UUID",
		title:"String",
		root:"Event",
		locale:"Locale",
		image:"Image",
		seo:"Seo",
		link:"Linkable",
		venue:"String",
		venueNote:"String",
		content:"Content",
		date:"String",
		leadParagraph:"String",
		isDark:"Boolean"
	},
	EventLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		image:"FieldMeta",
		seo:"FieldMeta",
		link:"FieldMeta",
		venue:"FieldMeta",
		venueNote:"FieldMeta",
		content:"FieldMeta",
		date:"FieldMeta",
		leadParagraph:"FieldMeta",
		isDark:"FieldMeta"
	},
	EventLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"EventLocaleEdge"
	},
	EventLocaleEdge:{
		node:"EventLocale"
	},
	EventItemConnection:{
		pageInfo:"PageInfo",
		edges:"EventItemEdge"
	},
	EventItemEdge:{
		node:"EventItem"
	},
	BoxList:{
		_meta:"BoxListMeta",
		id:"UUID",
		items:"BoxItem",
		paginateItems:"BoxItemConnection"
	},
	BoxListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	BoxItem:{
		_meta:"BoxItemMeta",
		id:"UUID",
		order:"Int",
		link:"String",
		date:"String",
		type:"String",
		title:"String",
		text:"String",
		list:"BoxList"
	},
	BoxItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta",
		date:"FieldMeta",
		type:"FieldMeta",
		title:"FieldMeta",
		text:"FieldMeta",
		list:"FieldMeta"
	},
	BoxItemConnection:{
		pageInfo:"PageInfo",
		edges:"BoxItemEdge"
	},
	BoxItemEdge:{
		node:"BoxItem"
	},
	Chart:{
		_meta:"ChartMeta",
		id:"UUID",
		type:"ChartType",
		items:"ChartData",
		paginateItems:"ChartDataConnection"
	},
	ChartMeta:{
		id:"FieldMeta",
		type:"FieldMeta",
		items:"FieldMeta"
	},
	ChartData:{
		_meta:"ChartDataMeta",
		id:"UUID",
		order:"Int",
		list:"Chart",
		date:"Date",
		number:"Float",
		text:"String",
		image:"Image"
	},
	ChartDataMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		date:"FieldMeta",
		number:"FieldMeta",
		text:"FieldMeta",
		image:"FieldMeta"
	},
	ChartDataConnection:{
		pageInfo:"PageInfo",
		edges:"ChartDataEdge"
	},
	ChartDataEdge:{
		node:"ChartData"
	},
	DefinitionList:{
		_meta:"DefinitionListMeta",
		id:"UUID",
		items:"DefinitionItem",
		paginateItems:"DefinitionItemConnection"
	},
	DefinitionListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	DefinitionItem:{
		_meta:"DefinitionItemMeta",
		id:"UUID",
		order:"Int",
		key:"String",
		value:"String",
		list:"DefinitionList"
	},
	DefinitionItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		key:"FieldMeta",
		value:"FieldMeta",
		list:"FieldMeta"
	},
	DefinitionItemConnection:{
		pageInfo:"PageInfo",
		edges:"DefinitionItemEdge"
	},
	DefinitionItemEdge:{
		node:"DefinitionItem"
	},
	LogoList:{
		_meta:"LogoListMeta",
		id:"UUID",
		items:"LogoItem",
		paginateItems:"LogoItemConnection"
	},
	LogoListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	LogoItem:{
		_meta:"LogoItemMeta",
		id:"UUID",
		order:"Int",
		list:"LogoList",
		image:"Image"
	},
	LogoItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		image:"FieldMeta"
	},
	LogoItemConnection:{
		pageInfo:"PageInfo",
		edges:"LogoItemEdge"
	},
	LogoItemEdge:{
		node:"LogoItem"
	},
	StrategySchema:{
		_meta:"StrategySchemaMeta",
		id:"UUID",
		inputFirst:"String",
		inputSecond:"String",
		inputThird:"String",
		outputFirst:"String",
		outputSecond:"String",
		outputThird:"String",
		itemsFirst:"StrategySchemaGroup",
		logo:"Image",
		itemsSecond:"StrategySchemaGroup"
	},
	StrategySchemaMeta:{
		id:"FieldMeta",
		inputFirst:"FieldMeta",
		inputSecond:"FieldMeta",
		inputThird:"FieldMeta",
		outputFirst:"FieldMeta",
		outputSecond:"FieldMeta",
		outputThird:"FieldMeta",
		itemsFirst:"FieldMeta",
		logo:"FieldMeta",
		itemsSecond:"FieldMeta"
	},
	StrategySchemaGroup:{
		_meta:"StrategySchemaGroupMeta",
		id:"UUID",
		items:"StrategySchemaGroupItem",
		paginateItems:"StrategySchemaGroupItemConnection"
	},
	StrategySchemaGroupMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	StrategySchemaGroupItem:{
		_meta:"StrategySchemaGroupItemMeta",
		id:"UUID",
		order:"Int",
		text:"String",
		schema:"StrategySchemaGroup"
	},
	StrategySchemaGroupItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		text:"FieldMeta",
		schema:"FieldMeta"
	},
	StrategySchemaGroupItemConnection:{
		pageInfo:"PageInfo",
		edges:"StrategySchemaGroupItemEdge"
	},
	StrategySchemaGroupItemEdge:{
		node:"StrategySchemaGroupItem"
	},
	ContactForm:{
		_meta:"ContactFormMeta",
		id:"UUID",
		unique:"One",
		locales:"ContactFormLocale",
		localesByLocale:"ContactFormLocale",
		localesByItems:"ContactFormLocale",
		paginateLocales:"ContactFormLocaleConnection"
	},
	ContactFormMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	ContactFormLocale:{
		_meta:"ContactFormLocaleMeta",
		id:"UUID",
		title:"String",
		name:"String",
		phone:"String",
		email:"String",
		message:"String",
		submit:"String",
		successMessage:"String",
		genericErrorMessage:"String",
		contactTypeErrorMessage:"String",
		root:"ContactForm",
		locale:"Locale",
		items:"ContactTypeItem",
		file:"String",
		itemsBySubscriptions:"ContactTypeItem",
		paginateItems:"ContactTypeItemConnection"
	},
	ContactFormLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		name:"FieldMeta",
		phone:"FieldMeta",
		email:"FieldMeta",
		message:"FieldMeta",
		submit:"FieldMeta",
		successMessage:"FieldMeta",
		genericErrorMessage:"FieldMeta",
		contactTypeErrorMessage:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		items:"FieldMeta",
		file:"FieldMeta"
	},
	ContactTypeItem:{
		_meta:"ContactTypeItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		subscriptions:"ContactSubscription",
		list:"ContactFormLocale",
		subscriptionsByFile:"ContactSubscription",
		paginateSubscriptions:"ContactSubscriptionConnection"
	},
	ContactTypeItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		subscriptions:"FieldMeta",
		list:"FieldMeta"
	},
	ContactSubscription:{
		_meta:"ContactSubscriptionMeta",
		id:"UUID",
		createdAt:"DateTime",
		email:"String",
		name:"String",
		phone:"String",
		message:"String",
		file:"File",
		contactType:"ContactTypeItem"
	},
	ContactSubscriptionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		email:"FieldMeta",
		name:"FieldMeta",
		phone:"FieldMeta",
		message:"FieldMeta",
		file:"FieldMeta",
		contactType:"FieldMeta"
	},
	File:{
		_meta:"FileMeta",
		id:"UUID",
		url:"String",
		size:"Int",
		type:"String"
	},
	FileMeta:{
		id:"FieldMeta",
		url:"FieldMeta",
		size:"FieldMeta",
		type:"FieldMeta"
	},
	ContactSubscriptionConnection:{
		pageInfo:"PageInfo",
		edges:"ContactSubscriptionEdge"
	},
	ContactSubscriptionEdge:{
		node:"ContactSubscription"
	},
	ContactTypeItemConnection:{
		pageInfo:"PageInfo",
		edges:"ContactTypeItemEdge"
	},
	ContactTypeItemEdge:{
		node:"ContactTypeItem"
	},
	ContactFormLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ContactFormLocaleEdge"
	},
	ContactFormLocaleEdge:{
		node:"ContactFormLocale"
	},
	NewsletterForm:{
		_meta:"NewsletterFormMeta",
		id:"UUID",
		unique:"One",
		locales:"NewsletterFormLocale",
		localesByLocale:"NewsletterFormLocale",
		localesByItems:"NewsletterFormLocale",
		paginateLocales:"NewsletterFormLocaleConnection"
	},
	NewsletterFormMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	NewsletterFormLocale:{
		_meta:"NewsletterFormLocaleMeta",
		id:"UUID",
		newsletterTypeNote:"String",
		email:"String",
		emailNote:"String",
		submit:"String",
		root:"NewsletterForm",
		locale:"Locale",
		items:"NewsletterTypeItem",
		title:"String",
		successMessage:"String",
		genericErrorMessage:"String",
		newsletterTypeErrorMessage:"String",
		itemsBySubscriptions:"NewsletterTypeItem",
		paginateItems:"NewsletterTypeItemConnection"
	},
	NewsletterFormLocaleMeta:{
		id:"FieldMeta",
		newsletterTypeNote:"FieldMeta",
		email:"FieldMeta",
		emailNote:"FieldMeta",
		submit:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		items:"FieldMeta",
		title:"FieldMeta",
		successMessage:"FieldMeta",
		genericErrorMessage:"FieldMeta",
		newsletterTypeErrorMessage:"FieldMeta"
	},
	NewsletterTypeItem:{
		_meta:"NewsletterTypeItemMeta",
		id:"UUID",
		order:"Int",
		title:"String",
		list:"NewsletterFormLocale",
		subscriptions:"NewsletterSubscription",
		paginateSubscriptions:"NewsletterSubscriptionConnection"
	},
	NewsletterTypeItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		title:"FieldMeta",
		list:"FieldMeta",
		subscriptions:"FieldMeta"
	},
	NewsletterSubscription:{
		_meta:"NewsletterSubscriptionMeta",
		id:"UUID",
		createdAt:"DateTime",
		email:"String",
		newsletterType:"NewsletterTypeItem"
	},
	NewsletterSubscriptionMeta:{
		id:"FieldMeta",
		createdAt:"FieldMeta",
		email:"FieldMeta",
		newsletterType:"FieldMeta"
	},
	NewsletterSubscriptionConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterSubscriptionEdge"
	},
	NewsletterSubscriptionEdge:{
		node:"NewsletterSubscription"
	},
	NewsletterTypeItemConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterTypeItemEdge"
	},
	NewsletterTypeItemEdge:{
		node:"NewsletterTypeItem"
	},
	NewsletterFormLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterFormLocaleEdge"
	},
	NewsletterFormLocaleEdge:{
		node:"NewsletterFormLocale"
	},
	ContentReferenceConnection:{
		pageInfo:"PageInfo",
		edges:"ContentReferenceEdge"
	},
	ContentReferenceEdge:{
		node:"ContentReference"
	},
	ContentBlockConnection:{
		pageInfo:"PageInfo",
		edges:"ContentBlockEdge"
	},
	ContentBlockEdge:{
		node:"ContentBlock"
	},
	Branches:{
		_meta:"BranchesMeta",
		id:"UUID",
		order:"Int",
		leadParagraph:"String",
		more:"String",
		link:"Link"
	},
	BranchesMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		leadParagraph:"FieldMeta",
		more:"FieldMeta",
		link:"FieldMeta"
	},
	BranchesConnection:{
		pageInfo:"PageInfo",
		edges:"BranchesEdge"
	},
	BranchesEdge:{
		node:"Branches"
	},
	PageLocale:{
		_meta:"PageLocaleMeta",
		id:"UUID",
		title:"String",
		link:"Linkable",
		root:"Page",
		locale:"Locale",
		content:"Content",
		seo:"Seo"
	},
	PageLocaleMeta:{
		id:"FieldMeta",
		title:"FieldMeta",
		link:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		content:"FieldMeta",
		seo:"FieldMeta"
	},
	Page:{
		_meta:"PageMeta",
		id:"UUID",
		locales:"PageLocale",
		localesByLocale:"PageLocale",
		localesByLink:"PageLocale",
		localesByContent:"PageLocale",
		localesBySeo:"PageLocale",
		paginateLocales:"PageLocaleConnection"
	},
	PageMeta:{
		id:"FieldMeta",
		locales:"FieldMeta"
	},
	PageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"PageLocaleEdge"
	},
	PageLocaleEdge:{
		node:"PageLocale"
	},
	Redirect:{
		_meta:"RedirectMeta",
		id:"UUID",
		link:"Linkable",
		target:"Linkable"
	},
	RedirectMeta:{
		id:"FieldMeta",
		link:"FieldMeta",
		target:"FieldMeta"
	},
	Photographer:{
		_meta:"PhotographerMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	PhotographerMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	GraphicDesignerConnection:{
		pageInfo:"PageInfo",
		edges:"GraphicDesignerEdge"
	},
	GraphicDesignerEdge:{
		node:"GraphicDesigner"
	},
	PhotographerConnection:{
		pageInfo:"PageInfo",
		edges:"PhotographerEdge"
	},
	PhotographerEdge:{
		node:"Photographer"
	},
	HeaderLocale:{
		_meta:"HeaderLocaleMeta",
		id:"UUID",
		root:"Header",
		locale:"Locale",
		links:"HeaderLink",
		artworkBreadcrumbParentLink:"Linkable",
		paginateLinks:"HeaderLinkConnection"
	},
	HeaderLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		links:"FieldMeta",
		artworkBreadcrumbParentLink:"FieldMeta"
	},
	Header:{
		_meta:"HeaderMeta",
		id:"UUID",
		unique:"One",
		locales:"HeaderLocale",
		logo:"Image",
		localesByLocale:"HeaderLocale",
		localesByArtworkBreadcrumbParentLink:"HeaderLocale",
		paginateLocales:"HeaderLocaleConnection"
	},
	HeaderMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta",
		logo:"FieldMeta"
	},
	HeaderLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLocaleEdge"
	},
	HeaderLocaleEdge:{
		node:"HeaderLocale"
	},
	HeaderLink:{
		_meta:"HeaderLinkMeta",
		id:"UUID",
		order:"Int",
		link:"Link"
	},
	HeaderLinkMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		link:"FieldMeta"
	},
	HeaderLinkConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderLinkEdge"
	},
	HeaderLinkEdge:{
		node:"HeaderLink"
	},
	SeoDefaultLocale:{
		_meta:"SeoDefaultLocaleMeta",
		id:"UUID",
		root:"SeoDefault",
		locale:"Locale",
		seo:"Seo"
	},
	SeoDefaultLocaleMeta:{
		id:"FieldMeta",
		root:"FieldMeta",
		locale:"FieldMeta",
		seo:"FieldMeta"
	},
	SeoDefault:{
		_meta:"SeoDefaultMeta",
		id:"UUID",
		unique:"One",
		locales:"SeoDefaultLocale",
		localesByLocale:"SeoDefaultLocale",
		localesBySeo:"SeoDefaultLocale",
		paginateLocales:"SeoDefaultLocaleConnection"
	},
	SeoDefaultMeta:{
		id:"FieldMeta",
		unique:"FieldMeta",
		locales:"FieldMeta"
	},
	SeoDefaultLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"SeoDefaultLocaleEdge"
	},
	SeoDefaultLocaleEdge:{
		node:"SeoDefaultLocale"
	},
	ContactPageLocaleConnection:{
		pageInfo:"PageInfo",
		edges:"ContactPageLocaleEdge"
	},
	ContactPageLocaleEdge:{
		node:"ContactPageLocale"
	},
	ContactPageConnection:{
		pageInfo:"PageInfo",
		edges:"ContactPageEdge"
	},
	ContactPageEdge:{
		node:"ContactPage"
	},
	_ValidationResult:{
		valid:"Boolean",
		errors:"_ValidationError"
	},
	_ValidationError:{
		path:"_PathFragment",
		message:"_ValidationMessage"
	},
	_PathFragment:{
		"...on _FieldPathFragment":"_FieldPathFragment",
		"...on _IndexPathFragment":"_IndexPathFragment"
	},
	_FieldPathFragment:{
		field:"String"
	},
	_IndexPathFragment:{
		index:"Int",
		alias:"String"
	},
	_ValidationMessage:{
		text:"String"
	},
	ContentConnection:{
		pageInfo:"PageInfo",
		edges:"ContentEdge"
	},
	ContentEdge:{
		node:"Content"
	},
	FooterConnection:{
		pageInfo:"PageInfo",
		edges:"FooterEdge"
	},
	FooterEdge:{
		node:"Footer"
	},
	HeaderConnection:{
		pageInfo:"PageInfo",
		edges:"HeaderEdge"
	},
	HeaderEdge:{
		node:"Header"
	},
	HomePageConnection:{
		pageInfo:"PageInfo",
		edges:"HomePageEdge"
	},
	HomePageEdge:{
		node:"HomePage"
	},
	LinkConnection:{
		pageInfo:"PageInfo",
		edges:"LinkEdge"
	},
	LinkEdge:{
		node:"Link"
	},
	LinkableConnection:{
		pageInfo:"PageInfo",
		edges:"LinkableEdge"
	},
	LinkableEdge:{
		node:"Linkable"
	},
	LocaleConnection:{
		pageInfo:"PageInfo",
		edges:"LocaleEdge"
	},
	LocaleEdge:{
		node:"Locale"
	},
	MediumConnection:{
		pageInfo:"PageInfo",
		edges:"MediumEdge"
	},
	MediumEdge:{
		node:"Medium"
	},
	MediumListConnection:{
		pageInfo:"PageInfo",
		edges:"MediumListEdge"
	},
	MediumListEdge:{
		node:"MediumList"
	},
	PageConnection:{
		pageInfo:"PageInfo",
		edges:"PageEdge"
	},
	PageEdge:{
		node:"Page"
	},
	SeoDefaultConnection:{
		pageInfo:"PageInfo",
		edges:"SeoDefaultEdge"
	},
	SeoDefaultEdge:{
		node:"SeoDefault"
	},
	VideoConnection:{
		pageInfo:"PageInfo",
		edges:"VideoEdge"
	},
	VideoEdge:{
		node:"Video"
	},
	ImageConnection:{
		pageInfo:"PageInfo",
		edges:"ImageEdge"
	},
	ImageEdge:{
		node:"Image"
	},
	SeoConnection:{
		pageInfo:"PageInfo",
		edges:"SeoEdge"
	},
	SeoEdge:{
		node:"Seo"
	},
	TranslationDomain:{
		_meta:"TranslationDomainMeta",
		id:"UUID",
		identifier:"String",
		name:"String",
		catalogues:"TranslationCatalogue",
		keys:"TranslationKey",
		cataloguesByIdentifier:"TranslationCatalogue",
		cataloguesByValues:"TranslationCatalogue",
		keysByIdentifier:"TranslationKey",
		keysByValues:"TranslationKey",
		paginateCatalogues:"TranslationCatalogueConnection",
		paginateKeys:"TranslationKeyConnection"
	},
	TranslationDomainMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		name:"FieldMeta",
		catalogues:"FieldMeta",
		keys:"FieldMeta"
	},
	TranslationCatalogue:{
		_meta:"TranslationCatalogueMeta",
		id:"UUID",
		domain:"TranslationDomain",
		identifier:"TranslationCataloguesIdentifier",
		fallback:"TranslationCatalogue",
		values:"TranslationValue",
		valuesByKey:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationCatalogueMeta:{
		id:"FieldMeta",
		domain:"FieldMeta",
		identifier:"FieldMeta",
		fallback:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationCataloguesIdentifier:{
		_meta:"TranslationCataloguesIdentifierMeta",
		id:"UUID",
		name:"String",
		code:"String",
		catalogue:"TranslationCatalogue",
		catalogueByDomain:"TranslationCatalogue",
		catalogueByValues:"TranslationCatalogue",
		paginateCatalogue:"TranslationCatalogueConnection"
	},
	TranslationCataloguesIdentifierMeta:{
		id:"FieldMeta",
		name:"FieldMeta",
		code:"FieldMeta",
		catalogue:"FieldMeta"
	},
	TranslationCatalogueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCatalogueEdge"
	},
	TranslationCatalogueEdge:{
		node:"TranslationCatalogue"
	},
	TranslationValue:{
		_meta:"TranslationValueMeta",
		id:"UUID",
		value:"String",
		catalogue:"TranslationCatalogue",
		key:"TranslationKey"
	},
	TranslationValueMeta:{
		id:"FieldMeta",
		value:"FieldMeta",
		catalogue:"FieldMeta",
		key:"FieldMeta"
	},
	TranslationKey:{
		_meta:"TranslationKeyMeta",
		id:"UUID",
		identifier:"String",
		contentType:"TranslationContentType",
		note:"String",
		domain:"TranslationDomain",
		values:"TranslationValue",
		valuesByCatalogue:"TranslationValue",
		paginateValues:"TranslationValueConnection"
	},
	TranslationKeyMeta:{
		id:"FieldMeta",
		identifier:"FieldMeta",
		contentType:"FieldMeta",
		note:"FieldMeta",
		domain:"FieldMeta",
		values:"FieldMeta"
	},
	TranslationValueConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationValueEdge"
	},
	TranslationValueEdge:{
		node:"TranslationValue"
	},
	TranslationKeyConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationKeyEdge"
	},
	TranslationKeyEdge:{
		node:"TranslationKey"
	},
	TranslationDomainConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationDomainEdge"
	},
	TranslationDomainEdge:{
		node:"TranslationDomain"
	},
	TranslationCataloguesIdentifierConnection:{
		pageInfo:"PageInfo",
		edges:"TranslationCataloguesIdentifierEdge"
	},
	TranslationCataloguesIdentifierEdge:{
		node:"TranslationCataloguesIdentifier"
	},
	EventConnection:{
		pageInfo:"PageInfo",
		edges:"EventEdge"
	},
	EventEdge:{
		node:"Event"
	},
	ArtworkConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkEdge"
	},
	ArtworkEdge:{
		node:"Artwork"
	},
	DropDownListConnection:{
		pageInfo:"PageInfo",
		edges:"DropDownListEdge"
	},
	DropDownListEdge:{
		node:"DropDownList"
	},
	ArtworkItem:{
		_meta:"ArtworkItemMeta",
		id:"UUID",
		order:"Int",
		list:"ArtworkList",
		artwork:"ArtworkLocale"
	},
	ArtworkItemMeta:{
		id:"FieldMeta",
		order:"FieldMeta",
		list:"FieldMeta",
		artwork:"FieldMeta"
	},
	ArtworkList:{
		_meta:"ArtworkListMeta",
		id:"UUID",
		items:"ArtworkItem",
		paginateItems:"ArtworkItemConnection"
	},
	ArtworkListMeta:{
		id:"FieldMeta",
		items:"FieldMeta"
	},
	ArtworkItemConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkItemEdge"
	},
	ArtworkItemEdge:{
		node:"ArtworkItem"
	},
	ArtworkListConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkListEdge"
	},
	ArtworkListEdge:{
		node:"ArtworkList"
	},
	ArtworkSelectionConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkSelectionEdge"
	},
	ArtworkSelectionEdge:{
		node:"ArtworkSelection"
	},
	ArtworkSelectionListConnection:{
		pageInfo:"PageInfo",
		edges:"ArtworkSelectionListEdge"
	},
	ArtworkSelectionListEdge:{
		node:"ArtworkSelectionList"
	},
	EventListConnection:{
		pageInfo:"PageInfo",
		edges:"EventListEdge"
	},
	EventListEdge:{
		node:"EventList"
	},
	BoxListConnection:{
		pageInfo:"PageInfo",
		edges:"BoxListEdge"
	},
	BoxListEdge:{
		node:"BoxList"
	},
	NewsletterFormConnection:{
		pageInfo:"PageInfo",
		edges:"NewsletterFormEdge"
	},
	NewsletterFormEdge:{
		node:"NewsletterForm"
	},
	ChartConnection:{
		pageInfo:"PageInfo",
		edges:"ChartEdge"
	},
	ChartEdge:{
		node:"Chart"
	},
	EmployeeConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeEdge"
	},
	EmployeeEdge:{
		node:"Employee"
	},
	EmployeeListConnection:{
		pageInfo:"PageInfo",
		edges:"EmployeeListEdge"
	},
	EmployeeListEdge:{
		node:"EmployeeList"
	},
	DefinitionListConnection:{
		pageInfo:"PageInfo",
		edges:"DefinitionListEdge"
	},
	DefinitionListEdge:{
		node:"DefinitionList"
	},
	LogoListConnection:{
		pageInfo:"PageInfo",
		edges:"LogoListEdge"
	},
	LogoListEdge:{
		node:"LogoList"
	},
	StrategySchemaConnection:{
		pageInfo:"PageInfo",
		edges:"StrategySchemaEdge"
	},
	StrategySchemaEdge:{
		node:"StrategySchema"
	},
	StrategySchemaGroupConnection:{
		pageInfo:"PageInfo",
		edges:"StrategySchemaGroupEdge"
	},
	StrategySchemaGroupEdge:{
		node:"StrategySchemaGroup"
	},
	RedirectConnection:{
		pageInfo:"PageInfo",
		edges:"RedirectEdge"
	},
	RedirectEdge:{
		node:"Redirect"
	},
	GalleryConnection:{
		pageInfo:"PageInfo",
		edges:"GalleryEdge"
	},
	GalleryEdge:{
		node:"Gallery"
	},
	ContactFormConnection:{
		pageInfo:"PageInfo",
		edges:"ContactFormEdge"
	},
	ContactFormEdge:{
		node:"ContactForm"
	},
	FileConnection:{
		pageInfo:"PageInfo",
		edges:"FileEdge"
	},
	FileEdge:{
		node:"File"
	},
	QueryTransaction:{
		getContactPage:"ContactPage",
		listContactPage:"ContactPage",
		paginateContactPage:"ContactPageConnection",
		validateCreateContactPage:"_ValidationResult",
		validateUpdateContactPage:"_ValidationResult",
		getContactPageLocale:"ContactPageLocale",
		listContactPageLocale:"ContactPageLocale",
		paginateContactPageLocale:"ContactPageLocaleConnection",
		validateCreateContactPageLocale:"_ValidationResult",
		validateUpdateContactPageLocale:"_ValidationResult",
		getContent:"Content",
		listContent:"Content",
		paginateContent:"ContentConnection",
		validateCreateContent:"_ValidationResult",
		validateUpdateContent:"_ValidationResult",
		getContentBlock:"ContentBlock",
		listContentBlock:"ContentBlock",
		paginateContentBlock:"ContentBlockConnection",
		validateCreateContentBlock:"_ValidationResult",
		validateUpdateContentBlock:"_ValidationResult",
		getContentReference:"ContentReference",
		listContentReference:"ContentReference",
		paginateContentReference:"ContentReferenceConnection",
		validateCreateContentReference:"_ValidationResult",
		validateUpdateContentReference:"_ValidationResult",
		getFooter:"Footer",
		listFooter:"Footer",
		paginateFooter:"FooterConnection",
		validateCreateFooter:"_ValidationResult",
		validateUpdateFooter:"_ValidationResult",
		getFooterLocale:"FooterLocale",
		listFooterLocale:"FooterLocale",
		paginateFooterLocale:"FooterLocaleConnection",
		validateCreateFooterLocale:"_ValidationResult",
		validateUpdateFooterLocale:"_ValidationResult",
		getHeader:"Header",
		listHeader:"Header",
		paginateHeader:"HeaderConnection",
		validateCreateHeader:"_ValidationResult",
		validateUpdateHeader:"_ValidationResult",
		getHeaderLink:"HeaderLink",
		listHeaderLink:"HeaderLink",
		paginateHeaderLink:"HeaderLinkConnection",
		validateCreateHeaderLink:"_ValidationResult",
		validateUpdateHeaderLink:"_ValidationResult",
		getHeaderLocale:"HeaderLocale",
		listHeaderLocale:"HeaderLocale",
		paginateHeaderLocale:"HeaderLocaleConnection",
		validateCreateHeaderLocale:"_ValidationResult",
		validateUpdateHeaderLocale:"_ValidationResult",
		getHomePage:"HomePage",
		listHomePage:"HomePage",
		paginateHomePage:"HomePageConnection",
		validateCreateHomePage:"_ValidationResult",
		validateUpdateHomePage:"_ValidationResult",
		getHomePageLocale:"HomePageLocale",
		listHomePageLocale:"HomePageLocale",
		paginateHomePageLocale:"HomePageLocaleConnection",
		validateCreateHomePageLocale:"_ValidationResult",
		validateUpdateHomePageLocale:"_ValidationResult",
		getLink:"Link",
		listLink:"Link",
		paginateLink:"LinkConnection",
		validateCreateLink:"_ValidationResult",
		validateUpdateLink:"_ValidationResult",
		getLinkable:"Linkable",
		listLinkable:"Linkable",
		paginateLinkable:"LinkableConnection",
		validateCreateLinkable:"_ValidationResult",
		validateUpdateLinkable:"_ValidationResult",
		getLocale:"Locale",
		listLocale:"Locale",
		paginateLocale:"LocaleConnection",
		validateCreateLocale:"_ValidationResult",
		validateUpdateLocale:"_ValidationResult",
		getMedium:"Medium",
		listMedium:"Medium",
		paginateMedium:"MediumConnection",
		validateCreateMedium:"_ValidationResult",
		validateUpdateMedium:"_ValidationResult",
		getMediumItem:"MediumItem",
		listMediumItem:"MediumItem",
		paginateMediumItem:"MediumItemConnection",
		validateCreateMediumItem:"_ValidationResult",
		validateUpdateMediumItem:"_ValidationResult",
		getMediumList:"MediumList",
		listMediumList:"MediumList",
		paginateMediumList:"MediumListConnection",
		validateCreateMediumList:"_ValidationResult",
		validateUpdateMediumList:"_ValidationResult",
		getPage:"Page",
		listPage:"Page",
		paginatePage:"PageConnection",
		validateCreatePage:"_ValidationResult",
		validateUpdatePage:"_ValidationResult",
		getPageLocale:"PageLocale",
		listPageLocale:"PageLocale",
		paginatePageLocale:"PageLocaleConnection",
		validateCreatePageLocale:"_ValidationResult",
		validateUpdatePageLocale:"_ValidationResult",
		getSeoDefault:"SeoDefault",
		listSeoDefault:"SeoDefault",
		paginateSeoDefault:"SeoDefaultConnection",
		validateCreateSeoDefault:"_ValidationResult",
		validateUpdateSeoDefault:"_ValidationResult",
		getSeoDefaultLocale:"SeoDefaultLocale",
		listSeoDefaultLocale:"SeoDefaultLocale",
		paginateSeoDefaultLocale:"SeoDefaultLocaleConnection",
		validateCreateSeoDefaultLocale:"_ValidationResult",
		validateUpdateSeoDefaultLocale:"_ValidationResult",
		getVideo:"Video",
		listVideo:"Video",
		paginateVideo:"VideoConnection",
		validateCreateVideo:"_ValidationResult",
		validateUpdateVideo:"_ValidationResult",
		getImage:"Image",
		listImage:"Image",
		paginateImage:"ImageConnection",
		validateCreateImage:"_ValidationResult",
		validateUpdateImage:"_ValidationResult",
		getSeo:"Seo",
		listSeo:"Seo",
		paginateSeo:"SeoConnection",
		validateCreateSeo:"_ValidationResult",
		validateUpdateSeo:"_ValidationResult",
		getTranslationDomain:"TranslationDomain",
		listTranslationDomain:"TranslationDomain",
		paginateTranslationDomain:"TranslationDomainConnection",
		validateCreateTranslationDomain:"_ValidationResult",
		validateUpdateTranslationDomain:"_ValidationResult",
		getTranslationCatalogue:"TranslationCatalogue",
		listTranslationCatalogue:"TranslationCatalogue",
		paginateTranslationCatalogue:"TranslationCatalogueConnection",
		validateCreateTranslationCatalogue:"_ValidationResult",
		validateUpdateTranslationCatalogue:"_ValidationResult",
		getTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		listTranslationCataloguesIdentifier:"TranslationCataloguesIdentifier",
		paginateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierConnection",
		validateCreateTranslationCataloguesIdentifier:"_ValidationResult",
		validateUpdateTranslationCataloguesIdentifier:"_ValidationResult",
		getTranslationKey:"TranslationKey",
		listTranslationKey:"TranslationKey",
		paginateTranslationKey:"TranslationKeyConnection",
		validateCreateTranslationKey:"_ValidationResult",
		validateUpdateTranslationKey:"_ValidationResult",
		getTranslationValue:"TranslationValue",
		listTranslationValue:"TranslationValue",
		paginateTranslationValue:"TranslationValueConnection",
		validateCreateTranslationValue:"_ValidationResult",
		validateUpdateTranslationValue:"_ValidationResult",
		getBranches:"Branches",
		listBranches:"Branches",
		paginateBranches:"BranchesConnection",
		validateCreateBranches:"_ValidationResult",
		validateUpdateBranches:"_ValidationResult",
		getGraphicDesigner:"GraphicDesigner",
		listGraphicDesigner:"GraphicDesigner",
		paginateGraphicDesigner:"GraphicDesignerConnection",
		validateCreateGraphicDesigner:"_ValidationResult",
		validateUpdateGraphicDesigner:"_ValidationResult",
		getEvent:"Event",
		listEvent:"Event",
		paginateEvent:"EventConnection",
		validateCreateEvent:"_ValidationResult",
		validateUpdateEvent:"_ValidationResult",
		getEventLocale:"EventLocale",
		listEventLocale:"EventLocale",
		paginateEventLocale:"EventLocaleConnection",
		validateCreateEventLocale:"_ValidationResult",
		validateUpdateEventLocale:"_ValidationResult",
		getArtwork:"Artwork",
		listArtwork:"Artwork",
		paginateArtwork:"ArtworkConnection",
		validateCreateArtwork:"_ValidationResult",
		validateUpdateArtwork:"_ValidationResult",
		getArtworkLocale:"ArtworkLocale",
		listArtworkLocale:"ArtworkLocale",
		paginateArtworkLocale:"ArtworkLocaleConnection",
		validateCreateArtworkLocale:"_ValidationResult",
		validateUpdateArtworkLocale:"_ValidationResult",
		getDropDownItem:"DropDownItem",
		listDropDownItem:"DropDownItem",
		paginateDropDownItem:"DropDownItemConnection",
		validateCreateDropDownItem:"_ValidationResult",
		validateUpdateDropDownItem:"_ValidationResult",
		getDropDownList:"DropDownList",
		listDropDownList:"DropDownList",
		paginateDropDownList:"DropDownListConnection",
		validateCreateDropDownList:"_ValidationResult",
		validateUpdateDropDownList:"_ValidationResult",
		getArtworkItem:"ArtworkItem",
		listArtworkItem:"ArtworkItem",
		paginateArtworkItem:"ArtworkItemConnection",
		validateCreateArtworkItem:"_ValidationResult",
		validateUpdateArtworkItem:"_ValidationResult",
		getArtworkList:"ArtworkList",
		listArtworkList:"ArtworkList",
		paginateArtworkList:"ArtworkListConnection",
		validateCreateArtworkList:"_ValidationResult",
		validateUpdateArtworkList:"_ValidationResult",
		getArtworkSelection:"ArtworkSelection",
		listArtworkSelection:"ArtworkSelection",
		paginateArtworkSelection:"ArtworkSelectionConnection",
		validateCreateArtworkSelection:"_ValidationResult",
		validateUpdateArtworkSelection:"_ValidationResult",
		getArtworkSelectionItem:"ArtworkSelectionItem",
		listArtworkSelectionItem:"ArtworkSelectionItem",
		paginateArtworkSelectionItem:"ArtworkSelectionItemConnection",
		validateCreateArtworkSelectionItem:"_ValidationResult",
		validateUpdateArtworkSelectionItem:"_ValidationResult",
		getArtworkSelectionList:"ArtworkSelectionList",
		listArtworkSelectionList:"ArtworkSelectionList",
		paginateArtworkSelectionList:"ArtworkSelectionListConnection",
		validateCreateArtworkSelectionList:"_ValidationResult",
		validateUpdateArtworkSelectionList:"_ValidationResult",
		getArtworkSelectionLocale:"ArtworkSelectionLocale",
		listArtworkSelectionLocale:"ArtworkSelectionLocale",
		paginateArtworkSelectionLocale:"ArtworkSelectionLocaleConnection",
		validateCreateArtworkSelectionLocale:"_ValidationResult",
		validateUpdateArtworkSelectionLocale:"_ValidationResult",
		getEventItem:"EventItem",
		listEventItem:"EventItem",
		paginateEventItem:"EventItemConnection",
		validateCreateEventItem:"_ValidationResult",
		validateUpdateEventItem:"_ValidationResult",
		getEventList:"EventList",
		listEventList:"EventList",
		paginateEventList:"EventListConnection",
		validateCreateEventList:"_ValidationResult",
		validateUpdateEventList:"_ValidationResult",
		getBoxItem:"BoxItem",
		listBoxItem:"BoxItem",
		paginateBoxItem:"BoxItemConnection",
		validateCreateBoxItem:"_ValidationResult",
		validateUpdateBoxItem:"_ValidationResult",
		getBoxList:"BoxList",
		listBoxList:"BoxList",
		paginateBoxList:"BoxListConnection",
		validateCreateBoxList:"_ValidationResult",
		validateUpdateBoxList:"_ValidationResult",
		getNewsletterForm:"NewsletterForm",
		listNewsletterForm:"NewsletterForm",
		paginateNewsletterForm:"NewsletterFormConnection",
		validateCreateNewsletterForm:"_ValidationResult",
		validateUpdateNewsletterForm:"_ValidationResult",
		getNewsletterTypeItem:"NewsletterTypeItem",
		listNewsletterTypeItem:"NewsletterTypeItem",
		paginateNewsletterTypeItem:"NewsletterTypeItemConnection",
		validateCreateNewsletterTypeItem:"_ValidationResult",
		validateUpdateNewsletterTypeItem:"_ValidationResult",
		getNewsletterFormLocale:"NewsletterFormLocale",
		listNewsletterFormLocale:"NewsletterFormLocale",
		paginateNewsletterFormLocale:"NewsletterFormLocaleConnection",
		validateCreateNewsletterFormLocale:"_ValidationResult",
		validateUpdateNewsletterFormLocale:"_ValidationResult",
		getNewsletterSubscription:"NewsletterSubscription",
		listNewsletterSubscription:"NewsletterSubscription",
		paginateNewsletterSubscription:"NewsletterSubscriptionConnection",
		validateCreateNewsletterSubscription:"_ValidationResult",
		validateUpdateNewsletterSubscription:"_ValidationResult",
		getChart:"Chart",
		listChart:"Chart",
		paginateChart:"ChartConnection",
		validateCreateChart:"_ValidationResult",
		validateUpdateChart:"_ValidationResult",
		getChartData:"ChartData",
		listChartData:"ChartData",
		paginateChartData:"ChartDataConnection",
		validateCreateChartData:"_ValidationResult",
		validateUpdateChartData:"_ValidationResult",
		getEmployee:"Employee",
		listEmployee:"Employee",
		paginateEmployee:"EmployeeConnection",
		validateCreateEmployee:"_ValidationResult",
		validateUpdateEmployee:"_ValidationResult",
		getEmployeeItem:"EmployeeItem",
		listEmployeeItem:"EmployeeItem",
		paginateEmployeeItem:"EmployeeItemConnection",
		validateCreateEmployeeItem:"_ValidationResult",
		validateUpdateEmployeeItem:"_ValidationResult",
		getEmployeeList:"EmployeeList",
		listEmployeeList:"EmployeeList",
		paginateEmployeeList:"EmployeeListConnection",
		validateCreateEmployeeList:"_ValidationResult",
		validateUpdateEmployeeList:"_ValidationResult",
		getEmployeeLocale:"EmployeeLocale",
		listEmployeeLocale:"EmployeeLocale",
		paginateEmployeeLocale:"EmployeeLocaleConnection",
		validateCreateEmployeeLocale:"_ValidationResult",
		validateUpdateEmployeeLocale:"_ValidationResult",
		getPhotographer:"Photographer",
		listPhotographer:"Photographer",
		paginatePhotographer:"PhotographerConnection",
		validateCreatePhotographer:"_ValidationResult",
		validateUpdatePhotographer:"_ValidationResult",
		getDefinitionItem:"DefinitionItem",
		listDefinitionItem:"DefinitionItem",
		paginateDefinitionItem:"DefinitionItemConnection",
		validateCreateDefinitionItem:"_ValidationResult",
		validateUpdateDefinitionItem:"_ValidationResult",
		getDefinitionList:"DefinitionList",
		listDefinitionList:"DefinitionList",
		paginateDefinitionList:"DefinitionListConnection",
		validateCreateDefinitionList:"_ValidationResult",
		validateUpdateDefinitionList:"_ValidationResult",
		getLogoItem:"LogoItem",
		listLogoItem:"LogoItem",
		paginateLogoItem:"LogoItemConnection",
		validateCreateLogoItem:"_ValidationResult",
		validateUpdateLogoItem:"_ValidationResult",
		getLogoList:"LogoList",
		listLogoList:"LogoList",
		paginateLogoList:"LogoListConnection",
		validateCreateLogoList:"_ValidationResult",
		validateUpdateLogoList:"_ValidationResult",
		getStrategySchema:"StrategySchema",
		listStrategySchema:"StrategySchema",
		paginateStrategySchema:"StrategySchemaConnection",
		validateCreateStrategySchema:"_ValidationResult",
		validateUpdateStrategySchema:"_ValidationResult",
		getStrategySchemaGroup:"StrategySchemaGroup",
		listStrategySchemaGroup:"StrategySchemaGroup",
		paginateStrategySchemaGroup:"StrategySchemaGroupConnection",
		validateCreateStrategySchemaGroup:"_ValidationResult",
		validateUpdateStrategySchemaGroup:"_ValidationResult",
		getStrategySchemaGroupItem:"StrategySchemaGroupItem",
		listStrategySchemaGroupItem:"StrategySchemaGroupItem",
		paginateStrategySchemaGroupItem:"StrategySchemaGroupItemConnection",
		validateCreateStrategySchemaGroupItem:"_ValidationResult",
		validateUpdateStrategySchemaGroupItem:"_ValidationResult",
		getRedirect:"Redirect",
		listRedirect:"Redirect",
		paginateRedirect:"RedirectConnection",
		validateCreateRedirect:"_ValidationResult",
		validateUpdateRedirect:"_ValidationResult",
		getGallery:"Gallery",
		listGallery:"Gallery",
		paginateGallery:"GalleryConnection",
		validateCreateGallery:"_ValidationResult",
		validateUpdateGallery:"_ValidationResult",
		getGalleryItem:"GalleryItem",
		listGalleryItem:"GalleryItem",
		paginateGalleryItem:"GalleryItemConnection",
		validateCreateGalleryItem:"_ValidationResult",
		validateUpdateGalleryItem:"_ValidationResult",
		getContactForm:"ContactForm",
		listContactForm:"ContactForm",
		paginateContactForm:"ContactFormConnection",
		validateCreateContactForm:"_ValidationResult",
		validateUpdateContactForm:"_ValidationResult",
		getContactFormLocale:"ContactFormLocale",
		listContactFormLocale:"ContactFormLocale",
		paginateContactFormLocale:"ContactFormLocaleConnection",
		validateCreateContactFormLocale:"_ValidationResult",
		validateUpdateContactFormLocale:"_ValidationResult",
		getContactSubscription:"ContactSubscription",
		listContactSubscription:"ContactSubscription",
		paginateContactSubscription:"ContactSubscriptionConnection",
		validateCreateContactSubscription:"_ValidationResult",
		validateUpdateContactSubscription:"_ValidationResult",
		getContactTypeItem:"ContactTypeItem",
		listContactTypeItem:"ContactTypeItem",
		paginateContactTypeItem:"ContactTypeItemConnection",
		validateCreateContactTypeItem:"_ValidationResult",
		validateUpdateContactTypeItem:"_ValidationResult",
		getFile:"File",
		listFile:"File",
		paginateFile:"FileConnection",
		validateCreateFile:"_ValidationResult",
		validateUpdateFile:"_ValidationResult"
	},
	Info:{
		description:"String"
	},
	Mutation:{
		createContactPage:"ContactPageCreateResult",
		deleteContactPage:"ContactPageDeleteResult",
		updateContactPage:"ContactPageUpdateResult",
		upsertContactPage:"ContactPageUpsertResult",
		createContactPageLocale:"ContactPageLocaleCreateResult",
		deleteContactPageLocale:"ContactPageLocaleDeleteResult",
		updateContactPageLocale:"ContactPageLocaleUpdateResult",
		upsertContactPageLocale:"ContactPageLocaleUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createHomePageLocale:"HomePageLocaleCreateResult",
		deleteHomePageLocale:"HomePageLocaleDeleteResult",
		updateHomePageLocale:"HomePageLocaleUpdateResult",
		upsertHomePageLocale:"HomePageLocaleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createSeoDefault:"SeoDefaultCreateResult",
		deleteSeoDefault:"SeoDefaultDeleteResult",
		updateSeoDefault:"SeoDefaultUpdateResult",
		upsertSeoDefault:"SeoDefaultUpsertResult",
		createSeoDefaultLocale:"SeoDefaultLocaleCreateResult",
		deleteSeoDefaultLocale:"SeoDefaultLocaleDeleteResult",
		updateSeoDefaultLocale:"SeoDefaultLocaleUpdateResult",
		upsertSeoDefaultLocale:"SeoDefaultLocaleUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createBranches:"BranchesCreateResult",
		deleteBranches:"BranchesDeleteResult",
		updateBranches:"BranchesUpdateResult",
		upsertBranches:"BranchesUpsertResult",
		createGraphicDesigner:"GraphicDesignerCreateResult",
		deleteGraphicDesigner:"GraphicDesignerDeleteResult",
		updateGraphicDesigner:"GraphicDesignerUpdateResult",
		upsertGraphicDesigner:"GraphicDesignerUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createEventLocale:"EventLocaleCreateResult",
		deleteEventLocale:"EventLocaleDeleteResult",
		updateEventLocale:"EventLocaleUpdateResult",
		upsertEventLocale:"EventLocaleUpsertResult",
		createArtwork:"ArtworkCreateResult",
		deleteArtwork:"ArtworkDeleteResult",
		updateArtwork:"ArtworkUpdateResult",
		upsertArtwork:"ArtworkUpsertResult",
		createArtworkLocale:"ArtworkLocaleCreateResult",
		deleteArtworkLocale:"ArtworkLocaleDeleteResult",
		updateArtworkLocale:"ArtworkLocaleUpdateResult",
		upsertArtworkLocale:"ArtworkLocaleUpsertResult",
		createDropDownItem:"DropDownItemCreateResult",
		deleteDropDownItem:"DropDownItemDeleteResult",
		updateDropDownItem:"DropDownItemUpdateResult",
		upsertDropDownItem:"DropDownItemUpsertResult",
		createDropDownList:"DropDownListCreateResult",
		deleteDropDownList:"DropDownListDeleteResult",
		updateDropDownList:"DropDownListUpdateResult",
		upsertDropDownList:"DropDownListUpsertResult",
		createArtworkItem:"ArtworkItemCreateResult",
		deleteArtworkItem:"ArtworkItemDeleteResult",
		updateArtworkItem:"ArtworkItemUpdateResult",
		upsertArtworkItem:"ArtworkItemUpsertResult",
		createArtworkList:"ArtworkListCreateResult",
		deleteArtworkList:"ArtworkListDeleteResult",
		updateArtworkList:"ArtworkListUpdateResult",
		upsertArtworkList:"ArtworkListUpsertResult",
		createArtworkSelection:"ArtworkSelectionCreateResult",
		deleteArtworkSelection:"ArtworkSelectionDeleteResult",
		updateArtworkSelection:"ArtworkSelectionUpdateResult",
		upsertArtworkSelection:"ArtworkSelectionUpsertResult",
		createArtworkSelectionItem:"ArtworkSelectionItemCreateResult",
		deleteArtworkSelectionItem:"ArtworkSelectionItemDeleteResult",
		updateArtworkSelectionItem:"ArtworkSelectionItemUpdateResult",
		upsertArtworkSelectionItem:"ArtworkSelectionItemUpsertResult",
		createArtworkSelectionList:"ArtworkSelectionListCreateResult",
		deleteArtworkSelectionList:"ArtworkSelectionListDeleteResult",
		updateArtworkSelectionList:"ArtworkSelectionListUpdateResult",
		upsertArtworkSelectionList:"ArtworkSelectionListUpsertResult",
		createArtworkSelectionLocale:"ArtworkSelectionLocaleCreateResult",
		deleteArtworkSelectionLocale:"ArtworkSelectionLocaleDeleteResult",
		updateArtworkSelectionLocale:"ArtworkSelectionLocaleUpdateResult",
		upsertArtworkSelectionLocale:"ArtworkSelectionLocaleUpsertResult",
		createEventItem:"EventItemCreateResult",
		deleteEventItem:"EventItemDeleteResult",
		updateEventItem:"EventItemUpdateResult",
		upsertEventItem:"EventItemUpsertResult",
		createEventList:"EventListCreateResult",
		deleteEventList:"EventListDeleteResult",
		updateEventList:"EventListUpdateResult",
		upsertEventList:"EventListUpsertResult",
		createBoxItem:"BoxItemCreateResult",
		deleteBoxItem:"BoxItemDeleteResult",
		updateBoxItem:"BoxItemUpdateResult",
		upsertBoxItem:"BoxItemUpsertResult",
		createBoxList:"BoxListCreateResult",
		deleteBoxList:"BoxListDeleteResult",
		updateBoxList:"BoxListUpdateResult",
		upsertBoxList:"BoxListUpsertResult",
		createNewsletterForm:"NewsletterFormCreateResult",
		deleteNewsletterForm:"NewsletterFormDeleteResult",
		updateNewsletterForm:"NewsletterFormUpdateResult",
		upsertNewsletterForm:"NewsletterFormUpsertResult",
		createNewsletterTypeItem:"NewsletterTypeItemCreateResult",
		deleteNewsletterTypeItem:"NewsletterTypeItemDeleteResult",
		updateNewsletterTypeItem:"NewsletterTypeItemUpdateResult",
		upsertNewsletterTypeItem:"NewsletterTypeItemUpsertResult",
		createNewsletterFormLocale:"NewsletterFormLocaleCreateResult",
		deleteNewsletterFormLocale:"NewsletterFormLocaleDeleteResult",
		updateNewsletterFormLocale:"NewsletterFormLocaleUpdateResult",
		upsertNewsletterFormLocale:"NewsletterFormLocaleUpsertResult",
		createNewsletterSubscription:"NewsletterSubscriptionCreateResult",
		deleteNewsletterSubscription:"NewsletterSubscriptionDeleteResult",
		updateNewsletterSubscription:"NewsletterSubscriptionUpdateResult",
		upsertNewsletterSubscription:"NewsletterSubscriptionUpsertResult",
		createChart:"ChartCreateResult",
		deleteChart:"ChartDeleteResult",
		updateChart:"ChartUpdateResult",
		upsertChart:"ChartUpsertResult",
		createChartData:"ChartDataCreateResult",
		deleteChartData:"ChartDataDeleteResult",
		updateChartData:"ChartDataUpdateResult",
		upsertChartData:"ChartDataUpsertResult",
		createEmployee:"EmployeeCreateResult",
		deleteEmployee:"EmployeeDeleteResult",
		updateEmployee:"EmployeeUpdateResult",
		upsertEmployee:"EmployeeUpsertResult",
		createEmployeeItem:"EmployeeItemCreateResult",
		deleteEmployeeItem:"EmployeeItemDeleteResult",
		updateEmployeeItem:"EmployeeItemUpdateResult",
		upsertEmployeeItem:"EmployeeItemUpsertResult",
		createEmployeeList:"EmployeeListCreateResult",
		deleteEmployeeList:"EmployeeListDeleteResult",
		updateEmployeeList:"EmployeeListUpdateResult",
		upsertEmployeeList:"EmployeeListUpsertResult",
		createEmployeeLocale:"EmployeeLocaleCreateResult",
		deleteEmployeeLocale:"EmployeeLocaleDeleteResult",
		updateEmployeeLocale:"EmployeeLocaleUpdateResult",
		upsertEmployeeLocale:"EmployeeLocaleUpsertResult",
		createPhotographer:"PhotographerCreateResult",
		deletePhotographer:"PhotographerDeleteResult",
		updatePhotographer:"PhotographerUpdateResult",
		upsertPhotographer:"PhotographerUpsertResult",
		createDefinitionItem:"DefinitionItemCreateResult",
		deleteDefinitionItem:"DefinitionItemDeleteResult",
		updateDefinitionItem:"DefinitionItemUpdateResult",
		upsertDefinitionItem:"DefinitionItemUpsertResult",
		createDefinitionList:"DefinitionListCreateResult",
		deleteDefinitionList:"DefinitionListDeleteResult",
		updateDefinitionList:"DefinitionListUpdateResult",
		upsertDefinitionList:"DefinitionListUpsertResult",
		createLogoItem:"LogoItemCreateResult",
		deleteLogoItem:"LogoItemDeleteResult",
		updateLogoItem:"LogoItemUpdateResult",
		upsertLogoItem:"LogoItemUpsertResult",
		createLogoList:"LogoListCreateResult",
		deleteLogoList:"LogoListDeleteResult",
		updateLogoList:"LogoListUpdateResult",
		upsertLogoList:"LogoListUpsertResult",
		createStrategySchema:"StrategySchemaCreateResult",
		deleteStrategySchema:"StrategySchemaDeleteResult",
		updateStrategySchema:"StrategySchemaUpdateResult",
		upsertStrategySchema:"StrategySchemaUpsertResult",
		createStrategySchemaGroup:"StrategySchemaGroupCreateResult",
		deleteStrategySchemaGroup:"StrategySchemaGroupDeleteResult",
		updateStrategySchemaGroup:"StrategySchemaGroupUpdateResult",
		upsertStrategySchemaGroup:"StrategySchemaGroupUpsertResult",
		createStrategySchemaGroupItem:"StrategySchemaGroupItemCreateResult",
		deleteStrategySchemaGroupItem:"StrategySchemaGroupItemDeleteResult",
		updateStrategySchemaGroupItem:"StrategySchemaGroupItemUpdateResult",
		upsertStrategySchemaGroupItem:"StrategySchemaGroupItemUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createContactForm:"ContactFormCreateResult",
		deleteContactForm:"ContactFormDeleteResult",
		updateContactForm:"ContactFormUpdateResult",
		upsertContactForm:"ContactFormUpsertResult",
		createContactFormLocale:"ContactFormLocaleCreateResult",
		deleteContactFormLocale:"ContactFormLocaleDeleteResult",
		updateContactFormLocale:"ContactFormLocaleUpdateResult",
		upsertContactFormLocale:"ContactFormLocaleUpsertResult",
		createContactSubscription:"ContactSubscriptionCreateResult",
		deleteContactSubscription:"ContactSubscriptionDeleteResult",
		updateContactSubscription:"ContactSubscriptionUpdateResult",
		upsertContactSubscription:"ContactSubscriptionUpsertResult",
		createContactTypeItem:"ContactTypeItemCreateResult",
		deleteContactTypeItem:"ContactTypeItemDeleteResult",
		updateContactTypeItem:"ContactTypeItemUpdateResult",
		upsertContactTypeItem:"ContactTypeItemUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		transaction:"MutationTransaction",
		query:"Query",
		generateUploadUrl:"S3SignedUpload",
		generateReadUrl:"S3SignedRead"
	},
	ContactPageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPage",
		validation:"_ValidationResult"
	},
	MutationResult:{
		"...on ContactPageCreateResult": "ContactPageCreateResult",
		"...on ContactPageDeleteResult": "ContactPageDeleteResult",
		"...on ContactPageUpdateResult": "ContactPageUpdateResult",
		"...on ContactPageUpsertResult": "ContactPageUpsertResult",
		"...on ContactPageLocaleCreateResult": "ContactPageLocaleCreateResult",
		"...on ContactPageLocaleDeleteResult": "ContactPageLocaleDeleteResult",
		"...on ContactPageLocaleUpdateResult": "ContactPageLocaleUpdateResult",
		"...on ContactPageLocaleUpsertResult": "ContactPageLocaleUpsertResult",
		"...on ContentCreateResult": "ContentCreateResult",
		"...on ContentDeleteResult": "ContentDeleteResult",
		"...on ContentUpdateResult": "ContentUpdateResult",
		"...on ContentUpsertResult": "ContentUpsertResult",
		"...on ContentBlockCreateResult": "ContentBlockCreateResult",
		"...on ContentBlockDeleteResult": "ContentBlockDeleteResult",
		"...on ContentBlockUpdateResult": "ContentBlockUpdateResult",
		"...on ContentBlockUpsertResult": "ContentBlockUpsertResult",
		"...on ContentReferenceCreateResult": "ContentReferenceCreateResult",
		"...on ContentReferenceDeleteResult": "ContentReferenceDeleteResult",
		"...on ContentReferenceUpdateResult": "ContentReferenceUpdateResult",
		"...on ContentReferenceUpsertResult": "ContentReferenceUpsertResult",
		"...on FooterCreateResult": "FooterCreateResult",
		"...on FooterDeleteResult": "FooterDeleteResult",
		"...on FooterUpdateResult": "FooterUpdateResult",
		"...on FooterUpsertResult": "FooterUpsertResult",
		"...on FooterLocaleCreateResult": "FooterLocaleCreateResult",
		"...on FooterLocaleDeleteResult": "FooterLocaleDeleteResult",
		"...on FooterLocaleUpdateResult": "FooterLocaleUpdateResult",
		"...on FooterLocaleUpsertResult": "FooterLocaleUpsertResult",
		"...on HeaderCreateResult": "HeaderCreateResult",
		"...on HeaderDeleteResult": "HeaderDeleteResult",
		"...on HeaderUpdateResult": "HeaderUpdateResult",
		"...on HeaderUpsertResult": "HeaderUpsertResult",
		"...on HeaderLinkCreateResult": "HeaderLinkCreateResult",
		"...on HeaderLinkDeleteResult": "HeaderLinkDeleteResult",
		"...on HeaderLinkUpdateResult": "HeaderLinkUpdateResult",
		"...on HeaderLinkUpsertResult": "HeaderLinkUpsertResult",
		"...on HeaderLocaleCreateResult": "HeaderLocaleCreateResult",
		"...on HeaderLocaleDeleteResult": "HeaderLocaleDeleteResult",
		"...on HeaderLocaleUpdateResult": "HeaderLocaleUpdateResult",
		"...on HeaderLocaleUpsertResult": "HeaderLocaleUpsertResult",
		"...on HomePageCreateResult": "HomePageCreateResult",
		"...on HomePageDeleteResult": "HomePageDeleteResult",
		"...on HomePageUpdateResult": "HomePageUpdateResult",
		"...on HomePageUpsertResult": "HomePageUpsertResult",
		"...on HomePageLocaleCreateResult": "HomePageLocaleCreateResult",
		"...on HomePageLocaleDeleteResult": "HomePageLocaleDeleteResult",
		"...on HomePageLocaleUpdateResult": "HomePageLocaleUpdateResult",
		"...on HomePageLocaleUpsertResult": "HomePageLocaleUpsertResult",
		"...on LinkCreateResult": "LinkCreateResult",
		"...on LinkDeleteResult": "LinkDeleteResult",
		"...on LinkUpdateResult": "LinkUpdateResult",
		"...on LinkUpsertResult": "LinkUpsertResult",
		"...on LinkableCreateResult": "LinkableCreateResult",
		"...on LinkableDeleteResult": "LinkableDeleteResult",
		"...on LinkableUpdateResult": "LinkableUpdateResult",
		"...on LinkableUpsertResult": "LinkableUpsertResult",
		"...on LocaleCreateResult": "LocaleCreateResult",
		"...on LocaleDeleteResult": "LocaleDeleteResult",
		"...on LocaleUpdateResult": "LocaleUpdateResult",
		"...on LocaleUpsertResult": "LocaleUpsertResult",
		"...on MediumCreateResult": "MediumCreateResult",
		"...on MediumDeleteResult": "MediumDeleteResult",
		"...on MediumUpdateResult": "MediumUpdateResult",
		"...on MediumUpsertResult": "MediumUpsertResult",
		"...on MediumItemCreateResult": "MediumItemCreateResult",
		"...on MediumItemDeleteResult": "MediumItemDeleteResult",
		"...on MediumItemUpdateResult": "MediumItemUpdateResult",
		"...on MediumItemUpsertResult": "MediumItemUpsertResult",
		"...on MediumListCreateResult": "MediumListCreateResult",
		"...on MediumListDeleteResult": "MediumListDeleteResult",
		"...on MediumListUpdateResult": "MediumListUpdateResult",
		"...on MediumListUpsertResult": "MediumListUpsertResult",
		"...on PageCreateResult": "PageCreateResult",
		"...on PageDeleteResult": "PageDeleteResult",
		"...on PageUpdateResult": "PageUpdateResult",
		"...on PageUpsertResult": "PageUpsertResult",
		"...on PageLocaleCreateResult": "PageLocaleCreateResult",
		"...on PageLocaleDeleteResult": "PageLocaleDeleteResult",
		"...on PageLocaleUpdateResult": "PageLocaleUpdateResult",
		"...on PageLocaleUpsertResult": "PageLocaleUpsertResult",
		"...on SeoDefaultCreateResult": "SeoDefaultCreateResult",
		"...on SeoDefaultDeleteResult": "SeoDefaultDeleteResult",
		"...on SeoDefaultUpdateResult": "SeoDefaultUpdateResult",
		"...on SeoDefaultUpsertResult": "SeoDefaultUpsertResult",
		"...on SeoDefaultLocaleCreateResult": "SeoDefaultLocaleCreateResult",
		"...on SeoDefaultLocaleDeleteResult": "SeoDefaultLocaleDeleteResult",
		"...on SeoDefaultLocaleUpdateResult": "SeoDefaultLocaleUpdateResult",
		"...on SeoDefaultLocaleUpsertResult": "SeoDefaultLocaleUpsertResult",
		"...on VideoCreateResult": "VideoCreateResult",
		"...on VideoDeleteResult": "VideoDeleteResult",
		"...on VideoUpdateResult": "VideoUpdateResult",
		"...on VideoUpsertResult": "VideoUpsertResult",
		"...on ImageCreateResult": "ImageCreateResult",
		"...on ImageDeleteResult": "ImageDeleteResult",
		"...on ImageUpdateResult": "ImageUpdateResult",
		"...on ImageUpsertResult": "ImageUpsertResult",
		"...on SeoCreateResult": "SeoCreateResult",
		"...on SeoDeleteResult": "SeoDeleteResult",
		"...on SeoUpdateResult": "SeoUpdateResult",
		"...on SeoUpsertResult": "SeoUpsertResult",
		"...on TranslationDomainCreateResult": "TranslationDomainCreateResult",
		"...on TranslationDomainDeleteResult": "TranslationDomainDeleteResult",
		"...on TranslationDomainUpdateResult": "TranslationDomainUpdateResult",
		"...on TranslationDomainUpsertResult": "TranslationDomainUpsertResult",
		"...on TranslationCatalogueCreateResult": "TranslationCatalogueCreateResult",
		"...on TranslationCatalogueDeleteResult": "TranslationCatalogueDeleteResult",
		"...on TranslationCatalogueUpdateResult": "TranslationCatalogueUpdateResult",
		"...on TranslationCatalogueUpsertResult": "TranslationCatalogueUpsertResult",
		"...on TranslationCataloguesIdentifierCreateResult": "TranslationCataloguesIdentifierCreateResult",
		"...on TranslationCataloguesIdentifierDeleteResult": "TranslationCataloguesIdentifierDeleteResult",
		"...on TranslationCataloguesIdentifierUpdateResult": "TranslationCataloguesIdentifierUpdateResult",
		"...on TranslationCataloguesIdentifierUpsertResult": "TranslationCataloguesIdentifierUpsertResult",
		"...on TranslationKeyCreateResult": "TranslationKeyCreateResult",
		"...on TranslationKeyDeleteResult": "TranslationKeyDeleteResult",
		"...on TranslationKeyUpdateResult": "TranslationKeyUpdateResult",
		"...on TranslationKeyUpsertResult": "TranslationKeyUpsertResult",
		"...on TranslationValueCreateResult": "TranslationValueCreateResult",
		"...on TranslationValueDeleteResult": "TranslationValueDeleteResult",
		"...on TranslationValueUpdateResult": "TranslationValueUpdateResult",
		"...on TranslationValueUpsertResult": "TranslationValueUpsertResult",
		"...on BranchesCreateResult": "BranchesCreateResult",
		"...on BranchesDeleteResult": "BranchesDeleteResult",
		"...on BranchesUpdateResult": "BranchesUpdateResult",
		"...on BranchesUpsertResult": "BranchesUpsertResult",
		"...on GraphicDesignerCreateResult": "GraphicDesignerCreateResult",
		"...on GraphicDesignerDeleteResult": "GraphicDesignerDeleteResult",
		"...on GraphicDesignerUpdateResult": "GraphicDesignerUpdateResult",
		"...on GraphicDesignerUpsertResult": "GraphicDesignerUpsertResult",
		"...on EventCreateResult": "EventCreateResult",
		"...on EventDeleteResult": "EventDeleteResult",
		"...on EventUpdateResult": "EventUpdateResult",
		"...on EventUpsertResult": "EventUpsertResult",
		"...on EventLocaleCreateResult": "EventLocaleCreateResult",
		"...on EventLocaleDeleteResult": "EventLocaleDeleteResult",
		"...on EventLocaleUpdateResult": "EventLocaleUpdateResult",
		"...on EventLocaleUpsertResult": "EventLocaleUpsertResult",
		"...on ArtworkCreateResult": "ArtworkCreateResult",
		"...on ArtworkDeleteResult": "ArtworkDeleteResult",
		"...on ArtworkUpdateResult": "ArtworkUpdateResult",
		"...on ArtworkUpsertResult": "ArtworkUpsertResult",
		"...on ArtworkLocaleCreateResult": "ArtworkLocaleCreateResult",
		"...on ArtworkLocaleDeleteResult": "ArtworkLocaleDeleteResult",
		"...on ArtworkLocaleUpdateResult": "ArtworkLocaleUpdateResult",
		"...on ArtworkLocaleUpsertResult": "ArtworkLocaleUpsertResult",
		"...on DropDownItemCreateResult": "DropDownItemCreateResult",
		"...on DropDownItemDeleteResult": "DropDownItemDeleteResult",
		"...on DropDownItemUpdateResult": "DropDownItemUpdateResult",
		"...on DropDownItemUpsertResult": "DropDownItemUpsertResult",
		"...on DropDownListCreateResult": "DropDownListCreateResult",
		"...on DropDownListDeleteResult": "DropDownListDeleteResult",
		"...on DropDownListUpdateResult": "DropDownListUpdateResult",
		"...on DropDownListUpsertResult": "DropDownListUpsertResult",
		"...on ArtworkItemCreateResult": "ArtworkItemCreateResult",
		"...on ArtworkItemDeleteResult": "ArtworkItemDeleteResult",
		"...on ArtworkItemUpdateResult": "ArtworkItemUpdateResult",
		"...on ArtworkItemUpsertResult": "ArtworkItemUpsertResult",
		"...on ArtworkListCreateResult": "ArtworkListCreateResult",
		"...on ArtworkListDeleteResult": "ArtworkListDeleteResult",
		"...on ArtworkListUpdateResult": "ArtworkListUpdateResult",
		"...on ArtworkListUpsertResult": "ArtworkListUpsertResult",
		"...on ArtworkSelectionCreateResult": "ArtworkSelectionCreateResult",
		"...on ArtworkSelectionDeleteResult": "ArtworkSelectionDeleteResult",
		"...on ArtworkSelectionUpdateResult": "ArtworkSelectionUpdateResult",
		"...on ArtworkSelectionUpsertResult": "ArtworkSelectionUpsertResult",
		"...on ArtworkSelectionItemCreateResult": "ArtworkSelectionItemCreateResult",
		"...on ArtworkSelectionItemDeleteResult": "ArtworkSelectionItemDeleteResult",
		"...on ArtworkSelectionItemUpdateResult": "ArtworkSelectionItemUpdateResult",
		"...on ArtworkSelectionItemUpsertResult": "ArtworkSelectionItemUpsertResult",
		"...on ArtworkSelectionListCreateResult": "ArtworkSelectionListCreateResult",
		"...on ArtworkSelectionListDeleteResult": "ArtworkSelectionListDeleteResult",
		"...on ArtworkSelectionListUpdateResult": "ArtworkSelectionListUpdateResult",
		"...on ArtworkSelectionListUpsertResult": "ArtworkSelectionListUpsertResult",
		"...on ArtworkSelectionLocaleCreateResult": "ArtworkSelectionLocaleCreateResult",
		"...on ArtworkSelectionLocaleDeleteResult": "ArtworkSelectionLocaleDeleteResult",
		"...on ArtworkSelectionLocaleUpdateResult": "ArtworkSelectionLocaleUpdateResult",
		"...on ArtworkSelectionLocaleUpsertResult": "ArtworkSelectionLocaleUpsertResult",
		"...on EventItemCreateResult": "EventItemCreateResult",
		"...on EventItemDeleteResult": "EventItemDeleteResult",
		"...on EventItemUpdateResult": "EventItemUpdateResult",
		"...on EventItemUpsertResult": "EventItemUpsertResult",
		"...on EventListCreateResult": "EventListCreateResult",
		"...on EventListDeleteResult": "EventListDeleteResult",
		"...on EventListUpdateResult": "EventListUpdateResult",
		"...on EventListUpsertResult": "EventListUpsertResult",
		"...on BoxItemCreateResult": "BoxItemCreateResult",
		"...on BoxItemDeleteResult": "BoxItemDeleteResult",
		"...on BoxItemUpdateResult": "BoxItemUpdateResult",
		"...on BoxItemUpsertResult": "BoxItemUpsertResult",
		"...on BoxListCreateResult": "BoxListCreateResult",
		"...on BoxListDeleteResult": "BoxListDeleteResult",
		"...on BoxListUpdateResult": "BoxListUpdateResult",
		"...on BoxListUpsertResult": "BoxListUpsertResult",
		"...on NewsletterFormCreateResult": "NewsletterFormCreateResult",
		"...on NewsletterFormDeleteResult": "NewsletterFormDeleteResult",
		"...on NewsletterFormUpdateResult": "NewsletterFormUpdateResult",
		"...on NewsletterFormUpsertResult": "NewsletterFormUpsertResult",
		"...on NewsletterTypeItemCreateResult": "NewsletterTypeItemCreateResult",
		"...on NewsletterTypeItemDeleteResult": "NewsletterTypeItemDeleteResult",
		"...on NewsletterTypeItemUpdateResult": "NewsletterTypeItemUpdateResult",
		"...on NewsletterTypeItemUpsertResult": "NewsletterTypeItemUpsertResult",
		"...on NewsletterFormLocaleCreateResult": "NewsletterFormLocaleCreateResult",
		"...on NewsletterFormLocaleDeleteResult": "NewsletterFormLocaleDeleteResult",
		"...on NewsletterFormLocaleUpdateResult": "NewsletterFormLocaleUpdateResult",
		"...on NewsletterFormLocaleUpsertResult": "NewsletterFormLocaleUpsertResult",
		"...on NewsletterSubscriptionCreateResult": "NewsletterSubscriptionCreateResult",
		"...on NewsletterSubscriptionDeleteResult": "NewsletterSubscriptionDeleteResult",
		"...on NewsletterSubscriptionUpdateResult": "NewsletterSubscriptionUpdateResult",
		"...on NewsletterSubscriptionUpsertResult": "NewsletterSubscriptionUpsertResult",
		"...on ChartCreateResult": "ChartCreateResult",
		"...on ChartDeleteResult": "ChartDeleteResult",
		"...on ChartUpdateResult": "ChartUpdateResult",
		"...on ChartUpsertResult": "ChartUpsertResult",
		"...on ChartDataCreateResult": "ChartDataCreateResult",
		"...on ChartDataDeleteResult": "ChartDataDeleteResult",
		"...on ChartDataUpdateResult": "ChartDataUpdateResult",
		"...on ChartDataUpsertResult": "ChartDataUpsertResult",
		"...on EmployeeCreateResult": "EmployeeCreateResult",
		"...on EmployeeDeleteResult": "EmployeeDeleteResult",
		"...on EmployeeUpdateResult": "EmployeeUpdateResult",
		"...on EmployeeUpsertResult": "EmployeeUpsertResult",
		"...on EmployeeItemCreateResult": "EmployeeItemCreateResult",
		"...on EmployeeItemDeleteResult": "EmployeeItemDeleteResult",
		"...on EmployeeItemUpdateResult": "EmployeeItemUpdateResult",
		"...on EmployeeItemUpsertResult": "EmployeeItemUpsertResult",
		"...on EmployeeListCreateResult": "EmployeeListCreateResult",
		"...on EmployeeListDeleteResult": "EmployeeListDeleteResult",
		"...on EmployeeListUpdateResult": "EmployeeListUpdateResult",
		"...on EmployeeListUpsertResult": "EmployeeListUpsertResult",
		"...on EmployeeLocaleCreateResult": "EmployeeLocaleCreateResult",
		"...on EmployeeLocaleDeleteResult": "EmployeeLocaleDeleteResult",
		"...on EmployeeLocaleUpdateResult": "EmployeeLocaleUpdateResult",
		"...on EmployeeLocaleUpsertResult": "EmployeeLocaleUpsertResult",
		"...on PhotographerCreateResult": "PhotographerCreateResult",
		"...on PhotographerDeleteResult": "PhotographerDeleteResult",
		"...on PhotographerUpdateResult": "PhotographerUpdateResult",
		"...on PhotographerUpsertResult": "PhotographerUpsertResult",
		"...on DefinitionItemCreateResult": "DefinitionItemCreateResult",
		"...on DefinitionItemDeleteResult": "DefinitionItemDeleteResult",
		"...on DefinitionItemUpdateResult": "DefinitionItemUpdateResult",
		"...on DefinitionItemUpsertResult": "DefinitionItemUpsertResult",
		"...on DefinitionListCreateResult": "DefinitionListCreateResult",
		"...on DefinitionListDeleteResult": "DefinitionListDeleteResult",
		"...on DefinitionListUpdateResult": "DefinitionListUpdateResult",
		"...on DefinitionListUpsertResult": "DefinitionListUpsertResult",
		"...on LogoItemCreateResult": "LogoItemCreateResult",
		"...on LogoItemDeleteResult": "LogoItemDeleteResult",
		"...on LogoItemUpdateResult": "LogoItemUpdateResult",
		"...on LogoItemUpsertResult": "LogoItemUpsertResult",
		"...on LogoListCreateResult": "LogoListCreateResult",
		"...on LogoListDeleteResult": "LogoListDeleteResult",
		"...on LogoListUpdateResult": "LogoListUpdateResult",
		"...on LogoListUpsertResult": "LogoListUpsertResult",
		"...on StrategySchemaCreateResult": "StrategySchemaCreateResult",
		"...on StrategySchemaDeleteResult": "StrategySchemaDeleteResult",
		"...on StrategySchemaUpdateResult": "StrategySchemaUpdateResult",
		"...on StrategySchemaUpsertResult": "StrategySchemaUpsertResult",
		"...on StrategySchemaGroupCreateResult": "StrategySchemaGroupCreateResult",
		"...on StrategySchemaGroupDeleteResult": "StrategySchemaGroupDeleteResult",
		"...on StrategySchemaGroupUpdateResult": "StrategySchemaGroupUpdateResult",
		"...on StrategySchemaGroupUpsertResult": "StrategySchemaGroupUpsertResult",
		"...on StrategySchemaGroupItemCreateResult": "StrategySchemaGroupItemCreateResult",
		"...on StrategySchemaGroupItemDeleteResult": "StrategySchemaGroupItemDeleteResult",
		"...on StrategySchemaGroupItemUpdateResult": "StrategySchemaGroupItemUpdateResult",
		"...on StrategySchemaGroupItemUpsertResult": "StrategySchemaGroupItemUpsertResult",
		"...on RedirectCreateResult": "RedirectCreateResult",
		"...on RedirectDeleteResult": "RedirectDeleteResult",
		"...on RedirectUpdateResult": "RedirectUpdateResult",
		"...on RedirectUpsertResult": "RedirectUpsertResult",
		"...on GalleryCreateResult": "GalleryCreateResult",
		"...on GalleryDeleteResult": "GalleryDeleteResult",
		"...on GalleryUpdateResult": "GalleryUpdateResult",
		"...on GalleryUpsertResult": "GalleryUpsertResult",
		"...on GalleryItemCreateResult": "GalleryItemCreateResult",
		"...on GalleryItemDeleteResult": "GalleryItemDeleteResult",
		"...on GalleryItemUpdateResult": "GalleryItemUpdateResult",
		"...on GalleryItemUpsertResult": "GalleryItemUpsertResult",
		"...on ContactFormCreateResult": "ContactFormCreateResult",
		"...on ContactFormDeleteResult": "ContactFormDeleteResult",
		"...on ContactFormUpdateResult": "ContactFormUpdateResult",
		"...on ContactFormUpsertResult": "ContactFormUpsertResult",
		"...on ContactFormLocaleCreateResult": "ContactFormLocaleCreateResult",
		"...on ContactFormLocaleDeleteResult": "ContactFormLocaleDeleteResult",
		"...on ContactFormLocaleUpdateResult": "ContactFormLocaleUpdateResult",
		"...on ContactFormLocaleUpsertResult": "ContactFormLocaleUpsertResult",
		"...on ContactSubscriptionCreateResult": "ContactSubscriptionCreateResult",
		"...on ContactSubscriptionDeleteResult": "ContactSubscriptionDeleteResult",
		"...on ContactSubscriptionUpdateResult": "ContactSubscriptionUpdateResult",
		"...on ContactSubscriptionUpsertResult": "ContactSubscriptionUpsertResult",
		"...on ContactTypeItemCreateResult": "ContactTypeItemCreateResult",
		"...on ContactTypeItemDeleteResult": "ContactTypeItemDeleteResult",
		"...on ContactTypeItemUpdateResult": "ContactTypeItemUpdateResult",
		"...on ContactTypeItemUpsertResult": "ContactTypeItemUpsertResult",
		"...on FileCreateResult": "FileCreateResult",
		"...on FileDeleteResult": "FileDeleteResult",
		"...on FileUpdateResult": "FileUpdateResult",
		"...on FileUpsertResult": "FileUpsertResult",
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError"
	},
	_MutationError:{
		path:"_PathFragment",
		paths:"_PathFragment",
		type:"_MutationErrorType",
		message:"String"
	},
	ContactPageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPage"
	},
	ContactPageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPage",
		validation:"_ValidationResult"
	},
	ContactPageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPage",
		validation:"_ValidationResult"
	},
	ContactPageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPageLocale",
		validation:"_ValidationResult"
	},
	ContactPageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPageLocale"
	},
	ContactPageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPageLocale",
		validation:"_ValidationResult"
	},
	ContactPageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactPageLocale",
		validation:"_ValidationResult"
	},
	ContentCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content"
	},
	ContentUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Content",
		validation:"_ValidationResult"
	},
	ContentBlockCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock"
	},
	ContentBlockUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentBlockUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentBlock",
		validation:"_ValidationResult"
	},
	ContentReferenceCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference"
	},
	ContentReferenceUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	ContentReferenceUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContentReference",
		validation:"_ValidationResult"
	},
	FooterCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer"
	},
	FooterUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Footer",
		validation:"_ValidationResult"
	},
	FooterLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale"
	},
	FooterLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	FooterLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"FooterLocale",
		validation:"_ValidationResult"
	},
	HeaderCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header"
	},
	HeaderUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Header",
		validation:"_ValidationResult"
	},
	HeaderLinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink"
	},
	HeaderLinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLink",
		validation:"_ValidationResult"
	},
	HeaderLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale"
	},
	HeaderLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HeaderLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HeaderLocale",
		validation:"_ValidationResult"
	},
	HomePageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage"
	},
	HomePageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePage",
		validation:"_ValidationResult"
	},
	HomePageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	HomePageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale"
	},
	HomePageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	HomePageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"HomePageLocale",
		validation:"_ValidationResult"
	},
	LinkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link"
	},
	LinkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Link",
		validation:"_ValidationResult"
	},
	LinkableCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable"
	},
	LinkableUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LinkableUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Linkable",
		validation:"_ValidationResult"
	},
	LocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale"
	},
	LocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	LocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Locale",
		validation:"_ValidationResult"
	},
	MediumCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium"
	},
	MediumUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Medium",
		validation:"_ValidationResult"
	},
	MediumItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem"
	},
	MediumItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumItem",
		validation:"_ValidationResult"
	},
	MediumListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList"
	},
	MediumListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	MediumListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"MediumList",
		validation:"_ValidationResult"
	},
	PageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page"
	},
	PageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Page",
		validation:"_ValidationResult"
	},
	PageLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale"
	},
	PageLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	PageLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"PageLocale",
		validation:"_ValidationResult"
	},
	SeoDefaultCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault"
	},
	SeoDefaultUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefault",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale"
	},
	SeoDefaultLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	SeoDefaultLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"SeoDefaultLocale",
		validation:"_ValidationResult"
	},
	VideoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video"
	},
	VideoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	VideoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Video",
		validation:"_ValidationResult"
	},
	ImageCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image"
	},
	ImageUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	ImageUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Image",
		validation:"_ValidationResult"
	},
	SeoCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo"
	},
	SeoUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	SeoUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Seo",
		validation:"_ValidationResult"
	},
	TranslationDomainCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain"
	},
	TranslationDomainUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationDomainUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationDomain",
		validation:"_ValidationResult"
	},
	TranslationCatalogueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue"
	},
	TranslationCatalogueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCatalogueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCatalogue",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier"
	},
	TranslationCataloguesIdentifierUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationCataloguesIdentifierUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationCataloguesIdentifier",
		validation:"_ValidationResult"
	},
	TranslationKeyCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey"
	},
	TranslationKeyUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationKeyUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationKey",
		validation:"_ValidationResult"
	},
	TranslationValueCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue"
	},
	TranslationValueUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	TranslationValueUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"TranslationValue",
		validation:"_ValidationResult"
	},
	BranchesCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Branches",
		validation:"_ValidationResult"
	},
	BranchesDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Branches"
	},
	BranchesUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Branches",
		validation:"_ValidationResult"
	},
	BranchesUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Branches",
		validation:"_ValidationResult"
	},
	GraphicDesignerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GraphicDesigner",
		validation:"_ValidationResult"
	},
	GraphicDesignerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GraphicDesigner"
	},
	GraphicDesignerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GraphicDesigner",
		validation:"_ValidationResult"
	},
	GraphicDesignerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GraphicDesigner",
		validation:"_ValidationResult"
	},
	EventCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event"
	},
	EventUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Event",
		validation:"_ValidationResult"
	},
	EventLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	EventLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale"
	},
	EventLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	EventLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventLocale",
		validation:"_ValidationResult"
	},
	ArtworkCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Artwork",
		validation:"_ValidationResult"
	},
	ArtworkDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Artwork"
	},
	ArtworkUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Artwork",
		validation:"_ValidationResult"
	},
	ArtworkUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Artwork",
		validation:"_ValidationResult"
	},
	ArtworkLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkLocale",
		validation:"_ValidationResult"
	},
	ArtworkLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkLocale"
	},
	ArtworkLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkLocale",
		validation:"_ValidationResult"
	},
	ArtworkLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkLocale",
		validation:"_ValidationResult"
	},
	DropDownItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownItem",
		validation:"_ValidationResult"
	},
	DropDownItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownItem"
	},
	DropDownItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownItem",
		validation:"_ValidationResult"
	},
	DropDownItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownItem",
		validation:"_ValidationResult"
	},
	DropDownListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownList",
		validation:"_ValidationResult"
	},
	DropDownListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownList"
	},
	DropDownListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownList",
		validation:"_ValidationResult"
	},
	DropDownListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DropDownList",
		validation:"_ValidationResult"
	},
	ArtworkItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkItem",
		validation:"_ValidationResult"
	},
	ArtworkItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkItem"
	},
	ArtworkItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkItem",
		validation:"_ValidationResult"
	},
	ArtworkItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkItem",
		validation:"_ValidationResult"
	},
	ArtworkListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkList",
		validation:"_ValidationResult"
	},
	ArtworkListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkList"
	},
	ArtworkListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkList",
		validation:"_ValidationResult"
	},
	ArtworkListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkList",
		validation:"_ValidationResult"
	},
	ArtworkSelectionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelection",
		validation:"_ValidationResult"
	},
	ArtworkSelectionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelection"
	},
	ArtworkSelectionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelection",
		validation:"_ValidationResult"
	},
	ArtworkSelectionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelection",
		validation:"_ValidationResult"
	},
	ArtworkSelectionItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionItem",
		validation:"_ValidationResult"
	},
	ArtworkSelectionItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionItem"
	},
	ArtworkSelectionItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionItem",
		validation:"_ValidationResult"
	},
	ArtworkSelectionItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionItem",
		validation:"_ValidationResult"
	},
	ArtworkSelectionListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionList",
		validation:"_ValidationResult"
	},
	ArtworkSelectionListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionList"
	},
	ArtworkSelectionListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionList",
		validation:"_ValidationResult"
	},
	ArtworkSelectionListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionList",
		validation:"_ValidationResult"
	},
	ArtworkSelectionLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionLocale",
		validation:"_ValidationResult"
	},
	ArtworkSelectionLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionLocale"
	},
	ArtworkSelectionLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionLocale",
		validation:"_ValidationResult"
	},
	ArtworkSelectionLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ArtworkSelectionLocale",
		validation:"_ValidationResult"
	},
	EventItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventItem",
		validation:"_ValidationResult"
	},
	EventItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventItem"
	},
	EventItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventItem",
		validation:"_ValidationResult"
	},
	EventItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventItem",
		validation:"_ValidationResult"
	},
	EventListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventList",
		validation:"_ValidationResult"
	},
	EventListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventList"
	},
	EventListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventList",
		validation:"_ValidationResult"
	},
	EventListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EventList",
		validation:"_ValidationResult"
	},
	BoxItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxItem",
		validation:"_ValidationResult"
	},
	BoxItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxItem"
	},
	BoxItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxItem",
		validation:"_ValidationResult"
	},
	BoxItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxItem",
		validation:"_ValidationResult"
	},
	BoxListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxList",
		validation:"_ValidationResult"
	},
	BoxListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxList"
	},
	BoxListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxList",
		validation:"_ValidationResult"
	},
	BoxListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"BoxList",
		validation:"_ValidationResult"
	},
	NewsletterFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterForm",
		validation:"_ValidationResult"
	},
	NewsletterFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterForm"
	},
	NewsletterFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterForm",
		validation:"_ValidationResult"
	},
	NewsletterFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterForm",
		validation:"_ValidationResult"
	},
	NewsletterTypeItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterTypeItem",
		validation:"_ValidationResult"
	},
	NewsletterTypeItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterTypeItem"
	},
	NewsletterTypeItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterTypeItem",
		validation:"_ValidationResult"
	},
	NewsletterTypeItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterTypeItem",
		validation:"_ValidationResult"
	},
	NewsletterFormLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterFormLocale",
		validation:"_ValidationResult"
	},
	NewsletterFormLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterFormLocale"
	},
	NewsletterFormLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterFormLocale",
		validation:"_ValidationResult"
	},
	NewsletterFormLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterFormLocale",
		validation:"_ValidationResult"
	},
	NewsletterSubscriptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSubscription",
		validation:"_ValidationResult"
	},
	NewsletterSubscriptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSubscription"
	},
	NewsletterSubscriptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSubscription",
		validation:"_ValidationResult"
	},
	NewsletterSubscriptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"NewsletterSubscription",
		validation:"_ValidationResult"
	},
	ChartCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Chart",
		validation:"_ValidationResult"
	},
	ChartDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Chart"
	},
	ChartUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Chart",
		validation:"_ValidationResult"
	},
	ChartUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Chart",
		validation:"_ValidationResult"
	},
	ChartDataCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChartData",
		validation:"_ValidationResult"
	},
	ChartDataDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChartData"
	},
	ChartDataUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChartData",
		validation:"_ValidationResult"
	},
	ChartDataUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ChartData",
		validation:"_ValidationResult"
	},
	EmployeeCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Employee",
		validation:"_ValidationResult"
	},
	EmployeeDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Employee"
	},
	EmployeeUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Employee",
		validation:"_ValidationResult"
	},
	EmployeeUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Employee",
		validation:"_ValidationResult"
	},
	EmployeeItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeItem",
		validation:"_ValidationResult"
	},
	EmployeeItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeItem"
	},
	EmployeeItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeItem",
		validation:"_ValidationResult"
	},
	EmployeeItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeItem",
		validation:"_ValidationResult"
	},
	EmployeeListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeList",
		validation:"_ValidationResult"
	},
	EmployeeListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeList"
	},
	EmployeeListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeList",
		validation:"_ValidationResult"
	},
	EmployeeListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeList",
		validation:"_ValidationResult"
	},
	EmployeeLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeLocale",
		validation:"_ValidationResult"
	},
	EmployeeLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeLocale"
	},
	EmployeeLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeLocale",
		validation:"_ValidationResult"
	},
	EmployeeLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"EmployeeLocale",
		validation:"_ValidationResult"
	},
	PhotographerCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	PhotographerDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer"
	},
	PhotographerUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	PhotographerUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Photographer",
		validation:"_ValidationResult"
	},
	DefinitionItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionItem",
		validation:"_ValidationResult"
	},
	DefinitionItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionItem"
	},
	DefinitionItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionItem",
		validation:"_ValidationResult"
	},
	DefinitionItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionItem",
		validation:"_ValidationResult"
	},
	DefinitionListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionList",
		validation:"_ValidationResult"
	},
	DefinitionListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionList"
	},
	DefinitionListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionList",
		validation:"_ValidationResult"
	},
	DefinitionListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"DefinitionList",
		validation:"_ValidationResult"
	},
	LogoItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoItem",
		validation:"_ValidationResult"
	},
	LogoItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoItem"
	},
	LogoItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoItem",
		validation:"_ValidationResult"
	},
	LogoItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoItem",
		validation:"_ValidationResult"
	},
	LogoListCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoList",
		validation:"_ValidationResult"
	},
	LogoListDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoList"
	},
	LogoListUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoList",
		validation:"_ValidationResult"
	},
	LogoListUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"LogoList",
		validation:"_ValidationResult"
	},
	StrategySchemaCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchema",
		validation:"_ValidationResult"
	},
	StrategySchemaDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchema"
	},
	StrategySchemaUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchema",
		validation:"_ValidationResult"
	},
	StrategySchemaUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchema",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroup",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroup"
	},
	StrategySchemaGroupUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroup",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroup",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroupItem",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroupItem"
	},
	StrategySchemaGroupItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroupItem",
		validation:"_ValidationResult"
	},
	StrategySchemaGroupItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"StrategySchemaGroupItem",
		validation:"_ValidationResult"
	},
	RedirectCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect"
	},
	RedirectUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	RedirectUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Redirect",
		validation:"_ValidationResult"
	},
	GalleryCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery"
	},
	GalleryUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"Gallery",
		validation:"_ValidationResult"
	},
	GalleryItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem"
	},
	GalleryItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	GalleryItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"GalleryItem",
		validation:"_ValidationResult"
	},
	ContactFormCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactForm",
		validation:"_ValidationResult"
	},
	ContactFormDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactForm"
	},
	ContactFormUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactForm",
		validation:"_ValidationResult"
	},
	ContactFormUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactForm",
		validation:"_ValidationResult"
	},
	ContactFormLocaleCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactFormLocale",
		validation:"_ValidationResult"
	},
	ContactFormLocaleDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactFormLocale"
	},
	ContactFormLocaleUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactFormLocale",
		validation:"_ValidationResult"
	},
	ContactFormLocaleUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactFormLocale",
		validation:"_ValidationResult"
	},
	ContactSubscriptionCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactSubscription",
		validation:"_ValidationResult"
	},
	ContactSubscriptionDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactSubscription"
	},
	ContactSubscriptionUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactSubscription",
		validation:"_ValidationResult"
	},
	ContactSubscriptionUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactSubscription",
		validation:"_ValidationResult"
	},
	ContactTypeItemCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactTypeItem",
		validation:"_ValidationResult"
	},
	ContactTypeItemDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactTypeItem"
	},
	ContactTypeItemUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactTypeItem",
		validation:"_ValidationResult"
	},
	ContactTypeItemUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"ContactTypeItem",
		validation:"_ValidationResult"
	},
	FileCreateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileDeleteResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File"
	},
	FileUpdateResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	FileUpsertResult:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		node:"File",
		validation:"_ValidationResult"
	},
	MutationTransaction:{
		ok:"Boolean",
		errorMessage:"String",
		errors:"_MutationError",
		validation:"_ValidationResult",
		createContactPage:"ContactPageCreateResult",
		deleteContactPage:"ContactPageDeleteResult",
		updateContactPage:"ContactPageUpdateResult",
		upsertContactPage:"ContactPageUpsertResult",
		createContactPageLocale:"ContactPageLocaleCreateResult",
		deleteContactPageLocale:"ContactPageLocaleDeleteResult",
		updateContactPageLocale:"ContactPageLocaleUpdateResult",
		upsertContactPageLocale:"ContactPageLocaleUpsertResult",
		createContent:"ContentCreateResult",
		deleteContent:"ContentDeleteResult",
		updateContent:"ContentUpdateResult",
		upsertContent:"ContentUpsertResult",
		createContentBlock:"ContentBlockCreateResult",
		deleteContentBlock:"ContentBlockDeleteResult",
		updateContentBlock:"ContentBlockUpdateResult",
		upsertContentBlock:"ContentBlockUpsertResult",
		createContentReference:"ContentReferenceCreateResult",
		deleteContentReference:"ContentReferenceDeleteResult",
		updateContentReference:"ContentReferenceUpdateResult",
		upsertContentReference:"ContentReferenceUpsertResult",
		createFooter:"FooterCreateResult",
		deleteFooter:"FooterDeleteResult",
		updateFooter:"FooterUpdateResult",
		upsertFooter:"FooterUpsertResult",
		createFooterLocale:"FooterLocaleCreateResult",
		deleteFooterLocale:"FooterLocaleDeleteResult",
		updateFooterLocale:"FooterLocaleUpdateResult",
		upsertFooterLocale:"FooterLocaleUpsertResult",
		createHeader:"HeaderCreateResult",
		deleteHeader:"HeaderDeleteResult",
		updateHeader:"HeaderUpdateResult",
		upsertHeader:"HeaderUpsertResult",
		createHeaderLink:"HeaderLinkCreateResult",
		deleteHeaderLink:"HeaderLinkDeleteResult",
		updateHeaderLink:"HeaderLinkUpdateResult",
		upsertHeaderLink:"HeaderLinkUpsertResult",
		createHeaderLocale:"HeaderLocaleCreateResult",
		deleteHeaderLocale:"HeaderLocaleDeleteResult",
		updateHeaderLocale:"HeaderLocaleUpdateResult",
		upsertHeaderLocale:"HeaderLocaleUpsertResult",
		createHomePage:"HomePageCreateResult",
		deleteHomePage:"HomePageDeleteResult",
		updateHomePage:"HomePageUpdateResult",
		upsertHomePage:"HomePageUpsertResult",
		createHomePageLocale:"HomePageLocaleCreateResult",
		deleteHomePageLocale:"HomePageLocaleDeleteResult",
		updateHomePageLocale:"HomePageLocaleUpdateResult",
		upsertHomePageLocale:"HomePageLocaleUpsertResult",
		createLink:"LinkCreateResult",
		deleteLink:"LinkDeleteResult",
		updateLink:"LinkUpdateResult",
		upsertLink:"LinkUpsertResult",
		createLinkable:"LinkableCreateResult",
		deleteLinkable:"LinkableDeleteResult",
		updateLinkable:"LinkableUpdateResult",
		upsertLinkable:"LinkableUpsertResult",
		createLocale:"LocaleCreateResult",
		deleteLocale:"LocaleDeleteResult",
		updateLocale:"LocaleUpdateResult",
		upsertLocale:"LocaleUpsertResult",
		createMedium:"MediumCreateResult",
		deleteMedium:"MediumDeleteResult",
		updateMedium:"MediumUpdateResult",
		upsertMedium:"MediumUpsertResult",
		createMediumItem:"MediumItemCreateResult",
		deleteMediumItem:"MediumItemDeleteResult",
		updateMediumItem:"MediumItemUpdateResult",
		upsertMediumItem:"MediumItemUpsertResult",
		createMediumList:"MediumListCreateResult",
		deleteMediumList:"MediumListDeleteResult",
		updateMediumList:"MediumListUpdateResult",
		upsertMediumList:"MediumListUpsertResult",
		createPage:"PageCreateResult",
		deletePage:"PageDeleteResult",
		updatePage:"PageUpdateResult",
		upsertPage:"PageUpsertResult",
		createPageLocale:"PageLocaleCreateResult",
		deletePageLocale:"PageLocaleDeleteResult",
		updatePageLocale:"PageLocaleUpdateResult",
		upsertPageLocale:"PageLocaleUpsertResult",
		createSeoDefault:"SeoDefaultCreateResult",
		deleteSeoDefault:"SeoDefaultDeleteResult",
		updateSeoDefault:"SeoDefaultUpdateResult",
		upsertSeoDefault:"SeoDefaultUpsertResult",
		createSeoDefaultLocale:"SeoDefaultLocaleCreateResult",
		deleteSeoDefaultLocale:"SeoDefaultLocaleDeleteResult",
		updateSeoDefaultLocale:"SeoDefaultLocaleUpdateResult",
		upsertSeoDefaultLocale:"SeoDefaultLocaleUpsertResult",
		createVideo:"VideoCreateResult",
		deleteVideo:"VideoDeleteResult",
		updateVideo:"VideoUpdateResult",
		upsertVideo:"VideoUpsertResult",
		createImage:"ImageCreateResult",
		deleteImage:"ImageDeleteResult",
		updateImage:"ImageUpdateResult",
		upsertImage:"ImageUpsertResult",
		createSeo:"SeoCreateResult",
		deleteSeo:"SeoDeleteResult",
		updateSeo:"SeoUpdateResult",
		upsertSeo:"SeoUpsertResult",
		createTranslationDomain:"TranslationDomainCreateResult",
		deleteTranslationDomain:"TranslationDomainDeleteResult",
		updateTranslationDomain:"TranslationDomainUpdateResult",
		upsertTranslationDomain:"TranslationDomainUpsertResult",
		createTranslationCatalogue:"TranslationCatalogueCreateResult",
		deleteTranslationCatalogue:"TranslationCatalogueDeleteResult",
		updateTranslationCatalogue:"TranslationCatalogueUpdateResult",
		upsertTranslationCatalogue:"TranslationCatalogueUpsertResult",
		createTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierCreateResult",
		deleteTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierDeleteResult",
		updateTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpdateResult",
		upsertTranslationCataloguesIdentifier:"TranslationCataloguesIdentifierUpsertResult",
		createTranslationKey:"TranslationKeyCreateResult",
		deleteTranslationKey:"TranslationKeyDeleteResult",
		updateTranslationKey:"TranslationKeyUpdateResult",
		upsertTranslationKey:"TranslationKeyUpsertResult",
		createTranslationValue:"TranslationValueCreateResult",
		deleteTranslationValue:"TranslationValueDeleteResult",
		updateTranslationValue:"TranslationValueUpdateResult",
		upsertTranslationValue:"TranslationValueUpsertResult",
		createBranches:"BranchesCreateResult",
		deleteBranches:"BranchesDeleteResult",
		updateBranches:"BranchesUpdateResult",
		upsertBranches:"BranchesUpsertResult",
		createGraphicDesigner:"GraphicDesignerCreateResult",
		deleteGraphicDesigner:"GraphicDesignerDeleteResult",
		updateGraphicDesigner:"GraphicDesignerUpdateResult",
		upsertGraphicDesigner:"GraphicDesignerUpsertResult",
		createEvent:"EventCreateResult",
		deleteEvent:"EventDeleteResult",
		updateEvent:"EventUpdateResult",
		upsertEvent:"EventUpsertResult",
		createEventLocale:"EventLocaleCreateResult",
		deleteEventLocale:"EventLocaleDeleteResult",
		updateEventLocale:"EventLocaleUpdateResult",
		upsertEventLocale:"EventLocaleUpsertResult",
		createArtwork:"ArtworkCreateResult",
		deleteArtwork:"ArtworkDeleteResult",
		updateArtwork:"ArtworkUpdateResult",
		upsertArtwork:"ArtworkUpsertResult",
		createArtworkLocale:"ArtworkLocaleCreateResult",
		deleteArtworkLocale:"ArtworkLocaleDeleteResult",
		updateArtworkLocale:"ArtworkLocaleUpdateResult",
		upsertArtworkLocale:"ArtworkLocaleUpsertResult",
		createDropDownItem:"DropDownItemCreateResult",
		deleteDropDownItem:"DropDownItemDeleteResult",
		updateDropDownItem:"DropDownItemUpdateResult",
		upsertDropDownItem:"DropDownItemUpsertResult",
		createDropDownList:"DropDownListCreateResult",
		deleteDropDownList:"DropDownListDeleteResult",
		updateDropDownList:"DropDownListUpdateResult",
		upsertDropDownList:"DropDownListUpsertResult",
		createArtworkItem:"ArtworkItemCreateResult",
		deleteArtworkItem:"ArtworkItemDeleteResult",
		updateArtworkItem:"ArtworkItemUpdateResult",
		upsertArtworkItem:"ArtworkItemUpsertResult",
		createArtworkList:"ArtworkListCreateResult",
		deleteArtworkList:"ArtworkListDeleteResult",
		updateArtworkList:"ArtworkListUpdateResult",
		upsertArtworkList:"ArtworkListUpsertResult",
		createArtworkSelection:"ArtworkSelectionCreateResult",
		deleteArtworkSelection:"ArtworkSelectionDeleteResult",
		updateArtworkSelection:"ArtworkSelectionUpdateResult",
		upsertArtworkSelection:"ArtworkSelectionUpsertResult",
		createArtworkSelectionItem:"ArtworkSelectionItemCreateResult",
		deleteArtworkSelectionItem:"ArtworkSelectionItemDeleteResult",
		updateArtworkSelectionItem:"ArtworkSelectionItemUpdateResult",
		upsertArtworkSelectionItem:"ArtworkSelectionItemUpsertResult",
		createArtworkSelectionList:"ArtworkSelectionListCreateResult",
		deleteArtworkSelectionList:"ArtworkSelectionListDeleteResult",
		updateArtworkSelectionList:"ArtworkSelectionListUpdateResult",
		upsertArtworkSelectionList:"ArtworkSelectionListUpsertResult",
		createArtworkSelectionLocale:"ArtworkSelectionLocaleCreateResult",
		deleteArtworkSelectionLocale:"ArtworkSelectionLocaleDeleteResult",
		updateArtworkSelectionLocale:"ArtworkSelectionLocaleUpdateResult",
		upsertArtworkSelectionLocale:"ArtworkSelectionLocaleUpsertResult",
		createEventItem:"EventItemCreateResult",
		deleteEventItem:"EventItemDeleteResult",
		updateEventItem:"EventItemUpdateResult",
		upsertEventItem:"EventItemUpsertResult",
		createEventList:"EventListCreateResult",
		deleteEventList:"EventListDeleteResult",
		updateEventList:"EventListUpdateResult",
		upsertEventList:"EventListUpsertResult",
		createBoxItem:"BoxItemCreateResult",
		deleteBoxItem:"BoxItemDeleteResult",
		updateBoxItem:"BoxItemUpdateResult",
		upsertBoxItem:"BoxItemUpsertResult",
		createBoxList:"BoxListCreateResult",
		deleteBoxList:"BoxListDeleteResult",
		updateBoxList:"BoxListUpdateResult",
		upsertBoxList:"BoxListUpsertResult",
		createNewsletterForm:"NewsletterFormCreateResult",
		deleteNewsletterForm:"NewsletterFormDeleteResult",
		updateNewsletterForm:"NewsletterFormUpdateResult",
		upsertNewsletterForm:"NewsletterFormUpsertResult",
		createNewsletterTypeItem:"NewsletterTypeItemCreateResult",
		deleteNewsletterTypeItem:"NewsletterTypeItemDeleteResult",
		updateNewsletterTypeItem:"NewsletterTypeItemUpdateResult",
		upsertNewsletterTypeItem:"NewsletterTypeItemUpsertResult",
		createNewsletterFormLocale:"NewsletterFormLocaleCreateResult",
		deleteNewsletterFormLocale:"NewsletterFormLocaleDeleteResult",
		updateNewsletterFormLocale:"NewsletterFormLocaleUpdateResult",
		upsertNewsletterFormLocale:"NewsletterFormLocaleUpsertResult",
		createNewsletterSubscription:"NewsletterSubscriptionCreateResult",
		deleteNewsletterSubscription:"NewsletterSubscriptionDeleteResult",
		updateNewsletterSubscription:"NewsletterSubscriptionUpdateResult",
		upsertNewsletterSubscription:"NewsletterSubscriptionUpsertResult",
		createChart:"ChartCreateResult",
		deleteChart:"ChartDeleteResult",
		updateChart:"ChartUpdateResult",
		upsertChart:"ChartUpsertResult",
		createChartData:"ChartDataCreateResult",
		deleteChartData:"ChartDataDeleteResult",
		updateChartData:"ChartDataUpdateResult",
		upsertChartData:"ChartDataUpsertResult",
		createEmployee:"EmployeeCreateResult",
		deleteEmployee:"EmployeeDeleteResult",
		updateEmployee:"EmployeeUpdateResult",
		upsertEmployee:"EmployeeUpsertResult",
		createEmployeeItem:"EmployeeItemCreateResult",
		deleteEmployeeItem:"EmployeeItemDeleteResult",
		updateEmployeeItem:"EmployeeItemUpdateResult",
		upsertEmployeeItem:"EmployeeItemUpsertResult",
		createEmployeeList:"EmployeeListCreateResult",
		deleteEmployeeList:"EmployeeListDeleteResult",
		updateEmployeeList:"EmployeeListUpdateResult",
		upsertEmployeeList:"EmployeeListUpsertResult",
		createEmployeeLocale:"EmployeeLocaleCreateResult",
		deleteEmployeeLocale:"EmployeeLocaleDeleteResult",
		updateEmployeeLocale:"EmployeeLocaleUpdateResult",
		upsertEmployeeLocale:"EmployeeLocaleUpsertResult",
		createPhotographer:"PhotographerCreateResult",
		deletePhotographer:"PhotographerDeleteResult",
		updatePhotographer:"PhotographerUpdateResult",
		upsertPhotographer:"PhotographerUpsertResult",
		createDefinitionItem:"DefinitionItemCreateResult",
		deleteDefinitionItem:"DefinitionItemDeleteResult",
		updateDefinitionItem:"DefinitionItemUpdateResult",
		upsertDefinitionItem:"DefinitionItemUpsertResult",
		createDefinitionList:"DefinitionListCreateResult",
		deleteDefinitionList:"DefinitionListDeleteResult",
		updateDefinitionList:"DefinitionListUpdateResult",
		upsertDefinitionList:"DefinitionListUpsertResult",
		createLogoItem:"LogoItemCreateResult",
		deleteLogoItem:"LogoItemDeleteResult",
		updateLogoItem:"LogoItemUpdateResult",
		upsertLogoItem:"LogoItemUpsertResult",
		createLogoList:"LogoListCreateResult",
		deleteLogoList:"LogoListDeleteResult",
		updateLogoList:"LogoListUpdateResult",
		upsertLogoList:"LogoListUpsertResult",
		createStrategySchema:"StrategySchemaCreateResult",
		deleteStrategySchema:"StrategySchemaDeleteResult",
		updateStrategySchema:"StrategySchemaUpdateResult",
		upsertStrategySchema:"StrategySchemaUpsertResult",
		createStrategySchemaGroup:"StrategySchemaGroupCreateResult",
		deleteStrategySchemaGroup:"StrategySchemaGroupDeleteResult",
		updateStrategySchemaGroup:"StrategySchemaGroupUpdateResult",
		upsertStrategySchemaGroup:"StrategySchemaGroupUpsertResult",
		createStrategySchemaGroupItem:"StrategySchemaGroupItemCreateResult",
		deleteStrategySchemaGroupItem:"StrategySchemaGroupItemDeleteResult",
		updateStrategySchemaGroupItem:"StrategySchemaGroupItemUpdateResult",
		upsertStrategySchemaGroupItem:"StrategySchemaGroupItemUpsertResult",
		createRedirect:"RedirectCreateResult",
		deleteRedirect:"RedirectDeleteResult",
		updateRedirect:"RedirectUpdateResult",
		upsertRedirect:"RedirectUpsertResult",
		createGallery:"GalleryCreateResult",
		deleteGallery:"GalleryDeleteResult",
		updateGallery:"GalleryUpdateResult",
		upsertGallery:"GalleryUpsertResult",
		createGalleryItem:"GalleryItemCreateResult",
		deleteGalleryItem:"GalleryItemDeleteResult",
		updateGalleryItem:"GalleryItemUpdateResult",
		upsertGalleryItem:"GalleryItemUpsertResult",
		createContactForm:"ContactFormCreateResult",
		deleteContactForm:"ContactFormDeleteResult",
		updateContactForm:"ContactFormUpdateResult",
		upsertContactForm:"ContactFormUpsertResult",
		createContactFormLocale:"ContactFormLocaleCreateResult",
		deleteContactFormLocale:"ContactFormLocaleDeleteResult",
		updateContactFormLocale:"ContactFormLocaleUpdateResult",
		upsertContactFormLocale:"ContactFormLocaleUpsertResult",
		createContactSubscription:"ContactSubscriptionCreateResult",
		deleteContactSubscription:"ContactSubscriptionDeleteResult",
		updateContactSubscription:"ContactSubscriptionUpdateResult",
		upsertContactSubscription:"ContactSubscriptionUpsertResult",
		createContactTypeItem:"ContactTypeItemCreateResult",
		deleteContactTypeItem:"ContactTypeItemDeleteResult",
		updateContactTypeItem:"ContactTypeItemUpdateResult",
		upsertContactTypeItem:"ContactTypeItemUpsertResult",
		createFile:"FileCreateResult",
		deleteFile:"FileDeleteResult",
		updateFile:"FileUpdateResult",
		upsertFile:"FileUpsertResult",
		query:"Query"
	},
	_Schema:{
		enums:"_Enum",
		entities:"_Entity"
	},
	_Entity:{
		name:"String",
		customPrimaryAllowed:"Boolean",
		fields:"_Field",
		unique:"_UniqueConstraint"
	},
	_UniqueConstraint:{
		fields:"String"
	},
	_Field:{
		"...on _Column": "_Column",
		"...on _Relation": "_Relation",
		name:"String",
		type:"String",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Column:{
		name:"String",
		type:"String",
		enumName:"String",
		defaultValue:"Json",
		nullable:"Boolean",
		rules:"_Rule",
		validators:"_Validator"
	},
	_OrderBy:{
		path:"String",
		direction:"_OrderByDirection"
	},
	_Relation:{
		name:"String",
		type:"String",
		side:"_RelationSide",
		targetEntity:"String",
		ownedBy:"String",
		inversedBy:"String",
		nullable:"Boolean",
		onDelete:"_OnDeleteBehaviour",
		orphanRemoval:"Boolean",
		orderBy:"_OrderBy",
		rules:"_Rule",
		validators:"_Validator"
	},
	_Rule:{
		message:"_RuleMessage",
		validator:"Int"
	},
	_Validator:{
		operation:"String",
		arguments:"_Argument"
	},
	_Argument:{
		"...on _ValidatorArgument":"_ValidatorArgument",
		"...on _PathArgument":"_PathArgument",
		"...on _LiteralArgument":"_LiteralArgument"
	},
	_ValidatorArgument:{
		validator:"Int"
	},
	_PathArgument:{
		path:"String"
	},
	_LiteralArgument:{
		value:"Json"
	},
	_RuleMessage:{
		text:"String"
	},
	_Enum:{
		name:"String",
		values:"String"
	},
	S3SignedUpload:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String",
		publicUrl:"String"
	},
	S3Header:{
		key:"String",
		value:"String"
	},
	S3SignedRead:{
		url:"String",
		headers:"S3Header",
		method:"String",
		objectKey:"String",
		bucket:"String"
	}
}
type ZEUS_INTERFACES = GraphQLTypes["MutationResult"] | GraphQLTypes["_Field"]
type ZEUS_UNIONS = GraphQLTypes["_PathFragment"] | GraphQLTypes["_Argument"]

export type ValueTypes = {
    ["Query"]: AliasType<{
getContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
listContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPage"]],
paginateContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageConnection"]],
validateCreateContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
listContactPageLocale?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPageLocale"]],
paginateContactPageLocale?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageLocaleConnection"]],
validateCreateContactPageLocale?: [{	data:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	data:ValueTypes["ContactPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	data:ValueTypes["HomePageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data:ValueTypes["MediumItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	data:ValueTypes["MediumItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumList"]],
listMediumList?: [{	filter?:ValueTypes["MediumListWhere"] | null,	orderBy?:ValueTypes["MediumListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?:ValueTypes["MediumListWhere"] | null,	orderBy?:ValueTypes["MediumListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data:ValueTypes["MediumListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	data:ValueTypes["MediumListUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null},ValueTypes["SeoDefault"]],
listSeoDefault?: [{	filter?:ValueTypes["SeoDefaultWhere"] | null,	orderBy?:ValueTypes["SeoDefaultOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?:ValueTypes["SeoDefaultWhere"] | null,	orderBy?:ValueTypes["SeoDefaultOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	data:ValueTypes["SeoDefaultUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	data:ValueTypes["SeoDefaultLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null},ValueTypes["Branches"]],
listBranches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Branches"]],
paginateBranches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BranchesConnection"]],
validateCreateBranches?: [{	data:ValueTypes["BranchesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	data:ValueTypes["BranchesUpdateInput"]},ValueTypes["_ValidationResult"]],
getGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null},ValueTypes["GraphicDesigner"]],
listGraphicDesigner?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GraphicDesigner"]],
paginateGraphicDesigner?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GraphicDesignerConnection"]],
validateCreateGraphicDesigner?: [{	data:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	data:ValueTypes["GraphicDesignerUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
listEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
paginateEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
validateCreateEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["Artwork"]],
listArtwork?: [{	filter?:ValueTypes["ArtworkWhere"] | null,	orderBy?:ValueTypes["ArtworkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Artwork"]],
paginateArtwork?: [{	filter?:ValueTypes["ArtworkWhere"] | null,	orderBy?:ValueTypes["ArtworkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkConnection"]],
validateCreateArtwork?: [{	data:ValueTypes["ArtworkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	data:ValueTypes["ArtworkUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
listArtworkLocale?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkLocale"]],
paginateArtworkLocale?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkLocaleConnection"]],
validateCreateArtworkLocale?: [{	data:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	data:ValueTypes["ArtworkLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null},ValueTypes["DropDownItem"]],
listDropDownItem?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DropDownItem"]],
paginateDropDownItem?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DropDownItemConnection"]],
validateCreateDropDownItem?: [{	data:ValueTypes["DropDownItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	data:ValueTypes["DropDownItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownList"]],
listDropDownList?: [{	filter?:ValueTypes["DropDownListWhere"] | null,	orderBy?:ValueTypes["DropDownListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DropDownList"]],
paginateDropDownList?: [{	filter?:ValueTypes["DropDownListWhere"] | null,	orderBy?:ValueTypes["DropDownListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DropDownListConnection"]],
validateCreateDropDownList?: [{	data:ValueTypes["DropDownListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	data:ValueTypes["DropDownListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null},ValueTypes["ArtworkItem"]],
listArtworkItem?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkItem"]],
paginateArtworkItem?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkItemConnection"]],
validateCreateArtworkItem?: [{	data:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	data:ValueTypes["ArtworkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null},ValueTypes["ArtworkList"]],
listArtworkList?: [{	filter?:ValueTypes["ArtworkListWhere"] | null,	orderBy?:ValueTypes["ArtworkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkList"]],
paginateArtworkList?: [{	filter?:ValueTypes["ArtworkListWhere"] | null,	orderBy?:ValueTypes["ArtworkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkListConnection"]],
validateCreateArtworkList?: [{	data:ValueTypes["ArtworkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	data:ValueTypes["ArtworkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelection"]],
listArtworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelection"]],
paginateArtworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionConnection"]],
validateCreateArtworkSelection?: [{	data:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	data:ValueTypes["ArtworkSelectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null},ValueTypes["ArtworkSelectionItem"]],
listArtworkSelectionItem?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionItem"]],
paginateArtworkSelectionItem?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionItemConnection"]],
validateCreateArtworkSelectionItem?: [{	data:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	data:ValueTypes["ArtworkSelectionItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionList"]],
listArtworkSelectionList?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionList"]],
paginateArtworkSelectionList?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionListConnection"]],
validateCreateArtworkSelectionList?: [{	data:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	data:ValueTypes["ArtworkSelectionListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
listArtworkSelectionLocale?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionLocale"]],
paginateArtworkSelectionLocale?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionLocaleConnection"]],
validateCreateArtworkSelectionLocale?: [{	data:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	data:ValueTypes["ArtworkSelectionLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null},ValueTypes["EventItem"]],
listEventItem?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventItem"]],
paginateEventItem?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventItemConnection"]],
validateCreateEventItem?: [{	data:ValueTypes["EventItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	data:ValueTypes["EventItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventList"]],
listEventList?: [{	filter?:ValueTypes["EventListWhere"] | null,	orderBy?:ValueTypes["EventListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventList"]],
paginateEventList?: [{	filter?:ValueTypes["EventListWhere"] | null,	orderBy?:ValueTypes["EventListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventListConnection"]],
validateCreateEventList?: [{	data:ValueTypes["EventListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	data:ValueTypes["EventListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null},ValueTypes["BoxItem"]],
listBoxItem?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BoxItem"]],
paginateBoxItem?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BoxItemConnection"]],
validateCreateBoxItem?: [{	data:ValueTypes["BoxItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	data:ValueTypes["BoxItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxList"]],
listBoxList?: [{	filter?:ValueTypes["BoxListWhere"] | null,	orderBy?:ValueTypes["BoxListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BoxList"]],
paginateBoxList?: [{	filter?:ValueTypes["BoxListWhere"] | null,	orderBy?:ValueTypes["BoxListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BoxListConnection"]],
validateCreateBoxList?: [{	data:ValueTypes["BoxListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	data:ValueTypes["BoxListUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterForm"]],
listNewsletterForm?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null,	orderBy?:ValueTypes["NewsletterFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterForm"]],
paginateNewsletterForm?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null,	orderBy?:ValueTypes["NewsletterFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormConnection"]],
validateCreateNewsletterForm?: [{	data:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	data:ValueTypes["NewsletterFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItem"]],
listNewsletterTypeItem?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterTypeItem"]],
paginateNewsletterTypeItem?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterTypeItemConnection"]],
validateCreateNewsletterTypeItem?: [{	data:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	data:ValueTypes["NewsletterTypeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
listNewsletterFormLocale?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterFormLocale"]],
paginateNewsletterFormLocale?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormLocaleConnection"]],
validateCreateNewsletterFormLocale?: [{	data:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	data:ValueTypes["NewsletterFormLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null},ValueTypes["NewsletterSubscription"]],
listNewsletterSubscription?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterSubscription"]],
paginateNewsletterSubscription?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterSubscriptionConnection"]],
validateCreateNewsletterSubscription?: [{	data:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	data:ValueTypes["NewsletterSubscriptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["Chart"]],
listChart?: [{	filter?:ValueTypes["ChartWhere"] | null,	orderBy?:ValueTypes["ChartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Chart"]],
paginateChart?: [{	filter?:ValueTypes["ChartWhere"] | null,	orderBy?:ValueTypes["ChartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ChartConnection"]],
validateCreateChart?: [{	data:ValueTypes["ChartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChart?: [{	by:ValueTypes["ChartUniqueWhere"],	data:ValueTypes["ChartUpdateInput"]},ValueTypes["_ValidationResult"]],
getChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null},ValueTypes["ChartData"]],
listChartData?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ChartData"]],
paginateChartData?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ChartDataConnection"]],
validateCreateChartData?: [{	data:ValueTypes["ChartDataCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	data:ValueTypes["ChartDataUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["Employee"]],
listEmployee?: [{	filter?:ValueTypes["EmployeeWhere"] | null,	orderBy?:ValueTypes["EmployeeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Employee"]],
paginateEmployee?: [{	filter?:ValueTypes["EmployeeWhere"] | null,	orderBy?:ValueTypes["EmployeeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeConnection"]],
validateCreateEmployee?: [{	data:ValueTypes["EmployeeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	data:ValueTypes["EmployeeUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null},ValueTypes["EmployeeItem"]],
listEmployeeItem?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeItem"]],
paginateEmployeeItem?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeItemConnection"]],
validateCreateEmployeeItem?: [{	data:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	data:ValueTypes["EmployeeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeList"]],
listEmployeeList?: [{	filter?:ValueTypes["EmployeeListWhere"] | null,	orderBy?:ValueTypes["EmployeeListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeList"]],
paginateEmployeeList?: [{	filter?:ValueTypes["EmployeeListWhere"] | null,	orderBy?:ValueTypes["EmployeeListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeListConnection"]],
validateCreateEmployeeList?: [{	data:ValueTypes["EmployeeListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	data:ValueTypes["EmployeeListUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocale"]],
listEmployeeLocale?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeLocale"]],
paginateEmployeeLocale?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeLocaleConnection"]],
validateCreateEmployeeLocale?: [{	data:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	data:ValueTypes["EmployeeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
listPhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
paginatePhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
validateCreatePhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null},ValueTypes["DefinitionItem"]],
listDefinitionItem?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DefinitionItem"]],
paginateDefinitionItem?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DefinitionItemConnection"]],
validateCreateDefinitionItem?: [{	data:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	data:ValueTypes["DefinitionItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionList"]],
listDefinitionList?: [{	filter?:ValueTypes["DefinitionListWhere"] | null,	orderBy?:ValueTypes["DefinitionListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DefinitionList"]],
paginateDefinitionList?: [{	filter?:ValueTypes["DefinitionListWhere"] | null,	orderBy?:ValueTypes["DefinitionListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DefinitionListConnection"]],
validateCreateDefinitionList?: [{	data:ValueTypes["DefinitionListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	data:ValueTypes["DefinitionListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null},ValueTypes["LogoItem"]],
listLogoItem?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LogoItem"]],
paginateLogoItem?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LogoItemConnection"]],
validateCreateLogoItem?: [{	data:ValueTypes["LogoItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	data:ValueTypes["LogoItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoList"]],
listLogoList?: [{	filter?:ValueTypes["LogoListWhere"] | null,	orderBy?:ValueTypes["LogoListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LogoList"]],
paginateLogoList?: [{	filter?:ValueTypes["LogoListWhere"] | null,	orderBy?:ValueTypes["LogoListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LogoListConnection"]],
validateCreateLogoList?: [{	data:ValueTypes["LogoListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	data:ValueTypes["LogoListUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null},ValueTypes["StrategySchema"]],
listStrategySchema?: [{	filter?:ValueTypes["StrategySchemaWhere"] | null,	orderBy?:ValueTypes["StrategySchemaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchema"]],
paginateStrategySchema?: [{	filter?:ValueTypes["StrategySchemaWhere"] | null,	orderBy?:ValueTypes["StrategySchemaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaConnection"]],
validateCreateStrategySchema?: [{	data:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	data:ValueTypes["StrategySchemaUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroup"]],
listStrategySchemaGroup?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchemaGroup"]],
paginateStrategySchemaGroup?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaGroupConnection"]],
validateCreateStrategySchemaGroup?: [{	data:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	data:ValueTypes["StrategySchemaGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null},ValueTypes["StrategySchemaGroupItem"]],
listStrategySchemaGroupItem?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchemaGroupItem"]],
paginateStrategySchemaGroupItem?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaGroupItemConnection"]],
validateCreateStrategySchemaGroupItem?: [{	data:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	data:ValueTypes["StrategySchemaGroupItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactForm"]],
listContactForm?: [{	filter?:ValueTypes["ContactFormWhere"] | null,	orderBy?:ValueTypes["ContactFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactForm"]],
paginateContactForm?: [{	filter?:ValueTypes["ContactFormWhere"] | null,	orderBy?:ValueTypes["ContactFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormConnection"]],
validateCreateContactForm?: [{	data:ValueTypes["ContactFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	data:ValueTypes["ContactFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
listContactFormLocale?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormLocale"]],
paginateContactFormLocale?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormLocaleConnection"]],
validateCreateContactFormLocale?: [{	data:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	data:ValueTypes["ContactFormLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null},ValueTypes["ContactSubscription"]],
listContactSubscription?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactSubscription"]],
paginateContactSubscription?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactSubscriptionConnection"]],
validateCreateContactSubscription?: [{	data:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	data:ValueTypes["ContactSubscriptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItem"]],
listContactTypeItem?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactTypeItem"]],
paginateContactTypeItem?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactTypeItemConnection"]],
validateCreateContactTypeItem?: [{	data:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	data:ValueTypes["ContactTypeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
listFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["File"]],
paginateFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by:ValueTypes["FileUniqueWhere"],	data:ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
	transaction?:ValueTypes["QueryTransaction"],
	_info?:ValueTypes["Info"],
	schema?:ValueTypes["_Schema"],
	s3DummyQuery?:true,
		__typename?: true
}>;
	["ContactPage"]: AliasType<{
	_meta?:ValueTypes["ContactPageMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPageLocale"]],
localesByLocale?: [{	by:ValueTypes["ContactPageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
localesByLink?: [{	by:ValueTypes["ContactPageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
localesBySeo?: [{	by:ValueTypes["ContactPageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
localesByAddressLink?: [{	by:ValueTypes["ContactPageLocalesByAddressLinkUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageLocaleConnection"]],
		__typename?: true
}>;
	["ContactPageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FieldMeta"]: AliasType<{
	readable?:true,
	updatable?:true,
		__typename?: true
}>;
	["UUID"]:string;
	["One"]:One;
	["ContactPageLocale"]: AliasType<{
	_meta?:ValueTypes["ContactPageLocaleMeta"],
	id?:true,
	title?:true,
root?: [{	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
	address?:true,
	phone?:true,
	email?:true,
	youtube?:true,
	instagram?:true,
	facebook?:true,
	databox?:true,
	databoxNumber?:true,
addressLink?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	socialsLabel?:true,
	openingHours?:true,
	identificationsLabel?:true,
	ico?:true,
	dic?:true,
	phoneLabel?:true,
	emailLabel?:true,
	linkedIn?:true,
	securities?:true,
	securitiesNumber?:true,
		__typename?: true
}>;
	["ContactPageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	youtube?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	facebook?:ValueTypes["FieldMeta"],
	databox?:ValueTypes["FieldMeta"],
	databoxNumber?:ValueTypes["FieldMeta"],
	addressLink?:ValueTypes["FieldMeta"],
	socialsLabel?:ValueTypes["FieldMeta"],
	openingHours?:ValueTypes["FieldMeta"],
	identificationsLabel?:ValueTypes["FieldMeta"],
	ico?:ValueTypes["FieldMeta"],
	dic?:ValueTypes["FieldMeta"],
	phoneLabel?:ValueTypes["FieldMeta"],
	emailLabel?:ValueTypes["FieldMeta"],
	linkedIn?:ValueTypes["FieldMeta"],
	securities?:ValueTypes["FieldMeta"],
	securitiesNumber?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactPageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["ContactPageLocaleWhere"] | null,
	and?:(ValueTypes["ContactPageWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactPageWhere"] | undefined | null)[],
	not?:ValueTypes["ContactPageWhere"] | null
};
	["UUIDCondition"]: {
	and?:ValueTypes["UUIDCondition"][],
	or?:ValueTypes["UUIDCondition"][],
	not?:ValueTypes["UUIDCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["UUID"] | null,
	notEq?:ValueTypes["UUID"] | null,
	in?:ValueTypes["UUID"][],
	notIn?:ValueTypes["UUID"][],
	lt?:ValueTypes["UUID"] | null,
	lte?:ValueTypes["UUID"] | null,
	gt?:ValueTypes["UUID"] | null,
	gte?:ValueTypes["UUID"] | null
};
	["OneCondition"]: {
	and?:ValueTypes["OneCondition"][],
	or?:ValueTypes["OneCondition"][],
	not?:ValueTypes["OneCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["One"] | null,
	notEq?:ValueTypes["One"] | null,
	in?:ValueTypes["One"][],
	notIn?:ValueTypes["One"][],
	lt?:ValueTypes["One"] | null,
	lte?:ValueTypes["One"] | null,
	gt?:ValueTypes["One"] | null,
	gte?:ValueTypes["One"] | null
};
	["ContactPageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["ContactPageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	address?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	youtube?:ValueTypes["StringCondition"] | null,
	instagram?:ValueTypes["StringCondition"] | null,
	facebook?:ValueTypes["StringCondition"] | null,
	databox?:ValueTypes["StringCondition"] | null,
	databoxNumber?:ValueTypes["StringCondition"] | null,
	addressLink?:ValueTypes["LinkWhere"] | null,
	socialsLabel?:ValueTypes["StringCondition"] | null,
	openingHours?:ValueTypes["StringCondition"] | null,
	identificationsLabel?:ValueTypes["StringCondition"] | null,
	ico?:ValueTypes["StringCondition"] | null,
	dic?:ValueTypes["StringCondition"] | null,
	phoneLabel?:ValueTypes["StringCondition"] | null,
	emailLabel?:ValueTypes["StringCondition"] | null,
	linkedIn?:ValueTypes["StringCondition"] | null,
	securities?:ValueTypes["StringCondition"] | null,
	securitiesNumber?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContactPageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactPageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["ContactPageLocaleWhere"] | null
};
	["StringCondition"]: {
	and?:ValueTypes["StringCondition"][],
	or?:ValueTypes["StringCondition"][],
	not?:ValueTypes["StringCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:string | null,
	notEq?:string | null,
	in?:string[],
	notIn?:string[],
	lt?:string | null,
	lte?:string | null,
	gt?:string | null,
	gte?:string | null,
	contains?:string | null,
	startsWith?:string | null,
	endsWith?:string | null,
	containsCI?:string | null,
	startsWithCI?:string | null,
	endsWithCI?:string | null
};
	["LocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	contactPages?:ValueTypes["ContactPageLocaleWhere"] | null,
	footers?:ValueTypes["FooterLocaleWhere"] | null,
	headers?:ValueTypes["HeaderLocaleWhere"] | null,
	homePages?:ValueTypes["HomePageLocaleWhere"] | null,
	pages?:ValueTypes["PageLocaleWhere"] | null,
	seoDefaults?:ValueTypes["SeoDefaultLocaleWhere"] | null,
	events?:ValueTypes["EventLocaleWhere"] | null,
	artworks?:ValueTypes["ArtworkLocaleWhere"] | null,
	artworkSelections?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,
	newsletterForms?:ValueTypes["NewsletterFormLocaleWhere"] | null,
	employees?:ValueTypes["EmployeeLocaleWhere"] | null,
	contactForms?:ValueTypes["ContactFormLocaleWhere"] | null,
	and?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["LocaleWhere"] | undefined | null)[],
	not?:ValueTypes["LocaleWhere"] | null
};
	["FooterLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	address?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	youtube?:ValueTypes["StringCondition"] | null,
	instagram?:ValueTypes["StringCondition"] | null,
	facebook?:ValueTypes["StringCondition"] | null,
	graphicDesign?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["FooterWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	graphicDesigners?:ValueTypes["GraphicDesignerWhere"] | null,
	developerLink?:ValueTypes["LinkWhere"] | null,
	development?:ValueTypes["StringCondition"] | null,
	linkedIn?:ValueTypes["StringCondition"] | null,
	photography?:ValueTypes["StringCondition"] | null,
	photographers?:ValueTypes["PhotographerWhere"] | null,
	and?:(ValueTypes["FooterLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["FooterLocaleWhere"] | null
};
	["FooterWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["FooterLocaleWhere"] | null,
	and?:(ValueTypes["FooterWhere"] | undefined | null)[],
	or?:(ValueTypes["FooterWhere"] | undefined | null)[],
	not?:ValueTypes["FooterWhere"] | null
};
	["ImageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	alt?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ImageWhere"] | undefined | null)[],
	or?:(ValueTypes["ImageWhere"] | undefined | null)[],
	not?:ValueTypes["ImageWhere"] | null
};
	["IntCondition"]: {
	and?:ValueTypes["IntCondition"][],
	or?:ValueTypes["IntCondition"][],
	not?:ValueTypes["IntCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["GraphicDesignerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["GraphicDesignerWhere"] | undefined | null)[],
	or?:(ValueTypes["GraphicDesignerWhere"] | undefined | null)[],
	not?:ValueTypes["GraphicDesignerWhere"] | null
};
	["LinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["LinkTypeCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	externalLink?:ValueTypes["StringCondition"] | null,
	internalLink?:ValueTypes["LinkableWhere"] | null,
	anchorLink?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["LinkWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkWhere"] | undefined | null)[],
	not?:ValueTypes["LinkWhere"] | null
};
	["LinkTypeCondition"]: {
	and?:ValueTypes["LinkTypeCondition"][],
	or?:ValueTypes["LinkTypeCondition"][],
	not?:ValueTypes["LinkTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["LinkType"] | null,
	notEq?:ValueTypes["LinkType"] | null,
	in?:ValueTypes["LinkType"][],
	notIn?:ValueTypes["LinkType"][],
	lt?:ValueTypes["LinkType"] | null,
	lte?:ValueTypes["LinkType"] | null,
	gt?:ValueTypes["LinkType"] | null,
	gte?:ValueTypes["LinkType"] | null
};
	["LinkType"]:LinkType;
	["LinkableWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	homePage?:ValueTypes["HomePageLocaleWhere"] | null,
	contactPage?:ValueTypes["ContactPageLocaleWhere"] | null,
	page?:ValueTypes["PageLocaleWhere"] | null,
	event?:ValueTypes["EventLocaleWhere"] | null,
	artwork?:ValueTypes["ArtworkLocaleWhere"] | null,
	artworkSelection?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,
	redirect?:ValueTypes["RedirectWhere"] | null,
	and?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	or?:(ValueTypes["LinkableWhere"] | undefined | null)[],
	not?:ValueTypes["LinkableWhere"] | null
};
	["HomePageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["HomePageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	branches?:ValueTypes["BranchesWhere"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["HomePageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageLocaleWhere"] | null
};
	["HomePageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["HomePageLocaleWhere"] | null,
	media?:ValueTypes["MediumListWhere"] | null,
	and?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	or?:(ValueTypes["HomePageWhere"] | undefined | null)[],
	not?:ValueTypes["HomePageWhere"] | null
};
	["MediumListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["MediumItemWhere"] | null,
	and?:(ValueTypes["MediumListWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumListWhere"] | undefined | null)[],
	not?:ValueTypes["MediumListWhere"] | null
};
	["MediumItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["MediumListWhere"] | null,
	medium?:ValueTypes["MediumWhere"] | null,
	and?:(ValueTypes["MediumItemWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumItemWhere"] | undefined | null)[],
	not?:ValueTypes["MediumItemWhere"] | null
};
	["MediumWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["MediumTypeCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	video?:ValueTypes["VideoWhere"] | null,
	youtubeEmbed?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["MediumWhere"] | undefined | null)[],
	or?:(ValueTypes["MediumWhere"] | undefined | null)[],
	not?:ValueTypes["MediumWhere"] | null
};
	["MediumTypeCondition"]: {
	and?:ValueTypes["MediumTypeCondition"][],
	or?:ValueTypes["MediumTypeCondition"][],
	not?:ValueTypes["MediumTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["MediumType"] | null,
	notEq?:ValueTypes["MediumType"] | null,
	in?:ValueTypes["MediumType"][],
	notIn?:ValueTypes["MediumType"][],
	lt?:ValueTypes["MediumType"] | null,
	lte?:ValueTypes["MediumType"] | null,
	gt?:ValueTypes["MediumType"] | null,
	gte?:ValueTypes["MediumType"] | null
};
	["MediumType"]:MediumType;
	["VideoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	src?:ValueTypes["StringCondition"] | null,
	width?:ValueTypes["IntCondition"] | null,
	height?:ValueTypes["IntCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	duration?:ValueTypes["FloatCondition"] | null,
	poster?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["VideoWhere"] | undefined | null)[],
	or?:(ValueTypes["VideoWhere"] | undefined | null)[],
	not?:ValueTypes["VideoWhere"] | null
};
	["FloatCondition"]: {
	and?:ValueTypes["FloatCondition"][],
	or?:ValueTypes["FloatCondition"][],
	not?:ValueTypes["FloatCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:number | null,
	notEq?:number | null,
	in?:number[],
	notIn?:number[],
	lt?:number | null,
	lte?:number | null,
	gt?:number | null,
	gte?:number | null
};
	["ContentWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	blocks?:ValueTypes["ContentBlockWhere"] | null,
	and?:(ValueTypes["ContentWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentWhere"] | undefined | null)[],
	not?:ValueTypes["ContentWhere"] | null
};
	["ContentBlockWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	json?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	references?:ValueTypes["ContentReferenceWhere"] | null,
	and?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentBlockWhere"] | undefined | null)[],
	not?:ValueTypes["ContentBlockWhere"] | null
};
	["ContentReferenceWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ContentReferenceTypeCondition"] | null,
	primaryText?:ValueTypes["StringCondition"] | null,
	block?:ValueTypes["ContentBlockWhere"] | null,
	media?:ValueTypes["MediumListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	secondaryText?:ValueTypes["StringCondition"] | null,
	dropDownList?:ValueTypes["DropDownListWhere"] | null,
	artworkSelection?:ValueTypes["ArtworkSelectionWhere"] | null,
	eventList?:ValueTypes["EventListWhere"] | null,
	boxList?:ValueTypes["BoxListWhere"] | null,
	isVisible?:ValueTypes["BooleanCondition"] | null,
	chart?:ValueTypes["ChartWhere"] | null,
	definitionList?:ValueTypes["DefinitionListWhere"] | null,
	logoList?:ValueTypes["LogoListWhere"] | null,
	strategySchema?:ValueTypes["StrategySchemaWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	employeeList?:ValueTypes["EmployeeListWhere"] | null,
	imageSecond?:ValueTypes["ImageWhere"] | null,
	contactForm?:ValueTypes["ContactFormWhere"] | null,
	newsletterForm?:ValueTypes["NewsletterFormWhere"] | null,
	and?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	or?:(ValueTypes["ContentReferenceWhere"] | undefined | null)[],
	not?:ValueTypes["ContentReferenceWhere"] | null
};
	["ContentReferenceTypeCondition"]: {
	and?:ValueTypes["ContentReferenceTypeCondition"][],
	or?:ValueTypes["ContentReferenceTypeCondition"][],
	not?:ValueTypes["ContentReferenceTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ContentReferenceType"] | null,
	notEq?:ValueTypes["ContentReferenceType"] | null,
	in?:ValueTypes["ContentReferenceType"][],
	notIn?:ValueTypes["ContentReferenceType"][],
	lt?:ValueTypes["ContentReferenceType"] | null,
	lte?:ValueTypes["ContentReferenceType"] | null,
	gt?:ValueTypes["ContentReferenceType"] | null,
	gte?:ValueTypes["ContentReferenceType"] | null
};
	["ContentReferenceType"]:ContentReferenceType;
	["DropDownListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["DropDownItemWhere"] | null,
	dropDownType?:ValueTypes["DropDownTypeCondition"] | null,
	employees?:ValueTypes["EmployeeListWhere"] | null,
	and?:(ValueTypes["DropDownListWhere"] | undefined | null)[],
	or?:(ValueTypes["DropDownListWhere"] | undefined | null)[],
	not?:ValueTypes["DropDownListWhere"] | null
};
	["DropDownItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["DropDownListWhere"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["DropDownItemWhere"] | undefined | null)[],
	or?:(ValueTypes["DropDownItemWhere"] | undefined | null)[],
	not?:ValueTypes["DropDownItemWhere"] | null
};
	["DropDownTypeCondition"]: {
	and?:ValueTypes["DropDownTypeCondition"][],
	or?:ValueTypes["DropDownTypeCondition"][],
	not?:ValueTypes["DropDownTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DropDownType"] | null,
	notEq?:ValueTypes["DropDownType"] | null,
	in?:ValueTypes["DropDownType"][],
	notIn?:ValueTypes["DropDownType"][],
	lt?:ValueTypes["DropDownType"] | null,
	lte?:ValueTypes["DropDownType"] | null,
	gt?:ValueTypes["DropDownType"] | null,
	gte?:ValueTypes["DropDownType"] | null
};
	["DropDownType"]:DropDownType;
	["EmployeeListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["EmployeeItemWhere"] | null,
	and?:(ValueTypes["EmployeeListWhere"] | undefined | null)[],
	or?:(ValueTypes["EmployeeListWhere"] | undefined | null)[],
	not?:ValueTypes["EmployeeListWhere"] | null
};
	["EmployeeItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["EmployeeListWhere"] | null,
	employee?:ValueTypes["EmployeeWhere"] | null,
	and?:(ValueTypes["EmployeeItemWhere"] | undefined | null)[],
	or?:(ValueTypes["EmployeeItemWhere"] | undefined | null)[],
	not?:ValueTypes["EmployeeItemWhere"] | null
};
	["EmployeeWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	locales?:ValueTypes["EmployeeLocaleWhere"] | null,
	and?:(ValueTypes["EmployeeWhere"] | undefined | null)[],
	or?:(ValueTypes["EmployeeWhere"] | undefined | null)[],
	not?:ValueTypes["EmployeeWhere"] | null
};
	["EmployeeLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	position?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["EmployeeWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	and?:(ValueTypes["EmployeeLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["EmployeeLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["EmployeeLocaleWhere"] | null
};
	["ArtworkSelectionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,
	artworks?:ValueTypes["ArtworkSelectionListWhere"] | null,
	and?:(ValueTypes["ArtworkSelectionWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkSelectionWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkSelectionWhere"] | null
};
	["ArtworkSelectionLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["ArtworkSelectionWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["ArtworkSelectionLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkSelectionLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkSelectionLocaleWhere"] | null
};
	["SeoWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	description?:ValueTypes["StringCondition"] | null,
	ogTitle?:ValueTypes["StringCondition"] | null,
	ogDescription?:ValueTypes["StringCondition"] | null,
	noIndex?:ValueTypes["BooleanCondition"] | null,
	noFollow?:ValueTypes["BooleanCondition"] | null,
	ogImage?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["SeoWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoWhere"] | undefined | null)[],
	not?:ValueTypes["SeoWhere"] | null
};
	["BooleanCondition"]: {
	and?:ValueTypes["BooleanCondition"][],
	or?:ValueTypes["BooleanCondition"][],
	not?:ValueTypes["BooleanCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:boolean | null,
	notEq?:boolean | null,
	in?:boolean[],
	notIn?:boolean[],
	lt?:boolean | null,
	lte?:boolean | null,
	gt?:boolean | null,
	gte?:boolean | null
};
	["ArtworkSelectionListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ArtworkSelectionItemWhere"] | null,
	and?:(ValueTypes["ArtworkSelectionListWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkSelectionListWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkSelectionListWhere"] | null
};
	["ArtworkSelectionItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ArtworkSelectionListWhere"] | null,
	artwork?:ValueTypes["ArtworkWhere"] | null,
	and?:(ValueTypes["ArtworkSelectionItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkSelectionItemWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkSelectionItemWhere"] | null
};
	["ArtworkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	locales?:ValueTypes["ArtworkLocaleWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	gallery?:ValueTypes["GalleryWhere"] | null,
	and?:(ValueTypes["ArtworkWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkWhere"] | null
};
	["ArtworkLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	label?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["ArtworkWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	artist?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ArtworkLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkLocaleWhere"] | null
};
	["GalleryWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["GalleryItemWhere"] | null,
	and?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryWhere"] | null
};
	["GalleryItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["GalleryWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	or?:(ValueTypes["GalleryItemWhere"] | undefined | null)[],
	not?:ValueTypes["GalleryItemWhere"] | null
};
	["EventListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["EventItemWhere"] | null,
	and?:(ValueTypes["EventListWhere"] | undefined | null)[],
	or?:(ValueTypes["EventListWhere"] | undefined | null)[],
	not?:ValueTypes["EventListWhere"] | null
};
	["EventItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["EventListWhere"] | null,
	event?:ValueTypes["EventWhere"] | null,
	and?:(ValueTypes["EventItemWhere"] | undefined | null)[],
	or?:(ValueTypes["EventItemWhere"] | undefined | null)[],
	not?:ValueTypes["EventItemWhere"] | null
};
	["EventWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	locales?:ValueTypes["EventLocaleWhere"] | null,
	order?:ValueTypes["IntCondition"] | null,
	dateStart?:ValueTypes["DateTimeCondition"] | null,
	dateFinish?:ValueTypes["DateTimeCondition"] | null,
	and?:(ValueTypes["EventWhere"] | undefined | null)[],
	or?:(ValueTypes["EventWhere"] | undefined | null)[],
	not?:ValueTypes["EventWhere"] | null
};
	["EventLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["EventWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	venue?:ValueTypes["StringCondition"] | null,
	venueNote?:ValueTypes["StringCondition"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	date?:ValueTypes["StringCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	isDark?:ValueTypes["BooleanCondition"] | null,
	and?:(ValueTypes["EventLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["EventLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["EventLocaleWhere"] | null
};
	["DateTimeCondition"]: {
	and?:ValueTypes["DateTimeCondition"][],
	or?:ValueTypes["DateTimeCondition"][],
	not?:ValueTypes["DateTimeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["DateTime"] | null,
	notEq?:ValueTypes["DateTime"] | null,
	in?:ValueTypes["DateTime"][],
	notIn?:ValueTypes["DateTime"][],
	lt?:ValueTypes["DateTime"] | null,
	lte?:ValueTypes["DateTime"] | null,
	gt?:ValueTypes["DateTime"] | null,
	gte?:ValueTypes["DateTime"] | null
};
	["DateTime"]:string;
	["BoxListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["BoxItemWhere"] | null,
	and?:(ValueTypes["BoxListWhere"] | undefined | null)[],
	or?:(ValueTypes["BoxListWhere"] | undefined | null)[],
	not?:ValueTypes["BoxListWhere"] | null
};
	["BoxItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["StringCondition"] | null,
	date?:ValueTypes["StringCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["BoxListWhere"] | null,
	and?:(ValueTypes["BoxItemWhere"] | undefined | null)[],
	or?:(ValueTypes["BoxItemWhere"] | undefined | null)[],
	not?:ValueTypes["BoxItemWhere"] | null
};
	["ChartWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	type?:ValueTypes["ChartTypeCondition"] | null,
	items?:ValueTypes["ChartDataWhere"] | null,
	and?:(ValueTypes["ChartWhere"] | undefined | null)[],
	or?:(ValueTypes["ChartWhere"] | undefined | null)[],
	not?:ValueTypes["ChartWhere"] | null
};
	["ChartTypeCondition"]: {
	and?:ValueTypes["ChartTypeCondition"][],
	or?:ValueTypes["ChartTypeCondition"][],
	not?:ValueTypes["ChartTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["ChartType"] | null,
	notEq?:ValueTypes["ChartType"] | null,
	in?:ValueTypes["ChartType"][],
	notIn?:ValueTypes["ChartType"][],
	lt?:ValueTypes["ChartType"] | null,
	lte?:ValueTypes["ChartType"] | null,
	gt?:ValueTypes["ChartType"] | null,
	gte?:ValueTypes["ChartType"] | null
};
	["ChartType"]:ChartType;
	["ChartDataWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ChartWhere"] | null,
	date?:ValueTypes["DateCondition"] | null,
	number?:ValueTypes["FloatCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["ChartDataWhere"] | undefined | null)[],
	or?:(ValueTypes["ChartDataWhere"] | undefined | null)[],
	not?:ValueTypes["ChartDataWhere"] | null
};
	["DateCondition"]: {
	and?:ValueTypes["DateCondition"][],
	or?:ValueTypes["DateCondition"][],
	not?:ValueTypes["DateCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["Date"] | null,
	notEq?:ValueTypes["Date"] | null,
	in?:ValueTypes["Date"][],
	notIn?:ValueTypes["Date"][],
	lt?:ValueTypes["Date"] | null,
	lte?:ValueTypes["Date"] | null,
	gt?:ValueTypes["Date"] | null,
	gte?:ValueTypes["Date"] | null
};
	["Date"]:string;
	["DefinitionListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["DefinitionItemWhere"] | null,
	and?:(ValueTypes["DefinitionListWhere"] | undefined | null)[],
	or?:(ValueTypes["DefinitionListWhere"] | undefined | null)[],
	not?:ValueTypes["DefinitionListWhere"] | null
};
	["DefinitionItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	key?:ValueTypes["StringCondition"] | null,
	value?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["DefinitionListWhere"] | null,
	and?:(ValueTypes["DefinitionItemWhere"] | undefined | null)[],
	or?:(ValueTypes["DefinitionItemWhere"] | undefined | null)[],
	not?:ValueTypes["DefinitionItemWhere"] | null
};
	["LogoListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["LogoItemWhere"] | null,
	and?:(ValueTypes["LogoListWhere"] | undefined | null)[],
	or?:(ValueTypes["LogoListWhere"] | undefined | null)[],
	not?:ValueTypes["LogoListWhere"] | null
};
	["LogoItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["LogoListWhere"] | null,
	image?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["LogoItemWhere"] | undefined | null)[],
	or?:(ValueTypes["LogoItemWhere"] | undefined | null)[],
	not?:ValueTypes["LogoItemWhere"] | null
};
	["StrategySchemaWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	inputFirst?:ValueTypes["StringCondition"] | null,
	inputSecond?:ValueTypes["StringCondition"] | null,
	inputThird?:ValueTypes["StringCondition"] | null,
	outputFirst?:ValueTypes["StringCondition"] | null,
	outputSecond?:ValueTypes["StringCondition"] | null,
	outputThird?:ValueTypes["StringCondition"] | null,
	itemsFirst?:ValueTypes["StrategySchemaGroupWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	itemsSecond?:ValueTypes["StrategySchemaGroupWhere"] | null,
	and?:(ValueTypes["StrategySchemaWhere"] | undefined | null)[],
	or?:(ValueTypes["StrategySchemaWhere"] | undefined | null)[],
	not?:ValueTypes["StrategySchemaWhere"] | null
};
	["StrategySchemaGroupWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["StrategySchemaGroupItemWhere"] | null,
	and?:(ValueTypes["StrategySchemaGroupWhere"] | undefined | null)[],
	or?:(ValueTypes["StrategySchemaGroupWhere"] | undefined | null)[],
	not?:ValueTypes["StrategySchemaGroupWhere"] | null
};
	["StrategySchemaGroupItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	text?:ValueTypes["StringCondition"] | null,
	schema?:ValueTypes["StrategySchemaGroupWhere"] | null,
	and?:(ValueTypes["StrategySchemaGroupItemWhere"] | undefined | null)[],
	or?:(ValueTypes["StrategySchemaGroupItemWhere"] | undefined | null)[],
	not?:ValueTypes["StrategySchemaGroupItemWhere"] | null
};
	["ContactFormWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["ContactFormLocaleWhere"] | null,
	and?:(ValueTypes["ContactFormWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactFormWhere"] | undefined | null)[],
	not?:ValueTypes["ContactFormWhere"] | null
};
	["ContactFormLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	message?:ValueTypes["StringCondition"] | null,
	submit?:ValueTypes["StringCondition"] | null,
	successMessage?:ValueTypes["StringCondition"] | null,
	genericErrorMessage?:ValueTypes["StringCondition"] | null,
	contactTypeErrorMessage?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["ContactFormWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	items?:ValueTypes["ContactTypeItemWhere"] | null,
	file?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["ContactFormLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactFormLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["ContactFormLocaleWhere"] | null
};
	["ContactTypeItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	subscriptions?:ValueTypes["ContactSubscriptionWhere"] | null,
	list?:ValueTypes["ContactFormLocaleWhere"] | null,
	and?:(ValueTypes["ContactTypeItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactTypeItemWhere"] | undefined | null)[],
	not?:ValueTypes["ContactTypeItemWhere"] | null
};
	["ContactSubscriptionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	phone?:ValueTypes["StringCondition"] | null,
	message?:ValueTypes["StringCondition"] | null,
	file?:ValueTypes["FileWhere"] | null,
	contactType?:ValueTypes["ContactTypeItemWhere"] | null,
	and?:(ValueTypes["ContactSubscriptionWhere"] | undefined | null)[],
	or?:(ValueTypes["ContactSubscriptionWhere"] | undefined | null)[],
	not?:ValueTypes["ContactSubscriptionWhere"] | null
};
	["FileWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	url?:ValueTypes["StringCondition"] | null,
	size?:ValueTypes["IntCondition"] | null,
	type?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["FileWhere"] | undefined | null)[],
	or?:(ValueTypes["FileWhere"] | undefined | null)[],
	not?:ValueTypes["FileWhere"] | null
};
	["NewsletterFormWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["NewsletterFormLocaleWhere"] | null,
	and?:(ValueTypes["NewsletterFormWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterFormWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterFormWhere"] | null
};
	["NewsletterFormLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	newsletterTypeNote?:ValueTypes["StringCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	emailNote?:ValueTypes["StringCondition"] | null,
	submit?:ValueTypes["StringCondition"] | null,
	root?:ValueTypes["NewsletterFormWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	items?:ValueTypes["NewsletterTypeItemWhere"] | null,
	title?:ValueTypes["StringCondition"] | null,
	successMessage?:ValueTypes["StringCondition"] | null,
	genericErrorMessage?:ValueTypes["StringCondition"] | null,
	newsletterTypeErrorMessage?:ValueTypes["StringCondition"] | null,
	and?:(ValueTypes["NewsletterFormLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterFormLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterFormLocaleWhere"] | null
};
	["NewsletterTypeItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	list?:ValueTypes["NewsletterFormLocaleWhere"] | null,
	subscriptions?:ValueTypes["NewsletterSubscriptionWhere"] | null,
	and?:(ValueTypes["NewsletterTypeItemWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterTypeItemWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterTypeItemWhere"] | null
};
	["NewsletterSubscriptionWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	createdAt?:ValueTypes["DateTimeCondition"] | null,
	email?:ValueTypes["StringCondition"] | null,
	newsletterType?:ValueTypes["NewsletterTypeItemWhere"] | null,
	and?:(ValueTypes["NewsletterSubscriptionWhere"] | undefined | null)[],
	or?:(ValueTypes["NewsletterSubscriptionWhere"] | undefined | null)[],
	not?:ValueTypes["NewsletterSubscriptionWhere"] | null
};
	["BranchesWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	leadParagraph?:ValueTypes["StringCondition"] | null,
	more?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["BranchesWhere"] | undefined | null)[],
	or?:(ValueTypes["BranchesWhere"] | undefined | null)[],
	not?:ValueTypes["BranchesWhere"] | null
};
	["PageLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	title?:ValueTypes["StringCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	root?:ValueTypes["PageWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	content?:ValueTypes["ContentWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["PageLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["PageLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["PageLocaleWhere"] | null
};
	["PageWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	locales?:ValueTypes["PageLocaleWhere"] | null,
	and?:(ValueTypes["PageWhere"] | undefined | null)[],
	or?:(ValueTypes["PageWhere"] | undefined | null)[],
	not?:ValueTypes["PageWhere"] | null
};
	["RedirectWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	link?:ValueTypes["LinkableWhere"] | null,
	target?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	or?:(ValueTypes["RedirectWhere"] | undefined | null)[],
	not?:ValueTypes["RedirectWhere"] | null
};
	["PhotographerWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["PhotographerWhere"] | undefined | null)[],
	or?:(ValueTypes["PhotographerWhere"] | undefined | null)[],
	not?:ValueTypes["PhotographerWhere"] | null
};
	["HeaderLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	root?:ValueTypes["HeaderWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	links?:ValueTypes["HeaderLinkWhere"] | null,
	artworkBreadcrumbParentLink?:ValueTypes["LinkableWhere"] | null,
	and?:(ValueTypes["HeaderLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderLocaleWhere"] | null
};
	["HeaderWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["HeaderLocaleWhere"] | null,
	logo?:ValueTypes["ImageWhere"] | null,
	and?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderWhere"] | null
};
	["HeaderLinkWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	link?:ValueTypes["LinkWhere"] | null,
	and?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	or?:(ValueTypes["HeaderLinkWhere"] | undefined | null)[],
	not?:ValueTypes["HeaderLinkWhere"] | null
};
	["SeoDefaultLocaleWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	root?:ValueTypes["SeoDefaultWhere"] | null,
	locale?:ValueTypes["LocaleWhere"] | null,
	seo?:ValueTypes["SeoWhere"] | null,
	and?:(ValueTypes["SeoDefaultLocaleWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoDefaultLocaleWhere"] | undefined | null)[],
	not?:ValueTypes["SeoDefaultLocaleWhere"] | null
};
	["SeoDefaultWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	unique?:ValueTypes["OneCondition"] | null,
	locales?:ValueTypes["SeoDefaultLocaleWhere"] | null,
	and?:(ValueTypes["SeoDefaultWhere"] | undefined | null)[],
	or?:(ValueTypes["SeoDefaultWhere"] | undefined | null)[],
	not?:ValueTypes["SeoDefaultWhere"] | null
};
	["Locale"]: AliasType<{
	_meta?:ValueTypes["LocaleMeta"],
	id?:true,
	code?:true,
	label?:true,
contactPages?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPageLocale"]],
footers?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
headers?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
homePages?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageLocale"]],
pages?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
seoDefaults?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefaultLocale"]],
events?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
artworks?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkLocale"]],
artworkSelections?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionLocale"]],
newsletterForms?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterFormLocale"]],
employees?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeLocale"]],
contactForms?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormLocale"]],
contactPagesByRoot?: [{	by:ValueTypes["LocaleContactPagesByRootUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
contactPagesByLink?: [{	by:ValueTypes["LocaleContactPagesByLinkUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
contactPagesBySeo?: [{	by:ValueTypes["LocaleContactPagesBySeoUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
contactPagesByAddressLink?: [{	by:ValueTypes["LocaleContactPagesByAddressLinkUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
footersByRoot?: [{	by:ValueTypes["LocaleFootersByRootUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
footersByDeveloperLink?: [{	by:ValueTypes["LocaleFootersByDeveloperLinkUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
headersByRoot?: [{	by:ValueTypes["LocaleHeadersByRootUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
headersByArtworkBreadcrumbParentLink?: [{	by:ValueTypes["LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
homePagesByRoot?: [{	by:ValueTypes["LocaleHomePagesByRootUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
homePagesByContent?: [{	by:ValueTypes["LocaleHomePagesByContentUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
homePagesByLink?: [{	by:ValueTypes["LocaleHomePagesByLinkUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
homePagesBySeo?: [{	by:ValueTypes["LocaleHomePagesBySeoUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
pagesByRoot?: [{	by:ValueTypes["LocalePagesByRootUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesByLink?: [{	by:ValueTypes["LocalePagesByLinkUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesByContent?: [{	by:ValueTypes["LocalePagesByContentUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
pagesBySeo?: [{	by:ValueTypes["LocalePagesBySeoUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
seoDefaultsByRoot?: [{	by:ValueTypes["LocaleSeoDefaultsByRootUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
seoDefaultsBySeo?: [{	by:ValueTypes["LocaleSeoDefaultsBySeoUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
eventsByRoot?: [{	by:ValueTypes["LocaleEventsByRootUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByImage?: [{	by:ValueTypes["LocaleEventsByImageUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsBySeo?: [{	by:ValueTypes["LocaleEventsBySeoUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByLink?: [{	by:ValueTypes["LocaleEventsByLinkUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
eventsByContent?: [{	by:ValueTypes["LocaleEventsByContentUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
artworksByRoot?: [{	by:ValueTypes["LocaleArtworksByRootUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
artworksByContent?: [{	by:ValueTypes["LocaleArtworksByContentUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
artworksBySeo?: [{	by:ValueTypes["LocaleArtworksBySeoUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
artworksByLink?: [{	by:ValueTypes["LocaleArtworksByLinkUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
artworkSelectionsByRoot?: [{	by:ValueTypes["LocaleArtworkSelectionsByRootUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
artworkSelectionsBySeo?: [{	by:ValueTypes["LocaleArtworkSelectionsBySeoUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
artworkSelectionsByLink?: [{	by:ValueTypes["LocaleArtworkSelectionsByLinkUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
newsletterFormsByRoot?: [{	by:ValueTypes["LocaleNewsletterFormsByRootUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
newsletterFormsByItems?: [{	by:ValueTypes["LocaleNewsletterFormsByItemsUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
employeesByRoot?: [{	by:ValueTypes["LocaleEmployeesByRootUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocale"]],
contactFormsByRoot?: [{	by:ValueTypes["LocaleContactFormsByRootUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
contactFormsByItems?: [{	by:ValueTypes["LocaleContactFormsByItemsUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
paginateContactPages?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageLocaleConnection"]],
paginateFooters?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
paginateHeaders?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
paginateHomePages?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageLocaleConnection"]],
paginatePages?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
paginateSeoDefaults?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultLocaleConnection"]],
paginateEvents?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
paginateArtworks?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkLocaleConnection"]],
paginateArtworkSelections?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionLocaleConnection"]],
paginateNewsletterForms?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormLocaleConnection"]],
paginateEmployees?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeLocaleConnection"]],
paginateContactForms?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormLocaleConnection"]],
		__typename?: true
}>;
	["LocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	contactPages?:ValueTypes["FieldMeta"],
	footers?:ValueTypes["FieldMeta"],
	headers?:ValueTypes["FieldMeta"],
	homePages?:ValueTypes["FieldMeta"],
	pages?:ValueTypes["FieldMeta"],
	seoDefaults?:ValueTypes["FieldMeta"],
	events?:ValueTypes["FieldMeta"],
	artworks?:ValueTypes["FieldMeta"],
	artworkSelections?:ValueTypes["FieldMeta"],
	newsletterForms?:ValueTypes["FieldMeta"],
	employees?:ValueTypes["FieldMeta"],
	contactForms?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactPageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["ContactPageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	address?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	youtube?:ValueTypes["OrderDirection"] | null,
	instagram?:ValueTypes["OrderDirection"] | null,
	facebook?:ValueTypes["OrderDirection"] | null,
	databox?:ValueTypes["OrderDirection"] | null,
	databoxNumber?:ValueTypes["OrderDirection"] | null,
	addressLink?:ValueTypes["LinkOrderBy"] | null,
	socialsLabel?:ValueTypes["OrderDirection"] | null,
	openingHours?:ValueTypes["OrderDirection"] | null,
	identificationsLabel?:ValueTypes["OrderDirection"] | null,
	ico?:ValueTypes["OrderDirection"] | null,
	dic?:ValueTypes["OrderDirection"] | null,
	phoneLabel?:ValueTypes["OrderDirection"] | null,
	emailLabel?:ValueTypes["OrderDirection"] | null,
	linkedIn?:ValueTypes["OrderDirection"] | null,
	securities?:ValueTypes["OrderDirection"] | null,
	securitiesNumber?:ValueTypes["OrderDirection"] | null
};
	["OrderDirection"]:OrderDirection;
	["ContactPageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["LocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null
};
	["LinkableOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	homePage?:ValueTypes["HomePageLocaleOrderBy"] | null,
	contactPage?:ValueTypes["ContactPageLocaleOrderBy"] | null,
	page?:ValueTypes["PageLocaleOrderBy"] | null,
	event?:ValueTypes["EventLocaleOrderBy"] | null,
	artwork?:ValueTypes["ArtworkLocaleOrderBy"] | null,
	artworkSelection?:ValueTypes["ArtworkSelectionLocaleOrderBy"] | null,
	redirect?:ValueTypes["RedirectOrderBy"] | null
};
	["HomePageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["HomePageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null
};
	["HomePageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	media?:ValueTypes["MediumListOrderBy"] | null
};
	["MediumListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ContentOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["SeoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	description?:ValueTypes["OrderDirection"] | null,
	ogTitle?:ValueTypes["OrderDirection"] | null,
	ogDescription?:ValueTypes["OrderDirection"] | null,
	noIndex?:ValueTypes["OrderDirection"] | null,
	noFollow?:ValueTypes["OrderDirection"] | null,
	ogImage?:ValueTypes["ImageOrderBy"] | null
};
	["ImageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	alt?:ValueTypes["OrderDirection"] | null
};
	["PageLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	root?:ValueTypes["PageOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["PageOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["EventLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["EventOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	venue?:ValueTypes["OrderDirection"] | null,
	venueNote?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	date?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	isDark?:ValueTypes["OrderDirection"] | null
};
	["EventOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	dateStart?:ValueTypes["OrderDirection"] | null,
	dateFinish?:ValueTypes["OrderDirection"] | null
};
	["ArtworkLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	label?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["ArtworkOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	content?:ValueTypes["ContentOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	artist?:ValueTypes["OrderDirection"] | null
};
	["ArtworkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	gallery?:ValueTypes["GalleryOrderBy"] | null
};
	["GalleryOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ArtworkSelectionLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["ArtworkSelectionOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null
};
	["ArtworkSelectionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	artworks?:ValueTypes["ArtworkSelectionListOrderBy"] | null
};
	["ArtworkSelectionListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["RedirectOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkableOrderBy"] | null,
	target?:ValueTypes["LinkableOrderBy"] | null
};
	["LinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	externalLink?:ValueTypes["OrderDirection"] | null,
	internalLink?:ValueTypes["LinkableOrderBy"] | null,
	anchorLink?:ValueTypes["OrderDirection"] | null
};
	["FooterLocale"]: AliasType<{
	_meta?:ValueTypes["FooterLocaleMeta"],
	id?:true,
	address?:true,
	phone?:true,
	email?:true,
	youtube?:true,
	instagram?:true,
	facebook?:true,
	graphicDesign?:true,
root?: [{	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
graphicDesigners?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GraphicDesigner"]],
developerLink?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	development?:true,
	linkedIn?:true,
	photography?:true,
photographers?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
paginateGraphicDesigners?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GraphicDesignerConnection"]],
paginatePhotographers?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
		__typename?: true
}>;
	["FooterLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	address?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	youtube?:ValueTypes["FieldMeta"],
	instagram?:ValueTypes["FieldMeta"],
	facebook?:ValueTypes["FieldMeta"],
	graphicDesign?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	graphicDesigners?:ValueTypes["FieldMeta"],
	developerLink?:ValueTypes["FieldMeta"],
	development?:ValueTypes["FieldMeta"],
	linkedIn?:ValueTypes["FieldMeta"],
	photography?:ValueTypes["FieldMeta"],
	photographers?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Footer"]: AliasType<{
	_meta?:ValueTypes["FooterMeta"],
	id?:true,
	unique?:true,
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
localesByLocale?: [{	by:ValueTypes["FooterLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
localesByDeveloperLink?: [{	by:ValueTypes["FooterLocalesByDeveloperLinkUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
paginateLocales?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
		__typename?: true
}>;
	["FooterMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Image"]: AliasType<{
	_meta?:ValueTypes["ImageMeta"],
	id?:true,
	url?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	alt?:true,
		__typename?: true
}>;
	["ImageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	alt?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["FooterLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	address?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	youtube?:ValueTypes["OrderDirection"] | null,
	instagram?:ValueTypes["OrderDirection"] | null,
	facebook?:ValueTypes["OrderDirection"] | null,
	graphicDesign?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["FooterOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	developerLink?:ValueTypes["LinkOrderBy"] | null,
	development?:ValueTypes["OrderDirection"] | null,
	linkedIn?:ValueTypes["OrderDirection"] | null,
	photography?:ValueTypes["OrderDirection"] | null
};
	["FooterOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["FooterLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["LocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	contactPages?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	footers?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	headers?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	homePages?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	pages?:ValueTypes["PageLocaleUniqueWhere"] | null,
	seoDefaults?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	events?:ValueTypes["EventLocaleUniqueWhere"] | null,
	artworks?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	artworkSelections?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	newsletterForms?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	employees?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	contactForms?:ValueTypes["ContactFormLocaleUniqueWhere"] | null
};
	["ContactPageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["ContactPageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	addressLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContactPageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactPageLocaleUniqueWhere"] | null
};
	["LinkableUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	contactPage?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	page?:ValueTypes["PageLocaleUniqueWhere"] | null,
	event?:ValueTypes["EventLocaleUniqueWhere"] | null,
	artwork?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	artworkSelection?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	redirect?:ValueTypes["RedirectUniqueWhere"] | null
};
	["HomePageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["HomePageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["HomePageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	media?:ValueTypes["MediumListUniqueWhere"] | null
};
	["MediumListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MediumItemUniqueWhere"] | null
};
	["MediumItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ContentUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentBlockUniqueWhere"] | null
};
	["ContentBlockUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentReferenceUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	media?:ValueTypes["MediumListUniqueWhere"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null,
	dropDownList?:ValueTypes["DropDownListUniqueWhere"] | null,
	eventList?:ValueTypes["EventListUniqueWhere"] | null,
	boxList?:ValueTypes["BoxListUniqueWhere"] | null,
	chart?:ValueTypes["ChartUniqueWhere"] | null,
	definitionList?:ValueTypes["DefinitionListUniqueWhere"] | null,
	logoList?:ValueTypes["LogoListUniqueWhere"] | null,
	strategySchema?:ValueTypes["StrategySchemaUniqueWhere"] | null,
	employeeList?:ValueTypes["EmployeeListUniqueWhere"] | null
};
	["LinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["DropDownListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["DropDownItemUniqueWhere"] | null,
	employees?:ValueTypes["EmployeeListUniqueWhere"] | null
};
	["DropDownItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["EmployeeListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["EmployeeItemUniqueWhere"] | null
};
	["EmployeeItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["EventListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["EventItemUniqueWhere"] | null
};
	["EventItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["BoxListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BoxItemUniqueWhere"] | null
};
	["BoxItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ChartUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ChartDataUniqueWhere"] | null
};
	["ChartDataUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["DefinitionListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["DefinitionItemUniqueWhere"] | null
};
	["DefinitionItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["LogoListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LogoItemUniqueWhere"] | null
};
	["LogoItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["StrategySchemaUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	itemsFirst?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	itemsSecond?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null
};
	["StrategySchemaGroupUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null
};
	["StrategySchemaGroupItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ImageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["SeoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	ogImage?:ValueTypes["ImageUniqueWhere"] | null
};
	["PageLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["PageUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["PageUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["PageLocaleUniqueWhere"] | null
};
	["EventLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EventUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["EventUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["EventLocaleUniqueWhere"] | null
};
	["ArtworkLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["ArtworkUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	content?:ValueTypes["ContentUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ArtworkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	gallery?:ValueTypes["GalleryUniqueWhere"] | null
};
	["GalleryUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryItemUniqueWhere"] | null
};
	["GalleryItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ArtworkSelectionLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["ArtworkSelectionUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ArtworkSelectionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	artworks?:ValueTypes["ArtworkSelectionListUniqueWhere"] | null
};
	["ArtworkSelectionListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null
};
	["ArtworkSelectionItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["RedirectUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["FooterLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["FooterUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	developerLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null,
	locales?:ValueTypes["FooterLocaleUniqueWhere"] | null
};
	["HeaderLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["HeaderUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	artworkBreadcrumbParentLink?:ValueTypes["LinkableUniqueWhere"] | null
};
	["HeaderUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	logo?:ValueTypes["ImageUniqueWhere"] | null
};
	["SeoDefaultLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SeoDefaultUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SeoDefaultUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null
};
	["NewsletterFormLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["NewsletterFormUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	items?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null
};
	["NewsletterFormUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null
};
	["NewsletterTypeItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	subscriptions?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null
};
	["NewsletterSubscriptionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["EmployeeLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["EmployeeUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["EmployeeUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	image?:ValueTypes["ImageUniqueWhere"] | null,
	locales?:ValueTypes["EmployeeLocaleUniqueWhere"] | null
};
	["ContactFormLocaleUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["ContactFormUniqueWhere"] | null,
	locale?:ValueTypes["LocaleUniqueWhere"] | null,
	items?:ValueTypes["ContactTypeItemUniqueWhere"] | null
};
	["ContactFormUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactFormLocaleUniqueWhere"] | null
};
	["ContactTypeItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	subscriptions?:ValueTypes["ContactSubscriptionUniqueWhere"] | null
};
	["ContactSubscriptionUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	file?:ValueTypes["FileUniqueWhere"] | null
};
	["FileUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["FooterLocalesByDeveloperLinkUniqueWhere"]: {
	developerLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["FooterLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterLocaleEdge"],
		__typename?: true
}>;
	["PageInfo"]: AliasType<{
	totalCount?:true,
		__typename?: true
}>;
	["FooterLocaleEdge"]: AliasType<{
	node?:ValueTypes["FooterLocale"],
		__typename?: true
}>;
	["GraphicDesigner"]: AliasType<{
	_meta?:ValueTypes["GraphicDesignerMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["GraphicDesignerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Link"]: AliasType<{
	_meta?:ValueTypes["LinkMeta"],
	id?:true,
	type?:true,
	title?:true,
	externalLink?:true,
internalLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	anchorLink?:true,
		__typename?: true
}>;
	["LinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	externalLink?:ValueTypes["FieldMeta"],
	internalLink?:ValueTypes["FieldMeta"],
	anchorLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Linkable"]: AliasType<{
	_meta?:ValueTypes["LinkableMeta"],
	id?:true,
	url?:true,
homePage?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
contactPage?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
page?: [{	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
event?: [{	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
artwork?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
artworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
redirect?: [{	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
		__typename?: true
}>;
	["LinkableMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	homePage?:ValueTypes["FieldMeta"],
	contactPage?:ValueTypes["FieldMeta"],
	page?:ValueTypes["FieldMeta"],
	event?:ValueTypes["FieldMeta"],
	artwork?:ValueTypes["FieldMeta"],
	artworkSelection?:ValueTypes["FieldMeta"],
	redirect?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HomePageLocale"]: AliasType<{
	_meta?:ValueTypes["HomePageLocaleMeta"],
	id?:true,
	title?:true,
root?: [{	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
branches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Branches"]],
	leadParagraph?:true,
paginateBranches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BranchesConnection"]],
		__typename?: true
}>;
	["HomePageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	branches?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HomePage"]: AliasType<{
	_meta?:ValueTypes["HomePageMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageLocale"]],
media?: [{	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumList"]],
localesByLocale?: [{	by:ValueTypes["HomePageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
localesByContent?: [{	by:ValueTypes["HomePageLocalesByContentUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
localesByLink?: [{	by:ValueTypes["HomePageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
localesBySeo?: [{	by:ValueTypes["HomePageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageLocaleConnection"]],
		__typename?: true
}>;
	["HomePageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	media?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MediumList"]: AliasType<{
	_meta?:ValueTypes["MediumListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumItem"]],
paginateItems?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumItemConnection"]],
		__typename?: true
}>;
	["MediumListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MediumItem"]: AliasType<{
	_meta?:ValueTypes["MediumItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumList"]],
medium?: [{	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
		__typename?: true
}>;
	["MediumItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	medium?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Medium"]: AliasType<{
	_meta?:ValueTypes["MediumMeta"],
	id?:true,
	type?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
video?: [{	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
	youtubeEmbed?:true,
		__typename?: true
}>;
	["MediumMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	video?:ValueTypes["FieldMeta"],
	youtubeEmbed?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Video"]: AliasType<{
	_meta?:ValueTypes["VideoMeta"],
	id?:true,
	src?:true,
	width?:true,
	height?:true,
	size?:true,
	type?:true,
	duration?:true,
poster?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["VideoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	src?:ValueTypes["FieldMeta"],
	width?:ValueTypes["FieldMeta"],
	height?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	duration?:ValueTypes["FieldMeta"],
	poster?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["MediumItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["MediumListOrderBy"] | null,
	medium?:ValueTypes["MediumOrderBy"] | null
};
	["MediumOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	video?:ValueTypes["VideoOrderBy"] | null,
	youtubeEmbed?:ValueTypes["OrderDirection"] | null
};
	["VideoOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	src?:ValueTypes["OrderDirection"] | null,
	width?:ValueTypes["OrderDirection"] | null,
	height?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	duration?:ValueTypes["OrderDirection"] | null,
	poster?:ValueTypes["ImageOrderBy"] | null
};
	["MediumItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumItemEdge"],
		__typename?: true
}>;
	["MediumItemEdge"]: AliasType<{
	node?:ValueTypes["MediumItem"],
		__typename?: true
}>;
	["HomePageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["HomePageLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["HomePageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["HomePageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["HomePageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageLocaleEdge"],
		__typename?: true
}>;
	["HomePageLocaleEdge"]: AliasType<{
	node?:ValueTypes["HomePageLocale"],
		__typename?: true
}>;
	["Content"]: AliasType<{
	_meta?:ValueTypes["ContentMeta"],
	id?:true,
blocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
blocksByReferences?: [{	by:ValueTypes["ContentBlocksByReferencesUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
paginateBlocks?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
		__typename?: true
}>;
	["ContentMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	blocks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentBlock"]: AliasType<{
	_meta?:ValueTypes["ContentBlockMeta"],
	id?:true,
	order?:true,
	json?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
references?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
referencesByMedia?: [{	by:ValueTypes["ContentBlockReferencesByMediaUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByLink?: [{	by:ValueTypes["ContentBlockReferencesByLinkUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByDropDownList?: [{	by:ValueTypes["ContentBlockReferencesByDropDownListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByEventList?: [{	by:ValueTypes["ContentBlockReferencesByEventListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByBoxList?: [{	by:ValueTypes["ContentBlockReferencesByBoxListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByChart?: [{	by:ValueTypes["ContentBlockReferencesByChartUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByDefinitionList?: [{	by:ValueTypes["ContentBlockReferencesByDefinitionListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByLogoList?: [{	by:ValueTypes["ContentBlockReferencesByLogoListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByStrategySchema?: [{	by:ValueTypes["ContentBlockReferencesByStrategySchemaUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
referencesByEmployeeList?: [{	by:ValueTypes["ContentBlockReferencesByEmployeeListUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
paginateReferences?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
		__typename?: true
}>;
	["ContentBlockMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	json?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	references?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContentReference"]: AliasType<{
	_meta?:ValueTypes["ContentReferenceMeta"],
	id?:true,
	type?:true,
	primaryText?:true,
block?: [{	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
media?: [{	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
	secondaryText?:true,
dropDownList?: [{	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownList"]],
artworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelection"]],
eventList?: [{	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventList"]],
boxList?: [{	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxList"]],
	isVisible?:true,
chart?: [{	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["Chart"]],
definitionList?: [{	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionList"]],
logoList?: [{	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoList"]],
strategySchema?: [{	filter?:ValueTypes["StrategySchemaWhere"] | null},ValueTypes["StrategySchema"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
employeeList?: [{	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeList"]],
imageSecond?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
contactForm?: [{	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactForm"]],
newsletterForm?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterForm"]],
		__typename?: true
}>;
	["ContentReferenceMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	primaryText?:ValueTypes["FieldMeta"],
	block?:ValueTypes["FieldMeta"],
	media?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	secondaryText?:ValueTypes["FieldMeta"],
	dropDownList?:ValueTypes["FieldMeta"],
	artworkSelection?:ValueTypes["FieldMeta"],
	eventList?:ValueTypes["FieldMeta"],
	boxList?:ValueTypes["FieldMeta"],
	isVisible?:ValueTypes["FieldMeta"],
	chart?:ValueTypes["FieldMeta"],
	definitionList?:ValueTypes["FieldMeta"],
	logoList?:ValueTypes["FieldMeta"],
	strategySchema?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	employeeList?:ValueTypes["FieldMeta"],
	imageSecond?:ValueTypes["FieldMeta"],
	contactForm?:ValueTypes["FieldMeta"],
	newsletterForm?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DropDownList"]: AliasType<{
	_meta?:ValueTypes["DropDownListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DropDownItem"]],
	dropDownType?:true,
employees?: [{	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeList"]],
itemsByLink?: [{	by:ValueTypes["DropDownListItemsByLinkUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null},ValueTypes["DropDownItem"]],
paginateItems?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DropDownItemConnection"]],
		__typename?: true
}>;
	["DropDownListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	dropDownType?:ValueTypes["FieldMeta"],
	employees?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DropDownItem"]: AliasType<{
	_meta?:ValueTypes["DropDownItemMeta"],
	id?:true,
	order?:true,
	title?:true,
	text?:true,
list?: [{	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownList"]],
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["DropDownItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DropDownItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["DropDownListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["DropDownListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	dropDownType?:ValueTypes["OrderDirection"] | null,
	employees?:ValueTypes["EmployeeListOrderBy"] | null
};
	["EmployeeListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["EmployeeList"]: AliasType<{
	_meta?:ValueTypes["EmployeeListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeItem"]],
paginateItems?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeItemConnection"]],
		__typename?: true
}>;
	["EmployeeListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EmployeeItem"]: AliasType<{
	_meta?:ValueTypes["EmployeeItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeList"]],
employee?: [{	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["Employee"]],
		__typename?: true
}>;
	["EmployeeItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	employee?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Employee"]: AliasType<{
	_meta?:ValueTypes["EmployeeMeta"],
	id?:true,
	order?:true,
	name?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
locales?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeLocale"]],
localesByLocale?: [{	by:ValueTypes["EmployeeLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocale"]],
paginateLocales?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeLocaleConnection"]],
		__typename?: true
}>;
	["EmployeeMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EmployeeLocale"]: AliasType<{
	_meta?:ValueTypes["EmployeeLocaleMeta"],
	id?:true,
	position?:true,
	text?:true,
	email?:true,
	phone?:true,
root?: [{	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["Employee"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
		__typename?: true
}>;
	["EmployeeLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	position?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EmployeeLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	position?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["EmployeeOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null
};
	["EmployeeOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["EmployeeLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["EmployeeLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeLocaleEdge"],
		__typename?: true
}>;
	["EmployeeLocaleEdge"]: AliasType<{
	node?:ValueTypes["EmployeeLocale"],
		__typename?: true
}>;
	["EmployeeItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["EmployeeListOrderBy"] | null,
	employee?:ValueTypes["EmployeeOrderBy"] | null
};
	["EmployeeItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeItemEdge"],
		__typename?: true
}>;
	["EmployeeItemEdge"]: AliasType<{
	node?:ValueTypes["EmployeeItem"],
		__typename?: true
}>;
	["DropDownListItemsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["DropDownItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DropDownItemEdge"],
		__typename?: true
}>;
	["DropDownItemEdge"]: AliasType<{
	node?:ValueTypes["DropDownItem"],
		__typename?: true
}>;
	["ArtworkSelection"]: AliasType<{
	_meta?:ValueTypes["ArtworkSelectionMeta"],
	id?:true,
	order?:true,
locales?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionLocale"]],
artworks?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionList"]],
localesByLocale?: [{	by:ValueTypes["ArtworkSelectionLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
localesBySeo?: [{	by:ValueTypes["ArtworkSelectionLocalesBySeoUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
localesByLink?: [{	by:ValueTypes["ArtworkSelectionLocalesByLinkUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
paginateLocales?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionLocaleConnection"]],
		__typename?: true
}>;
	["ArtworkSelectionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	artworks?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkSelectionLocale"]: AliasType<{
	_meta?:ValueTypes["ArtworkSelectionLocaleMeta"],
	id?:true,
	title?:true,
root?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelection"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["ArtworkSelectionLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Seo"]: AliasType<{
	_meta?:ValueTypes["SeoMeta"],
	id?:true,
	title?:true,
	description?:true,
	ogTitle?:true,
	ogDescription?:true,
	noIndex?:true,
	noFollow?:true,
ogImage?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["SeoMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	description?:ValueTypes["FieldMeta"],
	ogTitle?:ValueTypes["FieldMeta"],
	ogDescription?:ValueTypes["FieldMeta"],
	noIndex?:ValueTypes["FieldMeta"],
	noFollow?:ValueTypes["FieldMeta"],
	ogImage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkSelectionList"]: AliasType<{
	_meta?:ValueTypes["ArtworkSelectionListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionItem"]],
paginateItems?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionItemConnection"]],
		__typename?: true
}>;
	["ArtworkSelectionListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkSelectionItem"]: AliasType<{
	_meta?:ValueTypes["ArtworkSelectionItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionList"]],
artwork?: [{	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["Artwork"]],
		__typename?: true
}>;
	["ArtworkSelectionItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	artwork?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Artwork"]: AliasType<{
	_meta?:ValueTypes["ArtworkMeta"],
	id?:true,
	order?:true,
locales?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkLocale"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
gallery?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
localesByLocale?: [{	by:ValueTypes["ArtworkLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
localesByContent?: [{	by:ValueTypes["ArtworkLocalesByContentUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
localesBySeo?: [{	by:ValueTypes["ArtworkLocalesBySeoUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
localesByLink?: [{	by:ValueTypes["ArtworkLocalesByLinkUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
paginateLocales?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkLocaleConnection"]],
		__typename?: true
}>;
	["ArtworkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	gallery?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkLocale"]: AliasType<{
	_meta?:ValueTypes["ArtworkLocaleMeta"],
	id?:true,
	title?:true,
	label?:true,
	leadParagraph?:true,
root?: [{	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["Artwork"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	artist?:true,
		__typename?: true
}>;
	["ArtworkLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	label?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	artist?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Gallery"]: AliasType<{
	_meta?:ValueTypes["GalleryMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateItems?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
		__typename?: true
}>;
	["GalleryMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItem"]: AliasType<{
	_meta?:ValueTypes["GalleryItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["GalleryItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GalleryItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["GalleryOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["GalleryItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryItemEdge"],
		__typename?: true
}>;
	["GalleryItemEdge"]: AliasType<{
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["ArtworkLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["ArtworkLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["ArtworkLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ArtworkLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ArtworkLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkLocaleEdge"],
		__typename?: true
}>;
	["ArtworkLocaleEdge"]: AliasType<{
	node?:ValueTypes["ArtworkLocale"],
		__typename?: true
}>;
	["ArtworkSelectionItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ArtworkSelectionListOrderBy"] | null,
	artwork?:ValueTypes["ArtworkOrderBy"] | null
};
	["ArtworkSelectionItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkSelectionItemEdge"],
		__typename?: true
}>;
	["ArtworkSelectionItemEdge"]: AliasType<{
	node?:ValueTypes["ArtworkSelectionItem"],
		__typename?: true
}>;
	["ArtworkSelectionLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["ArtworkSelectionLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ArtworkSelectionLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ArtworkSelectionLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkSelectionLocaleEdge"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleEdge"]: AliasType<{
	node?:ValueTypes["ArtworkSelectionLocale"],
		__typename?: true
}>;
	["EventList"]: AliasType<{
	_meta?:ValueTypes["EventListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventItem"]],
paginateItems?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventItemConnection"]],
		__typename?: true
}>;
	["EventListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventItem"]: AliasType<{
	_meta?:ValueTypes["EventItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventList"]],
event?: [{	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
		__typename?: true
}>;
	["EventItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	event?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Event"]: AliasType<{
	_meta?:ValueTypes["EventMeta"],
	id?:true,
locales?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
	order?:true,
	dateStart?:true,
	dateFinish?:true,
localesByLocale?: [{	by:ValueTypes["EventLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByImage?: [{	by:ValueTypes["EventLocalesByImageUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesBySeo?: [{	by:ValueTypes["EventLocalesBySeoUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByLink?: [{	by:ValueTypes["EventLocalesByLinkUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
localesByContent?: [{	by:ValueTypes["EventLocalesByContentUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
paginateLocales?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
		__typename?: true
}>;
	["EventMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	dateStart?:ValueTypes["FieldMeta"],
	dateFinish?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLocale"]: AliasType<{
	_meta?:ValueTypes["EventLocaleMeta"],
	id?:true,
	title?:true,
root?: [{	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
	venue?:true,
	venueNote?:true,
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
	date?:true,
	leadParagraph?:true,
	isDark?:true,
		__typename?: true
}>;
	["EventLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	venue?:ValueTypes["FieldMeta"],
	venueNote?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	isDark?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["EventLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["EventLocalesByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["EventLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["EventLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["EventLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["EventLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventLocaleEdge"],
		__typename?: true
}>;
	["EventLocaleEdge"]: AliasType<{
	node?:ValueTypes["EventLocale"],
		__typename?: true
}>;
	["EventItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["EventListOrderBy"] | null,
	event?:ValueTypes["EventOrderBy"] | null
};
	["EventListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["EventItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventItemEdge"],
		__typename?: true
}>;
	["EventItemEdge"]: AliasType<{
	node?:ValueTypes["EventItem"],
		__typename?: true
}>;
	["BoxList"]: AliasType<{
	_meta?:ValueTypes["BoxListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BoxItem"]],
paginateItems?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BoxItemConnection"]],
		__typename?: true
}>;
	["BoxListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BoxItem"]: AliasType<{
	_meta?:ValueTypes["BoxItemMeta"],
	id?:true,
	order?:true,
	link?:true,
	date?:true,
	type?:true,
	title?:true,
	text?:true,
list?: [{	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxList"]],
		__typename?: true
}>;
	["BoxItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BoxItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["OrderDirection"] | null,
	date?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["BoxListOrderBy"] | null
};
	["BoxListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["BoxItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BoxItemEdge"],
		__typename?: true
}>;
	["BoxItemEdge"]: AliasType<{
	node?:ValueTypes["BoxItem"],
		__typename?: true
}>;
	["Chart"]: AliasType<{
	_meta?:ValueTypes["ChartMeta"],
	id?:true,
	type?:true,
items?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ChartData"]],
paginateItems?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ChartDataConnection"]],
		__typename?: true
}>;
	["ChartMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ChartData"]: AliasType<{
	_meta?:ValueTypes["ChartDataMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["Chart"]],
	date?:true,
	number?:true,
	text?:true,
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["ChartDataMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	date?:ValueTypes["FieldMeta"],
	number?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ChartDataOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ChartOrderBy"] | null,
	date?:ValueTypes["OrderDirection"] | null,
	number?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["ChartOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null
};
	["ChartDataConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ChartDataEdge"],
		__typename?: true
}>;
	["ChartDataEdge"]: AliasType<{
	node?:ValueTypes["ChartData"],
		__typename?: true
}>;
	["DefinitionList"]: AliasType<{
	_meta?:ValueTypes["DefinitionListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DefinitionItem"]],
paginateItems?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DefinitionItemConnection"]],
		__typename?: true
}>;
	["DefinitionListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DefinitionItem"]: AliasType<{
	_meta?:ValueTypes["DefinitionItemMeta"],
	id?:true,
	order?:true,
	key?:true,
	value?:true,
list?: [{	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionList"]],
		__typename?: true
}>;
	["DefinitionItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["DefinitionItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	key?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["DefinitionListOrderBy"] | null
};
	["DefinitionListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["DefinitionItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DefinitionItemEdge"],
		__typename?: true
}>;
	["DefinitionItemEdge"]: AliasType<{
	node?:ValueTypes["DefinitionItem"],
		__typename?: true
}>;
	["LogoList"]: AliasType<{
	_meta?:ValueTypes["LogoListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LogoItem"]],
paginateItems?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LogoItemConnection"]],
		__typename?: true
}>;
	["LogoListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LogoItem"]: AliasType<{
	_meta?:ValueTypes["LogoItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoList"]],
image?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
		__typename?: true
}>;
	["LogoItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	image?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["LogoItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["LogoListOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null
};
	["LogoListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["LogoItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LogoItemEdge"],
		__typename?: true
}>;
	["LogoItemEdge"]: AliasType<{
	node?:ValueTypes["LogoItem"],
		__typename?: true
}>;
	["StrategySchema"]: AliasType<{
	_meta?:ValueTypes["StrategySchemaMeta"],
	id?:true,
	inputFirst?:true,
	inputSecond?:true,
	inputThird?:true,
	outputFirst?:true,
	outputSecond?:true,
	outputThird?:true,
itemsFirst?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroup"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
itemsSecond?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroup"]],
		__typename?: true
}>;
	["StrategySchemaMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	inputFirst?:ValueTypes["FieldMeta"],
	inputSecond?:ValueTypes["FieldMeta"],
	inputThird?:ValueTypes["FieldMeta"],
	outputFirst?:ValueTypes["FieldMeta"],
	outputSecond?:ValueTypes["FieldMeta"],
	outputThird?:ValueTypes["FieldMeta"],
	itemsFirst?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
	itemsSecond?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StrategySchemaGroup"]: AliasType<{
	_meta?:ValueTypes["StrategySchemaGroupMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchemaGroupItem"]],
paginateItems?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaGroupItemConnection"]],
		__typename?: true
}>;
	["StrategySchemaGroupMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StrategySchemaGroupItem"]: AliasType<{
	_meta?:ValueTypes["StrategySchemaGroupItemMeta"],
	id?:true,
	order?:true,
	text?:true,
schema?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroup"]],
		__typename?: true
}>;
	["StrategySchemaGroupItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	text?:ValueTypes["FieldMeta"],
	schema?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["StrategySchemaGroupItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	text?:ValueTypes["OrderDirection"] | null,
	schema?:ValueTypes["StrategySchemaGroupOrderBy"] | null
};
	["StrategySchemaGroupOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["StrategySchemaGroupItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StrategySchemaGroupItemEdge"],
		__typename?: true
}>;
	["StrategySchemaGroupItemEdge"]: AliasType<{
	node?:ValueTypes["StrategySchemaGroupItem"],
		__typename?: true
}>;
	["ContactForm"]: AliasType<{
	_meta?:ValueTypes["ContactFormMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormLocale"]],
localesByLocale?: [{	by:ValueTypes["ContactFormLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
localesByItems?: [{	by:ValueTypes["ContactFormLocalesByItemsUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
paginateLocales?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormLocaleConnection"]],
		__typename?: true
}>;
	["ContactFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactFormLocale"]: AliasType<{
	_meta?:ValueTypes["ContactFormLocaleMeta"],
	id?:true,
	title?:true,
	name?:true,
	phone?:true,
	email?:true,
	message?:true,
	submit?:true,
	successMessage?:true,
	genericErrorMessage?:true,
	contactTypeErrorMessage?:true,
root?: [{	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactForm"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
items?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactTypeItem"]],
	file?:true,
itemsBySubscriptions?: [{	by:ValueTypes["ContactFormLocaleItemsBySubscriptionsUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItem"]],
paginateItems?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactTypeItemConnection"]],
		__typename?: true
}>;
	["ContactFormLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	submit?:ValueTypes["FieldMeta"],
	successMessage?:ValueTypes["FieldMeta"],
	genericErrorMessage?:ValueTypes["FieldMeta"],
	contactTypeErrorMessage?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	file?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactTypeItem"]: AliasType<{
	_meta?:ValueTypes["ContactTypeItemMeta"],
	id?:true,
	order?:true,
	title?:true,
subscriptions?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactSubscription"]],
list?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
subscriptionsByFile?: [{	by:ValueTypes["ContactTypeItemSubscriptionsByFileUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null},ValueTypes["ContactSubscription"]],
paginateSubscriptions?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactSubscriptionConnection"]],
		__typename?: true
}>;
	["ContactTypeItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	subscriptions?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactSubscription"]: AliasType<{
	_meta?:ValueTypes["ContactSubscriptionMeta"],
	id?:true,
	createdAt?:true,
	email?:true,
	name?:true,
	phone?:true,
	message?:true,
file?: [{	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
contactType?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItem"]],
		__typename?: true
}>;
	["ContactSubscriptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	phone?:ValueTypes["FieldMeta"],
	message?:ValueTypes["FieldMeta"],
	file?:ValueTypes["FieldMeta"],
	contactType?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["File"]: AliasType<{
	_meta?:ValueTypes["FileMeta"],
	id?:true,
	url?:true,
	size?:true,
	type?:true,
		__typename?: true
}>;
	["FileMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	url?:ValueTypes["FieldMeta"],
	size?:ValueTypes["FieldMeta"],
	type?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ContactSubscriptionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	message?:ValueTypes["OrderDirection"] | null,
	file?:ValueTypes["FileOrderBy"] | null,
	contactType?:ValueTypes["ContactTypeItemOrderBy"] | null
};
	["FileOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	url?:ValueTypes["OrderDirection"] | null,
	size?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null
};
	["ContactTypeItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ContactFormLocaleOrderBy"] | null
};
	["ContactFormLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	phone?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	message?:ValueTypes["OrderDirection"] | null,
	submit?:ValueTypes["OrderDirection"] | null,
	successMessage?:ValueTypes["OrderDirection"] | null,
	genericErrorMessage?:ValueTypes["OrderDirection"] | null,
	contactTypeErrorMessage?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["ContactFormOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	file?:ValueTypes["OrderDirection"] | null
};
	["ContactFormOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["ContactTypeItemSubscriptionsByFileUniqueWhere"]: {
	file?:ValueTypes["FileUniqueWhere"] | null
};
	["ContactSubscriptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactSubscriptionEdge"],
		__typename?: true
}>;
	["ContactSubscriptionEdge"]: AliasType<{
	node?:ValueTypes["ContactSubscription"],
		__typename?: true
}>;
	["ContactFormLocaleItemsBySubscriptionsUniqueWhere"]: {
	subscriptions?:ValueTypes["ContactSubscriptionUniqueWhere"] | null
};
	["ContactTypeItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactTypeItemEdge"],
		__typename?: true
}>;
	["ContactTypeItemEdge"]: AliasType<{
	node?:ValueTypes["ContactTypeItem"],
		__typename?: true
}>;
	["ContactFormLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["ContactFormLocalesByItemsUniqueWhere"]: {
	items?:ValueTypes["ContactTypeItemUniqueWhere"] | null
};
	["ContactFormLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactFormLocaleEdge"],
		__typename?: true
}>;
	["ContactFormLocaleEdge"]: AliasType<{
	node?:ValueTypes["ContactFormLocale"],
		__typename?: true
}>;
	["NewsletterForm"]: AliasType<{
	_meta?:ValueTypes["NewsletterFormMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterFormLocale"]],
localesByLocale?: [{	by:ValueTypes["NewsletterFormLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
localesByItems?: [{	by:ValueTypes["NewsletterFormLocalesByItemsUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
paginateLocales?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormLocaleConnection"]],
		__typename?: true
}>;
	["NewsletterFormMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["NewsletterFormLocale"]: AliasType<{
	_meta?:ValueTypes["NewsletterFormLocaleMeta"],
	id?:true,
	newsletterTypeNote?:true,
	email?:true,
	emailNote?:true,
	submit?:true,
root?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterForm"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
items?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterTypeItem"]],
	title?:true,
	successMessage?:true,
	genericErrorMessage?:true,
	newsletterTypeErrorMessage?:true,
itemsBySubscriptions?: [{	by:ValueTypes["NewsletterFormLocaleItemsBySubscriptionsUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItem"]],
paginateItems?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterTypeItemConnection"]],
		__typename?: true
}>;
	["NewsletterFormLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	newsletterTypeNote?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	emailNote?:ValueTypes["FieldMeta"],
	submit?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	successMessage?:ValueTypes["FieldMeta"],
	genericErrorMessage?:ValueTypes["FieldMeta"],
	newsletterTypeErrorMessage?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["NewsletterTypeItem"]: AliasType<{
	_meta?:ValueTypes["NewsletterTypeItemMeta"],
	id?:true,
	order?:true,
	title?:true,
list?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
subscriptions?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterSubscription"]],
paginateSubscriptions?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterSubscriptionConnection"]],
		__typename?: true
}>;
	["NewsletterTypeItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	subscriptions?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["NewsletterSubscription"]: AliasType<{
	_meta?:ValueTypes["NewsletterSubscriptionMeta"],
	id?:true,
	createdAt?:true,
	email?:true,
newsletterType?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItem"]],
		__typename?: true
}>;
	["NewsletterSubscriptionMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	createdAt?:ValueTypes["FieldMeta"],
	email?:ValueTypes["FieldMeta"],
	newsletterType?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["NewsletterSubscriptionOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	createdAt?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	newsletterType?:ValueTypes["NewsletterTypeItemOrderBy"] | null
};
	["NewsletterTypeItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["NewsletterFormLocaleOrderBy"] | null
};
	["NewsletterFormLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	newsletterTypeNote?:ValueTypes["OrderDirection"] | null,
	email?:ValueTypes["OrderDirection"] | null,
	emailNote?:ValueTypes["OrderDirection"] | null,
	submit?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["NewsletterFormOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	title?:ValueTypes["OrderDirection"] | null,
	successMessage?:ValueTypes["OrderDirection"] | null,
	genericErrorMessage?:ValueTypes["OrderDirection"] | null,
	newsletterTypeErrorMessage?:ValueTypes["OrderDirection"] | null
};
	["NewsletterFormOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["NewsletterSubscriptionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterSubscriptionEdge"],
		__typename?: true
}>;
	["NewsletterSubscriptionEdge"]: AliasType<{
	node?:ValueTypes["NewsletterSubscription"],
		__typename?: true
}>;
	["NewsletterFormLocaleItemsBySubscriptionsUniqueWhere"]: {
	subscriptions?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null
};
	["NewsletterTypeItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterTypeItemEdge"],
		__typename?: true
}>;
	["NewsletterTypeItemEdge"]: AliasType<{
	node?:ValueTypes["NewsletterTypeItem"],
		__typename?: true
}>;
	["NewsletterFormLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["NewsletterFormLocalesByItemsUniqueWhere"]: {
	items?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null
};
	["NewsletterFormLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterFormLocaleEdge"],
		__typename?: true
}>;
	["NewsletterFormLocaleEdge"]: AliasType<{
	node?:ValueTypes["NewsletterFormLocale"],
		__typename?: true
}>;
	["ContentReferenceOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	type?:ValueTypes["OrderDirection"] | null,
	primaryText?:ValueTypes["OrderDirection"] | null,
	block?:ValueTypes["ContentBlockOrderBy"] | null,
	media?:ValueTypes["MediumListOrderBy"] | null,
	link?:ValueTypes["LinkOrderBy"] | null,
	secondaryText?:ValueTypes["OrderDirection"] | null,
	dropDownList?:ValueTypes["DropDownListOrderBy"] | null,
	artworkSelection?:ValueTypes["ArtworkSelectionOrderBy"] | null,
	eventList?:ValueTypes["EventListOrderBy"] | null,
	boxList?:ValueTypes["BoxListOrderBy"] | null,
	isVisible?:ValueTypes["OrderDirection"] | null,
	chart?:ValueTypes["ChartOrderBy"] | null,
	definitionList?:ValueTypes["DefinitionListOrderBy"] | null,
	logoList?:ValueTypes["LogoListOrderBy"] | null,
	strategySchema?:ValueTypes["StrategySchemaOrderBy"] | null,
	image?:ValueTypes["ImageOrderBy"] | null,
	employeeList?:ValueTypes["EmployeeListOrderBy"] | null,
	imageSecond?:ValueTypes["ImageOrderBy"] | null,
	contactForm?:ValueTypes["ContactFormOrderBy"] | null,
	newsletterForm?:ValueTypes["NewsletterFormOrderBy"] | null
};
	["ContentBlockOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	json?:ValueTypes["OrderDirection"] | null,
	content?:ValueTypes["ContentOrderBy"] | null
};
	["StrategySchemaOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	inputFirst?:ValueTypes["OrderDirection"] | null,
	inputSecond?:ValueTypes["OrderDirection"] | null,
	inputThird?:ValueTypes["OrderDirection"] | null,
	outputFirst?:ValueTypes["OrderDirection"] | null,
	outputSecond?:ValueTypes["OrderDirection"] | null,
	outputThird?:ValueTypes["OrderDirection"] | null,
	itemsFirst?:ValueTypes["StrategySchemaGroupOrderBy"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null,
	itemsSecond?:ValueTypes["StrategySchemaGroupOrderBy"] | null
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
	media?:ValueTypes["MediumListUniqueWhere"] | null
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContentBlockReferencesByDropDownListUniqueWhere"]: {
	dropDownList?:ValueTypes["DropDownListUniqueWhere"] | null
};
	["ContentBlockReferencesByEventListUniqueWhere"]: {
	eventList?:ValueTypes["EventListUniqueWhere"] | null
};
	["ContentBlockReferencesByBoxListUniqueWhere"]: {
	boxList?:ValueTypes["BoxListUniqueWhere"] | null
};
	["ContentBlockReferencesByChartUniqueWhere"]: {
	chart?:ValueTypes["ChartUniqueWhere"] | null
};
	["ContentBlockReferencesByDefinitionListUniqueWhere"]: {
	definitionList?:ValueTypes["DefinitionListUniqueWhere"] | null
};
	["ContentBlockReferencesByLogoListUniqueWhere"]: {
	logoList?:ValueTypes["LogoListUniqueWhere"] | null
};
	["ContentBlockReferencesByStrategySchemaUniqueWhere"]: {
	strategySchema?:ValueTypes["StrategySchemaUniqueWhere"] | null
};
	["ContentBlockReferencesByEmployeeListUniqueWhere"]: {
	employeeList?:ValueTypes["EmployeeListUniqueWhere"] | null
};
	["ContentReferenceConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentReferenceEdge"],
		__typename?: true
}>;
	["ContentReferenceEdge"]: AliasType<{
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentBlocksByReferencesUniqueWhere"]: {
	references?:ValueTypes["ContentReferenceUniqueWhere"] | null
};
	["ContentBlockConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentBlockEdge"],
		__typename?: true
}>;
	["ContentBlockEdge"]: AliasType<{
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["Branches"]: AliasType<{
	_meta?:ValueTypes["BranchesMeta"],
	id?:true,
	order?:true,
	leadParagraph?:true,
	more?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["BranchesMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	leadParagraph?:ValueTypes["FieldMeta"],
	more?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["BranchesOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	leadParagraph?:ValueTypes["OrderDirection"] | null,
	more?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["BranchesConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BranchesEdge"],
		__typename?: true
}>;
	["BranchesEdge"]: AliasType<{
	node?:ValueTypes["Branches"],
		__typename?: true
}>;
	["PageLocale"]: AliasType<{
	_meta?:ValueTypes["PageLocaleMeta"],
	id?:true,
	title?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
root?: [{	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
content?: [{	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["PageLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	title?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	content?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Page"]: AliasType<{
	_meta?:ValueTypes["PageMeta"],
	id?:true,
locales?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
localesByLocale?: [{	by:ValueTypes["PageLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesByLink?: [{	by:ValueTypes["PageLocalesByLinkUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesByContent?: [{	by:ValueTypes["PageLocalesByContentUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
localesBySeo?: [{	by:ValueTypes["PageLocalesBySeoUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
paginateLocales?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
		__typename?: true
}>;
	["PageMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["PageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["PageLocalesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["PageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["PageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageLocaleEdge"],
		__typename?: true
}>;
	["PageLocaleEdge"]: AliasType<{
	node?:ValueTypes["PageLocale"],
		__typename?: true
}>;
	["Redirect"]: AliasType<{
	_meta?:ValueTypes["RedirectMeta"],
	id?:true,
link?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
target?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
		__typename?: true
}>;
	["RedirectMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
	target?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["GraphicDesignerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["Photographer"]: AliasType<{
	_meta?:ValueTypes["PhotographerMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["PhotographerMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["PhotographerOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["GraphicDesignerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GraphicDesignerEdge"],
		__typename?: true
}>;
	["GraphicDesignerEdge"]: AliasType<{
	node?:ValueTypes["GraphicDesigner"],
		__typename?: true
}>;
	["PhotographerConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PhotographerEdge"],
		__typename?: true
}>;
	["PhotographerEdge"]: AliasType<{
	node?:ValueTypes["Photographer"],
		__typename?: true
}>;
	["HeaderLocale"]: AliasType<{
	_meta?:ValueTypes["HeaderLocaleMeta"],
	id?:true,
root?: [{	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
links?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
artworkBreadcrumbParentLink?: [{	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
paginateLinks?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
		__typename?: true
}>;
	["HeaderLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	links?:ValueTypes["FieldMeta"],
	artworkBreadcrumbParentLink?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["Header"]: AliasType<{
	_meta?:ValueTypes["HeaderMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
logo?: [{	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
localesByLocale?: [{	by:ValueTypes["HeaderLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
localesByArtworkBreadcrumbParentLink?: [{	by:ValueTypes["HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
paginateLocales?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
		__typename?: true
}>;
	["HeaderMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
	logo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["HeaderOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	artworkBreadcrumbParentLink?:ValueTypes["LinkableOrderBy"] | null
};
	["HeaderOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null,
	logo?:ValueTypes["ImageOrderBy"] | null
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere"]: {
	artworkBreadcrumbParentLink?:ValueTypes["LinkableUniqueWhere"] | null
};
	["HeaderLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLocaleEdge"],
		__typename?: true
}>;
	["HeaderLocaleEdge"]: AliasType<{
	node?:ValueTypes["HeaderLocale"],
		__typename?: true
}>;
	["HeaderLink"]: AliasType<{
	_meta?:ValueTypes["HeaderLinkMeta"],
	id?:true,
	order?:true,
link?: [{	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
		__typename?: true
}>;
	["HeaderLinkMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	link?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["HeaderLinkOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	link?:ValueTypes["LinkOrderBy"] | null
};
	["HeaderLinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderLinkEdge"],
		__typename?: true
}>;
	["HeaderLinkEdge"]: AliasType<{
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["SeoDefaultLocale"]: AliasType<{
	_meta?:ValueTypes["SeoDefaultLocaleMeta"],
	id?:true,
root?: [{	filter?:ValueTypes["SeoDefaultWhere"] | null},ValueTypes["SeoDefault"]],
locale?: [{	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
seo?: [{	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
		__typename?: true
}>;
	["SeoDefaultLocaleMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	root?:ValueTypes["FieldMeta"],
	locale?:ValueTypes["FieldMeta"],
	seo?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SeoDefault"]: AliasType<{
	_meta?:ValueTypes["SeoDefaultMeta"],
	id?:true,
	unique?:true,
locales?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefaultLocale"]],
localesByLocale?: [{	by:ValueTypes["SeoDefaultLocalesByLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
localesBySeo?: [{	by:ValueTypes["SeoDefaultLocalesBySeoUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
paginateLocales?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultLocaleConnection"]],
		__typename?: true
}>;
	["SeoDefaultMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	unique?:ValueTypes["FieldMeta"],
	locales?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["SeoDefaultLocaleOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	root?:ValueTypes["SeoDefaultOrderBy"] | null,
	locale?:ValueTypes["LocaleOrderBy"] | null,
	seo?:ValueTypes["SeoOrderBy"] | null
};
	["SeoDefaultOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	unique?:ValueTypes["OrderDirection"] | null
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["SeoDefaultLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoDefaultLocaleEdge"],
		__typename?: true
}>;
	["SeoDefaultLocaleEdge"]: AliasType<{
	node?:ValueTypes["SeoDefaultLocale"],
		__typename?: true
}>;
	["LocaleContactPagesByRootUniqueWhere"]: {
	root?:ValueTypes["ContactPageUniqueWhere"] | null
};
	["LocaleContactPagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleContactPagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleContactPagesByAddressLinkUniqueWhere"]: {
	addressLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["LocaleFootersByRootUniqueWhere"]: {
	root?:ValueTypes["FooterUniqueWhere"] | null
};
	["LocaleFootersByDeveloperLinkUniqueWhere"]: {
	developerLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["LocaleHeadersByRootUniqueWhere"]: {
	root?:ValueTypes["HeaderUniqueWhere"] | null
};
	["LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere"]: {
	artworkBreadcrumbParentLink?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleHomePagesByRootUniqueWhere"]: {
	root?:ValueTypes["HomePageUniqueWhere"] | null
};
	["LocaleHomePagesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocalePagesByRootUniqueWhere"]: {
	root?:ValueTypes["PageUniqueWhere"] | null
};
	["LocalePagesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocalePagesByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocalePagesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
	root?:ValueTypes["SeoDefaultUniqueWhere"] | null
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleEventsByRootUniqueWhere"]: {
	root?:ValueTypes["EventUniqueWhere"] | null
};
	["LocaleEventsByImageUniqueWhere"]: {
	image?:ValueTypes["ImageUniqueWhere"] | null
};
	["LocaleEventsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleEventsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleEventsByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocaleArtworksByRootUniqueWhere"]: {
	root?:ValueTypes["ArtworkUniqueWhere"] | null
};
	["LocaleArtworksByContentUniqueWhere"]: {
	content?:ValueTypes["ContentUniqueWhere"] | null
};
	["LocaleArtworksBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleArtworksByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleArtworkSelectionsByRootUniqueWhere"]: {
	root?:ValueTypes["ArtworkSelectionUniqueWhere"] | null
};
	["LocaleArtworkSelectionsBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["LocaleArtworkSelectionsByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["LocaleNewsletterFormsByRootUniqueWhere"]: {
	root?:ValueTypes["NewsletterFormUniqueWhere"] | null
};
	["LocaleNewsletterFormsByItemsUniqueWhere"]: {
	items?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null
};
	["LocaleEmployeesByRootUniqueWhere"]: {
	root?:ValueTypes["EmployeeUniqueWhere"] | null
};
	["LocaleContactFormsByRootUniqueWhere"]: {
	root?:ValueTypes["ContactFormUniqueWhere"] | null
};
	["LocaleContactFormsByItemsUniqueWhere"]: {
	items?:ValueTypes["ContactTypeItemUniqueWhere"] | null
};
	["ContactPageLocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactPageLocaleEdge"],
		__typename?: true
}>;
	["ContactPageLocaleEdge"]: AliasType<{
	node?:ValueTypes["ContactPageLocale"],
		__typename?: true
}>;
	["ContactPageLocalesByLocaleUniqueWhere"]: {
	locale?:ValueTypes["LocaleUniqueWhere"] | null
};
	["ContactPageLocalesByLinkUniqueWhere"]: {
	link?:ValueTypes["LinkableUniqueWhere"] | null
};
	["ContactPageLocalesBySeoUniqueWhere"]: {
	seo?:ValueTypes["SeoUniqueWhere"] | null
};
	["ContactPageLocalesByAddressLinkUniqueWhere"]: {
	addressLink?:ValueTypes["LinkUniqueWhere"] | null
};
	["ContactPageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactPageEdge"],
		__typename?: true
}>;
	["ContactPageEdge"]: AliasType<{
	node?:ValueTypes["ContactPage"],
		__typename?: true
}>;
	["_ValidationResult"]: AliasType<{
	valid?:true,
	errors?:ValueTypes["_ValidationError"],
		__typename?: true
}>;
	["_ValidationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	message?:ValueTypes["_ValidationMessage"],
		__typename?: true
}>;
	["_PathFragment"]: AliasType<{		["...on _FieldPathFragment"] : ValueTypes["_FieldPathFragment"],
		["...on _IndexPathFragment"] : ValueTypes["_IndexPathFragment"]
		__typename?: true
}>;
	["_FieldPathFragment"]: AliasType<{
	field?:true,
		__typename?: true
}>;
	["_IndexPathFragment"]: AliasType<{
	index?:true,
	alias?:true,
		__typename?: true
}>;
	["_ValidationMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["ContactPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactPageCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactPageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["ContactPageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["ContactPageLocaleCreateLocaleEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleCreateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutContactPagesCreateInput"] | null
};
	["LocaleWithoutContactPagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateFootersEntityRelationInput"]: {
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	root?:ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleCreatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null
};
	["FooterWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ImageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterLocaleCreateGraphicDesignersEntityRelationInput"]: {
	connect?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	create?:ValueTypes["GraphicDesignerCreateInput"] | null,
	alias?:string | null
};
	["GraphicDesignerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["GraphicDesignerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["GraphicDesignerCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GraphicDesignerCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkCreateInternalLinkEntityRelationInput"] | null,
	anchorLink?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateHomePageEntityRelationInput"]: {
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	create?:ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | null
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleCreateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	create?:ValueTypes["HomePageWithoutLocalesCreateInput"] | null
};
	["HomePageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	media?:ValueTypes["HomePageCreateMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateMediaEntityRelationInput"]: {
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	create?:ValueTypes["MediumListCreateInput"] | null
};
	["MediumListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["MediumListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["MediumItemUniqueWhere"] | null,
	create?:ValueTypes["MediumItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["MediumItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	medium?:ValueTypes["MediumItemCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumItemCreateMediumEntityRelationInput"]: {
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["MediumUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["MediumCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["MediumType"] | null,
	image?:ValueTypes["MediumCreateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumCreateVideoEntityRelationInput"] | null,
	youtubeEmbed?:string | null,
	_dummy_field_?:boolean | null
};
	["MediumCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumCreateVideoEntityRelationInput"]: {
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["VideoUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["VideoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoCreatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoCreatePosterEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutHomePagesCreateInput"] | null
};
	["LocaleWithoutHomePagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateContactPagesEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["ContactPageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleCreateRootEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleCreateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	create?:ValueTypes["ContactPageWithoutLocalesCreateInput"] | null
};
	["ContactPageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutContactPageCreateInput"] | null
};
	["LinkableWithoutContactPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreatePageEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null
};
	["PageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["PageUniqueWhere"] | null,
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null
};
	["PageWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null
};
	["LocaleWithoutPagesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateHeadersEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["HeaderUniqueWhere"] | null,
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null
};
	["HeaderWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	alias?:string | null
};
	["HeaderLinkUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["HeaderLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["HeaderLinkCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	create?:ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleCreateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	blocks?:ValueTypes["ContentCreateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentCreateBlocksEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	alias?:string | null
};
	["ContentBlockWithoutContentCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	alias?:string | null
};
	["ContentReferenceWithoutBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	media?:ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	secondaryText?:string | null,
	dropDownList?:ValueTypes["ContentReferenceCreateDropDownListEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["ContentReferenceCreateArtworkSelectionEntityRelationInput"] | null,
	eventList?:ValueTypes["ContentReferenceCreateEventListEntityRelationInput"] | null,
	boxList?:ValueTypes["ContentReferenceCreateBoxListEntityRelationInput"] | null,
	isVisible?:boolean | null,
	chart?:ValueTypes["ContentReferenceCreateChartEntityRelationInput"] | null,
	definitionList?:ValueTypes["ContentReferenceCreateDefinitionListEntityRelationInput"] | null,
	logoList?:ValueTypes["ContentReferenceCreateLogoListEntityRelationInput"] | null,
	strategySchema?:ValueTypes["ContentReferenceCreateStrategySchemaEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	employeeList?:ValueTypes["ContentReferenceCreateEmployeeListEntityRelationInput"] | null,
	imageSecond?:ValueTypes["ContentReferenceCreateImageSecondEntityRelationInput"] | null,
	contactForm?:ValueTypes["ContentReferenceCreateContactFormEntityRelationInput"] | null,
	newsletterForm?:ValueTypes["ContentReferenceCreateNewsletterFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	create?:ValueTypes["MediumListCreateInput"] | null
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceCreateDropDownListEntityRelationInput"]: {
	connect?:ValueTypes["DropDownListUniqueWhere"] | null,
	create?:ValueTypes["DropDownListCreateInput"] | null
};
	["DropDownListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["DropDownListCreateItemsEntityRelationInput"][],
	dropDownType?:ValueTypes["DropDownType"] | null,
	employees?:ValueTypes["DropDownListCreateEmployeesEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["DropDownItemUniqueWhere"] | null,
	create?:ValueTypes["DropDownItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["DropDownItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	text?:string | null,
	link?:ValueTypes["DropDownItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["DropDownListCreateEmployeesEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	create?:ValueTypes["EmployeeListCreateInput"] | null
};
	["EmployeeListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["EmployeeListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EmployeeListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	create?:ValueTypes["EmployeeItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["EmployeeItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	employee?:ValueTypes["EmployeeItemCreateEmployeeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeItemCreateEmployeeEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeUniqueWhere"] | null,
	create?:ValueTypes["EmployeeCreateInput"] | null
};
	["EmployeeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	image?:ValueTypes["EmployeeCreateImageEntityRelationInput"] | null,
	locales?:ValueTypes["EmployeeCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EmployeeCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EmployeeCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	create?:ValueTypes["EmployeeLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["EmployeeLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	locale?:ValueTypes["EmployeeLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutEmployeesCreateInput"] | null
};
	["LocaleWithoutEmployeesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreatePagesEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["PageLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["LinkableWithoutPageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateContactPageEntityRelationInput"]: {
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutLinkCreateInput"] | null
};
	["ContactPageLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactPageLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleCreateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["SeoCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	ogImage?:ValueTypes["SeoCreateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoCreateOgImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContactPageLocaleCreateAddressLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkableCreateEventEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null
};
	["EventLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["EventUniqueWhere"] | null,
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null
};
	["EventWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	dateStart?:ValueTypes["DateTime"] | null,
	dateFinish?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null
};
	["LocaleWithoutEventsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
	connect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	create?:ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["SeoDefaultUniqueWhere"] | null,
	create?:ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | null
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LocaleCreateArtworksEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["ArtworkLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleCreateRootEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleCreateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkUniqueWhere"] | null,
	create?:ValueTypes["ArtworkWithoutLocalesCreateInput"] | null
};
	["ArtworkWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["ArtworkCreateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["ArtworkCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ArtworkCreateGalleryEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["GalleryCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["GalleryCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["GalleryItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ArtworkLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArtworkLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ArtworkLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutArtworkCreateInput"] | null
};
	["LinkableWithoutArtworkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateArtworkSelectionEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"] | null
};
	["ArtworkSelectionLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionWithoutLocalesCreateInput"] | null
};
	["ArtworkSelectionWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	artworks?:ValueTypes["ArtworkSelectionCreateArtworksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionCreateArtworksEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionListUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionListCreateInput"] | null
};
	["ArtworkSelectionListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ArtworkSelectionListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ArtworkSelectionItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	artwork?:ValueTypes["ArtworkSelectionItemCreateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemCreateArtworkEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkUniqueWhere"] | null,
	create?:ValueTypes["ArtworkCreateInput"] | null
};
	["ArtworkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["ArtworkCreateLocalesEntityRelationInput"][],
	image?:ValueTypes["ArtworkCreateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["ArtworkCreateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["ArtworkLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	locale?:ValueTypes["ArtworkLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleCreateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutArtworksCreateInput"] | null
};
	["LocaleWithoutArtworksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleCreateEventsEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["EventLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["EventLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["LinkableWithoutEventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateArtworkEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutLinkCreateInput"] | null
};
	["ArtworkLocaleWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleCreateSeoEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableCreateRedirectEntityRelationInput"]: {
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["RedirectWithoutLinkCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateTargetEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["EventLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LocaleCreateArtworkSelectionsEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["ArtworkSelectionLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ArtworkSelectionLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutArtworkSelectionCreateInput"] | null
};
	["LinkableWithoutArtworkSelectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LocaleCreateNewsletterFormsEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["NewsletterFormLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleCreateRootEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterFormUniqueWhere"] | null,
	create?:ValueTypes["NewsletterFormWithoutLocalesCreateInput"] | null
};
	["NewsletterFormWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	create?:ValueTypes["NewsletterTypeItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["NewsletterTypeItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	create?:ValueTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"] | null,
	alias?:string | null
};
	["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	_dummy_field_?:boolean | null
};
	["LocaleCreateEmployeesEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	create?:ValueTypes["EmployeeLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["EmployeeLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	root?:ValueTypes["EmployeeLocaleCreateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeUniqueWhere"] | null,
	create?:ValueTypes["EmployeeWithoutLocalesCreateInput"] | null
};
	["EmployeeWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	name?:string | null,
	image?:ValueTypes["EmployeeCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LocaleCreateContactFormsEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutLocaleCreateInput"] | null,
	alias?:string | null
};
	["ContactFormLocaleWithoutLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleCreateRootEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleCreateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleCreateRootEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormUniqueWhere"] | null,
	create?:ValueTypes["ContactFormWithoutLocalesCreateInput"] | null
};
	["ContactFormWithoutLocalesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	create?:ValueTypes["ContactTypeItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ContactTypeItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["ContactTypeItemCreateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactTypeItemCreateSubscriptionsEntityRelationInput"]: {
	connect?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	create?:ValueTypes["ContactSubscriptionWithoutContactTypeCreateInput"] | null,
	alias?:string | null
};
	["ContactSubscriptionWithoutContactTypeCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	name?:string | null,
	phone?:string | null,
	message?:string | null,
	file?:ValueTypes["ContactSubscriptionCreateFileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionCreateFileEntityRelationInput"]: {
	connect?:ValueTypes["FileUniqueWhere"] | null,
	create?:ValueTypes["FileCreateInput"] | null
};
	["FileCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	size?:number | null,
	type?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutArtworkSelectionsCreateInput"] | null
};
	["LocaleWithoutArtworkSelectionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PageLocaleCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ContentReferenceCreateArtworkSelectionEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionCreateInput"] | null
};
	["ArtworkSelectionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	locales?:ValueTypes["ArtworkSelectionCreateLocalesEntityRelationInput"][],
	artworks?:ValueTypes["ArtworkSelectionCreateArtworksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["ArtworkSelectionLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateEventListEntityRelationInput"]: {
	connect?:ValueTypes["EventListUniqueWhere"] | null,
	create?:ValueTypes["EventListCreateInput"] | null
};
	["EventListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["EventListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["EventItemUniqueWhere"] | null,
	create?:ValueTypes["EventItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["EventItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	event?:ValueTypes["EventItemCreateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemCreateEventEntityRelationInput"]: {
	connect?:ValueTypes["EventUniqueWhere"] | null,
	create?:ValueTypes["EventCreateInput"] | null
};
	["EventCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["EventCreateLocalesEntityRelationInput"][],
	order?:number | null,
	dateStart?:ValueTypes["DateTime"] | null,
	dateFinish?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["EventCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["EventLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBoxListEntityRelationInput"]: {
	connect?:ValueTypes["BoxListUniqueWhere"] | null,
	create?:ValueTypes["BoxListCreateInput"] | null
};
	["BoxListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["BoxListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BoxListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["BoxItemUniqueWhere"] | null,
	create?:ValueTypes["BoxItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["BoxItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:string | null,
	date?:string | null,
	type?:string | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateChartEntityRelationInput"]: {
	connect?:ValueTypes["ChartUniqueWhere"] | null,
	create?:ValueTypes["ChartCreateInput"] | null
};
	["ChartCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ChartType"] | null,
	items?:ValueTypes["ChartCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ChartCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ChartDataUniqueWhere"] | null,
	create?:ValueTypes["ChartDataWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ChartDataWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	date?:ValueTypes["Date"] | null,
	number?:number | null,
	text?:string | null,
	image?:ValueTypes["ChartDataCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateDefinitionListEntityRelationInput"]: {
	connect?:ValueTypes["DefinitionListUniqueWhere"] | null,
	create?:ValueTypes["DefinitionListCreateInput"] | null
};
	["DefinitionListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["DefinitionListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["DefinitionListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	create?:ValueTypes["DefinitionItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["DefinitionItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	key?:string | null,
	value?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateLogoListEntityRelationInput"]: {
	connect?:ValueTypes["LogoListUniqueWhere"] | null,
	create?:ValueTypes["LogoListCreateInput"] | null
};
	["LogoListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["LogoListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LogoListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["LogoItemUniqueWhere"] | null,
	create?:ValueTypes["LogoItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["LogoItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	image?:ValueTypes["LogoItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LogoItemCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateStrategySchemaEntityRelationInput"]: {
	connect?:ValueTypes["StrategySchemaUniqueWhere"] | null,
	create?:ValueTypes["StrategySchemaCreateInput"] | null
};
	["StrategySchemaCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	inputFirst?:string | null,
	inputSecond?:string | null,
	inputThird?:string | null,
	outputFirst?:string | null,
	outputSecond?:string | null,
	outputThird?:string | null,
	itemsFirst?:ValueTypes["StrategySchemaCreateItemsFirstEntityRelationInput"] | null,
	logo?:ValueTypes["StrategySchemaCreateLogoEntityRelationInput"] | null,
	itemsSecond?:ValueTypes["StrategySchemaCreateItemsSecondEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaCreateItemsFirstEntityRelationInput"]: {
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null
};
	["StrategySchemaGroupCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["StrategySchemaGroupCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	create?:ValueTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"] | null,
	alias?:string | null
};
	["StrategySchemaGroupItemWithoutSchemaCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaCreateLogoEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["StrategySchemaCreateItemsSecondEntityRelationInput"]: {
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateEmployeeListEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	create?:ValueTypes["EmployeeListCreateInput"] | null
};
	["ContentReferenceCreateImageSecondEntityRelationInput"]: {
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceCreateContactFormEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormUniqueWhere"] | null,
	create?:ValueTypes["ContactFormCreateInput"] | null
};
	["ContactFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactFormCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactFormCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["ContactFormLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	locale?:ValueTypes["ContactFormLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleCreateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutContactFormsCreateInput"] | null
};
	["LocaleWithoutContactFormsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateNewsletterFormEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterFormUniqueWhere"] | null,
	create?:ValueTypes["NewsletterFormCreateInput"] | null
};
	["NewsletterFormCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["NewsletterFormCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterFormCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["NewsletterFormLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	locale?:ValueTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutNewsletterFormsCreateInput"] | null
};
	["LocaleWithoutNewsletterFormsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["LinkableWithoutHomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableCreateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageLocaleCreateBranchesEntityRelationInput"]: {
	connect?:ValueTypes["BranchesUniqueWhere"] | null,
	create?:ValueTypes["BranchesCreateInput"] | null,
	alias?:string | null
};
	["BranchesUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["BranchesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	leadParagraph?:string | null,
	more?:string | null,
	link?:ValueTypes["BranchesCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BranchesCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLocaleCreateDeveloperLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLocaleCreatePhotographersEntityRelationInput"]: {
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	create?:ValueTypes["PhotographerCreateInput"] | null,
	alias?:string | null
};
	["PhotographerUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["LinkUniqueWhere"] | null
};
	["PhotographerCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:ValueTypes["PhotographerCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContactPageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactPageUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactPageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["ContactPageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["ContactPageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["ContactPageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["ContactPageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["ContactPageLocaleWithoutRootUpdateInput"] | null
};
	["ContactPageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleUpdateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutContactPagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutContactPagesUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutContactPagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateFootersEntityRelationInput"]: {
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateFootersRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertFootersRelationInput"] | null,
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateFootersRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	data?:ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | null
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	root?:ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleUpdatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["FooterWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["FooterUniqueWhere"] | null,
	delete?:boolean | null
};
	["FooterWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FooterUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["FooterUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ImageUpdateInput"]: {
	url?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	alt?:string | null,
	_dummy_field_?:boolean | null
};
	["FooterUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["FooterLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["FooterWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["FooterWithoutLocalesCreateInput"] | null
};
	["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]: {
	create?:ValueTypes["GraphicDesignerCreateInput"] | null,
	update?:ValueTypes["FooterLocaleUpdateGraphicDesignersRelationInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertGraphicDesignersRelationInput"] | null,
	connect?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	disconnect?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	delete?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	alias?:string | null
};
	["FooterLocaleUpdateGraphicDesignersRelationInput"]: {
	by?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	data?:ValueTypes["GraphicDesignerUpdateInput"] | null
};
	["GraphicDesignerUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["GraphicDesignerUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GraphicDesignerUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["GraphicDesignerUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkUpdateInput"]: {
	type?:ValueTypes["LinkType"] | null,
	title?:string | null,
	externalLink?:string | null,
	internalLink?:ValueTypes["LinkUpdateInternalLinkEntityRelationInput"] | null,
	anchorLink?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["LinkUpsertInternalLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
	create?:ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["HomePageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertHomePageRelationInput"] | null,
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleUpdateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["HomePageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["HomePageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["HomePageUniqueWhere"] | null,
	delete?:boolean | null
};
	["HomePageWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	media?:ValueTypes["HomePageUpdateMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateMediaEntityRelationInput"]: {
	create?:ValueTypes["MediumListCreateInput"] | null,
	update?:ValueTypes["MediumListUpdateInput"] | null,
	upsert?:ValueTypes["HomePageUpsertMediaRelationInput"] | null,
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumListUpdateInput"]: {
	items?:ValueTypes["MediumListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["MediumItemWithoutListCreateInput"] | null,
	update?:ValueTypes["MediumListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["MediumListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["MediumItemUniqueWhere"] | null,
	disconnect?:ValueTypes["MediumItemUniqueWhere"] | null,
	delete?:ValueTypes["MediumItemUniqueWhere"] | null,
	alias?:string | null
};
	["MediumListUpdateItemsRelationInput"]: {
	by?:ValueTypes["MediumItemUniqueWhere"] | null,
	data?:ValueTypes["MediumItemWithoutListUpdateInput"] | null
};
	["MediumItemWithoutListUpdateInput"]: {
	order?:number | null,
	medium?:ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
	create?:ValueTypes["MediumCreateInput"] | null,
	update?:ValueTypes["MediumUpdateInput"] | null,
	upsert?:ValueTypes["MediumItemUpsertMediumRelationInput"] | null,
	connect?:ValueTypes["MediumUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumUpdateInput"]: {
	type?:ValueTypes["MediumType"] | null,
	image?:ValueTypes["MediumUpdateImageEntityRelationInput"] | null,
	video?:ValueTypes["MediumUpdateVideoEntityRelationInput"] | null,
	youtubeEmbed?:string | null,
	_dummy_field_?:boolean | null
};
	["MediumUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumUpdateVideoEntityRelationInput"]: {
	create?:ValueTypes["VideoCreateInput"] | null,
	update?:ValueTypes["VideoUpdateInput"] | null,
	upsert?:ValueTypes["MediumUpsertVideoRelationInput"] | null,
	connect?:ValueTypes["VideoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpdateInput"]: {
	src?:string | null,
	width?:number | null,
	height?:number | null,
	size?:number | null,
	type?:string | null,
	duration?:number | null,
	poster?:ValueTypes["VideoUpdatePosterEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoUpdatePosterEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["VideoUpsertPosterRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["VideoUpsertPosterRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["MediumUpsertVideoRelationInput"]: {
	update?:ValueTypes["VideoUpdateInput"] | null,
	create?:ValueTypes["VideoCreateInput"] | null
};
	["MediumItemUpsertMediumRelationInput"]: {
	update?:ValueTypes["MediumUpdateInput"] | null,
	create?:ValueTypes["MediumCreateInput"] | null
};
	["MediumListUpsertItemsRelationInput"]: {
	by?:ValueTypes["MediumItemUniqueWhere"] | null,
	update?:ValueTypes["MediumItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["MediumItemWithoutListCreateInput"] | null
};
	["HomePageUpsertMediaRelationInput"]: {
	update?:ValueTypes["MediumListUpdateInput"] | null,
	create?:ValueTypes["MediumListCreateInput"] | null
};
	["HomePageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["HomePageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["HomePageWithoutLocalesCreateInput"] | null
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutHomePagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutHomePagesUpdateInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutHomePagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateContactPagesEntityRelationInput"]: {
	create?:ValueTypes["ContactPageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateContactPagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertContactPagesRelationInput"] | null,
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateContactPagesRelationInput"]: {
	by?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	data?:ValueTypes["ContactPageLocaleWithoutLocaleUpdateInput"] | null
};
	["ContactPageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleUpdateRootEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleUpdateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["ContactPageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["ContactPageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["ContactPageUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContactPageWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["ContactPageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["ContactPageWithoutLocalesCreateInput"] | null
};
	["ContactPageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutContactPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutContactPageUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutContactPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdatePageEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["PageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertPageRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["PageWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["PageUniqueWhere"] | null,
	delete?:boolean | null
};
	["PageWithoutLocalesUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["PageLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["PageWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["PageWithoutLocalesCreateInput"] | null
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutPagesUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutPagesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateHeadersRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertHeadersRelationInput"] | null,
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateHeadersRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	data?:ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | null
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
	root?:ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["HeaderWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["HeaderUniqueWhere"] | null,
	delete?:boolean | null
};
	["HeaderWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["HeaderLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["HeaderWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["HeaderWithoutLocalesCreateInput"] | null
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
	create?:ValueTypes["HeaderLinkCreateInput"] | null,
	update?:ValueTypes["HeaderLocaleUpdateLinksRelationInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertLinksRelationInput"] | null,
	connect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderLocaleUpdateLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	data?:ValueTypes["HeaderLinkUpdateInput"] | null
};
	["HeaderLinkUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["HeaderLinkUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLinkUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderLinkUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
	by?:ValueTypes["HeaderLinkUniqueWhere"] | null,
	update?:ValueTypes["HeaderLinkUpdateInput"] | null,
	create?:ValueTypes["HeaderLinkCreateInput"] | null
};
	["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LocaleUpsertHeadersRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	update?:ValueTypes["HeaderLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["HeaderLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
	create?:ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateHomePagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertHomePagesRelationInput"] | null,
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateHomePagesRelationInput"]: {
	by?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	data?:ValueTypes["HomePageLocaleWithoutLocaleUpdateInput"] | null
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleUpdateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentUpdateInput"]: {
	blocks?:ValueTypes["ContentUpdateBlocksEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentUpdateBlocksEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateBlocksRelationInput"] | null,
	upsert?:ValueTypes["ContentUpsertBlocksRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:ValueTypes["ContentBlockUniqueWhere"] | null,
	alias?:string | null
};
	["ContentUpdateBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	data?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null
};
	["ContentBlockWithoutContentUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null,
	update?:ValueTypes["ContentBlockUpdateReferencesRelationInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertReferencesRelationInput"] | null,
	connect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	disconnect?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	delete?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	alias?:string | null
};
	["ContentBlockUpdateReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	data?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	media?:ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	secondaryText?:string | null,
	dropDownList?:ValueTypes["ContentReferenceUpdateDropDownListEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["ContentReferenceUpdateArtworkSelectionEntityRelationInput"] | null,
	eventList?:ValueTypes["ContentReferenceUpdateEventListEntityRelationInput"] | null,
	boxList?:ValueTypes["ContentReferenceUpdateBoxListEntityRelationInput"] | null,
	isVisible?:boolean | null,
	chart?:ValueTypes["ContentReferenceUpdateChartEntityRelationInput"] | null,
	definitionList?:ValueTypes["ContentReferenceUpdateDefinitionListEntityRelationInput"] | null,
	logoList?:ValueTypes["ContentReferenceUpdateLogoListEntityRelationInput"] | null,
	strategySchema?:ValueTypes["ContentReferenceUpdateStrategySchemaEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	employeeList?:ValueTypes["ContentReferenceUpdateEmployeeListEntityRelationInput"] | null,
	imageSecond?:ValueTypes["ContentReferenceUpdateImageSecondEntityRelationInput"] | null,
	contactForm?:ValueTypes["ContentReferenceUpdateContactFormEntityRelationInput"] | null,
	newsletterForm?:ValueTypes["ContentReferenceUpdateNewsletterFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
	create?:ValueTypes["MediumListCreateInput"] | null,
	update?:ValueTypes["MediumListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertMediaRelationInput"] | null,
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertMediaRelationInput"]: {
	update?:ValueTypes["MediumListUpdateInput"] | null,
	create?:ValueTypes["MediumListCreateInput"] | null
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["ContentReferenceUpdateDropDownListEntityRelationInput"]: {
	create?:ValueTypes["DropDownListCreateInput"] | null,
	update?:ValueTypes["DropDownListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertDropDownListRelationInput"] | null,
	connect?:ValueTypes["DropDownListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DropDownListUpdateInput"]: {
	items?:ValueTypes["DropDownListUpdateItemsEntityRelationInput"][],
	dropDownType?:ValueTypes["DropDownType"] | null,
	employees?:ValueTypes["DropDownListUpdateEmployeesEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["DropDownItemWithoutListCreateInput"] | null,
	update?:ValueTypes["DropDownListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["DropDownListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["DropDownItemUniqueWhere"] | null,
	disconnect?:ValueTypes["DropDownItemUniqueWhere"] | null,
	delete?:ValueTypes["DropDownItemUniqueWhere"] | null,
	alias?:string | null
};
	["DropDownListUpdateItemsRelationInput"]: {
	by?:ValueTypes["DropDownItemUniqueWhere"] | null,
	data?:ValueTypes["DropDownItemWithoutListUpdateInput"] | null
};
	["DropDownItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	text?:string | null,
	link?:ValueTypes["DropDownItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["DropDownItemUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DropDownItemUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["DropDownListUpsertItemsRelationInput"]: {
	by?:ValueTypes["DropDownItemUniqueWhere"] | null,
	update?:ValueTypes["DropDownItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["DropDownItemWithoutListCreateInput"] | null
};
	["DropDownListUpdateEmployeesEntityRelationInput"]: {
	create?:ValueTypes["EmployeeListCreateInput"] | null,
	update?:ValueTypes["EmployeeListUpdateInput"] | null,
	upsert?:ValueTypes["DropDownListUpsertEmployeesRelationInput"] | null,
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EmployeeListUpdateInput"]: {
	items?:ValueTypes["EmployeeListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EmployeeListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["EmployeeItemWithoutListCreateInput"] | null,
	update?:ValueTypes["EmployeeListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["EmployeeListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	disconnect?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	delete?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	alias?:string | null
};
	["EmployeeListUpdateItemsRelationInput"]: {
	by?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	data?:ValueTypes["EmployeeItemWithoutListUpdateInput"] | null
};
	["EmployeeItemWithoutListUpdateInput"]: {
	order?:number | null,
	employee?:ValueTypes["EmployeeItemUpdateEmployeeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeItemUpdateEmployeeEntityRelationInput"]: {
	create?:ValueTypes["EmployeeCreateInput"] | null,
	update?:ValueTypes["EmployeeUpdateInput"] | null,
	upsert?:ValueTypes["EmployeeItemUpsertEmployeeRelationInput"] | null,
	connect?:ValueTypes["EmployeeUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EmployeeUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	image?:ValueTypes["EmployeeUpdateImageEntityRelationInput"] | null,
	locales?:ValueTypes["EmployeeUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EmployeeUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["EmployeeUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EmployeeUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EmployeeUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["EmployeeLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["EmployeeUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["EmployeeUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["EmployeeUpdateLocalesRelationInput"]: {
	by?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	data?:ValueTypes["EmployeeLocaleWithoutRootUpdateInput"] | null
};
	["EmployeeLocaleWithoutRootUpdateInput"]: {
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	locale?:ValueTypes["EmployeeLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutEmployeesCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutEmployeesUpdateInput"] | null,
	upsert?:ValueTypes["EmployeeLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutEmployeesUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdatePagesEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdatePagesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertPagesRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["PageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdatePagesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	data?:ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | null
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutPageUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateContactPageEntityRelationInput"]: {
	create?:ValueTypes["ContactPageLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ContactPageLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertContactPageRelationInput"] | null,
	connect?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleUpdateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpdateInput"]: {
	title?:string | null,
	description?:string | null,
	ogTitle?:string | null,
	ogDescription?:string | null,
	noIndex?:boolean | null,
	noFollow?:boolean | null,
	ogImage?:ValueTypes["SeoUpdateOgImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoUpdateOgImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["SeoUpsertOgImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoUpsertOgImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContactPageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ContactPageLocaleUpdateAddressLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["ContactPageLocaleUpsertAddressLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactPageLocaleUpsertAddressLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["LinkableUpsertContactPageRelationInput"]: {
	update?:ValueTypes["ContactPageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutLinkCreateInput"] | null
};
	["LinkableUpdateEventEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["EventLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertEventRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["EventWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["EventUniqueWhere"] | null,
	delete?:boolean | null
};
	["EventWithoutLocalesUpdateInput"]: {
	order?:number | null,
	dateStart?:ValueTypes["DateTime"] | null,
	dateFinish?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["EventWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["EventWithoutLocalesCreateInput"] | null
};
	["EventLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutEventsUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutEventsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
	create?:ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateSeoDefaultsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertSeoDefaultsRelationInput"] | null,
	connect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
	by?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	data?:ValueTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"] | null
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
	root?:ValueTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["SeoDefaultWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["SeoDefaultLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["SeoDefaultUniqueWhere"] | null,
	delete?:boolean | null
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["SeoDefaultWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["SeoDefaultWithoutLocalesCreateInput"] | null
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["SeoDefaultLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
	by?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	update?:ValueTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["SeoDefaultLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateArtworksEntityRelationInput"]: {
	create?:ValueTypes["ArtworkLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateArtworksRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertArtworksRelationInput"] | null,
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateArtworksRelationInput"]: {
	by?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	data?:ValueTypes["ArtworkLocaleWithoutLocaleUpdateInput"] | null
};
	["ArtworkLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleUpdateRootEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleUpdateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["ArtworkWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["ArtworkWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["ArtworkUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArtworkWithoutLocalesUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["ArtworkUpdateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["ArtworkUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ArtworkUpdateGalleryEntityRelationInput"]: {
	create?:ValueTypes["GalleryCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkUpsertGalleryRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryUpdateInput"]: {
	items?:ValueTypes["GalleryUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["GalleryUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null,
	update?:ValueTypes["GalleryUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["GalleryUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	disconnect?:ValueTypes["GalleryItemUniqueWhere"] | null,
	delete?:ValueTypes["GalleryItemUniqueWhere"] | null,
	alias?:string | null
};
	["GalleryUpdateItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	data?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null
};
	["GalleryItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["GalleryUpsertItemsRelationInput"]: {
	by?:ValueTypes["GalleryItemUniqueWhere"] | null,
	update?:ValueTypes["GalleryItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["GalleryItemWithoutListCreateInput"] | null
};
	["ArtworkUpsertGalleryRelationInput"]: {
	update?:ValueTypes["GalleryUpdateInput"] | null,
	create?:ValueTypes["GalleryCreateInput"] | null
};
	["ArtworkLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["ArtworkWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["ArtworkWithoutLocalesCreateInput"] | null
};
	["ArtworkLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["ArtworkLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ArtworkLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutArtworkCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutArtworkUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutArtworkUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateArtworkSelectionEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertArtworkSelectionRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkSelectionLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArtworkSelectionWithoutLocalesUpdateInput"]: {
	order?:number | null,
	artworks?:ValueTypes["ArtworkSelectionUpdateArtworksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionUpdateArtworksEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionListCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionListUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionUpsertArtworksRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkSelectionListUpdateInput"]: {
	items?:ValueTypes["ArtworkSelectionListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	alias?:string | null
};
	["ArtworkSelectionListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	data?:ValueTypes["ArtworkSelectionItemWithoutListUpdateInput"] | null
};
	["ArtworkSelectionItemWithoutListUpdateInput"]: {
	order?:number | null,
	artwork?:ValueTypes["ArtworkSelectionItemUpdateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemUpdateArtworkEntityRelationInput"]: {
	create?:ValueTypes["ArtworkCreateInput"] | null,
	update?:ValueTypes["ArtworkUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionItemUpsertArtworkRelationInput"] | null,
	connect?:ValueTypes["ArtworkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["ArtworkUpdateLocalesEntityRelationInput"][],
	image?:ValueTypes["ArtworkUpdateImageEntityRelationInput"] | null,
	gallery?:ValueTypes["ArtworkUpdateGalleryEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["ArtworkLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["ArtworkUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["ArtworkUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["ArtworkUpdateLocalesRelationInput"]: {
	by?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	data?:ValueTypes["ArtworkLocaleWithoutRootUpdateInput"] | null
};
	["ArtworkLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	locale?:ValueTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleUpdateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutArtworksCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutArtworksUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutArtworksUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateEventsEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateEventsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertEventsRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EventLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateEventsRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	data?:ValueTypes["EventLocaleWithoutLocaleUpdateInput"] | null
};
	["EventLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["EventLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["EventLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutEventUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpdateArtworkEntityRelationInput"]: {
	create?:ValueTypes["ArtworkLocaleWithoutLinkCreateInput"] | null,
	update?:ValueTypes["ArtworkLocaleWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertArtworkRelationInput"] | null,
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkLocaleWithoutLinkUpdateInput"]: {
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleUpdateSeoEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkableUpsertArtworkRelationInput"]: {
	update?:ValueTypes["ArtworkLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutLinkCreateInput"] | null
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null,
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	upsert?:ValueTypes["LinkableUpsertRedirectRelationInput"] | null,
	connect?:ValueTypes["RedirectUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["RedirectWithoutLinkUpdateInput"]: {
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateTargetEntityRelationInput"]: {
	create?:ValueTypes["LinkableCreateInput"] | null,
	update?:ValueTypes["LinkableUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertTargetRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null
};
	["RedirectUpsertTargetRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["LinkableUpsertRedirectRelationInput"]: {
	update?:ValueTypes["RedirectWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["RedirectWithoutLinkCreateInput"] | null
};
	["EventLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutEventUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutEventCreateInput"] | null
};
	["EventLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["EventLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["LocaleUpsertEventsRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	update?:ValueTypes["EventLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateArtworkSelectionsEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateArtworkSelectionsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertArtworkSelectionsRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateArtworkSelectionsRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	data?:ValueTypes["ArtworkSelectionLocaleWithoutLocaleUpdateInput"] | null
};
	["ArtworkSelectionLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkSelectionLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutArtworkSelectionCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutArtworkSelectionUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutArtworkSelectionUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutArtworkSelectionUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutArtworkSelectionCreateInput"] | null
};
	["LocaleUpsertArtworkSelectionsRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	update?:ValueTypes["ArtworkSelectionLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateNewsletterFormsEntityRelationInput"]: {
	create?:ValueTypes["NewsletterFormLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateNewsletterFormsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertNewsletterFormsRelationInput"] | null,
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	delete?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateNewsletterFormsRelationInput"]: {
	by?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	data?:ValueTypes["NewsletterFormLocaleWithoutLocaleUpdateInput"] | null
};
	["NewsletterFormLocaleWithoutLocaleUpdateInput"]: {
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["NewsletterFormWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["NewsletterFormWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["NewsletterFormLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["NewsletterFormUniqueWhere"] | null,
	delete?:boolean | null
};
	["NewsletterFormWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["NewsletterFormWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["NewsletterFormWithoutLocalesCreateInput"] | null
};
	["NewsletterFormLocaleUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["NewsletterTypeItemWithoutListCreateInput"] | null,
	update?:ValueTypes["NewsletterFormLocaleUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["NewsletterFormLocaleUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	disconnect?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	delete?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	alias?:string | null
};
	["NewsletterFormLocaleUpdateItemsRelationInput"]: {
	by?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	data?:ValueTypes["NewsletterTypeItemWithoutListUpdateInput"] | null
};
	["NewsletterTypeItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"]: {
	create?:ValueTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"] | null,
	update?:ValueTypes["NewsletterTypeItemUpdateSubscriptionsRelationInput"] | null,
	upsert?:ValueTypes["NewsletterTypeItemUpsertSubscriptionsRelationInput"] | null,
	connect?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	disconnect?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	delete?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	alias?:string | null
};
	["NewsletterTypeItemUpdateSubscriptionsRelationInput"]: {
	by?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	data?:ValueTypes["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"] | null
};
	["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemUpsertSubscriptionsRelationInput"]: {
	by?:ValueTypes["NewsletterSubscriptionUniqueWhere"] | null,
	update?:ValueTypes["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"] | null,
	create?:ValueTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"] | null
};
	["NewsletterFormLocaleUpsertItemsRelationInput"]: {
	by?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	update?:ValueTypes["NewsletterTypeItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["NewsletterTypeItemWithoutListCreateInput"] | null
};
	["LocaleUpsertNewsletterFormsRelationInput"]: {
	by?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	update?:ValueTypes["NewsletterFormLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateEmployeesEntityRelationInput"]: {
	create?:ValueTypes["EmployeeLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateEmployeesRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertEmployeesRelationInput"] | null,
	connect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateEmployeesRelationInput"]: {
	by?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	data?:ValueTypes["EmployeeLocaleWithoutLocaleUpdateInput"] | null
};
	["EmployeeLocaleWithoutLocaleUpdateInput"]: {
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	root?:ValueTypes["EmployeeLocaleUpdateRootEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["EmployeeWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["EmployeeWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["EmployeeLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["EmployeeUniqueWhere"] | null,
	delete?:boolean | null
};
	["EmployeeWithoutLocalesUpdateInput"]: {
	order?:number | null,
	name?:string | null,
	image?:ValueTypes["EmployeeUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["EmployeeWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["EmployeeWithoutLocalesCreateInput"] | null
};
	["LocaleUpsertEmployeesRelationInput"]: {
	by?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	update?:ValueTypes["EmployeeLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["EmployeeLocaleWithoutLocaleCreateInput"] | null
};
	["LocaleUpdateContactFormsEntityRelationInput"]: {
	create?:ValueTypes["ContactFormLocaleWithoutLocaleCreateInput"] | null,
	update?:ValueTypes["LocaleUpdateContactFormsRelationInput"] | null,
	upsert?:ValueTypes["LocaleUpsertContactFormsRelationInput"] | null,
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["LocaleUpdateContactFormsRelationInput"]: {
	by?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	data?:ValueTypes["ContactFormLocaleWithoutLocaleUpdateInput"] | null
};
	["ContactFormLocaleWithoutLocaleUpdateInput"]: {
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleUpdateRootEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleUpdateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleUpdateRootEntityRelationInput"]: {
	create?:ValueTypes["ContactFormWithoutLocalesCreateInput"] | null,
	update?:ValueTypes["ContactFormWithoutLocalesUpdateInput"] | null,
	upsert?:ValueTypes["ContactFormLocaleUpsertRootRelationInput"] | null,
	connect?:ValueTypes["ContactFormUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContactFormWithoutLocalesUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["ContactFormWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["ContactFormWithoutLocalesCreateInput"] | null
};
	["ContactFormLocaleUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ContactTypeItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ContactFormLocaleUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ContactFormLocaleUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	delete?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	alias?:string | null
};
	["ContactFormLocaleUpdateItemsRelationInput"]: {
	by?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	data?:ValueTypes["ContactTypeItemWithoutListUpdateInput"] | null
};
	["ContactTypeItemWithoutListUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["ContactTypeItemUpdateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactTypeItemUpdateSubscriptionsEntityRelationInput"]: {
	create?:ValueTypes["ContactSubscriptionWithoutContactTypeCreateInput"] | null,
	update?:ValueTypes["ContactTypeItemUpdateSubscriptionsRelationInput"] | null,
	upsert?:ValueTypes["ContactTypeItemUpsertSubscriptionsRelationInput"] | null,
	connect?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	delete?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	alias?:string | null
};
	["ContactTypeItemUpdateSubscriptionsRelationInput"]: {
	by?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	data?:ValueTypes["ContactSubscriptionWithoutContactTypeUpdateInput"] | null
};
	["ContactSubscriptionWithoutContactTypeUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	name?:string | null,
	phone?:string | null,
	message?:string | null,
	file?:ValueTypes["ContactSubscriptionUpdateFileEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionUpdateFileEntityRelationInput"]: {
	create?:ValueTypes["FileCreateInput"] | null,
	update?:ValueTypes["FileUpdateInput"] | null,
	upsert?:ValueTypes["ContactSubscriptionUpsertFileRelationInput"] | null,
	connect?:ValueTypes["FileUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FileUpdateInput"]: {
	url?:string | null,
	size?:number | null,
	type?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionUpsertFileRelationInput"]: {
	update?:ValueTypes["FileUpdateInput"] | null,
	create?:ValueTypes["FileCreateInput"] | null
};
	["ContactTypeItemUpsertSubscriptionsRelationInput"]: {
	by?:ValueTypes["ContactSubscriptionUniqueWhere"] | null,
	update?:ValueTypes["ContactSubscriptionWithoutContactTypeUpdateInput"] | null,
	create?:ValueTypes["ContactSubscriptionWithoutContactTypeCreateInput"] | null
};
	["ContactFormLocaleUpsertItemsRelationInput"]: {
	by?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	update?:ValueTypes["ContactTypeItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ContactTypeItemWithoutListCreateInput"] | null
};
	["LocaleUpsertContactFormsRelationInput"]: {
	by?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	update?:ValueTypes["ContactFormLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutLocaleCreateInput"] | null
};
	["ArtworkLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutArtworksUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutArtworksCreateInput"] | null
};
	["ArtworkUpsertLocalesRelationInput"]: {
	by?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	update?:ValueTypes["ArtworkLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutRootCreateInput"] | null
};
	["ArtworkSelectionItemUpsertArtworkRelationInput"]: {
	update?:ValueTypes["ArtworkUpdateInput"] | null,
	create?:ValueTypes["ArtworkCreateInput"] | null
};
	["ArtworkSelectionListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionItemUniqueWhere"] | null,
	update?:ValueTypes["ArtworkSelectionItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionItemWithoutListCreateInput"] | null
};
	["ArtworkSelectionUpsertArtworksRelationInput"]: {
	update?:ValueTypes["ArtworkSelectionListUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionListCreateInput"] | null
};
	["ArtworkSelectionLocaleUpsertRootRelationInput"]: {
	update?:ValueTypes["ArtworkSelectionWithoutLocalesUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionWithoutLocalesCreateInput"] | null
};
	["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutArtworkSelectionsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutArtworkSelectionsUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutArtworkSelectionsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutArtworkSelectionsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutArtworkSelectionsCreateInput"] | null
};
	["LinkableUpsertArtworkSelectionRelationInput"]: {
	update?:ValueTypes["ArtworkSelectionLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"] | null
};
	["ArtworkLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutArtworkUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutArtworkCreateInput"] | null
};
	["LocaleUpsertArtworksRelationInput"]: {
	by?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	update?:ValueTypes["ArtworkLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["ArtworkLocaleWithoutLocaleCreateInput"] | null
};
	["EventLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutEventsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutEventsCreateInput"] | null
};
	["LinkableUpsertEventRelationInput"]: {
	update?:ValueTypes["EventLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutLinkCreateInput"] | null
};
	["PageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutPageCreateInput"] | null
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentCreateInput"] | null,
	update?:ValueTypes["ContentUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["PageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["LocaleUpsertPagesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	update?:ValueTypes["PageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutLocaleCreateInput"] | null
};
	["EmployeeLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutEmployeesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutEmployeesCreateInput"] | null
};
	["EmployeeUpsertLocalesRelationInput"]: {
	by?:ValueTypes["EmployeeLocaleUniqueWhere"] | null,
	update?:ValueTypes["EmployeeLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["EmployeeLocaleWithoutRootCreateInput"] | null
};
	["EmployeeItemUpsertEmployeeRelationInput"]: {
	update?:ValueTypes["EmployeeUpdateInput"] | null,
	create?:ValueTypes["EmployeeCreateInput"] | null
};
	["EmployeeListUpsertItemsRelationInput"]: {
	by?:ValueTypes["EmployeeItemUniqueWhere"] | null,
	update?:ValueTypes["EmployeeItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["EmployeeItemWithoutListCreateInput"] | null
};
	["DropDownListUpsertEmployeesRelationInput"]: {
	update?:ValueTypes["EmployeeListUpdateInput"] | null,
	create?:ValueTypes["EmployeeListCreateInput"] | null
};
	["ContentReferenceUpsertDropDownListRelationInput"]: {
	update?:ValueTypes["DropDownListUpdateInput"] | null,
	create?:ValueTypes["DropDownListCreateInput"] | null
};
	["ContentReferenceUpdateArtworkSelectionEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertArtworkSelectionRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkSelectionUpdateInput"]: {
	order?:number | null,
	locales?:ValueTypes["ArtworkSelectionUpdateLocalesEntityRelationInput"][],
	artworks?:ValueTypes["ArtworkSelectionUpdateArtworksEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["ArtworkSelectionUpdateLocalesRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	data?:ValueTypes["ArtworkSelectionLocaleWithoutRootUpdateInput"] | null
};
	["ArtworkSelectionLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionUpsertLocalesRelationInput"]: {
	by?:ValueTypes["ArtworkSelectionLocaleUniqueWhere"] | null,
	update?:ValueTypes["ArtworkSelectionLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionLocaleWithoutRootCreateInput"] | null
};
	["ContentReferenceUpsertArtworkSelectionRelationInput"]: {
	update?:ValueTypes["ArtworkSelectionUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionCreateInput"] | null
};
	["ContentReferenceUpdateEventListEntityRelationInput"]: {
	create?:ValueTypes["EventListCreateInput"] | null,
	update?:ValueTypes["EventListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertEventListRelationInput"] | null,
	connect?:ValueTypes["EventListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventListUpdateInput"]: {
	items?:ValueTypes["EventListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["EventListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["EventItemWithoutListCreateInput"] | null,
	update?:ValueTypes["EventListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["EventListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["EventItemUniqueWhere"] | null,
	disconnect?:ValueTypes["EventItemUniqueWhere"] | null,
	delete?:ValueTypes["EventItemUniqueWhere"] | null,
	alias?:string | null
};
	["EventListUpdateItemsRelationInput"]: {
	by?:ValueTypes["EventItemUniqueWhere"] | null,
	data?:ValueTypes["EventItemWithoutListUpdateInput"] | null
};
	["EventItemWithoutListUpdateInput"]: {
	order?:number | null,
	event?:ValueTypes["EventItemUpdateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemUpdateEventEntityRelationInput"]: {
	create?:ValueTypes["EventCreateInput"] | null,
	update?:ValueTypes["EventUpdateInput"] | null,
	upsert?:ValueTypes["EventItemUpsertEventRelationInput"] | null,
	connect?:ValueTypes["EventUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EventUpdateInput"]: {
	locales?:ValueTypes["EventUpdateLocalesEntityRelationInput"][],
	order?:number | null,
	dateStart?:ValueTypes["DateTime"] | null,
	dateFinish?:ValueTypes["DateTime"] | null,
	_dummy_field_?:boolean | null
};
	["EventUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["EventUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["EventUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["EventLocaleUniqueWhere"] | null,
	delete?:ValueTypes["EventLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["EventUpdateLocalesRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	data?:ValueTypes["EventLocaleWithoutRootUpdateInput"] | null
};
	["EventLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventUpsertLocalesRelationInput"]: {
	by?:ValueTypes["EventLocaleUniqueWhere"] | null,
	update?:ValueTypes["EventLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["EventLocaleWithoutRootCreateInput"] | null
};
	["EventItemUpsertEventRelationInput"]: {
	update?:ValueTypes["EventUpdateInput"] | null,
	create?:ValueTypes["EventCreateInput"] | null
};
	["EventListUpsertItemsRelationInput"]: {
	by?:ValueTypes["EventItemUniqueWhere"] | null,
	update?:ValueTypes["EventItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["EventItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertEventListRelationInput"]: {
	update?:ValueTypes["EventListUpdateInput"] | null,
	create?:ValueTypes["EventListCreateInput"] | null
};
	["ContentReferenceUpdateBoxListEntityRelationInput"]: {
	create?:ValueTypes["BoxListCreateInput"] | null,
	update?:ValueTypes["BoxListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBoxListRelationInput"] | null,
	connect?:ValueTypes["BoxListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BoxListUpdateInput"]: {
	items?:ValueTypes["BoxListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["BoxListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["BoxItemWithoutListCreateInput"] | null,
	update?:ValueTypes["BoxListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["BoxListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["BoxItemUniqueWhere"] | null,
	disconnect?:ValueTypes["BoxItemUniqueWhere"] | null,
	delete?:ValueTypes["BoxItemUniqueWhere"] | null,
	alias?:string | null
};
	["BoxListUpdateItemsRelationInput"]: {
	by?:ValueTypes["BoxItemUniqueWhere"] | null,
	data?:ValueTypes["BoxItemWithoutListUpdateInput"] | null
};
	["BoxItemWithoutListUpdateInput"]: {
	order?:number | null,
	link?:string | null,
	date?:string | null,
	type?:string | null,
	title?:string | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["BoxListUpsertItemsRelationInput"]: {
	by?:ValueTypes["BoxItemUniqueWhere"] | null,
	update?:ValueTypes["BoxItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["BoxItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertBoxListRelationInput"]: {
	update?:ValueTypes["BoxListUpdateInput"] | null,
	create?:ValueTypes["BoxListCreateInput"] | null
};
	["ContentReferenceUpdateChartEntityRelationInput"]: {
	create?:ValueTypes["ChartCreateInput"] | null,
	update?:ValueTypes["ChartUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertChartRelationInput"] | null,
	connect?:ValueTypes["ChartUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ChartUpdateInput"]: {
	type?:ValueTypes["ChartType"] | null,
	items?:ValueTypes["ChartUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ChartUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ChartDataWithoutListCreateInput"] | null,
	update?:ValueTypes["ChartUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ChartUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ChartDataUniqueWhere"] | null,
	disconnect?:ValueTypes["ChartDataUniqueWhere"] | null,
	delete?:ValueTypes["ChartDataUniqueWhere"] | null,
	alias?:string | null
};
	["ChartUpdateItemsRelationInput"]: {
	by?:ValueTypes["ChartDataUniqueWhere"] | null,
	data?:ValueTypes["ChartDataWithoutListUpdateInput"] | null
};
	["ChartDataWithoutListUpdateInput"]: {
	order?:number | null,
	date?:ValueTypes["Date"] | null,
	number?:number | null,
	text?:string | null,
	image?:ValueTypes["ChartDataUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ChartDataUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ChartDataUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ChartUpsertItemsRelationInput"]: {
	by?:ValueTypes["ChartDataUniqueWhere"] | null,
	update?:ValueTypes["ChartDataWithoutListUpdateInput"] | null,
	create?:ValueTypes["ChartDataWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertChartRelationInput"]: {
	update?:ValueTypes["ChartUpdateInput"] | null,
	create?:ValueTypes["ChartCreateInput"] | null
};
	["ContentReferenceUpdateDefinitionListEntityRelationInput"]: {
	create?:ValueTypes["DefinitionListCreateInput"] | null,
	update?:ValueTypes["DefinitionListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertDefinitionListRelationInput"] | null,
	connect?:ValueTypes["DefinitionListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["DefinitionListUpdateInput"]: {
	items?:ValueTypes["DefinitionListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["DefinitionListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["DefinitionItemWithoutListCreateInput"] | null,
	update?:ValueTypes["DefinitionListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["DefinitionListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	disconnect?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	delete?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	alias?:string | null
};
	["DefinitionListUpdateItemsRelationInput"]: {
	by?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	data?:ValueTypes["DefinitionItemWithoutListUpdateInput"] | null
};
	["DefinitionItemWithoutListUpdateInput"]: {
	order?:number | null,
	key?:string | null,
	value?:string | null,
	_dummy_field_?:boolean | null
};
	["DefinitionListUpsertItemsRelationInput"]: {
	by?:ValueTypes["DefinitionItemUniqueWhere"] | null,
	update?:ValueTypes["DefinitionItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["DefinitionItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertDefinitionListRelationInput"]: {
	update?:ValueTypes["DefinitionListUpdateInput"] | null,
	create?:ValueTypes["DefinitionListCreateInput"] | null
};
	["ContentReferenceUpdateLogoListEntityRelationInput"]: {
	create?:ValueTypes["LogoListCreateInput"] | null,
	update?:ValueTypes["LogoListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertLogoListRelationInput"] | null,
	connect?:ValueTypes["LogoListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LogoListUpdateInput"]: {
	items?:ValueTypes["LogoListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LogoListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["LogoItemWithoutListCreateInput"] | null,
	update?:ValueTypes["LogoListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["LogoListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["LogoItemUniqueWhere"] | null,
	disconnect?:ValueTypes["LogoItemUniqueWhere"] | null,
	delete?:ValueTypes["LogoItemUniqueWhere"] | null,
	alias?:string | null
};
	["LogoListUpdateItemsRelationInput"]: {
	by?:ValueTypes["LogoItemUniqueWhere"] | null,
	data?:ValueTypes["LogoItemWithoutListUpdateInput"] | null
};
	["LogoItemWithoutListUpdateInput"]: {
	order?:number | null,
	image?:ValueTypes["LogoItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LogoItemUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["LogoItemUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LogoItemUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["LogoListUpsertItemsRelationInput"]: {
	by?:ValueTypes["LogoItemUniqueWhere"] | null,
	update?:ValueTypes["LogoItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["LogoItemWithoutListCreateInput"] | null
};
	["ContentReferenceUpsertLogoListRelationInput"]: {
	update?:ValueTypes["LogoListUpdateInput"] | null,
	create?:ValueTypes["LogoListCreateInput"] | null
};
	["ContentReferenceUpdateStrategySchemaEntityRelationInput"]: {
	create?:ValueTypes["StrategySchemaCreateInput"] | null,
	update?:ValueTypes["StrategySchemaUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertStrategySchemaRelationInput"] | null,
	connect?:ValueTypes["StrategySchemaUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StrategySchemaUpdateInput"]: {
	inputFirst?:string | null,
	inputSecond?:string | null,
	inputThird?:string | null,
	outputFirst?:string | null,
	outputSecond?:string | null,
	outputThird?:string | null,
	itemsFirst?:ValueTypes["StrategySchemaUpdateItemsFirstEntityRelationInput"] | null,
	logo?:ValueTypes["StrategySchemaUpdateLogoEntityRelationInput"] | null,
	itemsSecond?:ValueTypes["StrategySchemaUpdateItemsSecondEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaUpdateItemsFirstEntityRelationInput"]: {
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null,
	update?:ValueTypes["StrategySchemaGroupUpdateInput"] | null,
	upsert?:ValueTypes["StrategySchemaUpsertItemsFirstRelationInput"] | null,
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StrategySchemaGroupUpdateInput"]: {
	items?:ValueTypes["StrategySchemaGroupUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"] | null,
	update?:ValueTypes["StrategySchemaGroupUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["StrategySchemaGroupUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	disconnect?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	delete?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	alias?:string | null
};
	["StrategySchemaGroupUpdateItemsRelationInput"]: {
	by?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	data?:ValueTypes["StrategySchemaGroupItemWithoutSchemaUpdateInput"] | null
};
	["StrategySchemaGroupItemWithoutSchemaUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupUpsertItemsRelationInput"]: {
	by?:ValueTypes["StrategySchemaGroupItemUniqueWhere"] | null,
	update?:ValueTypes["StrategySchemaGroupItemWithoutSchemaUpdateInput"] | null,
	create?:ValueTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"] | null
};
	["StrategySchemaUpsertItemsFirstRelationInput"]: {
	update?:ValueTypes["StrategySchemaGroupUpdateInput"] | null,
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null
};
	["StrategySchemaUpdateLogoEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["StrategySchemaUpsertLogoRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StrategySchemaUpsertLogoRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["StrategySchemaUpdateItemsSecondEntityRelationInput"]: {
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null,
	update?:ValueTypes["StrategySchemaGroupUpdateInput"] | null,
	upsert?:ValueTypes["StrategySchemaUpsertItemsSecondRelationInput"] | null,
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["StrategySchemaUpsertItemsSecondRelationInput"]: {
	update?:ValueTypes["StrategySchemaGroupUpdateInput"] | null,
	create?:ValueTypes["StrategySchemaGroupCreateInput"] | null
};
	["ContentReferenceUpsertStrategySchemaRelationInput"]: {
	update?:ValueTypes["StrategySchemaUpdateInput"] | null,
	create?:ValueTypes["StrategySchemaCreateInput"] | null
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertImageRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpdateEmployeeListEntityRelationInput"]: {
	create?:ValueTypes["EmployeeListCreateInput"] | null,
	update?:ValueTypes["EmployeeListUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertEmployeeListRelationInput"] | null,
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertEmployeeListRelationInput"]: {
	update?:ValueTypes["EmployeeListUpdateInput"] | null,
	create?:ValueTypes["EmployeeListCreateInput"] | null
};
	["ContentReferenceUpdateImageSecondEntityRelationInput"]: {
	create?:ValueTypes["ImageCreateInput"] | null,
	update?:ValueTypes["ImageUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertImageSecondRelationInput"] | null,
	connect?:ValueTypes["ImageUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContentReferenceUpsertImageSecondRelationInput"]: {
	update?:ValueTypes["ImageUpdateInput"] | null,
	create?:ValueTypes["ImageCreateInput"] | null
};
	["ContentReferenceUpdateContactFormEntityRelationInput"]: {
	create?:ValueTypes["ContactFormCreateInput"] | null,
	update?:ValueTypes["ContactFormUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertContactFormRelationInput"] | null,
	connect?:ValueTypes["ContactFormUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactFormUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["ContactFormUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactFormUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["ContactFormLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["ContactFormUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["ContactFormUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	delete?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["ContactFormUpdateLocalesRelationInput"]: {
	by?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	data?:ValueTypes["ContactFormLocaleWithoutRootUpdateInput"] | null
};
	["ContactFormLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	locale?:ValueTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleUpdateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutContactFormsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutContactFormsUpdateInput"] | null,
	upsert?:ValueTypes["ContactFormLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutContactFormsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutContactFormsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutContactFormsCreateInput"] | null
};
	["ContactFormUpsertLocalesRelationInput"]: {
	by?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	update?:ValueTypes["ContactFormLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutRootCreateInput"] | null
};
	["ContentReferenceUpsertContactFormRelationInput"]: {
	update?:ValueTypes["ContactFormUpdateInput"] | null,
	create?:ValueTypes["ContactFormCreateInput"] | null
};
	["ContentReferenceUpdateNewsletterFormEntityRelationInput"]: {
	create?:ValueTypes["NewsletterFormCreateInput"] | null,
	update?:ValueTypes["NewsletterFormUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertNewsletterFormRelationInput"] | null,
	connect?:ValueTypes["NewsletterFormUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsletterFormUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["NewsletterFormUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterFormUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["NewsletterFormLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["NewsletterFormUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["NewsletterFormUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	delete?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["NewsletterFormUpdateLocalesRelationInput"]: {
	by?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	data?:ValueTypes["NewsletterFormLocaleWithoutRootUpdateInput"] | null
};
	["NewsletterFormLocaleWithoutRootUpdateInput"]: {
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	locale?:ValueTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutNewsletterFormsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutNewsletterFormsUpdateInput"] | null,
	upsert?:ValueTypes["NewsletterFormLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutNewsletterFormsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutNewsletterFormsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutNewsletterFormsCreateInput"] | null
};
	["NewsletterFormUpsertLocalesRelationInput"]: {
	by?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	update?:ValueTypes["NewsletterFormLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutRootCreateInput"] | null
};
	["ContentReferenceUpsertNewsletterFormRelationInput"]: {
	update?:ValueTypes["NewsletterFormUpdateInput"] | null,
	create?:ValueTypes["NewsletterFormCreateInput"] | null
};
	["ContentBlockUpsertReferencesRelationInput"]: {
	by?:ValueTypes["ContentReferenceUniqueWhere"] | null,
	update?:ValueTypes["ContentReferenceWithoutBlockUpdateInput"] | null,
	create?:ValueTypes["ContentReferenceWithoutBlockCreateInput"] | null
};
	["ContentUpsertBlocksRelationInput"]: {
	by?:ValueTypes["ContentBlockUniqueWhere"] | null,
	update?:ValueTypes["ContentBlockWithoutContentUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutContentCreateInput"] | null
};
	["HomePageLocaleUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentUpdateInput"] | null,
	create?:ValueTypes["ContentCreateInput"] | null
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutHomePageUpdateInput"]: {
	url?:string | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	redirect?:ValueTypes["LinkableUpdateRedirectEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutHomePageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutHomePageCreateInput"] | null
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
	create?:ValueTypes["SeoCreateInput"] | null,
	update?:ValueTypes["SeoUpdateInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertSeoRelationInput"] | null,
	connect?:ValueTypes["SeoUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
	update?:ValueTypes["SeoUpdateInput"] | null,
	create?:ValueTypes["SeoCreateInput"] | null
};
	["HomePageLocaleUpdateBranchesEntityRelationInput"]: {
	create?:ValueTypes["BranchesCreateInput"] | null,
	update?:ValueTypes["HomePageLocaleUpdateBranchesRelationInput"] | null,
	upsert?:ValueTypes["HomePageLocaleUpsertBranchesRelationInput"] | null,
	connect?:ValueTypes["BranchesUniqueWhere"] | null,
	disconnect?:ValueTypes["BranchesUniqueWhere"] | null,
	delete?:ValueTypes["BranchesUniqueWhere"] | null,
	alias?:string | null
};
	["HomePageLocaleUpdateBranchesRelationInput"]: {
	by?:ValueTypes["BranchesUniqueWhere"] | null,
	data?:ValueTypes["BranchesUpdateInput"] | null
};
	["BranchesUpdateInput"]: {
	order?:number | null,
	leadParagraph?:string | null,
	more?:string | null,
	link?:ValueTypes["BranchesUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BranchesUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["BranchesUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["BranchesUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["HomePageLocaleUpsertBranchesRelationInput"]: {
	by?:ValueTypes["BranchesUniqueWhere"] | null,
	update?:ValueTypes["BranchesUpdateInput"] | null,
	create?:ValueTypes["BranchesCreateInput"] | null
};
	["LocaleUpsertHomePagesRelationInput"]: {
	by?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	update?:ValueTypes["HomePageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["HomePageLocaleWithoutLocaleCreateInput"] | null
};
	["PageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutPagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutPagesCreateInput"] | null
};
	["LinkableUpsertPageRelationInput"]: {
	update?:ValueTypes["PageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutLinkCreateInput"] | null
};
	["ContactPageLocaleUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutContactPageUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutContactPageCreateInput"] | null
};
	["LocaleUpsertContactPagesRelationInput"]: {
	by?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["ContactPageLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutLocaleCreateInput"] | null
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutHomePagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutHomePagesCreateInput"] | null
};
	["LinkableUpsertHomePageRelationInput"]: {
	update?:ValueTypes["HomePageLocaleWithoutLinkUpdateInput"] | null,
	create?:ValueTypes["HomePageLocaleWithoutLinkCreateInput"] | null
};
	["LinkUpsertInternalLinkRelationInput"]: {
	update?:ValueTypes["LinkableUpdateInput"] | null,
	create?:ValueTypes["LinkableCreateInput"] | null
};
	["GraphicDesignerUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLocaleUpsertGraphicDesignersRelationInput"]: {
	by?:ValueTypes["GraphicDesignerUniqueWhere"] | null,
	update?:ValueTypes["GraphicDesignerUpdateInput"] | null,
	create?:ValueTypes["GraphicDesignerCreateInput"] | null
};
	["FooterLocaleUpdateDeveloperLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertDeveloperLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["FooterLocaleUpsertDeveloperLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLocaleUpdatePhotographersEntityRelationInput"]: {
	create?:ValueTypes["PhotographerCreateInput"] | null,
	update?:ValueTypes["FooterLocaleUpdatePhotographersRelationInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertPhotographersRelationInput"] | null,
	connect?:ValueTypes["PhotographerUniqueWhere"] | null,
	disconnect?:ValueTypes["PhotographerUniqueWhere"] | null,
	delete?:ValueTypes["PhotographerUniqueWhere"] | null,
	alias?:string | null
};
	["FooterLocaleUpdatePhotographersRelationInput"]: {
	by?:ValueTypes["PhotographerUniqueWhere"] | null,
	data?:ValueTypes["PhotographerUpdateInput"] | null
};
	["PhotographerUpdateInput"]: {
	order?:number | null,
	link?:ValueTypes["PhotographerUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PhotographerUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkCreateInput"] | null,
	update?:ValueTypes["LinkUpdateInput"] | null,
	upsert?:ValueTypes["PhotographerUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["PhotographerUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkUpdateInput"] | null,
	create?:ValueTypes["LinkCreateInput"] | null
};
	["FooterLocaleUpsertPhotographersRelationInput"]: {
	by?:ValueTypes["PhotographerUniqueWhere"] | null,
	update?:ValueTypes["PhotographerUpdateInput"] | null,
	create?:ValueTypes["PhotographerCreateInput"] | null
};
	["LocaleUpsertFootersRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	update?:ValueTypes["FooterLocaleWithoutLocaleUpdateInput"] | null,
	create?:ValueTypes["FooterLocaleWithoutLocaleCreateInput"] | null
};
	["ContactPageLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutContactPagesUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutContactPagesCreateInput"] | null
};
	["ContactPageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["ContactPageLocaleUniqueWhere"] | null,
	update?:ValueTypes["ContactPageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["ContactPageLocaleWithoutRootCreateInput"] | null
};
	["ContactPageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactPageLocaleCreateLocaleEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleCreateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactPageLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ContactPageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"] | null,
	link?:ValueTypes["ContactPageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["ContactPageLocaleUpdateSeoEntityRelationInput"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	databox?:string | null,
	databoxNumber?:string | null,
	addressLink?:ValueTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"] | null,
	socialsLabel?:string | null,
	openingHours?:string | null,
	identificationsLabel?:string | null,
	ico?:string | null,
	dic?:string | null,
	phoneLabel?:string | null,
	emailLabel?:string | null,
	linkedIn?:string | null,
	securities?:string | null,
	securitiesNumber?:string | null,
	_dummy_field_?:boolean | null
};
	["ContentConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContentEdge"],
		__typename?: true
}>;
	["ContentEdge"]: AliasType<{
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentBlockCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockCreateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockCreateContentEntityRelationInput"]: {
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentWithoutBlocksCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	references?:ValueTypes["ContentBlockUpdateReferencesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null,
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	upsert?:ValueTypes["ContentBlockUpsertContentRelationInput"] | null,
	connect?:ValueTypes["ContentUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentWithoutBlocksUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ContentBlockUpsertContentRelationInput"]: {
	update?:ValueTypes["ContentWithoutBlocksUpdateInput"] | null,
	create?:ValueTypes["ContentWithoutBlocksCreateInput"] | null
};
	["ContentReferenceCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	block?:ValueTypes["ContentReferenceCreateBlockEntityRelationInput"] | null,
	media?:ValueTypes["ContentReferenceCreateMediaEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceCreateLinkEntityRelationInput"] | null,
	secondaryText?:string | null,
	dropDownList?:ValueTypes["ContentReferenceCreateDropDownListEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["ContentReferenceCreateArtworkSelectionEntityRelationInput"] | null,
	eventList?:ValueTypes["ContentReferenceCreateEventListEntityRelationInput"] | null,
	boxList?:ValueTypes["ContentReferenceCreateBoxListEntityRelationInput"] | null,
	isVisible?:boolean | null,
	chart?:ValueTypes["ContentReferenceCreateChartEntityRelationInput"] | null,
	definitionList?:ValueTypes["ContentReferenceCreateDefinitionListEntityRelationInput"] | null,
	logoList?:ValueTypes["ContentReferenceCreateLogoListEntityRelationInput"] | null,
	strategySchema?:ValueTypes["ContentReferenceCreateStrategySchemaEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceCreateImageEntityRelationInput"] | null,
	employeeList?:ValueTypes["ContentReferenceCreateEmployeeListEntityRelationInput"] | null,
	imageSecond?:ValueTypes["ContentReferenceCreateImageSecondEntityRelationInput"] | null,
	contactForm?:ValueTypes["ContentReferenceCreateContactFormEntityRelationInput"] | null,
	newsletterForm?:ValueTypes["ContentReferenceCreateNewsletterFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["ContentBlockWithoutReferencesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockCreateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateInput"]: {
	type?:ValueTypes["ContentReferenceType"] | null,
	primaryText?:string | null,
	block?:ValueTypes["ContentReferenceUpdateBlockEntityRelationInput"] | null,
	media?:ValueTypes["ContentReferenceUpdateMediaEntityRelationInput"] | null,
	link?:ValueTypes["ContentReferenceUpdateLinkEntityRelationInput"] | null,
	secondaryText?:string | null,
	dropDownList?:ValueTypes["ContentReferenceUpdateDropDownListEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["ContentReferenceUpdateArtworkSelectionEntityRelationInput"] | null,
	eventList?:ValueTypes["ContentReferenceUpdateEventListEntityRelationInput"] | null,
	boxList?:ValueTypes["ContentReferenceUpdateBoxListEntityRelationInput"] | null,
	isVisible?:boolean | null,
	chart?:ValueTypes["ContentReferenceUpdateChartEntityRelationInput"] | null,
	definitionList?:ValueTypes["ContentReferenceUpdateDefinitionListEntityRelationInput"] | null,
	logoList?:ValueTypes["ContentReferenceUpdateLogoListEntityRelationInput"] | null,
	strategySchema?:ValueTypes["ContentReferenceUpdateStrategySchemaEntityRelationInput"] | null,
	image?:ValueTypes["ContentReferenceUpdateImageEntityRelationInput"] | null,
	employeeList?:ValueTypes["ContentReferenceUpdateEmployeeListEntityRelationInput"] | null,
	imageSecond?:ValueTypes["ContentReferenceUpdateImageSecondEntityRelationInput"] | null,
	contactForm?:ValueTypes["ContentReferenceUpdateContactFormEntityRelationInput"] | null,
	newsletterForm?:ValueTypes["ContentReferenceUpdateNewsletterFormEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null,
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	upsert?:ValueTypes["ContentReferenceUpsertBlockRelationInput"] | null,
	connect?:ValueTypes["ContentBlockUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
	order?:number | null,
	json?:string | null,
	content?:ValueTypes["ContentBlockUpdateContentEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContentReferenceUpsertBlockRelationInput"]: {
	update?:ValueTypes["ContentBlockWithoutReferencesUpdateInput"] | null,
	create?:ValueTypes["ContentBlockWithoutReferencesCreateInput"] | null
};
	["FooterConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FooterEdge"],
		__typename?: true
}>;
	["FooterEdge"]: AliasType<{
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterCreateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["FooterCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["FooterLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	locale?:ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleCreatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null
};
	["LocaleWithoutFootersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	logo?:ValueTypes["FooterUpdateLogoEntityRelationInput"] | null,
	locales?:ValueTypes["FooterUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["FooterUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["FooterUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	delete?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["FooterUpdateLocalesRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	data?:ValueTypes["FooterLocaleWithoutRootUpdateInput"] | null
};
	["FooterLocaleWithoutRootUpdateInput"]: {
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	locale?:ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleUpdatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutFootersUpdateInput"] | null,
	upsert?:ValueTypes["FooterLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutFootersUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutFootersUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutFootersCreateInput"] | null
};
	["FooterUpsertLocalesRelationInput"]: {
	by?:ValueTypes["FooterLocaleUniqueWhere"] | null,
	update?:ValueTypes["FooterLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["FooterLocaleWithoutRootCreateInput"] | null
};
	["FooterLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	root?:ValueTypes["FooterLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FooterLocaleCreateLocaleEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleCreatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["FooterLocaleUpdateInput"]: {
	address?:string | null,
	phone?:string | null,
	email?:string | null,
	youtube?:string | null,
	instagram?:string | null,
	facebook?:string | null,
	graphicDesign?:string | null,
	root?:ValueTypes["FooterLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["FooterLocaleUpdateLocaleEntityRelationInput"] | null,
	graphicDesigners?:ValueTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"][],
	developerLink?:ValueTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"] | null,
	development?:string | null,
	linkedIn?:string | null,
	photography?:string | null,
	photographers?:ValueTypes["FooterLocaleUpdatePhotographersEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HeaderEdge"],
		__typename?: true
}>;
	["HeaderEdge"]: AliasType<{
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HeaderCreateLocalesEntityRelationInput"][],
	logo?:ValueTypes["HeaderCreateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["HeaderLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locale?:ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null
};
	["LocaleWithoutHeadersCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HeaderUpdateLocalesEntityRelationInput"][],
	logo?:ValueTypes["HeaderUpdateLogoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["HeaderUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["HeaderUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["HeaderUpdateLocalesRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	data?:ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | null
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
	locale?:ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutHeadersUpdateInput"] | null,
	upsert?:ValueTypes["HeaderLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutHeadersUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutHeadersUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutHeadersCreateInput"] | null
};
	["HeaderUpsertLocalesRelationInput"]: {
	by?:ValueTypes["HeaderLocaleUniqueWhere"] | null,
	update?:ValueTypes["HeaderLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["HeaderLocaleWithoutRootCreateInput"] | null
};
	["HeaderLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["HeaderLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleCreateLocaleEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleCreateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HeaderLocaleUpdateInput"]: {
	root?:ValueTypes["HeaderLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HeaderLocaleUpdateLocaleEntityRelationInput"] | null,
	links?:ValueTypes["HeaderLocaleUpdateLinksEntityRelationInput"][],
	artworkBreadcrumbParentLink?:ValueTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["HomePageEdge"],
		__typename?: true
}>;
	["HomePageEdge"]: AliasType<{
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HomePageCreateLocalesEntityRelationInput"][],
	media?:ValueTypes["HomePageCreateMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	create?:ValueTypes["HomePageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["HomePageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	locale?:ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleCreateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["HomePageUpdateLocalesEntityRelationInput"][],
	media?:ValueTypes["HomePageUpdateMediaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["HomePageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["HomePageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["HomePageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["HomePageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	data?:ValueTypes["HomePageLocaleWithoutRootUpdateInput"] | null
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	locale?:ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleUpdateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["HomePageLocaleUniqueWhere"] | null,
	update?:ValueTypes["HomePageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["HomePageLocaleWithoutRootCreateInput"] | null
};
	["HomePageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["HomePageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HomePageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleCreateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleCreateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleCreateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleCreateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["HomePageLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["HomePageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["HomePageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["HomePageLocaleUpdateContentEntityRelationInput"] | null,
	link?:ValueTypes["HomePageLocaleUpdateLinkEntityRelationInput"] | null,
	seo?:ValueTypes["HomePageLocaleUpdateSeoEntityRelationInput"] | null,
	branches?:ValueTypes["HomePageLocaleUpdateBranchesEntityRelationInput"][],
	leadParagraph?:string | null,
	_dummy_field_?:boolean | null
};
	["LinkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkEdge"],
		__typename?: true
}>;
	["LinkEdge"]: AliasType<{
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkableConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LinkableEdge"],
		__typename?: true
}>;
	["LinkableEdge"]: AliasType<{
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LocaleConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LocaleEdge"],
		__typename?: true
}>;
	["LocaleEdge"]: AliasType<{
	node?:ValueTypes["Locale"],
		__typename?: true
}>;
	["LocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleCreateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["LocaleUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	seoDefaults?:ValueTypes["LocaleUpdateSeoDefaultsEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["MediumConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumEdge"],
		__typename?: true
}>;
	["MediumEdge"]: AliasType<{
	node?:ValueTypes["Medium"],
		__typename?: true
}>;
	["MediumItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["MediumItemCreateListEntityRelationInput"] | null,
	medium?:ValueTypes["MediumItemCreateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	create?:ValueTypes["MediumListWithoutItemsCreateInput"] | null
};
	["MediumListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["MediumItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["MediumItemUpdateListEntityRelationInput"] | null,
	medium?:ValueTypes["MediumItemUpdateMediumEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["MediumItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["MediumListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["MediumListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["MediumItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["MediumListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["MediumListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["MediumItemUpsertListRelationInput"]: {
	update?:ValueTypes["MediumListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["MediumListWithoutItemsCreateInput"] | null
};
	["MediumListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["MediumListEdge"],
		__typename?: true
}>;
	["MediumListEdge"]: AliasType<{
	node?:ValueTypes["MediumList"],
		__typename?: true
}>;
	["PageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["PageEdge"],
		__typename?: true
}>;
	["PageEdge"]: AliasType<{
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locales?:ValueTypes["PageCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PageCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["PageLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpdateInput"]: {
	locales?:ValueTypes["PageUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["PageUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["PageUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["PageUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["PageLocaleUniqueWhere"] | null,
	delete?:ValueTypes["PageLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["PageUpdateLocalesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	data?:ValueTypes["PageLocaleWithoutRootUpdateInput"] | null
};
	["PageLocaleWithoutRootUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageUpsertLocalesRelationInput"]: {
	by?:ValueTypes["PageLocaleUniqueWhere"] | null,
	update?:ValueTypes["PageLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["PageLocaleWithoutRootCreateInput"] | null
};
	["PageLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	link?:ValueTypes["PageLocaleCreateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["PageLocaleUpdateInput"]: {
	title?:string | null,
	link?:ValueTypes["PageLocaleUpdateLinkEntityRelationInput"] | null,
	root?:ValueTypes["PageLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["PageLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["PageLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["PageLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoDefaultEdge"],
		__typename?: true
}>;
	["SeoDefaultEdge"]: AliasType<{
	node?:ValueTypes["SeoDefault"],
		__typename?: true
}>;
	["SeoDefaultCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["SeoDefaultCreateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
	connect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	create?:ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | null,
	alias?:string | null
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	locale?:ValueTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	create?:ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | null
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleCreateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleCreateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleCreateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleCreateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleCreatePagesEntityRelationInput"][],
	events?:ValueTypes["LocaleCreateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleCreateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleCreateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleCreateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleCreateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleCreateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoDefaultUpdateInput"]: {
	unique?:ValueTypes["One"] | null,
	locales?:ValueTypes["SeoDefaultUpdateLocalesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
	create?:ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | null,
	update?:ValueTypes["SeoDefaultUpdateLocalesRelationInput"] | null,
	upsert?:ValueTypes["SeoDefaultUpsertLocalesRelationInput"] | null,
	connect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	disconnect?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	delete?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	alias?:string | null
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
	by?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	data?:ValueTypes["SeoDefaultLocaleWithoutRootUpdateInput"] | null
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
	locale?:ValueTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
	create?:ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | null,
	update?:ValueTypes["LocaleWithoutSeoDefaultsUpdateInput"] | null,
	upsert?:ValueTypes["SeoDefaultLocaleUpsertLocaleRelationInput"] | null,
	connect?:ValueTypes["LocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
	code?:string | null,
	label?:string | null,
	contactPages?:ValueTypes["LocaleUpdateContactPagesEntityRelationInput"][],
	footers?:ValueTypes["LocaleUpdateFootersEntityRelationInput"][],
	headers?:ValueTypes["LocaleUpdateHeadersEntityRelationInput"][],
	homePages?:ValueTypes["LocaleUpdateHomePagesEntityRelationInput"][],
	pages?:ValueTypes["LocaleUpdatePagesEntityRelationInput"][],
	events?:ValueTypes["LocaleUpdateEventsEntityRelationInput"][],
	artworks?:ValueTypes["LocaleUpdateArtworksEntityRelationInput"][],
	artworkSelections?:ValueTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"][],
	newsletterForms?:ValueTypes["LocaleUpdateNewsletterFormsEntityRelationInput"][],
	employees?:ValueTypes["LocaleUpdateEmployeesEntityRelationInput"][],
	contactForms?:ValueTypes["LocaleUpdateContactFormsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
	update?:ValueTypes["LocaleWithoutSeoDefaultsUpdateInput"] | null,
	create?:ValueTypes["LocaleWithoutSeoDefaultsCreateInput"] | null
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
	by?:ValueTypes["SeoDefaultLocaleUniqueWhere"] | null,
	update?:ValueTypes["SeoDefaultLocaleWithoutRootUpdateInput"] | null,
	create?:ValueTypes["SeoDefaultLocaleWithoutRootCreateInput"] | null
};
	["SeoDefaultLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	root?:ValueTypes["SeoDefaultLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["SeoDefaultLocaleUpdateInput"]: {
	root?:ValueTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["VideoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["VideoEdge"],
		__typename?: true
}>;
	["VideoEdge"]: AliasType<{
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["ImageConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ImageEdge"],
		__typename?: true
}>;
	["ImageEdge"]: AliasType<{
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["SeoConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["SeoEdge"],
		__typename?: true
}>;
	["SeoEdge"]: AliasType<{
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["TranslationDomain"]: AliasType<{
	_meta?:ValueTypes["TranslationDomainMeta"],
	id?:true,
	identifier?:true,
	name?:true,
catalogues?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
keys?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
cataloguesByIdentifier?: [{	by:ValueTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
cataloguesByValues?: [{	by:ValueTypes["TranslationDomainCataloguesByValuesUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
keysByIdentifier?: [{	by:ValueTypes["TranslationDomainKeysByIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
keysByValues?: [{	by:ValueTypes["TranslationDomainKeysByValuesUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
paginateCatalogues?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
paginateKeys?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
		__typename?: true
}>;
	["TranslationDomainMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	catalogues?:ValueTypes["FieldMeta"],
	keys?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TranslationCatalogue"]: AliasType<{
	_meta?:ValueTypes["TranslationCatalogueMeta"],
	id?:true,
domain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
identifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
fallback?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
values?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
valuesByKey?: [{	by:ValueTypes["TranslationCatalogueValuesByKeyUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
		__typename?: true
}>;
	["TranslationCatalogueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	fallback?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TranslationDomainWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	identifier?:ValueTypes["StringCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	catalogues?:ValueTypes["TranslationCatalogueWhere"] | null,
	keys?:ValueTypes["TranslationKeyWhere"] | null,
	and?:(ValueTypes["TranslationDomainWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationDomainWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationDomainWhere"] | null
};
	["TranslationCatalogueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	domain?:ValueTypes["TranslationDomainWhere"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,
	fallback?:ValueTypes["TranslationCatalogueWhere"] | null,
	values?:ValueTypes["TranslationValueWhere"] | null,
	and?:(ValueTypes["TranslationCatalogueWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationCatalogueWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationCatalogueWhere"] | null
};
	["TranslationCataloguesIdentifierWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	name?:ValueTypes["StringCondition"] | null,
	code?:ValueTypes["StringCondition"] | null,
	catalogue?:ValueTypes["TranslationCatalogueWhere"] | null,
	and?:(ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationCataloguesIdentifierWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null
};
	["TranslationValueWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	value?:ValueTypes["StringCondition"] | null,
	catalogue?:ValueTypes["TranslationCatalogueWhere"] | null,
	key?:ValueTypes["TranslationKeyWhere"] | null,
	and?:(ValueTypes["TranslationValueWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationValueWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationValueWhere"] | null
};
	["TranslationKeyWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	identifier?:ValueTypes["StringCondition"] | null,
	contentType?:ValueTypes["TranslationContentTypeCondition"] | null,
	note?:ValueTypes["StringCondition"] | null,
	domain?:ValueTypes["TranslationDomainWhere"] | null,
	values?:ValueTypes["TranslationValueWhere"] | null,
	and?:(ValueTypes["TranslationKeyWhere"] | undefined | null)[],
	or?:(ValueTypes["TranslationKeyWhere"] | undefined | null)[],
	not?:ValueTypes["TranslationKeyWhere"] | null
};
	["TranslationContentTypeCondition"]: {
	and?:ValueTypes["TranslationContentTypeCondition"][],
	or?:ValueTypes["TranslationContentTypeCondition"][],
	not?:ValueTypes["TranslationContentTypeCondition"] | null,
	null?:boolean | null,
	isNull?:boolean | null,
	eq?:ValueTypes["TranslationContentType"] | null,
	notEq?:ValueTypes["TranslationContentType"] | null,
	in?:ValueTypes["TranslationContentType"][],
	notIn?:ValueTypes["TranslationContentType"][],
	lt?:ValueTypes["TranslationContentType"] | null,
	lte?:ValueTypes["TranslationContentType"] | null,
	gt?:ValueTypes["TranslationContentType"] | null,
	gte?:ValueTypes["TranslationContentType"] | null
};
	["TranslationContentType"]:TranslationContentType;
	["TranslationCataloguesIdentifier"]: AliasType<{
	_meta?:ValueTypes["TranslationCataloguesIdentifierMeta"],
	id?:true,
	name?:true,
	code?:true,
catalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
catalogueByDomain?: [{	by:ValueTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
catalogueByValues?: [{	by:ValueTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
paginateCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	name?:ValueTypes["FieldMeta"],
	code?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TranslationCatalogueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	domain?:ValueTypes["TranslationDomainOrderBy"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierOrderBy"] | null,
	fallback?:ValueTypes["TranslationCatalogueOrderBy"] | null
};
	["TranslationDomainOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	identifier?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null
};
	["TranslationCataloguesIdentifierOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	name?:ValueTypes["OrderDirection"] | null,
	code?:ValueTypes["OrderDirection"] | null
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null
};
	["TranslationDomainUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	catalogues?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	keys?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationCatalogueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	identifier?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null
};
	["TranslationValueUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	key?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationKeyUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	identifier?:string | null,
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationCatalogueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCatalogueEdge"],
		__typename?: true
}>;
	["TranslationCatalogueEdge"]: AliasType<{
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: true
}>;
	["TranslationValue"]: AliasType<{
	_meta?:ValueTypes["TranslationValueMeta"],
	id?:true,
	value?:true,
catalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
key?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
		__typename?: true
}>;
	["TranslationValueMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	value?:ValueTypes["FieldMeta"],
	catalogue?:ValueTypes["FieldMeta"],
	key?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TranslationKey"]: AliasType<{
	_meta?:ValueTypes["TranslationKeyMeta"],
	id?:true,
	identifier?:true,
	contentType?:true,
	note?:true,
domain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
values?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
valuesByCatalogue?: [{	by:ValueTypes["TranslationKeyValuesByCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
paginateValues?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
		__typename?: true
}>;
	["TranslationKeyMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	identifier?:ValueTypes["FieldMeta"],
	contentType?:ValueTypes["FieldMeta"],
	note?:ValueTypes["FieldMeta"],
	domain?:ValueTypes["FieldMeta"],
	values?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["TranslationValueOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	value?:ValueTypes["OrderDirection"] | null,
	catalogue?:ValueTypes["TranslationCatalogueOrderBy"] | null,
	key?:ValueTypes["TranslationKeyOrderBy"] | null
};
	["TranslationKeyOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	identifier?:ValueTypes["OrderDirection"] | null,
	contentType?:ValueTypes["OrderDirection"] | null,
	note?:ValueTypes["OrderDirection"] | null,
	domain?:ValueTypes["TranslationDomainOrderBy"] | null
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
	catalogue?:ValueTypes["TranslationCatalogueUniqueWhere"] | null
};
	["TranslationValueConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationValueEdge"],
		__typename?: true
}>;
	["TranslationValueEdge"]: AliasType<{
	node?:ValueTypes["TranslationValue"],
		__typename?: true
}>;
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
	key?:ValueTypes["TranslationKeyUniqueWhere"] | null
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
	identifier?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
	identifier?:string | null
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
	values?:ValueTypes["TranslationValueUniqueWhere"] | null
};
	["TranslationKeyConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationKeyEdge"],
		__typename?: true
}>;
	["TranslationKeyEdge"]: AliasType<{
	node?:ValueTypes["TranslationKey"],
		__typename?: true
}>;
	["TranslationDomainConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationDomainEdge"],
		__typename?: true
}>;
	["TranslationDomainEdge"]: AliasType<{
	node?:ValueTypes["TranslationDomain"],
		__typename?: true
}>;
	["TranslationDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"][],
	keys?:ValueTypes["TranslationDomainCreateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null,
	alias?:string | null
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null
};
	["TranslationCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	keys?:ValueTypes["TranslationDomainCreateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null,
	alias?:string | null
};
	["TranslationKeyWithoutDomainCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	values?:ValueTypes["TranslationKeyCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null,
	alias?:string | null
};
	["TranslationValueWithoutKeyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null,
	alias?:string | null
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	key?:ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null
};
	["TranslationKeyWithoutValuesCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null
};
	["TranslationDomainWithoutKeysCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainCreateCataloguesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"][],
	keys?:ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null,
	update?:ValueTypes["TranslationDomainUpdateCataloguesRelationInput"] | null,
	upsert?:ValueTypes["TranslationDomainUpsertCataloguesRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	data?:ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | null
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertIdentifierRelationInput"] | null,
	connect?:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
	update?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"] | null
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertFallbackRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["TranslationCatalogueUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null,
	update?:ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertDomainRelationInput"] | null,
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	keys?:ValueTypes["TranslationDomainUpdateKeysEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null,
	update?:ValueTypes["TranslationDomainUpdateKeysRelationInput"] | null,
	upsert?:ValueTypes["TranslationDomainUpsertKeysRelationInput"] | null,
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	delete?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationDomainUpdateKeysRelationInput"]: {
	by?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	data?:ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | null
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	values?:ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null,
	update?:ValueTypes["TranslationKeyUpdateValuesRelationInput"] | null,
	upsert?:ValueTypes["TranslationKeyUpsertValuesRelationInput"] | null,
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationValueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationKeyUpdateValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	data?:ValueTypes["TranslationValueWithoutKeyUpdateInput"] | null
};
	["TranslationValueWithoutKeyUpdateInput"]: {
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationValueUpsertCatalogueRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	identifier?:ValueTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
	update?:ValueTypes["TranslationCatalogueWithoutValuesUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutValuesCreateInput"] | null
};
	["TranslationKeyUpsertValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	update?:ValueTypes["TranslationValueWithoutKeyUpdateInput"] | null,
	create?:ValueTypes["TranslationValueWithoutKeyCreateInput"] | null
};
	["TranslationDomainUpsertKeysRelationInput"]: {
	by?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	update?:ValueTypes["TranslationKeyWithoutDomainUpdateInput"] | null,
	create?:ValueTypes["TranslationKeyWithoutDomainCreateInput"] | null
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
	update?:ValueTypes["TranslationDomainWithoutCataloguesUpdateInput"] | null,
	create?:ValueTypes["TranslationDomainWithoutCataloguesCreateInput"] | null
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null,
	update?:ValueTypes["TranslationCatalogueUpdateValuesRelationInput"] | null,
	upsert?:ValueTypes["TranslationCatalogueUpsertValuesRelationInput"] | null,
	connect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationValueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationValueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	data?:ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | null
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
	value?:string | null,
	key?:ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null,
	update?:ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | null,
	upsert?:ValueTypes["TranslationValueUpsertKeyRelationInput"] | null,
	connect?:ValueTypes["TranslationKeyUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null,
	update?:ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | null,
	upsert?:ValueTypes["TranslationKeyUpsertDomainRelationInput"] | null,
	connect?:ValueTypes["TranslationDomainUniqueWhere"] | null,
	delete?:boolean | null
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
	identifier?:string | null,
	name?:string | null,
	catalogues?:ValueTypes["TranslationDomainUpdateCataloguesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpsertDomainRelationInput"]: {
	update?:ValueTypes["TranslationDomainWithoutKeysUpdateInput"] | null,
	create?:ValueTypes["TranslationDomainWithoutKeysCreateInput"] | null
};
	["TranslationValueUpsertKeyRelationInput"]: {
	update?:ValueTypes["TranslationKeyWithoutValuesUpdateInput"] | null,
	create?:ValueTypes["TranslationKeyWithoutValuesCreateInput"] | null
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
	by?:ValueTypes["TranslationValueUniqueWhere"] | null,
	update?:ValueTypes["TranslationValueWithoutCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationValueWithoutCatalogueCreateInput"] | null
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
	update?:ValueTypes["TranslationCatalogueUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueCreateInput"] | null
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutDomainUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutDomainCreateInput"] | null
};
	["TranslationCataloguesIdentifierConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["TranslationCataloguesIdentifierEdge"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierEdge"]: AliasType<{
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	name?:string | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null,
	alias?:string | null
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	domain?:ValueTypes["TranslationCatalogueCreateDomainEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueCreateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
	name?:string | null,
	code?:string | null,
	catalogue?:ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null,
	update?:ValueTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"] | null,
	upsert?:ValueTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"] | null,
	connect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	disconnect?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	delete?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	alias?:string | null
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	data?:ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | null
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
	domain?:ValueTypes["TranslationCatalogueUpdateDomainEntityRelationInput"] | null,
	fallback?:ValueTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"] | null,
	values?:ValueTypes["TranslationCatalogueUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
	by?:ValueTypes["TranslationCatalogueUniqueWhere"] | null,
	update?:ValueTypes["TranslationCatalogueWithoutIdentifierUpdateInput"] | null,
	create?:ValueTypes["TranslationCatalogueWithoutIdentifierCreateInput"] | null
};
	["TranslationKeyCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyCreateDomainEntityRelationInput"] | null,
	values?:ValueTypes["TranslationKeyCreateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationKeyUpdateInput"]: {
	identifier?:string | null,
	contentType?:ValueTypes["TranslationContentType"] | null,
	note?:string | null,
	domain?:ValueTypes["TranslationKeyUpdateDomainEntityRelationInput"] | null,
	values?:ValueTypes["TranslationKeyUpdateValuesEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["TranslationValueCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueCreateCatalogueEntityRelationInput"] | null,
	key?:ValueTypes["TranslationValueCreateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["TranslationValueUpdateInput"]: {
	value?:string | null,
	catalogue?:ValueTypes["TranslationValueUpdateCatalogueEntityRelationInput"] | null,
	key?:ValueTypes["TranslationValueUpdateKeyEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventEdge"],
		__typename?: true
}>;
	["EventEdge"]: AliasType<{
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["EventLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleCreateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleCreateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleCreateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleCreateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["EventLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["EventLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EventLocaleUpdateLocaleEntityRelationInput"] | null,
	image?:ValueTypes["EventLocaleUpdateImageEntityRelationInput"] | null,
	seo?:ValueTypes["EventLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["EventLocaleUpdateLinkEntityRelationInput"] | null,
	venue?:string | null,
	venueNote?:string | null,
	content?:ValueTypes["EventLocaleUpdateContentEntityRelationInput"] | null,
	date?:string | null,
	leadParagraph?:string | null,
	isDark?:boolean | null,
	_dummy_field_?:boolean | null
};
	["ArtworkConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkEdge"],
		__typename?: true
}>;
	["ArtworkEdge"]: AliasType<{
	node?:ValueTypes["Artwork"],
		__typename?: true
}>;
	["ArtworkLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkLocaleCreateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleCreateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleCreateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["ArtworkLocaleUpdateInput"]: {
	title?:string | null,
	label?:string | null,
	leadParagraph?:string | null,
	root?:ValueTypes["ArtworkLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"] | null,
	content?:ValueTypes["ArtworkLocaleUpdateContentEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkLocaleUpdateLinkEntityRelationInput"] | null,
	artist?:string | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["DropDownItemCreateListEntityRelationInput"] | null,
	link?:ValueTypes["DropDownItemCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["DropDownListUniqueWhere"] | null,
	create?:ValueTypes["DropDownListWithoutItemsCreateInput"] | null
};
	["DropDownListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	dropDownType?:ValueTypes["DropDownType"] | null,
	employees?:ValueTypes["DropDownListCreateEmployeesEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["DropDownItemUpdateListEntityRelationInput"] | null,
	link?:ValueTypes["DropDownItemUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["DropDownListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["DropDownListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["DropDownItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["DropDownListUniqueWhere"] | null,
	delete?:boolean | null
};
	["DropDownListWithoutItemsUpdateInput"]: {
	dropDownType?:ValueTypes["DropDownType"] | null,
	employees?:ValueTypes["DropDownListUpdateEmployeesEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DropDownItemUpsertListRelationInput"]: {
	update?:ValueTypes["DropDownListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["DropDownListWithoutItemsCreateInput"] | null
};
	["DropDownListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DropDownListEdge"],
		__typename?: true
}>;
	["DropDownListEdge"]: AliasType<{
	node?:ValueTypes["DropDownList"],
		__typename?: true
}>;
	["ArtworkItem"]: AliasType<{
	_meta?:ValueTypes["ArtworkItemMeta"],
	id?:true,
	order?:true,
list?: [{	filter?:ValueTypes["ArtworkListWhere"] | null},ValueTypes["ArtworkList"]],
artwork?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
		__typename?: true
}>;
	["ArtworkItemMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	order?:ValueTypes["FieldMeta"],
	list?:ValueTypes["FieldMeta"],
	artwork?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkList"]: AliasType<{
	_meta?:ValueTypes["ArtworkListMeta"],
	id?:true,
items?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkItem"]],
paginateItems?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkItemConnection"]],
		__typename?: true
}>;
	["ArtworkListMeta"]: AliasType<{
	id?:ValueTypes["FieldMeta"],
	items?:ValueTypes["FieldMeta"],
		__typename?: true
}>;
	["ArtworkItemWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	order?:ValueTypes["IntCondition"] | null,
	list?:ValueTypes["ArtworkListWhere"] | null,
	artwork?:ValueTypes["ArtworkLocaleWhere"] | null,
	and?:(ValueTypes["ArtworkItemWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkItemWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkItemWhere"] | null
};
	["ArtworkListWhere"]: {
	id?:ValueTypes["UUIDCondition"] | null,
	items?:ValueTypes["ArtworkItemWhere"] | null,
	and?:(ValueTypes["ArtworkListWhere"] | undefined | null)[],
	or?:(ValueTypes["ArtworkListWhere"] | undefined | null)[],
	not?:ValueTypes["ArtworkListWhere"] | null
};
	["ArtworkItemOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null,
	order?:ValueTypes["OrderDirection"] | null,
	list?:ValueTypes["ArtworkListOrderBy"] | null,
	artwork?:ValueTypes["ArtworkLocaleOrderBy"] | null
};
	["ArtworkListOrderBy"]: {
	_random?:boolean | null,
	_randomSeeded?:number | null,
	id?:ValueTypes["OrderDirection"] | null
};
	["ArtworkItemConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkItemEdge"],
		__typename?: true
}>;
	["ArtworkItemEdge"]: AliasType<{
	node?:ValueTypes["ArtworkItem"],
		__typename?: true
}>;
	["ArtworkItemUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null
};
	["ArtworkItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ArtworkItemCreateListEntityRelationInput"] | null,
	artwork?:ValueTypes["ArtworkItemCreateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkListUniqueWhere"] | null,
	create?:ValueTypes["ArtworkListWithoutItemsCreateInput"] | null
};
	["ArtworkListUniqueWhere"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ArtworkItemUniqueWhere"] | null
};
	["ArtworkListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkItemCreateArtworkEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	create?:ValueTypes["ArtworkLocaleCreateInput"] | null
};
	["ArtworkItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ArtworkItemUpdateListEntityRelationInput"] | null,
	artwork?:ValueTypes["ArtworkItemUpdateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ArtworkListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ArtworkListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ArtworkListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ArtworkItemUpsertListRelationInput"]: {
	update?:ValueTypes["ArtworkListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ArtworkListWithoutItemsCreateInput"] | null
};
	["ArtworkItemUpdateArtworkEntityRelationInput"]: {
	create?:ValueTypes["ArtworkLocaleCreateInput"] | null,
	update?:ValueTypes["ArtworkLocaleUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkItemUpsertArtworkRelationInput"] | null,
	connect?:ValueTypes["ArtworkLocaleUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ArtworkItemUpsertArtworkRelationInput"]: {
	update?:ValueTypes["ArtworkLocaleUpdateInput"] | null,
	create?:ValueTypes["ArtworkLocaleCreateInput"] | null
};
	["ArtworkListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkListEdge"],
		__typename?: true
}>;
	["ArtworkListEdge"]: AliasType<{
	node?:ValueTypes["ArtworkList"],
		__typename?: true
}>;
	["ArtworkListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	items?:ValueTypes["ArtworkListCreateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArtworkListCreateItemsEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	create?:ValueTypes["ArtworkItemWithoutListCreateInput"] | null,
	alias?:string | null
};
	["ArtworkItemWithoutListCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	artwork?:ValueTypes["ArtworkItemCreateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkListUpdateInput"]: {
	items?:ValueTypes["ArtworkListUpdateItemsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["ArtworkListUpdateItemsEntityRelationInput"]: {
	create?:ValueTypes["ArtworkItemWithoutListCreateInput"] | null,
	update?:ValueTypes["ArtworkListUpdateItemsRelationInput"] | null,
	upsert?:ValueTypes["ArtworkListUpsertItemsRelationInput"] | null,
	connect?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	disconnect?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	delete?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	alias?:string | null
};
	["ArtworkListUpdateItemsRelationInput"]: {
	by?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	data?:ValueTypes["ArtworkItemWithoutListUpdateInput"] | null
};
	["ArtworkItemWithoutListUpdateInput"]: {
	order?:number | null,
	artwork?:ValueTypes["ArtworkItemUpdateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkListUpsertItemsRelationInput"]: {
	by?:ValueTypes["ArtworkItemUniqueWhere"] | null,
	update?:ValueTypes["ArtworkItemWithoutListUpdateInput"] | null,
	create?:ValueTypes["ArtworkItemWithoutListCreateInput"] | null
};
	["ArtworkSelectionConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkSelectionEdge"],
		__typename?: true
}>;
	["ArtworkSelectionEdge"]: AliasType<{
	node?:ValueTypes["ArtworkSelection"],
		__typename?: true
}>;
	["ArtworkSelectionItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ArtworkSelectionItemCreateListEntityRelationInput"] | null,
	artwork?:ValueTypes["ArtworkSelectionItemCreateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ArtworkSelectionListUniqueWhere"] | null,
	create?:ValueTypes["ArtworkSelectionListWithoutItemsCreateInput"] | null
};
	["ArtworkSelectionListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ArtworkSelectionItemUpdateListEntityRelationInput"] | null,
	artwork?:ValueTypes["ArtworkSelectionItemUpdateArtworkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ArtworkSelectionListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ArtworkSelectionListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ArtworkSelectionItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ArtworkSelectionListUniqueWhere"] | null,
	delete?:boolean | null
};
	["ArtworkSelectionListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionItemUpsertListRelationInput"]: {
	update?:ValueTypes["ArtworkSelectionListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ArtworkSelectionListWithoutItemsCreateInput"] | null
};
	["ArtworkSelectionListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ArtworkSelectionListEdge"],
		__typename?: true
}>;
	["ArtworkSelectionListEdge"]: AliasType<{
	node?:ValueTypes["ArtworkSelectionList"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ArtworkSelectionLocaleUpdateInput"]: {
	title?:string | null,
	root?:ValueTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"] | null,
	seo?:ValueTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"] | null,
	link?:ValueTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["EventItemCreateListEntityRelationInput"] | null,
	event?:ValueTypes["EventItemCreateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["EventListUniqueWhere"] | null,
	create?:ValueTypes["EventListWithoutItemsCreateInput"] | null
};
	["EventListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["EventItemUpdateListEntityRelationInput"] | null,
	event?:ValueTypes["EventItemUpdateEventEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EventItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["EventListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["EventListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["EventItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["EventListUniqueWhere"] | null,
	delete?:boolean | null
};
	["EventListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["EventItemUpsertListRelationInput"]: {
	update?:ValueTypes["EventListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["EventListWithoutItemsCreateInput"] | null
};
	["EventListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EventListEdge"],
		__typename?: true
}>;
	["EventListEdge"]: AliasType<{
	node?:ValueTypes["EventList"],
		__typename?: true
}>;
	["BoxItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	link?:string | null,
	date?:string | null,
	type?:string | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["BoxItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BoxItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["BoxListUniqueWhere"] | null,
	create?:ValueTypes["BoxListWithoutItemsCreateInput"] | null
};
	["BoxListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["BoxItemUpdateInput"]: {
	order?:number | null,
	link?:string | null,
	date?:string | null,
	type?:string | null,
	title?:string | null,
	text?:string | null,
	list?:ValueTypes["BoxItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["BoxItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["BoxListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["BoxListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["BoxItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["BoxListUniqueWhere"] | null,
	delete?:boolean | null
};
	["BoxListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["BoxItemUpsertListRelationInput"]: {
	update?:ValueTypes["BoxListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["BoxListWithoutItemsCreateInput"] | null
};
	["BoxListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["BoxListEdge"],
		__typename?: true
}>;
	["BoxListEdge"]: AliasType<{
	node?:ValueTypes["BoxList"],
		__typename?: true
}>;
	["NewsletterFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["NewsletterFormEdge"],
		__typename?: true
}>;
	["NewsletterFormEdge"]: AliasType<{
	node?:ValueTypes["NewsletterForm"],
		__typename?: true
}>;
	["NewsletterTypeItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["NewsletterTypeItemCreateListEntityRelationInput"] | null,
	subscriptions?:ValueTypes["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutItemsCreateInput"] | null
};
	["NewsletterFormLocaleWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"] | null,
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["NewsletterTypeItemUpdateListEntityRelationInput"] | null,
	subscriptions?:ValueTypes["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"][],
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["NewsletterFormLocaleWithoutItemsCreateInput"] | null,
	update?:ValueTypes["NewsletterFormLocaleWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["NewsletterTypeItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["NewsletterFormLocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["NewsletterFormLocaleWithoutItemsUpdateInput"]: {
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"] | null,
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterTypeItemUpsertListRelationInput"]: {
	update?:ValueTypes["NewsletterFormLocaleWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["NewsletterFormLocaleWithoutItemsCreateInput"] | null
};
	["NewsletterFormLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterFormLocaleUpdateInput"]: {
	newsletterTypeNote?:string | null,
	email?:string | null,
	emailNote?:string | null,
	submit?:string | null,
	root?:ValueTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"][],
	title?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	newsletterTypeErrorMessage?:string | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSubscriptionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	newsletterType?:ValueTypes["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"]: {
	connect?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	create?:ValueTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"] | null
};
	["NewsletterTypeItemWithoutSubscriptionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["NewsletterTypeItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSubscriptionUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	newsletterType?:ValueTypes["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"]: {
	create?:ValueTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"] | null,
	update?:ValueTypes["NewsletterTypeItemWithoutSubscriptionsUpdateInput"] | null,
	upsert?:ValueTypes["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"] | null,
	connect?:ValueTypes["NewsletterTypeItemUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["NewsletterTypeItemWithoutSubscriptionsUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["NewsletterTypeItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"]: {
	update?:ValueTypes["NewsletterTypeItemWithoutSubscriptionsUpdateInput"] | null,
	create?:ValueTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"] | null
};
	["ChartConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ChartEdge"],
		__typename?: true
}>;
	["ChartEdge"]: AliasType<{
	node?:ValueTypes["Chart"],
		__typename?: true
}>;
	["ChartDataCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["ChartDataCreateListEntityRelationInput"] | null,
	date?:ValueTypes["Date"] | null,
	number?:number | null,
	text?:string | null,
	image?:ValueTypes["ChartDataCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ChartUniqueWhere"] | null,
	create?:ValueTypes["ChartWithoutItemsCreateInput"] | null
};
	["ChartWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	type?:ValueTypes["ChartType"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["ChartDataUpdateListEntityRelationInput"] | null,
	date?:ValueTypes["Date"] | null,
	number?:number | null,
	text?:string | null,
	image?:ValueTypes["ChartDataUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ChartWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ChartWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ChartDataUpsertListRelationInput"] | null,
	connect?:ValueTypes["ChartUniqueWhere"] | null,
	delete?:boolean | null
};
	["ChartWithoutItemsUpdateInput"]: {
	type?:ValueTypes["ChartType"] | null,
	_dummy_field_?:boolean | null
};
	["ChartDataUpsertListRelationInput"]: {
	update?:ValueTypes["ChartWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ChartWithoutItemsCreateInput"] | null
};
	["EmployeeConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeEdge"],
		__typename?: true
}>;
	["EmployeeEdge"]: AliasType<{
	node?:ValueTypes["Employee"],
		__typename?: true
}>;
	["EmployeeItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["EmployeeItemCreateListEntityRelationInput"] | null,
	employee?:ValueTypes["EmployeeItemCreateEmployeeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	create?:ValueTypes["EmployeeListWithoutItemsCreateInput"] | null
};
	["EmployeeListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["EmployeeItemUpdateListEntityRelationInput"] | null,
	employee?:ValueTypes["EmployeeItemUpdateEmployeeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["EmployeeListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["EmployeeListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["EmployeeItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["EmployeeListUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["EmployeeListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["EmployeeItemUpsertListRelationInput"]: {
	update?:ValueTypes["EmployeeListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["EmployeeListWithoutItemsCreateInput"] | null
};
	["EmployeeListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["EmployeeListEdge"],
		__typename?: true
}>;
	["EmployeeListEdge"]: AliasType<{
	node?:ValueTypes["EmployeeList"],
		__typename?: true
}>;
	["EmployeeLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	root?:ValueTypes["EmployeeLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EmployeeLocaleCreateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["EmployeeLocaleUpdateInput"]: {
	position?:string | null,
	text?:string | null,
	email?:string | null,
	phone?:string | null,
	root?:ValueTypes["EmployeeLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["EmployeeLocaleUpdateLocaleEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DefinitionItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	key?:string | null,
	value?:string | null,
	list?:ValueTypes["DefinitionItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DefinitionItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["DefinitionListUniqueWhere"] | null,
	create?:ValueTypes["DefinitionListWithoutItemsCreateInput"] | null
};
	["DefinitionListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["DefinitionItemUpdateInput"]: {
	order?:number | null,
	key?:string | null,
	value?:string | null,
	list?:ValueTypes["DefinitionItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["DefinitionItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["DefinitionListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["DefinitionListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["DefinitionItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["DefinitionListUniqueWhere"] | null,
	delete?:boolean | null
};
	["DefinitionListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["DefinitionItemUpsertListRelationInput"]: {
	update?:ValueTypes["DefinitionListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["DefinitionListWithoutItemsCreateInput"] | null
};
	["DefinitionListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["DefinitionListEdge"],
		__typename?: true
}>;
	["DefinitionListEdge"]: AliasType<{
	node?:ValueTypes["DefinitionList"],
		__typename?: true
}>;
	["LogoItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["LogoItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["LogoItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LogoItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["LogoListUniqueWhere"] | null,
	create?:ValueTypes["LogoListWithoutItemsCreateInput"] | null
};
	["LogoListWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["LogoItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["LogoItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["LogoItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["LogoItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["LogoListWithoutItemsCreateInput"] | null,
	update?:ValueTypes["LogoListWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["LogoItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["LogoListUniqueWhere"] | null,
	delete?:boolean | null
};
	["LogoListWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["LogoItemUpsertListRelationInput"]: {
	update?:ValueTypes["LogoListWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["LogoListWithoutItemsCreateInput"] | null
};
	["LogoListConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["LogoListEdge"],
		__typename?: true
}>;
	["LogoListEdge"]: AliasType<{
	node?:ValueTypes["LogoList"],
		__typename?: true
}>;
	["StrategySchemaConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StrategySchemaEdge"],
		__typename?: true
}>;
	["StrategySchemaEdge"]: AliasType<{
	node?:ValueTypes["StrategySchema"],
		__typename?: true
}>;
	["StrategySchemaGroupConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["StrategySchemaGroupEdge"],
		__typename?: true
}>;
	["StrategySchemaGroupEdge"]: AliasType<{
	node?:ValueTypes["StrategySchemaGroup"],
		__typename?: true
}>;
	["StrategySchemaGroupItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	text?:string | null,
	schema?:ValueTypes["StrategySchemaGroupItemCreateSchemaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupItemCreateSchemaEntityRelationInput"]: {
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	create?:ValueTypes["StrategySchemaGroupWithoutItemsCreateInput"] | null
};
	["StrategySchemaGroupWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupItemUpdateInput"]: {
	order?:number | null,
	text?:string | null,
	schema?:ValueTypes["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"]: {
	create?:ValueTypes["StrategySchemaGroupWithoutItemsCreateInput"] | null,
	update?:ValueTypes["StrategySchemaGroupWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["StrategySchemaGroupItemUpsertSchemaRelationInput"] | null,
	connect?:ValueTypes["StrategySchemaGroupUniqueWhere"] | null,
	delete?:boolean | null
};
	["StrategySchemaGroupWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["StrategySchemaGroupItemUpsertSchemaRelationInput"]: {
	update?:ValueTypes["StrategySchemaGroupWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["StrategySchemaGroupWithoutItemsCreateInput"] | null
};
	["RedirectConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["RedirectEdge"],
		__typename?: true
}>;
	["RedirectEdge"]: AliasType<{
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	link?:ValueTypes["RedirectCreateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectCreateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectCreateLinkEntityRelationInput"]: {
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["LinkableWithoutRedirectCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	url?:string | null,
	homePage?:ValueTypes["LinkableCreateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableCreateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableCreatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableCreateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableCreateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableCreateArtworkSelectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateInput"]: {
	link?:ValueTypes["RedirectUpdateLinkEntityRelationInput"] | null,
	target?:ValueTypes["RedirectUpdateTargetEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpdateLinkEntityRelationInput"]: {
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null,
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	upsert?:ValueTypes["RedirectUpsertLinkRelationInput"] | null,
	connect?:ValueTypes["LinkableUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["LinkableWithoutRedirectUpdateInput"]: {
	url?:string | null,
	homePage?:ValueTypes["LinkableUpdateHomePageEntityRelationInput"] | null,
	contactPage?:ValueTypes["LinkableUpdateContactPageEntityRelationInput"] | null,
	page?:ValueTypes["LinkableUpdatePageEntityRelationInput"] | null,
	event?:ValueTypes["LinkableUpdateEventEntityRelationInput"] | null,
	artwork?:ValueTypes["LinkableUpdateArtworkEntityRelationInput"] | null,
	artworkSelection?:ValueTypes["LinkableUpdateArtworkSelectionEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["RedirectUpsertLinkRelationInput"]: {
	update?:ValueTypes["LinkableWithoutRedirectUpdateInput"] | null,
	create?:ValueTypes["LinkableWithoutRedirectCreateInput"] | null
};
	["GalleryConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["GalleryEdge"],
		__typename?: true
}>;
	["GalleryEdge"]: AliasType<{
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	list?:ValueTypes["GalleryItemCreateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemCreateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["GalleryWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateInput"]: {
	order?:number | null,
	list?:ValueTypes["GalleryItemUpdateListEntityRelationInput"] | null,
	image?:ValueTypes["GalleryItemUpdateImageEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["GalleryItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null,
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["GalleryItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["GalleryUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["GalleryWithoutItemsUpdateInput"]: {
	_dummy_field_?:boolean | null
};
	["GalleryItemUpsertListRelationInput"]: {
	update?:ValueTypes["GalleryWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["GalleryWithoutItemsCreateInput"] | null
};
	["ContactFormConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["ContactFormEdge"],
		__typename?: true
}>;
	["ContactFormEdge"]: AliasType<{
	node?:ValueTypes["ContactForm"],
		__typename?: true
}>;
	["ContactFormLocaleCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactFormLocaleCreateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleCreateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactFormLocaleUpdateInput"]: {
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"] | null,
	items?:ValueTypes["ContactFormLocaleUpdateItemsEntityRelationInput"][],
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	name?:string | null,
	phone?:string | null,
	message?:string | null,
	file?:ValueTypes["ContactSubscriptionCreateFileEntityRelationInput"] | null,
	contactType?:ValueTypes["ContactSubscriptionCreateContactTypeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionCreateContactTypeEntityRelationInput"]: {
	connect?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	create?:ValueTypes["ContactTypeItemWithoutSubscriptionsCreateInput"] | null
};
	["ContactTypeItemWithoutSubscriptionsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["ContactTypeItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactTypeItemCreateListEntityRelationInput"]: {
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutItemsCreateInput"] | null
};
	["ContactFormLocaleWithoutItemsCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleCreateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactFormLocaleCreateLocaleEntityRelationInput"] | null,
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionUpdateInput"]: {
	createdAt?:ValueTypes["DateTime"] | null,
	email?:string | null,
	name?:string | null,
	phone?:string | null,
	message?:string | null,
	file?:ValueTypes["ContactSubscriptionUpdateFileEntityRelationInput"] | null,
	contactType?:ValueTypes["ContactSubscriptionUpdateContactTypeEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactSubscriptionUpdateContactTypeEntityRelationInput"]: {
	create?:ValueTypes["ContactTypeItemWithoutSubscriptionsCreateInput"] | null,
	update?:ValueTypes["ContactTypeItemWithoutSubscriptionsUpdateInput"] | null,
	upsert?:ValueTypes["ContactSubscriptionUpsertContactTypeRelationInput"] | null,
	connect?:ValueTypes["ContactTypeItemUniqueWhere"] | null,
	disconnect?:boolean | null,
	delete?:boolean | null
};
	["ContactTypeItemWithoutSubscriptionsUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	list?:ValueTypes["ContactTypeItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactTypeItemUpdateListEntityRelationInput"]: {
	create?:ValueTypes["ContactFormLocaleWithoutItemsCreateInput"] | null,
	update?:ValueTypes["ContactFormLocaleWithoutItemsUpdateInput"] | null,
	upsert?:ValueTypes["ContactTypeItemUpsertListRelationInput"] | null,
	connect?:ValueTypes["ContactFormLocaleUniqueWhere"] | null,
	delete?:boolean | null
};
	["ContactFormLocaleWithoutItemsUpdateInput"]: {
	title?:string | null,
	name?:string | null,
	phone?:string | null,
	email?:string | null,
	message?:string | null,
	submit?:string | null,
	successMessage?:string | null,
	genericErrorMessage?:string | null,
	contactTypeErrorMessage?:string | null,
	root?:ValueTypes["ContactFormLocaleUpdateRootEntityRelationInput"] | null,
	locale?:ValueTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"] | null,
	file?:string | null,
	_dummy_field_?:boolean | null
};
	["ContactTypeItemUpsertListRelationInput"]: {
	update?:ValueTypes["ContactFormLocaleWithoutItemsUpdateInput"] | null,
	create?:ValueTypes["ContactFormLocaleWithoutItemsCreateInput"] | null
};
	["ContactSubscriptionUpsertContactTypeRelationInput"]: {
	update?:ValueTypes["ContactTypeItemWithoutSubscriptionsUpdateInput"] | null,
	create?:ValueTypes["ContactTypeItemWithoutSubscriptionsCreateInput"] | null
};
	["ContactTypeItemCreateInput"]: {
	id?:ValueTypes["UUID"] | null,
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["ContactTypeItemCreateSubscriptionsEntityRelationInput"][],
	list?:ValueTypes["ContactTypeItemCreateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["ContactTypeItemUpdateInput"]: {
	order?:number | null,
	title?:string | null,
	subscriptions?:ValueTypes["ContactTypeItemUpdateSubscriptionsEntityRelationInput"][],
	list?:ValueTypes["ContactTypeItemUpdateListEntityRelationInput"] | null,
	_dummy_field_?:boolean | null
};
	["FileConnection"]: AliasType<{
	pageInfo?:ValueTypes["PageInfo"],
	edges?:ValueTypes["FileEdge"],
		__typename?: true
}>;
	["FileEdge"]: AliasType<{
	node?:ValueTypes["File"],
		__typename?: true
}>;
	["QueryTransaction"]: AliasType<{
getContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPage"]],
listContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPage"]],
paginateContactPage?: [{	filter?:ValueTypes["ContactPageWhere"] | null,	orderBy?:ValueTypes["ContactPageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageConnection"]],
validateCreateContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocale"]],
listContactPageLocale?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactPageLocale"]],
paginateContactPageLocale?: [{	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	orderBy?:ValueTypes["ContactPageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactPageLocaleConnection"]],
validateCreateContactPageLocale?: [{	data:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	data:ValueTypes["ContactPageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["Content"]],
listContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Content"]],
paginateContent?: [{	filter?:ValueTypes["ContentWhere"] | null,	orderBy?:ValueTypes["ContentOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentConnection"]],
validateCreateContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	data:ValueTypes["ContentUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlock"]],
listContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentBlock"]],
paginateContentBlock?: [{	filter?:ValueTypes["ContentBlockWhere"] | null,	orderBy?:ValueTypes["ContentBlockOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentBlockConnection"]],
validateCreateContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["_ValidationResult"]],
getContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReference"]],
listContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContentReference"]],
paginateContentReference?: [{	filter?:ValueTypes["ContentReferenceWhere"] | null,	orderBy?:ValueTypes["ContentReferenceOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContentReferenceConnection"]],
validateCreateContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["Footer"]],
listFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Footer"]],
paginateFooter?: [{	filter?:ValueTypes["FooterWhere"] | null,	orderBy?:ValueTypes["FooterOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterConnection"]],
validateCreateFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	data:ValueTypes["FooterUpdateInput"]},ValueTypes["_ValidationResult"]],
getFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocale"]],
listFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["FooterLocale"]],
paginateFooterLocale?: [{	filter?:ValueTypes["FooterLocaleWhere"] | null,	orderBy?:ValueTypes["FooterLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FooterLocaleConnection"]],
validateCreateFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["Header"]],
listHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Header"]],
paginateHeader?: [{	filter?:ValueTypes["HeaderWhere"] | null,	orderBy?:ValueTypes["HeaderOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderConnection"]],
validateCreateHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLink"]],
listHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLink"]],
paginateHeaderLink?: [{	filter?:ValueTypes["HeaderLinkWhere"] | null,	orderBy?:ValueTypes["HeaderLinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLinkConnection"]],
validateCreateHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocale"]],
listHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HeaderLocale"]],
paginateHeaderLocale?: [{	filter?:ValueTypes["HeaderLocaleWhere"] | null,	orderBy?:ValueTypes["HeaderLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HeaderLocaleConnection"]],
validateCreateHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePage"]],
listHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePage"]],
paginateHomePage?: [{	filter?:ValueTypes["HomePageWhere"] | null,	orderBy?:ValueTypes["HomePageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageConnection"]],
validateCreateHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["_ValidationResult"]],
getHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocale"]],
listHomePageLocale?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["HomePageLocale"]],
paginateHomePageLocale?: [{	filter?:ValueTypes["HomePageLocaleWhere"] | null,	orderBy?:ValueTypes["HomePageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["HomePageLocaleConnection"]],
validateCreateHomePageLocale?: [{	data:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	data:ValueTypes["HomePageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["Link"]],
listLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Link"]],
paginateLink?: [{	filter?:ValueTypes["LinkWhere"] | null,	orderBy?:ValueTypes["LinkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkConnection"]],
validateCreateLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	data:ValueTypes["LinkUpdateInput"]},ValueTypes["_ValidationResult"]],
getLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["Linkable"]],
listLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Linkable"]],
paginateLinkable?: [{	filter?:ValueTypes["LinkableWhere"] | null,	orderBy?:ValueTypes["LinkableOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LinkableConnection"]],
validateCreateLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["_ValidationResult"]],
getLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["Locale"]],
listLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Locale"]],
paginateLocale?: [{	filter?:ValueTypes["LocaleWhere"] | null,	orderBy?:ValueTypes["LocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LocaleConnection"]],
validateCreateLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["Medium"]],
listMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Medium"]],
paginateMedium?: [{	filter?:ValueTypes["MediumWhere"] | null,	orderBy?:ValueTypes["MediumOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumConnection"]],
validateCreateMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	data:ValueTypes["MediumUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null},ValueTypes["MediumItem"]],
listMediumItem?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumItem"]],
paginateMediumItem?: [{	filter?:ValueTypes["MediumItemWhere"] | null,	orderBy?:ValueTypes["MediumItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumItemConnection"]],
validateCreateMediumItem?: [{	data:ValueTypes["MediumItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	data:ValueTypes["MediumItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumList"]],
listMediumList?: [{	filter?:ValueTypes["MediumListWhere"] | null,	orderBy?:ValueTypes["MediumListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["MediumList"]],
paginateMediumList?: [{	filter?:ValueTypes["MediumListWhere"] | null,	orderBy?:ValueTypes["MediumListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["MediumListConnection"]],
validateCreateMediumList?: [{	data:ValueTypes["MediumListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	data:ValueTypes["MediumListUpdateInput"]},ValueTypes["_ValidationResult"]],
getPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["Page"]],
listPage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Page"]],
paginatePage?: [{	filter?:ValueTypes["PageWhere"] | null,	orderBy?:ValueTypes["PageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageConnection"]],
validateCreatePage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePage?: [{	by:ValueTypes["PageUniqueWhere"],	data:ValueTypes["PageUpdateInput"]},ValueTypes["_ValidationResult"]],
getPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocale"]],
listPageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["PageLocale"]],
paginatePageLocale?: [{	filter?:ValueTypes["PageLocaleWhere"] | null,	orderBy?:ValueTypes["PageLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PageLocaleConnection"]],
validateCreatePageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null},ValueTypes["SeoDefault"]],
listSeoDefault?: [{	filter?:ValueTypes["SeoDefaultWhere"] | null,	orderBy?:ValueTypes["SeoDefaultOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefault"]],
paginateSeoDefault?: [{	filter?:ValueTypes["SeoDefaultWhere"] | null,	orderBy?:ValueTypes["SeoDefaultOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultConnection"]],
validateCreateSeoDefault?: [{	data:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	data:ValueTypes["SeoDefaultUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocale"]],
listSeoDefaultLocale?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["SeoDefaultLocale"]],
paginateSeoDefaultLocale?: [{	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	orderBy?:ValueTypes["SeoDefaultLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoDefaultLocaleConnection"]],
validateCreateSeoDefaultLocale?: [{	data:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	data:ValueTypes["SeoDefaultLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["Video"]],
listVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Video"]],
paginateVideo?: [{	filter?:ValueTypes["VideoWhere"] | null,	orderBy?:ValueTypes["VideoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["VideoConnection"]],
validateCreateVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	data:ValueTypes["VideoUpdateInput"]},ValueTypes["_ValidationResult"]],
getImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["Image"]],
listImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Image"]],
paginateImage?: [{	filter?:ValueTypes["ImageWhere"] | null,	orderBy?:ValueTypes["ImageOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ImageConnection"]],
validateCreateImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	data:ValueTypes["ImageUpdateInput"]},ValueTypes["_ValidationResult"]],
getSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["Seo"]],
listSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Seo"]],
paginateSeo?: [{	filter?:ValueTypes["SeoWhere"] | null,	orderBy?:ValueTypes["SeoOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["SeoConnection"]],
validateCreateSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	data:ValueTypes["SeoUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomain"]],
listTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationDomain"]],
paginateTranslationDomain?: [{	filter?:ValueTypes["TranslationDomainWhere"] | null,	orderBy?:ValueTypes["TranslationDomainOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationDomainConnection"]],
validateCreateTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogue"]],
listTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCatalogue"]],
paginateTranslationCatalogue?: [{	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	orderBy?:ValueTypes["TranslationCatalogueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCatalogueConnection"]],
validateCreateTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifier"]],
listTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationCataloguesIdentifier"]],
paginateTranslationCataloguesIdentifier?: [{	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	orderBy?:ValueTypes["TranslationCataloguesIdentifierOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationCataloguesIdentifierConnection"]],
validateCreateTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKey"]],
listTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationKey"]],
paginateTranslationKey?: [{	filter?:ValueTypes["TranslationKeyWhere"] | null,	orderBy?:ValueTypes["TranslationKeyOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationKeyConnection"]],
validateCreateTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["_ValidationResult"]],
getTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValue"]],
listTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["TranslationValue"]],
paginateTranslationValue?: [{	filter?:ValueTypes["TranslationValueWhere"] | null,	orderBy?:ValueTypes["TranslationValueOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["TranslationValueConnection"]],
validateCreateTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["_ValidationResult"]],
getBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null},ValueTypes["Branches"]],
listBranches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Branches"]],
paginateBranches?: [{	filter?:ValueTypes["BranchesWhere"] | null,	orderBy?:ValueTypes["BranchesOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BranchesConnection"]],
validateCreateBranches?: [{	data:ValueTypes["BranchesCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	data:ValueTypes["BranchesUpdateInput"]},ValueTypes["_ValidationResult"]],
getGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null},ValueTypes["GraphicDesigner"]],
listGraphicDesigner?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GraphicDesigner"]],
paginateGraphicDesigner?: [{	filter?:ValueTypes["GraphicDesignerWhere"] | null,	orderBy?:ValueTypes["GraphicDesignerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GraphicDesignerConnection"]],
validateCreateGraphicDesigner?: [{	data:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	data:ValueTypes["GraphicDesignerUpdateInput"]},ValueTypes["_ValidationResult"]],
getEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["Event"]],
listEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Event"]],
paginateEvent?: [{	filter?:ValueTypes["EventWhere"] | null,	orderBy?:ValueTypes["EventOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventConnection"]],
validateCreateEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	data:ValueTypes["EventUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocale"]],
listEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventLocale"]],
paginateEventLocale?: [{	filter?:ValueTypes["EventLocaleWhere"] | null,	orderBy?:ValueTypes["EventLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventLocaleConnection"]],
validateCreateEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["Artwork"]],
listArtwork?: [{	filter?:ValueTypes["ArtworkWhere"] | null,	orderBy?:ValueTypes["ArtworkOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Artwork"]],
paginateArtwork?: [{	filter?:ValueTypes["ArtworkWhere"] | null,	orderBy?:ValueTypes["ArtworkOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkConnection"]],
validateCreateArtwork?: [{	data:ValueTypes["ArtworkCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	data:ValueTypes["ArtworkUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocale"]],
listArtworkLocale?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkLocale"]],
paginateArtworkLocale?: [{	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkLocaleConnection"]],
validateCreateArtworkLocale?: [{	data:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	data:ValueTypes["ArtworkLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null},ValueTypes["DropDownItem"]],
listDropDownItem?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DropDownItem"]],
paginateDropDownItem?: [{	filter?:ValueTypes["DropDownItemWhere"] | null,	orderBy?:ValueTypes["DropDownItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DropDownItemConnection"]],
validateCreateDropDownItem?: [{	data:ValueTypes["DropDownItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	data:ValueTypes["DropDownItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownList"]],
listDropDownList?: [{	filter?:ValueTypes["DropDownListWhere"] | null,	orderBy?:ValueTypes["DropDownListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DropDownList"]],
paginateDropDownList?: [{	filter?:ValueTypes["DropDownListWhere"] | null,	orderBy?:ValueTypes["DropDownListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DropDownListConnection"]],
validateCreateDropDownList?: [{	data:ValueTypes["DropDownListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	data:ValueTypes["DropDownListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null},ValueTypes["ArtworkItem"]],
listArtworkItem?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkItem"]],
paginateArtworkItem?: [{	filter?:ValueTypes["ArtworkItemWhere"] | null,	orderBy?:ValueTypes["ArtworkItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkItemConnection"]],
validateCreateArtworkItem?: [{	data:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	data:ValueTypes["ArtworkItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null},ValueTypes["ArtworkList"]],
listArtworkList?: [{	filter?:ValueTypes["ArtworkListWhere"] | null,	orderBy?:ValueTypes["ArtworkListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkList"]],
paginateArtworkList?: [{	filter?:ValueTypes["ArtworkListWhere"] | null,	orderBy?:ValueTypes["ArtworkListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkListConnection"]],
validateCreateArtworkList?: [{	data:ValueTypes["ArtworkListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	data:ValueTypes["ArtworkListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelection"]],
listArtworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelection"]],
paginateArtworkSelection?: [{	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionConnection"]],
validateCreateArtworkSelection?: [{	data:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	data:ValueTypes["ArtworkSelectionUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null},ValueTypes["ArtworkSelectionItem"]],
listArtworkSelectionItem?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionItem"]],
paginateArtworkSelectionItem?: [{	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionItemConnection"]],
validateCreateArtworkSelectionItem?: [{	data:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	data:ValueTypes["ArtworkSelectionItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionList"]],
listArtworkSelectionList?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionList"]],
paginateArtworkSelectionList?: [{	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionListConnection"]],
validateCreateArtworkSelectionList?: [{	data:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	data:ValueTypes["ArtworkSelectionListUpdateInput"]},ValueTypes["_ValidationResult"]],
getArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocale"]],
listArtworkSelectionLocale?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ArtworkSelectionLocale"]],
paginateArtworkSelectionLocale?: [{	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	orderBy?:ValueTypes["ArtworkSelectionLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ArtworkSelectionLocaleConnection"]],
validateCreateArtworkSelectionLocale?: [{	data:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	data:ValueTypes["ArtworkSelectionLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null},ValueTypes["EventItem"]],
listEventItem?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventItem"]],
paginateEventItem?: [{	filter?:ValueTypes["EventItemWhere"] | null,	orderBy?:ValueTypes["EventItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventItemConnection"]],
validateCreateEventItem?: [{	data:ValueTypes["EventItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	data:ValueTypes["EventItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventList"]],
listEventList?: [{	filter?:ValueTypes["EventListWhere"] | null,	orderBy?:ValueTypes["EventListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EventList"]],
paginateEventList?: [{	filter?:ValueTypes["EventListWhere"] | null,	orderBy?:ValueTypes["EventListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EventListConnection"]],
validateCreateEventList?: [{	data:ValueTypes["EventListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	data:ValueTypes["EventListUpdateInput"]},ValueTypes["_ValidationResult"]],
getBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null},ValueTypes["BoxItem"]],
listBoxItem?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BoxItem"]],
paginateBoxItem?: [{	filter?:ValueTypes["BoxItemWhere"] | null,	orderBy?:ValueTypes["BoxItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BoxItemConnection"]],
validateCreateBoxItem?: [{	data:ValueTypes["BoxItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	data:ValueTypes["BoxItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxList"]],
listBoxList?: [{	filter?:ValueTypes["BoxListWhere"] | null,	orderBy?:ValueTypes["BoxListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["BoxList"]],
paginateBoxList?: [{	filter?:ValueTypes["BoxListWhere"] | null,	orderBy?:ValueTypes["BoxListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["BoxListConnection"]],
validateCreateBoxList?: [{	data:ValueTypes["BoxListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	data:ValueTypes["BoxListUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterForm"]],
listNewsletterForm?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null,	orderBy?:ValueTypes["NewsletterFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterForm"]],
paginateNewsletterForm?: [{	filter?:ValueTypes["NewsletterFormWhere"] | null,	orderBy?:ValueTypes["NewsletterFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormConnection"]],
validateCreateNewsletterForm?: [{	data:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	data:ValueTypes["NewsletterFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItem"]],
listNewsletterTypeItem?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterTypeItem"]],
paginateNewsletterTypeItem?: [{	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	orderBy?:ValueTypes["NewsletterTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterTypeItemConnection"]],
validateCreateNewsletterTypeItem?: [{	data:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	data:ValueTypes["NewsletterTypeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocale"]],
listNewsletterFormLocale?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterFormLocale"]],
paginateNewsletterFormLocale?: [{	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	orderBy?:ValueTypes["NewsletterFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterFormLocaleConnection"]],
validateCreateNewsletterFormLocale?: [{	data:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	data:ValueTypes["NewsletterFormLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null},ValueTypes["NewsletterSubscription"]],
listNewsletterSubscription?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["NewsletterSubscription"]],
paginateNewsletterSubscription?: [{	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	orderBy?:ValueTypes["NewsletterSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["NewsletterSubscriptionConnection"]],
validateCreateNewsletterSubscription?: [{	data:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	data:ValueTypes["NewsletterSubscriptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["Chart"]],
listChart?: [{	filter?:ValueTypes["ChartWhere"] | null,	orderBy?:ValueTypes["ChartOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Chart"]],
paginateChart?: [{	filter?:ValueTypes["ChartWhere"] | null,	orderBy?:ValueTypes["ChartOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ChartConnection"]],
validateCreateChart?: [{	data:ValueTypes["ChartCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChart?: [{	by:ValueTypes["ChartUniqueWhere"],	data:ValueTypes["ChartUpdateInput"]},ValueTypes["_ValidationResult"]],
getChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null},ValueTypes["ChartData"]],
listChartData?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ChartData"]],
paginateChartData?: [{	filter?:ValueTypes["ChartDataWhere"] | null,	orderBy?:ValueTypes["ChartDataOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ChartDataConnection"]],
validateCreateChartData?: [{	data:ValueTypes["ChartDataCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	data:ValueTypes["ChartDataUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["Employee"]],
listEmployee?: [{	filter?:ValueTypes["EmployeeWhere"] | null,	orderBy?:ValueTypes["EmployeeOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Employee"]],
paginateEmployee?: [{	filter?:ValueTypes["EmployeeWhere"] | null,	orderBy?:ValueTypes["EmployeeOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeConnection"]],
validateCreateEmployee?: [{	data:ValueTypes["EmployeeCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	data:ValueTypes["EmployeeUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null},ValueTypes["EmployeeItem"]],
listEmployeeItem?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeItem"]],
paginateEmployeeItem?: [{	filter?:ValueTypes["EmployeeItemWhere"] | null,	orderBy?:ValueTypes["EmployeeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeItemConnection"]],
validateCreateEmployeeItem?: [{	data:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	data:ValueTypes["EmployeeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeList"]],
listEmployeeList?: [{	filter?:ValueTypes["EmployeeListWhere"] | null,	orderBy?:ValueTypes["EmployeeListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeList"]],
paginateEmployeeList?: [{	filter?:ValueTypes["EmployeeListWhere"] | null,	orderBy?:ValueTypes["EmployeeListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeListConnection"]],
validateCreateEmployeeList?: [{	data:ValueTypes["EmployeeListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	data:ValueTypes["EmployeeListUpdateInput"]},ValueTypes["_ValidationResult"]],
getEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocale"]],
listEmployeeLocale?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["EmployeeLocale"]],
paginateEmployeeLocale?: [{	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	orderBy?:ValueTypes["EmployeeLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["EmployeeLocaleConnection"]],
validateCreateEmployeeLocale?: [{	data:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	data:ValueTypes["EmployeeLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["Photographer"]],
listPhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Photographer"]],
paginatePhotographer?: [{	filter?:ValueTypes["PhotographerWhere"] | null,	orderBy?:ValueTypes["PhotographerOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["PhotographerConnection"]],
validateCreatePhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["_ValidationResult"]],
getDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null},ValueTypes["DefinitionItem"]],
listDefinitionItem?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DefinitionItem"]],
paginateDefinitionItem?: [{	filter?:ValueTypes["DefinitionItemWhere"] | null,	orderBy?:ValueTypes["DefinitionItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DefinitionItemConnection"]],
validateCreateDefinitionItem?: [{	data:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	data:ValueTypes["DefinitionItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionList"]],
listDefinitionList?: [{	filter?:ValueTypes["DefinitionListWhere"] | null,	orderBy?:ValueTypes["DefinitionListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["DefinitionList"]],
paginateDefinitionList?: [{	filter?:ValueTypes["DefinitionListWhere"] | null,	orderBy?:ValueTypes["DefinitionListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["DefinitionListConnection"]],
validateCreateDefinitionList?: [{	data:ValueTypes["DefinitionListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	data:ValueTypes["DefinitionListUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null},ValueTypes["LogoItem"]],
listLogoItem?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LogoItem"]],
paginateLogoItem?: [{	filter?:ValueTypes["LogoItemWhere"] | null,	orderBy?:ValueTypes["LogoItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LogoItemConnection"]],
validateCreateLogoItem?: [{	data:ValueTypes["LogoItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	data:ValueTypes["LogoItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoList"]],
listLogoList?: [{	filter?:ValueTypes["LogoListWhere"] | null,	orderBy?:ValueTypes["LogoListOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["LogoList"]],
paginateLogoList?: [{	filter?:ValueTypes["LogoListWhere"] | null,	orderBy?:ValueTypes["LogoListOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["LogoListConnection"]],
validateCreateLogoList?: [{	data:ValueTypes["LogoListCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	data:ValueTypes["LogoListUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null},ValueTypes["StrategySchema"]],
listStrategySchema?: [{	filter?:ValueTypes["StrategySchemaWhere"] | null,	orderBy?:ValueTypes["StrategySchemaOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchema"]],
paginateStrategySchema?: [{	filter?:ValueTypes["StrategySchemaWhere"] | null,	orderBy?:ValueTypes["StrategySchemaOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaConnection"]],
validateCreateStrategySchema?: [{	data:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	data:ValueTypes["StrategySchemaUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroup"]],
listStrategySchemaGroup?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchemaGroup"]],
paginateStrategySchemaGroup?: [{	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaGroupConnection"]],
validateCreateStrategySchemaGroup?: [{	data:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	data:ValueTypes["StrategySchemaGroupUpdateInput"]},ValueTypes["_ValidationResult"]],
getStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null},ValueTypes["StrategySchemaGroupItem"]],
listStrategySchemaGroupItem?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["StrategySchemaGroupItem"]],
paginateStrategySchemaGroupItem?: [{	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	orderBy?:ValueTypes["StrategySchemaGroupItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["StrategySchemaGroupItemConnection"]],
validateCreateStrategySchemaGroupItem?: [{	data:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	data:ValueTypes["StrategySchemaGroupItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["Redirect"]],
listRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Redirect"]],
paginateRedirect?: [{	filter?:ValueTypes["RedirectWhere"] | null,	orderBy?:ValueTypes["RedirectOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["RedirectConnection"]],
validateCreateRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["_ValidationResult"]],
getGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["Gallery"]],
listGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["Gallery"]],
paginateGallery?: [{	filter?:ValueTypes["GalleryWhere"] | null,	orderBy?:ValueTypes["GalleryOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryConnection"]],
validateCreateGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["_ValidationResult"]],
getGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItem"]],
listGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["GalleryItem"]],
paginateGalleryItem?: [{	filter?:ValueTypes["GalleryItemWhere"] | null,	orderBy?:ValueTypes["GalleryItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["GalleryItemConnection"]],
validateCreateGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactForm"]],
listContactForm?: [{	filter?:ValueTypes["ContactFormWhere"] | null,	orderBy?:ValueTypes["ContactFormOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactForm"]],
paginateContactForm?: [{	filter?:ValueTypes["ContactFormWhere"] | null,	orderBy?:ValueTypes["ContactFormOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormConnection"]],
validateCreateContactForm?: [{	data:ValueTypes["ContactFormCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	data:ValueTypes["ContactFormUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocale"]],
listContactFormLocale?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactFormLocale"]],
paginateContactFormLocale?: [{	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	orderBy?:ValueTypes["ContactFormLocaleOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactFormLocaleConnection"]],
validateCreateContactFormLocale?: [{	data:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	data:ValueTypes["ContactFormLocaleUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null},ValueTypes["ContactSubscription"]],
listContactSubscription?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactSubscription"]],
paginateContactSubscription?: [{	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	orderBy?:ValueTypes["ContactSubscriptionOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactSubscriptionConnection"]],
validateCreateContactSubscription?: [{	data:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	data:ValueTypes["ContactSubscriptionUpdateInput"]},ValueTypes["_ValidationResult"]],
getContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItem"]],
listContactTypeItem?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["ContactTypeItem"]],
paginateContactTypeItem?: [{	filter?:ValueTypes["ContactTypeItemWhere"] | null,	orderBy?:ValueTypes["ContactTypeItemOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["ContactTypeItemConnection"]],
validateCreateContactTypeItem?: [{	data:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	data:ValueTypes["ContactTypeItemUpdateInput"]},ValueTypes["_ValidationResult"]],
getFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["File"]],
listFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	offset?:number | null,	limit?:number | null},ValueTypes["File"]],
paginateFile?: [{	filter?:ValueTypes["FileWhere"] | null,	orderBy?:ValueTypes["FileOrderBy"][],	skip?:number | null,	first?:number | null},ValueTypes["FileConnection"]],
validateCreateFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["_ValidationResult"]],
validateUpdateFile?: [{	by:ValueTypes["FileUniqueWhere"],	data:ValueTypes["FileUpdateInput"]},ValueTypes["_ValidationResult"]],
		__typename?: true
}>;
	["Info"]: AliasType<{
	description?:true,
		__typename?: true
}>;
	["Mutation"]: AliasType<{
createContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageCreateResult"]],
deleteContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPageDeleteResult"]],
updateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["ContactPageUpdateResult"]],
upsertContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	update:ValueTypes["ContactPageUpdateInput"],	create:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageUpsertResult"]],
createContactPageLocale?: [{	data:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["ContactPageLocaleCreateResult"]],
deleteContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocaleDeleteResult"]],
updateContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	data:ValueTypes["ContactPageLocaleUpdateInput"]},ValueTypes["ContactPageLocaleUpdateResult"]],
upsertContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	update:ValueTypes["ContactPageLocaleUpdateInput"],	create:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["ContactPageLocaleUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	update:ValueTypes["FooterLocaleUpdateInput"],	create:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	update:ValueTypes["HeaderLocaleUpdateInput"],	create:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null,	data:ValueTypes["HomePageLocaleUpdateInput"]},ValueTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null,	update:ValueTypes["HomePageLocaleUpdateInput"],	create:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["HomePageLocaleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data:ValueTypes["MediumItemCreateInput"]},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null,	data:ValueTypes["MediumItemUpdateInput"]},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null,	update:ValueTypes["MediumItemUpdateInput"],	create:ValueTypes["MediumItemCreateInput"]},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data:ValueTypes["MediumListCreateInput"]},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null,	data:ValueTypes["MediumListUpdateInput"]},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null,	update:ValueTypes["MediumListUpdateInput"],	create:ValueTypes["MediumListCreateInput"]},ValueTypes["MediumListUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	update:ValueTypes["PageLocaleUpdateInput"],	create:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createSeoDefault?: [{	data:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null},ValueTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null,	data:ValueTypes["SeoDefaultUpdateInput"]},ValueTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null,	update:ValueTypes["SeoDefaultUpdateInput"],	create:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	data:ValueTypes["SeoDefaultLocaleUpdateInput"]},ValueTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	update:ValueTypes["SeoDefaultLocaleUpdateInput"],	create:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["SeoDefaultLocaleUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	update:ValueTypes["TranslationDomainUpdateInput"],	create:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	update:ValueTypes["TranslationCatalogueUpdateInput"],	create:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	update:ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	update:ValueTypes["TranslationKeyUpdateInput"],	create:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	update:ValueTypes["TranslationValueUpdateInput"],	create:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createBranches?: [{	data:ValueTypes["BranchesCreateInput"]},ValueTypes["BranchesCreateResult"]],
deleteBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null},ValueTypes["BranchesDeleteResult"]],
updateBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null,	data:ValueTypes["BranchesUpdateInput"]},ValueTypes["BranchesUpdateResult"]],
upsertBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null,	update:ValueTypes["BranchesUpdateInput"],	create:ValueTypes["BranchesCreateInput"]},ValueTypes["BranchesUpsertResult"]],
createGraphicDesigner?: [{	data:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["GraphicDesignerCreateResult"]],
deleteGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null},ValueTypes["GraphicDesignerDeleteResult"]],
updateGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null,	data:ValueTypes["GraphicDesignerUpdateInput"]},ValueTypes["GraphicDesignerUpdateResult"]],
upsertGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null,	update:ValueTypes["GraphicDesignerUpdateInput"],	create:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["GraphicDesignerUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleCreateResult"]],
deleteEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocaleDeleteResult"]],
updateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["EventLocaleUpdateResult"]],
upsertEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	update:ValueTypes["EventLocaleUpdateInput"],	create:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleUpsertResult"]],
createArtwork?: [{	data:ValueTypes["ArtworkCreateInput"]},ValueTypes["ArtworkCreateResult"]],
deleteArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["ArtworkDeleteResult"]],
updateArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null,	data:ValueTypes["ArtworkUpdateInput"]},ValueTypes["ArtworkUpdateResult"]],
upsertArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null,	update:ValueTypes["ArtworkUpdateInput"],	create:ValueTypes["ArtworkCreateInput"]},ValueTypes["ArtworkUpsertResult"]],
createArtworkLocale?: [{	data:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["ArtworkLocaleCreateResult"]],
deleteArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocaleDeleteResult"]],
updateArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	data:ValueTypes["ArtworkLocaleUpdateInput"]},ValueTypes["ArtworkLocaleUpdateResult"]],
upsertArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	update:ValueTypes["ArtworkLocaleUpdateInput"],	create:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["ArtworkLocaleUpsertResult"]],
createDropDownItem?: [{	data:ValueTypes["DropDownItemCreateInput"]},ValueTypes["DropDownItemCreateResult"]],
deleteDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null},ValueTypes["DropDownItemDeleteResult"]],
updateDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null,	data:ValueTypes["DropDownItemUpdateInput"]},ValueTypes["DropDownItemUpdateResult"]],
upsertDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null,	update:ValueTypes["DropDownItemUpdateInput"],	create:ValueTypes["DropDownItemCreateInput"]},ValueTypes["DropDownItemUpsertResult"]],
createDropDownList?: [{	data:ValueTypes["DropDownListCreateInput"]},ValueTypes["DropDownListCreateResult"]],
deleteDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownListDeleteResult"]],
updateDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null,	data:ValueTypes["DropDownListUpdateInput"]},ValueTypes["DropDownListUpdateResult"]],
upsertDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null,	update:ValueTypes["DropDownListUpdateInput"],	create:ValueTypes["DropDownListCreateInput"]},ValueTypes["DropDownListUpsertResult"]],
createArtworkItem?: [{	data:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["ArtworkItemCreateResult"]],
deleteArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null},ValueTypes["ArtworkItemDeleteResult"]],
updateArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null,	data:ValueTypes["ArtworkItemUpdateInput"]},ValueTypes["ArtworkItemUpdateResult"]],
upsertArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null,	update:ValueTypes["ArtworkItemUpdateInput"],	create:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["ArtworkItemUpsertResult"]],
createArtworkList?: [{	data:ValueTypes["ArtworkListCreateInput"]},ValueTypes["ArtworkListCreateResult"]],
deleteArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null},ValueTypes["ArtworkListDeleteResult"]],
updateArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null,	data:ValueTypes["ArtworkListUpdateInput"]},ValueTypes["ArtworkListUpdateResult"]],
upsertArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null,	update:ValueTypes["ArtworkListUpdateInput"],	create:ValueTypes["ArtworkListCreateInput"]},ValueTypes["ArtworkListUpsertResult"]],
createArtworkSelection?: [{	data:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["ArtworkSelectionCreateResult"]],
deleteArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelectionDeleteResult"]],
updateArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	data:ValueTypes["ArtworkSelectionUpdateInput"]},ValueTypes["ArtworkSelectionUpdateResult"]],
upsertArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	update:ValueTypes["ArtworkSelectionUpdateInput"],	create:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["ArtworkSelectionUpsertResult"]],
createArtworkSelectionItem?: [{	data:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["ArtworkSelectionItemCreateResult"]],
deleteArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null},ValueTypes["ArtworkSelectionItemDeleteResult"]],
updateArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	data:ValueTypes["ArtworkSelectionItemUpdateInput"]},ValueTypes["ArtworkSelectionItemUpdateResult"]],
upsertArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	update:ValueTypes["ArtworkSelectionItemUpdateInput"],	create:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["ArtworkSelectionItemUpsertResult"]],
createArtworkSelectionList?: [{	data:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["ArtworkSelectionListCreateResult"]],
deleteArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionListDeleteResult"]],
updateArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	data:ValueTypes["ArtworkSelectionListUpdateInput"]},ValueTypes["ArtworkSelectionListUpdateResult"]],
upsertArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	update:ValueTypes["ArtworkSelectionListUpdateInput"],	create:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["ArtworkSelectionListUpsertResult"]],
createArtworkSelectionLocale?: [{	data:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["ArtworkSelectionLocaleCreateResult"]],
deleteArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocaleDeleteResult"]],
updateArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	data:ValueTypes["ArtworkSelectionLocaleUpdateInput"]},ValueTypes["ArtworkSelectionLocaleUpdateResult"]],
upsertArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	update:ValueTypes["ArtworkSelectionLocaleUpdateInput"],	create:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["ArtworkSelectionLocaleUpsertResult"]],
createEventItem?: [{	data:ValueTypes["EventItemCreateInput"]},ValueTypes["EventItemCreateResult"]],
deleteEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null},ValueTypes["EventItemDeleteResult"]],
updateEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null,	data:ValueTypes["EventItemUpdateInput"]},ValueTypes["EventItemUpdateResult"]],
upsertEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null,	update:ValueTypes["EventItemUpdateInput"],	create:ValueTypes["EventItemCreateInput"]},ValueTypes["EventItemUpsertResult"]],
createEventList?: [{	data:ValueTypes["EventListCreateInput"]},ValueTypes["EventListCreateResult"]],
deleteEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventListDeleteResult"]],
updateEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null,	data:ValueTypes["EventListUpdateInput"]},ValueTypes["EventListUpdateResult"]],
upsertEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null,	update:ValueTypes["EventListUpdateInput"],	create:ValueTypes["EventListCreateInput"]},ValueTypes["EventListUpsertResult"]],
createBoxItem?: [{	data:ValueTypes["BoxItemCreateInput"]},ValueTypes["BoxItemCreateResult"]],
deleteBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null},ValueTypes["BoxItemDeleteResult"]],
updateBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null,	data:ValueTypes["BoxItemUpdateInput"]},ValueTypes["BoxItemUpdateResult"]],
upsertBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null,	update:ValueTypes["BoxItemUpdateInput"],	create:ValueTypes["BoxItemCreateInput"]},ValueTypes["BoxItemUpsertResult"]],
createBoxList?: [{	data:ValueTypes["BoxListCreateInput"]},ValueTypes["BoxListCreateResult"]],
deleteBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxListDeleteResult"]],
updateBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null,	data:ValueTypes["BoxListUpdateInput"]},ValueTypes["BoxListUpdateResult"]],
upsertBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null,	update:ValueTypes["BoxListUpdateInput"],	create:ValueTypes["BoxListCreateInput"]},ValueTypes["BoxListUpsertResult"]],
createNewsletterForm?: [{	data:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["NewsletterFormCreateResult"]],
deleteNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterFormDeleteResult"]],
updateNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null,	data:ValueTypes["NewsletterFormUpdateInput"]},ValueTypes["NewsletterFormUpdateResult"]],
upsertNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null,	update:ValueTypes["NewsletterFormUpdateInput"],	create:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["NewsletterFormUpsertResult"]],
createNewsletterTypeItem?: [{	data:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["NewsletterTypeItemCreateResult"]],
deleteNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItemDeleteResult"]],
updateNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	data:ValueTypes["NewsletterTypeItemUpdateInput"]},ValueTypes["NewsletterTypeItemUpdateResult"]],
upsertNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	update:ValueTypes["NewsletterTypeItemUpdateInput"],	create:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["NewsletterTypeItemUpsertResult"]],
createNewsletterFormLocale?: [{	data:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["NewsletterFormLocaleCreateResult"]],
deleteNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocaleDeleteResult"]],
updateNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	data:ValueTypes["NewsletterFormLocaleUpdateInput"]},ValueTypes["NewsletterFormLocaleUpdateResult"]],
upsertNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	update:ValueTypes["NewsletterFormLocaleUpdateInput"],	create:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["NewsletterFormLocaleUpsertResult"]],
createNewsletterSubscription?: [{	data:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["NewsletterSubscriptionCreateResult"]],
deleteNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null},ValueTypes["NewsletterSubscriptionDeleteResult"]],
updateNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	data:ValueTypes["NewsletterSubscriptionUpdateInput"]},ValueTypes["NewsletterSubscriptionUpdateResult"]],
upsertNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	update:ValueTypes["NewsletterSubscriptionUpdateInput"],	create:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["NewsletterSubscriptionUpsertResult"]],
createChart?: [{	data:ValueTypes["ChartCreateInput"]},ValueTypes["ChartCreateResult"]],
deleteChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["ChartDeleteResult"]],
updateChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null,	data:ValueTypes["ChartUpdateInput"]},ValueTypes["ChartUpdateResult"]],
upsertChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null,	update:ValueTypes["ChartUpdateInput"],	create:ValueTypes["ChartCreateInput"]},ValueTypes["ChartUpsertResult"]],
createChartData?: [{	data:ValueTypes["ChartDataCreateInput"]},ValueTypes["ChartDataCreateResult"]],
deleteChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null},ValueTypes["ChartDataDeleteResult"]],
updateChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null,	data:ValueTypes["ChartDataUpdateInput"]},ValueTypes["ChartDataUpdateResult"]],
upsertChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null,	update:ValueTypes["ChartDataUpdateInput"],	create:ValueTypes["ChartDataCreateInput"]},ValueTypes["ChartDataUpsertResult"]],
createEmployee?: [{	data:ValueTypes["EmployeeCreateInput"]},ValueTypes["EmployeeCreateResult"]],
deleteEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["EmployeeDeleteResult"]],
updateEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null,	data:ValueTypes["EmployeeUpdateInput"]},ValueTypes["EmployeeUpdateResult"]],
upsertEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null,	update:ValueTypes["EmployeeUpdateInput"],	create:ValueTypes["EmployeeCreateInput"]},ValueTypes["EmployeeUpsertResult"]],
createEmployeeItem?: [{	data:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["EmployeeItemCreateResult"]],
deleteEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null},ValueTypes["EmployeeItemDeleteResult"]],
updateEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null,	data:ValueTypes["EmployeeItemUpdateInput"]},ValueTypes["EmployeeItemUpdateResult"]],
upsertEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null,	update:ValueTypes["EmployeeItemUpdateInput"],	create:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["EmployeeItemUpsertResult"]],
createEmployeeList?: [{	data:ValueTypes["EmployeeListCreateInput"]},ValueTypes["EmployeeListCreateResult"]],
deleteEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeListDeleteResult"]],
updateEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null,	data:ValueTypes["EmployeeListUpdateInput"]},ValueTypes["EmployeeListUpdateResult"]],
upsertEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null,	update:ValueTypes["EmployeeListUpdateInput"],	create:ValueTypes["EmployeeListCreateInput"]},ValueTypes["EmployeeListUpsertResult"]],
createEmployeeLocale?: [{	data:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["EmployeeLocaleCreateResult"]],
deleteEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocaleDeleteResult"]],
updateEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	data:ValueTypes["EmployeeLocaleUpdateInput"]},ValueTypes["EmployeeLocaleUpdateResult"]],
upsertEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	update:ValueTypes["EmployeeLocaleUpdateInput"],	create:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["EmployeeLocaleUpsertResult"]],
createPhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerCreateResult"]],
deletePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["PhotographerDeleteResult"]],
updatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["PhotographerUpdateResult"]],
upsertPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	update:ValueTypes["PhotographerUpdateInput"],	create:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerUpsertResult"]],
createDefinitionItem?: [{	data:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["DefinitionItemCreateResult"]],
deleteDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null},ValueTypes["DefinitionItemDeleteResult"]],
updateDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null,	data:ValueTypes["DefinitionItemUpdateInput"]},ValueTypes["DefinitionItemUpdateResult"]],
upsertDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null,	update:ValueTypes["DefinitionItemUpdateInput"],	create:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["DefinitionItemUpsertResult"]],
createDefinitionList?: [{	data:ValueTypes["DefinitionListCreateInput"]},ValueTypes["DefinitionListCreateResult"]],
deleteDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionListDeleteResult"]],
updateDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null,	data:ValueTypes["DefinitionListUpdateInput"]},ValueTypes["DefinitionListUpdateResult"]],
upsertDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null,	update:ValueTypes["DefinitionListUpdateInput"],	create:ValueTypes["DefinitionListCreateInput"]},ValueTypes["DefinitionListUpsertResult"]],
createLogoItem?: [{	data:ValueTypes["LogoItemCreateInput"]},ValueTypes["LogoItemCreateResult"]],
deleteLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null},ValueTypes["LogoItemDeleteResult"]],
updateLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null,	data:ValueTypes["LogoItemUpdateInput"]},ValueTypes["LogoItemUpdateResult"]],
upsertLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null,	update:ValueTypes["LogoItemUpdateInput"],	create:ValueTypes["LogoItemCreateInput"]},ValueTypes["LogoItemUpsertResult"]],
createLogoList?: [{	data:ValueTypes["LogoListCreateInput"]},ValueTypes["LogoListCreateResult"]],
deleteLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoListDeleteResult"]],
updateLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null,	data:ValueTypes["LogoListUpdateInput"]},ValueTypes["LogoListUpdateResult"]],
upsertLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null,	update:ValueTypes["LogoListUpdateInput"],	create:ValueTypes["LogoListCreateInput"]},ValueTypes["LogoListUpsertResult"]],
createStrategySchema?: [{	data:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["StrategySchemaCreateResult"]],
deleteStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null},ValueTypes["StrategySchemaDeleteResult"]],
updateStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null,	data:ValueTypes["StrategySchemaUpdateInput"]},ValueTypes["StrategySchemaUpdateResult"]],
upsertStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null,	update:ValueTypes["StrategySchemaUpdateInput"],	create:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["StrategySchemaUpsertResult"]],
createStrategySchemaGroup?: [{	data:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["StrategySchemaGroupCreateResult"]],
deleteStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroupDeleteResult"]],
updateStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	data:ValueTypes["StrategySchemaGroupUpdateInput"]},ValueTypes["StrategySchemaGroupUpdateResult"]],
upsertStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	update:ValueTypes["StrategySchemaGroupUpdateInput"],	create:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["StrategySchemaGroupUpsertResult"]],
createStrategySchemaGroupItem?: [{	data:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["StrategySchemaGroupItemCreateResult"]],
deleteStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null},ValueTypes["StrategySchemaGroupItemDeleteResult"]],
updateStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	data:ValueTypes["StrategySchemaGroupItemUpdateInput"]},ValueTypes["StrategySchemaGroupItemUpdateResult"]],
upsertStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	update:ValueTypes["StrategySchemaGroupItemUpdateInput"],	create:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["StrategySchemaGroupItemUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createContactForm?: [{	data:ValueTypes["ContactFormCreateInput"]},ValueTypes["ContactFormCreateResult"]],
deleteContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactFormDeleteResult"]],
updateContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null,	data:ValueTypes["ContactFormUpdateInput"]},ValueTypes["ContactFormUpdateResult"]],
upsertContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null,	update:ValueTypes["ContactFormUpdateInput"],	create:ValueTypes["ContactFormCreateInput"]},ValueTypes["ContactFormUpsertResult"]],
createContactFormLocale?: [{	data:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["ContactFormLocaleCreateResult"]],
deleteContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocaleDeleteResult"]],
updateContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	data:ValueTypes["ContactFormLocaleUpdateInput"]},ValueTypes["ContactFormLocaleUpdateResult"]],
upsertContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	update:ValueTypes["ContactFormLocaleUpdateInput"],	create:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["ContactFormLocaleUpsertResult"]],
createContactSubscription?: [{	data:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["ContactSubscriptionCreateResult"]],
deleteContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null},ValueTypes["ContactSubscriptionDeleteResult"]],
updateContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	data:ValueTypes["ContactSubscriptionUpdateInput"]},ValueTypes["ContactSubscriptionUpdateResult"]],
upsertContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	update:ValueTypes["ContactSubscriptionUpdateInput"],	create:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["ContactSubscriptionUpsertResult"]],
createContactTypeItem?: [{	data:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["ContactTypeItemCreateResult"]],
deleteContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItemDeleteResult"]],
updateContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null,	data:ValueTypes["ContactTypeItemUpdateInput"]},ValueTypes["ContactTypeItemUpdateResult"]],
upsertContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null,	update:ValueTypes["ContactTypeItemUpdateInput"],	create:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["ContactTypeItemUpsertResult"]],
createFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	data:ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	update:ValueTypes["FileUpdateInput"],	create:ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
transaction?: [{	options?:ValueTypes["MutationTransactionOptions"] | null},ValueTypes["MutationTransaction"]],
	query?:ValueTypes["Query"],
generateUploadUrl?: [{	contentType:string,	expiration?:number | null,	prefix?:string | null},ValueTypes["S3SignedUpload"]],
generateReadUrl?: [{	objectKey:string,	expiration?:number | null},ValueTypes["S3SignedRead"]],
		__typename?: true
}>;
	["ContactPageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationResult"]:AliasType<{
		ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"];
		['...on ContactPageCreateResult']?: Omit<ValueTypes["ContactPageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageDeleteResult']?: Omit<ValueTypes["ContactPageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageUpdateResult']?: Omit<ValueTypes["ContactPageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageUpsertResult']?: Omit<ValueTypes["ContactPageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageLocaleCreateResult']?: Omit<ValueTypes["ContactPageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageLocaleDeleteResult']?: Omit<ValueTypes["ContactPageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageLocaleUpdateResult']?: Omit<ValueTypes["ContactPageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactPageLocaleUpsertResult']?: Omit<ValueTypes["ContactPageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentCreateResult']?: Omit<ValueTypes["ContentCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentDeleteResult']?: Omit<ValueTypes["ContentDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpdateResult']?: Omit<ValueTypes["ContentUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentUpsertResult']?: Omit<ValueTypes["ContentUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockCreateResult']?: Omit<ValueTypes["ContentBlockCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockDeleteResult']?: Omit<ValueTypes["ContentBlockDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpdateResult']?: Omit<ValueTypes["ContentBlockUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentBlockUpsertResult']?: Omit<ValueTypes["ContentBlockUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceCreateResult']?: Omit<ValueTypes["ContentReferenceCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceDeleteResult']?: Omit<ValueTypes["ContentReferenceDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpdateResult']?: Omit<ValueTypes["ContentReferenceUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContentReferenceUpsertResult']?: Omit<ValueTypes["ContentReferenceUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterCreateResult']?: Omit<ValueTypes["FooterCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterDeleteResult']?: Omit<ValueTypes["FooterDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpdateResult']?: Omit<ValueTypes["FooterUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterUpsertResult']?: Omit<ValueTypes["FooterUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleCreateResult']?: Omit<ValueTypes["FooterLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleDeleteResult']?: Omit<ValueTypes["FooterLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpdateResult']?: Omit<ValueTypes["FooterLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FooterLocaleUpsertResult']?: Omit<ValueTypes["FooterLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderCreateResult']?: Omit<ValueTypes["HeaderCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderDeleteResult']?: Omit<ValueTypes["HeaderDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpdateResult']?: Omit<ValueTypes["HeaderUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderUpsertResult']?: Omit<ValueTypes["HeaderUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkCreateResult']?: Omit<ValueTypes["HeaderLinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkDeleteResult']?: Omit<ValueTypes["HeaderLinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpdateResult']?: Omit<ValueTypes["HeaderLinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLinkUpsertResult']?: Omit<ValueTypes["HeaderLinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleCreateResult']?: Omit<ValueTypes["HeaderLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleDeleteResult']?: Omit<ValueTypes["HeaderLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpdateResult']?: Omit<ValueTypes["HeaderLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HeaderLocaleUpsertResult']?: Omit<ValueTypes["HeaderLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageCreateResult']?: Omit<ValueTypes["HomePageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageDeleteResult']?: Omit<ValueTypes["HomePageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpdateResult']?: Omit<ValueTypes["HomePageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageUpsertResult']?: Omit<ValueTypes["HomePageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleCreateResult']?: Omit<ValueTypes["HomePageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleDeleteResult']?: Omit<ValueTypes["HomePageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleUpdateResult']?: Omit<ValueTypes["HomePageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on HomePageLocaleUpsertResult']?: Omit<ValueTypes["HomePageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkCreateResult']?: Omit<ValueTypes["LinkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkDeleteResult']?: Omit<ValueTypes["LinkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpdateResult']?: Omit<ValueTypes["LinkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkUpsertResult']?: Omit<ValueTypes["LinkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableCreateResult']?: Omit<ValueTypes["LinkableCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableDeleteResult']?: Omit<ValueTypes["LinkableDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpdateResult']?: Omit<ValueTypes["LinkableUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LinkableUpsertResult']?: Omit<ValueTypes["LinkableUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleCreateResult']?: Omit<ValueTypes["LocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleDeleteResult']?: Omit<ValueTypes["LocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpdateResult']?: Omit<ValueTypes["LocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LocaleUpsertResult']?: Omit<ValueTypes["LocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumCreateResult']?: Omit<ValueTypes["MediumCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumDeleteResult']?: Omit<ValueTypes["MediumDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpdateResult']?: Omit<ValueTypes["MediumUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumUpsertResult']?: Omit<ValueTypes["MediumUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemCreateResult']?: Omit<ValueTypes["MediumItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemDeleteResult']?: Omit<ValueTypes["MediumItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpdateResult']?: Omit<ValueTypes["MediumItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumItemUpsertResult']?: Omit<ValueTypes["MediumItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListCreateResult']?: Omit<ValueTypes["MediumListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListDeleteResult']?: Omit<ValueTypes["MediumListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpdateResult']?: Omit<ValueTypes["MediumListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on MediumListUpsertResult']?: Omit<ValueTypes["MediumListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageCreateResult']?: Omit<ValueTypes["PageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageDeleteResult']?: Omit<ValueTypes["PageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpdateResult']?: Omit<ValueTypes["PageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageUpsertResult']?: Omit<ValueTypes["PageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleCreateResult']?: Omit<ValueTypes["PageLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleDeleteResult']?: Omit<ValueTypes["PageLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpdateResult']?: Omit<ValueTypes["PageLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PageLocaleUpsertResult']?: Omit<ValueTypes["PageLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultCreateResult']?: Omit<ValueTypes["SeoDefaultCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultDeleteResult']?: Omit<ValueTypes["SeoDefaultDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultUpdateResult']?: Omit<ValueTypes["SeoDefaultUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultUpsertResult']?: Omit<ValueTypes["SeoDefaultUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleCreateResult']?: Omit<ValueTypes["SeoDefaultLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleDeleteResult']?: Omit<ValueTypes["SeoDefaultLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpdateResult']?: Omit<ValueTypes["SeoDefaultLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDefaultLocaleUpsertResult']?: Omit<ValueTypes["SeoDefaultLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoCreateResult']?: Omit<ValueTypes["VideoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoDeleteResult']?: Omit<ValueTypes["VideoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpdateResult']?: Omit<ValueTypes["VideoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on VideoUpsertResult']?: Omit<ValueTypes["VideoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageCreateResult']?: Omit<ValueTypes["ImageCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageDeleteResult']?: Omit<ValueTypes["ImageDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpdateResult']?: Omit<ValueTypes["ImageUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ImageUpsertResult']?: Omit<ValueTypes["ImageUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoCreateResult']?: Omit<ValueTypes["SeoCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoDeleteResult']?: Omit<ValueTypes["SeoDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpdateResult']?: Omit<ValueTypes["SeoUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on SeoUpsertResult']?: Omit<ValueTypes["SeoUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainCreateResult']?: Omit<ValueTypes["TranslationDomainCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainDeleteResult']?: Omit<ValueTypes["TranslationDomainDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpdateResult']?: Omit<ValueTypes["TranslationDomainUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationDomainUpsertResult']?: Omit<ValueTypes["TranslationDomainUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueCreateResult']?: Omit<ValueTypes["TranslationCatalogueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueDeleteResult']?: Omit<ValueTypes["TranslationCatalogueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpdateResult']?: Omit<ValueTypes["TranslationCatalogueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCatalogueUpsertResult']?: Omit<ValueTypes["TranslationCatalogueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierCreateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierDeleteResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpdateResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationCataloguesIdentifierUpsertResult']?: Omit<ValueTypes["TranslationCataloguesIdentifierUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyCreateResult']?: Omit<ValueTypes["TranslationKeyCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyDeleteResult']?: Omit<ValueTypes["TranslationKeyDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpdateResult']?: Omit<ValueTypes["TranslationKeyUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationKeyUpsertResult']?: Omit<ValueTypes["TranslationKeyUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueCreateResult']?: Omit<ValueTypes["TranslationValueCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueDeleteResult']?: Omit<ValueTypes["TranslationValueDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpdateResult']?: Omit<ValueTypes["TranslationValueUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on TranslationValueUpsertResult']?: Omit<ValueTypes["TranslationValueUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BranchesCreateResult']?: Omit<ValueTypes["BranchesCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BranchesDeleteResult']?: Omit<ValueTypes["BranchesDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BranchesUpdateResult']?: Omit<ValueTypes["BranchesUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BranchesUpsertResult']?: Omit<ValueTypes["BranchesUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GraphicDesignerCreateResult']?: Omit<ValueTypes["GraphicDesignerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GraphicDesignerDeleteResult']?: Omit<ValueTypes["GraphicDesignerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GraphicDesignerUpdateResult']?: Omit<ValueTypes["GraphicDesignerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GraphicDesignerUpsertResult']?: Omit<ValueTypes["GraphicDesignerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventCreateResult']?: Omit<ValueTypes["EventCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventDeleteResult']?: Omit<ValueTypes["EventDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpdateResult']?: Omit<ValueTypes["EventUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventUpsertResult']?: Omit<ValueTypes["EventUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleCreateResult']?: Omit<ValueTypes["EventLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleDeleteResult']?: Omit<ValueTypes["EventLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleUpdateResult']?: Omit<ValueTypes["EventLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventLocaleUpsertResult']?: Omit<ValueTypes["EventLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkCreateResult']?: Omit<ValueTypes["ArtworkCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkDeleteResult']?: Omit<ValueTypes["ArtworkDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkUpdateResult']?: Omit<ValueTypes["ArtworkUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkUpsertResult']?: Omit<ValueTypes["ArtworkUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkLocaleCreateResult']?: Omit<ValueTypes["ArtworkLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkLocaleDeleteResult']?: Omit<ValueTypes["ArtworkLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkLocaleUpdateResult']?: Omit<ValueTypes["ArtworkLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkLocaleUpsertResult']?: Omit<ValueTypes["ArtworkLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownItemCreateResult']?: Omit<ValueTypes["DropDownItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownItemDeleteResult']?: Omit<ValueTypes["DropDownItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownItemUpdateResult']?: Omit<ValueTypes["DropDownItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownItemUpsertResult']?: Omit<ValueTypes["DropDownItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownListCreateResult']?: Omit<ValueTypes["DropDownListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownListDeleteResult']?: Omit<ValueTypes["DropDownListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownListUpdateResult']?: Omit<ValueTypes["DropDownListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DropDownListUpsertResult']?: Omit<ValueTypes["DropDownListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkItemCreateResult']?: Omit<ValueTypes["ArtworkItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkItemDeleteResult']?: Omit<ValueTypes["ArtworkItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkItemUpdateResult']?: Omit<ValueTypes["ArtworkItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkItemUpsertResult']?: Omit<ValueTypes["ArtworkItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkListCreateResult']?: Omit<ValueTypes["ArtworkListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkListDeleteResult']?: Omit<ValueTypes["ArtworkListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkListUpdateResult']?: Omit<ValueTypes["ArtworkListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkListUpsertResult']?: Omit<ValueTypes["ArtworkListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionCreateResult']?: Omit<ValueTypes["ArtworkSelectionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionDeleteResult']?: Omit<ValueTypes["ArtworkSelectionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionUpdateResult']?: Omit<ValueTypes["ArtworkSelectionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionUpsertResult']?: Omit<ValueTypes["ArtworkSelectionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionItemCreateResult']?: Omit<ValueTypes["ArtworkSelectionItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionItemDeleteResult']?: Omit<ValueTypes["ArtworkSelectionItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionItemUpdateResult']?: Omit<ValueTypes["ArtworkSelectionItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionItemUpsertResult']?: Omit<ValueTypes["ArtworkSelectionItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionListCreateResult']?: Omit<ValueTypes["ArtworkSelectionListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionListDeleteResult']?: Omit<ValueTypes["ArtworkSelectionListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionListUpdateResult']?: Omit<ValueTypes["ArtworkSelectionListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionListUpsertResult']?: Omit<ValueTypes["ArtworkSelectionListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionLocaleCreateResult']?: Omit<ValueTypes["ArtworkSelectionLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionLocaleDeleteResult']?: Omit<ValueTypes["ArtworkSelectionLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionLocaleUpdateResult']?: Omit<ValueTypes["ArtworkSelectionLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ArtworkSelectionLocaleUpsertResult']?: Omit<ValueTypes["ArtworkSelectionLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventItemCreateResult']?: Omit<ValueTypes["EventItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventItemDeleteResult']?: Omit<ValueTypes["EventItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventItemUpdateResult']?: Omit<ValueTypes["EventItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventItemUpsertResult']?: Omit<ValueTypes["EventItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventListCreateResult']?: Omit<ValueTypes["EventListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventListDeleteResult']?: Omit<ValueTypes["EventListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventListUpdateResult']?: Omit<ValueTypes["EventListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EventListUpsertResult']?: Omit<ValueTypes["EventListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxItemCreateResult']?: Omit<ValueTypes["BoxItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxItemDeleteResult']?: Omit<ValueTypes["BoxItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxItemUpdateResult']?: Omit<ValueTypes["BoxItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxItemUpsertResult']?: Omit<ValueTypes["BoxItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxListCreateResult']?: Omit<ValueTypes["BoxListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxListDeleteResult']?: Omit<ValueTypes["BoxListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxListUpdateResult']?: Omit<ValueTypes["BoxListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on BoxListUpsertResult']?: Omit<ValueTypes["BoxListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormCreateResult']?: Omit<ValueTypes["NewsletterFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormDeleteResult']?: Omit<ValueTypes["NewsletterFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormUpdateResult']?: Omit<ValueTypes["NewsletterFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormUpsertResult']?: Omit<ValueTypes["NewsletterFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterTypeItemCreateResult']?: Omit<ValueTypes["NewsletterTypeItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterTypeItemDeleteResult']?: Omit<ValueTypes["NewsletterTypeItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterTypeItemUpdateResult']?: Omit<ValueTypes["NewsletterTypeItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterTypeItemUpsertResult']?: Omit<ValueTypes["NewsletterTypeItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormLocaleCreateResult']?: Omit<ValueTypes["NewsletterFormLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormLocaleDeleteResult']?: Omit<ValueTypes["NewsletterFormLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormLocaleUpdateResult']?: Omit<ValueTypes["NewsletterFormLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterFormLocaleUpsertResult']?: Omit<ValueTypes["NewsletterFormLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSubscriptionCreateResult']?: Omit<ValueTypes["NewsletterSubscriptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSubscriptionDeleteResult']?: Omit<ValueTypes["NewsletterSubscriptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSubscriptionUpdateResult']?: Omit<ValueTypes["NewsletterSubscriptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on NewsletterSubscriptionUpsertResult']?: Omit<ValueTypes["NewsletterSubscriptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartCreateResult']?: Omit<ValueTypes["ChartCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartDeleteResult']?: Omit<ValueTypes["ChartDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartUpdateResult']?: Omit<ValueTypes["ChartUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartUpsertResult']?: Omit<ValueTypes["ChartUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartDataCreateResult']?: Omit<ValueTypes["ChartDataCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartDataDeleteResult']?: Omit<ValueTypes["ChartDataDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartDataUpdateResult']?: Omit<ValueTypes["ChartDataUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ChartDataUpsertResult']?: Omit<ValueTypes["ChartDataUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeCreateResult']?: Omit<ValueTypes["EmployeeCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeDeleteResult']?: Omit<ValueTypes["EmployeeDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeUpdateResult']?: Omit<ValueTypes["EmployeeUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeUpsertResult']?: Omit<ValueTypes["EmployeeUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeItemCreateResult']?: Omit<ValueTypes["EmployeeItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeItemDeleteResult']?: Omit<ValueTypes["EmployeeItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeItemUpdateResult']?: Omit<ValueTypes["EmployeeItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeItemUpsertResult']?: Omit<ValueTypes["EmployeeItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeListCreateResult']?: Omit<ValueTypes["EmployeeListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeListDeleteResult']?: Omit<ValueTypes["EmployeeListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeListUpdateResult']?: Omit<ValueTypes["EmployeeListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeListUpsertResult']?: Omit<ValueTypes["EmployeeListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeLocaleCreateResult']?: Omit<ValueTypes["EmployeeLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeLocaleDeleteResult']?: Omit<ValueTypes["EmployeeLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeLocaleUpdateResult']?: Omit<ValueTypes["EmployeeLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on EmployeeLocaleUpsertResult']?: Omit<ValueTypes["EmployeeLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerCreateResult']?: Omit<ValueTypes["PhotographerCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerDeleteResult']?: Omit<ValueTypes["PhotographerDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerUpdateResult']?: Omit<ValueTypes["PhotographerUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on PhotographerUpsertResult']?: Omit<ValueTypes["PhotographerUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionItemCreateResult']?: Omit<ValueTypes["DefinitionItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionItemDeleteResult']?: Omit<ValueTypes["DefinitionItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionItemUpdateResult']?: Omit<ValueTypes["DefinitionItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionItemUpsertResult']?: Omit<ValueTypes["DefinitionItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionListCreateResult']?: Omit<ValueTypes["DefinitionListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionListDeleteResult']?: Omit<ValueTypes["DefinitionListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionListUpdateResult']?: Omit<ValueTypes["DefinitionListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on DefinitionListUpsertResult']?: Omit<ValueTypes["DefinitionListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoItemCreateResult']?: Omit<ValueTypes["LogoItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoItemDeleteResult']?: Omit<ValueTypes["LogoItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoItemUpdateResult']?: Omit<ValueTypes["LogoItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoItemUpsertResult']?: Omit<ValueTypes["LogoItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoListCreateResult']?: Omit<ValueTypes["LogoListCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoListDeleteResult']?: Omit<ValueTypes["LogoListDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoListUpdateResult']?: Omit<ValueTypes["LogoListUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on LogoListUpsertResult']?: Omit<ValueTypes["LogoListUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaCreateResult']?: Omit<ValueTypes["StrategySchemaCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaDeleteResult']?: Omit<ValueTypes["StrategySchemaDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaUpdateResult']?: Omit<ValueTypes["StrategySchemaUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaUpsertResult']?: Omit<ValueTypes["StrategySchemaUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupCreateResult']?: Omit<ValueTypes["StrategySchemaGroupCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupDeleteResult']?: Omit<ValueTypes["StrategySchemaGroupDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupUpdateResult']?: Omit<ValueTypes["StrategySchemaGroupUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupUpsertResult']?: Omit<ValueTypes["StrategySchemaGroupUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupItemCreateResult']?: Omit<ValueTypes["StrategySchemaGroupItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupItemDeleteResult']?: Omit<ValueTypes["StrategySchemaGroupItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupItemUpdateResult']?: Omit<ValueTypes["StrategySchemaGroupItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on StrategySchemaGroupItemUpsertResult']?: Omit<ValueTypes["StrategySchemaGroupItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectCreateResult']?: Omit<ValueTypes["RedirectCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectDeleteResult']?: Omit<ValueTypes["RedirectDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpdateResult']?: Omit<ValueTypes["RedirectUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on RedirectUpsertResult']?: Omit<ValueTypes["RedirectUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryCreateResult']?: Omit<ValueTypes["GalleryCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryDeleteResult']?: Omit<ValueTypes["GalleryDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpdateResult']?: Omit<ValueTypes["GalleryUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryUpsertResult']?: Omit<ValueTypes["GalleryUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemCreateResult']?: Omit<ValueTypes["GalleryItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemDeleteResult']?: Omit<ValueTypes["GalleryItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpdateResult']?: Omit<ValueTypes["GalleryItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on GalleryItemUpsertResult']?: Omit<ValueTypes["GalleryItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormCreateResult']?: Omit<ValueTypes["ContactFormCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormDeleteResult']?: Omit<ValueTypes["ContactFormDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormUpdateResult']?: Omit<ValueTypes["ContactFormUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormUpsertResult']?: Omit<ValueTypes["ContactFormUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormLocaleCreateResult']?: Omit<ValueTypes["ContactFormLocaleCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormLocaleDeleteResult']?: Omit<ValueTypes["ContactFormLocaleDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormLocaleUpdateResult']?: Omit<ValueTypes["ContactFormLocaleUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactFormLocaleUpsertResult']?: Omit<ValueTypes["ContactFormLocaleUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubscriptionCreateResult']?: Omit<ValueTypes["ContactSubscriptionCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubscriptionDeleteResult']?: Omit<ValueTypes["ContactSubscriptionDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubscriptionUpdateResult']?: Omit<ValueTypes["ContactSubscriptionUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactSubscriptionUpsertResult']?: Omit<ValueTypes["ContactSubscriptionUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactTypeItemCreateResult']?: Omit<ValueTypes["ContactTypeItemCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactTypeItemDeleteResult']?: Omit<ValueTypes["ContactTypeItemDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactTypeItemUpdateResult']?: Omit<ValueTypes["ContactTypeItemUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on ContactTypeItemUpsertResult']?: Omit<ValueTypes["ContactTypeItemUpsertResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileCreateResult']?: Omit<ValueTypes["FileCreateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileDeleteResult']?: Omit<ValueTypes["FileDeleteResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpdateResult']?: Omit<ValueTypes["FileUpdateResult"],keyof ValueTypes["MutationResult"]>;
		['...on FileUpsertResult']?: Omit<ValueTypes["FileUpsertResult"],keyof ValueTypes["MutationResult"]>;
		__typename?: true
}>;
	["_MutationError"]: AliasType<{
	path?:ValueTypes["_PathFragment"],
	paths?:ValueTypes["_PathFragment"],
	type?:true,
	message?:true,
		__typename?: true
}>;
	["_MutationErrorType"]:_MutationErrorType;
	["ContactPageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
		__typename?: true
}>;
	["ContactPageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactPageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactPageLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactPageLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPageLocale"],
		__typename?: true
}>;
	["ContactPageLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactPageLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactPageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
		__typename?: true
}>;
	["ContentUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Content"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
		__typename?: true
}>;
	["ContentBlockUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentBlockUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentBlock"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
		__typename?: true
}>;
	["ContentReferenceUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContentReferenceUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContentReference"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
		__typename?: true
}>;
	["FooterUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Footer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
		__typename?: true
}>;
	["FooterLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FooterLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["FooterLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
		__typename?: true
}>;
	["HeaderUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Header"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
		__typename?: true
}>;
	["HeaderLinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLink"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
		__typename?: true
}>;
	["HeaderLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HeaderLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HeaderLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
		__typename?: true
}>;
	["HomePageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePage"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
		__typename?: true
}>;
	["HomePageLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["HomePageLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["HomePageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
		__typename?: true
}>;
	["LinkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Link"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
		__typename?: true
}>;
	["LinkableUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LinkableUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Linkable"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
		__typename?: true
}>;
	["LocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Locale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
		__typename?: true
}>;
	["MediumUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Medium"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
		__typename?: true
}>;
	["MediumItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
		__typename?: true
}>;
	["MediumListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MediumListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["MediumList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
		__typename?: true
}>;
	["PageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Page"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
		__typename?: true
}>;
	["PageLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PageLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["PageLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
		__typename?: true
}>;
	["SeoDefaultUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefault"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
		__typename?: true
}>;
	["SeoDefaultLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDefaultLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["SeoDefaultLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
		__typename?: true
}>;
	["VideoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["VideoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Video"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
		__typename?: true
}>;
	["ImageUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ImageUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Image"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
		__typename?: true
}>;
	["SeoUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["SeoUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Seo"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationDomainCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationDomainDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
		__typename?: true
}>;
	["TranslationDomainUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationDomainUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationDomain"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCatalogueCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCatalogueDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
		__typename?: true
}>;
	["TranslationCatalogueUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCatalogueUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCatalogue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationCataloguesIdentifierUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationCataloguesIdentifier"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationKeyCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationKeyDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
		__typename?: true
}>;
	["TranslationKeyUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationKeyUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationKey"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationValueCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationValueDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
		__typename?: true
}>;
	["TranslationValueUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["TranslationValueUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["TranslationValue"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BranchesCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Branches"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BranchesDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Branches"],
		__typename?: true
}>;
	["BranchesUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Branches"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BranchesUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Branches"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GraphicDesignerCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GraphicDesigner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GraphicDesignerDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GraphicDesigner"],
		__typename?: true
}>;
	["GraphicDesignerUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GraphicDesigner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GraphicDesignerUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GraphicDesigner"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
		__typename?: true
}>;
	["EventUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Event"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
		__typename?: true
}>;
	["EventLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Artwork"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Artwork"],
		__typename?: true
}>;
	["ArtworkUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Artwork"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Artwork"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkLocale"],
		__typename?: true
}>;
	["ArtworkLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownItem"],
		__typename?: true
}>;
	["DropDownItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownList"],
		__typename?: true
}>;
	["DropDownListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DropDownListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DropDownList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkItem"],
		__typename?: true
}>;
	["ArtworkItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkList"],
		__typename?: true
}>;
	["ArtworkListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelection"],
		__typename?: true
}>;
	["ArtworkSelectionUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelection"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionItem"],
		__typename?: true
}>;
	["ArtworkSelectionItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionList"],
		__typename?: true
}>;
	["ArtworkSelectionListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionLocale"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ArtworkSelectionLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ArtworkSelectionLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventItem"],
		__typename?: true
}>;
	["EventItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventList"],
		__typename?: true
}>;
	["EventListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EventListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EventList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxItem"],
		__typename?: true
}>;
	["BoxItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxList"],
		__typename?: true
}>;
	["BoxListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["BoxListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["BoxList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterForm"],
		__typename?: true
}>;
	["NewsletterFormUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterTypeItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterTypeItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterTypeItem"],
		__typename?: true
}>;
	["NewsletterTypeItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterTypeItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterFormLocale"],
		__typename?: true
}>;
	["NewsletterFormLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterFormLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterSubscriptionCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterSubscriptionDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSubscription"],
		__typename?: true
}>;
	["NewsletterSubscriptionUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["NewsletterSubscriptionUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["NewsletterSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Chart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Chart"],
		__typename?: true
}>;
	["ChartUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Chart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Chart"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartDataCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChartData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartDataDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChartData"],
		__typename?: true
}>;
	["ChartDataUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChartData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ChartDataUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ChartData"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Employee"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Employee"],
		__typename?: true
}>;
	["EmployeeUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Employee"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Employee"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeItem"],
		__typename?: true
}>;
	["EmployeeItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeList"],
		__typename?: true
}>;
	["EmployeeListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeLocale"],
		__typename?: true
}>;
	["EmployeeLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["EmployeeLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["EmployeeLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
		__typename?: true
}>;
	["PhotographerUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["PhotographerUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Photographer"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionItem"],
		__typename?: true
}>;
	["DefinitionItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionList"],
		__typename?: true
}>;
	["DefinitionListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["DefinitionListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["DefinitionList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoItem"],
		__typename?: true
}>;
	["LogoItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoListCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoListDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoList"],
		__typename?: true
}>;
	["LogoListUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["LogoListUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["LogoList"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchema"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchema"],
		__typename?: true
}>;
	["StrategySchemaUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchema"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchema"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroup"],
		__typename?: true
}>;
	["StrategySchemaGroupUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroup"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroupItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroupItem"],
		__typename?: true
}>;
	["StrategySchemaGroupItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroupItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["StrategySchemaGroupItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["StrategySchemaGroupItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
		__typename?: true
}>;
	["RedirectUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["RedirectUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Redirect"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
		__typename?: true
}>;
	["GalleryUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["Gallery"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
		__typename?: true
}>;
	["GalleryItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["GalleryItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["GalleryItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactForm"],
		__typename?: true
}>;
	["ContactFormUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactForm"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormLocaleCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormLocaleDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormLocale"],
		__typename?: true
}>;
	["ContactFormLocaleUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactFormLocaleUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactFormLocale"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactSubscriptionCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactSubscriptionDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubscription"],
		__typename?: true
}>;
	["ContactSubscriptionUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactSubscriptionUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactSubscription"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactTypeItemCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactTypeItemDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactTypeItem"],
		__typename?: true
}>;
	["ContactTypeItemUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["ContactTypeItemUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["ContactTypeItem"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileCreateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileDeleteResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
		__typename?: true
}>;
	["FileUpdateResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["FileUpsertResult"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	node?:ValueTypes["File"],
	validation?:ValueTypes["_ValidationResult"],
		__typename?: true
}>;
	["MutationTransaction"]: AliasType<{
	ok?:true,
	errorMessage?:true,
	errors?:ValueTypes["_MutationError"],
	validation?:ValueTypes["_ValidationResult"],
createContactPage?: [{	data:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageCreateResult"]],
deleteContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null},ValueTypes["ContactPageDeleteResult"]],
updateContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	data:ValueTypes["ContactPageUpdateInput"]},ValueTypes["ContactPageUpdateResult"]],
upsertContactPage?: [{	by:ValueTypes["ContactPageUniqueWhere"],	filter?:ValueTypes["ContactPageWhere"] | null,	update:ValueTypes["ContactPageUpdateInput"],	create:ValueTypes["ContactPageCreateInput"]},ValueTypes["ContactPageUpsertResult"]],
createContactPageLocale?: [{	data:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["ContactPageLocaleCreateResult"]],
deleteContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null},ValueTypes["ContactPageLocaleDeleteResult"]],
updateContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	data:ValueTypes["ContactPageLocaleUpdateInput"]},ValueTypes["ContactPageLocaleUpdateResult"]],
upsertContactPageLocale?: [{	by:ValueTypes["ContactPageLocaleUniqueWhere"],	filter?:ValueTypes["ContactPageLocaleWhere"] | null,	update:ValueTypes["ContactPageLocaleUpdateInput"],	create:ValueTypes["ContactPageLocaleCreateInput"]},ValueTypes["ContactPageLocaleUpsertResult"]],
createContent?: [{	data:ValueTypes["ContentCreateInput"]},ValueTypes["ContentCreateResult"]],
deleteContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null},ValueTypes["ContentDeleteResult"]],
updateContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	data:ValueTypes["ContentUpdateInput"]},ValueTypes["ContentUpdateResult"]],
upsertContent?: [{	by:ValueTypes["ContentUniqueWhere"],	filter?:ValueTypes["ContentWhere"] | null,	update:ValueTypes["ContentUpdateInput"],	create:ValueTypes["ContentCreateInput"]},ValueTypes["ContentUpsertResult"]],
createContentBlock?: [{	data:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockCreateResult"]],
deleteContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null},ValueTypes["ContentBlockDeleteResult"]],
updateContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	data:ValueTypes["ContentBlockUpdateInput"]},ValueTypes["ContentBlockUpdateResult"]],
upsertContentBlock?: [{	by:ValueTypes["ContentBlockUniqueWhere"],	filter?:ValueTypes["ContentBlockWhere"] | null,	update:ValueTypes["ContentBlockUpdateInput"],	create:ValueTypes["ContentBlockCreateInput"]},ValueTypes["ContentBlockUpsertResult"]],
createContentReference?: [{	data:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceCreateResult"]],
deleteContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null},ValueTypes["ContentReferenceDeleteResult"]],
updateContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	data:ValueTypes["ContentReferenceUpdateInput"]},ValueTypes["ContentReferenceUpdateResult"]],
upsertContentReference?: [{	by:ValueTypes["ContentReferenceUniqueWhere"],	filter?:ValueTypes["ContentReferenceWhere"] | null,	update:ValueTypes["ContentReferenceUpdateInput"],	create:ValueTypes["ContentReferenceCreateInput"]},ValueTypes["ContentReferenceUpsertResult"]],
createFooter?: [{	data:ValueTypes["FooterCreateInput"]},ValueTypes["FooterCreateResult"]],
deleteFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null},ValueTypes["FooterDeleteResult"]],
updateFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	data:ValueTypes["FooterUpdateInput"]},ValueTypes["FooterUpdateResult"]],
upsertFooter?: [{	by:ValueTypes["FooterUniqueWhere"],	filter?:ValueTypes["FooterWhere"] | null,	update:ValueTypes["FooterUpdateInput"],	create:ValueTypes["FooterCreateInput"]},ValueTypes["FooterUpsertResult"]],
createFooterLocale?: [{	data:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleCreateResult"]],
deleteFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null},ValueTypes["FooterLocaleDeleteResult"]],
updateFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	data:ValueTypes["FooterLocaleUpdateInput"]},ValueTypes["FooterLocaleUpdateResult"]],
upsertFooterLocale?: [{	by:ValueTypes["FooterLocaleUniqueWhere"],	filter?:ValueTypes["FooterLocaleWhere"] | null,	update:ValueTypes["FooterLocaleUpdateInput"],	create:ValueTypes["FooterLocaleCreateInput"]},ValueTypes["FooterLocaleUpsertResult"]],
createHeader?: [{	data:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderCreateResult"]],
deleteHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null},ValueTypes["HeaderDeleteResult"]],
updateHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	data:ValueTypes["HeaderUpdateInput"]},ValueTypes["HeaderUpdateResult"]],
upsertHeader?: [{	by:ValueTypes["HeaderUniqueWhere"],	filter?:ValueTypes["HeaderWhere"] | null,	update:ValueTypes["HeaderUpdateInput"],	create:ValueTypes["HeaderCreateInput"]},ValueTypes["HeaderUpsertResult"]],
createHeaderLink?: [{	data:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkCreateResult"]],
deleteHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null},ValueTypes["HeaderLinkDeleteResult"]],
updateHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	data:ValueTypes["HeaderLinkUpdateInput"]},ValueTypes["HeaderLinkUpdateResult"]],
upsertHeaderLink?: [{	by:ValueTypes["HeaderLinkUniqueWhere"],	filter?:ValueTypes["HeaderLinkWhere"] | null,	update:ValueTypes["HeaderLinkUpdateInput"],	create:ValueTypes["HeaderLinkCreateInput"]},ValueTypes["HeaderLinkUpsertResult"]],
createHeaderLocale?: [{	data:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleCreateResult"]],
deleteHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null},ValueTypes["HeaderLocaleDeleteResult"]],
updateHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	data:ValueTypes["HeaderLocaleUpdateInput"]},ValueTypes["HeaderLocaleUpdateResult"]],
upsertHeaderLocale?: [{	by:ValueTypes["HeaderLocaleUniqueWhere"],	filter?:ValueTypes["HeaderLocaleWhere"] | null,	update:ValueTypes["HeaderLocaleUpdateInput"],	create:ValueTypes["HeaderLocaleCreateInput"]},ValueTypes["HeaderLocaleUpsertResult"]],
createHomePage?: [{	data:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageCreateResult"]],
deleteHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null},ValueTypes["HomePageDeleteResult"]],
updateHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	data:ValueTypes["HomePageUpdateInput"]},ValueTypes["HomePageUpdateResult"]],
upsertHomePage?: [{	by:ValueTypes["HomePageUniqueWhere"],	filter?:ValueTypes["HomePageWhere"] | null,	update:ValueTypes["HomePageUpdateInput"],	create:ValueTypes["HomePageCreateInput"]},ValueTypes["HomePageUpsertResult"]],
createHomePageLocale?: [{	data:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["HomePageLocaleCreateResult"]],
deleteHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null},ValueTypes["HomePageLocaleDeleteResult"]],
updateHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null,	data:ValueTypes["HomePageLocaleUpdateInput"]},ValueTypes["HomePageLocaleUpdateResult"]],
upsertHomePageLocale?: [{	by:ValueTypes["HomePageLocaleUniqueWhere"],	filter?:ValueTypes["HomePageLocaleWhere"] | null,	update:ValueTypes["HomePageLocaleUpdateInput"],	create:ValueTypes["HomePageLocaleCreateInput"]},ValueTypes["HomePageLocaleUpsertResult"]],
createLink?: [{	data:ValueTypes["LinkCreateInput"]},ValueTypes["LinkCreateResult"]],
deleteLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null},ValueTypes["LinkDeleteResult"]],
updateLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	data:ValueTypes["LinkUpdateInput"]},ValueTypes["LinkUpdateResult"]],
upsertLink?: [{	by:ValueTypes["LinkUniqueWhere"],	filter?:ValueTypes["LinkWhere"] | null,	update:ValueTypes["LinkUpdateInput"],	create:ValueTypes["LinkCreateInput"]},ValueTypes["LinkUpsertResult"]],
createLinkable?: [{	data:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableCreateResult"]],
deleteLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null},ValueTypes["LinkableDeleteResult"]],
updateLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	data:ValueTypes["LinkableUpdateInput"]},ValueTypes["LinkableUpdateResult"]],
upsertLinkable?: [{	by:ValueTypes["LinkableUniqueWhere"],	filter?:ValueTypes["LinkableWhere"] | null,	update:ValueTypes["LinkableUpdateInput"],	create:ValueTypes["LinkableCreateInput"]},ValueTypes["LinkableUpsertResult"]],
createLocale?: [{	data:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleCreateResult"]],
deleteLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null},ValueTypes["LocaleDeleteResult"]],
updateLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	data:ValueTypes["LocaleUpdateInput"]},ValueTypes["LocaleUpdateResult"]],
upsertLocale?: [{	by:ValueTypes["LocaleUniqueWhere"],	filter?:ValueTypes["LocaleWhere"] | null,	update:ValueTypes["LocaleUpdateInput"],	create:ValueTypes["LocaleCreateInput"]},ValueTypes["LocaleUpsertResult"]],
createMedium?: [{	data:ValueTypes["MediumCreateInput"]},ValueTypes["MediumCreateResult"]],
deleteMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null},ValueTypes["MediumDeleteResult"]],
updateMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	data:ValueTypes["MediumUpdateInput"]},ValueTypes["MediumUpdateResult"]],
upsertMedium?: [{	by:ValueTypes["MediumUniqueWhere"],	filter?:ValueTypes["MediumWhere"] | null,	update:ValueTypes["MediumUpdateInput"],	create:ValueTypes["MediumCreateInput"]},ValueTypes["MediumUpsertResult"]],
createMediumItem?: [{	data:ValueTypes["MediumItemCreateInput"]},ValueTypes["MediumItemCreateResult"]],
deleteMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null},ValueTypes["MediumItemDeleteResult"]],
updateMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null,	data:ValueTypes["MediumItemUpdateInput"]},ValueTypes["MediumItemUpdateResult"]],
upsertMediumItem?: [{	by:ValueTypes["MediumItemUniqueWhere"],	filter?:ValueTypes["MediumItemWhere"] | null,	update:ValueTypes["MediumItemUpdateInput"],	create:ValueTypes["MediumItemCreateInput"]},ValueTypes["MediumItemUpsertResult"]],
createMediumList?: [{	data:ValueTypes["MediumListCreateInput"]},ValueTypes["MediumListCreateResult"]],
deleteMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null},ValueTypes["MediumListDeleteResult"]],
updateMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null,	data:ValueTypes["MediumListUpdateInput"]},ValueTypes["MediumListUpdateResult"]],
upsertMediumList?: [{	by:ValueTypes["MediumListUniqueWhere"],	filter?:ValueTypes["MediumListWhere"] | null,	update:ValueTypes["MediumListUpdateInput"],	create:ValueTypes["MediumListCreateInput"]},ValueTypes["MediumListUpsertResult"]],
createPage?: [{	data:ValueTypes["PageCreateInput"]},ValueTypes["PageCreateResult"]],
deletePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null},ValueTypes["PageDeleteResult"]],
updatePage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	data:ValueTypes["PageUpdateInput"]},ValueTypes["PageUpdateResult"]],
upsertPage?: [{	by:ValueTypes["PageUniqueWhere"],	filter?:ValueTypes["PageWhere"] | null,	update:ValueTypes["PageUpdateInput"],	create:ValueTypes["PageCreateInput"]},ValueTypes["PageUpsertResult"]],
createPageLocale?: [{	data:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleCreateResult"]],
deletePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null},ValueTypes["PageLocaleDeleteResult"]],
updatePageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	data:ValueTypes["PageLocaleUpdateInput"]},ValueTypes["PageLocaleUpdateResult"]],
upsertPageLocale?: [{	by:ValueTypes["PageLocaleUniqueWhere"],	filter?:ValueTypes["PageLocaleWhere"] | null,	update:ValueTypes["PageLocaleUpdateInput"],	create:ValueTypes["PageLocaleCreateInput"]},ValueTypes["PageLocaleUpsertResult"]],
createSeoDefault?: [{	data:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["SeoDefaultCreateResult"]],
deleteSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null},ValueTypes["SeoDefaultDeleteResult"]],
updateSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null,	data:ValueTypes["SeoDefaultUpdateInput"]},ValueTypes["SeoDefaultUpdateResult"]],
upsertSeoDefault?: [{	by:ValueTypes["SeoDefaultUniqueWhere"],	filter?:ValueTypes["SeoDefaultWhere"] | null,	update:ValueTypes["SeoDefaultUpdateInput"],	create:ValueTypes["SeoDefaultCreateInput"]},ValueTypes["SeoDefaultUpsertResult"]],
createSeoDefaultLocale?: [{	data:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["SeoDefaultLocaleCreateResult"]],
deleteSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null},ValueTypes["SeoDefaultLocaleDeleteResult"]],
updateSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	data:ValueTypes["SeoDefaultLocaleUpdateInput"]},ValueTypes["SeoDefaultLocaleUpdateResult"]],
upsertSeoDefaultLocale?: [{	by:ValueTypes["SeoDefaultLocaleUniqueWhere"],	filter?:ValueTypes["SeoDefaultLocaleWhere"] | null,	update:ValueTypes["SeoDefaultLocaleUpdateInput"],	create:ValueTypes["SeoDefaultLocaleCreateInput"]},ValueTypes["SeoDefaultLocaleUpsertResult"]],
createVideo?: [{	data:ValueTypes["VideoCreateInput"]},ValueTypes["VideoCreateResult"]],
deleteVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null},ValueTypes["VideoDeleteResult"]],
updateVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	data:ValueTypes["VideoUpdateInput"]},ValueTypes["VideoUpdateResult"]],
upsertVideo?: [{	by:ValueTypes["VideoUniqueWhere"],	filter?:ValueTypes["VideoWhere"] | null,	update:ValueTypes["VideoUpdateInput"],	create:ValueTypes["VideoCreateInput"]},ValueTypes["VideoUpsertResult"]],
createImage?: [{	data:ValueTypes["ImageCreateInput"]},ValueTypes["ImageCreateResult"]],
deleteImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null},ValueTypes["ImageDeleteResult"]],
updateImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	data:ValueTypes["ImageUpdateInput"]},ValueTypes["ImageUpdateResult"]],
upsertImage?: [{	by:ValueTypes["ImageUniqueWhere"],	filter?:ValueTypes["ImageWhere"] | null,	update:ValueTypes["ImageUpdateInput"],	create:ValueTypes["ImageCreateInput"]},ValueTypes["ImageUpsertResult"]],
createSeo?: [{	data:ValueTypes["SeoCreateInput"]},ValueTypes["SeoCreateResult"]],
deleteSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null},ValueTypes["SeoDeleteResult"]],
updateSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	data:ValueTypes["SeoUpdateInput"]},ValueTypes["SeoUpdateResult"]],
upsertSeo?: [{	by:ValueTypes["SeoUniqueWhere"],	filter?:ValueTypes["SeoWhere"] | null,	update:ValueTypes["SeoUpdateInput"],	create:ValueTypes["SeoCreateInput"]},ValueTypes["SeoUpsertResult"]],
createTranslationDomain?: [{	data:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainCreateResult"]],
deleteTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null},ValueTypes["TranslationDomainDeleteResult"]],
updateTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	data:ValueTypes["TranslationDomainUpdateInput"]},ValueTypes["TranslationDomainUpdateResult"]],
upsertTranslationDomain?: [{	by:ValueTypes["TranslationDomainUniqueWhere"],	filter?:ValueTypes["TranslationDomainWhere"] | null,	update:ValueTypes["TranslationDomainUpdateInput"],	create:ValueTypes["TranslationDomainCreateInput"]},ValueTypes["TranslationDomainUpsertResult"]],
createTranslationCatalogue?: [{	data:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueCreateResult"]],
deleteTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null},ValueTypes["TranslationCatalogueDeleteResult"]],
updateTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	data:ValueTypes["TranslationCatalogueUpdateInput"]},ValueTypes["TranslationCatalogueUpdateResult"]],
upsertTranslationCatalogue?: [{	by:ValueTypes["TranslationCatalogueUniqueWhere"],	filter?:ValueTypes["TranslationCatalogueWhere"] | null,	update:ValueTypes["TranslationCatalogueUpdateInput"],	create:ValueTypes["TranslationCatalogueCreateInput"]},ValueTypes["TranslationCatalogueUpsertResult"]],
createTranslationCataloguesIdentifier?: [{	data:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierCreateResult"]],
deleteTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null},ValueTypes["TranslationCataloguesIdentifierDeleteResult"]],
updateTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	data:ValueTypes["TranslationCataloguesIdentifierUpdateInput"]},ValueTypes["TranslationCataloguesIdentifierUpdateResult"]],
upsertTranslationCataloguesIdentifier?: [{	by:ValueTypes["TranslationCataloguesIdentifierUniqueWhere"],	filter?:ValueTypes["TranslationCataloguesIdentifierWhere"] | null,	update:ValueTypes["TranslationCataloguesIdentifierUpdateInput"],	create:ValueTypes["TranslationCataloguesIdentifierCreateInput"]},ValueTypes["TranslationCataloguesIdentifierUpsertResult"]],
createTranslationKey?: [{	data:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyCreateResult"]],
deleteTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null},ValueTypes["TranslationKeyDeleteResult"]],
updateTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	data:ValueTypes["TranslationKeyUpdateInput"]},ValueTypes["TranslationKeyUpdateResult"]],
upsertTranslationKey?: [{	by:ValueTypes["TranslationKeyUniqueWhere"],	filter?:ValueTypes["TranslationKeyWhere"] | null,	update:ValueTypes["TranslationKeyUpdateInput"],	create:ValueTypes["TranslationKeyCreateInput"]},ValueTypes["TranslationKeyUpsertResult"]],
createTranslationValue?: [{	data:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueCreateResult"]],
deleteTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null},ValueTypes["TranslationValueDeleteResult"]],
updateTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	data:ValueTypes["TranslationValueUpdateInput"]},ValueTypes["TranslationValueUpdateResult"]],
upsertTranslationValue?: [{	by:ValueTypes["TranslationValueUniqueWhere"],	filter?:ValueTypes["TranslationValueWhere"] | null,	update:ValueTypes["TranslationValueUpdateInput"],	create:ValueTypes["TranslationValueCreateInput"]},ValueTypes["TranslationValueUpsertResult"]],
createBranches?: [{	data:ValueTypes["BranchesCreateInput"]},ValueTypes["BranchesCreateResult"]],
deleteBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null},ValueTypes["BranchesDeleteResult"]],
updateBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null,	data:ValueTypes["BranchesUpdateInput"]},ValueTypes["BranchesUpdateResult"]],
upsertBranches?: [{	by:ValueTypes["BranchesUniqueWhere"],	filter?:ValueTypes["BranchesWhere"] | null,	update:ValueTypes["BranchesUpdateInput"],	create:ValueTypes["BranchesCreateInput"]},ValueTypes["BranchesUpsertResult"]],
createGraphicDesigner?: [{	data:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["GraphicDesignerCreateResult"]],
deleteGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null},ValueTypes["GraphicDesignerDeleteResult"]],
updateGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null,	data:ValueTypes["GraphicDesignerUpdateInput"]},ValueTypes["GraphicDesignerUpdateResult"]],
upsertGraphicDesigner?: [{	by:ValueTypes["GraphicDesignerUniqueWhere"],	filter?:ValueTypes["GraphicDesignerWhere"] | null,	update:ValueTypes["GraphicDesignerUpdateInput"],	create:ValueTypes["GraphicDesignerCreateInput"]},ValueTypes["GraphicDesignerUpsertResult"]],
createEvent?: [{	data:ValueTypes["EventCreateInput"]},ValueTypes["EventCreateResult"]],
deleteEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null},ValueTypes["EventDeleteResult"]],
updateEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	data:ValueTypes["EventUpdateInput"]},ValueTypes["EventUpdateResult"]],
upsertEvent?: [{	by:ValueTypes["EventUniqueWhere"],	filter?:ValueTypes["EventWhere"] | null,	update:ValueTypes["EventUpdateInput"],	create:ValueTypes["EventCreateInput"]},ValueTypes["EventUpsertResult"]],
createEventLocale?: [{	data:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleCreateResult"]],
deleteEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null},ValueTypes["EventLocaleDeleteResult"]],
updateEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	data:ValueTypes["EventLocaleUpdateInput"]},ValueTypes["EventLocaleUpdateResult"]],
upsertEventLocale?: [{	by:ValueTypes["EventLocaleUniqueWhere"],	filter?:ValueTypes["EventLocaleWhere"] | null,	update:ValueTypes["EventLocaleUpdateInput"],	create:ValueTypes["EventLocaleCreateInput"]},ValueTypes["EventLocaleUpsertResult"]],
createArtwork?: [{	data:ValueTypes["ArtworkCreateInput"]},ValueTypes["ArtworkCreateResult"]],
deleteArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null},ValueTypes["ArtworkDeleteResult"]],
updateArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null,	data:ValueTypes["ArtworkUpdateInput"]},ValueTypes["ArtworkUpdateResult"]],
upsertArtwork?: [{	by:ValueTypes["ArtworkUniqueWhere"],	filter?:ValueTypes["ArtworkWhere"] | null,	update:ValueTypes["ArtworkUpdateInput"],	create:ValueTypes["ArtworkCreateInput"]},ValueTypes["ArtworkUpsertResult"]],
createArtworkLocale?: [{	data:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["ArtworkLocaleCreateResult"]],
deleteArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null},ValueTypes["ArtworkLocaleDeleteResult"]],
updateArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	data:ValueTypes["ArtworkLocaleUpdateInput"]},ValueTypes["ArtworkLocaleUpdateResult"]],
upsertArtworkLocale?: [{	by:ValueTypes["ArtworkLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkLocaleWhere"] | null,	update:ValueTypes["ArtworkLocaleUpdateInput"],	create:ValueTypes["ArtworkLocaleCreateInput"]},ValueTypes["ArtworkLocaleUpsertResult"]],
createDropDownItem?: [{	data:ValueTypes["DropDownItemCreateInput"]},ValueTypes["DropDownItemCreateResult"]],
deleteDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null},ValueTypes["DropDownItemDeleteResult"]],
updateDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null,	data:ValueTypes["DropDownItemUpdateInput"]},ValueTypes["DropDownItemUpdateResult"]],
upsertDropDownItem?: [{	by:ValueTypes["DropDownItemUniqueWhere"],	filter?:ValueTypes["DropDownItemWhere"] | null,	update:ValueTypes["DropDownItemUpdateInput"],	create:ValueTypes["DropDownItemCreateInput"]},ValueTypes["DropDownItemUpsertResult"]],
createDropDownList?: [{	data:ValueTypes["DropDownListCreateInput"]},ValueTypes["DropDownListCreateResult"]],
deleteDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null},ValueTypes["DropDownListDeleteResult"]],
updateDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null,	data:ValueTypes["DropDownListUpdateInput"]},ValueTypes["DropDownListUpdateResult"]],
upsertDropDownList?: [{	by:ValueTypes["DropDownListUniqueWhere"],	filter?:ValueTypes["DropDownListWhere"] | null,	update:ValueTypes["DropDownListUpdateInput"],	create:ValueTypes["DropDownListCreateInput"]},ValueTypes["DropDownListUpsertResult"]],
createArtworkItem?: [{	data:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["ArtworkItemCreateResult"]],
deleteArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null},ValueTypes["ArtworkItemDeleteResult"]],
updateArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null,	data:ValueTypes["ArtworkItemUpdateInput"]},ValueTypes["ArtworkItemUpdateResult"]],
upsertArtworkItem?: [{	by:ValueTypes["ArtworkItemUniqueWhere"],	filter?:ValueTypes["ArtworkItemWhere"] | null,	update:ValueTypes["ArtworkItemUpdateInput"],	create:ValueTypes["ArtworkItemCreateInput"]},ValueTypes["ArtworkItemUpsertResult"]],
createArtworkList?: [{	data:ValueTypes["ArtworkListCreateInput"]},ValueTypes["ArtworkListCreateResult"]],
deleteArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null},ValueTypes["ArtworkListDeleteResult"]],
updateArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null,	data:ValueTypes["ArtworkListUpdateInput"]},ValueTypes["ArtworkListUpdateResult"]],
upsertArtworkList?: [{	by:ValueTypes["ArtworkListUniqueWhere"],	filter?:ValueTypes["ArtworkListWhere"] | null,	update:ValueTypes["ArtworkListUpdateInput"],	create:ValueTypes["ArtworkListCreateInput"]},ValueTypes["ArtworkListUpsertResult"]],
createArtworkSelection?: [{	data:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["ArtworkSelectionCreateResult"]],
deleteArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null},ValueTypes["ArtworkSelectionDeleteResult"]],
updateArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	data:ValueTypes["ArtworkSelectionUpdateInput"]},ValueTypes["ArtworkSelectionUpdateResult"]],
upsertArtworkSelection?: [{	by:ValueTypes["ArtworkSelectionUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionWhere"] | null,	update:ValueTypes["ArtworkSelectionUpdateInput"],	create:ValueTypes["ArtworkSelectionCreateInput"]},ValueTypes["ArtworkSelectionUpsertResult"]],
createArtworkSelectionItem?: [{	data:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["ArtworkSelectionItemCreateResult"]],
deleteArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null},ValueTypes["ArtworkSelectionItemDeleteResult"]],
updateArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	data:ValueTypes["ArtworkSelectionItemUpdateInput"]},ValueTypes["ArtworkSelectionItemUpdateResult"]],
upsertArtworkSelectionItem?: [{	by:ValueTypes["ArtworkSelectionItemUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionItemWhere"] | null,	update:ValueTypes["ArtworkSelectionItemUpdateInput"],	create:ValueTypes["ArtworkSelectionItemCreateInput"]},ValueTypes["ArtworkSelectionItemUpsertResult"]],
createArtworkSelectionList?: [{	data:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["ArtworkSelectionListCreateResult"]],
deleteArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null},ValueTypes["ArtworkSelectionListDeleteResult"]],
updateArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	data:ValueTypes["ArtworkSelectionListUpdateInput"]},ValueTypes["ArtworkSelectionListUpdateResult"]],
upsertArtworkSelectionList?: [{	by:ValueTypes["ArtworkSelectionListUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionListWhere"] | null,	update:ValueTypes["ArtworkSelectionListUpdateInput"],	create:ValueTypes["ArtworkSelectionListCreateInput"]},ValueTypes["ArtworkSelectionListUpsertResult"]],
createArtworkSelectionLocale?: [{	data:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["ArtworkSelectionLocaleCreateResult"]],
deleteArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null},ValueTypes["ArtworkSelectionLocaleDeleteResult"]],
updateArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	data:ValueTypes["ArtworkSelectionLocaleUpdateInput"]},ValueTypes["ArtworkSelectionLocaleUpdateResult"]],
upsertArtworkSelectionLocale?: [{	by:ValueTypes["ArtworkSelectionLocaleUniqueWhere"],	filter?:ValueTypes["ArtworkSelectionLocaleWhere"] | null,	update:ValueTypes["ArtworkSelectionLocaleUpdateInput"],	create:ValueTypes["ArtworkSelectionLocaleCreateInput"]},ValueTypes["ArtworkSelectionLocaleUpsertResult"]],
createEventItem?: [{	data:ValueTypes["EventItemCreateInput"]},ValueTypes["EventItemCreateResult"]],
deleteEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null},ValueTypes["EventItemDeleteResult"]],
updateEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null,	data:ValueTypes["EventItemUpdateInput"]},ValueTypes["EventItemUpdateResult"]],
upsertEventItem?: [{	by:ValueTypes["EventItemUniqueWhere"],	filter?:ValueTypes["EventItemWhere"] | null,	update:ValueTypes["EventItemUpdateInput"],	create:ValueTypes["EventItemCreateInput"]},ValueTypes["EventItemUpsertResult"]],
createEventList?: [{	data:ValueTypes["EventListCreateInput"]},ValueTypes["EventListCreateResult"]],
deleteEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null},ValueTypes["EventListDeleteResult"]],
updateEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null,	data:ValueTypes["EventListUpdateInput"]},ValueTypes["EventListUpdateResult"]],
upsertEventList?: [{	by:ValueTypes["EventListUniqueWhere"],	filter?:ValueTypes["EventListWhere"] | null,	update:ValueTypes["EventListUpdateInput"],	create:ValueTypes["EventListCreateInput"]},ValueTypes["EventListUpsertResult"]],
createBoxItem?: [{	data:ValueTypes["BoxItemCreateInput"]},ValueTypes["BoxItemCreateResult"]],
deleteBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null},ValueTypes["BoxItemDeleteResult"]],
updateBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null,	data:ValueTypes["BoxItemUpdateInput"]},ValueTypes["BoxItemUpdateResult"]],
upsertBoxItem?: [{	by:ValueTypes["BoxItemUniqueWhere"],	filter?:ValueTypes["BoxItemWhere"] | null,	update:ValueTypes["BoxItemUpdateInput"],	create:ValueTypes["BoxItemCreateInput"]},ValueTypes["BoxItemUpsertResult"]],
createBoxList?: [{	data:ValueTypes["BoxListCreateInput"]},ValueTypes["BoxListCreateResult"]],
deleteBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null},ValueTypes["BoxListDeleteResult"]],
updateBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null,	data:ValueTypes["BoxListUpdateInput"]},ValueTypes["BoxListUpdateResult"]],
upsertBoxList?: [{	by:ValueTypes["BoxListUniqueWhere"],	filter?:ValueTypes["BoxListWhere"] | null,	update:ValueTypes["BoxListUpdateInput"],	create:ValueTypes["BoxListCreateInput"]},ValueTypes["BoxListUpsertResult"]],
createNewsletterForm?: [{	data:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["NewsletterFormCreateResult"]],
deleteNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null},ValueTypes["NewsletterFormDeleteResult"]],
updateNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null,	data:ValueTypes["NewsletterFormUpdateInput"]},ValueTypes["NewsletterFormUpdateResult"]],
upsertNewsletterForm?: [{	by:ValueTypes["NewsletterFormUniqueWhere"],	filter?:ValueTypes["NewsletterFormWhere"] | null,	update:ValueTypes["NewsletterFormUpdateInput"],	create:ValueTypes["NewsletterFormCreateInput"]},ValueTypes["NewsletterFormUpsertResult"]],
createNewsletterTypeItem?: [{	data:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["NewsletterTypeItemCreateResult"]],
deleteNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null},ValueTypes["NewsletterTypeItemDeleteResult"]],
updateNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	data:ValueTypes["NewsletterTypeItemUpdateInput"]},ValueTypes["NewsletterTypeItemUpdateResult"]],
upsertNewsletterTypeItem?: [{	by:ValueTypes["NewsletterTypeItemUniqueWhere"],	filter?:ValueTypes["NewsletterTypeItemWhere"] | null,	update:ValueTypes["NewsletterTypeItemUpdateInput"],	create:ValueTypes["NewsletterTypeItemCreateInput"]},ValueTypes["NewsletterTypeItemUpsertResult"]],
createNewsletterFormLocale?: [{	data:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["NewsletterFormLocaleCreateResult"]],
deleteNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null},ValueTypes["NewsletterFormLocaleDeleteResult"]],
updateNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	data:ValueTypes["NewsletterFormLocaleUpdateInput"]},ValueTypes["NewsletterFormLocaleUpdateResult"]],
upsertNewsletterFormLocale?: [{	by:ValueTypes["NewsletterFormLocaleUniqueWhere"],	filter?:ValueTypes["NewsletterFormLocaleWhere"] | null,	update:ValueTypes["NewsletterFormLocaleUpdateInput"],	create:ValueTypes["NewsletterFormLocaleCreateInput"]},ValueTypes["NewsletterFormLocaleUpsertResult"]],
createNewsletterSubscription?: [{	data:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["NewsletterSubscriptionCreateResult"]],
deleteNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null},ValueTypes["NewsletterSubscriptionDeleteResult"]],
updateNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	data:ValueTypes["NewsletterSubscriptionUpdateInput"]},ValueTypes["NewsletterSubscriptionUpdateResult"]],
upsertNewsletterSubscription?: [{	by:ValueTypes["NewsletterSubscriptionUniqueWhere"],	filter?:ValueTypes["NewsletterSubscriptionWhere"] | null,	update:ValueTypes["NewsletterSubscriptionUpdateInput"],	create:ValueTypes["NewsletterSubscriptionCreateInput"]},ValueTypes["NewsletterSubscriptionUpsertResult"]],
createChart?: [{	data:ValueTypes["ChartCreateInput"]},ValueTypes["ChartCreateResult"]],
deleteChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null},ValueTypes["ChartDeleteResult"]],
updateChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null,	data:ValueTypes["ChartUpdateInput"]},ValueTypes["ChartUpdateResult"]],
upsertChart?: [{	by:ValueTypes["ChartUniqueWhere"],	filter?:ValueTypes["ChartWhere"] | null,	update:ValueTypes["ChartUpdateInput"],	create:ValueTypes["ChartCreateInput"]},ValueTypes["ChartUpsertResult"]],
createChartData?: [{	data:ValueTypes["ChartDataCreateInput"]},ValueTypes["ChartDataCreateResult"]],
deleteChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null},ValueTypes["ChartDataDeleteResult"]],
updateChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null,	data:ValueTypes["ChartDataUpdateInput"]},ValueTypes["ChartDataUpdateResult"]],
upsertChartData?: [{	by:ValueTypes["ChartDataUniqueWhere"],	filter?:ValueTypes["ChartDataWhere"] | null,	update:ValueTypes["ChartDataUpdateInput"],	create:ValueTypes["ChartDataCreateInput"]},ValueTypes["ChartDataUpsertResult"]],
createEmployee?: [{	data:ValueTypes["EmployeeCreateInput"]},ValueTypes["EmployeeCreateResult"]],
deleteEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null},ValueTypes["EmployeeDeleteResult"]],
updateEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null,	data:ValueTypes["EmployeeUpdateInput"]},ValueTypes["EmployeeUpdateResult"]],
upsertEmployee?: [{	by:ValueTypes["EmployeeUniqueWhere"],	filter?:ValueTypes["EmployeeWhere"] | null,	update:ValueTypes["EmployeeUpdateInput"],	create:ValueTypes["EmployeeCreateInput"]},ValueTypes["EmployeeUpsertResult"]],
createEmployeeItem?: [{	data:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["EmployeeItemCreateResult"]],
deleteEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null},ValueTypes["EmployeeItemDeleteResult"]],
updateEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null,	data:ValueTypes["EmployeeItemUpdateInput"]},ValueTypes["EmployeeItemUpdateResult"]],
upsertEmployeeItem?: [{	by:ValueTypes["EmployeeItemUniqueWhere"],	filter?:ValueTypes["EmployeeItemWhere"] | null,	update:ValueTypes["EmployeeItemUpdateInput"],	create:ValueTypes["EmployeeItemCreateInput"]},ValueTypes["EmployeeItemUpsertResult"]],
createEmployeeList?: [{	data:ValueTypes["EmployeeListCreateInput"]},ValueTypes["EmployeeListCreateResult"]],
deleteEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null},ValueTypes["EmployeeListDeleteResult"]],
updateEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null,	data:ValueTypes["EmployeeListUpdateInput"]},ValueTypes["EmployeeListUpdateResult"]],
upsertEmployeeList?: [{	by:ValueTypes["EmployeeListUniqueWhere"],	filter?:ValueTypes["EmployeeListWhere"] | null,	update:ValueTypes["EmployeeListUpdateInput"],	create:ValueTypes["EmployeeListCreateInput"]},ValueTypes["EmployeeListUpsertResult"]],
createEmployeeLocale?: [{	data:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["EmployeeLocaleCreateResult"]],
deleteEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null},ValueTypes["EmployeeLocaleDeleteResult"]],
updateEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	data:ValueTypes["EmployeeLocaleUpdateInput"]},ValueTypes["EmployeeLocaleUpdateResult"]],
upsertEmployeeLocale?: [{	by:ValueTypes["EmployeeLocaleUniqueWhere"],	filter?:ValueTypes["EmployeeLocaleWhere"] | null,	update:ValueTypes["EmployeeLocaleUpdateInput"],	create:ValueTypes["EmployeeLocaleCreateInput"]},ValueTypes["EmployeeLocaleUpsertResult"]],
createPhotographer?: [{	data:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerCreateResult"]],
deletePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null},ValueTypes["PhotographerDeleteResult"]],
updatePhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	data:ValueTypes["PhotographerUpdateInput"]},ValueTypes["PhotographerUpdateResult"]],
upsertPhotographer?: [{	by:ValueTypes["PhotographerUniqueWhere"],	filter?:ValueTypes["PhotographerWhere"] | null,	update:ValueTypes["PhotographerUpdateInput"],	create:ValueTypes["PhotographerCreateInput"]},ValueTypes["PhotographerUpsertResult"]],
createDefinitionItem?: [{	data:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["DefinitionItemCreateResult"]],
deleteDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null},ValueTypes["DefinitionItemDeleteResult"]],
updateDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null,	data:ValueTypes["DefinitionItemUpdateInput"]},ValueTypes["DefinitionItemUpdateResult"]],
upsertDefinitionItem?: [{	by:ValueTypes["DefinitionItemUniqueWhere"],	filter?:ValueTypes["DefinitionItemWhere"] | null,	update:ValueTypes["DefinitionItemUpdateInput"],	create:ValueTypes["DefinitionItemCreateInput"]},ValueTypes["DefinitionItemUpsertResult"]],
createDefinitionList?: [{	data:ValueTypes["DefinitionListCreateInput"]},ValueTypes["DefinitionListCreateResult"]],
deleteDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null},ValueTypes["DefinitionListDeleteResult"]],
updateDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null,	data:ValueTypes["DefinitionListUpdateInput"]},ValueTypes["DefinitionListUpdateResult"]],
upsertDefinitionList?: [{	by:ValueTypes["DefinitionListUniqueWhere"],	filter?:ValueTypes["DefinitionListWhere"] | null,	update:ValueTypes["DefinitionListUpdateInput"],	create:ValueTypes["DefinitionListCreateInput"]},ValueTypes["DefinitionListUpsertResult"]],
createLogoItem?: [{	data:ValueTypes["LogoItemCreateInput"]},ValueTypes["LogoItemCreateResult"]],
deleteLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null},ValueTypes["LogoItemDeleteResult"]],
updateLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null,	data:ValueTypes["LogoItemUpdateInput"]},ValueTypes["LogoItemUpdateResult"]],
upsertLogoItem?: [{	by:ValueTypes["LogoItemUniqueWhere"],	filter?:ValueTypes["LogoItemWhere"] | null,	update:ValueTypes["LogoItemUpdateInput"],	create:ValueTypes["LogoItemCreateInput"]},ValueTypes["LogoItemUpsertResult"]],
createLogoList?: [{	data:ValueTypes["LogoListCreateInput"]},ValueTypes["LogoListCreateResult"]],
deleteLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null},ValueTypes["LogoListDeleteResult"]],
updateLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null,	data:ValueTypes["LogoListUpdateInput"]},ValueTypes["LogoListUpdateResult"]],
upsertLogoList?: [{	by:ValueTypes["LogoListUniqueWhere"],	filter?:ValueTypes["LogoListWhere"] | null,	update:ValueTypes["LogoListUpdateInput"],	create:ValueTypes["LogoListCreateInput"]},ValueTypes["LogoListUpsertResult"]],
createStrategySchema?: [{	data:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["StrategySchemaCreateResult"]],
deleteStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null},ValueTypes["StrategySchemaDeleteResult"]],
updateStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null,	data:ValueTypes["StrategySchemaUpdateInput"]},ValueTypes["StrategySchemaUpdateResult"]],
upsertStrategySchema?: [{	by:ValueTypes["StrategySchemaUniqueWhere"],	filter?:ValueTypes["StrategySchemaWhere"] | null,	update:ValueTypes["StrategySchemaUpdateInput"],	create:ValueTypes["StrategySchemaCreateInput"]},ValueTypes["StrategySchemaUpsertResult"]],
createStrategySchemaGroup?: [{	data:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["StrategySchemaGroupCreateResult"]],
deleteStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null},ValueTypes["StrategySchemaGroupDeleteResult"]],
updateStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	data:ValueTypes["StrategySchemaGroupUpdateInput"]},ValueTypes["StrategySchemaGroupUpdateResult"]],
upsertStrategySchemaGroup?: [{	by:ValueTypes["StrategySchemaGroupUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupWhere"] | null,	update:ValueTypes["StrategySchemaGroupUpdateInput"],	create:ValueTypes["StrategySchemaGroupCreateInput"]},ValueTypes["StrategySchemaGroupUpsertResult"]],
createStrategySchemaGroupItem?: [{	data:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["StrategySchemaGroupItemCreateResult"]],
deleteStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null},ValueTypes["StrategySchemaGroupItemDeleteResult"]],
updateStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	data:ValueTypes["StrategySchemaGroupItemUpdateInput"]},ValueTypes["StrategySchemaGroupItemUpdateResult"]],
upsertStrategySchemaGroupItem?: [{	by:ValueTypes["StrategySchemaGroupItemUniqueWhere"],	filter?:ValueTypes["StrategySchemaGroupItemWhere"] | null,	update:ValueTypes["StrategySchemaGroupItemUpdateInput"],	create:ValueTypes["StrategySchemaGroupItemCreateInput"]},ValueTypes["StrategySchemaGroupItemUpsertResult"]],
createRedirect?: [{	data:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectCreateResult"]],
deleteRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null},ValueTypes["RedirectDeleteResult"]],
updateRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	data:ValueTypes["RedirectUpdateInput"]},ValueTypes["RedirectUpdateResult"]],
upsertRedirect?: [{	by:ValueTypes["RedirectUniqueWhere"],	filter?:ValueTypes["RedirectWhere"] | null,	update:ValueTypes["RedirectUpdateInput"],	create:ValueTypes["RedirectCreateInput"]},ValueTypes["RedirectUpsertResult"]],
createGallery?: [{	data:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryCreateResult"]],
deleteGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null},ValueTypes["GalleryDeleteResult"]],
updateGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	data:ValueTypes["GalleryUpdateInput"]},ValueTypes["GalleryUpdateResult"]],
upsertGallery?: [{	by:ValueTypes["GalleryUniqueWhere"],	filter?:ValueTypes["GalleryWhere"] | null,	update:ValueTypes["GalleryUpdateInput"],	create:ValueTypes["GalleryCreateInput"]},ValueTypes["GalleryUpsertResult"]],
createGalleryItem?: [{	data:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemCreateResult"]],
deleteGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null},ValueTypes["GalleryItemDeleteResult"]],
updateGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	data:ValueTypes["GalleryItemUpdateInput"]},ValueTypes["GalleryItemUpdateResult"]],
upsertGalleryItem?: [{	by:ValueTypes["GalleryItemUniqueWhere"],	filter?:ValueTypes["GalleryItemWhere"] | null,	update:ValueTypes["GalleryItemUpdateInput"],	create:ValueTypes["GalleryItemCreateInput"]},ValueTypes["GalleryItemUpsertResult"]],
createContactForm?: [{	data:ValueTypes["ContactFormCreateInput"]},ValueTypes["ContactFormCreateResult"]],
deleteContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null},ValueTypes["ContactFormDeleteResult"]],
updateContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null,	data:ValueTypes["ContactFormUpdateInput"]},ValueTypes["ContactFormUpdateResult"]],
upsertContactForm?: [{	by:ValueTypes["ContactFormUniqueWhere"],	filter?:ValueTypes["ContactFormWhere"] | null,	update:ValueTypes["ContactFormUpdateInput"],	create:ValueTypes["ContactFormCreateInput"]},ValueTypes["ContactFormUpsertResult"]],
createContactFormLocale?: [{	data:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["ContactFormLocaleCreateResult"]],
deleteContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null},ValueTypes["ContactFormLocaleDeleteResult"]],
updateContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	data:ValueTypes["ContactFormLocaleUpdateInput"]},ValueTypes["ContactFormLocaleUpdateResult"]],
upsertContactFormLocale?: [{	by:ValueTypes["ContactFormLocaleUniqueWhere"],	filter?:ValueTypes["ContactFormLocaleWhere"] | null,	update:ValueTypes["ContactFormLocaleUpdateInput"],	create:ValueTypes["ContactFormLocaleCreateInput"]},ValueTypes["ContactFormLocaleUpsertResult"]],
createContactSubscription?: [{	data:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["ContactSubscriptionCreateResult"]],
deleteContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null},ValueTypes["ContactSubscriptionDeleteResult"]],
updateContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	data:ValueTypes["ContactSubscriptionUpdateInput"]},ValueTypes["ContactSubscriptionUpdateResult"]],
upsertContactSubscription?: [{	by:ValueTypes["ContactSubscriptionUniqueWhere"],	filter?:ValueTypes["ContactSubscriptionWhere"] | null,	update:ValueTypes["ContactSubscriptionUpdateInput"],	create:ValueTypes["ContactSubscriptionCreateInput"]},ValueTypes["ContactSubscriptionUpsertResult"]],
createContactTypeItem?: [{	data:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["ContactTypeItemCreateResult"]],
deleteContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null},ValueTypes["ContactTypeItemDeleteResult"]],
updateContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null,	data:ValueTypes["ContactTypeItemUpdateInput"]},ValueTypes["ContactTypeItemUpdateResult"]],
upsertContactTypeItem?: [{	by:ValueTypes["ContactTypeItemUniqueWhere"],	filter?:ValueTypes["ContactTypeItemWhere"] | null,	update:ValueTypes["ContactTypeItemUpdateInput"],	create:ValueTypes["ContactTypeItemCreateInput"]},ValueTypes["ContactTypeItemUpsertResult"]],
createFile?: [{	data:ValueTypes["FileCreateInput"]},ValueTypes["FileCreateResult"]],
deleteFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null},ValueTypes["FileDeleteResult"]],
updateFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	data:ValueTypes["FileUpdateInput"]},ValueTypes["FileUpdateResult"]],
upsertFile?: [{	by:ValueTypes["FileUniqueWhere"],	filter?:ValueTypes["FileWhere"] | null,	update:ValueTypes["FileUpdateInput"],	create:ValueTypes["FileCreateInput"]},ValueTypes["FileUpsertResult"]],
	query?:ValueTypes["Query"],
		__typename?: true
}>;
	["MutationTransactionOptions"]: {
	deferForeignKeyConstraints?:boolean | null
};
	/** Json custom scalar type */
["Json"]:unknown;
	["_Schema"]: AliasType<{
	enums?:ValueTypes["_Enum"],
	entities?:ValueTypes["_Entity"],
		__typename?: true
}>;
	["_Entity"]: AliasType<{
	name?:true,
	customPrimaryAllowed?:true,
	fields?:ValueTypes["_Field"],
	unique?:ValueTypes["_UniqueConstraint"],
		__typename?: true
}>;
	["_UniqueConstraint"]: AliasType<{
	fields?:true,
		__typename?: true
}>;
	["_Field"]:AliasType<{
		name?:true,
	type?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"];
		['...on _Column']?: Omit<ValueTypes["_Column"],keyof ValueTypes["_Field"]>;
		['...on _Relation']?: Omit<ValueTypes["_Relation"],keyof ValueTypes["_Field"]>;
		__typename?: true
}>;
	["_Column"]: AliasType<{
	name?:true,
	type?:true,
	enumName?:true,
	defaultValue?:true,
	nullable?:true,
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_OnDeleteBehaviour"]:_OnDeleteBehaviour;
	["_RelationSide"]:_RelationSide;
	["_OrderByDirection"]:_OrderByDirection;
	["_OrderBy"]: AliasType<{
	path?:true,
	direction?:true,
		__typename?: true
}>;
	["_Relation"]: AliasType<{
	name?:true,
	type?:true,
	side?:true,
	targetEntity?:true,
	ownedBy?:true,
	inversedBy?:true,
	nullable?:true,
	onDelete?:true,
	orphanRemoval?:true,
	orderBy?:ValueTypes["_OrderBy"],
	rules?:ValueTypes["_Rule"],
	validators?:ValueTypes["_Validator"],
		__typename?: true
}>;
	["_Rule"]: AliasType<{
	message?:ValueTypes["_RuleMessage"],
	validator?:true,
		__typename?: true
}>;
	["_Validator"]: AliasType<{
	operation?:true,
	arguments?:ValueTypes["_Argument"],
		__typename?: true
}>;
	["_Argument"]: AliasType<{		["...on _ValidatorArgument"] : ValueTypes["_ValidatorArgument"],
		["...on _PathArgument"] : ValueTypes["_PathArgument"],
		["...on _LiteralArgument"] : ValueTypes["_LiteralArgument"]
		__typename?: true
}>;
	["_ValidatorArgument"]: AliasType<{
	validator?:true,
		__typename?: true
}>;
	["_PathArgument"]: AliasType<{
	path?:true,
		__typename?: true
}>;
	["_LiteralArgument"]: AliasType<{
	value?:true,
		__typename?: true
}>;
	["_RuleMessage"]: AliasType<{
	text?:true,
		__typename?: true
}>;
	["_Enum"]: AliasType<{
	name?:true,
	values?:true,
		__typename?: true
}>;
	["S3SignedUpload"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
	publicUrl?:true,
		__typename?: true
}>;
	["S3Header"]: AliasType<{
	key?:true,
	value?:true,
		__typename?: true
}>;
	["S3SignedRead"]: AliasType<{
	url?:true,
	headers?:ValueTypes["S3Header"],
	method?:true,
	/** Allowed patterns:
** */
	objectKey?:true,
	bucket?:true,
		__typename?: true
}>
  }

export type ModelTypes = {
    ["Query"]: {
		getContactPage?:ModelTypes["ContactPage"],
	listContactPage:ModelTypes["ContactPage"][],
	paginateContactPage:ModelTypes["ContactPageConnection"],
	validateCreateContactPage:ModelTypes["_ValidationResult"],
	validateUpdateContactPage:ModelTypes["_ValidationResult"],
	getContactPageLocale?:ModelTypes["ContactPageLocale"],
	listContactPageLocale:ModelTypes["ContactPageLocale"][],
	paginateContactPageLocale:ModelTypes["ContactPageLocaleConnection"],
	validateCreateContactPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateContactPageLocale:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLocale?:ModelTypes["FooterLocale"],
	listFooterLocale:ModelTypes["FooterLocale"][],
	paginateFooterLocale:ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale:ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getHeaderLocale?:ModelTypes["HeaderLocale"],
	listHeaderLocale:ModelTypes["HeaderLocale"][],
	paginateHeaderLocale:ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getHomePageLocale?:ModelTypes["HomePageLocale"],
	listHomePageLocale:ModelTypes["HomePageLocale"][],
	paginateHomePageLocale:ModelTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale:ModelTypes["_ValidationResult"],
	validateUpdateHomePageLocale:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getMediumItem?:ModelTypes["MediumItem"],
	listMediumItem:ModelTypes["MediumItem"][],
	paginateMediumItem:ModelTypes["MediumItemConnection"],
	validateCreateMediumItem:ModelTypes["_ValidationResult"],
	validateUpdateMediumItem:ModelTypes["_ValidationResult"],
	getMediumList?:ModelTypes["MediumList"],
	listMediumList:ModelTypes["MediumList"][],
	paginateMediumList:ModelTypes["MediumListConnection"],
	validateCreateMediumList:ModelTypes["_ValidationResult"],
	validateUpdateMediumList:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getPageLocale?:ModelTypes["PageLocale"],
	listPageLocale:ModelTypes["PageLocale"][],
	paginatePageLocale:ModelTypes["PageLocaleConnection"],
	validateCreatePageLocale:ModelTypes["_ValidationResult"],
	validateUpdatePageLocale:ModelTypes["_ValidationResult"],
	getSeoDefault?:ModelTypes["SeoDefault"],
	listSeoDefault:ModelTypes["SeoDefault"][],
	paginateSeoDefault:ModelTypes["SeoDefaultConnection"],
	validateCreateSeoDefault:ModelTypes["_ValidationResult"],
	validateUpdateSeoDefault:ModelTypes["_ValidationResult"],
	getSeoDefaultLocale?:ModelTypes["SeoDefaultLocale"],
	listSeoDefaultLocale:ModelTypes["SeoDefaultLocale"][],
	paginateSeoDefaultLocale:ModelTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale:ModelTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getTranslationDomain?:ModelTypes["TranslationDomain"],
	listTranslationDomain:ModelTypes["TranslationDomain"][],
	paginateTranslationDomain:ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain:ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain:ModelTypes["_ValidationResult"],
	getTranslationCatalogue?:ModelTypes["TranslationCatalogue"],
	listTranslationCatalogue:ModelTypes["TranslationCatalogue"][],
	paginateTranslationCatalogue:ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue:ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?:ModelTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifier"][],
	paginateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	getTranslationKey?:ModelTypes["TranslationKey"],
	listTranslationKey:ModelTypes["TranslationKey"][],
	paginateTranslationKey:ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey:ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey:ModelTypes["_ValidationResult"],
	getTranslationValue?:ModelTypes["TranslationValue"],
	listTranslationValue:ModelTypes["TranslationValue"][],
	paginateTranslationValue:ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue:ModelTypes["_ValidationResult"],
	getBranches?:ModelTypes["Branches"],
	listBranches:ModelTypes["Branches"][],
	paginateBranches:ModelTypes["BranchesConnection"],
	validateCreateBranches:ModelTypes["_ValidationResult"],
	validateUpdateBranches:ModelTypes["_ValidationResult"],
	getGraphicDesigner?:ModelTypes["GraphicDesigner"],
	listGraphicDesigner:ModelTypes["GraphicDesigner"][],
	paginateGraphicDesigner:ModelTypes["GraphicDesignerConnection"],
	validateCreateGraphicDesigner:ModelTypes["_ValidationResult"],
	validateUpdateGraphicDesigner:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getEventLocale?:ModelTypes["EventLocale"],
	listEventLocale:ModelTypes["EventLocale"][],
	paginateEventLocale:ModelTypes["EventLocaleConnection"],
	validateCreateEventLocale:ModelTypes["_ValidationResult"],
	validateUpdateEventLocale:ModelTypes["_ValidationResult"],
	getArtwork?:ModelTypes["Artwork"],
	listArtwork:ModelTypes["Artwork"][],
	paginateArtwork:ModelTypes["ArtworkConnection"],
	validateCreateArtwork:ModelTypes["_ValidationResult"],
	validateUpdateArtwork:ModelTypes["_ValidationResult"],
	getArtworkLocale?:ModelTypes["ArtworkLocale"],
	listArtworkLocale:ModelTypes["ArtworkLocale"][],
	paginateArtworkLocale:ModelTypes["ArtworkLocaleConnection"],
	validateCreateArtworkLocale:ModelTypes["_ValidationResult"],
	validateUpdateArtworkLocale:ModelTypes["_ValidationResult"],
	getDropDownItem?:ModelTypes["DropDownItem"],
	listDropDownItem:ModelTypes["DropDownItem"][],
	paginateDropDownItem:ModelTypes["DropDownItemConnection"],
	validateCreateDropDownItem:ModelTypes["_ValidationResult"],
	validateUpdateDropDownItem:ModelTypes["_ValidationResult"],
	getDropDownList?:ModelTypes["DropDownList"],
	listDropDownList:ModelTypes["DropDownList"][],
	paginateDropDownList:ModelTypes["DropDownListConnection"],
	validateCreateDropDownList:ModelTypes["_ValidationResult"],
	validateUpdateDropDownList:ModelTypes["_ValidationResult"],
	getArtworkItem?:ModelTypes["ArtworkItem"],
	listArtworkItem:ModelTypes["ArtworkItem"][],
	paginateArtworkItem:ModelTypes["ArtworkItemConnection"],
	validateCreateArtworkItem:ModelTypes["_ValidationResult"],
	validateUpdateArtworkItem:ModelTypes["_ValidationResult"],
	getArtworkList?:ModelTypes["ArtworkList"],
	listArtworkList:ModelTypes["ArtworkList"][],
	paginateArtworkList:ModelTypes["ArtworkListConnection"],
	validateCreateArtworkList:ModelTypes["_ValidationResult"],
	validateUpdateArtworkList:ModelTypes["_ValidationResult"],
	getArtworkSelection?:ModelTypes["ArtworkSelection"],
	listArtworkSelection:ModelTypes["ArtworkSelection"][],
	paginateArtworkSelection:ModelTypes["ArtworkSelectionConnection"],
	validateCreateArtworkSelection:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelection:ModelTypes["_ValidationResult"],
	getArtworkSelectionItem?:ModelTypes["ArtworkSelectionItem"],
	listArtworkSelectionItem:ModelTypes["ArtworkSelectionItem"][],
	paginateArtworkSelectionItem:ModelTypes["ArtworkSelectionItemConnection"],
	validateCreateArtworkSelectionItem:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionItem:ModelTypes["_ValidationResult"],
	getArtworkSelectionList?:ModelTypes["ArtworkSelectionList"],
	listArtworkSelectionList:ModelTypes["ArtworkSelectionList"][],
	paginateArtworkSelectionList:ModelTypes["ArtworkSelectionListConnection"],
	validateCreateArtworkSelectionList:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionList:ModelTypes["_ValidationResult"],
	getArtworkSelectionLocale?:ModelTypes["ArtworkSelectionLocale"],
	listArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocale"][],
	paginateArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleConnection"],
	validateCreateArtworkSelectionLocale:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionLocale:ModelTypes["_ValidationResult"],
	getEventItem?:ModelTypes["EventItem"],
	listEventItem:ModelTypes["EventItem"][],
	paginateEventItem:ModelTypes["EventItemConnection"],
	validateCreateEventItem:ModelTypes["_ValidationResult"],
	validateUpdateEventItem:ModelTypes["_ValidationResult"],
	getEventList?:ModelTypes["EventList"],
	listEventList:ModelTypes["EventList"][],
	paginateEventList:ModelTypes["EventListConnection"],
	validateCreateEventList:ModelTypes["_ValidationResult"],
	validateUpdateEventList:ModelTypes["_ValidationResult"],
	getBoxItem?:ModelTypes["BoxItem"],
	listBoxItem:ModelTypes["BoxItem"][],
	paginateBoxItem:ModelTypes["BoxItemConnection"],
	validateCreateBoxItem:ModelTypes["_ValidationResult"],
	validateUpdateBoxItem:ModelTypes["_ValidationResult"],
	getBoxList?:ModelTypes["BoxList"],
	listBoxList:ModelTypes["BoxList"][],
	paginateBoxList:ModelTypes["BoxListConnection"],
	validateCreateBoxList:ModelTypes["_ValidationResult"],
	validateUpdateBoxList:ModelTypes["_ValidationResult"],
	getNewsletterForm?:ModelTypes["NewsletterForm"],
	listNewsletterForm:ModelTypes["NewsletterForm"][],
	paginateNewsletterForm:ModelTypes["NewsletterFormConnection"],
	validateCreateNewsletterForm:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterForm:ModelTypes["_ValidationResult"],
	getNewsletterTypeItem?:ModelTypes["NewsletterTypeItem"],
	listNewsletterTypeItem:ModelTypes["NewsletterTypeItem"][],
	paginateNewsletterTypeItem:ModelTypes["NewsletterTypeItemConnection"],
	validateCreateNewsletterTypeItem:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterTypeItem:ModelTypes["_ValidationResult"],
	getNewsletterFormLocale?:ModelTypes["NewsletterFormLocale"],
	listNewsletterFormLocale:ModelTypes["NewsletterFormLocale"][],
	paginateNewsletterFormLocale:ModelTypes["NewsletterFormLocaleConnection"],
	validateCreateNewsletterFormLocale:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterFormLocale:ModelTypes["_ValidationResult"],
	getNewsletterSubscription?:ModelTypes["NewsletterSubscription"],
	listNewsletterSubscription:ModelTypes["NewsletterSubscription"][],
	paginateNewsletterSubscription:ModelTypes["NewsletterSubscriptionConnection"],
	validateCreateNewsletterSubscription:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterSubscription:ModelTypes["_ValidationResult"],
	getChart?:ModelTypes["Chart"],
	listChart:ModelTypes["Chart"][],
	paginateChart:ModelTypes["ChartConnection"],
	validateCreateChart:ModelTypes["_ValidationResult"],
	validateUpdateChart:ModelTypes["_ValidationResult"],
	getChartData?:ModelTypes["ChartData"],
	listChartData:ModelTypes["ChartData"][],
	paginateChartData:ModelTypes["ChartDataConnection"],
	validateCreateChartData:ModelTypes["_ValidationResult"],
	validateUpdateChartData:ModelTypes["_ValidationResult"],
	getEmployee?:ModelTypes["Employee"],
	listEmployee:ModelTypes["Employee"][],
	paginateEmployee:ModelTypes["EmployeeConnection"],
	validateCreateEmployee:ModelTypes["_ValidationResult"],
	validateUpdateEmployee:ModelTypes["_ValidationResult"],
	getEmployeeItem?:ModelTypes["EmployeeItem"],
	listEmployeeItem:ModelTypes["EmployeeItem"][],
	paginateEmployeeItem:ModelTypes["EmployeeItemConnection"],
	validateCreateEmployeeItem:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeItem:ModelTypes["_ValidationResult"],
	getEmployeeList?:ModelTypes["EmployeeList"],
	listEmployeeList:ModelTypes["EmployeeList"][],
	paginateEmployeeList:ModelTypes["EmployeeListConnection"],
	validateCreateEmployeeList:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeList:ModelTypes["_ValidationResult"],
	getEmployeeLocale?:ModelTypes["EmployeeLocale"],
	listEmployeeLocale:ModelTypes["EmployeeLocale"][],
	paginateEmployeeLocale:ModelTypes["EmployeeLocaleConnection"],
	validateCreateEmployeeLocale:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeLocale:ModelTypes["_ValidationResult"],
	getPhotographer?:ModelTypes["Photographer"],
	listPhotographer:ModelTypes["Photographer"][],
	paginatePhotographer:ModelTypes["PhotographerConnection"],
	validateCreatePhotographer:ModelTypes["_ValidationResult"],
	validateUpdatePhotographer:ModelTypes["_ValidationResult"],
	getDefinitionItem?:ModelTypes["DefinitionItem"],
	listDefinitionItem:ModelTypes["DefinitionItem"][],
	paginateDefinitionItem:ModelTypes["DefinitionItemConnection"],
	validateCreateDefinitionItem:ModelTypes["_ValidationResult"],
	validateUpdateDefinitionItem:ModelTypes["_ValidationResult"],
	getDefinitionList?:ModelTypes["DefinitionList"],
	listDefinitionList:ModelTypes["DefinitionList"][],
	paginateDefinitionList:ModelTypes["DefinitionListConnection"],
	validateCreateDefinitionList:ModelTypes["_ValidationResult"],
	validateUpdateDefinitionList:ModelTypes["_ValidationResult"],
	getLogoItem?:ModelTypes["LogoItem"],
	listLogoItem:ModelTypes["LogoItem"][],
	paginateLogoItem:ModelTypes["LogoItemConnection"],
	validateCreateLogoItem:ModelTypes["_ValidationResult"],
	validateUpdateLogoItem:ModelTypes["_ValidationResult"],
	getLogoList?:ModelTypes["LogoList"],
	listLogoList:ModelTypes["LogoList"][],
	paginateLogoList:ModelTypes["LogoListConnection"],
	validateCreateLogoList:ModelTypes["_ValidationResult"],
	validateUpdateLogoList:ModelTypes["_ValidationResult"],
	getStrategySchema?:ModelTypes["StrategySchema"],
	listStrategySchema:ModelTypes["StrategySchema"][],
	paginateStrategySchema:ModelTypes["StrategySchemaConnection"],
	validateCreateStrategySchema:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchema:ModelTypes["_ValidationResult"],
	getStrategySchemaGroup?:ModelTypes["StrategySchemaGroup"],
	listStrategySchemaGroup:ModelTypes["StrategySchemaGroup"][],
	paginateStrategySchemaGroup:ModelTypes["StrategySchemaGroupConnection"],
	validateCreateStrategySchemaGroup:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroup:ModelTypes["_ValidationResult"],
	getStrategySchemaGroupItem?:ModelTypes["StrategySchemaGroupItem"],
	listStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItem"][],
	paginateStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemConnection"],
	validateCreateStrategySchemaGroupItem:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroupItem:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getContactForm?:ModelTypes["ContactForm"],
	listContactForm:ModelTypes["ContactForm"][],
	paginateContactForm:ModelTypes["ContactFormConnection"],
	validateCreateContactForm:ModelTypes["_ValidationResult"],
	validateUpdateContactForm:ModelTypes["_ValidationResult"],
	getContactFormLocale?:ModelTypes["ContactFormLocale"],
	listContactFormLocale:ModelTypes["ContactFormLocale"][],
	paginateContactFormLocale:ModelTypes["ContactFormLocaleConnection"],
	validateCreateContactFormLocale:ModelTypes["_ValidationResult"],
	validateUpdateContactFormLocale:ModelTypes["_ValidationResult"],
	getContactSubscription?:ModelTypes["ContactSubscription"],
	listContactSubscription:ModelTypes["ContactSubscription"][],
	paginateContactSubscription:ModelTypes["ContactSubscriptionConnection"],
	validateCreateContactSubscription:ModelTypes["_ValidationResult"],
	validateUpdateContactSubscription:ModelTypes["_ValidationResult"],
	getContactTypeItem?:ModelTypes["ContactTypeItem"],
	listContactTypeItem:ModelTypes["ContactTypeItem"][],
	paginateContactTypeItem:ModelTypes["ContactTypeItemConnection"],
	validateCreateContactTypeItem:ModelTypes["_ValidationResult"],
	validateUpdateContactTypeItem:ModelTypes["_ValidationResult"],
	getFile?:ModelTypes["File"],
	listFile:ModelTypes["File"][],
	paginateFile:ModelTypes["FileConnection"],
	validateCreateFile:ModelTypes["_ValidationResult"],
	validateUpdateFile:ModelTypes["_ValidationResult"],
	transaction?:ModelTypes["QueryTransaction"],
	_info?:ModelTypes["Info"],
	schema?:ModelTypes["_Schema"],
	s3DummyQuery?:string
};
	["ContactPage"]: {
		_meta?:ModelTypes["ContactPageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["ContactPageLocale"][],
	localesByLocale?:ModelTypes["ContactPageLocale"],
	localesByLink?:ModelTypes["ContactPageLocale"],
	localesBySeo?:ModelTypes["ContactPageLocale"],
	localesByAddressLink?:ModelTypes["ContactPageLocale"],
	paginateLocales:ModelTypes["ContactPageLocaleConnection"]
};
	["ContactPageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["FieldMeta"]: {
		readable?:boolean,
	updatable?:boolean
};
	["UUID"]:string;
	["One"]: GraphQLTypes["One"];
	["ContactPageLocale"]: {
		_meta?:ModelTypes["ContactPageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["ContactPage"],
	locale?:ModelTypes["Locale"],
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"],
	address?:string,
	phone?:string,
	email?:string,
	youtube?:string,
	instagram?:string,
	facebook?:string,
	databox?:string,
	databoxNumber?:string,
	addressLink?:ModelTypes["Link"],
	socialsLabel?:string,
	openingHours?:string,
	identificationsLabel?:string,
	ico?:string,
	dic?:string,
	phoneLabel?:string,
	emailLabel?:string,
	linkedIn?:string,
	securities?:string,
	securitiesNumber?:string
};
	["ContactPageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	youtube?:ModelTypes["FieldMeta"],
	instagram?:ModelTypes["FieldMeta"],
	facebook?:ModelTypes["FieldMeta"],
	databox?:ModelTypes["FieldMeta"],
	databoxNumber?:ModelTypes["FieldMeta"],
	addressLink?:ModelTypes["FieldMeta"],
	socialsLabel?:ModelTypes["FieldMeta"],
	openingHours?:ModelTypes["FieldMeta"],
	identificationsLabel?:ModelTypes["FieldMeta"],
	ico?:ModelTypes["FieldMeta"],
	dic?:ModelTypes["FieldMeta"],
	phoneLabel?:ModelTypes["FieldMeta"],
	emailLabel?:ModelTypes["FieldMeta"],
	linkedIn?:ModelTypes["FieldMeta"],
	securities?:ModelTypes["FieldMeta"],
	securitiesNumber?:ModelTypes["FieldMeta"]
};
	["ContactPageWhere"]: GraphQLTypes["ContactPageWhere"];
	["UUIDCondition"]: GraphQLTypes["UUIDCondition"];
	["OneCondition"]: GraphQLTypes["OneCondition"];
	["ContactPageLocaleWhere"]: GraphQLTypes["ContactPageLocaleWhere"];
	["StringCondition"]: GraphQLTypes["StringCondition"];
	["LocaleWhere"]: GraphQLTypes["LocaleWhere"];
	["FooterLocaleWhere"]: GraphQLTypes["FooterLocaleWhere"];
	["FooterWhere"]: GraphQLTypes["FooterWhere"];
	["ImageWhere"]: GraphQLTypes["ImageWhere"];
	["IntCondition"]: GraphQLTypes["IntCondition"];
	["GraphicDesignerWhere"]: GraphQLTypes["GraphicDesignerWhere"];
	["LinkWhere"]: GraphQLTypes["LinkWhere"];
	["LinkTypeCondition"]: GraphQLTypes["LinkTypeCondition"];
	["LinkType"]: GraphQLTypes["LinkType"];
	["LinkableWhere"]: GraphQLTypes["LinkableWhere"];
	["HomePageLocaleWhere"]: GraphQLTypes["HomePageLocaleWhere"];
	["HomePageWhere"]: GraphQLTypes["HomePageWhere"];
	["MediumListWhere"]: GraphQLTypes["MediumListWhere"];
	["MediumItemWhere"]: GraphQLTypes["MediumItemWhere"];
	["MediumWhere"]: GraphQLTypes["MediumWhere"];
	["MediumTypeCondition"]: GraphQLTypes["MediumTypeCondition"];
	["MediumType"]: GraphQLTypes["MediumType"];
	["VideoWhere"]: GraphQLTypes["VideoWhere"];
	["FloatCondition"]: GraphQLTypes["FloatCondition"];
	["ContentWhere"]: GraphQLTypes["ContentWhere"];
	["ContentBlockWhere"]: GraphQLTypes["ContentBlockWhere"];
	["ContentReferenceWhere"]: GraphQLTypes["ContentReferenceWhere"];
	["ContentReferenceTypeCondition"]: GraphQLTypes["ContentReferenceTypeCondition"];
	["ContentReferenceType"]: GraphQLTypes["ContentReferenceType"];
	["DropDownListWhere"]: GraphQLTypes["DropDownListWhere"];
	["DropDownItemWhere"]: GraphQLTypes["DropDownItemWhere"];
	["DropDownTypeCondition"]: GraphQLTypes["DropDownTypeCondition"];
	["DropDownType"]: GraphQLTypes["DropDownType"];
	["EmployeeListWhere"]: GraphQLTypes["EmployeeListWhere"];
	["EmployeeItemWhere"]: GraphQLTypes["EmployeeItemWhere"];
	["EmployeeWhere"]: GraphQLTypes["EmployeeWhere"];
	["EmployeeLocaleWhere"]: GraphQLTypes["EmployeeLocaleWhere"];
	["ArtworkSelectionWhere"]: GraphQLTypes["ArtworkSelectionWhere"];
	["ArtworkSelectionLocaleWhere"]: GraphQLTypes["ArtworkSelectionLocaleWhere"];
	["SeoWhere"]: GraphQLTypes["SeoWhere"];
	["BooleanCondition"]: GraphQLTypes["BooleanCondition"];
	["ArtworkSelectionListWhere"]: GraphQLTypes["ArtworkSelectionListWhere"];
	["ArtworkSelectionItemWhere"]: GraphQLTypes["ArtworkSelectionItemWhere"];
	["ArtworkWhere"]: GraphQLTypes["ArtworkWhere"];
	["ArtworkLocaleWhere"]: GraphQLTypes["ArtworkLocaleWhere"];
	["GalleryWhere"]: GraphQLTypes["GalleryWhere"];
	["GalleryItemWhere"]: GraphQLTypes["GalleryItemWhere"];
	["EventListWhere"]: GraphQLTypes["EventListWhere"];
	["EventItemWhere"]: GraphQLTypes["EventItemWhere"];
	["EventWhere"]: GraphQLTypes["EventWhere"];
	["EventLocaleWhere"]: GraphQLTypes["EventLocaleWhere"];
	["DateTimeCondition"]: GraphQLTypes["DateTimeCondition"];
	["DateTime"]:string;
	["BoxListWhere"]: GraphQLTypes["BoxListWhere"];
	["BoxItemWhere"]: GraphQLTypes["BoxItemWhere"];
	["ChartWhere"]: GraphQLTypes["ChartWhere"];
	["ChartTypeCondition"]: GraphQLTypes["ChartTypeCondition"];
	["ChartType"]: GraphQLTypes["ChartType"];
	["ChartDataWhere"]: GraphQLTypes["ChartDataWhere"];
	["DateCondition"]: GraphQLTypes["DateCondition"];
	["Date"]:string;
	["DefinitionListWhere"]: GraphQLTypes["DefinitionListWhere"];
	["DefinitionItemWhere"]: GraphQLTypes["DefinitionItemWhere"];
	["LogoListWhere"]: GraphQLTypes["LogoListWhere"];
	["LogoItemWhere"]: GraphQLTypes["LogoItemWhere"];
	["StrategySchemaWhere"]: GraphQLTypes["StrategySchemaWhere"];
	["StrategySchemaGroupWhere"]: GraphQLTypes["StrategySchemaGroupWhere"];
	["StrategySchemaGroupItemWhere"]: GraphQLTypes["StrategySchemaGroupItemWhere"];
	["ContactFormWhere"]: GraphQLTypes["ContactFormWhere"];
	["ContactFormLocaleWhere"]: GraphQLTypes["ContactFormLocaleWhere"];
	["ContactTypeItemWhere"]: GraphQLTypes["ContactTypeItemWhere"];
	["ContactSubscriptionWhere"]: GraphQLTypes["ContactSubscriptionWhere"];
	["FileWhere"]: GraphQLTypes["FileWhere"];
	["NewsletterFormWhere"]: GraphQLTypes["NewsletterFormWhere"];
	["NewsletterFormLocaleWhere"]: GraphQLTypes["NewsletterFormLocaleWhere"];
	["NewsletterTypeItemWhere"]: GraphQLTypes["NewsletterTypeItemWhere"];
	["NewsletterSubscriptionWhere"]: GraphQLTypes["NewsletterSubscriptionWhere"];
	["BranchesWhere"]: GraphQLTypes["BranchesWhere"];
	["PageLocaleWhere"]: GraphQLTypes["PageLocaleWhere"];
	["PageWhere"]: GraphQLTypes["PageWhere"];
	["RedirectWhere"]: GraphQLTypes["RedirectWhere"];
	["PhotographerWhere"]: GraphQLTypes["PhotographerWhere"];
	["HeaderLocaleWhere"]: GraphQLTypes["HeaderLocaleWhere"];
	["HeaderWhere"]: GraphQLTypes["HeaderWhere"];
	["HeaderLinkWhere"]: GraphQLTypes["HeaderLinkWhere"];
	["SeoDefaultLocaleWhere"]: GraphQLTypes["SeoDefaultLocaleWhere"];
	["SeoDefaultWhere"]: GraphQLTypes["SeoDefaultWhere"];
	["Locale"]: {
		_meta?:ModelTypes["LocaleMeta"],
	id:ModelTypes["UUID"],
	code:string,
	label?:string,
	contactPages:ModelTypes["ContactPageLocale"][],
	footers:ModelTypes["FooterLocale"][],
	headers:ModelTypes["HeaderLocale"][],
	homePages:ModelTypes["HomePageLocale"][],
	pages:ModelTypes["PageLocale"][],
	seoDefaults:ModelTypes["SeoDefaultLocale"][],
	events:ModelTypes["EventLocale"][],
	artworks:ModelTypes["ArtworkLocale"][],
	artworkSelections:ModelTypes["ArtworkSelectionLocale"][],
	newsletterForms:ModelTypes["NewsletterFormLocale"][],
	employees:ModelTypes["EmployeeLocale"][],
	contactForms:ModelTypes["ContactFormLocale"][],
	contactPagesByRoot?:ModelTypes["ContactPageLocale"],
	contactPagesByLink?:ModelTypes["ContactPageLocale"],
	contactPagesBySeo?:ModelTypes["ContactPageLocale"],
	contactPagesByAddressLink?:ModelTypes["ContactPageLocale"],
	footersByRoot?:ModelTypes["FooterLocale"],
	footersByDeveloperLink?:ModelTypes["FooterLocale"],
	headersByRoot?:ModelTypes["HeaderLocale"],
	headersByArtworkBreadcrumbParentLink?:ModelTypes["HeaderLocale"],
	homePagesByRoot?:ModelTypes["HomePageLocale"],
	homePagesByContent?:ModelTypes["HomePageLocale"],
	homePagesByLink?:ModelTypes["HomePageLocale"],
	homePagesBySeo?:ModelTypes["HomePageLocale"],
	pagesByRoot?:ModelTypes["PageLocale"],
	pagesByLink?:ModelTypes["PageLocale"],
	pagesByContent?:ModelTypes["PageLocale"],
	pagesBySeo?:ModelTypes["PageLocale"],
	seoDefaultsByRoot?:ModelTypes["SeoDefaultLocale"],
	seoDefaultsBySeo?:ModelTypes["SeoDefaultLocale"],
	eventsByRoot?:ModelTypes["EventLocale"],
	eventsByImage?:ModelTypes["EventLocale"],
	eventsBySeo?:ModelTypes["EventLocale"],
	eventsByLink?:ModelTypes["EventLocale"],
	eventsByContent?:ModelTypes["EventLocale"],
	artworksByRoot?:ModelTypes["ArtworkLocale"],
	artworksByContent?:ModelTypes["ArtworkLocale"],
	artworksBySeo?:ModelTypes["ArtworkLocale"],
	artworksByLink?:ModelTypes["ArtworkLocale"],
	artworkSelectionsByRoot?:ModelTypes["ArtworkSelectionLocale"],
	artworkSelectionsBySeo?:ModelTypes["ArtworkSelectionLocale"],
	artworkSelectionsByLink?:ModelTypes["ArtworkSelectionLocale"],
	newsletterFormsByRoot?:ModelTypes["NewsletterFormLocale"],
	newsletterFormsByItems?:ModelTypes["NewsletterFormLocale"],
	employeesByRoot?:ModelTypes["EmployeeLocale"],
	contactFormsByRoot?:ModelTypes["ContactFormLocale"],
	contactFormsByItems?:ModelTypes["ContactFormLocale"],
	paginateContactPages:ModelTypes["ContactPageLocaleConnection"],
	paginateFooters:ModelTypes["FooterLocaleConnection"],
	paginateHeaders:ModelTypes["HeaderLocaleConnection"],
	paginateHomePages:ModelTypes["HomePageLocaleConnection"],
	paginatePages:ModelTypes["PageLocaleConnection"],
	paginateSeoDefaults:ModelTypes["SeoDefaultLocaleConnection"],
	paginateEvents:ModelTypes["EventLocaleConnection"],
	paginateArtworks:ModelTypes["ArtworkLocaleConnection"],
	paginateArtworkSelections:ModelTypes["ArtworkSelectionLocaleConnection"],
	paginateNewsletterForms:ModelTypes["NewsletterFormLocaleConnection"],
	paginateEmployees:ModelTypes["EmployeeLocaleConnection"],
	paginateContactForms:ModelTypes["ContactFormLocaleConnection"]
};
	["LocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	contactPages?:ModelTypes["FieldMeta"],
	footers?:ModelTypes["FieldMeta"],
	headers?:ModelTypes["FieldMeta"],
	homePages?:ModelTypes["FieldMeta"],
	pages?:ModelTypes["FieldMeta"],
	seoDefaults?:ModelTypes["FieldMeta"],
	events?:ModelTypes["FieldMeta"],
	artworks?:ModelTypes["FieldMeta"],
	artworkSelections?:ModelTypes["FieldMeta"],
	newsletterForms?:ModelTypes["FieldMeta"],
	employees?:ModelTypes["FieldMeta"],
	contactForms?:ModelTypes["FieldMeta"]
};
	["ContactPageLocaleOrderBy"]: GraphQLTypes["ContactPageLocaleOrderBy"];
	["OrderDirection"]: GraphQLTypes["OrderDirection"];
	["ContactPageOrderBy"]: GraphQLTypes["ContactPageOrderBy"];
	["LocaleOrderBy"]: GraphQLTypes["LocaleOrderBy"];
	["LinkableOrderBy"]: GraphQLTypes["LinkableOrderBy"];
	["HomePageLocaleOrderBy"]: GraphQLTypes["HomePageLocaleOrderBy"];
	["HomePageOrderBy"]: GraphQLTypes["HomePageOrderBy"];
	["MediumListOrderBy"]: GraphQLTypes["MediumListOrderBy"];
	["ContentOrderBy"]: GraphQLTypes["ContentOrderBy"];
	["SeoOrderBy"]: GraphQLTypes["SeoOrderBy"];
	["ImageOrderBy"]: GraphQLTypes["ImageOrderBy"];
	["PageLocaleOrderBy"]: GraphQLTypes["PageLocaleOrderBy"];
	["PageOrderBy"]: GraphQLTypes["PageOrderBy"];
	["EventLocaleOrderBy"]: GraphQLTypes["EventLocaleOrderBy"];
	["EventOrderBy"]: GraphQLTypes["EventOrderBy"];
	["ArtworkLocaleOrderBy"]: GraphQLTypes["ArtworkLocaleOrderBy"];
	["ArtworkOrderBy"]: GraphQLTypes["ArtworkOrderBy"];
	["GalleryOrderBy"]: GraphQLTypes["GalleryOrderBy"];
	["ArtworkSelectionLocaleOrderBy"]: GraphQLTypes["ArtworkSelectionLocaleOrderBy"];
	["ArtworkSelectionOrderBy"]: GraphQLTypes["ArtworkSelectionOrderBy"];
	["ArtworkSelectionListOrderBy"]: GraphQLTypes["ArtworkSelectionListOrderBy"];
	["RedirectOrderBy"]: GraphQLTypes["RedirectOrderBy"];
	["LinkOrderBy"]: GraphQLTypes["LinkOrderBy"];
	["FooterLocale"]: {
		_meta?:ModelTypes["FooterLocaleMeta"],
	id:ModelTypes["UUID"],
	address?:string,
	phone?:string,
	email?:string,
	youtube?:string,
	instagram?:string,
	facebook?:string,
	graphicDesign?:string,
	root?:ModelTypes["Footer"],
	locale?:ModelTypes["Locale"],
	graphicDesigners:ModelTypes["GraphicDesigner"][],
	developerLink?:ModelTypes["Link"],
	development?:string,
	linkedIn?:string,
	photography?:string,
	photographers:ModelTypes["Photographer"][],
	paginateGraphicDesigners:ModelTypes["GraphicDesignerConnection"],
	paginatePhotographers:ModelTypes["PhotographerConnection"]
};
	["FooterLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	address?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	youtube?:ModelTypes["FieldMeta"],
	instagram?:ModelTypes["FieldMeta"],
	facebook?:ModelTypes["FieldMeta"],
	graphicDesign?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	graphicDesigners?:ModelTypes["FieldMeta"],
	developerLink?:ModelTypes["FieldMeta"],
	development?:ModelTypes["FieldMeta"],
	linkedIn?:ModelTypes["FieldMeta"],
	photography?:ModelTypes["FieldMeta"],
	photographers?:ModelTypes["FieldMeta"]
};
	["Footer"]: {
		_meta?:ModelTypes["FooterMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	logo?:ModelTypes["Image"],
	locales:ModelTypes["FooterLocale"][],
	localesByLocale?:ModelTypes["FooterLocale"],
	localesByDeveloperLink?:ModelTypes["FooterLocale"],
	paginateLocales:ModelTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["Image"]: {
		_meta?:ModelTypes["ImageMeta"],
	id:ModelTypes["UUID"],
	url:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	alt?:string
};
	["ImageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	alt?:ModelTypes["FieldMeta"]
};
	["FooterLocaleOrderBy"]: GraphQLTypes["FooterLocaleOrderBy"];
	["FooterOrderBy"]: GraphQLTypes["FooterOrderBy"];
	["FooterLocalesByLocaleUniqueWhere"]: GraphQLTypes["FooterLocalesByLocaleUniqueWhere"];
	["LocaleUniqueWhere"]: GraphQLTypes["LocaleUniqueWhere"];
	["ContactPageLocaleUniqueWhere"]: GraphQLTypes["ContactPageLocaleUniqueWhere"];
	["ContactPageUniqueWhere"]: GraphQLTypes["ContactPageUniqueWhere"];
	["LinkableUniqueWhere"]: GraphQLTypes["LinkableUniqueWhere"];
	["HomePageLocaleUniqueWhere"]: GraphQLTypes["HomePageLocaleUniqueWhere"];
	["HomePageUniqueWhere"]: GraphQLTypes["HomePageUniqueWhere"];
	["MediumListUniqueWhere"]: GraphQLTypes["MediumListUniqueWhere"];
	["MediumItemUniqueWhere"]: GraphQLTypes["MediumItemUniqueWhere"];
	["ContentUniqueWhere"]: GraphQLTypes["ContentUniqueWhere"];
	["ContentBlockUniqueWhere"]: GraphQLTypes["ContentBlockUniqueWhere"];
	["ContentReferenceUniqueWhere"]: GraphQLTypes["ContentReferenceUniqueWhere"];
	["LinkUniqueWhere"]: GraphQLTypes["LinkUniqueWhere"];
	["DropDownListUniqueWhere"]: GraphQLTypes["DropDownListUniqueWhere"];
	["DropDownItemUniqueWhere"]: GraphQLTypes["DropDownItemUniqueWhere"];
	["EmployeeListUniqueWhere"]: GraphQLTypes["EmployeeListUniqueWhere"];
	["EmployeeItemUniqueWhere"]: GraphQLTypes["EmployeeItemUniqueWhere"];
	["EventListUniqueWhere"]: GraphQLTypes["EventListUniqueWhere"];
	["EventItemUniqueWhere"]: GraphQLTypes["EventItemUniqueWhere"];
	["BoxListUniqueWhere"]: GraphQLTypes["BoxListUniqueWhere"];
	["BoxItemUniqueWhere"]: GraphQLTypes["BoxItemUniqueWhere"];
	["ChartUniqueWhere"]: GraphQLTypes["ChartUniqueWhere"];
	["ChartDataUniqueWhere"]: GraphQLTypes["ChartDataUniqueWhere"];
	["DefinitionListUniqueWhere"]: GraphQLTypes["DefinitionListUniqueWhere"];
	["DefinitionItemUniqueWhere"]: GraphQLTypes["DefinitionItemUniqueWhere"];
	["LogoListUniqueWhere"]: GraphQLTypes["LogoListUniqueWhere"];
	["LogoItemUniqueWhere"]: GraphQLTypes["LogoItemUniqueWhere"];
	["StrategySchemaUniqueWhere"]: GraphQLTypes["StrategySchemaUniqueWhere"];
	["StrategySchemaGroupUniqueWhere"]: GraphQLTypes["StrategySchemaGroupUniqueWhere"];
	["StrategySchemaGroupItemUniqueWhere"]: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"];
	["ImageUniqueWhere"]: GraphQLTypes["ImageUniqueWhere"];
	["SeoUniqueWhere"]: GraphQLTypes["SeoUniqueWhere"];
	["PageLocaleUniqueWhere"]: GraphQLTypes["PageLocaleUniqueWhere"];
	["PageUniqueWhere"]: GraphQLTypes["PageUniqueWhere"];
	["EventLocaleUniqueWhere"]: GraphQLTypes["EventLocaleUniqueWhere"];
	["EventUniqueWhere"]: GraphQLTypes["EventUniqueWhere"];
	["ArtworkLocaleUniqueWhere"]: GraphQLTypes["ArtworkLocaleUniqueWhere"];
	["ArtworkUniqueWhere"]: GraphQLTypes["ArtworkUniqueWhere"];
	["GalleryUniqueWhere"]: GraphQLTypes["GalleryUniqueWhere"];
	["GalleryItemUniqueWhere"]: GraphQLTypes["GalleryItemUniqueWhere"];
	["ArtworkSelectionLocaleUniqueWhere"]: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"];
	["ArtworkSelectionUniqueWhere"]: GraphQLTypes["ArtworkSelectionUniqueWhere"];
	["ArtworkSelectionListUniqueWhere"]: GraphQLTypes["ArtworkSelectionListUniqueWhere"];
	["ArtworkSelectionItemUniqueWhere"]: GraphQLTypes["ArtworkSelectionItemUniqueWhere"];
	["RedirectUniqueWhere"]: GraphQLTypes["RedirectUniqueWhere"];
	["FooterLocaleUniqueWhere"]: GraphQLTypes["FooterLocaleUniqueWhere"];
	["FooterUniqueWhere"]: GraphQLTypes["FooterUniqueWhere"];
	["HeaderLocaleUniqueWhere"]: GraphQLTypes["HeaderLocaleUniqueWhere"];
	["HeaderUniqueWhere"]: GraphQLTypes["HeaderUniqueWhere"];
	["SeoDefaultLocaleUniqueWhere"]: GraphQLTypes["SeoDefaultLocaleUniqueWhere"];
	["SeoDefaultUniqueWhere"]: GraphQLTypes["SeoDefaultUniqueWhere"];
	["NewsletterFormLocaleUniqueWhere"]: GraphQLTypes["NewsletterFormLocaleUniqueWhere"];
	["NewsletterFormUniqueWhere"]: GraphQLTypes["NewsletterFormUniqueWhere"];
	["NewsletterTypeItemUniqueWhere"]: GraphQLTypes["NewsletterTypeItemUniqueWhere"];
	["NewsletterSubscriptionUniqueWhere"]: GraphQLTypes["NewsletterSubscriptionUniqueWhere"];
	["EmployeeLocaleUniqueWhere"]: GraphQLTypes["EmployeeLocaleUniqueWhere"];
	["EmployeeUniqueWhere"]: GraphQLTypes["EmployeeUniqueWhere"];
	["ContactFormLocaleUniqueWhere"]: GraphQLTypes["ContactFormLocaleUniqueWhere"];
	["ContactFormUniqueWhere"]: GraphQLTypes["ContactFormUniqueWhere"];
	["ContactTypeItemUniqueWhere"]: GraphQLTypes["ContactTypeItemUniqueWhere"];
	["ContactSubscriptionUniqueWhere"]: GraphQLTypes["ContactSubscriptionUniqueWhere"];
	["FileUniqueWhere"]: GraphQLTypes["FileUniqueWhere"];
	["FooterLocalesByDeveloperLinkUniqueWhere"]: GraphQLTypes["FooterLocalesByDeveloperLinkUniqueWhere"];
	["FooterLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterLocaleEdge"][]
};
	["PageInfo"]: {
		totalCount:number
};
	["FooterLocaleEdge"]: {
		node:ModelTypes["FooterLocale"]
};
	["GraphicDesigner"]: {
		_meta?:ModelTypes["GraphicDesignerMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["GraphicDesignerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["Link"]: {
		_meta?:ModelTypes["LinkMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["LinkType"],
	title?:string,
	externalLink?:string,
	internalLink?:ModelTypes["Linkable"],
	anchorLink?:string
};
	["LinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	externalLink?:ModelTypes["FieldMeta"],
	internalLink?:ModelTypes["FieldMeta"],
	anchorLink?:ModelTypes["FieldMeta"]
};
	["Linkable"]: {
		_meta?:ModelTypes["LinkableMeta"],
	id:ModelTypes["UUID"],
	url:string,
	homePage?:ModelTypes["HomePageLocale"],
	contactPage?:ModelTypes["ContactPageLocale"],
	page?:ModelTypes["PageLocale"],
	event?:ModelTypes["EventLocale"],
	artwork?:ModelTypes["ArtworkLocale"],
	artworkSelection?:ModelTypes["ArtworkSelectionLocale"],
	redirect?:ModelTypes["Redirect"]
};
	["LinkableMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	homePage?:ModelTypes["FieldMeta"],
	contactPage?:ModelTypes["FieldMeta"],
	page?:ModelTypes["FieldMeta"],
	event?:ModelTypes["FieldMeta"],
	artwork?:ModelTypes["FieldMeta"],
	artworkSelection?:ModelTypes["FieldMeta"],
	redirect?:ModelTypes["FieldMeta"]
};
	["HomePageLocale"]: {
		_meta?:ModelTypes["HomePageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["HomePage"],
	locale?:ModelTypes["Locale"],
	content?:ModelTypes["Content"],
	link?:ModelTypes["Linkable"],
	seo?:ModelTypes["Seo"],
	branches:ModelTypes["Branches"][],
	leadParagraph?:string,
	paginateBranches:ModelTypes["BranchesConnection"]
};
	["HomePageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	branches?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"]
};
	["HomePage"]: {
		_meta?:ModelTypes["HomePageMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["HomePageLocale"][],
	media?:ModelTypes["MediumList"],
	localesByLocale?:ModelTypes["HomePageLocale"],
	localesByContent?:ModelTypes["HomePageLocale"],
	localesByLink?:ModelTypes["HomePageLocale"],
	localesBySeo?:ModelTypes["HomePageLocale"],
	paginateLocales:ModelTypes["HomePageLocaleConnection"]
};
	["HomePageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	media?:ModelTypes["FieldMeta"]
};
	["MediumList"]: {
		_meta?:ModelTypes["MediumListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["MediumItem"][],
	paginateItems:ModelTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["MediumItem"]: {
		_meta?:ModelTypes["MediumItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["MediumList"],
	medium?:ModelTypes["Medium"]
};
	["MediumItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	medium?:ModelTypes["FieldMeta"]
};
	["Medium"]: {
		_meta?:ModelTypes["MediumMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["MediumType"],
	image?:ModelTypes["Image"],
	video?:ModelTypes["Video"],
	youtubeEmbed?:string
};
	["MediumMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	video?:ModelTypes["FieldMeta"],
	youtubeEmbed?:ModelTypes["FieldMeta"]
};
	["Video"]: {
		_meta?:ModelTypes["VideoMeta"],
	id:ModelTypes["UUID"],
	src?:string,
	width?:number,
	height?:number,
	size?:number,
	type?:string,
	duration?:number,
	poster?:ModelTypes["Image"]
};
	["VideoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	src?:ModelTypes["FieldMeta"],
	width?:ModelTypes["FieldMeta"],
	height?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	duration?:ModelTypes["FieldMeta"],
	poster?:ModelTypes["FieldMeta"]
};
	["MediumItemOrderBy"]: GraphQLTypes["MediumItemOrderBy"];
	["MediumOrderBy"]: GraphQLTypes["MediumOrderBy"];
	["VideoOrderBy"]: GraphQLTypes["VideoOrderBy"];
	["MediumItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumItemEdge"][]
};
	["MediumItemEdge"]: {
		node:ModelTypes["MediumItem"]
};
	["HomePageLocalesByLocaleUniqueWhere"]: GraphQLTypes["HomePageLocalesByLocaleUniqueWhere"];
	["HomePageLocalesByContentUniqueWhere"]: GraphQLTypes["HomePageLocalesByContentUniqueWhere"];
	["HomePageLocalesByLinkUniqueWhere"]: GraphQLTypes["HomePageLocalesByLinkUniqueWhere"];
	["HomePageLocalesBySeoUniqueWhere"]: GraphQLTypes["HomePageLocalesBySeoUniqueWhere"];
	["HomePageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageLocaleEdge"][]
};
	["HomePageLocaleEdge"]: {
		node:ModelTypes["HomePageLocale"]
};
	["Content"]: {
		_meta?:ModelTypes["ContentMeta"],
	id:ModelTypes["UUID"],
	blocks:ModelTypes["ContentBlock"][],
	blocksByReferences?:ModelTypes["ContentBlock"],
	paginateBlocks:ModelTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
		id?:ModelTypes["FieldMeta"],
	blocks?:ModelTypes["FieldMeta"]
};
	["ContentBlock"]: {
		_meta?:ModelTypes["ContentBlockMeta"],
	id:ModelTypes["UUID"],
	order:number,
	json:string,
	content?:ModelTypes["Content"],
	references:ModelTypes["ContentReference"][],
	referencesByMedia?:ModelTypes["ContentReference"],
	referencesByLink?:ModelTypes["ContentReference"],
	referencesByDropDownList?:ModelTypes["ContentReference"],
	referencesByEventList?:ModelTypes["ContentReference"],
	referencesByBoxList?:ModelTypes["ContentReference"],
	referencesByChart?:ModelTypes["ContentReference"],
	referencesByDefinitionList?:ModelTypes["ContentReference"],
	referencesByLogoList?:ModelTypes["ContentReference"],
	referencesByStrategySchema?:ModelTypes["ContentReference"],
	referencesByEmployeeList?:ModelTypes["ContentReference"],
	paginateReferences:ModelTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	json?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	references?:ModelTypes["FieldMeta"]
};
	["ContentReference"]: {
		_meta?:ModelTypes["ContentReferenceMeta"],
	id:ModelTypes["UUID"],
	type:ModelTypes["ContentReferenceType"],
	primaryText?:string,
	block?:ModelTypes["ContentBlock"],
	media?:ModelTypes["MediumList"],
	link?:ModelTypes["Link"],
	secondaryText?:string,
	dropDownList?:ModelTypes["DropDownList"],
	artworkSelection?:ModelTypes["ArtworkSelection"],
	eventList?:ModelTypes["EventList"],
	boxList?:ModelTypes["BoxList"],
	isVisible?:boolean,
	chart?:ModelTypes["Chart"],
	definitionList?:ModelTypes["DefinitionList"],
	logoList?:ModelTypes["LogoList"],
	strategySchema?:ModelTypes["StrategySchema"],
	image?:ModelTypes["Image"],
	employeeList?:ModelTypes["EmployeeList"],
	imageSecond?:ModelTypes["Image"],
	contactForm?:ModelTypes["ContactForm"],
	newsletterForm?:ModelTypes["NewsletterForm"]
};
	["ContentReferenceMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	primaryText?:ModelTypes["FieldMeta"],
	block?:ModelTypes["FieldMeta"],
	media?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	secondaryText?:ModelTypes["FieldMeta"],
	dropDownList?:ModelTypes["FieldMeta"],
	artworkSelection?:ModelTypes["FieldMeta"],
	eventList?:ModelTypes["FieldMeta"],
	boxList?:ModelTypes["FieldMeta"],
	isVisible?:ModelTypes["FieldMeta"],
	chart?:ModelTypes["FieldMeta"],
	definitionList?:ModelTypes["FieldMeta"],
	logoList?:ModelTypes["FieldMeta"],
	strategySchema?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	employeeList?:ModelTypes["FieldMeta"],
	imageSecond?:ModelTypes["FieldMeta"],
	contactForm?:ModelTypes["FieldMeta"],
	newsletterForm?:ModelTypes["FieldMeta"]
};
	["DropDownList"]: {
		_meta?:ModelTypes["DropDownListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["DropDownItem"][],
	dropDownType?:ModelTypes["DropDownType"],
	employees?:ModelTypes["EmployeeList"],
	itemsByLink?:ModelTypes["DropDownItem"],
	paginateItems:ModelTypes["DropDownItemConnection"]
};
	["DropDownListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	dropDownType?:ModelTypes["FieldMeta"],
	employees?:ModelTypes["FieldMeta"]
};
	["DropDownItem"]: {
		_meta?:ModelTypes["DropDownItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	text?:string,
	list?:ModelTypes["DropDownList"],
	link?:ModelTypes["Link"]
};
	["DropDownItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["DropDownItemOrderBy"]: GraphQLTypes["DropDownItemOrderBy"];
	["DropDownListOrderBy"]: GraphQLTypes["DropDownListOrderBy"];
	["EmployeeListOrderBy"]: GraphQLTypes["EmployeeListOrderBy"];
	["EmployeeList"]: {
		_meta?:ModelTypes["EmployeeListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["EmployeeItem"][],
	paginateItems:ModelTypes["EmployeeItemConnection"]
};
	["EmployeeListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["EmployeeItem"]: {
		_meta?:ModelTypes["EmployeeItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["EmployeeList"],
	employee?:ModelTypes["Employee"]
};
	["EmployeeItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	employee?:ModelTypes["FieldMeta"]
};
	["Employee"]: {
		_meta?:ModelTypes["EmployeeMeta"],
	id:ModelTypes["UUID"],
	order:number,
	name?:string,
	image?:ModelTypes["Image"],
	locales:ModelTypes["EmployeeLocale"][],
	localesByLocale?:ModelTypes["EmployeeLocale"],
	paginateLocales:ModelTypes["EmployeeLocaleConnection"]
};
	["EmployeeMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["EmployeeLocale"]: {
		_meta?:ModelTypes["EmployeeLocaleMeta"],
	id:ModelTypes["UUID"],
	position?:string,
	text?:string,
	email?:string,
	phone?:string,
	root?:ModelTypes["Employee"],
	locale?:ModelTypes["Locale"]
};
	["EmployeeLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	position?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"]
};
	["EmployeeLocaleOrderBy"]: GraphQLTypes["EmployeeLocaleOrderBy"];
	["EmployeeOrderBy"]: GraphQLTypes["EmployeeOrderBy"];
	["EmployeeLocalesByLocaleUniqueWhere"]: GraphQLTypes["EmployeeLocalesByLocaleUniqueWhere"];
	["EmployeeLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EmployeeLocaleEdge"][]
};
	["EmployeeLocaleEdge"]: {
		node:ModelTypes["EmployeeLocale"]
};
	["EmployeeItemOrderBy"]: GraphQLTypes["EmployeeItemOrderBy"];
	["EmployeeItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EmployeeItemEdge"][]
};
	["EmployeeItemEdge"]: {
		node:ModelTypes["EmployeeItem"]
};
	["DropDownListItemsByLinkUniqueWhere"]: GraphQLTypes["DropDownListItemsByLinkUniqueWhere"];
	["DropDownItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DropDownItemEdge"][]
};
	["DropDownItemEdge"]: {
		node:ModelTypes["DropDownItem"]
};
	["ArtworkSelection"]: {
		_meta?:ModelTypes["ArtworkSelectionMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["ArtworkSelectionLocale"][],
	artworks?:ModelTypes["ArtworkSelectionList"],
	localesByLocale?:ModelTypes["ArtworkSelectionLocale"],
	localesBySeo?:ModelTypes["ArtworkSelectionLocale"],
	localesByLink?:ModelTypes["ArtworkSelectionLocale"],
	paginateLocales:ModelTypes["ArtworkSelectionLocaleConnection"]
};
	["ArtworkSelectionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	artworks?:ModelTypes["FieldMeta"]
};
	["ArtworkSelectionLocale"]: {
		_meta?:ModelTypes["ArtworkSelectionLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["ArtworkSelection"],
	locale?:ModelTypes["Locale"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"]
};
	["ArtworkSelectionLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["Seo"]: {
		_meta?:ModelTypes["SeoMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	description?:string,
	ogTitle?:string,
	ogDescription?:string,
	noIndex?:boolean,
	noFollow?:boolean,
	ogImage?:ModelTypes["Image"]
};
	["SeoMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	description?:ModelTypes["FieldMeta"],
	ogTitle?:ModelTypes["FieldMeta"],
	ogDescription?:ModelTypes["FieldMeta"],
	noIndex?:ModelTypes["FieldMeta"],
	noFollow?:ModelTypes["FieldMeta"],
	ogImage?:ModelTypes["FieldMeta"]
};
	["ArtworkSelectionList"]: {
		_meta?:ModelTypes["ArtworkSelectionListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ArtworkSelectionItem"][],
	paginateItems:ModelTypes["ArtworkSelectionItemConnection"]
};
	["ArtworkSelectionListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ArtworkSelectionItem"]: {
		_meta?:ModelTypes["ArtworkSelectionItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ArtworkSelectionList"],
	artwork?:ModelTypes["Artwork"]
};
	["ArtworkSelectionItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	artwork?:ModelTypes["FieldMeta"]
};
	["Artwork"]: {
		_meta?:ModelTypes["ArtworkMeta"],
	id:ModelTypes["UUID"],
	order:number,
	locales:ModelTypes["ArtworkLocale"][],
	image?:ModelTypes["Image"],
	gallery?:ModelTypes["Gallery"],
	localesByLocale?:ModelTypes["ArtworkLocale"],
	localesByContent?:ModelTypes["ArtworkLocale"],
	localesBySeo?:ModelTypes["ArtworkLocale"],
	localesByLink?:ModelTypes["ArtworkLocale"],
	paginateLocales:ModelTypes["ArtworkLocaleConnection"]
};
	["ArtworkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	gallery?:ModelTypes["FieldMeta"]
};
	["ArtworkLocale"]: {
		_meta?:ModelTypes["ArtworkLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	label?:string,
	leadParagraph?:string,
	root?:ModelTypes["Artwork"],
	locale?:ModelTypes["Locale"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	artist?:string
};
	["ArtworkLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	label?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	artist?:ModelTypes["FieldMeta"]
};
	["Gallery"]: {
		_meta?:ModelTypes["GalleryMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["GalleryItem"][],
	paginateItems:ModelTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["GalleryItem"]: {
		_meta?:ModelTypes["GalleryItemMeta"],
	id:ModelTypes["UUID"],
	order?:number,
	list?:ModelTypes["Gallery"],
	image?:ModelTypes["Image"]
};
	["GalleryItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: GraphQLTypes["GalleryItemOrderBy"];
	["GalleryItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryItemEdge"][]
};
	["GalleryItemEdge"]: {
		node:ModelTypes["GalleryItem"]
};
	["ArtworkLocalesByLocaleUniqueWhere"]: GraphQLTypes["ArtworkLocalesByLocaleUniqueWhere"];
	["ArtworkLocalesByContentUniqueWhere"]: GraphQLTypes["ArtworkLocalesByContentUniqueWhere"];
	["ArtworkLocalesBySeoUniqueWhere"]: GraphQLTypes["ArtworkLocalesBySeoUniqueWhere"];
	["ArtworkLocalesByLinkUniqueWhere"]: GraphQLTypes["ArtworkLocalesByLinkUniqueWhere"];
	["ArtworkLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkLocaleEdge"][]
};
	["ArtworkLocaleEdge"]: {
		node:ModelTypes["ArtworkLocale"]
};
	["ArtworkSelectionItemOrderBy"]: GraphQLTypes["ArtworkSelectionItemOrderBy"];
	["ArtworkSelectionItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkSelectionItemEdge"][]
};
	["ArtworkSelectionItemEdge"]: {
		node:ModelTypes["ArtworkSelectionItem"]
};
	["ArtworkSelectionLocalesByLocaleUniqueWhere"]: GraphQLTypes["ArtworkSelectionLocalesByLocaleUniqueWhere"];
	["ArtworkSelectionLocalesBySeoUniqueWhere"]: GraphQLTypes["ArtworkSelectionLocalesBySeoUniqueWhere"];
	["ArtworkSelectionLocalesByLinkUniqueWhere"]: GraphQLTypes["ArtworkSelectionLocalesByLinkUniqueWhere"];
	["ArtworkSelectionLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkSelectionLocaleEdge"][]
};
	["ArtworkSelectionLocaleEdge"]: {
		node:ModelTypes["ArtworkSelectionLocale"]
};
	["EventList"]: {
		_meta?:ModelTypes["EventListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["EventItem"][],
	paginateItems:ModelTypes["EventItemConnection"]
};
	["EventListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["EventItem"]: {
		_meta?:ModelTypes["EventItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["EventList"],
	event?:ModelTypes["Event"]
};
	["EventItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	event?:ModelTypes["FieldMeta"]
};
	["Event"]: {
		_meta?:ModelTypes["EventMeta"],
	id:ModelTypes["UUID"],
	locales:ModelTypes["EventLocale"][],
	order:number,
	dateStart?:ModelTypes["DateTime"],
	dateFinish?:ModelTypes["DateTime"],
	localesByLocale?:ModelTypes["EventLocale"],
	localesByImage?:ModelTypes["EventLocale"],
	localesBySeo?:ModelTypes["EventLocale"],
	localesByLink?:ModelTypes["EventLocale"],
	localesByContent?:ModelTypes["EventLocale"],
	paginateLocales:ModelTypes["EventLocaleConnection"]
};
	["EventMeta"]: {
		id?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	dateStart?:ModelTypes["FieldMeta"],
	dateFinish?:ModelTypes["FieldMeta"]
};
	["EventLocale"]: {
		_meta?:ModelTypes["EventLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	root?:ModelTypes["Event"],
	locale?:ModelTypes["Locale"],
	image?:ModelTypes["Image"],
	seo?:ModelTypes["Seo"],
	link?:ModelTypes["Linkable"],
	venue?:string,
	venueNote?:string,
	content?:ModelTypes["Content"],
	date?:string,
	leadParagraph?:string,
	isDark?:boolean
};
	["EventLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	venue?:ModelTypes["FieldMeta"],
	venueNote?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	date?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	isDark?:ModelTypes["FieldMeta"]
};
	["EventLocalesByLocaleUniqueWhere"]: GraphQLTypes["EventLocalesByLocaleUniqueWhere"];
	["EventLocalesByImageUniqueWhere"]: GraphQLTypes["EventLocalesByImageUniqueWhere"];
	["EventLocalesBySeoUniqueWhere"]: GraphQLTypes["EventLocalesBySeoUniqueWhere"];
	["EventLocalesByLinkUniqueWhere"]: GraphQLTypes["EventLocalesByLinkUniqueWhere"];
	["EventLocalesByContentUniqueWhere"]: GraphQLTypes["EventLocalesByContentUniqueWhere"];
	["EventLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventLocaleEdge"][]
};
	["EventLocaleEdge"]: {
		node:ModelTypes["EventLocale"]
};
	["EventItemOrderBy"]: GraphQLTypes["EventItemOrderBy"];
	["EventListOrderBy"]: GraphQLTypes["EventListOrderBy"];
	["EventItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventItemEdge"][]
};
	["EventItemEdge"]: {
		node:ModelTypes["EventItem"]
};
	["BoxList"]: {
		_meta?:ModelTypes["BoxListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["BoxItem"][],
	paginateItems:ModelTypes["BoxItemConnection"]
};
	["BoxListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["BoxItem"]: {
		_meta?:ModelTypes["BoxItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:string,
	date?:string,
	type?:string,
	title?:string,
	text?:string,
	list?:ModelTypes["BoxList"]
};
	["BoxItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	date?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["BoxItemOrderBy"]: GraphQLTypes["BoxItemOrderBy"];
	["BoxListOrderBy"]: GraphQLTypes["BoxListOrderBy"];
	["BoxItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BoxItemEdge"][]
};
	["BoxItemEdge"]: {
		node:ModelTypes["BoxItem"]
};
	["Chart"]: {
		_meta?:ModelTypes["ChartMeta"],
	id:ModelTypes["UUID"],
	type?:ModelTypes["ChartType"],
	items:ModelTypes["ChartData"][],
	paginateItems:ModelTypes["ChartDataConnection"]
};
	["ChartMeta"]: {
		id?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ChartData"]: {
		_meta?:ModelTypes["ChartDataMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["Chart"],
	date?:ModelTypes["Date"],
	number?:number,
	text?:string,
	image?:ModelTypes["Image"]
};
	["ChartDataMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	date?:ModelTypes["FieldMeta"],
	number?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["ChartDataOrderBy"]: GraphQLTypes["ChartDataOrderBy"];
	["ChartOrderBy"]: GraphQLTypes["ChartOrderBy"];
	["ChartDataConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ChartDataEdge"][]
};
	["ChartDataEdge"]: {
		node:ModelTypes["ChartData"]
};
	["DefinitionList"]: {
		_meta?:ModelTypes["DefinitionListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["DefinitionItem"][],
	paginateItems:ModelTypes["DefinitionItemConnection"]
};
	["DefinitionListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["DefinitionItem"]: {
		_meta?:ModelTypes["DefinitionItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	key?:string,
	value?:string,
	list?:ModelTypes["DefinitionList"]
};
	["DefinitionItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["DefinitionItemOrderBy"]: GraphQLTypes["DefinitionItemOrderBy"];
	["DefinitionListOrderBy"]: GraphQLTypes["DefinitionListOrderBy"];
	["DefinitionItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DefinitionItemEdge"][]
};
	["DefinitionItemEdge"]: {
		node:ModelTypes["DefinitionItem"]
};
	["LogoList"]: {
		_meta?:ModelTypes["LogoListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["LogoItem"][],
	paginateItems:ModelTypes["LogoItemConnection"]
};
	["LogoListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["LogoItem"]: {
		_meta?:ModelTypes["LogoItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["LogoList"],
	image?:ModelTypes["Image"]
};
	["LogoItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	image?:ModelTypes["FieldMeta"]
};
	["LogoItemOrderBy"]: GraphQLTypes["LogoItemOrderBy"];
	["LogoListOrderBy"]: GraphQLTypes["LogoListOrderBy"];
	["LogoItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LogoItemEdge"][]
};
	["LogoItemEdge"]: {
		node:ModelTypes["LogoItem"]
};
	["StrategySchema"]: {
		_meta?:ModelTypes["StrategySchemaMeta"],
	id:ModelTypes["UUID"],
	inputFirst?:string,
	inputSecond?:string,
	inputThird?:string,
	outputFirst?:string,
	outputSecond?:string,
	outputThird?:string,
	itemsFirst?:ModelTypes["StrategySchemaGroup"],
	logo?:ModelTypes["Image"],
	itemsSecond?:ModelTypes["StrategySchemaGroup"]
};
	["StrategySchemaMeta"]: {
		id?:ModelTypes["FieldMeta"],
	inputFirst?:ModelTypes["FieldMeta"],
	inputSecond?:ModelTypes["FieldMeta"],
	inputThird?:ModelTypes["FieldMeta"],
	outputFirst?:ModelTypes["FieldMeta"],
	outputSecond?:ModelTypes["FieldMeta"],
	outputThird?:ModelTypes["FieldMeta"],
	itemsFirst?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"],
	itemsSecond?:ModelTypes["FieldMeta"]
};
	["StrategySchemaGroup"]: {
		_meta?:ModelTypes["StrategySchemaGroupMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["StrategySchemaGroupItem"][],
	paginateItems:ModelTypes["StrategySchemaGroupItemConnection"]
};
	["StrategySchemaGroupMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["StrategySchemaGroupItem"]: {
		_meta?:ModelTypes["StrategySchemaGroupItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	text?:string,
	schema?:ModelTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	text?:ModelTypes["FieldMeta"],
	schema?:ModelTypes["FieldMeta"]
};
	["StrategySchemaGroupItemOrderBy"]: GraphQLTypes["StrategySchemaGroupItemOrderBy"];
	["StrategySchemaGroupOrderBy"]: GraphQLTypes["StrategySchemaGroupOrderBy"];
	["StrategySchemaGroupItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StrategySchemaGroupItemEdge"][]
};
	["StrategySchemaGroupItemEdge"]: {
		node:ModelTypes["StrategySchemaGroupItem"]
};
	["ContactForm"]: {
		_meta?:ModelTypes["ContactFormMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["ContactFormLocale"][],
	localesByLocale?:ModelTypes["ContactFormLocale"],
	localesByItems?:ModelTypes["ContactFormLocale"],
	paginateLocales:ModelTypes["ContactFormLocaleConnection"]
};
	["ContactFormMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["ContactFormLocale"]: {
		_meta?:ModelTypes["ContactFormLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	name?:string,
	phone?:string,
	email?:string,
	message?:string,
	submit?:string,
	successMessage?:string,
	genericErrorMessage?:string,
	contactTypeErrorMessage?:string,
	root?:ModelTypes["ContactForm"],
	locale?:ModelTypes["Locale"],
	items:ModelTypes["ContactTypeItem"][],
	file?:string,
	itemsBySubscriptions?:ModelTypes["ContactTypeItem"],
	paginateItems:ModelTypes["ContactTypeItemConnection"]
};
	["ContactFormLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	message?:ModelTypes["FieldMeta"],
	submit?:ModelTypes["FieldMeta"],
	successMessage?:ModelTypes["FieldMeta"],
	genericErrorMessage?:ModelTypes["FieldMeta"],
	contactTypeErrorMessage?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	file?:ModelTypes["FieldMeta"]
};
	["ContactTypeItem"]: {
		_meta?:ModelTypes["ContactTypeItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	subscriptions:ModelTypes["ContactSubscription"][],
	list?:ModelTypes["ContactFormLocale"],
	subscriptionsByFile?:ModelTypes["ContactSubscription"],
	paginateSubscriptions:ModelTypes["ContactSubscriptionConnection"]
};
	["ContactTypeItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	subscriptions?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"]
};
	["ContactSubscription"]: {
		_meta?:ModelTypes["ContactSubscriptionMeta"],
	id:ModelTypes["UUID"],
	createdAt:ModelTypes["DateTime"],
	email?:string,
	name?:string,
	phone?:string,
	message?:string,
	file?:ModelTypes["File"],
	contactType?:ModelTypes["ContactTypeItem"]
};
	["ContactSubscriptionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	phone?:ModelTypes["FieldMeta"],
	message?:ModelTypes["FieldMeta"],
	file?:ModelTypes["FieldMeta"],
	contactType?:ModelTypes["FieldMeta"]
};
	["File"]: {
		_meta?:ModelTypes["FileMeta"],
	id:ModelTypes["UUID"],
	url:string,
	size?:number,
	type?:string
};
	["FileMeta"]: {
		id?:ModelTypes["FieldMeta"],
	url?:ModelTypes["FieldMeta"],
	size?:ModelTypes["FieldMeta"],
	type?:ModelTypes["FieldMeta"]
};
	["ContactSubscriptionOrderBy"]: GraphQLTypes["ContactSubscriptionOrderBy"];
	["FileOrderBy"]: GraphQLTypes["FileOrderBy"];
	["ContactTypeItemOrderBy"]: GraphQLTypes["ContactTypeItemOrderBy"];
	["ContactFormLocaleOrderBy"]: GraphQLTypes["ContactFormLocaleOrderBy"];
	["ContactFormOrderBy"]: GraphQLTypes["ContactFormOrderBy"];
	["ContactTypeItemSubscriptionsByFileUniqueWhere"]: GraphQLTypes["ContactTypeItemSubscriptionsByFileUniqueWhere"];
	["ContactSubscriptionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactSubscriptionEdge"][]
};
	["ContactSubscriptionEdge"]: {
		node:ModelTypes["ContactSubscription"]
};
	["ContactFormLocaleItemsBySubscriptionsUniqueWhere"]: GraphQLTypes["ContactFormLocaleItemsBySubscriptionsUniqueWhere"];
	["ContactTypeItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactTypeItemEdge"][]
};
	["ContactTypeItemEdge"]: {
		node:ModelTypes["ContactTypeItem"]
};
	["ContactFormLocalesByLocaleUniqueWhere"]: GraphQLTypes["ContactFormLocalesByLocaleUniqueWhere"];
	["ContactFormLocalesByItemsUniqueWhere"]: GraphQLTypes["ContactFormLocalesByItemsUniqueWhere"];
	["ContactFormLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactFormLocaleEdge"][]
};
	["ContactFormLocaleEdge"]: {
		node:ModelTypes["ContactFormLocale"]
};
	["NewsletterForm"]: {
		_meta?:ModelTypes["NewsletterFormMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["NewsletterFormLocale"][],
	localesByLocale?:ModelTypes["NewsletterFormLocale"],
	localesByItems?:ModelTypes["NewsletterFormLocale"],
	paginateLocales:ModelTypes["NewsletterFormLocaleConnection"]
};
	["NewsletterFormMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["NewsletterFormLocale"]: {
		_meta?:ModelTypes["NewsletterFormLocaleMeta"],
	id:ModelTypes["UUID"],
	newsletterTypeNote?:string,
	email?:string,
	emailNote?:string,
	submit?:string,
	root?:ModelTypes["NewsletterForm"],
	locale?:ModelTypes["Locale"],
	items:ModelTypes["NewsletterTypeItem"][],
	title?:string,
	successMessage?:string,
	genericErrorMessage?:string,
	newsletterTypeErrorMessage?:string,
	itemsBySubscriptions?:ModelTypes["NewsletterTypeItem"],
	paginateItems:ModelTypes["NewsletterTypeItemConnection"]
};
	["NewsletterFormLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	newsletterTypeNote?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	emailNote?:ModelTypes["FieldMeta"],
	submit?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	successMessage?:ModelTypes["FieldMeta"],
	genericErrorMessage?:ModelTypes["FieldMeta"],
	newsletterTypeErrorMessage?:ModelTypes["FieldMeta"]
};
	["NewsletterTypeItem"]: {
		_meta?:ModelTypes["NewsletterTypeItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	title?:string,
	list?:ModelTypes["NewsletterFormLocale"],
	subscriptions:ModelTypes["NewsletterSubscription"][],
	paginateSubscriptions:ModelTypes["NewsletterSubscriptionConnection"]
};
	["NewsletterTypeItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	subscriptions?:ModelTypes["FieldMeta"]
};
	["NewsletterSubscription"]: {
		_meta?:ModelTypes["NewsletterSubscriptionMeta"],
	id:ModelTypes["UUID"],
	createdAt:ModelTypes["DateTime"],
	email?:string,
	newsletterType?:ModelTypes["NewsletterTypeItem"]
};
	["NewsletterSubscriptionMeta"]: {
		id?:ModelTypes["FieldMeta"],
	createdAt?:ModelTypes["FieldMeta"],
	email?:ModelTypes["FieldMeta"],
	newsletterType?:ModelTypes["FieldMeta"]
};
	["NewsletterSubscriptionOrderBy"]: GraphQLTypes["NewsletterSubscriptionOrderBy"];
	["NewsletterTypeItemOrderBy"]: GraphQLTypes["NewsletterTypeItemOrderBy"];
	["NewsletterFormLocaleOrderBy"]: GraphQLTypes["NewsletterFormLocaleOrderBy"];
	["NewsletterFormOrderBy"]: GraphQLTypes["NewsletterFormOrderBy"];
	["NewsletterSubscriptionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterSubscriptionEdge"][]
};
	["NewsletterSubscriptionEdge"]: {
		node:ModelTypes["NewsletterSubscription"]
};
	["NewsletterFormLocaleItemsBySubscriptionsUniqueWhere"]: GraphQLTypes["NewsletterFormLocaleItemsBySubscriptionsUniqueWhere"];
	["NewsletterTypeItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterTypeItemEdge"][]
};
	["NewsletterTypeItemEdge"]: {
		node:ModelTypes["NewsletterTypeItem"]
};
	["NewsletterFormLocalesByLocaleUniqueWhere"]: GraphQLTypes["NewsletterFormLocalesByLocaleUniqueWhere"];
	["NewsletterFormLocalesByItemsUniqueWhere"]: GraphQLTypes["NewsletterFormLocalesByItemsUniqueWhere"];
	["NewsletterFormLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterFormLocaleEdge"][]
};
	["NewsletterFormLocaleEdge"]: {
		node:ModelTypes["NewsletterFormLocale"]
};
	["ContentReferenceOrderBy"]: GraphQLTypes["ContentReferenceOrderBy"];
	["ContentBlockOrderBy"]: GraphQLTypes["ContentBlockOrderBy"];
	["StrategySchemaOrderBy"]: GraphQLTypes["StrategySchemaOrderBy"];
	["ContentBlockReferencesByMediaUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByMediaUniqueWhere"];
	["ContentBlockReferencesByLinkUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLinkUniqueWhere"];
	["ContentBlockReferencesByDropDownListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByDropDownListUniqueWhere"];
	["ContentBlockReferencesByEventListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByEventListUniqueWhere"];
	["ContentBlockReferencesByBoxListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByBoxListUniqueWhere"];
	["ContentBlockReferencesByChartUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByChartUniqueWhere"];
	["ContentBlockReferencesByDefinitionListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByDefinitionListUniqueWhere"];
	["ContentBlockReferencesByLogoListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByLogoListUniqueWhere"];
	["ContentBlockReferencesByStrategySchemaUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByStrategySchemaUniqueWhere"];
	["ContentBlockReferencesByEmployeeListUniqueWhere"]: GraphQLTypes["ContentBlockReferencesByEmployeeListUniqueWhere"];
	["ContentReferenceConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentReferenceEdge"][]
};
	["ContentReferenceEdge"]: {
		node:ModelTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: GraphQLTypes["ContentBlocksByReferencesUniqueWhere"];
	["ContentBlockConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentBlockEdge"][]
};
	["ContentBlockEdge"]: {
		node:ModelTypes["ContentBlock"]
};
	["Branches"]: {
		_meta?:ModelTypes["BranchesMeta"],
	id:ModelTypes["UUID"],
	order:number,
	leadParagraph?:string,
	more?:string,
	link?:ModelTypes["Link"]
};
	["BranchesMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	leadParagraph?:ModelTypes["FieldMeta"],
	more?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["BranchesOrderBy"]: GraphQLTypes["BranchesOrderBy"];
	["BranchesConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BranchesEdge"][]
};
	["BranchesEdge"]: {
		node:ModelTypes["Branches"]
};
	["PageLocale"]: {
		_meta?:ModelTypes["PageLocaleMeta"],
	id:ModelTypes["UUID"],
	title?:string,
	link?:ModelTypes["Linkable"],
	root?:ModelTypes["Page"],
	locale?:ModelTypes["Locale"],
	content?:ModelTypes["Content"],
	seo?:ModelTypes["Seo"]
};
	["PageLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	title?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	content?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["Page"]: {
		_meta?:ModelTypes["PageMeta"],
	id:ModelTypes["UUID"],
	locales:ModelTypes["PageLocale"][],
	localesByLocale?:ModelTypes["PageLocale"],
	localesByLink?:ModelTypes["PageLocale"],
	localesByContent?:ModelTypes["PageLocale"],
	localesBySeo?:ModelTypes["PageLocale"],
	paginateLocales:ModelTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
		id?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["PageLocalesByLocaleUniqueWhere"]: GraphQLTypes["PageLocalesByLocaleUniqueWhere"];
	["PageLocalesByLinkUniqueWhere"]: GraphQLTypes["PageLocalesByLinkUniqueWhere"];
	["PageLocalesByContentUniqueWhere"]: GraphQLTypes["PageLocalesByContentUniqueWhere"];
	["PageLocalesBySeoUniqueWhere"]: GraphQLTypes["PageLocalesBySeoUniqueWhere"];
	["PageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageLocaleEdge"][]
};
	["PageLocaleEdge"]: {
		node:ModelTypes["PageLocale"]
};
	["Redirect"]: {
		_meta?:ModelTypes["RedirectMeta"],
	id:ModelTypes["UUID"],
	link?:ModelTypes["Linkable"],
	target?:ModelTypes["Linkable"]
};
	["RedirectMeta"]: {
		id?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"],
	target?:ModelTypes["FieldMeta"]
};
	["GraphicDesignerOrderBy"]: GraphQLTypes["GraphicDesignerOrderBy"];
	["Photographer"]: {
		_meta?:ModelTypes["PhotographerMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["PhotographerMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["PhotographerOrderBy"]: GraphQLTypes["PhotographerOrderBy"];
	["GraphicDesignerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GraphicDesignerEdge"][]
};
	["GraphicDesignerEdge"]: {
		node:ModelTypes["GraphicDesigner"]
};
	["PhotographerConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PhotographerEdge"][]
};
	["PhotographerEdge"]: {
		node:ModelTypes["Photographer"]
};
	["HeaderLocale"]: {
		_meta?:ModelTypes["HeaderLocaleMeta"],
	id:ModelTypes["UUID"],
	root?:ModelTypes["Header"],
	locale?:ModelTypes["Locale"],
	links:ModelTypes["HeaderLink"][],
	artworkBreadcrumbParentLink?:ModelTypes["Linkable"],
	paginateLinks:ModelTypes["HeaderLinkConnection"]
};
	["HeaderLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	links?:ModelTypes["FieldMeta"],
	artworkBreadcrumbParentLink?:ModelTypes["FieldMeta"]
};
	["Header"]: {
		_meta?:ModelTypes["HeaderMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["HeaderLocale"][],
	logo?:ModelTypes["Image"],
	localesByLocale?:ModelTypes["HeaderLocale"],
	localesByArtworkBreadcrumbParentLink?:ModelTypes["HeaderLocale"],
	paginateLocales:ModelTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"],
	logo?:ModelTypes["FieldMeta"]
};
	["HeaderLocaleOrderBy"]: GraphQLTypes["HeaderLocaleOrderBy"];
	["HeaderOrderBy"]: GraphQLTypes["HeaderOrderBy"];
	["HeaderLocalesByLocaleUniqueWhere"]: GraphQLTypes["HeaderLocalesByLocaleUniqueWhere"];
	["HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere"]: GraphQLTypes["HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere"];
	["HeaderLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderLocaleEdge"][]
};
	["HeaderLocaleEdge"]: {
		node:ModelTypes["HeaderLocale"]
};
	["HeaderLink"]: {
		_meta?:ModelTypes["HeaderLinkMeta"],
	id:ModelTypes["UUID"],
	order:number,
	link?:ModelTypes["Link"]
};
	["HeaderLinkMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	link?:ModelTypes["FieldMeta"]
};
	["HeaderLinkOrderBy"]: GraphQLTypes["HeaderLinkOrderBy"];
	["HeaderLinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderLinkEdge"][]
};
	["HeaderLinkEdge"]: {
		node:ModelTypes["HeaderLink"]
};
	["SeoDefaultLocale"]: {
		_meta?:ModelTypes["SeoDefaultLocaleMeta"],
	id:ModelTypes["UUID"],
	root?:ModelTypes["SeoDefault"],
	locale?:ModelTypes["Locale"],
	seo?:ModelTypes["Seo"]
};
	["SeoDefaultLocaleMeta"]: {
		id?:ModelTypes["FieldMeta"],
	root?:ModelTypes["FieldMeta"],
	locale?:ModelTypes["FieldMeta"],
	seo?:ModelTypes["FieldMeta"]
};
	["SeoDefault"]: {
		_meta?:ModelTypes["SeoDefaultMeta"],
	id:ModelTypes["UUID"],
	unique:ModelTypes["One"],
	locales:ModelTypes["SeoDefaultLocale"][],
	localesByLocale?:ModelTypes["SeoDefaultLocale"],
	localesBySeo?:ModelTypes["SeoDefaultLocale"],
	paginateLocales:ModelTypes["SeoDefaultLocaleConnection"]
};
	["SeoDefaultMeta"]: {
		id?:ModelTypes["FieldMeta"],
	unique?:ModelTypes["FieldMeta"],
	locales?:ModelTypes["FieldMeta"]
};
	["SeoDefaultLocaleOrderBy"]: GraphQLTypes["SeoDefaultLocaleOrderBy"];
	["SeoDefaultOrderBy"]: GraphQLTypes["SeoDefaultOrderBy"];
	["SeoDefaultLocalesByLocaleUniqueWhere"]: GraphQLTypes["SeoDefaultLocalesByLocaleUniqueWhere"];
	["SeoDefaultLocalesBySeoUniqueWhere"]: GraphQLTypes["SeoDefaultLocalesBySeoUniqueWhere"];
	["SeoDefaultLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoDefaultLocaleEdge"][]
};
	["SeoDefaultLocaleEdge"]: {
		node:ModelTypes["SeoDefaultLocale"]
};
	["LocaleContactPagesByRootUniqueWhere"]: GraphQLTypes["LocaleContactPagesByRootUniqueWhere"];
	["LocaleContactPagesByLinkUniqueWhere"]: GraphQLTypes["LocaleContactPagesByLinkUniqueWhere"];
	["LocaleContactPagesBySeoUniqueWhere"]: GraphQLTypes["LocaleContactPagesBySeoUniqueWhere"];
	["LocaleContactPagesByAddressLinkUniqueWhere"]: GraphQLTypes["LocaleContactPagesByAddressLinkUniqueWhere"];
	["LocaleFootersByRootUniqueWhere"]: GraphQLTypes["LocaleFootersByRootUniqueWhere"];
	["LocaleFootersByDeveloperLinkUniqueWhere"]: GraphQLTypes["LocaleFootersByDeveloperLinkUniqueWhere"];
	["LocaleHeadersByRootUniqueWhere"]: GraphQLTypes["LocaleHeadersByRootUniqueWhere"];
	["LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere"]: GraphQLTypes["LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere"];
	["LocaleHomePagesByRootUniqueWhere"]: GraphQLTypes["LocaleHomePagesByRootUniqueWhere"];
	["LocaleHomePagesByContentUniqueWhere"]: GraphQLTypes["LocaleHomePagesByContentUniqueWhere"];
	["LocaleHomePagesByLinkUniqueWhere"]: GraphQLTypes["LocaleHomePagesByLinkUniqueWhere"];
	["LocaleHomePagesBySeoUniqueWhere"]: GraphQLTypes["LocaleHomePagesBySeoUniqueWhere"];
	["LocalePagesByRootUniqueWhere"]: GraphQLTypes["LocalePagesByRootUniqueWhere"];
	["LocalePagesByLinkUniqueWhere"]: GraphQLTypes["LocalePagesByLinkUniqueWhere"];
	["LocalePagesByContentUniqueWhere"]: GraphQLTypes["LocalePagesByContentUniqueWhere"];
	["LocalePagesBySeoUniqueWhere"]: GraphQLTypes["LocalePagesBySeoUniqueWhere"];
	["LocaleSeoDefaultsByRootUniqueWhere"]: GraphQLTypes["LocaleSeoDefaultsByRootUniqueWhere"];
	["LocaleSeoDefaultsBySeoUniqueWhere"]: GraphQLTypes["LocaleSeoDefaultsBySeoUniqueWhere"];
	["LocaleEventsByRootUniqueWhere"]: GraphQLTypes["LocaleEventsByRootUniqueWhere"];
	["LocaleEventsByImageUniqueWhere"]: GraphQLTypes["LocaleEventsByImageUniqueWhere"];
	["LocaleEventsBySeoUniqueWhere"]: GraphQLTypes["LocaleEventsBySeoUniqueWhere"];
	["LocaleEventsByLinkUniqueWhere"]: GraphQLTypes["LocaleEventsByLinkUniqueWhere"];
	["LocaleEventsByContentUniqueWhere"]: GraphQLTypes["LocaleEventsByContentUniqueWhere"];
	["LocaleArtworksByRootUniqueWhere"]: GraphQLTypes["LocaleArtworksByRootUniqueWhere"];
	["LocaleArtworksByContentUniqueWhere"]: GraphQLTypes["LocaleArtworksByContentUniqueWhere"];
	["LocaleArtworksBySeoUniqueWhere"]: GraphQLTypes["LocaleArtworksBySeoUniqueWhere"];
	["LocaleArtworksByLinkUniqueWhere"]: GraphQLTypes["LocaleArtworksByLinkUniqueWhere"];
	["LocaleArtworkSelectionsByRootUniqueWhere"]: GraphQLTypes["LocaleArtworkSelectionsByRootUniqueWhere"];
	["LocaleArtworkSelectionsBySeoUniqueWhere"]: GraphQLTypes["LocaleArtworkSelectionsBySeoUniqueWhere"];
	["LocaleArtworkSelectionsByLinkUniqueWhere"]: GraphQLTypes["LocaleArtworkSelectionsByLinkUniqueWhere"];
	["LocaleNewsletterFormsByRootUniqueWhere"]: GraphQLTypes["LocaleNewsletterFormsByRootUniqueWhere"];
	["LocaleNewsletterFormsByItemsUniqueWhere"]: GraphQLTypes["LocaleNewsletterFormsByItemsUniqueWhere"];
	["LocaleEmployeesByRootUniqueWhere"]: GraphQLTypes["LocaleEmployeesByRootUniqueWhere"];
	["LocaleContactFormsByRootUniqueWhere"]: GraphQLTypes["LocaleContactFormsByRootUniqueWhere"];
	["LocaleContactFormsByItemsUniqueWhere"]: GraphQLTypes["LocaleContactFormsByItemsUniqueWhere"];
	["ContactPageLocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactPageLocaleEdge"][]
};
	["ContactPageLocaleEdge"]: {
		node:ModelTypes["ContactPageLocale"]
};
	["ContactPageLocalesByLocaleUniqueWhere"]: GraphQLTypes["ContactPageLocalesByLocaleUniqueWhere"];
	["ContactPageLocalesByLinkUniqueWhere"]: GraphQLTypes["ContactPageLocalesByLinkUniqueWhere"];
	["ContactPageLocalesBySeoUniqueWhere"]: GraphQLTypes["ContactPageLocalesBySeoUniqueWhere"];
	["ContactPageLocalesByAddressLinkUniqueWhere"]: GraphQLTypes["ContactPageLocalesByAddressLinkUniqueWhere"];
	["ContactPageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactPageEdge"][]
};
	["ContactPageEdge"]: {
		node:ModelTypes["ContactPage"]
};
	["_ValidationResult"]: {
		valid:boolean,
	errors:ModelTypes["_ValidationError"][]
};
	["_ValidationError"]: {
		path:ModelTypes["_PathFragment"][],
	message:ModelTypes["_ValidationMessage"]
};
	["_PathFragment"]:ModelTypes["_FieldPathFragment"] | ModelTypes["_IndexPathFragment"];
	["_FieldPathFragment"]: {
		field:string
};
	["_IndexPathFragment"]: {
		index:number,
	alias?:string
};
	["_ValidationMessage"]: {
		text:string
};
	["ContactPageCreateInput"]: GraphQLTypes["ContactPageCreateInput"];
	["ContactPageCreateLocalesEntityRelationInput"]: GraphQLTypes["ContactPageCreateLocalesEntityRelationInput"];
	["ContactPageLocaleWithoutRootCreateInput"]: GraphQLTypes["ContactPageLocaleWithoutRootCreateInput"];
	["ContactPageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ContactPageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutContactPagesCreateInput"]: GraphQLTypes["LocaleWithoutContactPagesCreateInput"];
	["LocaleCreateFootersEntityRelationInput"]: GraphQLTypes["LocaleCreateFootersEntityRelationInput"];
	["FooterLocaleWithoutLocaleCreateInput"]: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"];
	["FooterLocaleCreateRootEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"];
	["FooterWithoutLocalesCreateInput"]: GraphQLTypes["FooterWithoutLocalesCreateInput"];
	["FooterCreateLogoEntityRelationInput"]: GraphQLTypes["FooterCreateLogoEntityRelationInput"];
	["ImageCreateInput"]: GraphQLTypes["ImageCreateInput"];
	["FooterLocaleCreateGraphicDesignersEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"];
	["GraphicDesignerUniqueWhere"]: GraphQLTypes["GraphicDesignerUniqueWhere"];
	["GraphicDesignerCreateInput"]: GraphQLTypes["GraphicDesignerCreateInput"];
	["GraphicDesignerCreateLinkEntityRelationInput"]: GraphQLTypes["GraphicDesignerCreateLinkEntityRelationInput"];
	["LinkCreateInput"]: GraphQLTypes["LinkCreateInput"];
	["LinkCreateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"];
	["LinkableCreateInput"]: GraphQLTypes["LinkableCreateInput"];
	["LinkableCreateHomePageEntityRelationInput"]: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"];
	["HomePageLocaleWithoutLinkCreateInput"]: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"];
	["HomePageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"];
	["HomePageWithoutLocalesCreateInput"]: GraphQLTypes["HomePageWithoutLocalesCreateInput"];
	["HomePageCreateMediaEntityRelationInput"]: GraphQLTypes["HomePageCreateMediaEntityRelationInput"];
	["MediumListCreateInput"]: GraphQLTypes["MediumListCreateInput"];
	["MediumListCreateItemsEntityRelationInput"]: GraphQLTypes["MediumListCreateItemsEntityRelationInput"];
	["MediumItemWithoutListCreateInput"]: GraphQLTypes["MediumItemWithoutListCreateInput"];
	["MediumItemCreateMediumEntityRelationInput"]: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"];
	["MediumUniqueWhere"]: GraphQLTypes["MediumUniqueWhere"];
	["MediumCreateInput"]: GraphQLTypes["MediumCreateInput"];
	["MediumCreateImageEntityRelationInput"]: GraphQLTypes["MediumCreateImageEntityRelationInput"];
	["MediumCreateVideoEntityRelationInput"]: GraphQLTypes["MediumCreateVideoEntityRelationInput"];
	["VideoUniqueWhere"]: GraphQLTypes["VideoUniqueWhere"];
	["VideoCreateInput"]: GraphQLTypes["VideoCreateInput"];
	["VideoCreatePosterEntityRelationInput"]: GraphQLTypes["VideoCreatePosterEntityRelationInput"];
	["HomePageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHomePagesCreateInput"]: GraphQLTypes["LocaleWithoutHomePagesCreateInput"];
	["LocaleCreateContactPagesEntityRelationInput"]: GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"];
	["ContactPageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ContactPageLocaleWithoutLocaleCreateInput"];
	["ContactPageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ContactPageLocaleCreateRootEntityRelationInput"];
	["ContactPageWithoutLocalesCreateInput"]: GraphQLTypes["ContactPageWithoutLocalesCreateInput"];
	["ContactPageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["ContactPageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutContactPageCreateInput"]: GraphQLTypes["LinkableWithoutContactPageCreateInput"];
	["LinkableCreatePageEntityRelationInput"]: GraphQLTypes["LinkableCreatePageEntityRelationInput"];
	["PageLocaleWithoutLinkCreateInput"]: GraphQLTypes["PageLocaleWithoutLinkCreateInput"];
	["PageLocaleCreateRootEntityRelationInput"]: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"];
	["PageWithoutLocalesCreateInput"]: GraphQLTypes["PageWithoutLocalesCreateInput"];
	["PageLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutPagesCreateInput"]: GraphQLTypes["LocaleWithoutPagesCreateInput"];
	["LocaleCreateHeadersEntityRelationInput"]: GraphQLTypes["LocaleCreateHeadersEntityRelationInput"];
	["HeaderLocaleWithoutLocaleCreateInput"]: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"];
	["HeaderLocaleCreateRootEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"];
	["HeaderWithoutLocalesCreateInput"]: GraphQLTypes["HeaderWithoutLocalesCreateInput"];
	["HeaderCreateLogoEntityRelationInput"]: GraphQLTypes["HeaderCreateLogoEntityRelationInput"];
	["HeaderLocaleCreateLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"];
	["HeaderLinkUniqueWhere"]: GraphQLTypes["HeaderLinkUniqueWhere"];
	["HeaderLinkCreateInput"]: GraphQLTypes["HeaderLinkCreateInput"];
	["HeaderLinkCreateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"];
	["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"];
	["LocaleCreateHomePagesEntityRelationInput"]: GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"];
	["HomePageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"];
	["HomePageLocaleCreateContentEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"];
	["ContentCreateInput"]: GraphQLTypes["ContentCreateInput"];
	["ContentCreateBlocksEntityRelationInput"]: GraphQLTypes["ContentCreateBlocksEntityRelationInput"];
	["ContentBlockWithoutContentCreateInput"]: GraphQLTypes["ContentBlockWithoutContentCreateInput"];
	["ContentBlockCreateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"];
	["ContentReferenceWithoutBlockCreateInput"]: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"];
	["ContentReferenceCreateMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"];
	["ContentReferenceCreateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"];
	["ContentReferenceCreateDropDownListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateDropDownListEntityRelationInput"];
	["DropDownListCreateInput"]: GraphQLTypes["DropDownListCreateInput"];
	["DropDownListCreateItemsEntityRelationInput"]: GraphQLTypes["DropDownListCreateItemsEntityRelationInput"];
	["DropDownItemWithoutListCreateInput"]: GraphQLTypes["DropDownItemWithoutListCreateInput"];
	["DropDownItemCreateLinkEntityRelationInput"]: GraphQLTypes["DropDownItemCreateLinkEntityRelationInput"];
	["DropDownListCreateEmployeesEntityRelationInput"]: GraphQLTypes["DropDownListCreateEmployeesEntityRelationInput"];
	["EmployeeListCreateInput"]: GraphQLTypes["EmployeeListCreateInput"];
	["EmployeeListCreateItemsEntityRelationInput"]: GraphQLTypes["EmployeeListCreateItemsEntityRelationInput"];
	["EmployeeItemWithoutListCreateInput"]: GraphQLTypes["EmployeeItemWithoutListCreateInput"];
	["EmployeeItemCreateEmployeeEntityRelationInput"]: GraphQLTypes["EmployeeItemCreateEmployeeEntityRelationInput"];
	["EmployeeCreateInput"]: GraphQLTypes["EmployeeCreateInput"];
	["EmployeeCreateImageEntityRelationInput"]: GraphQLTypes["EmployeeCreateImageEntityRelationInput"];
	["EmployeeCreateLocalesEntityRelationInput"]: GraphQLTypes["EmployeeCreateLocalesEntityRelationInput"];
	["EmployeeLocaleWithoutRootCreateInput"]: GraphQLTypes["EmployeeLocaleWithoutRootCreateInput"];
	["EmployeeLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["EmployeeLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutEmployeesCreateInput"]: GraphQLTypes["LocaleWithoutEmployeesCreateInput"];
	["LocaleCreatePagesEntityRelationInput"]: GraphQLTypes["LocaleCreatePagesEntityRelationInput"];
	["PageLocaleWithoutLocaleCreateInput"]: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"];
	["PageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutPageCreateInput"]: GraphQLTypes["LinkableWithoutPageCreateInput"];
	["LinkableCreateContactPageEntityRelationInput"]: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"];
	["ContactPageLocaleWithoutLinkCreateInput"]: GraphQLTypes["ContactPageLocaleWithoutLinkCreateInput"];
	["ContactPageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["ContactPageLocaleCreateSeoEntityRelationInput"];
	["SeoCreateInput"]: GraphQLTypes["SeoCreateInput"];
	["SeoCreateOgImageEntityRelationInput"]: GraphQLTypes["SeoCreateOgImageEntityRelationInput"];
	["ContactPageLocaleCreateAddressLinkEntityRelationInput"]: GraphQLTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"];
	["LinkableCreateEventEntityRelationInput"]: GraphQLTypes["LinkableCreateEventEntityRelationInput"];
	["EventLocaleWithoutLinkCreateInput"]: GraphQLTypes["EventLocaleWithoutLinkCreateInput"];
	["EventLocaleCreateRootEntityRelationInput"]: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"];
	["EventWithoutLocalesCreateInput"]: GraphQLTypes["EventWithoutLocalesCreateInput"];
	["EventLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutEventsCreateInput"]: GraphQLTypes["LocaleWithoutEventsCreateInput"];
	["LocaleCreateSeoDefaultsEntityRelationInput"]: GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"];
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"];
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleCreateRootEntityRelationInput"];
	["SeoDefaultWithoutLocalesCreateInput"]: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"];
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"];
	["LocaleCreateArtworksEntityRelationInput"]: GraphQLTypes["LocaleCreateArtworksEntityRelationInput"];
	["ArtworkLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ArtworkLocaleWithoutLocaleCreateInput"];
	["ArtworkLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ArtworkLocaleCreateRootEntityRelationInput"];
	["ArtworkWithoutLocalesCreateInput"]: GraphQLTypes["ArtworkWithoutLocalesCreateInput"];
	["ArtworkCreateImageEntityRelationInput"]: GraphQLTypes["ArtworkCreateImageEntityRelationInput"];
	["ArtworkCreateGalleryEntityRelationInput"]: GraphQLTypes["ArtworkCreateGalleryEntityRelationInput"];
	["GalleryCreateInput"]: GraphQLTypes["GalleryCreateInput"];
	["GalleryCreateItemsEntityRelationInput"]: GraphQLTypes["GalleryCreateItemsEntityRelationInput"];
	["GalleryItemWithoutListCreateInput"]: GraphQLTypes["GalleryItemWithoutListCreateInput"];
	["GalleryItemCreateImageEntityRelationInput"]: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"];
	["ArtworkLocaleCreateContentEntityRelationInput"]: GraphQLTypes["ArtworkLocaleCreateContentEntityRelationInput"];
	["ArtworkLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["ArtworkLocaleCreateSeoEntityRelationInput"];
	["ArtworkLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["ArtworkLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutArtworkCreateInput"]: GraphQLTypes["LinkableWithoutArtworkCreateInput"];
	["LinkableCreateArtworkSelectionEntityRelationInput"]: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"];
	["ArtworkSelectionLocaleWithoutLinkCreateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"];
	["ArtworkSelectionLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"];
	["ArtworkSelectionWithoutLocalesCreateInput"]: GraphQLTypes["ArtworkSelectionWithoutLocalesCreateInput"];
	["ArtworkSelectionCreateArtworksEntityRelationInput"]: GraphQLTypes["ArtworkSelectionCreateArtworksEntityRelationInput"];
	["ArtworkSelectionListCreateInput"]: GraphQLTypes["ArtworkSelectionListCreateInput"];
	["ArtworkSelectionListCreateItemsEntityRelationInput"]: GraphQLTypes["ArtworkSelectionListCreateItemsEntityRelationInput"];
	["ArtworkSelectionItemWithoutListCreateInput"]: GraphQLTypes["ArtworkSelectionItemWithoutListCreateInput"];
	["ArtworkSelectionItemCreateArtworkEntityRelationInput"]: GraphQLTypes["ArtworkSelectionItemCreateArtworkEntityRelationInput"];
	["ArtworkCreateInput"]: GraphQLTypes["ArtworkCreateInput"];
	["ArtworkCreateLocalesEntityRelationInput"]: GraphQLTypes["ArtworkCreateLocalesEntityRelationInput"];
	["ArtworkLocaleWithoutRootCreateInput"]: GraphQLTypes["ArtworkLocaleWithoutRootCreateInput"];
	["ArtworkLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ArtworkLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutArtworksCreateInput"]: GraphQLTypes["LocaleWithoutArtworksCreateInput"];
	["LocaleCreateEventsEntityRelationInput"]: GraphQLTypes["LocaleCreateEventsEntityRelationInput"];
	["EventLocaleWithoutLocaleCreateInput"]: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"];
	["EventLocaleCreateImageEntityRelationInput"]: GraphQLTypes["EventLocaleCreateImageEntityRelationInput"];
	["EventLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"];
	["EventLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutEventCreateInput"]: GraphQLTypes["LinkableWithoutEventCreateInput"];
	["LinkableCreateArtworkEntityRelationInput"]: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"];
	["ArtworkLocaleWithoutLinkCreateInput"]: GraphQLTypes["ArtworkLocaleWithoutLinkCreateInput"];
	["LinkableCreateRedirectEntityRelationInput"]: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"];
	["RedirectWithoutLinkCreateInput"]: GraphQLTypes["RedirectWithoutLinkCreateInput"];
	["RedirectCreateTargetEntityRelationInput"]: GraphQLTypes["RedirectCreateTargetEntityRelationInput"];
	["EventLocaleCreateContentEntityRelationInput"]: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"];
	["LocaleCreateArtworkSelectionsEntityRelationInput"]: GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"];
	["ArtworkSelectionLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"];
	["ArtworkSelectionLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"];
	["ArtworkSelectionLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutArtworkSelectionCreateInput"]: GraphQLTypes["LinkableWithoutArtworkSelectionCreateInput"];
	["LocaleCreateNewsletterFormsEntityRelationInput"]: GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"];
	["NewsletterFormLocaleWithoutLocaleCreateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutLocaleCreateInput"];
	["NewsletterFormLocaleCreateRootEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleCreateRootEntityRelationInput"];
	["NewsletterFormWithoutLocalesCreateInput"]: GraphQLTypes["NewsletterFormWithoutLocalesCreateInput"];
	["NewsletterFormLocaleCreateItemsEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"];
	["NewsletterTypeItemWithoutListCreateInput"]: GraphQLTypes["NewsletterTypeItemWithoutListCreateInput"];
	["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"]: GraphQLTypes["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"];
	["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"]: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"];
	["LocaleCreateEmployeesEntityRelationInput"]: GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"];
	["EmployeeLocaleWithoutLocaleCreateInput"]: GraphQLTypes["EmployeeLocaleWithoutLocaleCreateInput"];
	["EmployeeLocaleCreateRootEntityRelationInput"]: GraphQLTypes["EmployeeLocaleCreateRootEntityRelationInput"];
	["EmployeeWithoutLocalesCreateInput"]: GraphQLTypes["EmployeeWithoutLocalesCreateInput"];
	["LocaleCreateContactFormsEntityRelationInput"]: GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"];
	["ContactFormLocaleWithoutLocaleCreateInput"]: GraphQLTypes["ContactFormLocaleWithoutLocaleCreateInput"];
	["ContactFormLocaleCreateRootEntityRelationInput"]: GraphQLTypes["ContactFormLocaleCreateRootEntityRelationInput"];
	["ContactFormWithoutLocalesCreateInput"]: GraphQLTypes["ContactFormWithoutLocalesCreateInput"];
	["ContactFormLocaleCreateItemsEntityRelationInput"]: GraphQLTypes["ContactFormLocaleCreateItemsEntityRelationInput"];
	["ContactTypeItemWithoutListCreateInput"]: GraphQLTypes["ContactTypeItemWithoutListCreateInput"];
	["ContactTypeItemCreateSubscriptionsEntityRelationInput"]: GraphQLTypes["ContactTypeItemCreateSubscriptionsEntityRelationInput"];
	["ContactSubscriptionWithoutContactTypeCreateInput"]: GraphQLTypes["ContactSubscriptionWithoutContactTypeCreateInput"];
	["ContactSubscriptionCreateFileEntityRelationInput"]: GraphQLTypes["ContactSubscriptionCreateFileEntityRelationInput"];
	["FileCreateInput"]: GraphQLTypes["FileCreateInput"];
	["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutArtworkSelectionsCreateInput"]: GraphQLTypes["LocaleWithoutArtworkSelectionsCreateInput"];
	["PageLocaleCreateContentEntityRelationInput"]: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"];
	["PageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"];
	["ContentReferenceCreateArtworkSelectionEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateArtworkSelectionEntityRelationInput"];
	["ArtworkSelectionCreateInput"]: GraphQLTypes["ArtworkSelectionCreateInput"];
	["ArtworkSelectionCreateLocalesEntityRelationInput"]: GraphQLTypes["ArtworkSelectionCreateLocalesEntityRelationInput"];
	["ArtworkSelectionLocaleWithoutRootCreateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutRootCreateInput"];
	["ContentReferenceCreateEventListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateEventListEntityRelationInput"];
	["EventListCreateInput"]: GraphQLTypes["EventListCreateInput"];
	["EventListCreateItemsEntityRelationInput"]: GraphQLTypes["EventListCreateItemsEntityRelationInput"];
	["EventItemWithoutListCreateInput"]: GraphQLTypes["EventItemWithoutListCreateInput"];
	["EventItemCreateEventEntityRelationInput"]: GraphQLTypes["EventItemCreateEventEntityRelationInput"];
	["EventCreateInput"]: GraphQLTypes["EventCreateInput"];
	["EventCreateLocalesEntityRelationInput"]: GraphQLTypes["EventCreateLocalesEntityRelationInput"];
	["EventLocaleWithoutRootCreateInput"]: GraphQLTypes["EventLocaleWithoutRootCreateInput"];
	["ContentReferenceCreateBoxListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBoxListEntityRelationInput"];
	["BoxListCreateInput"]: GraphQLTypes["BoxListCreateInput"];
	["BoxListCreateItemsEntityRelationInput"]: GraphQLTypes["BoxListCreateItemsEntityRelationInput"];
	["BoxItemWithoutListCreateInput"]: GraphQLTypes["BoxItemWithoutListCreateInput"];
	["ContentReferenceCreateChartEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateChartEntityRelationInput"];
	["ChartCreateInput"]: GraphQLTypes["ChartCreateInput"];
	["ChartCreateItemsEntityRelationInput"]: GraphQLTypes["ChartCreateItemsEntityRelationInput"];
	["ChartDataWithoutListCreateInput"]: GraphQLTypes["ChartDataWithoutListCreateInput"];
	["ChartDataCreateImageEntityRelationInput"]: GraphQLTypes["ChartDataCreateImageEntityRelationInput"];
	["ContentReferenceCreateDefinitionListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateDefinitionListEntityRelationInput"];
	["DefinitionListCreateInput"]: GraphQLTypes["DefinitionListCreateInput"];
	["DefinitionListCreateItemsEntityRelationInput"]: GraphQLTypes["DefinitionListCreateItemsEntityRelationInput"];
	["DefinitionItemWithoutListCreateInput"]: GraphQLTypes["DefinitionItemWithoutListCreateInput"];
	["ContentReferenceCreateLogoListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateLogoListEntityRelationInput"];
	["LogoListCreateInput"]: GraphQLTypes["LogoListCreateInput"];
	["LogoListCreateItemsEntityRelationInput"]: GraphQLTypes["LogoListCreateItemsEntityRelationInput"];
	["LogoItemWithoutListCreateInput"]: GraphQLTypes["LogoItemWithoutListCreateInput"];
	["LogoItemCreateImageEntityRelationInput"]: GraphQLTypes["LogoItemCreateImageEntityRelationInput"];
	["ContentReferenceCreateStrategySchemaEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateStrategySchemaEntityRelationInput"];
	["StrategySchemaCreateInput"]: GraphQLTypes["StrategySchemaCreateInput"];
	["StrategySchemaCreateItemsFirstEntityRelationInput"]: GraphQLTypes["StrategySchemaCreateItemsFirstEntityRelationInput"];
	["StrategySchemaGroupCreateInput"]: GraphQLTypes["StrategySchemaGroupCreateInput"];
	["StrategySchemaGroupCreateItemsEntityRelationInput"]: GraphQLTypes["StrategySchemaGroupCreateItemsEntityRelationInput"];
	["StrategySchemaGroupItemWithoutSchemaCreateInput"]: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"];
	["StrategySchemaCreateLogoEntityRelationInput"]: GraphQLTypes["StrategySchemaCreateLogoEntityRelationInput"];
	["StrategySchemaCreateItemsSecondEntityRelationInput"]: GraphQLTypes["StrategySchemaCreateItemsSecondEntityRelationInput"];
	["ContentReferenceCreateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"];
	["ContentReferenceCreateEmployeeListEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateEmployeeListEntityRelationInput"];
	["ContentReferenceCreateImageSecondEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateImageSecondEntityRelationInput"];
	["ContentReferenceCreateContactFormEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateContactFormEntityRelationInput"];
	["ContactFormCreateInput"]: GraphQLTypes["ContactFormCreateInput"];
	["ContactFormCreateLocalesEntityRelationInput"]: GraphQLTypes["ContactFormCreateLocalesEntityRelationInput"];
	["ContactFormLocaleWithoutRootCreateInput"]: GraphQLTypes["ContactFormLocaleWithoutRootCreateInput"];
	["ContactFormLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["ContactFormLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutContactFormsCreateInput"]: GraphQLTypes["LocaleWithoutContactFormsCreateInput"];
	["ContentReferenceCreateNewsletterFormEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateNewsletterFormEntityRelationInput"];
	["NewsletterFormCreateInput"]: GraphQLTypes["NewsletterFormCreateInput"];
	["NewsletterFormCreateLocalesEntityRelationInput"]: GraphQLTypes["NewsletterFormCreateLocalesEntityRelationInput"];
	["NewsletterFormLocaleWithoutRootCreateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutRootCreateInput"];
	["NewsletterFormLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutNewsletterFormsCreateInput"]: GraphQLTypes["LocaleWithoutNewsletterFormsCreateInput"];
	["HomePageLocaleCreateLinkEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"];
	["LinkableWithoutHomePageCreateInput"]: GraphQLTypes["LinkableWithoutHomePageCreateInput"];
	["HomePageLocaleCreateSeoEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"];
	["HomePageLocaleCreateBranchesEntityRelationInput"]: GraphQLTypes["HomePageLocaleCreateBranchesEntityRelationInput"];
	["BranchesUniqueWhere"]: GraphQLTypes["BranchesUniqueWhere"];
	["BranchesCreateInput"]: GraphQLTypes["BranchesCreateInput"];
	["BranchesCreateLinkEntityRelationInput"]: GraphQLTypes["BranchesCreateLinkEntityRelationInput"];
	["FooterLocaleCreateDeveloperLinkEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"];
	["FooterLocaleCreatePhotographersEntityRelationInput"]: GraphQLTypes["FooterLocaleCreatePhotographersEntityRelationInput"];
	["PhotographerUniqueWhere"]: GraphQLTypes["PhotographerUniqueWhere"];
	["PhotographerCreateInput"]: GraphQLTypes["PhotographerCreateInput"];
	["PhotographerCreateLinkEntityRelationInput"]: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"];
	["ContactPageUpdateInput"]: GraphQLTypes["ContactPageUpdateInput"];
	["ContactPageUpdateLocalesEntityRelationInput"]: GraphQLTypes["ContactPageUpdateLocalesEntityRelationInput"];
	["ContactPageUpdateLocalesRelationInput"]: GraphQLTypes["ContactPageUpdateLocalesRelationInput"];
	["ContactPageLocaleWithoutRootUpdateInput"]: GraphQLTypes["ContactPageLocaleWithoutRootUpdateInput"];
	["ContactPageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutContactPagesUpdateInput"]: GraphQLTypes["LocaleWithoutContactPagesUpdateInput"];
	["LocaleUpdateFootersEntityRelationInput"]: GraphQLTypes["LocaleUpdateFootersEntityRelationInput"];
	["LocaleUpdateFootersRelationInput"]: GraphQLTypes["LocaleUpdateFootersRelationInput"];
	["FooterLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"];
	["FooterLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"];
	["FooterWithoutLocalesUpdateInput"]: GraphQLTypes["FooterWithoutLocalesUpdateInput"];
	["FooterUpdateLogoEntityRelationInput"]: GraphQLTypes["FooterUpdateLogoEntityRelationInput"];
	["ImageUpdateInput"]: GraphQLTypes["ImageUpdateInput"];
	["FooterUpsertLogoRelationInput"]: GraphQLTypes["FooterUpsertLogoRelationInput"];
	["FooterLocaleUpsertRootRelationInput"]: GraphQLTypes["FooterLocaleUpsertRootRelationInput"];
	["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"];
	["FooterLocaleUpdateGraphicDesignersRelationInput"]: GraphQLTypes["FooterLocaleUpdateGraphicDesignersRelationInput"];
	["GraphicDesignerUpdateInput"]: GraphQLTypes["GraphicDesignerUpdateInput"];
	["GraphicDesignerUpdateLinkEntityRelationInput"]: GraphQLTypes["GraphicDesignerUpdateLinkEntityRelationInput"];
	["LinkUpdateInput"]: GraphQLTypes["LinkUpdateInput"];
	["LinkUpdateInternalLinkEntityRelationInput"]: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"];
	["LinkableUpdateInput"]: GraphQLTypes["LinkableUpdateInput"];
	["LinkableUpdateHomePageEntityRelationInput"]: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"];
	["HomePageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["HomePageLocaleWithoutLinkUpdateInput"];
	["HomePageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"];
	["HomePageWithoutLocalesUpdateInput"]: GraphQLTypes["HomePageWithoutLocalesUpdateInput"];
	["HomePageUpdateMediaEntityRelationInput"]: GraphQLTypes["HomePageUpdateMediaEntityRelationInput"];
	["MediumListUpdateInput"]: GraphQLTypes["MediumListUpdateInput"];
	["MediumListUpdateItemsEntityRelationInput"]: GraphQLTypes["MediumListUpdateItemsEntityRelationInput"];
	["MediumListUpdateItemsRelationInput"]: GraphQLTypes["MediumListUpdateItemsRelationInput"];
	["MediumItemWithoutListUpdateInput"]: GraphQLTypes["MediumItemWithoutListUpdateInput"];
	["MediumItemUpdateMediumEntityRelationInput"]: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"];
	["MediumUpdateInput"]: GraphQLTypes["MediumUpdateInput"];
	["MediumUpdateImageEntityRelationInput"]: GraphQLTypes["MediumUpdateImageEntityRelationInput"];
	["MediumUpsertImageRelationInput"]: GraphQLTypes["MediumUpsertImageRelationInput"];
	["MediumUpdateVideoEntityRelationInput"]: GraphQLTypes["MediumUpdateVideoEntityRelationInput"];
	["VideoUpdateInput"]: GraphQLTypes["VideoUpdateInput"];
	["VideoUpdatePosterEntityRelationInput"]: GraphQLTypes["VideoUpdatePosterEntityRelationInput"];
	["VideoUpsertPosterRelationInput"]: GraphQLTypes["VideoUpsertPosterRelationInput"];
	["MediumUpsertVideoRelationInput"]: GraphQLTypes["MediumUpsertVideoRelationInput"];
	["MediumItemUpsertMediumRelationInput"]: GraphQLTypes["MediumItemUpsertMediumRelationInput"];
	["MediumListUpsertItemsRelationInput"]: GraphQLTypes["MediumListUpsertItemsRelationInput"];
	["HomePageUpsertMediaRelationInput"]: GraphQLTypes["HomePageUpsertMediaRelationInput"];
	["HomePageLocaleUpsertRootRelationInput"]: GraphQLTypes["HomePageLocaleUpsertRootRelationInput"];
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHomePagesUpdateInput"]: GraphQLTypes["LocaleWithoutHomePagesUpdateInput"];
	["LocaleUpdateContactPagesEntityRelationInput"]: GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"];
	["LocaleUpdateContactPagesRelationInput"]: GraphQLTypes["LocaleUpdateContactPagesRelationInput"];
	["ContactPageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ContactPageLocaleWithoutLocaleUpdateInput"];
	["ContactPageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ContactPageLocaleUpdateRootEntityRelationInput"];
	["ContactPageWithoutLocalesUpdateInput"]: GraphQLTypes["ContactPageWithoutLocalesUpdateInput"];
	["ContactPageLocaleUpsertRootRelationInput"]: GraphQLTypes["ContactPageLocaleUpsertRootRelationInput"];
	["ContactPageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["ContactPageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutContactPageUpdateInput"]: GraphQLTypes["LinkableWithoutContactPageUpdateInput"];
	["LinkableUpdatePageEntityRelationInput"]: GraphQLTypes["LinkableUpdatePageEntityRelationInput"];
	["PageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"];
	["PageLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"];
	["PageWithoutLocalesUpdateInput"]: GraphQLTypes["PageWithoutLocalesUpdateInput"];
	["PageLocaleUpsertRootRelationInput"]: GraphQLTypes["PageLocaleUpsertRootRelationInput"];
	["PageLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutPagesUpdateInput"]: GraphQLTypes["LocaleWithoutPagesUpdateInput"];
	["LocaleUpdateHeadersEntityRelationInput"]: GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"];
	["LocaleUpdateHeadersRelationInput"]: GraphQLTypes["LocaleUpdateHeadersRelationInput"];
	["HeaderLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"];
	["HeaderLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"];
	["HeaderWithoutLocalesUpdateInput"]: GraphQLTypes["HeaderWithoutLocalesUpdateInput"];
	["HeaderUpdateLogoEntityRelationInput"]: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"];
	["HeaderUpsertLogoRelationInput"]: GraphQLTypes["HeaderUpsertLogoRelationInput"];
	["HeaderLocaleUpsertRootRelationInput"]: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"];
	["HeaderLocaleUpdateLinksEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"];
	["HeaderLocaleUpdateLinksRelationInput"]: GraphQLTypes["HeaderLocaleUpdateLinksRelationInput"];
	["HeaderLinkUpdateInput"]: GraphQLTypes["HeaderLinkUpdateInput"];
	["HeaderLinkUpdateLinkEntityRelationInput"]: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"];
	["HeaderLinkUpsertLinkRelationInput"]: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"];
	["HeaderLocaleUpsertLinksRelationInput"]: GraphQLTypes["HeaderLocaleUpsertLinksRelationInput"];
	["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"];
	["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"]: GraphQLTypes["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"];
	["LocaleUpsertHeadersRelationInput"]: GraphQLTypes["LocaleUpsertHeadersRelationInput"];
	["LocaleUpdateHomePagesEntityRelationInput"]: GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"];
	["LocaleUpdateHomePagesRelationInput"]: GraphQLTypes["LocaleUpdateHomePagesRelationInput"];
	["HomePageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["HomePageLocaleWithoutLocaleUpdateInput"];
	["HomePageLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"];
	["ContentUpdateInput"]: GraphQLTypes["ContentUpdateInput"];
	["ContentUpdateBlocksEntityRelationInput"]: GraphQLTypes["ContentUpdateBlocksEntityRelationInput"];
	["ContentUpdateBlocksRelationInput"]: GraphQLTypes["ContentUpdateBlocksRelationInput"];
	["ContentBlockWithoutContentUpdateInput"]: GraphQLTypes["ContentBlockWithoutContentUpdateInput"];
	["ContentBlockUpdateReferencesEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"];
	["ContentBlockUpdateReferencesRelationInput"]: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"];
	["ContentReferenceWithoutBlockUpdateInput"]: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"];
	["ContentReferenceUpdateMediaEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"];
	["ContentReferenceUpsertMediaRelationInput"]: GraphQLTypes["ContentReferenceUpsertMediaRelationInput"];
	["ContentReferenceUpdateLinkEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"];
	["ContentReferenceUpsertLinkRelationInput"]: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"];
	["ContentReferenceUpdateDropDownListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateDropDownListEntityRelationInput"];
	["DropDownListUpdateInput"]: GraphQLTypes["DropDownListUpdateInput"];
	["DropDownListUpdateItemsEntityRelationInput"]: GraphQLTypes["DropDownListUpdateItemsEntityRelationInput"];
	["DropDownListUpdateItemsRelationInput"]: GraphQLTypes["DropDownListUpdateItemsRelationInput"];
	["DropDownItemWithoutListUpdateInput"]: GraphQLTypes["DropDownItemWithoutListUpdateInput"];
	["DropDownItemUpdateLinkEntityRelationInput"]: GraphQLTypes["DropDownItemUpdateLinkEntityRelationInput"];
	["DropDownItemUpsertLinkRelationInput"]: GraphQLTypes["DropDownItemUpsertLinkRelationInput"];
	["DropDownListUpsertItemsRelationInput"]: GraphQLTypes["DropDownListUpsertItemsRelationInput"];
	["DropDownListUpdateEmployeesEntityRelationInput"]: GraphQLTypes["DropDownListUpdateEmployeesEntityRelationInput"];
	["EmployeeListUpdateInput"]: GraphQLTypes["EmployeeListUpdateInput"];
	["EmployeeListUpdateItemsEntityRelationInput"]: GraphQLTypes["EmployeeListUpdateItemsEntityRelationInput"];
	["EmployeeListUpdateItemsRelationInput"]: GraphQLTypes["EmployeeListUpdateItemsRelationInput"];
	["EmployeeItemWithoutListUpdateInput"]: GraphQLTypes["EmployeeItemWithoutListUpdateInput"];
	["EmployeeItemUpdateEmployeeEntityRelationInput"]: GraphQLTypes["EmployeeItemUpdateEmployeeEntityRelationInput"];
	["EmployeeUpdateInput"]: GraphQLTypes["EmployeeUpdateInput"];
	["EmployeeUpdateImageEntityRelationInput"]: GraphQLTypes["EmployeeUpdateImageEntityRelationInput"];
	["EmployeeUpsertImageRelationInput"]: GraphQLTypes["EmployeeUpsertImageRelationInput"];
	["EmployeeUpdateLocalesEntityRelationInput"]: GraphQLTypes["EmployeeUpdateLocalesEntityRelationInput"];
	["EmployeeUpdateLocalesRelationInput"]: GraphQLTypes["EmployeeUpdateLocalesRelationInput"];
	["EmployeeLocaleWithoutRootUpdateInput"]: GraphQLTypes["EmployeeLocaleWithoutRootUpdateInput"];
	["EmployeeLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["EmployeeLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutEmployeesUpdateInput"]: GraphQLTypes["LocaleWithoutEmployeesUpdateInput"];
	["LocaleUpdatePagesEntityRelationInput"]: GraphQLTypes["LocaleUpdatePagesEntityRelationInput"];
	["LocaleUpdatePagesRelationInput"]: GraphQLTypes["LocaleUpdatePagesRelationInput"];
	["PageLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"];
	["PageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutPageUpdateInput"]: GraphQLTypes["LinkableWithoutPageUpdateInput"];
	["LinkableUpdateContactPageEntityRelationInput"]: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"];
	["ContactPageLocaleWithoutLinkUpdateInput"]: GraphQLTypes["ContactPageLocaleWithoutLinkUpdateInput"];
	["ContactPageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["ContactPageLocaleUpdateSeoEntityRelationInput"];
	["SeoUpdateInput"]: GraphQLTypes["SeoUpdateInput"];
	["SeoUpdateOgImageEntityRelationInput"]: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"];
	["SeoUpsertOgImageRelationInput"]: GraphQLTypes["SeoUpsertOgImageRelationInput"];
	["ContactPageLocaleUpsertSeoRelationInput"]: GraphQLTypes["ContactPageLocaleUpsertSeoRelationInput"];
	["ContactPageLocaleUpdateAddressLinkEntityRelationInput"]: GraphQLTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"];
	["ContactPageLocaleUpsertAddressLinkRelationInput"]: GraphQLTypes["ContactPageLocaleUpsertAddressLinkRelationInput"];
	["LinkableUpsertContactPageRelationInput"]: GraphQLTypes["LinkableUpsertContactPageRelationInput"];
	["LinkableUpdateEventEntityRelationInput"]: GraphQLTypes["LinkableUpdateEventEntityRelationInput"];
	["EventLocaleWithoutLinkUpdateInput"]: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"];
	["EventLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"];
	["EventWithoutLocalesUpdateInput"]: GraphQLTypes["EventWithoutLocalesUpdateInput"];
	["EventLocaleUpsertRootRelationInput"]: GraphQLTypes["EventLocaleUpsertRootRelationInput"];
	["EventLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutEventsUpdateInput"]: GraphQLTypes["LocaleWithoutEventsUpdateInput"];
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"];
	["LocaleUpdateSeoDefaultsRelationInput"]: GraphQLTypes["LocaleUpdateSeoDefaultsRelationInput"];
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"];
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"];
	["SeoDefaultWithoutLocalesUpdateInput"]: GraphQLTypes["SeoDefaultWithoutLocalesUpdateInput"];
	["SeoDefaultLocaleUpsertRootRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpsertRootRelationInput"];
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"];
	["SeoDefaultLocaleUpsertSeoRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpsertSeoRelationInput"];
	["LocaleUpsertSeoDefaultsRelationInput"]: GraphQLTypes["LocaleUpsertSeoDefaultsRelationInput"];
	["LocaleUpdateArtworksEntityRelationInput"]: GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"];
	["LocaleUpdateArtworksRelationInput"]: GraphQLTypes["LocaleUpdateArtworksRelationInput"];
	["ArtworkLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ArtworkLocaleWithoutLocaleUpdateInput"];
	["ArtworkLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ArtworkLocaleUpdateRootEntityRelationInput"];
	["ArtworkWithoutLocalesUpdateInput"]: GraphQLTypes["ArtworkWithoutLocalesUpdateInput"];
	["ArtworkUpdateImageEntityRelationInput"]: GraphQLTypes["ArtworkUpdateImageEntityRelationInput"];
	["ArtworkUpsertImageRelationInput"]: GraphQLTypes["ArtworkUpsertImageRelationInput"];
	["ArtworkUpdateGalleryEntityRelationInput"]: GraphQLTypes["ArtworkUpdateGalleryEntityRelationInput"];
	["GalleryUpdateInput"]: GraphQLTypes["GalleryUpdateInput"];
	["GalleryUpdateItemsEntityRelationInput"]: GraphQLTypes["GalleryUpdateItemsEntityRelationInput"];
	["GalleryUpdateItemsRelationInput"]: GraphQLTypes["GalleryUpdateItemsRelationInput"];
	["GalleryItemWithoutListUpdateInput"]: GraphQLTypes["GalleryItemWithoutListUpdateInput"];
	["GalleryItemUpdateImageEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"];
	["GalleryItemUpsertImageRelationInput"]: GraphQLTypes["GalleryItemUpsertImageRelationInput"];
	["GalleryUpsertItemsRelationInput"]: GraphQLTypes["GalleryUpsertItemsRelationInput"];
	["ArtworkUpsertGalleryRelationInput"]: GraphQLTypes["ArtworkUpsertGalleryRelationInput"];
	["ArtworkLocaleUpsertRootRelationInput"]: GraphQLTypes["ArtworkLocaleUpsertRootRelationInput"];
	["ArtworkLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["ArtworkLocaleUpdateContentEntityRelationInput"];
	["ArtworkLocaleUpsertContentRelationInput"]: GraphQLTypes["ArtworkLocaleUpsertContentRelationInput"];
	["ArtworkLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["ArtworkLocaleUpdateSeoEntityRelationInput"];
	["ArtworkLocaleUpsertSeoRelationInput"]: GraphQLTypes["ArtworkLocaleUpsertSeoRelationInput"];
	["ArtworkLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["ArtworkLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutArtworkUpdateInput"]: GraphQLTypes["LinkableWithoutArtworkUpdateInput"];
	["LinkableUpdateArtworkSelectionEntityRelationInput"]: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"];
	["ArtworkSelectionLocaleWithoutLinkUpdateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkUpdateInput"];
	["ArtworkSelectionLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"];
	["ArtworkSelectionWithoutLocalesUpdateInput"]: GraphQLTypes["ArtworkSelectionWithoutLocalesUpdateInput"];
	["ArtworkSelectionUpdateArtworksEntityRelationInput"]: GraphQLTypes["ArtworkSelectionUpdateArtworksEntityRelationInput"];
	["ArtworkSelectionListUpdateInput"]: GraphQLTypes["ArtworkSelectionListUpdateInput"];
	["ArtworkSelectionListUpdateItemsEntityRelationInput"]: GraphQLTypes["ArtworkSelectionListUpdateItemsEntityRelationInput"];
	["ArtworkSelectionListUpdateItemsRelationInput"]: GraphQLTypes["ArtworkSelectionListUpdateItemsRelationInput"];
	["ArtworkSelectionItemWithoutListUpdateInput"]: GraphQLTypes["ArtworkSelectionItemWithoutListUpdateInput"];
	["ArtworkSelectionItemUpdateArtworkEntityRelationInput"]: GraphQLTypes["ArtworkSelectionItemUpdateArtworkEntityRelationInput"];
	["ArtworkUpdateInput"]: GraphQLTypes["ArtworkUpdateInput"];
	["ArtworkUpdateLocalesEntityRelationInput"]: GraphQLTypes["ArtworkUpdateLocalesEntityRelationInput"];
	["ArtworkUpdateLocalesRelationInput"]: GraphQLTypes["ArtworkUpdateLocalesRelationInput"];
	["ArtworkLocaleWithoutRootUpdateInput"]: GraphQLTypes["ArtworkLocaleWithoutRootUpdateInput"];
	["ArtworkLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutArtworksUpdateInput"]: GraphQLTypes["LocaleWithoutArtworksUpdateInput"];
	["LocaleUpdateEventsEntityRelationInput"]: GraphQLTypes["LocaleUpdateEventsEntityRelationInput"];
	["LocaleUpdateEventsRelationInput"]: GraphQLTypes["LocaleUpdateEventsRelationInput"];
	["EventLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"];
	["EventLocaleUpdateImageEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateImageEntityRelationInput"];
	["EventLocaleUpsertImageRelationInput"]: GraphQLTypes["EventLocaleUpsertImageRelationInput"];
	["EventLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"];
	["EventLocaleUpsertSeoRelationInput"]: GraphQLTypes["EventLocaleUpsertSeoRelationInput"];
	["EventLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutEventUpdateInput"]: GraphQLTypes["LinkableWithoutEventUpdateInput"];
	["LinkableUpdateArtworkEntityRelationInput"]: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"];
	["ArtworkLocaleWithoutLinkUpdateInput"]: GraphQLTypes["ArtworkLocaleWithoutLinkUpdateInput"];
	["LinkableUpsertArtworkRelationInput"]: GraphQLTypes["LinkableUpsertArtworkRelationInput"];
	["LinkableUpdateRedirectEntityRelationInput"]: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"];
	["RedirectWithoutLinkUpdateInput"]: GraphQLTypes["RedirectWithoutLinkUpdateInput"];
	["RedirectUpdateTargetEntityRelationInput"]: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"];
	["RedirectUpsertTargetRelationInput"]: GraphQLTypes["RedirectUpsertTargetRelationInput"];
	["LinkableUpsertRedirectRelationInput"]: GraphQLTypes["LinkableUpsertRedirectRelationInput"];
	["EventLocaleUpsertLinkRelationInput"]: GraphQLTypes["EventLocaleUpsertLinkRelationInput"];
	["EventLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"];
	["EventLocaleUpsertContentRelationInput"]: GraphQLTypes["EventLocaleUpsertContentRelationInput"];
	["LocaleUpsertEventsRelationInput"]: GraphQLTypes["LocaleUpsertEventsRelationInput"];
	["LocaleUpdateArtworkSelectionsEntityRelationInput"]: GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"];
	["LocaleUpdateArtworkSelectionsRelationInput"]: GraphQLTypes["LocaleUpdateArtworkSelectionsRelationInput"];
	["ArtworkSelectionLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleUpdateInput"];
	["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"];
	["ArtworkSelectionLocaleUpsertSeoRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpsertSeoRelationInput"];
	["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutArtworkSelectionUpdateInput"]: GraphQLTypes["LinkableWithoutArtworkSelectionUpdateInput"];
	["ArtworkSelectionLocaleUpsertLinkRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpsertLinkRelationInput"];
	["LocaleUpsertArtworkSelectionsRelationInput"]: GraphQLTypes["LocaleUpsertArtworkSelectionsRelationInput"];
	["LocaleUpdateNewsletterFormsEntityRelationInput"]: GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"];
	["LocaleUpdateNewsletterFormsRelationInput"]: GraphQLTypes["LocaleUpdateNewsletterFormsRelationInput"];
	["NewsletterFormLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutLocaleUpdateInput"];
	["NewsletterFormLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"];
	["NewsletterFormWithoutLocalesUpdateInput"]: GraphQLTypes["NewsletterFormWithoutLocalesUpdateInput"];
	["NewsletterFormLocaleUpsertRootRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpsertRootRelationInput"];
	["NewsletterFormLocaleUpdateItemsEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"];
	["NewsletterFormLocaleUpdateItemsRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpdateItemsRelationInput"];
	["NewsletterTypeItemWithoutListUpdateInput"]: GraphQLTypes["NewsletterTypeItemWithoutListUpdateInput"];
	["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"]: GraphQLTypes["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"];
	["NewsletterTypeItemUpdateSubscriptionsRelationInput"]: GraphQLTypes["NewsletterTypeItemUpdateSubscriptionsRelationInput"];
	["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"]: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"];
	["NewsletterTypeItemUpsertSubscriptionsRelationInput"]: GraphQLTypes["NewsletterTypeItemUpsertSubscriptionsRelationInput"];
	["NewsletterFormLocaleUpsertItemsRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpsertItemsRelationInput"];
	["LocaleUpsertNewsletterFormsRelationInput"]: GraphQLTypes["LocaleUpsertNewsletterFormsRelationInput"];
	["LocaleUpdateEmployeesEntityRelationInput"]: GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"];
	["LocaleUpdateEmployeesRelationInput"]: GraphQLTypes["LocaleUpdateEmployeesRelationInput"];
	["EmployeeLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["EmployeeLocaleWithoutLocaleUpdateInput"];
	["EmployeeLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["EmployeeLocaleUpdateRootEntityRelationInput"];
	["EmployeeWithoutLocalesUpdateInput"]: GraphQLTypes["EmployeeWithoutLocalesUpdateInput"];
	["EmployeeLocaleUpsertRootRelationInput"]: GraphQLTypes["EmployeeLocaleUpsertRootRelationInput"];
	["LocaleUpsertEmployeesRelationInput"]: GraphQLTypes["LocaleUpsertEmployeesRelationInput"];
	["LocaleUpdateContactFormsEntityRelationInput"]: GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"];
	["LocaleUpdateContactFormsRelationInput"]: GraphQLTypes["LocaleUpdateContactFormsRelationInput"];
	["ContactFormLocaleWithoutLocaleUpdateInput"]: GraphQLTypes["ContactFormLocaleWithoutLocaleUpdateInput"];
	["ContactFormLocaleUpdateRootEntityRelationInput"]: GraphQLTypes["ContactFormLocaleUpdateRootEntityRelationInput"];
	["ContactFormWithoutLocalesUpdateInput"]: GraphQLTypes["ContactFormWithoutLocalesUpdateInput"];
	["ContactFormLocaleUpsertRootRelationInput"]: GraphQLTypes["ContactFormLocaleUpsertRootRelationInput"];
	["ContactFormLocaleUpdateItemsEntityRelationInput"]: GraphQLTypes["ContactFormLocaleUpdateItemsEntityRelationInput"];
	["ContactFormLocaleUpdateItemsRelationInput"]: GraphQLTypes["ContactFormLocaleUpdateItemsRelationInput"];
	["ContactTypeItemWithoutListUpdateInput"]: GraphQLTypes["ContactTypeItemWithoutListUpdateInput"];
	["ContactTypeItemUpdateSubscriptionsEntityRelationInput"]: GraphQLTypes["ContactTypeItemUpdateSubscriptionsEntityRelationInput"];
	["ContactTypeItemUpdateSubscriptionsRelationInput"]: GraphQLTypes["ContactTypeItemUpdateSubscriptionsRelationInput"];
	["ContactSubscriptionWithoutContactTypeUpdateInput"]: GraphQLTypes["ContactSubscriptionWithoutContactTypeUpdateInput"];
	["ContactSubscriptionUpdateFileEntityRelationInput"]: GraphQLTypes["ContactSubscriptionUpdateFileEntityRelationInput"];
	["FileUpdateInput"]: GraphQLTypes["FileUpdateInput"];
	["ContactSubscriptionUpsertFileRelationInput"]: GraphQLTypes["ContactSubscriptionUpsertFileRelationInput"];
	["ContactTypeItemUpsertSubscriptionsRelationInput"]: GraphQLTypes["ContactTypeItemUpsertSubscriptionsRelationInput"];
	["ContactFormLocaleUpsertItemsRelationInput"]: GraphQLTypes["ContactFormLocaleUpsertItemsRelationInput"];
	["LocaleUpsertContactFormsRelationInput"]: GraphQLTypes["LocaleUpsertContactFormsRelationInput"];
	["ArtworkLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ArtworkLocaleUpsertLocaleRelationInput"];
	["ArtworkUpsertLocalesRelationInput"]: GraphQLTypes["ArtworkUpsertLocalesRelationInput"];
	["ArtworkSelectionItemUpsertArtworkRelationInput"]: GraphQLTypes["ArtworkSelectionItemUpsertArtworkRelationInput"];
	["ArtworkSelectionListUpsertItemsRelationInput"]: GraphQLTypes["ArtworkSelectionListUpsertItemsRelationInput"];
	["ArtworkSelectionUpsertArtworksRelationInput"]: GraphQLTypes["ArtworkSelectionUpsertArtworksRelationInput"];
	["ArtworkSelectionLocaleUpsertRootRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpsertRootRelationInput"];
	["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutArtworkSelectionsUpdateInput"]: GraphQLTypes["LocaleWithoutArtworkSelectionsUpdateInput"];
	["ArtworkSelectionLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ArtworkSelectionLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertArtworkSelectionRelationInput"]: GraphQLTypes["LinkableUpsertArtworkSelectionRelationInput"];
	["ArtworkLocaleUpsertLinkRelationInput"]: GraphQLTypes["ArtworkLocaleUpsertLinkRelationInput"];
	["LocaleUpsertArtworksRelationInput"]: GraphQLTypes["LocaleUpsertArtworksRelationInput"];
	["EventLocaleUpsertLocaleRelationInput"]: GraphQLTypes["EventLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertEventRelationInput"]: GraphQLTypes["LinkableUpsertEventRelationInput"];
	["PageLocaleUpsertLinkRelationInput"]: GraphQLTypes["PageLocaleUpsertLinkRelationInput"];
	["PageLocaleUpdateContentEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"];
	["PageLocaleUpsertContentRelationInput"]: GraphQLTypes["PageLocaleUpsertContentRelationInput"];
	["PageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"];
	["PageLocaleUpsertSeoRelationInput"]: GraphQLTypes["PageLocaleUpsertSeoRelationInput"];
	["LocaleUpsertPagesRelationInput"]: GraphQLTypes["LocaleUpsertPagesRelationInput"];
	["EmployeeLocaleUpsertLocaleRelationInput"]: GraphQLTypes["EmployeeLocaleUpsertLocaleRelationInput"];
	["EmployeeUpsertLocalesRelationInput"]: GraphQLTypes["EmployeeUpsertLocalesRelationInput"];
	["EmployeeItemUpsertEmployeeRelationInput"]: GraphQLTypes["EmployeeItemUpsertEmployeeRelationInput"];
	["EmployeeListUpsertItemsRelationInput"]: GraphQLTypes["EmployeeListUpsertItemsRelationInput"];
	["DropDownListUpsertEmployeesRelationInput"]: GraphQLTypes["DropDownListUpsertEmployeesRelationInput"];
	["ContentReferenceUpsertDropDownListRelationInput"]: GraphQLTypes["ContentReferenceUpsertDropDownListRelationInput"];
	["ContentReferenceUpdateArtworkSelectionEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateArtworkSelectionEntityRelationInput"];
	["ArtworkSelectionUpdateInput"]: GraphQLTypes["ArtworkSelectionUpdateInput"];
	["ArtworkSelectionUpdateLocalesEntityRelationInput"]: GraphQLTypes["ArtworkSelectionUpdateLocalesEntityRelationInput"];
	["ArtworkSelectionUpdateLocalesRelationInput"]: GraphQLTypes["ArtworkSelectionUpdateLocalesRelationInput"];
	["ArtworkSelectionLocaleWithoutRootUpdateInput"]: GraphQLTypes["ArtworkSelectionLocaleWithoutRootUpdateInput"];
	["ArtworkSelectionUpsertLocalesRelationInput"]: GraphQLTypes["ArtworkSelectionUpsertLocalesRelationInput"];
	["ContentReferenceUpsertArtworkSelectionRelationInput"]: GraphQLTypes["ContentReferenceUpsertArtworkSelectionRelationInput"];
	["ContentReferenceUpdateEventListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateEventListEntityRelationInput"];
	["EventListUpdateInput"]: GraphQLTypes["EventListUpdateInput"];
	["EventListUpdateItemsEntityRelationInput"]: GraphQLTypes["EventListUpdateItemsEntityRelationInput"];
	["EventListUpdateItemsRelationInput"]: GraphQLTypes["EventListUpdateItemsRelationInput"];
	["EventItemWithoutListUpdateInput"]: GraphQLTypes["EventItemWithoutListUpdateInput"];
	["EventItemUpdateEventEntityRelationInput"]: GraphQLTypes["EventItemUpdateEventEntityRelationInput"];
	["EventUpdateInput"]: GraphQLTypes["EventUpdateInput"];
	["EventUpdateLocalesEntityRelationInput"]: GraphQLTypes["EventUpdateLocalesEntityRelationInput"];
	["EventUpdateLocalesRelationInput"]: GraphQLTypes["EventUpdateLocalesRelationInput"];
	["EventLocaleWithoutRootUpdateInput"]: GraphQLTypes["EventLocaleWithoutRootUpdateInput"];
	["EventUpsertLocalesRelationInput"]: GraphQLTypes["EventUpsertLocalesRelationInput"];
	["EventItemUpsertEventRelationInput"]: GraphQLTypes["EventItemUpsertEventRelationInput"];
	["EventListUpsertItemsRelationInput"]: GraphQLTypes["EventListUpsertItemsRelationInput"];
	["ContentReferenceUpsertEventListRelationInput"]: GraphQLTypes["ContentReferenceUpsertEventListRelationInput"];
	["ContentReferenceUpdateBoxListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBoxListEntityRelationInput"];
	["BoxListUpdateInput"]: GraphQLTypes["BoxListUpdateInput"];
	["BoxListUpdateItemsEntityRelationInput"]: GraphQLTypes["BoxListUpdateItemsEntityRelationInput"];
	["BoxListUpdateItemsRelationInput"]: GraphQLTypes["BoxListUpdateItemsRelationInput"];
	["BoxItemWithoutListUpdateInput"]: GraphQLTypes["BoxItemWithoutListUpdateInput"];
	["BoxListUpsertItemsRelationInput"]: GraphQLTypes["BoxListUpsertItemsRelationInput"];
	["ContentReferenceUpsertBoxListRelationInput"]: GraphQLTypes["ContentReferenceUpsertBoxListRelationInput"];
	["ContentReferenceUpdateChartEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateChartEntityRelationInput"];
	["ChartUpdateInput"]: GraphQLTypes["ChartUpdateInput"];
	["ChartUpdateItemsEntityRelationInput"]: GraphQLTypes["ChartUpdateItemsEntityRelationInput"];
	["ChartUpdateItemsRelationInput"]: GraphQLTypes["ChartUpdateItemsRelationInput"];
	["ChartDataWithoutListUpdateInput"]: GraphQLTypes["ChartDataWithoutListUpdateInput"];
	["ChartDataUpdateImageEntityRelationInput"]: GraphQLTypes["ChartDataUpdateImageEntityRelationInput"];
	["ChartDataUpsertImageRelationInput"]: GraphQLTypes["ChartDataUpsertImageRelationInput"];
	["ChartUpsertItemsRelationInput"]: GraphQLTypes["ChartUpsertItemsRelationInput"];
	["ContentReferenceUpsertChartRelationInput"]: GraphQLTypes["ContentReferenceUpsertChartRelationInput"];
	["ContentReferenceUpdateDefinitionListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateDefinitionListEntityRelationInput"];
	["DefinitionListUpdateInput"]: GraphQLTypes["DefinitionListUpdateInput"];
	["DefinitionListUpdateItemsEntityRelationInput"]: GraphQLTypes["DefinitionListUpdateItemsEntityRelationInput"];
	["DefinitionListUpdateItemsRelationInput"]: GraphQLTypes["DefinitionListUpdateItemsRelationInput"];
	["DefinitionItemWithoutListUpdateInput"]: GraphQLTypes["DefinitionItemWithoutListUpdateInput"];
	["DefinitionListUpsertItemsRelationInput"]: GraphQLTypes["DefinitionListUpsertItemsRelationInput"];
	["ContentReferenceUpsertDefinitionListRelationInput"]: GraphQLTypes["ContentReferenceUpsertDefinitionListRelationInput"];
	["ContentReferenceUpdateLogoListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateLogoListEntityRelationInput"];
	["LogoListUpdateInput"]: GraphQLTypes["LogoListUpdateInput"];
	["LogoListUpdateItemsEntityRelationInput"]: GraphQLTypes["LogoListUpdateItemsEntityRelationInput"];
	["LogoListUpdateItemsRelationInput"]: GraphQLTypes["LogoListUpdateItemsRelationInput"];
	["LogoItemWithoutListUpdateInput"]: GraphQLTypes["LogoItemWithoutListUpdateInput"];
	["LogoItemUpdateImageEntityRelationInput"]: GraphQLTypes["LogoItemUpdateImageEntityRelationInput"];
	["LogoItemUpsertImageRelationInput"]: GraphQLTypes["LogoItemUpsertImageRelationInput"];
	["LogoListUpsertItemsRelationInput"]: GraphQLTypes["LogoListUpsertItemsRelationInput"];
	["ContentReferenceUpsertLogoListRelationInput"]: GraphQLTypes["ContentReferenceUpsertLogoListRelationInput"];
	["ContentReferenceUpdateStrategySchemaEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateStrategySchemaEntityRelationInput"];
	["StrategySchemaUpdateInput"]: GraphQLTypes["StrategySchemaUpdateInput"];
	["StrategySchemaUpdateItemsFirstEntityRelationInput"]: GraphQLTypes["StrategySchemaUpdateItemsFirstEntityRelationInput"];
	["StrategySchemaGroupUpdateInput"]: GraphQLTypes["StrategySchemaGroupUpdateInput"];
	["StrategySchemaGroupUpdateItemsEntityRelationInput"]: GraphQLTypes["StrategySchemaGroupUpdateItemsEntityRelationInput"];
	["StrategySchemaGroupUpdateItemsRelationInput"]: GraphQLTypes["StrategySchemaGroupUpdateItemsRelationInput"];
	["StrategySchemaGroupItemWithoutSchemaUpdateInput"]: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaUpdateInput"];
	["StrategySchemaGroupUpsertItemsRelationInput"]: GraphQLTypes["StrategySchemaGroupUpsertItemsRelationInput"];
	["StrategySchemaUpsertItemsFirstRelationInput"]: GraphQLTypes["StrategySchemaUpsertItemsFirstRelationInput"];
	["StrategySchemaUpdateLogoEntityRelationInput"]: GraphQLTypes["StrategySchemaUpdateLogoEntityRelationInput"];
	["StrategySchemaUpsertLogoRelationInput"]: GraphQLTypes["StrategySchemaUpsertLogoRelationInput"];
	["StrategySchemaUpdateItemsSecondEntityRelationInput"]: GraphQLTypes["StrategySchemaUpdateItemsSecondEntityRelationInput"];
	["StrategySchemaUpsertItemsSecondRelationInput"]: GraphQLTypes["StrategySchemaUpsertItemsSecondRelationInput"];
	["ContentReferenceUpsertStrategySchemaRelationInput"]: GraphQLTypes["ContentReferenceUpsertStrategySchemaRelationInput"];
	["ContentReferenceUpdateImageEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"];
	["ContentReferenceUpsertImageRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageRelationInput"];
	["ContentReferenceUpdateEmployeeListEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateEmployeeListEntityRelationInput"];
	["ContentReferenceUpsertEmployeeListRelationInput"]: GraphQLTypes["ContentReferenceUpsertEmployeeListRelationInput"];
	["ContentReferenceUpdateImageSecondEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateImageSecondEntityRelationInput"];
	["ContentReferenceUpsertImageSecondRelationInput"]: GraphQLTypes["ContentReferenceUpsertImageSecondRelationInput"];
	["ContentReferenceUpdateContactFormEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateContactFormEntityRelationInput"];
	["ContactFormUpdateInput"]: GraphQLTypes["ContactFormUpdateInput"];
	["ContactFormUpdateLocalesEntityRelationInput"]: GraphQLTypes["ContactFormUpdateLocalesEntityRelationInput"];
	["ContactFormUpdateLocalesRelationInput"]: GraphQLTypes["ContactFormUpdateLocalesRelationInput"];
	["ContactFormLocaleWithoutRootUpdateInput"]: GraphQLTypes["ContactFormLocaleWithoutRootUpdateInput"];
	["ContactFormLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutContactFormsUpdateInput"]: GraphQLTypes["LocaleWithoutContactFormsUpdateInput"];
	["ContactFormLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ContactFormLocaleUpsertLocaleRelationInput"];
	["ContactFormUpsertLocalesRelationInput"]: GraphQLTypes["ContactFormUpsertLocalesRelationInput"];
	["ContentReferenceUpsertContactFormRelationInput"]: GraphQLTypes["ContentReferenceUpsertContactFormRelationInput"];
	["ContentReferenceUpdateNewsletterFormEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateNewsletterFormEntityRelationInput"];
	["NewsletterFormUpdateInput"]: GraphQLTypes["NewsletterFormUpdateInput"];
	["NewsletterFormUpdateLocalesEntityRelationInput"]: GraphQLTypes["NewsletterFormUpdateLocalesEntityRelationInput"];
	["NewsletterFormUpdateLocalesRelationInput"]: GraphQLTypes["NewsletterFormUpdateLocalesRelationInput"];
	["NewsletterFormLocaleWithoutRootUpdateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutRootUpdateInput"];
	["NewsletterFormLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutNewsletterFormsUpdateInput"]: GraphQLTypes["LocaleWithoutNewsletterFormsUpdateInput"];
	["NewsletterFormLocaleUpsertLocaleRelationInput"]: GraphQLTypes["NewsletterFormLocaleUpsertLocaleRelationInput"];
	["NewsletterFormUpsertLocalesRelationInput"]: GraphQLTypes["NewsletterFormUpsertLocalesRelationInput"];
	["ContentReferenceUpsertNewsletterFormRelationInput"]: GraphQLTypes["ContentReferenceUpsertNewsletterFormRelationInput"];
	["ContentBlockUpsertReferencesRelationInput"]: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"];
	["ContentUpsertBlocksRelationInput"]: GraphQLTypes["ContentUpsertBlocksRelationInput"];
	["HomePageLocaleUpsertContentRelationInput"]: GraphQLTypes["HomePageLocaleUpsertContentRelationInput"];
	["HomePageLocaleUpdateLinkEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"];
	["LinkableWithoutHomePageUpdateInput"]: GraphQLTypes["LinkableWithoutHomePageUpdateInput"];
	["HomePageLocaleUpsertLinkRelationInput"]: GraphQLTypes["HomePageLocaleUpsertLinkRelationInput"];
	["HomePageLocaleUpdateSeoEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"];
	["HomePageLocaleUpsertSeoRelationInput"]: GraphQLTypes["HomePageLocaleUpsertSeoRelationInput"];
	["HomePageLocaleUpdateBranchesEntityRelationInput"]: GraphQLTypes["HomePageLocaleUpdateBranchesEntityRelationInput"];
	["HomePageLocaleUpdateBranchesRelationInput"]: GraphQLTypes["HomePageLocaleUpdateBranchesRelationInput"];
	["BranchesUpdateInput"]: GraphQLTypes["BranchesUpdateInput"];
	["BranchesUpdateLinkEntityRelationInput"]: GraphQLTypes["BranchesUpdateLinkEntityRelationInput"];
	["BranchesUpsertLinkRelationInput"]: GraphQLTypes["BranchesUpsertLinkRelationInput"];
	["HomePageLocaleUpsertBranchesRelationInput"]: GraphQLTypes["HomePageLocaleUpsertBranchesRelationInput"];
	["LocaleUpsertHomePagesRelationInput"]: GraphQLTypes["LocaleUpsertHomePagesRelationInput"];
	["PageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertPageRelationInput"]: GraphQLTypes["LinkableUpsertPageRelationInput"];
	["ContactPageLocaleUpsertLinkRelationInput"]: GraphQLTypes["ContactPageLocaleUpsertLinkRelationInput"];
	["LocaleUpsertContactPagesRelationInput"]: GraphQLTypes["LocaleUpsertContactPagesRelationInput"];
	["HomePageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["HomePageLocaleUpsertLocaleRelationInput"];
	["LinkableUpsertHomePageRelationInput"]: GraphQLTypes["LinkableUpsertHomePageRelationInput"];
	["LinkUpsertInternalLinkRelationInput"]: GraphQLTypes["LinkUpsertInternalLinkRelationInput"];
	["GraphicDesignerUpsertLinkRelationInput"]: GraphQLTypes["GraphicDesignerUpsertLinkRelationInput"];
	["FooterLocaleUpsertGraphicDesignersRelationInput"]: GraphQLTypes["FooterLocaleUpsertGraphicDesignersRelationInput"];
	["FooterLocaleUpdateDeveloperLinkEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"];
	["FooterLocaleUpsertDeveloperLinkRelationInput"]: GraphQLTypes["FooterLocaleUpsertDeveloperLinkRelationInput"];
	["FooterLocaleUpdatePhotographersEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdatePhotographersEntityRelationInput"];
	["FooterLocaleUpdatePhotographersRelationInput"]: GraphQLTypes["FooterLocaleUpdatePhotographersRelationInput"];
	["PhotographerUpdateInput"]: GraphQLTypes["PhotographerUpdateInput"];
	["PhotographerUpdateLinkEntityRelationInput"]: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"];
	["PhotographerUpsertLinkRelationInput"]: GraphQLTypes["PhotographerUpsertLinkRelationInput"];
	["FooterLocaleUpsertPhotographersRelationInput"]: GraphQLTypes["FooterLocaleUpsertPhotographersRelationInput"];
	["LocaleUpsertFootersRelationInput"]: GraphQLTypes["LocaleUpsertFootersRelationInput"];
	["ContactPageLocaleUpsertLocaleRelationInput"]: GraphQLTypes["ContactPageLocaleUpsertLocaleRelationInput"];
	["ContactPageUpsertLocalesRelationInput"]: GraphQLTypes["ContactPageUpsertLocalesRelationInput"];
	["ContactPageLocaleCreateInput"]: GraphQLTypes["ContactPageLocaleCreateInput"];
	["ContactPageLocaleUpdateInput"]: GraphQLTypes["ContactPageLocaleUpdateInput"];
	["ContentConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContentEdge"][]
};
	["ContentEdge"]: {
		node:ModelTypes["Content"]
};
	["ContentBlockCreateInput"]: GraphQLTypes["ContentBlockCreateInput"];
	["ContentBlockCreateContentEntityRelationInput"]: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"];
	["ContentWithoutBlocksCreateInput"]: GraphQLTypes["ContentWithoutBlocksCreateInput"];
	["ContentBlockUpdateInput"]: GraphQLTypes["ContentBlockUpdateInput"];
	["ContentBlockUpdateContentEntityRelationInput"]: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"];
	["ContentWithoutBlocksUpdateInput"]: GraphQLTypes["ContentWithoutBlocksUpdateInput"];
	["ContentBlockUpsertContentRelationInput"]: GraphQLTypes["ContentBlockUpsertContentRelationInput"];
	["ContentReferenceCreateInput"]: GraphQLTypes["ContentReferenceCreateInput"];
	["ContentReferenceCreateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesCreateInput"]: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"];
	["ContentReferenceUpdateInput"]: GraphQLTypes["ContentReferenceUpdateInput"];
	["ContentReferenceUpdateBlockEntityRelationInput"]: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"];
	["ContentBlockWithoutReferencesUpdateInput"]: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"];
	["ContentReferenceUpsertBlockRelationInput"]: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"];
	["FooterConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FooterEdge"][]
};
	["FooterEdge"]: {
		node:ModelTypes["Footer"]
};
	["FooterCreateInput"]: GraphQLTypes["FooterCreateInput"];
	["FooterCreateLocalesEntityRelationInput"]: GraphQLTypes["FooterCreateLocalesEntityRelationInput"];
	["FooterLocaleWithoutRootCreateInput"]: GraphQLTypes["FooterLocaleWithoutRootCreateInput"];
	["FooterLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutFootersCreateInput"]: GraphQLTypes["LocaleWithoutFootersCreateInput"];
	["FooterUpdateInput"]: GraphQLTypes["FooterUpdateInput"];
	["FooterUpdateLocalesEntityRelationInput"]: GraphQLTypes["FooterUpdateLocalesEntityRelationInput"];
	["FooterUpdateLocalesRelationInput"]: GraphQLTypes["FooterUpdateLocalesRelationInput"];
	["FooterLocaleWithoutRootUpdateInput"]: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"];
	["FooterLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutFootersUpdateInput"]: GraphQLTypes["LocaleWithoutFootersUpdateInput"];
	["FooterLocaleUpsertLocaleRelationInput"]: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"];
	["FooterUpsertLocalesRelationInput"]: GraphQLTypes["FooterUpsertLocalesRelationInput"];
	["FooterLocaleCreateInput"]: GraphQLTypes["FooterLocaleCreateInput"];
	["FooterLocaleUpdateInput"]: GraphQLTypes["FooterLocaleUpdateInput"];
	["HeaderConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HeaderEdge"][]
};
	["HeaderEdge"]: {
		node:ModelTypes["Header"]
};
	["HeaderCreateInput"]: GraphQLTypes["HeaderCreateInput"];
	["HeaderCreateLocalesEntityRelationInput"]: GraphQLTypes["HeaderCreateLocalesEntityRelationInput"];
	["HeaderLocaleWithoutRootCreateInput"]: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"];
	["HeaderLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersCreateInput"]: GraphQLTypes["LocaleWithoutHeadersCreateInput"];
	["HeaderUpdateInput"]: GraphQLTypes["HeaderUpdateInput"];
	["HeaderUpdateLocalesEntityRelationInput"]: GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"];
	["HeaderUpdateLocalesRelationInput"]: GraphQLTypes["HeaderUpdateLocalesRelationInput"];
	["HeaderLocaleWithoutRootUpdateInput"]: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"];
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutHeadersUpdateInput"]: GraphQLTypes["LocaleWithoutHeadersUpdateInput"];
	["HeaderLocaleUpsertLocaleRelationInput"]: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"];
	["HeaderUpsertLocalesRelationInput"]: GraphQLTypes["HeaderUpsertLocalesRelationInput"];
	["HeaderLocaleCreateInput"]: GraphQLTypes["HeaderLocaleCreateInput"];
	["HeaderLocaleUpdateInput"]: GraphQLTypes["HeaderLocaleUpdateInput"];
	["HomePageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["HomePageEdge"][]
};
	["HomePageEdge"]: {
		node:ModelTypes["HomePage"]
};
	["HomePageCreateInput"]: GraphQLTypes["HomePageCreateInput"];
	["HomePageCreateLocalesEntityRelationInput"]: GraphQLTypes["HomePageCreateLocalesEntityRelationInput"];
	["HomePageLocaleWithoutRootCreateInput"]: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"];
	["HomePageUpdateInput"]: GraphQLTypes["HomePageUpdateInput"];
	["HomePageUpdateLocalesEntityRelationInput"]: GraphQLTypes["HomePageUpdateLocalesEntityRelationInput"];
	["HomePageUpdateLocalesRelationInput"]: GraphQLTypes["HomePageUpdateLocalesRelationInput"];
	["HomePageLocaleWithoutRootUpdateInput"]: GraphQLTypes["HomePageLocaleWithoutRootUpdateInput"];
	["HomePageUpsertLocalesRelationInput"]: GraphQLTypes["HomePageUpsertLocalesRelationInput"];
	["HomePageLocaleCreateInput"]: GraphQLTypes["HomePageLocaleCreateInput"];
	["HomePageLocaleUpdateInput"]: GraphQLTypes["HomePageLocaleUpdateInput"];
	["LinkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkEdge"][]
};
	["LinkEdge"]: {
		node:ModelTypes["Link"]
};
	["LinkableConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LinkableEdge"][]
};
	["LinkableEdge"]: {
		node:ModelTypes["Linkable"]
};
	["LocaleConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LocaleEdge"][]
};
	["LocaleEdge"]: {
		node:ModelTypes["Locale"]
};
	["LocaleCreateInput"]: GraphQLTypes["LocaleCreateInput"];
	["LocaleUpdateInput"]: GraphQLTypes["LocaleUpdateInput"];
	["MediumConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumEdge"][]
};
	["MediumEdge"]: {
		node:ModelTypes["Medium"]
};
	["MediumItemCreateInput"]: GraphQLTypes["MediumItemCreateInput"];
	["MediumItemCreateListEntityRelationInput"]: GraphQLTypes["MediumItemCreateListEntityRelationInput"];
	["MediumListWithoutItemsCreateInput"]: GraphQLTypes["MediumListWithoutItemsCreateInput"];
	["MediumItemUpdateInput"]: GraphQLTypes["MediumItemUpdateInput"];
	["MediumItemUpdateListEntityRelationInput"]: GraphQLTypes["MediumItemUpdateListEntityRelationInput"];
	["MediumListWithoutItemsUpdateInput"]: GraphQLTypes["MediumListWithoutItemsUpdateInput"];
	["MediumItemUpsertListRelationInput"]: GraphQLTypes["MediumItemUpsertListRelationInput"];
	["MediumListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["MediumListEdge"][]
};
	["MediumListEdge"]: {
		node:ModelTypes["MediumList"]
};
	["PageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["PageEdge"][]
};
	["PageEdge"]: {
		node:ModelTypes["Page"]
};
	["PageCreateInput"]: GraphQLTypes["PageCreateInput"];
	["PageCreateLocalesEntityRelationInput"]: GraphQLTypes["PageCreateLocalesEntityRelationInput"];
	["PageLocaleWithoutRootCreateInput"]: GraphQLTypes["PageLocaleWithoutRootCreateInput"];
	["PageUpdateInput"]: GraphQLTypes["PageUpdateInput"];
	["PageUpdateLocalesEntityRelationInput"]: GraphQLTypes["PageUpdateLocalesEntityRelationInput"];
	["PageUpdateLocalesRelationInput"]: GraphQLTypes["PageUpdateLocalesRelationInput"];
	["PageLocaleWithoutRootUpdateInput"]: GraphQLTypes["PageLocaleWithoutRootUpdateInput"];
	["PageUpsertLocalesRelationInput"]: GraphQLTypes["PageUpsertLocalesRelationInput"];
	["PageLocaleCreateInput"]: GraphQLTypes["PageLocaleCreateInput"];
	["PageLocaleUpdateInput"]: GraphQLTypes["PageLocaleUpdateInput"];
	["SeoDefaultConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoDefaultEdge"][]
};
	["SeoDefaultEdge"]: {
		node:ModelTypes["SeoDefault"]
};
	["SeoDefaultCreateInput"]: GraphQLTypes["SeoDefaultCreateInput"];
	["SeoDefaultCreateLocalesEntityRelationInput"]: GraphQLTypes["SeoDefaultCreateLocalesEntityRelationInput"];
	["SeoDefaultLocaleWithoutRootCreateInput"]: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"];
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"];
	["LocaleWithoutSeoDefaultsCreateInput"]: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"];
	["SeoDefaultUpdateInput"]: GraphQLTypes["SeoDefaultUpdateInput"];
	["SeoDefaultUpdateLocalesEntityRelationInput"]: GraphQLTypes["SeoDefaultUpdateLocalesEntityRelationInput"];
	["SeoDefaultUpdateLocalesRelationInput"]: GraphQLTypes["SeoDefaultUpdateLocalesRelationInput"];
	["SeoDefaultLocaleWithoutRootUpdateInput"]: GraphQLTypes["SeoDefaultLocaleWithoutRootUpdateInput"];
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"];
	["LocaleWithoutSeoDefaultsUpdateInput"]: GraphQLTypes["LocaleWithoutSeoDefaultsUpdateInput"];
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: GraphQLTypes["SeoDefaultLocaleUpsertLocaleRelationInput"];
	["SeoDefaultUpsertLocalesRelationInput"]: GraphQLTypes["SeoDefaultUpsertLocalesRelationInput"];
	["SeoDefaultLocaleCreateInput"]: GraphQLTypes["SeoDefaultLocaleCreateInput"];
	["SeoDefaultLocaleUpdateInput"]: GraphQLTypes["SeoDefaultLocaleUpdateInput"];
	["VideoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["VideoEdge"][]
};
	["VideoEdge"]: {
		node:ModelTypes["Video"]
};
	["ImageConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ImageEdge"][]
};
	["ImageEdge"]: {
		node:ModelTypes["Image"]
};
	["SeoConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["SeoEdge"][]
};
	["SeoEdge"]: {
		node:ModelTypes["Seo"]
};
	["TranslationDomain"]: {
		_meta?:ModelTypes["TranslationDomainMeta"],
	id:ModelTypes["UUID"],
	identifier:string,
	name:string,
	catalogues:ModelTypes["TranslationCatalogue"][],
	keys:ModelTypes["TranslationKey"][],
	cataloguesByIdentifier?:ModelTypes["TranslationCatalogue"],
	cataloguesByValues?:ModelTypes["TranslationCatalogue"],
	keysByIdentifier?:ModelTypes["TranslationKey"],
	keysByValues?:ModelTypes["TranslationKey"],
	paginateCatalogues:ModelTypes["TranslationCatalogueConnection"],
	paginateKeys:ModelTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
		id?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	catalogues?:ModelTypes["FieldMeta"],
	keys?:ModelTypes["FieldMeta"]
};
	["TranslationCatalogue"]: {
		_meta?:ModelTypes["TranslationCatalogueMeta"],
	id:ModelTypes["UUID"],
	domain?:ModelTypes["TranslationDomain"],
	identifier?:ModelTypes["TranslationCataloguesIdentifier"],
	fallback?:ModelTypes["TranslationCatalogue"],
	values:ModelTypes["TranslationValue"][],
	valuesByKey?:ModelTypes["TranslationValue"],
	paginateValues:ModelTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	domain?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	fallback?:ModelTypes["FieldMeta"],
	values?:ModelTypes["FieldMeta"]
};
	["TranslationDomainWhere"]: GraphQLTypes["TranslationDomainWhere"];
	["TranslationCatalogueWhere"]: GraphQLTypes["TranslationCatalogueWhere"];
	["TranslationCataloguesIdentifierWhere"]: GraphQLTypes["TranslationCataloguesIdentifierWhere"];
	["TranslationValueWhere"]: GraphQLTypes["TranslationValueWhere"];
	["TranslationKeyWhere"]: GraphQLTypes["TranslationKeyWhere"];
	["TranslationContentTypeCondition"]: GraphQLTypes["TranslationContentTypeCondition"];
	["TranslationContentType"]: GraphQLTypes["TranslationContentType"];
	["TranslationCataloguesIdentifier"]: {
		_meta?:ModelTypes["TranslationCataloguesIdentifierMeta"],
	id:ModelTypes["UUID"],
	name:string,
	code:string,
	catalogue:ModelTypes["TranslationCatalogue"][],
	catalogueByDomain?:ModelTypes["TranslationCatalogue"],
	catalogueByValues?:ModelTypes["TranslationCatalogue"],
	paginateCatalogue:ModelTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
		id?:ModelTypes["FieldMeta"],
	name?:ModelTypes["FieldMeta"],
	code?:ModelTypes["FieldMeta"],
	catalogue?:ModelTypes["FieldMeta"]
};
	["TranslationCatalogueOrderBy"]: GraphQLTypes["TranslationCatalogueOrderBy"];
	["TranslationDomainOrderBy"]: GraphQLTypes["TranslationDomainOrderBy"];
	["TranslationCataloguesIdentifierOrderBy"]: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"];
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"];
	["TranslationDomainUniqueWhere"]: GraphQLTypes["TranslationDomainUniqueWhere"];
	["TranslationCatalogueUniqueWhere"]: GraphQLTypes["TranslationCatalogueUniqueWhere"];
	["TranslationCataloguesIdentifierUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"];
	["TranslationValueUniqueWhere"]: GraphQLTypes["TranslationValueUniqueWhere"];
	["TranslationKeyUniqueWhere"]: GraphQLTypes["TranslationKeyUniqueWhere"];
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: GraphQLTypes["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"];
	["TranslationCatalogueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationCatalogueEdge"][]
};
	["TranslationCatalogueEdge"]: {
		node:ModelTypes["TranslationCatalogue"]
};
	["TranslationValue"]: {
		_meta?:ModelTypes["TranslationValueMeta"],
	id:ModelTypes["UUID"],
	value:string,
	catalogue?:ModelTypes["TranslationCatalogue"],
	key?:ModelTypes["TranslationKey"]
};
	["TranslationValueMeta"]: {
		id?:ModelTypes["FieldMeta"],
	value?:ModelTypes["FieldMeta"],
	catalogue?:ModelTypes["FieldMeta"],
	key?:ModelTypes["FieldMeta"]
};
	["TranslationKey"]: {
		_meta?:ModelTypes["TranslationKeyMeta"],
	id:ModelTypes["UUID"],
	identifier:string,
	contentType:ModelTypes["TranslationContentType"],
	note?:string,
	domain?:ModelTypes["TranslationDomain"],
	values:ModelTypes["TranslationValue"][],
	valuesByCatalogue?:ModelTypes["TranslationValue"],
	paginateValues:ModelTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
		id?:ModelTypes["FieldMeta"],
	identifier?:ModelTypes["FieldMeta"],
	contentType?:ModelTypes["FieldMeta"],
	note?:ModelTypes["FieldMeta"],
	domain?:ModelTypes["FieldMeta"],
	values?:ModelTypes["FieldMeta"]
};
	["TranslationValueOrderBy"]: GraphQLTypes["TranslationValueOrderBy"];
	["TranslationKeyOrderBy"]: GraphQLTypes["TranslationKeyOrderBy"];
	["TranslationKeyValuesByCatalogueUniqueWhere"]: GraphQLTypes["TranslationKeyValuesByCatalogueUniqueWhere"];
	["TranslationValueConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationValueEdge"][]
};
	["TranslationValueEdge"]: {
		node:ModelTypes["TranslationValue"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: GraphQLTypes["TranslationCatalogueValuesByKeyUniqueWhere"];
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByIdentifierUniqueWhere"];
	["TranslationDomainCataloguesByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainCataloguesByValuesUniqueWhere"];
	["TranslationDomainKeysByIdentifierUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByIdentifierUniqueWhere"];
	["TranslationDomainKeysByValuesUniqueWhere"]: GraphQLTypes["TranslationDomainKeysByValuesUniqueWhere"];
	["TranslationKeyConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationKeyEdge"][]
};
	["TranslationKeyEdge"]: {
		node:ModelTypes["TranslationKey"]
};
	["TranslationDomainConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationDomainEdge"][]
};
	["TranslationDomainEdge"]: {
		node:ModelTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: GraphQLTypes["TranslationDomainCreateInput"];
	["TranslationDomainCreateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"];
	["TranslationCatalogueWithoutDomainCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"];
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"];
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"];
	["TranslationCatalogueCreateInput"]: GraphQLTypes["TranslationCatalogueCreateInput"];
	["TranslationCatalogueCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesCreateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"];
	["TranslationDomainCreateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"];
	["TranslationKeyWithoutDomainCreateInput"]: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"];
	["TranslationKeyCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"];
	["TranslationValueWithoutKeyCreateInput"]: GraphQLTypes["TranslationValueWithoutKeyCreateInput"];
	["TranslationValueCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"];
	["TranslationCatalogueCreateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"];
	["TranslationValueWithoutCatalogueCreateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"];
	["TranslationValueCreateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesCreateInput"]: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"];
	["TranslationKeyCreateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysCreateInput"]: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"];
	["TranslationDomainUpdateInput"]: GraphQLTypes["TranslationDomainUpdateInput"];
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"];
	["TranslationDomainUpdateCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"];
	["TranslationCatalogueWithoutDomainUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"];
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"];
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"];
	["TranslationCatalogueUpsertIdentifierRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"];
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"];
	["TranslationCatalogueUpdateInput"]: GraphQLTypes["TranslationCatalogueUpdateInput"];
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutCataloguesUpdateInput"]: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"];
	["TranslationDomainUpdateKeysEntityRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"];
	["TranslationDomainUpdateKeysRelationInput"]: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"];
	["TranslationKeyWithoutDomainUpdateInput"]: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"];
	["TranslationKeyUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"];
	["TranslationKeyUpdateValuesRelationInput"]: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"];
	["TranslationValueWithoutKeyUpdateInput"]: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"];
	["TranslationValueUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutValuesUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"];
	["TranslationValueUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"];
	["TranslationKeyUpsertValuesRelationInput"]: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"];
	["TranslationDomainUpsertKeysRelationInput"]: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"];
	["TranslationCatalogueUpsertDomainRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"];
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"];
	["TranslationCatalogueUpdateValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"];
	["TranslationValueWithoutCatalogueUpdateInput"]: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"];
	["TranslationValueUpdateKeyEntityRelationInput"]: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"];
	["TranslationKeyWithoutValuesUpdateInput"]: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"];
	["TranslationKeyUpdateDomainEntityRelationInput"]: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"];
	["TranslationDomainWithoutKeysUpdateInput"]: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"];
	["TranslationKeyUpsertDomainRelationInput"]: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"];
	["TranslationValueUpsertKeyRelationInput"]: GraphQLTypes["TranslationValueUpsertKeyRelationInput"];
	["TranslationCatalogueUpsertValuesRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"];
	["TranslationCatalogueUpsertFallbackRelationInput"]: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"];
	["TranslationDomainUpsertCataloguesRelationInput"]: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"];
	["TranslationCataloguesIdentifierConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["TranslationCataloguesIdentifierEdge"][]
};
	["TranslationCataloguesIdentifierEdge"]: {
		node:ModelTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateInput"];
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"];
	["TranslationCatalogueWithoutIdentifierCreateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"];
	["TranslationCataloguesIdentifierUpdateInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"];
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"];
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"];
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"];
	["TranslationKeyCreateInput"]: GraphQLTypes["TranslationKeyCreateInput"];
	["TranslationKeyUpdateInput"]: GraphQLTypes["TranslationKeyUpdateInput"];
	["TranslationValueCreateInput"]: GraphQLTypes["TranslationValueCreateInput"];
	["TranslationValueUpdateInput"]: GraphQLTypes["TranslationValueUpdateInput"];
	["EventConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventEdge"][]
};
	["EventEdge"]: {
		node:ModelTypes["Event"]
};
	["EventLocaleCreateInput"]: GraphQLTypes["EventLocaleCreateInput"];
	["EventLocaleUpdateInput"]: GraphQLTypes["EventLocaleUpdateInput"];
	["ArtworkConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkEdge"][]
};
	["ArtworkEdge"]: {
		node:ModelTypes["Artwork"]
};
	["ArtworkLocaleCreateInput"]: GraphQLTypes["ArtworkLocaleCreateInput"];
	["ArtworkLocaleUpdateInput"]: GraphQLTypes["ArtworkLocaleUpdateInput"];
	["DropDownItemCreateInput"]: GraphQLTypes["DropDownItemCreateInput"];
	["DropDownItemCreateListEntityRelationInput"]: GraphQLTypes["DropDownItemCreateListEntityRelationInput"];
	["DropDownListWithoutItemsCreateInput"]: GraphQLTypes["DropDownListWithoutItemsCreateInput"];
	["DropDownItemUpdateInput"]: GraphQLTypes["DropDownItemUpdateInput"];
	["DropDownItemUpdateListEntityRelationInput"]: GraphQLTypes["DropDownItemUpdateListEntityRelationInput"];
	["DropDownListWithoutItemsUpdateInput"]: GraphQLTypes["DropDownListWithoutItemsUpdateInput"];
	["DropDownItemUpsertListRelationInput"]: GraphQLTypes["DropDownItemUpsertListRelationInput"];
	["DropDownListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DropDownListEdge"][]
};
	["DropDownListEdge"]: {
		node:ModelTypes["DropDownList"]
};
	["ArtworkItem"]: {
		_meta?:ModelTypes["ArtworkItemMeta"],
	id:ModelTypes["UUID"],
	order:number,
	list?:ModelTypes["ArtworkList"],
	artwork?:ModelTypes["ArtworkLocale"]
};
	["ArtworkItemMeta"]: {
		id?:ModelTypes["FieldMeta"],
	order?:ModelTypes["FieldMeta"],
	list?:ModelTypes["FieldMeta"],
	artwork?:ModelTypes["FieldMeta"]
};
	["ArtworkList"]: {
		_meta?:ModelTypes["ArtworkListMeta"],
	id:ModelTypes["UUID"],
	items:ModelTypes["ArtworkItem"][],
	paginateItems:ModelTypes["ArtworkItemConnection"]
};
	["ArtworkListMeta"]: {
		id?:ModelTypes["FieldMeta"],
	items?:ModelTypes["FieldMeta"]
};
	["ArtworkItemWhere"]: GraphQLTypes["ArtworkItemWhere"];
	["ArtworkListWhere"]: GraphQLTypes["ArtworkListWhere"];
	["ArtworkItemOrderBy"]: GraphQLTypes["ArtworkItemOrderBy"];
	["ArtworkListOrderBy"]: GraphQLTypes["ArtworkListOrderBy"];
	["ArtworkItemConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkItemEdge"][]
};
	["ArtworkItemEdge"]: {
		node:ModelTypes["ArtworkItem"]
};
	["ArtworkItemUniqueWhere"]: GraphQLTypes["ArtworkItemUniqueWhere"];
	["ArtworkItemCreateInput"]: GraphQLTypes["ArtworkItemCreateInput"];
	["ArtworkItemCreateListEntityRelationInput"]: GraphQLTypes["ArtworkItemCreateListEntityRelationInput"];
	["ArtworkListUniqueWhere"]: GraphQLTypes["ArtworkListUniqueWhere"];
	["ArtworkListWithoutItemsCreateInput"]: GraphQLTypes["ArtworkListWithoutItemsCreateInput"];
	["ArtworkItemCreateArtworkEntityRelationInput"]: GraphQLTypes["ArtworkItemCreateArtworkEntityRelationInput"];
	["ArtworkItemUpdateInput"]: GraphQLTypes["ArtworkItemUpdateInput"];
	["ArtworkItemUpdateListEntityRelationInput"]: GraphQLTypes["ArtworkItemUpdateListEntityRelationInput"];
	["ArtworkListWithoutItemsUpdateInput"]: GraphQLTypes["ArtworkListWithoutItemsUpdateInput"];
	["ArtworkItemUpsertListRelationInput"]: GraphQLTypes["ArtworkItemUpsertListRelationInput"];
	["ArtworkItemUpdateArtworkEntityRelationInput"]: GraphQLTypes["ArtworkItemUpdateArtworkEntityRelationInput"];
	["ArtworkItemUpsertArtworkRelationInput"]: GraphQLTypes["ArtworkItemUpsertArtworkRelationInput"];
	["ArtworkListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkListEdge"][]
};
	["ArtworkListEdge"]: {
		node:ModelTypes["ArtworkList"]
};
	["ArtworkListCreateInput"]: GraphQLTypes["ArtworkListCreateInput"];
	["ArtworkListCreateItemsEntityRelationInput"]: GraphQLTypes["ArtworkListCreateItemsEntityRelationInput"];
	["ArtworkItemWithoutListCreateInput"]: GraphQLTypes["ArtworkItemWithoutListCreateInput"];
	["ArtworkListUpdateInput"]: GraphQLTypes["ArtworkListUpdateInput"];
	["ArtworkListUpdateItemsEntityRelationInput"]: GraphQLTypes["ArtworkListUpdateItemsEntityRelationInput"];
	["ArtworkListUpdateItemsRelationInput"]: GraphQLTypes["ArtworkListUpdateItemsRelationInput"];
	["ArtworkItemWithoutListUpdateInput"]: GraphQLTypes["ArtworkItemWithoutListUpdateInput"];
	["ArtworkListUpsertItemsRelationInput"]: GraphQLTypes["ArtworkListUpsertItemsRelationInput"];
	["ArtworkSelectionConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkSelectionEdge"][]
};
	["ArtworkSelectionEdge"]: {
		node:ModelTypes["ArtworkSelection"]
};
	["ArtworkSelectionItemCreateInput"]: GraphQLTypes["ArtworkSelectionItemCreateInput"];
	["ArtworkSelectionItemCreateListEntityRelationInput"]: GraphQLTypes["ArtworkSelectionItemCreateListEntityRelationInput"];
	["ArtworkSelectionListWithoutItemsCreateInput"]: GraphQLTypes["ArtworkSelectionListWithoutItemsCreateInput"];
	["ArtworkSelectionItemUpdateInput"]: GraphQLTypes["ArtworkSelectionItemUpdateInput"];
	["ArtworkSelectionItemUpdateListEntityRelationInput"]: GraphQLTypes["ArtworkSelectionItemUpdateListEntityRelationInput"];
	["ArtworkSelectionListWithoutItemsUpdateInput"]: GraphQLTypes["ArtworkSelectionListWithoutItemsUpdateInput"];
	["ArtworkSelectionItemUpsertListRelationInput"]: GraphQLTypes["ArtworkSelectionItemUpsertListRelationInput"];
	["ArtworkSelectionListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ArtworkSelectionListEdge"][]
};
	["ArtworkSelectionListEdge"]: {
		node:ModelTypes["ArtworkSelectionList"]
};
	["ArtworkSelectionLocaleCreateInput"]: GraphQLTypes["ArtworkSelectionLocaleCreateInput"];
	["ArtworkSelectionLocaleUpdateInput"]: GraphQLTypes["ArtworkSelectionLocaleUpdateInput"];
	["EventItemCreateInput"]: GraphQLTypes["EventItemCreateInput"];
	["EventItemCreateListEntityRelationInput"]: GraphQLTypes["EventItemCreateListEntityRelationInput"];
	["EventListWithoutItemsCreateInput"]: GraphQLTypes["EventListWithoutItemsCreateInput"];
	["EventItemUpdateInput"]: GraphQLTypes["EventItemUpdateInput"];
	["EventItemUpdateListEntityRelationInput"]: GraphQLTypes["EventItemUpdateListEntityRelationInput"];
	["EventListWithoutItemsUpdateInput"]: GraphQLTypes["EventListWithoutItemsUpdateInput"];
	["EventItemUpsertListRelationInput"]: GraphQLTypes["EventItemUpsertListRelationInput"];
	["EventListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EventListEdge"][]
};
	["EventListEdge"]: {
		node:ModelTypes["EventList"]
};
	["BoxItemCreateInput"]: GraphQLTypes["BoxItemCreateInput"];
	["BoxItemCreateListEntityRelationInput"]: GraphQLTypes["BoxItemCreateListEntityRelationInput"];
	["BoxListWithoutItemsCreateInput"]: GraphQLTypes["BoxListWithoutItemsCreateInput"];
	["BoxItemUpdateInput"]: GraphQLTypes["BoxItemUpdateInput"];
	["BoxItemUpdateListEntityRelationInput"]: GraphQLTypes["BoxItemUpdateListEntityRelationInput"];
	["BoxListWithoutItemsUpdateInput"]: GraphQLTypes["BoxListWithoutItemsUpdateInput"];
	["BoxItemUpsertListRelationInput"]: GraphQLTypes["BoxItemUpsertListRelationInput"];
	["BoxListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["BoxListEdge"][]
};
	["BoxListEdge"]: {
		node:ModelTypes["BoxList"]
};
	["NewsletterFormConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["NewsletterFormEdge"][]
};
	["NewsletterFormEdge"]: {
		node:ModelTypes["NewsletterForm"]
};
	["NewsletterTypeItemCreateInput"]: GraphQLTypes["NewsletterTypeItemCreateInput"];
	["NewsletterTypeItemCreateListEntityRelationInput"]: GraphQLTypes["NewsletterTypeItemCreateListEntityRelationInput"];
	["NewsletterFormLocaleWithoutItemsCreateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutItemsCreateInput"];
	["NewsletterTypeItemUpdateInput"]: GraphQLTypes["NewsletterTypeItemUpdateInput"];
	["NewsletterTypeItemUpdateListEntityRelationInput"]: GraphQLTypes["NewsletterTypeItemUpdateListEntityRelationInput"];
	["NewsletterFormLocaleWithoutItemsUpdateInput"]: GraphQLTypes["NewsletterFormLocaleWithoutItemsUpdateInput"];
	["NewsletterTypeItemUpsertListRelationInput"]: GraphQLTypes["NewsletterTypeItemUpsertListRelationInput"];
	["NewsletterFormLocaleCreateInput"]: GraphQLTypes["NewsletterFormLocaleCreateInput"];
	["NewsletterFormLocaleUpdateInput"]: GraphQLTypes["NewsletterFormLocaleUpdateInput"];
	["NewsletterSubscriptionCreateInput"]: GraphQLTypes["NewsletterSubscriptionCreateInput"];
	["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"]: GraphQLTypes["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"];
	["NewsletterTypeItemWithoutSubscriptionsCreateInput"]: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"];
	["NewsletterSubscriptionUpdateInput"]: GraphQLTypes["NewsletterSubscriptionUpdateInput"];
	["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"]: GraphQLTypes["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"];
	["NewsletterTypeItemWithoutSubscriptionsUpdateInput"]: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsUpdateInput"];
	["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"]: GraphQLTypes["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"];
	["ChartConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ChartEdge"][]
};
	["ChartEdge"]: {
		node:ModelTypes["Chart"]
};
	["ChartDataCreateInput"]: GraphQLTypes["ChartDataCreateInput"];
	["ChartDataCreateListEntityRelationInput"]: GraphQLTypes["ChartDataCreateListEntityRelationInput"];
	["ChartWithoutItemsCreateInput"]: GraphQLTypes["ChartWithoutItemsCreateInput"];
	["ChartDataUpdateInput"]: GraphQLTypes["ChartDataUpdateInput"];
	["ChartDataUpdateListEntityRelationInput"]: GraphQLTypes["ChartDataUpdateListEntityRelationInput"];
	["ChartWithoutItemsUpdateInput"]: GraphQLTypes["ChartWithoutItemsUpdateInput"];
	["ChartDataUpsertListRelationInput"]: GraphQLTypes["ChartDataUpsertListRelationInput"];
	["EmployeeConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EmployeeEdge"][]
};
	["EmployeeEdge"]: {
		node:ModelTypes["Employee"]
};
	["EmployeeItemCreateInput"]: GraphQLTypes["EmployeeItemCreateInput"];
	["EmployeeItemCreateListEntityRelationInput"]: GraphQLTypes["EmployeeItemCreateListEntityRelationInput"];
	["EmployeeListWithoutItemsCreateInput"]: GraphQLTypes["EmployeeListWithoutItemsCreateInput"];
	["EmployeeItemUpdateInput"]: GraphQLTypes["EmployeeItemUpdateInput"];
	["EmployeeItemUpdateListEntityRelationInput"]: GraphQLTypes["EmployeeItemUpdateListEntityRelationInput"];
	["EmployeeListWithoutItemsUpdateInput"]: GraphQLTypes["EmployeeListWithoutItemsUpdateInput"];
	["EmployeeItemUpsertListRelationInput"]: GraphQLTypes["EmployeeItemUpsertListRelationInput"];
	["EmployeeListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["EmployeeListEdge"][]
};
	["EmployeeListEdge"]: {
		node:ModelTypes["EmployeeList"]
};
	["EmployeeLocaleCreateInput"]: GraphQLTypes["EmployeeLocaleCreateInput"];
	["EmployeeLocaleUpdateInput"]: GraphQLTypes["EmployeeLocaleUpdateInput"];
	["DefinitionItemCreateInput"]: GraphQLTypes["DefinitionItemCreateInput"];
	["DefinitionItemCreateListEntityRelationInput"]: GraphQLTypes["DefinitionItemCreateListEntityRelationInput"];
	["DefinitionListWithoutItemsCreateInput"]: GraphQLTypes["DefinitionListWithoutItemsCreateInput"];
	["DefinitionItemUpdateInput"]: GraphQLTypes["DefinitionItemUpdateInput"];
	["DefinitionItemUpdateListEntityRelationInput"]: GraphQLTypes["DefinitionItemUpdateListEntityRelationInput"];
	["DefinitionListWithoutItemsUpdateInput"]: GraphQLTypes["DefinitionListWithoutItemsUpdateInput"];
	["DefinitionItemUpsertListRelationInput"]: GraphQLTypes["DefinitionItemUpsertListRelationInput"];
	["DefinitionListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["DefinitionListEdge"][]
};
	["DefinitionListEdge"]: {
		node:ModelTypes["DefinitionList"]
};
	["LogoItemCreateInput"]: GraphQLTypes["LogoItemCreateInput"];
	["LogoItemCreateListEntityRelationInput"]: GraphQLTypes["LogoItemCreateListEntityRelationInput"];
	["LogoListWithoutItemsCreateInput"]: GraphQLTypes["LogoListWithoutItemsCreateInput"];
	["LogoItemUpdateInput"]: GraphQLTypes["LogoItemUpdateInput"];
	["LogoItemUpdateListEntityRelationInput"]: GraphQLTypes["LogoItemUpdateListEntityRelationInput"];
	["LogoListWithoutItemsUpdateInput"]: GraphQLTypes["LogoListWithoutItemsUpdateInput"];
	["LogoItemUpsertListRelationInput"]: GraphQLTypes["LogoItemUpsertListRelationInput"];
	["LogoListConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["LogoListEdge"][]
};
	["LogoListEdge"]: {
		node:ModelTypes["LogoList"]
};
	["StrategySchemaConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StrategySchemaEdge"][]
};
	["StrategySchemaEdge"]: {
		node:ModelTypes["StrategySchema"]
};
	["StrategySchemaGroupConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["StrategySchemaGroupEdge"][]
};
	["StrategySchemaGroupEdge"]: {
		node:ModelTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupItemCreateInput"]: GraphQLTypes["StrategySchemaGroupItemCreateInput"];
	["StrategySchemaGroupItemCreateSchemaEntityRelationInput"]: GraphQLTypes["StrategySchemaGroupItemCreateSchemaEntityRelationInput"];
	["StrategySchemaGroupWithoutItemsCreateInput"]: GraphQLTypes["StrategySchemaGroupWithoutItemsCreateInput"];
	["StrategySchemaGroupItemUpdateInput"]: GraphQLTypes["StrategySchemaGroupItemUpdateInput"];
	["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"]: GraphQLTypes["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"];
	["StrategySchemaGroupWithoutItemsUpdateInput"]: GraphQLTypes["StrategySchemaGroupWithoutItemsUpdateInput"];
	["StrategySchemaGroupItemUpsertSchemaRelationInput"]: GraphQLTypes["StrategySchemaGroupItemUpsertSchemaRelationInput"];
	["RedirectConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["RedirectEdge"][]
};
	["RedirectEdge"]: {
		node:ModelTypes["Redirect"]
};
	["RedirectCreateInput"]: GraphQLTypes["RedirectCreateInput"];
	["RedirectCreateLinkEntityRelationInput"]: GraphQLTypes["RedirectCreateLinkEntityRelationInput"];
	["LinkableWithoutRedirectCreateInput"]: GraphQLTypes["LinkableWithoutRedirectCreateInput"];
	["RedirectUpdateInput"]: GraphQLTypes["RedirectUpdateInput"];
	["RedirectUpdateLinkEntityRelationInput"]: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"];
	["LinkableWithoutRedirectUpdateInput"]: GraphQLTypes["LinkableWithoutRedirectUpdateInput"];
	["RedirectUpsertLinkRelationInput"]: GraphQLTypes["RedirectUpsertLinkRelationInput"];
	["GalleryConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["GalleryEdge"][]
};
	["GalleryEdge"]: {
		node:ModelTypes["Gallery"]
};
	["GalleryItemCreateInput"]: GraphQLTypes["GalleryItemCreateInput"];
	["GalleryItemCreateListEntityRelationInput"]: GraphQLTypes["GalleryItemCreateListEntityRelationInput"];
	["GalleryWithoutItemsCreateInput"]: GraphQLTypes["GalleryWithoutItemsCreateInput"];
	["GalleryItemUpdateInput"]: GraphQLTypes["GalleryItemUpdateInput"];
	["GalleryItemUpdateListEntityRelationInput"]: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"];
	["GalleryWithoutItemsUpdateInput"]: GraphQLTypes["GalleryWithoutItemsUpdateInput"];
	["GalleryItemUpsertListRelationInput"]: GraphQLTypes["GalleryItemUpsertListRelationInput"];
	["ContactFormConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["ContactFormEdge"][]
};
	["ContactFormEdge"]: {
		node:ModelTypes["ContactForm"]
};
	["ContactFormLocaleCreateInput"]: GraphQLTypes["ContactFormLocaleCreateInput"];
	["ContactFormLocaleUpdateInput"]: GraphQLTypes["ContactFormLocaleUpdateInput"];
	["ContactSubscriptionCreateInput"]: GraphQLTypes["ContactSubscriptionCreateInput"];
	["ContactSubscriptionCreateContactTypeEntityRelationInput"]: GraphQLTypes["ContactSubscriptionCreateContactTypeEntityRelationInput"];
	["ContactTypeItemWithoutSubscriptionsCreateInput"]: GraphQLTypes["ContactTypeItemWithoutSubscriptionsCreateInput"];
	["ContactTypeItemCreateListEntityRelationInput"]: GraphQLTypes["ContactTypeItemCreateListEntityRelationInput"];
	["ContactFormLocaleWithoutItemsCreateInput"]: GraphQLTypes["ContactFormLocaleWithoutItemsCreateInput"];
	["ContactSubscriptionUpdateInput"]: GraphQLTypes["ContactSubscriptionUpdateInput"];
	["ContactSubscriptionUpdateContactTypeEntityRelationInput"]: GraphQLTypes["ContactSubscriptionUpdateContactTypeEntityRelationInput"];
	["ContactTypeItemWithoutSubscriptionsUpdateInput"]: GraphQLTypes["ContactTypeItemWithoutSubscriptionsUpdateInput"];
	["ContactTypeItemUpdateListEntityRelationInput"]: GraphQLTypes["ContactTypeItemUpdateListEntityRelationInput"];
	["ContactFormLocaleWithoutItemsUpdateInput"]: GraphQLTypes["ContactFormLocaleWithoutItemsUpdateInput"];
	["ContactTypeItemUpsertListRelationInput"]: GraphQLTypes["ContactTypeItemUpsertListRelationInput"];
	["ContactSubscriptionUpsertContactTypeRelationInput"]: GraphQLTypes["ContactSubscriptionUpsertContactTypeRelationInput"];
	["ContactTypeItemCreateInput"]: GraphQLTypes["ContactTypeItemCreateInput"];
	["ContactTypeItemUpdateInput"]: GraphQLTypes["ContactTypeItemUpdateInput"];
	["FileConnection"]: {
		pageInfo:ModelTypes["PageInfo"],
	edges:ModelTypes["FileEdge"][]
};
	["FileEdge"]: {
		node:ModelTypes["File"]
};
	["QueryTransaction"]: {
		getContactPage?:ModelTypes["ContactPage"],
	listContactPage:ModelTypes["ContactPage"][],
	paginateContactPage:ModelTypes["ContactPageConnection"],
	validateCreateContactPage:ModelTypes["_ValidationResult"],
	validateUpdateContactPage:ModelTypes["_ValidationResult"],
	getContactPageLocale?:ModelTypes["ContactPageLocale"],
	listContactPageLocale:ModelTypes["ContactPageLocale"][],
	paginateContactPageLocale:ModelTypes["ContactPageLocaleConnection"],
	validateCreateContactPageLocale:ModelTypes["_ValidationResult"],
	validateUpdateContactPageLocale:ModelTypes["_ValidationResult"],
	getContent?:ModelTypes["Content"],
	listContent:ModelTypes["Content"][],
	paginateContent:ModelTypes["ContentConnection"],
	validateCreateContent:ModelTypes["_ValidationResult"],
	validateUpdateContent:ModelTypes["_ValidationResult"],
	getContentBlock?:ModelTypes["ContentBlock"],
	listContentBlock:ModelTypes["ContentBlock"][],
	paginateContentBlock:ModelTypes["ContentBlockConnection"],
	validateCreateContentBlock:ModelTypes["_ValidationResult"],
	validateUpdateContentBlock:ModelTypes["_ValidationResult"],
	getContentReference?:ModelTypes["ContentReference"],
	listContentReference:ModelTypes["ContentReference"][],
	paginateContentReference:ModelTypes["ContentReferenceConnection"],
	validateCreateContentReference:ModelTypes["_ValidationResult"],
	validateUpdateContentReference:ModelTypes["_ValidationResult"],
	getFooter?:ModelTypes["Footer"],
	listFooter:ModelTypes["Footer"][],
	paginateFooter:ModelTypes["FooterConnection"],
	validateCreateFooter:ModelTypes["_ValidationResult"],
	validateUpdateFooter:ModelTypes["_ValidationResult"],
	getFooterLocale?:ModelTypes["FooterLocale"],
	listFooterLocale:ModelTypes["FooterLocale"][],
	paginateFooterLocale:ModelTypes["FooterLocaleConnection"],
	validateCreateFooterLocale:ModelTypes["_ValidationResult"],
	validateUpdateFooterLocale:ModelTypes["_ValidationResult"],
	getHeader?:ModelTypes["Header"],
	listHeader:ModelTypes["Header"][],
	paginateHeader:ModelTypes["HeaderConnection"],
	validateCreateHeader:ModelTypes["_ValidationResult"],
	validateUpdateHeader:ModelTypes["_ValidationResult"],
	getHeaderLink?:ModelTypes["HeaderLink"],
	listHeaderLink:ModelTypes["HeaderLink"][],
	paginateHeaderLink:ModelTypes["HeaderLinkConnection"],
	validateCreateHeaderLink:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLink:ModelTypes["_ValidationResult"],
	getHeaderLocale?:ModelTypes["HeaderLocale"],
	listHeaderLocale:ModelTypes["HeaderLocale"][],
	paginateHeaderLocale:ModelTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale:ModelTypes["_ValidationResult"],
	validateUpdateHeaderLocale:ModelTypes["_ValidationResult"],
	getHomePage?:ModelTypes["HomePage"],
	listHomePage:ModelTypes["HomePage"][],
	paginateHomePage:ModelTypes["HomePageConnection"],
	validateCreateHomePage:ModelTypes["_ValidationResult"],
	validateUpdateHomePage:ModelTypes["_ValidationResult"],
	getHomePageLocale?:ModelTypes["HomePageLocale"],
	listHomePageLocale:ModelTypes["HomePageLocale"][],
	paginateHomePageLocale:ModelTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale:ModelTypes["_ValidationResult"],
	validateUpdateHomePageLocale:ModelTypes["_ValidationResult"],
	getLink?:ModelTypes["Link"],
	listLink:ModelTypes["Link"][],
	paginateLink:ModelTypes["LinkConnection"],
	validateCreateLink:ModelTypes["_ValidationResult"],
	validateUpdateLink:ModelTypes["_ValidationResult"],
	getLinkable?:ModelTypes["Linkable"],
	listLinkable:ModelTypes["Linkable"][],
	paginateLinkable:ModelTypes["LinkableConnection"],
	validateCreateLinkable:ModelTypes["_ValidationResult"],
	validateUpdateLinkable:ModelTypes["_ValidationResult"],
	getLocale?:ModelTypes["Locale"],
	listLocale:ModelTypes["Locale"][],
	paginateLocale:ModelTypes["LocaleConnection"],
	validateCreateLocale:ModelTypes["_ValidationResult"],
	validateUpdateLocale:ModelTypes["_ValidationResult"],
	getMedium?:ModelTypes["Medium"],
	listMedium:ModelTypes["Medium"][],
	paginateMedium:ModelTypes["MediumConnection"],
	validateCreateMedium:ModelTypes["_ValidationResult"],
	validateUpdateMedium:ModelTypes["_ValidationResult"],
	getMediumItem?:ModelTypes["MediumItem"],
	listMediumItem:ModelTypes["MediumItem"][],
	paginateMediumItem:ModelTypes["MediumItemConnection"],
	validateCreateMediumItem:ModelTypes["_ValidationResult"],
	validateUpdateMediumItem:ModelTypes["_ValidationResult"],
	getMediumList?:ModelTypes["MediumList"],
	listMediumList:ModelTypes["MediumList"][],
	paginateMediumList:ModelTypes["MediumListConnection"],
	validateCreateMediumList:ModelTypes["_ValidationResult"],
	validateUpdateMediumList:ModelTypes["_ValidationResult"],
	getPage?:ModelTypes["Page"],
	listPage:ModelTypes["Page"][],
	paginatePage:ModelTypes["PageConnection"],
	validateCreatePage:ModelTypes["_ValidationResult"],
	validateUpdatePage:ModelTypes["_ValidationResult"],
	getPageLocale?:ModelTypes["PageLocale"],
	listPageLocale:ModelTypes["PageLocale"][],
	paginatePageLocale:ModelTypes["PageLocaleConnection"],
	validateCreatePageLocale:ModelTypes["_ValidationResult"],
	validateUpdatePageLocale:ModelTypes["_ValidationResult"],
	getSeoDefault?:ModelTypes["SeoDefault"],
	listSeoDefault:ModelTypes["SeoDefault"][],
	paginateSeoDefault:ModelTypes["SeoDefaultConnection"],
	validateCreateSeoDefault:ModelTypes["_ValidationResult"],
	validateUpdateSeoDefault:ModelTypes["_ValidationResult"],
	getSeoDefaultLocale?:ModelTypes["SeoDefaultLocale"],
	listSeoDefaultLocale:ModelTypes["SeoDefaultLocale"][],
	paginateSeoDefaultLocale:ModelTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale:ModelTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale:ModelTypes["_ValidationResult"],
	getVideo?:ModelTypes["Video"],
	listVideo:ModelTypes["Video"][],
	paginateVideo:ModelTypes["VideoConnection"],
	validateCreateVideo:ModelTypes["_ValidationResult"],
	validateUpdateVideo:ModelTypes["_ValidationResult"],
	getImage?:ModelTypes["Image"],
	listImage:ModelTypes["Image"][],
	paginateImage:ModelTypes["ImageConnection"],
	validateCreateImage:ModelTypes["_ValidationResult"],
	validateUpdateImage:ModelTypes["_ValidationResult"],
	getSeo?:ModelTypes["Seo"],
	listSeo:ModelTypes["Seo"][],
	paginateSeo:ModelTypes["SeoConnection"],
	validateCreateSeo:ModelTypes["_ValidationResult"],
	validateUpdateSeo:ModelTypes["_ValidationResult"],
	getTranslationDomain?:ModelTypes["TranslationDomain"],
	listTranslationDomain:ModelTypes["TranslationDomain"][],
	paginateTranslationDomain:ModelTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain:ModelTypes["_ValidationResult"],
	validateUpdateTranslationDomain:ModelTypes["_ValidationResult"],
	getTranslationCatalogue?:ModelTypes["TranslationCatalogue"],
	listTranslationCatalogue:ModelTypes["TranslationCatalogue"][],
	paginateTranslationCatalogue:ModelTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue:ModelTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?:ModelTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifier"][],
	paginateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier:ModelTypes["_ValidationResult"],
	getTranslationKey?:ModelTypes["TranslationKey"],
	listTranslationKey:ModelTypes["TranslationKey"][],
	paginateTranslationKey:ModelTypes["TranslationKeyConnection"],
	validateCreateTranslationKey:ModelTypes["_ValidationResult"],
	validateUpdateTranslationKey:ModelTypes["_ValidationResult"],
	getTranslationValue?:ModelTypes["TranslationValue"],
	listTranslationValue:ModelTypes["TranslationValue"][],
	paginateTranslationValue:ModelTypes["TranslationValueConnection"],
	validateCreateTranslationValue:ModelTypes["_ValidationResult"],
	validateUpdateTranslationValue:ModelTypes["_ValidationResult"],
	getBranches?:ModelTypes["Branches"],
	listBranches:ModelTypes["Branches"][],
	paginateBranches:ModelTypes["BranchesConnection"],
	validateCreateBranches:ModelTypes["_ValidationResult"],
	validateUpdateBranches:ModelTypes["_ValidationResult"],
	getGraphicDesigner?:ModelTypes["GraphicDesigner"],
	listGraphicDesigner:ModelTypes["GraphicDesigner"][],
	paginateGraphicDesigner:ModelTypes["GraphicDesignerConnection"],
	validateCreateGraphicDesigner:ModelTypes["_ValidationResult"],
	validateUpdateGraphicDesigner:ModelTypes["_ValidationResult"],
	getEvent?:ModelTypes["Event"],
	listEvent:ModelTypes["Event"][],
	paginateEvent:ModelTypes["EventConnection"],
	validateCreateEvent:ModelTypes["_ValidationResult"],
	validateUpdateEvent:ModelTypes["_ValidationResult"],
	getEventLocale?:ModelTypes["EventLocale"],
	listEventLocale:ModelTypes["EventLocale"][],
	paginateEventLocale:ModelTypes["EventLocaleConnection"],
	validateCreateEventLocale:ModelTypes["_ValidationResult"],
	validateUpdateEventLocale:ModelTypes["_ValidationResult"],
	getArtwork?:ModelTypes["Artwork"],
	listArtwork:ModelTypes["Artwork"][],
	paginateArtwork:ModelTypes["ArtworkConnection"],
	validateCreateArtwork:ModelTypes["_ValidationResult"],
	validateUpdateArtwork:ModelTypes["_ValidationResult"],
	getArtworkLocale?:ModelTypes["ArtworkLocale"],
	listArtworkLocale:ModelTypes["ArtworkLocale"][],
	paginateArtworkLocale:ModelTypes["ArtworkLocaleConnection"],
	validateCreateArtworkLocale:ModelTypes["_ValidationResult"],
	validateUpdateArtworkLocale:ModelTypes["_ValidationResult"],
	getDropDownItem?:ModelTypes["DropDownItem"],
	listDropDownItem:ModelTypes["DropDownItem"][],
	paginateDropDownItem:ModelTypes["DropDownItemConnection"],
	validateCreateDropDownItem:ModelTypes["_ValidationResult"],
	validateUpdateDropDownItem:ModelTypes["_ValidationResult"],
	getDropDownList?:ModelTypes["DropDownList"],
	listDropDownList:ModelTypes["DropDownList"][],
	paginateDropDownList:ModelTypes["DropDownListConnection"],
	validateCreateDropDownList:ModelTypes["_ValidationResult"],
	validateUpdateDropDownList:ModelTypes["_ValidationResult"],
	getArtworkItem?:ModelTypes["ArtworkItem"],
	listArtworkItem:ModelTypes["ArtworkItem"][],
	paginateArtworkItem:ModelTypes["ArtworkItemConnection"],
	validateCreateArtworkItem:ModelTypes["_ValidationResult"],
	validateUpdateArtworkItem:ModelTypes["_ValidationResult"],
	getArtworkList?:ModelTypes["ArtworkList"],
	listArtworkList:ModelTypes["ArtworkList"][],
	paginateArtworkList:ModelTypes["ArtworkListConnection"],
	validateCreateArtworkList:ModelTypes["_ValidationResult"],
	validateUpdateArtworkList:ModelTypes["_ValidationResult"],
	getArtworkSelection?:ModelTypes["ArtworkSelection"],
	listArtworkSelection:ModelTypes["ArtworkSelection"][],
	paginateArtworkSelection:ModelTypes["ArtworkSelectionConnection"],
	validateCreateArtworkSelection:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelection:ModelTypes["_ValidationResult"],
	getArtworkSelectionItem?:ModelTypes["ArtworkSelectionItem"],
	listArtworkSelectionItem:ModelTypes["ArtworkSelectionItem"][],
	paginateArtworkSelectionItem:ModelTypes["ArtworkSelectionItemConnection"],
	validateCreateArtworkSelectionItem:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionItem:ModelTypes["_ValidationResult"],
	getArtworkSelectionList?:ModelTypes["ArtworkSelectionList"],
	listArtworkSelectionList:ModelTypes["ArtworkSelectionList"][],
	paginateArtworkSelectionList:ModelTypes["ArtworkSelectionListConnection"],
	validateCreateArtworkSelectionList:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionList:ModelTypes["_ValidationResult"],
	getArtworkSelectionLocale?:ModelTypes["ArtworkSelectionLocale"],
	listArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocale"][],
	paginateArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleConnection"],
	validateCreateArtworkSelectionLocale:ModelTypes["_ValidationResult"],
	validateUpdateArtworkSelectionLocale:ModelTypes["_ValidationResult"],
	getEventItem?:ModelTypes["EventItem"],
	listEventItem:ModelTypes["EventItem"][],
	paginateEventItem:ModelTypes["EventItemConnection"],
	validateCreateEventItem:ModelTypes["_ValidationResult"],
	validateUpdateEventItem:ModelTypes["_ValidationResult"],
	getEventList?:ModelTypes["EventList"],
	listEventList:ModelTypes["EventList"][],
	paginateEventList:ModelTypes["EventListConnection"],
	validateCreateEventList:ModelTypes["_ValidationResult"],
	validateUpdateEventList:ModelTypes["_ValidationResult"],
	getBoxItem?:ModelTypes["BoxItem"],
	listBoxItem:ModelTypes["BoxItem"][],
	paginateBoxItem:ModelTypes["BoxItemConnection"],
	validateCreateBoxItem:ModelTypes["_ValidationResult"],
	validateUpdateBoxItem:ModelTypes["_ValidationResult"],
	getBoxList?:ModelTypes["BoxList"],
	listBoxList:ModelTypes["BoxList"][],
	paginateBoxList:ModelTypes["BoxListConnection"],
	validateCreateBoxList:ModelTypes["_ValidationResult"],
	validateUpdateBoxList:ModelTypes["_ValidationResult"],
	getNewsletterForm?:ModelTypes["NewsletterForm"],
	listNewsletterForm:ModelTypes["NewsletterForm"][],
	paginateNewsletterForm:ModelTypes["NewsletterFormConnection"],
	validateCreateNewsletterForm:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterForm:ModelTypes["_ValidationResult"],
	getNewsletterTypeItem?:ModelTypes["NewsletterTypeItem"],
	listNewsletterTypeItem:ModelTypes["NewsletterTypeItem"][],
	paginateNewsletterTypeItem:ModelTypes["NewsletterTypeItemConnection"],
	validateCreateNewsletterTypeItem:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterTypeItem:ModelTypes["_ValidationResult"],
	getNewsletterFormLocale?:ModelTypes["NewsletterFormLocale"],
	listNewsletterFormLocale:ModelTypes["NewsletterFormLocale"][],
	paginateNewsletterFormLocale:ModelTypes["NewsletterFormLocaleConnection"],
	validateCreateNewsletterFormLocale:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterFormLocale:ModelTypes["_ValidationResult"],
	getNewsletterSubscription?:ModelTypes["NewsletterSubscription"],
	listNewsletterSubscription:ModelTypes["NewsletterSubscription"][],
	paginateNewsletterSubscription:ModelTypes["NewsletterSubscriptionConnection"],
	validateCreateNewsletterSubscription:ModelTypes["_ValidationResult"],
	validateUpdateNewsletterSubscription:ModelTypes["_ValidationResult"],
	getChart?:ModelTypes["Chart"],
	listChart:ModelTypes["Chart"][],
	paginateChart:ModelTypes["ChartConnection"],
	validateCreateChart:ModelTypes["_ValidationResult"],
	validateUpdateChart:ModelTypes["_ValidationResult"],
	getChartData?:ModelTypes["ChartData"],
	listChartData:ModelTypes["ChartData"][],
	paginateChartData:ModelTypes["ChartDataConnection"],
	validateCreateChartData:ModelTypes["_ValidationResult"],
	validateUpdateChartData:ModelTypes["_ValidationResult"],
	getEmployee?:ModelTypes["Employee"],
	listEmployee:ModelTypes["Employee"][],
	paginateEmployee:ModelTypes["EmployeeConnection"],
	validateCreateEmployee:ModelTypes["_ValidationResult"],
	validateUpdateEmployee:ModelTypes["_ValidationResult"],
	getEmployeeItem?:ModelTypes["EmployeeItem"],
	listEmployeeItem:ModelTypes["EmployeeItem"][],
	paginateEmployeeItem:ModelTypes["EmployeeItemConnection"],
	validateCreateEmployeeItem:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeItem:ModelTypes["_ValidationResult"],
	getEmployeeList?:ModelTypes["EmployeeList"],
	listEmployeeList:ModelTypes["EmployeeList"][],
	paginateEmployeeList:ModelTypes["EmployeeListConnection"],
	validateCreateEmployeeList:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeList:ModelTypes["_ValidationResult"],
	getEmployeeLocale?:ModelTypes["EmployeeLocale"],
	listEmployeeLocale:ModelTypes["EmployeeLocale"][],
	paginateEmployeeLocale:ModelTypes["EmployeeLocaleConnection"],
	validateCreateEmployeeLocale:ModelTypes["_ValidationResult"],
	validateUpdateEmployeeLocale:ModelTypes["_ValidationResult"],
	getPhotographer?:ModelTypes["Photographer"],
	listPhotographer:ModelTypes["Photographer"][],
	paginatePhotographer:ModelTypes["PhotographerConnection"],
	validateCreatePhotographer:ModelTypes["_ValidationResult"],
	validateUpdatePhotographer:ModelTypes["_ValidationResult"],
	getDefinitionItem?:ModelTypes["DefinitionItem"],
	listDefinitionItem:ModelTypes["DefinitionItem"][],
	paginateDefinitionItem:ModelTypes["DefinitionItemConnection"],
	validateCreateDefinitionItem:ModelTypes["_ValidationResult"],
	validateUpdateDefinitionItem:ModelTypes["_ValidationResult"],
	getDefinitionList?:ModelTypes["DefinitionList"],
	listDefinitionList:ModelTypes["DefinitionList"][],
	paginateDefinitionList:ModelTypes["DefinitionListConnection"],
	validateCreateDefinitionList:ModelTypes["_ValidationResult"],
	validateUpdateDefinitionList:ModelTypes["_ValidationResult"],
	getLogoItem?:ModelTypes["LogoItem"],
	listLogoItem:ModelTypes["LogoItem"][],
	paginateLogoItem:ModelTypes["LogoItemConnection"],
	validateCreateLogoItem:ModelTypes["_ValidationResult"],
	validateUpdateLogoItem:ModelTypes["_ValidationResult"],
	getLogoList?:ModelTypes["LogoList"],
	listLogoList:ModelTypes["LogoList"][],
	paginateLogoList:ModelTypes["LogoListConnection"],
	validateCreateLogoList:ModelTypes["_ValidationResult"],
	validateUpdateLogoList:ModelTypes["_ValidationResult"],
	getStrategySchema?:ModelTypes["StrategySchema"],
	listStrategySchema:ModelTypes["StrategySchema"][],
	paginateStrategySchema:ModelTypes["StrategySchemaConnection"],
	validateCreateStrategySchema:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchema:ModelTypes["_ValidationResult"],
	getStrategySchemaGroup?:ModelTypes["StrategySchemaGroup"],
	listStrategySchemaGroup:ModelTypes["StrategySchemaGroup"][],
	paginateStrategySchemaGroup:ModelTypes["StrategySchemaGroupConnection"],
	validateCreateStrategySchemaGroup:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroup:ModelTypes["_ValidationResult"],
	getStrategySchemaGroupItem?:ModelTypes["StrategySchemaGroupItem"],
	listStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItem"][],
	paginateStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemConnection"],
	validateCreateStrategySchemaGroupItem:ModelTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroupItem:ModelTypes["_ValidationResult"],
	getRedirect?:ModelTypes["Redirect"],
	listRedirect:ModelTypes["Redirect"][],
	paginateRedirect:ModelTypes["RedirectConnection"],
	validateCreateRedirect:ModelTypes["_ValidationResult"],
	validateUpdateRedirect:ModelTypes["_ValidationResult"],
	getGallery?:ModelTypes["Gallery"],
	listGallery:ModelTypes["Gallery"][],
	paginateGallery:ModelTypes["GalleryConnection"],
	validateCreateGallery:ModelTypes["_ValidationResult"],
	validateUpdateGallery:ModelTypes["_ValidationResult"],
	getGalleryItem?:ModelTypes["GalleryItem"],
	listGalleryItem:ModelTypes["GalleryItem"][],
	paginateGalleryItem:ModelTypes["GalleryItemConnection"],
	validateCreateGalleryItem:ModelTypes["_ValidationResult"],
	validateUpdateGalleryItem:ModelTypes["_ValidationResult"],
	getContactForm?:ModelTypes["ContactForm"],
	listContactForm:ModelTypes["ContactForm"][],
	paginateContactForm:ModelTypes["ContactFormConnection"],
	validateCreateContactForm:ModelTypes["_ValidationResult"],
	validateUpdateContactForm:ModelTypes["_ValidationResult"],
	getContactFormLocale?:ModelTypes["ContactFormLocale"],
	listContactFormLocale:ModelTypes["ContactFormLocale"][],
	paginateContactFormLocale:ModelTypes["ContactFormLocaleConnection"],
	validateCreateContactFormLocale:ModelTypes["_ValidationResult"],
	validateUpdateContactFormLocale:ModelTypes["_ValidationResult"],
	getContactSubscription?:ModelTypes["ContactSubscription"],
	listContactSubscription:ModelTypes["ContactSubscription"][],
	paginateContactSubscription:ModelTypes["ContactSubscriptionConnection"],
	validateCreateContactSubscription:ModelTypes["_ValidationResult"],
	validateUpdateContactSubscription:ModelTypes["_ValidationResult"],
	getContactTypeItem?:ModelTypes["ContactTypeItem"],
	listContactTypeItem:ModelTypes["ContactTypeItem"][],
	paginateContactTypeItem:ModelTypes["ContactTypeItemConnection"],
	validateCreateContactTypeItem:ModelTypes["_ValidationResult"],
	validateUpdateContactTypeItem:ModelTypes["_ValidationResult"],
	getFile?:ModelTypes["File"],
	listFile:ModelTypes["File"][],
	paginateFile:ModelTypes["FileConnection"],
	validateCreateFile:ModelTypes["_ValidationResult"],
	validateUpdateFile:ModelTypes["_ValidationResult"]
};
	["Info"]: {
		description?:string
};
	["Mutation"]: {
		createContactPage:ModelTypes["ContactPageCreateResult"],
	deleteContactPage:ModelTypes["ContactPageDeleteResult"],
	updateContactPage:ModelTypes["ContactPageUpdateResult"],
	upsertContactPage:ModelTypes["ContactPageUpsertResult"],
	createContactPageLocale:ModelTypes["ContactPageLocaleCreateResult"],
	deleteContactPageLocale:ModelTypes["ContactPageLocaleDeleteResult"],
	updateContactPageLocale:ModelTypes["ContactPageLocaleUpdateResult"],
	upsertContactPageLocale:ModelTypes["ContactPageLocaleUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLocale:ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale:ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale:ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale:ModelTypes["FooterLocaleUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createHeaderLocale:ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale:ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale:ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale:ModelTypes["HeaderLocaleUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createHomePageLocale:ModelTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale:ModelTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale:ModelTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale:ModelTypes["HomePageLocaleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createMediumItem:ModelTypes["MediumItemCreateResult"],
	deleteMediumItem:ModelTypes["MediumItemDeleteResult"],
	updateMediumItem:ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem:ModelTypes["MediumItemUpsertResult"],
	createMediumList:ModelTypes["MediumListCreateResult"],
	deleteMediumList:ModelTypes["MediumListDeleteResult"],
	updateMediumList:ModelTypes["MediumListUpdateResult"],
	upsertMediumList:ModelTypes["MediumListUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createPageLocale:ModelTypes["PageLocaleCreateResult"],
	deletePageLocale:ModelTypes["PageLocaleDeleteResult"],
	updatePageLocale:ModelTypes["PageLocaleUpdateResult"],
	upsertPageLocale:ModelTypes["PageLocaleUpsertResult"],
	createSeoDefault:ModelTypes["SeoDefaultCreateResult"],
	deleteSeoDefault:ModelTypes["SeoDefaultDeleteResult"],
	updateSeoDefault:ModelTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault:ModelTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale:ModelTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale:ModelTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale:ModelTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale:ModelTypes["SeoDefaultLocaleUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createTranslationDomain:ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain:ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain:ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain:ModelTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue:ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue:ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue:ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue:ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey:ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey:ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey:ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey:ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue:ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue:ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue:ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue:ModelTypes["TranslationValueUpsertResult"],
	createBranches:ModelTypes["BranchesCreateResult"],
	deleteBranches:ModelTypes["BranchesDeleteResult"],
	updateBranches:ModelTypes["BranchesUpdateResult"],
	upsertBranches:ModelTypes["BranchesUpsertResult"],
	createGraphicDesigner:ModelTypes["GraphicDesignerCreateResult"],
	deleteGraphicDesigner:ModelTypes["GraphicDesignerDeleteResult"],
	updateGraphicDesigner:ModelTypes["GraphicDesignerUpdateResult"],
	upsertGraphicDesigner:ModelTypes["GraphicDesignerUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createEventLocale:ModelTypes["EventLocaleCreateResult"],
	deleteEventLocale:ModelTypes["EventLocaleDeleteResult"],
	updateEventLocale:ModelTypes["EventLocaleUpdateResult"],
	upsertEventLocale:ModelTypes["EventLocaleUpsertResult"],
	createArtwork:ModelTypes["ArtworkCreateResult"],
	deleteArtwork:ModelTypes["ArtworkDeleteResult"],
	updateArtwork:ModelTypes["ArtworkUpdateResult"],
	upsertArtwork:ModelTypes["ArtworkUpsertResult"],
	createArtworkLocale:ModelTypes["ArtworkLocaleCreateResult"],
	deleteArtworkLocale:ModelTypes["ArtworkLocaleDeleteResult"],
	updateArtworkLocale:ModelTypes["ArtworkLocaleUpdateResult"],
	upsertArtworkLocale:ModelTypes["ArtworkLocaleUpsertResult"],
	createDropDownItem:ModelTypes["DropDownItemCreateResult"],
	deleteDropDownItem:ModelTypes["DropDownItemDeleteResult"],
	updateDropDownItem:ModelTypes["DropDownItemUpdateResult"],
	upsertDropDownItem:ModelTypes["DropDownItemUpsertResult"],
	createDropDownList:ModelTypes["DropDownListCreateResult"],
	deleteDropDownList:ModelTypes["DropDownListDeleteResult"],
	updateDropDownList:ModelTypes["DropDownListUpdateResult"],
	upsertDropDownList:ModelTypes["DropDownListUpsertResult"],
	createArtworkItem:ModelTypes["ArtworkItemCreateResult"],
	deleteArtworkItem:ModelTypes["ArtworkItemDeleteResult"],
	updateArtworkItem:ModelTypes["ArtworkItemUpdateResult"],
	upsertArtworkItem:ModelTypes["ArtworkItemUpsertResult"],
	createArtworkList:ModelTypes["ArtworkListCreateResult"],
	deleteArtworkList:ModelTypes["ArtworkListDeleteResult"],
	updateArtworkList:ModelTypes["ArtworkListUpdateResult"],
	upsertArtworkList:ModelTypes["ArtworkListUpsertResult"],
	createArtworkSelection:ModelTypes["ArtworkSelectionCreateResult"],
	deleteArtworkSelection:ModelTypes["ArtworkSelectionDeleteResult"],
	updateArtworkSelection:ModelTypes["ArtworkSelectionUpdateResult"],
	upsertArtworkSelection:ModelTypes["ArtworkSelectionUpsertResult"],
	createArtworkSelectionItem:ModelTypes["ArtworkSelectionItemCreateResult"],
	deleteArtworkSelectionItem:ModelTypes["ArtworkSelectionItemDeleteResult"],
	updateArtworkSelectionItem:ModelTypes["ArtworkSelectionItemUpdateResult"],
	upsertArtworkSelectionItem:ModelTypes["ArtworkSelectionItemUpsertResult"],
	createArtworkSelectionList:ModelTypes["ArtworkSelectionListCreateResult"],
	deleteArtworkSelectionList:ModelTypes["ArtworkSelectionListDeleteResult"],
	updateArtworkSelectionList:ModelTypes["ArtworkSelectionListUpdateResult"],
	upsertArtworkSelectionList:ModelTypes["ArtworkSelectionListUpsertResult"],
	createArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleCreateResult"],
	deleteArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleDeleteResult"],
	updateArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleUpdateResult"],
	upsertArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleUpsertResult"],
	createEventItem:ModelTypes["EventItemCreateResult"],
	deleteEventItem:ModelTypes["EventItemDeleteResult"],
	updateEventItem:ModelTypes["EventItemUpdateResult"],
	upsertEventItem:ModelTypes["EventItemUpsertResult"],
	createEventList:ModelTypes["EventListCreateResult"],
	deleteEventList:ModelTypes["EventListDeleteResult"],
	updateEventList:ModelTypes["EventListUpdateResult"],
	upsertEventList:ModelTypes["EventListUpsertResult"],
	createBoxItem:ModelTypes["BoxItemCreateResult"],
	deleteBoxItem:ModelTypes["BoxItemDeleteResult"],
	updateBoxItem:ModelTypes["BoxItemUpdateResult"],
	upsertBoxItem:ModelTypes["BoxItemUpsertResult"],
	createBoxList:ModelTypes["BoxListCreateResult"],
	deleteBoxList:ModelTypes["BoxListDeleteResult"],
	updateBoxList:ModelTypes["BoxListUpdateResult"],
	upsertBoxList:ModelTypes["BoxListUpsertResult"],
	createNewsletterForm:ModelTypes["NewsletterFormCreateResult"],
	deleteNewsletterForm:ModelTypes["NewsletterFormDeleteResult"],
	updateNewsletterForm:ModelTypes["NewsletterFormUpdateResult"],
	upsertNewsletterForm:ModelTypes["NewsletterFormUpsertResult"],
	createNewsletterTypeItem:ModelTypes["NewsletterTypeItemCreateResult"],
	deleteNewsletterTypeItem:ModelTypes["NewsletterTypeItemDeleteResult"],
	updateNewsletterTypeItem:ModelTypes["NewsletterTypeItemUpdateResult"],
	upsertNewsletterTypeItem:ModelTypes["NewsletterTypeItemUpsertResult"],
	createNewsletterFormLocale:ModelTypes["NewsletterFormLocaleCreateResult"],
	deleteNewsletterFormLocale:ModelTypes["NewsletterFormLocaleDeleteResult"],
	updateNewsletterFormLocale:ModelTypes["NewsletterFormLocaleUpdateResult"],
	upsertNewsletterFormLocale:ModelTypes["NewsletterFormLocaleUpsertResult"],
	createNewsletterSubscription:ModelTypes["NewsletterSubscriptionCreateResult"],
	deleteNewsletterSubscription:ModelTypes["NewsletterSubscriptionDeleteResult"],
	updateNewsletterSubscription:ModelTypes["NewsletterSubscriptionUpdateResult"],
	upsertNewsletterSubscription:ModelTypes["NewsletterSubscriptionUpsertResult"],
	createChart:ModelTypes["ChartCreateResult"],
	deleteChart:ModelTypes["ChartDeleteResult"],
	updateChart:ModelTypes["ChartUpdateResult"],
	upsertChart:ModelTypes["ChartUpsertResult"],
	createChartData:ModelTypes["ChartDataCreateResult"],
	deleteChartData:ModelTypes["ChartDataDeleteResult"],
	updateChartData:ModelTypes["ChartDataUpdateResult"],
	upsertChartData:ModelTypes["ChartDataUpsertResult"],
	createEmployee:ModelTypes["EmployeeCreateResult"],
	deleteEmployee:ModelTypes["EmployeeDeleteResult"],
	updateEmployee:ModelTypes["EmployeeUpdateResult"],
	upsertEmployee:ModelTypes["EmployeeUpsertResult"],
	createEmployeeItem:ModelTypes["EmployeeItemCreateResult"],
	deleteEmployeeItem:ModelTypes["EmployeeItemDeleteResult"],
	updateEmployeeItem:ModelTypes["EmployeeItemUpdateResult"],
	upsertEmployeeItem:ModelTypes["EmployeeItemUpsertResult"],
	createEmployeeList:ModelTypes["EmployeeListCreateResult"],
	deleteEmployeeList:ModelTypes["EmployeeListDeleteResult"],
	updateEmployeeList:ModelTypes["EmployeeListUpdateResult"],
	upsertEmployeeList:ModelTypes["EmployeeListUpsertResult"],
	createEmployeeLocale:ModelTypes["EmployeeLocaleCreateResult"],
	deleteEmployeeLocale:ModelTypes["EmployeeLocaleDeleteResult"],
	updateEmployeeLocale:ModelTypes["EmployeeLocaleUpdateResult"],
	upsertEmployeeLocale:ModelTypes["EmployeeLocaleUpsertResult"],
	createPhotographer:ModelTypes["PhotographerCreateResult"],
	deletePhotographer:ModelTypes["PhotographerDeleteResult"],
	updatePhotographer:ModelTypes["PhotographerUpdateResult"],
	upsertPhotographer:ModelTypes["PhotographerUpsertResult"],
	createDefinitionItem:ModelTypes["DefinitionItemCreateResult"],
	deleteDefinitionItem:ModelTypes["DefinitionItemDeleteResult"],
	updateDefinitionItem:ModelTypes["DefinitionItemUpdateResult"],
	upsertDefinitionItem:ModelTypes["DefinitionItemUpsertResult"],
	createDefinitionList:ModelTypes["DefinitionListCreateResult"],
	deleteDefinitionList:ModelTypes["DefinitionListDeleteResult"],
	updateDefinitionList:ModelTypes["DefinitionListUpdateResult"],
	upsertDefinitionList:ModelTypes["DefinitionListUpsertResult"],
	createLogoItem:ModelTypes["LogoItemCreateResult"],
	deleteLogoItem:ModelTypes["LogoItemDeleteResult"],
	updateLogoItem:ModelTypes["LogoItemUpdateResult"],
	upsertLogoItem:ModelTypes["LogoItemUpsertResult"],
	createLogoList:ModelTypes["LogoListCreateResult"],
	deleteLogoList:ModelTypes["LogoListDeleteResult"],
	updateLogoList:ModelTypes["LogoListUpdateResult"],
	upsertLogoList:ModelTypes["LogoListUpsertResult"],
	createStrategySchema:ModelTypes["StrategySchemaCreateResult"],
	deleteStrategySchema:ModelTypes["StrategySchemaDeleteResult"],
	updateStrategySchema:ModelTypes["StrategySchemaUpdateResult"],
	upsertStrategySchema:ModelTypes["StrategySchemaUpsertResult"],
	createStrategySchemaGroup:ModelTypes["StrategySchemaGroupCreateResult"],
	deleteStrategySchemaGroup:ModelTypes["StrategySchemaGroupDeleteResult"],
	updateStrategySchemaGroup:ModelTypes["StrategySchemaGroupUpdateResult"],
	upsertStrategySchemaGroup:ModelTypes["StrategySchemaGroupUpsertResult"],
	createStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemCreateResult"],
	deleteStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemDeleteResult"],
	updateStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemUpdateResult"],
	upsertStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createContactForm:ModelTypes["ContactFormCreateResult"],
	deleteContactForm:ModelTypes["ContactFormDeleteResult"],
	updateContactForm:ModelTypes["ContactFormUpdateResult"],
	upsertContactForm:ModelTypes["ContactFormUpsertResult"],
	createContactFormLocale:ModelTypes["ContactFormLocaleCreateResult"],
	deleteContactFormLocale:ModelTypes["ContactFormLocaleDeleteResult"],
	updateContactFormLocale:ModelTypes["ContactFormLocaleUpdateResult"],
	upsertContactFormLocale:ModelTypes["ContactFormLocaleUpsertResult"],
	createContactSubscription:ModelTypes["ContactSubscriptionCreateResult"],
	deleteContactSubscription:ModelTypes["ContactSubscriptionDeleteResult"],
	updateContactSubscription:ModelTypes["ContactSubscriptionUpdateResult"],
	upsertContactSubscription:ModelTypes["ContactSubscriptionUpsertResult"],
	createContactTypeItem:ModelTypes["ContactTypeItemCreateResult"],
	deleteContactTypeItem:ModelTypes["ContactTypeItemDeleteResult"],
	updateContactTypeItem:ModelTypes["ContactTypeItemUpdateResult"],
	upsertContactTypeItem:ModelTypes["ContactTypeItemUpsertResult"],
	createFile:ModelTypes["FileCreateResult"],
	deleteFile:ModelTypes["FileDeleteResult"],
	updateFile:ModelTypes["FileUpdateResult"],
	upsertFile:ModelTypes["FileUpsertResult"],
	transaction:ModelTypes["MutationTransaction"],
	query:ModelTypes["Query"],
	generateUploadUrl:ModelTypes["S3SignedUpload"],
	generateReadUrl:ModelTypes["S3SignedRead"]
};
	["ContactPageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationResult"]: ModelTypes["ContactPageCreateResult"] | ModelTypes["ContactPageDeleteResult"] | ModelTypes["ContactPageUpdateResult"] | ModelTypes["ContactPageUpsertResult"] | ModelTypes["ContactPageLocaleCreateResult"] | ModelTypes["ContactPageLocaleDeleteResult"] | ModelTypes["ContactPageLocaleUpdateResult"] | ModelTypes["ContactPageLocaleUpsertResult"] | ModelTypes["ContentCreateResult"] | ModelTypes["ContentDeleteResult"] | ModelTypes["ContentUpdateResult"] | ModelTypes["ContentUpsertResult"] | ModelTypes["ContentBlockCreateResult"] | ModelTypes["ContentBlockDeleteResult"] | ModelTypes["ContentBlockUpdateResult"] | ModelTypes["ContentBlockUpsertResult"] | ModelTypes["ContentReferenceCreateResult"] | ModelTypes["ContentReferenceDeleteResult"] | ModelTypes["ContentReferenceUpdateResult"] | ModelTypes["ContentReferenceUpsertResult"] | ModelTypes["FooterCreateResult"] | ModelTypes["FooterDeleteResult"] | ModelTypes["FooterUpdateResult"] | ModelTypes["FooterUpsertResult"] | ModelTypes["FooterLocaleCreateResult"] | ModelTypes["FooterLocaleDeleteResult"] | ModelTypes["FooterLocaleUpdateResult"] | ModelTypes["FooterLocaleUpsertResult"] | ModelTypes["HeaderCreateResult"] | ModelTypes["HeaderDeleteResult"] | ModelTypes["HeaderUpdateResult"] | ModelTypes["HeaderUpsertResult"] | ModelTypes["HeaderLinkCreateResult"] | ModelTypes["HeaderLinkDeleteResult"] | ModelTypes["HeaderLinkUpdateResult"] | ModelTypes["HeaderLinkUpsertResult"] | ModelTypes["HeaderLocaleCreateResult"] | ModelTypes["HeaderLocaleDeleteResult"] | ModelTypes["HeaderLocaleUpdateResult"] | ModelTypes["HeaderLocaleUpsertResult"] | ModelTypes["HomePageCreateResult"] | ModelTypes["HomePageDeleteResult"] | ModelTypes["HomePageUpdateResult"] | ModelTypes["HomePageUpsertResult"] | ModelTypes["HomePageLocaleCreateResult"] | ModelTypes["HomePageLocaleDeleteResult"] | ModelTypes["HomePageLocaleUpdateResult"] | ModelTypes["HomePageLocaleUpsertResult"] | ModelTypes["LinkCreateResult"] | ModelTypes["LinkDeleteResult"] | ModelTypes["LinkUpdateResult"] | ModelTypes["LinkUpsertResult"] | ModelTypes["LinkableCreateResult"] | ModelTypes["LinkableDeleteResult"] | ModelTypes["LinkableUpdateResult"] | ModelTypes["LinkableUpsertResult"] | ModelTypes["LocaleCreateResult"] | ModelTypes["LocaleDeleteResult"] | ModelTypes["LocaleUpdateResult"] | ModelTypes["LocaleUpsertResult"] | ModelTypes["MediumCreateResult"] | ModelTypes["MediumDeleteResult"] | ModelTypes["MediumUpdateResult"] | ModelTypes["MediumUpsertResult"] | ModelTypes["MediumItemCreateResult"] | ModelTypes["MediumItemDeleteResult"] | ModelTypes["MediumItemUpdateResult"] | ModelTypes["MediumItemUpsertResult"] | ModelTypes["MediumListCreateResult"] | ModelTypes["MediumListDeleteResult"] | ModelTypes["MediumListUpdateResult"] | ModelTypes["MediumListUpsertResult"] | ModelTypes["PageCreateResult"] | ModelTypes["PageDeleteResult"] | ModelTypes["PageUpdateResult"] | ModelTypes["PageUpsertResult"] | ModelTypes["PageLocaleCreateResult"] | ModelTypes["PageLocaleDeleteResult"] | ModelTypes["PageLocaleUpdateResult"] | ModelTypes["PageLocaleUpsertResult"] | ModelTypes["SeoDefaultCreateResult"] | ModelTypes["SeoDefaultDeleteResult"] | ModelTypes["SeoDefaultUpdateResult"] | ModelTypes["SeoDefaultUpsertResult"] | ModelTypes["SeoDefaultLocaleCreateResult"] | ModelTypes["SeoDefaultLocaleDeleteResult"] | ModelTypes["SeoDefaultLocaleUpdateResult"] | ModelTypes["SeoDefaultLocaleUpsertResult"] | ModelTypes["VideoCreateResult"] | ModelTypes["VideoDeleteResult"] | ModelTypes["VideoUpdateResult"] | ModelTypes["VideoUpsertResult"] | ModelTypes["ImageCreateResult"] | ModelTypes["ImageDeleteResult"] | ModelTypes["ImageUpdateResult"] | ModelTypes["ImageUpsertResult"] | ModelTypes["SeoCreateResult"] | ModelTypes["SeoDeleteResult"] | ModelTypes["SeoUpdateResult"] | ModelTypes["SeoUpsertResult"] | ModelTypes["TranslationDomainCreateResult"] | ModelTypes["TranslationDomainDeleteResult"] | ModelTypes["TranslationDomainUpdateResult"] | ModelTypes["TranslationDomainUpsertResult"] | ModelTypes["TranslationCatalogueCreateResult"] | ModelTypes["TranslationCatalogueDeleteResult"] | ModelTypes["TranslationCatalogueUpdateResult"] | ModelTypes["TranslationCatalogueUpsertResult"] | ModelTypes["TranslationCataloguesIdentifierCreateResult"] | ModelTypes["TranslationCataloguesIdentifierDeleteResult"] | ModelTypes["TranslationCataloguesIdentifierUpdateResult"] | ModelTypes["TranslationCataloguesIdentifierUpsertResult"] | ModelTypes["TranslationKeyCreateResult"] | ModelTypes["TranslationKeyDeleteResult"] | ModelTypes["TranslationKeyUpdateResult"] | ModelTypes["TranslationKeyUpsertResult"] | ModelTypes["TranslationValueCreateResult"] | ModelTypes["TranslationValueDeleteResult"] | ModelTypes["TranslationValueUpdateResult"] | ModelTypes["TranslationValueUpsertResult"] | ModelTypes["BranchesCreateResult"] | ModelTypes["BranchesDeleteResult"] | ModelTypes["BranchesUpdateResult"] | ModelTypes["BranchesUpsertResult"] | ModelTypes["GraphicDesignerCreateResult"] | ModelTypes["GraphicDesignerDeleteResult"] | ModelTypes["GraphicDesignerUpdateResult"] | ModelTypes["GraphicDesignerUpsertResult"] | ModelTypes["EventCreateResult"] | ModelTypes["EventDeleteResult"] | ModelTypes["EventUpdateResult"] | ModelTypes["EventUpsertResult"] | ModelTypes["EventLocaleCreateResult"] | ModelTypes["EventLocaleDeleteResult"] | ModelTypes["EventLocaleUpdateResult"] | ModelTypes["EventLocaleUpsertResult"] | ModelTypes["ArtworkCreateResult"] | ModelTypes["ArtworkDeleteResult"] | ModelTypes["ArtworkUpdateResult"] | ModelTypes["ArtworkUpsertResult"] | ModelTypes["ArtworkLocaleCreateResult"] | ModelTypes["ArtworkLocaleDeleteResult"] | ModelTypes["ArtworkLocaleUpdateResult"] | ModelTypes["ArtworkLocaleUpsertResult"] | ModelTypes["DropDownItemCreateResult"] | ModelTypes["DropDownItemDeleteResult"] | ModelTypes["DropDownItemUpdateResult"] | ModelTypes["DropDownItemUpsertResult"] | ModelTypes["DropDownListCreateResult"] | ModelTypes["DropDownListDeleteResult"] | ModelTypes["DropDownListUpdateResult"] | ModelTypes["DropDownListUpsertResult"] | ModelTypes["ArtworkItemCreateResult"] | ModelTypes["ArtworkItemDeleteResult"] | ModelTypes["ArtworkItemUpdateResult"] | ModelTypes["ArtworkItemUpsertResult"] | ModelTypes["ArtworkListCreateResult"] | ModelTypes["ArtworkListDeleteResult"] | ModelTypes["ArtworkListUpdateResult"] | ModelTypes["ArtworkListUpsertResult"] | ModelTypes["ArtworkSelectionCreateResult"] | ModelTypes["ArtworkSelectionDeleteResult"] | ModelTypes["ArtworkSelectionUpdateResult"] | ModelTypes["ArtworkSelectionUpsertResult"] | ModelTypes["ArtworkSelectionItemCreateResult"] | ModelTypes["ArtworkSelectionItemDeleteResult"] | ModelTypes["ArtworkSelectionItemUpdateResult"] | ModelTypes["ArtworkSelectionItemUpsertResult"] | ModelTypes["ArtworkSelectionListCreateResult"] | ModelTypes["ArtworkSelectionListDeleteResult"] | ModelTypes["ArtworkSelectionListUpdateResult"] | ModelTypes["ArtworkSelectionListUpsertResult"] | ModelTypes["ArtworkSelectionLocaleCreateResult"] | ModelTypes["ArtworkSelectionLocaleDeleteResult"] | ModelTypes["ArtworkSelectionLocaleUpdateResult"] | ModelTypes["ArtworkSelectionLocaleUpsertResult"] | ModelTypes["EventItemCreateResult"] | ModelTypes["EventItemDeleteResult"] | ModelTypes["EventItemUpdateResult"] | ModelTypes["EventItemUpsertResult"] | ModelTypes["EventListCreateResult"] | ModelTypes["EventListDeleteResult"] | ModelTypes["EventListUpdateResult"] | ModelTypes["EventListUpsertResult"] | ModelTypes["BoxItemCreateResult"] | ModelTypes["BoxItemDeleteResult"] | ModelTypes["BoxItemUpdateResult"] | ModelTypes["BoxItemUpsertResult"] | ModelTypes["BoxListCreateResult"] | ModelTypes["BoxListDeleteResult"] | ModelTypes["BoxListUpdateResult"] | ModelTypes["BoxListUpsertResult"] | ModelTypes["NewsletterFormCreateResult"] | ModelTypes["NewsletterFormDeleteResult"] | ModelTypes["NewsletterFormUpdateResult"] | ModelTypes["NewsletterFormUpsertResult"] | ModelTypes["NewsletterTypeItemCreateResult"] | ModelTypes["NewsletterTypeItemDeleteResult"] | ModelTypes["NewsletterTypeItemUpdateResult"] | ModelTypes["NewsletterTypeItemUpsertResult"] | ModelTypes["NewsletterFormLocaleCreateResult"] | ModelTypes["NewsletterFormLocaleDeleteResult"] | ModelTypes["NewsletterFormLocaleUpdateResult"] | ModelTypes["NewsletterFormLocaleUpsertResult"] | ModelTypes["NewsletterSubscriptionCreateResult"] | ModelTypes["NewsletterSubscriptionDeleteResult"] | ModelTypes["NewsletterSubscriptionUpdateResult"] | ModelTypes["NewsletterSubscriptionUpsertResult"] | ModelTypes["ChartCreateResult"] | ModelTypes["ChartDeleteResult"] | ModelTypes["ChartUpdateResult"] | ModelTypes["ChartUpsertResult"] | ModelTypes["ChartDataCreateResult"] | ModelTypes["ChartDataDeleteResult"] | ModelTypes["ChartDataUpdateResult"] | ModelTypes["ChartDataUpsertResult"] | ModelTypes["EmployeeCreateResult"] | ModelTypes["EmployeeDeleteResult"] | ModelTypes["EmployeeUpdateResult"] | ModelTypes["EmployeeUpsertResult"] | ModelTypes["EmployeeItemCreateResult"] | ModelTypes["EmployeeItemDeleteResult"] | ModelTypes["EmployeeItemUpdateResult"] | ModelTypes["EmployeeItemUpsertResult"] | ModelTypes["EmployeeListCreateResult"] | ModelTypes["EmployeeListDeleteResult"] | ModelTypes["EmployeeListUpdateResult"] | ModelTypes["EmployeeListUpsertResult"] | ModelTypes["EmployeeLocaleCreateResult"] | ModelTypes["EmployeeLocaleDeleteResult"] | ModelTypes["EmployeeLocaleUpdateResult"] | ModelTypes["EmployeeLocaleUpsertResult"] | ModelTypes["PhotographerCreateResult"] | ModelTypes["PhotographerDeleteResult"] | ModelTypes["PhotographerUpdateResult"] | ModelTypes["PhotographerUpsertResult"] | ModelTypes["DefinitionItemCreateResult"] | ModelTypes["DefinitionItemDeleteResult"] | ModelTypes["DefinitionItemUpdateResult"] | ModelTypes["DefinitionItemUpsertResult"] | ModelTypes["DefinitionListCreateResult"] | ModelTypes["DefinitionListDeleteResult"] | ModelTypes["DefinitionListUpdateResult"] | ModelTypes["DefinitionListUpsertResult"] | ModelTypes["LogoItemCreateResult"] | ModelTypes["LogoItemDeleteResult"] | ModelTypes["LogoItemUpdateResult"] | ModelTypes["LogoItemUpsertResult"] | ModelTypes["LogoListCreateResult"] | ModelTypes["LogoListDeleteResult"] | ModelTypes["LogoListUpdateResult"] | ModelTypes["LogoListUpsertResult"] | ModelTypes["StrategySchemaCreateResult"] | ModelTypes["StrategySchemaDeleteResult"] | ModelTypes["StrategySchemaUpdateResult"] | ModelTypes["StrategySchemaUpsertResult"] | ModelTypes["StrategySchemaGroupCreateResult"] | ModelTypes["StrategySchemaGroupDeleteResult"] | ModelTypes["StrategySchemaGroupUpdateResult"] | ModelTypes["StrategySchemaGroupUpsertResult"] | ModelTypes["StrategySchemaGroupItemCreateResult"] | ModelTypes["StrategySchemaGroupItemDeleteResult"] | ModelTypes["StrategySchemaGroupItemUpdateResult"] | ModelTypes["StrategySchemaGroupItemUpsertResult"] | ModelTypes["RedirectCreateResult"] | ModelTypes["RedirectDeleteResult"] | ModelTypes["RedirectUpdateResult"] | ModelTypes["RedirectUpsertResult"] | ModelTypes["GalleryCreateResult"] | ModelTypes["GalleryDeleteResult"] | ModelTypes["GalleryUpdateResult"] | ModelTypes["GalleryUpsertResult"] | ModelTypes["GalleryItemCreateResult"] | ModelTypes["GalleryItemDeleteResult"] | ModelTypes["GalleryItemUpdateResult"] | ModelTypes["GalleryItemUpsertResult"] | ModelTypes["ContactFormCreateResult"] | ModelTypes["ContactFormDeleteResult"] | ModelTypes["ContactFormUpdateResult"] | ModelTypes["ContactFormUpsertResult"] | ModelTypes["ContactFormLocaleCreateResult"] | ModelTypes["ContactFormLocaleDeleteResult"] | ModelTypes["ContactFormLocaleUpdateResult"] | ModelTypes["ContactFormLocaleUpsertResult"] | ModelTypes["ContactSubscriptionCreateResult"] | ModelTypes["ContactSubscriptionDeleteResult"] | ModelTypes["ContactSubscriptionUpdateResult"] | ModelTypes["ContactSubscriptionUpsertResult"] | ModelTypes["ContactTypeItemCreateResult"] | ModelTypes["ContactTypeItemDeleteResult"] | ModelTypes["ContactTypeItemUpdateResult"] | ModelTypes["ContactTypeItemUpsertResult"] | ModelTypes["FileCreateResult"] | ModelTypes["FileDeleteResult"] | ModelTypes["FileUpdateResult"] | ModelTypes["FileUpsertResult"];
	["_MutationError"]: {
		path:ModelTypes["_PathFragment"][],
	paths:ModelTypes["_PathFragment"][],
	type:ModelTypes["_MutationErrorType"],
	message?:string
};
	["_MutationErrorType"]: GraphQLTypes["_MutationErrorType"];
	["ContactPageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"]
};
	["ContactPageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPage"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPageLocale"]
};
	["ContactPageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactPageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactPageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"]
};
	["ContentUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Content"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentBlock"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContentReference"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"]
};
	["FooterUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Footer"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"]
};
	["FooterLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["FooterLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"]
};
	["HeaderUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Header"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLink"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"]
};
	["HeaderLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HeaderLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePage"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageLocale"]
};
	["HomePageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["HomePageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["HomePageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"]
};
	["LinkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Link"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Linkable"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"]
};
	["LocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Locale"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"]
};
	["MediumUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Medium"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumItem"]
};
	["MediumItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumList"]
};
	["MediumListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumList"],
	validation:ModelTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["MediumList"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"]
};
	["PageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Page"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"]
};
	["PageLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["PageLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefault"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefault"]
};
	["SeoDefaultUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefault"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefault"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefaultLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefaultLocale"]
};
	["SeoDefaultLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefaultLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDefaultLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["SeoDefaultLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"]
};
	["VideoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Video"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"]
};
	["ImageUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Image"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"]
};
	["SeoUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Seo"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"]
};
	["TranslationDomainUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationDomain"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"]
};
	["TranslationCatalogueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCatalogue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationCataloguesIdentifier"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"]
};
	["TranslationKeyUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationKey"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"]
};
	["TranslationValueUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["TranslationValue"],
	validation:ModelTypes["_ValidationResult"]
};
	["BranchesCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Branches"],
	validation:ModelTypes["_ValidationResult"]
};
	["BranchesDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Branches"]
};
	["BranchesUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Branches"],
	validation:ModelTypes["_ValidationResult"]
};
	["BranchesUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Branches"],
	validation:ModelTypes["_ValidationResult"]
};
	["GraphicDesignerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GraphicDesigner"],
	validation:ModelTypes["_ValidationResult"]
};
	["GraphicDesignerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GraphicDesigner"]
};
	["GraphicDesignerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GraphicDesigner"],
	validation:ModelTypes["_ValidationResult"]
};
	["GraphicDesignerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GraphicDesigner"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"]
};
	["EventUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Event"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"]
};
	["EventLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Artwork"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Artwork"]
};
	["ArtworkUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Artwork"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Artwork"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkLocale"]
};
	["ArtworkLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownItem"]
};
	["DropDownItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownList"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownList"]
};
	["DropDownListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownList"],
	validation:ModelTypes["_ValidationResult"]
};
	["DropDownListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DropDownList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkItem"]
};
	["ArtworkItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkList"]
};
	["ArtworkListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelection"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelection"]
};
	["ArtworkSelectionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelection"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelection"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionItem"]
};
	["ArtworkSelectionItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionList"]
};
	["ArtworkSelectionListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionLocale"]
};
	["ArtworkSelectionLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ArtworkSelectionLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventItem"]
};
	["EventItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventList"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventList"]
};
	["EventListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventList"],
	validation:ModelTypes["_ValidationResult"]
};
	["EventListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EventList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxItem"]
};
	["BoxItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxList"]
};
	["BoxListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxList"],
	validation:ModelTypes["_ValidationResult"]
};
	["BoxListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["BoxList"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterForm"]
};
	["NewsletterFormUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterTypeItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterTypeItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterTypeItem"]
};
	["NewsletterTypeItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterTypeItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterFormLocale"]
};
	["NewsletterFormLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterFormLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSubscriptionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSubscriptionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSubscription"]
};
	["NewsletterSubscriptionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["NewsletterSubscriptionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["NewsletterSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Chart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Chart"]
};
	["ChartUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Chart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Chart"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartDataCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ChartData"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartDataDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ChartData"]
};
	["ChartDataUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ChartData"],
	validation:ModelTypes["_ValidationResult"]
};
	["ChartDataUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ChartData"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Employee"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Employee"]
};
	["EmployeeUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Employee"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Employee"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeItem"]
};
	["EmployeeItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeList"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeList"]
};
	["EmployeeListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeList"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeList"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeLocale"]
};
	["EmployeeLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["EmployeeLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["EmployeeLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"]
};
	["PhotographerUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["PhotographerUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Photographer"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionItem"]
};
	["DefinitionItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionList"]
};
	["DefinitionListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["DefinitionListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["DefinitionList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoItem"]
};
	["LogoItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoListCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoListDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoList"]
};
	["LogoListUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["LogoListUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["LogoList"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchema"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchema"]
};
	["StrategySchemaUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchema"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchema"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroup"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroupItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroupItem"]
};
	["StrategySchemaGroupItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroupItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["StrategySchemaGroupItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Redirect"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["Gallery"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["GalleryItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactForm"]
};
	["ContactFormUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactForm"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormLocaleCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormLocaleDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormLocale"]
};
	["ContactFormLocaleUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactFormLocaleUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactFormLocale"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubscriptionCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubscriptionDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubscription"]
};
	["ContactSubscriptionUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactSubscriptionUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactSubscription"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactTypeItemCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactTypeItemDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactTypeItem"]
};
	["ContactTypeItemUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["ContactTypeItemUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["ContactTypeItem"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"]
};
	["FileUpdateResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	node?:ModelTypes["File"],
	validation:ModelTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
		ok:boolean,
	errorMessage?:string,
	errors:ModelTypes["_MutationError"][],
	validation:ModelTypes["_ValidationResult"],
	createContactPage:ModelTypes["ContactPageCreateResult"],
	deleteContactPage:ModelTypes["ContactPageDeleteResult"],
	updateContactPage:ModelTypes["ContactPageUpdateResult"],
	upsertContactPage:ModelTypes["ContactPageUpsertResult"],
	createContactPageLocale:ModelTypes["ContactPageLocaleCreateResult"],
	deleteContactPageLocale:ModelTypes["ContactPageLocaleDeleteResult"],
	updateContactPageLocale:ModelTypes["ContactPageLocaleUpdateResult"],
	upsertContactPageLocale:ModelTypes["ContactPageLocaleUpsertResult"],
	createContent:ModelTypes["ContentCreateResult"],
	deleteContent:ModelTypes["ContentDeleteResult"],
	updateContent:ModelTypes["ContentUpdateResult"],
	upsertContent:ModelTypes["ContentUpsertResult"],
	createContentBlock:ModelTypes["ContentBlockCreateResult"],
	deleteContentBlock:ModelTypes["ContentBlockDeleteResult"],
	updateContentBlock:ModelTypes["ContentBlockUpdateResult"],
	upsertContentBlock:ModelTypes["ContentBlockUpsertResult"],
	createContentReference:ModelTypes["ContentReferenceCreateResult"],
	deleteContentReference:ModelTypes["ContentReferenceDeleteResult"],
	updateContentReference:ModelTypes["ContentReferenceUpdateResult"],
	upsertContentReference:ModelTypes["ContentReferenceUpsertResult"],
	createFooter:ModelTypes["FooterCreateResult"],
	deleteFooter:ModelTypes["FooterDeleteResult"],
	updateFooter:ModelTypes["FooterUpdateResult"],
	upsertFooter:ModelTypes["FooterUpsertResult"],
	createFooterLocale:ModelTypes["FooterLocaleCreateResult"],
	deleteFooterLocale:ModelTypes["FooterLocaleDeleteResult"],
	updateFooterLocale:ModelTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale:ModelTypes["FooterLocaleUpsertResult"],
	createHeader:ModelTypes["HeaderCreateResult"],
	deleteHeader:ModelTypes["HeaderDeleteResult"],
	updateHeader:ModelTypes["HeaderUpdateResult"],
	upsertHeader:ModelTypes["HeaderUpsertResult"],
	createHeaderLink:ModelTypes["HeaderLinkCreateResult"],
	deleteHeaderLink:ModelTypes["HeaderLinkDeleteResult"],
	updateHeaderLink:ModelTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink:ModelTypes["HeaderLinkUpsertResult"],
	createHeaderLocale:ModelTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale:ModelTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale:ModelTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale:ModelTypes["HeaderLocaleUpsertResult"],
	createHomePage:ModelTypes["HomePageCreateResult"],
	deleteHomePage:ModelTypes["HomePageDeleteResult"],
	updateHomePage:ModelTypes["HomePageUpdateResult"],
	upsertHomePage:ModelTypes["HomePageUpsertResult"],
	createHomePageLocale:ModelTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale:ModelTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale:ModelTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale:ModelTypes["HomePageLocaleUpsertResult"],
	createLink:ModelTypes["LinkCreateResult"],
	deleteLink:ModelTypes["LinkDeleteResult"],
	updateLink:ModelTypes["LinkUpdateResult"],
	upsertLink:ModelTypes["LinkUpsertResult"],
	createLinkable:ModelTypes["LinkableCreateResult"],
	deleteLinkable:ModelTypes["LinkableDeleteResult"],
	updateLinkable:ModelTypes["LinkableUpdateResult"],
	upsertLinkable:ModelTypes["LinkableUpsertResult"],
	createLocale:ModelTypes["LocaleCreateResult"],
	deleteLocale:ModelTypes["LocaleDeleteResult"],
	updateLocale:ModelTypes["LocaleUpdateResult"],
	upsertLocale:ModelTypes["LocaleUpsertResult"],
	createMedium:ModelTypes["MediumCreateResult"],
	deleteMedium:ModelTypes["MediumDeleteResult"],
	updateMedium:ModelTypes["MediumUpdateResult"],
	upsertMedium:ModelTypes["MediumUpsertResult"],
	createMediumItem:ModelTypes["MediumItemCreateResult"],
	deleteMediumItem:ModelTypes["MediumItemDeleteResult"],
	updateMediumItem:ModelTypes["MediumItemUpdateResult"],
	upsertMediumItem:ModelTypes["MediumItemUpsertResult"],
	createMediumList:ModelTypes["MediumListCreateResult"],
	deleteMediumList:ModelTypes["MediumListDeleteResult"],
	updateMediumList:ModelTypes["MediumListUpdateResult"],
	upsertMediumList:ModelTypes["MediumListUpsertResult"],
	createPage:ModelTypes["PageCreateResult"],
	deletePage:ModelTypes["PageDeleteResult"],
	updatePage:ModelTypes["PageUpdateResult"],
	upsertPage:ModelTypes["PageUpsertResult"],
	createPageLocale:ModelTypes["PageLocaleCreateResult"],
	deletePageLocale:ModelTypes["PageLocaleDeleteResult"],
	updatePageLocale:ModelTypes["PageLocaleUpdateResult"],
	upsertPageLocale:ModelTypes["PageLocaleUpsertResult"],
	createSeoDefault:ModelTypes["SeoDefaultCreateResult"],
	deleteSeoDefault:ModelTypes["SeoDefaultDeleteResult"],
	updateSeoDefault:ModelTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault:ModelTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale:ModelTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale:ModelTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale:ModelTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale:ModelTypes["SeoDefaultLocaleUpsertResult"],
	createVideo:ModelTypes["VideoCreateResult"],
	deleteVideo:ModelTypes["VideoDeleteResult"],
	updateVideo:ModelTypes["VideoUpdateResult"],
	upsertVideo:ModelTypes["VideoUpsertResult"],
	createImage:ModelTypes["ImageCreateResult"],
	deleteImage:ModelTypes["ImageDeleteResult"],
	updateImage:ModelTypes["ImageUpdateResult"],
	upsertImage:ModelTypes["ImageUpsertResult"],
	createSeo:ModelTypes["SeoCreateResult"],
	deleteSeo:ModelTypes["SeoDeleteResult"],
	updateSeo:ModelTypes["SeoUpdateResult"],
	upsertSeo:ModelTypes["SeoUpsertResult"],
	createTranslationDomain:ModelTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain:ModelTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain:ModelTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain:ModelTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue:ModelTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue:ModelTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue:ModelTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue:ModelTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier:ModelTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey:ModelTypes["TranslationKeyCreateResult"],
	deleteTranslationKey:ModelTypes["TranslationKeyDeleteResult"],
	updateTranslationKey:ModelTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey:ModelTypes["TranslationKeyUpsertResult"],
	createTranslationValue:ModelTypes["TranslationValueCreateResult"],
	deleteTranslationValue:ModelTypes["TranslationValueDeleteResult"],
	updateTranslationValue:ModelTypes["TranslationValueUpdateResult"],
	upsertTranslationValue:ModelTypes["TranslationValueUpsertResult"],
	createBranches:ModelTypes["BranchesCreateResult"],
	deleteBranches:ModelTypes["BranchesDeleteResult"],
	updateBranches:ModelTypes["BranchesUpdateResult"],
	upsertBranches:ModelTypes["BranchesUpsertResult"],
	createGraphicDesigner:ModelTypes["GraphicDesignerCreateResult"],
	deleteGraphicDesigner:ModelTypes["GraphicDesignerDeleteResult"],
	updateGraphicDesigner:ModelTypes["GraphicDesignerUpdateResult"],
	upsertGraphicDesigner:ModelTypes["GraphicDesignerUpsertResult"],
	createEvent:ModelTypes["EventCreateResult"],
	deleteEvent:ModelTypes["EventDeleteResult"],
	updateEvent:ModelTypes["EventUpdateResult"],
	upsertEvent:ModelTypes["EventUpsertResult"],
	createEventLocale:ModelTypes["EventLocaleCreateResult"],
	deleteEventLocale:ModelTypes["EventLocaleDeleteResult"],
	updateEventLocale:ModelTypes["EventLocaleUpdateResult"],
	upsertEventLocale:ModelTypes["EventLocaleUpsertResult"],
	createArtwork:ModelTypes["ArtworkCreateResult"],
	deleteArtwork:ModelTypes["ArtworkDeleteResult"],
	updateArtwork:ModelTypes["ArtworkUpdateResult"],
	upsertArtwork:ModelTypes["ArtworkUpsertResult"],
	createArtworkLocale:ModelTypes["ArtworkLocaleCreateResult"],
	deleteArtworkLocale:ModelTypes["ArtworkLocaleDeleteResult"],
	updateArtworkLocale:ModelTypes["ArtworkLocaleUpdateResult"],
	upsertArtworkLocale:ModelTypes["ArtworkLocaleUpsertResult"],
	createDropDownItem:ModelTypes["DropDownItemCreateResult"],
	deleteDropDownItem:ModelTypes["DropDownItemDeleteResult"],
	updateDropDownItem:ModelTypes["DropDownItemUpdateResult"],
	upsertDropDownItem:ModelTypes["DropDownItemUpsertResult"],
	createDropDownList:ModelTypes["DropDownListCreateResult"],
	deleteDropDownList:ModelTypes["DropDownListDeleteResult"],
	updateDropDownList:ModelTypes["DropDownListUpdateResult"],
	upsertDropDownList:ModelTypes["DropDownListUpsertResult"],
	createArtworkItem:ModelTypes["ArtworkItemCreateResult"],
	deleteArtworkItem:ModelTypes["ArtworkItemDeleteResult"],
	updateArtworkItem:ModelTypes["ArtworkItemUpdateResult"],
	upsertArtworkItem:ModelTypes["ArtworkItemUpsertResult"],
	createArtworkList:ModelTypes["ArtworkListCreateResult"],
	deleteArtworkList:ModelTypes["ArtworkListDeleteResult"],
	updateArtworkList:ModelTypes["ArtworkListUpdateResult"],
	upsertArtworkList:ModelTypes["ArtworkListUpsertResult"],
	createArtworkSelection:ModelTypes["ArtworkSelectionCreateResult"],
	deleteArtworkSelection:ModelTypes["ArtworkSelectionDeleteResult"],
	updateArtworkSelection:ModelTypes["ArtworkSelectionUpdateResult"],
	upsertArtworkSelection:ModelTypes["ArtworkSelectionUpsertResult"],
	createArtworkSelectionItem:ModelTypes["ArtworkSelectionItemCreateResult"],
	deleteArtworkSelectionItem:ModelTypes["ArtworkSelectionItemDeleteResult"],
	updateArtworkSelectionItem:ModelTypes["ArtworkSelectionItemUpdateResult"],
	upsertArtworkSelectionItem:ModelTypes["ArtworkSelectionItemUpsertResult"],
	createArtworkSelectionList:ModelTypes["ArtworkSelectionListCreateResult"],
	deleteArtworkSelectionList:ModelTypes["ArtworkSelectionListDeleteResult"],
	updateArtworkSelectionList:ModelTypes["ArtworkSelectionListUpdateResult"],
	upsertArtworkSelectionList:ModelTypes["ArtworkSelectionListUpsertResult"],
	createArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleCreateResult"],
	deleteArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleDeleteResult"],
	updateArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleUpdateResult"],
	upsertArtworkSelectionLocale:ModelTypes["ArtworkSelectionLocaleUpsertResult"],
	createEventItem:ModelTypes["EventItemCreateResult"],
	deleteEventItem:ModelTypes["EventItemDeleteResult"],
	updateEventItem:ModelTypes["EventItemUpdateResult"],
	upsertEventItem:ModelTypes["EventItemUpsertResult"],
	createEventList:ModelTypes["EventListCreateResult"],
	deleteEventList:ModelTypes["EventListDeleteResult"],
	updateEventList:ModelTypes["EventListUpdateResult"],
	upsertEventList:ModelTypes["EventListUpsertResult"],
	createBoxItem:ModelTypes["BoxItemCreateResult"],
	deleteBoxItem:ModelTypes["BoxItemDeleteResult"],
	updateBoxItem:ModelTypes["BoxItemUpdateResult"],
	upsertBoxItem:ModelTypes["BoxItemUpsertResult"],
	createBoxList:ModelTypes["BoxListCreateResult"],
	deleteBoxList:ModelTypes["BoxListDeleteResult"],
	updateBoxList:ModelTypes["BoxListUpdateResult"],
	upsertBoxList:ModelTypes["BoxListUpsertResult"],
	createNewsletterForm:ModelTypes["NewsletterFormCreateResult"],
	deleteNewsletterForm:ModelTypes["NewsletterFormDeleteResult"],
	updateNewsletterForm:ModelTypes["NewsletterFormUpdateResult"],
	upsertNewsletterForm:ModelTypes["NewsletterFormUpsertResult"],
	createNewsletterTypeItem:ModelTypes["NewsletterTypeItemCreateResult"],
	deleteNewsletterTypeItem:ModelTypes["NewsletterTypeItemDeleteResult"],
	updateNewsletterTypeItem:ModelTypes["NewsletterTypeItemUpdateResult"],
	upsertNewsletterTypeItem:ModelTypes["NewsletterTypeItemUpsertResult"],
	createNewsletterFormLocale:ModelTypes["NewsletterFormLocaleCreateResult"],
	deleteNewsletterFormLocale:ModelTypes["NewsletterFormLocaleDeleteResult"],
	updateNewsletterFormLocale:ModelTypes["NewsletterFormLocaleUpdateResult"],
	upsertNewsletterFormLocale:ModelTypes["NewsletterFormLocaleUpsertResult"],
	createNewsletterSubscription:ModelTypes["NewsletterSubscriptionCreateResult"],
	deleteNewsletterSubscription:ModelTypes["NewsletterSubscriptionDeleteResult"],
	updateNewsletterSubscription:ModelTypes["NewsletterSubscriptionUpdateResult"],
	upsertNewsletterSubscription:ModelTypes["NewsletterSubscriptionUpsertResult"],
	createChart:ModelTypes["ChartCreateResult"],
	deleteChart:ModelTypes["ChartDeleteResult"],
	updateChart:ModelTypes["ChartUpdateResult"],
	upsertChart:ModelTypes["ChartUpsertResult"],
	createChartData:ModelTypes["ChartDataCreateResult"],
	deleteChartData:ModelTypes["ChartDataDeleteResult"],
	updateChartData:ModelTypes["ChartDataUpdateResult"],
	upsertChartData:ModelTypes["ChartDataUpsertResult"],
	createEmployee:ModelTypes["EmployeeCreateResult"],
	deleteEmployee:ModelTypes["EmployeeDeleteResult"],
	updateEmployee:ModelTypes["EmployeeUpdateResult"],
	upsertEmployee:ModelTypes["EmployeeUpsertResult"],
	createEmployeeItem:ModelTypes["EmployeeItemCreateResult"],
	deleteEmployeeItem:ModelTypes["EmployeeItemDeleteResult"],
	updateEmployeeItem:ModelTypes["EmployeeItemUpdateResult"],
	upsertEmployeeItem:ModelTypes["EmployeeItemUpsertResult"],
	createEmployeeList:ModelTypes["EmployeeListCreateResult"],
	deleteEmployeeList:ModelTypes["EmployeeListDeleteResult"],
	updateEmployeeList:ModelTypes["EmployeeListUpdateResult"],
	upsertEmployeeList:ModelTypes["EmployeeListUpsertResult"],
	createEmployeeLocale:ModelTypes["EmployeeLocaleCreateResult"],
	deleteEmployeeLocale:ModelTypes["EmployeeLocaleDeleteResult"],
	updateEmployeeLocale:ModelTypes["EmployeeLocaleUpdateResult"],
	upsertEmployeeLocale:ModelTypes["EmployeeLocaleUpsertResult"],
	createPhotographer:ModelTypes["PhotographerCreateResult"],
	deletePhotographer:ModelTypes["PhotographerDeleteResult"],
	updatePhotographer:ModelTypes["PhotographerUpdateResult"],
	upsertPhotographer:ModelTypes["PhotographerUpsertResult"],
	createDefinitionItem:ModelTypes["DefinitionItemCreateResult"],
	deleteDefinitionItem:ModelTypes["DefinitionItemDeleteResult"],
	updateDefinitionItem:ModelTypes["DefinitionItemUpdateResult"],
	upsertDefinitionItem:ModelTypes["DefinitionItemUpsertResult"],
	createDefinitionList:ModelTypes["DefinitionListCreateResult"],
	deleteDefinitionList:ModelTypes["DefinitionListDeleteResult"],
	updateDefinitionList:ModelTypes["DefinitionListUpdateResult"],
	upsertDefinitionList:ModelTypes["DefinitionListUpsertResult"],
	createLogoItem:ModelTypes["LogoItemCreateResult"],
	deleteLogoItem:ModelTypes["LogoItemDeleteResult"],
	updateLogoItem:ModelTypes["LogoItemUpdateResult"],
	upsertLogoItem:ModelTypes["LogoItemUpsertResult"],
	createLogoList:ModelTypes["LogoListCreateResult"],
	deleteLogoList:ModelTypes["LogoListDeleteResult"],
	updateLogoList:ModelTypes["LogoListUpdateResult"],
	upsertLogoList:ModelTypes["LogoListUpsertResult"],
	createStrategySchema:ModelTypes["StrategySchemaCreateResult"],
	deleteStrategySchema:ModelTypes["StrategySchemaDeleteResult"],
	updateStrategySchema:ModelTypes["StrategySchemaUpdateResult"],
	upsertStrategySchema:ModelTypes["StrategySchemaUpsertResult"],
	createStrategySchemaGroup:ModelTypes["StrategySchemaGroupCreateResult"],
	deleteStrategySchemaGroup:ModelTypes["StrategySchemaGroupDeleteResult"],
	updateStrategySchemaGroup:ModelTypes["StrategySchemaGroupUpdateResult"],
	upsertStrategySchemaGroup:ModelTypes["StrategySchemaGroupUpsertResult"],
	createStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemCreateResult"],
	deleteStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemDeleteResult"],
	updateStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemUpdateResult"],
	upsertStrategySchemaGroupItem:ModelTypes["StrategySchemaGroupItemUpsertResult"],
	createRedirect:ModelTypes["RedirectCreateResult"],
	deleteRedirect:ModelTypes["RedirectDeleteResult"],
	updateRedirect:ModelTypes["RedirectUpdateResult"],
	upsertRedirect:ModelTypes["RedirectUpsertResult"],
	createGallery:ModelTypes["GalleryCreateResult"],
	deleteGallery:ModelTypes["GalleryDeleteResult"],
	updateGallery:ModelTypes["GalleryUpdateResult"],
	upsertGallery:ModelTypes["GalleryUpsertResult"],
	createGalleryItem:ModelTypes["GalleryItemCreateResult"],
	deleteGalleryItem:ModelTypes["GalleryItemDeleteResult"],
	updateGalleryItem:ModelTypes["GalleryItemUpdateResult"],
	upsertGalleryItem:ModelTypes["GalleryItemUpsertResult"],
	createContactForm:ModelTypes["ContactFormCreateResult"],
	deleteContactForm:ModelTypes["ContactFormDeleteResult"],
	updateContactForm:ModelTypes["ContactFormUpdateResult"],
	upsertContactForm:ModelTypes["ContactFormUpsertResult"],
	createContactFormLocale:ModelTypes["ContactFormLocaleCreateResult"],
	deleteContactFormLocale:ModelTypes["ContactFormLocaleDeleteResult"],
	updateContactFormLocale:ModelTypes["ContactFormLocaleUpdateResult"],
	upsertContactFormLocale:ModelTypes["ContactFormLocaleUpsertResult"],
	createContactSubscription:ModelTypes["ContactSubscriptionCreateResult"],
	deleteContactSubscription:ModelTypes["ContactSubscriptionDeleteResult"],
	updateContactSubscription:ModelTypes["ContactSubscriptionUpdateResult"],
	upsertContactSubscription:ModelTypes["ContactSubscriptionUpsertResult"],
	createContactTypeItem:ModelTypes["ContactTypeItemCreateResult"],
	deleteContactTypeItem:ModelTypes["ContactTypeItemDeleteResult"],
	updateContactTypeItem:ModelTypes["ContactTypeItemUpdateResult"],
	upsertContactTypeItem:ModelTypes["ContactTypeItemUpsertResult"],
	createFile:ModelTypes["FileCreateResult"],
	deleteFile:ModelTypes["FileDeleteResult"],
	updateFile:ModelTypes["FileUpdateResult"],
	upsertFile:ModelTypes["FileUpsertResult"],
	query?:ModelTypes["Query"]
};
	["MutationTransactionOptions"]: GraphQLTypes["MutationTransactionOptions"];
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
		enums:ModelTypes["_Enum"][],
	entities:ModelTypes["_Entity"][]
};
	["_Entity"]: {
		name:string,
	customPrimaryAllowed:boolean,
	fields:ModelTypes["_Field"][],
	unique:ModelTypes["_UniqueConstraint"][]
};
	["_UniqueConstraint"]: {
		fields:string[]
};
	["_Field"]: ModelTypes["_Column"] | ModelTypes["_Relation"];
	["_Column"]: {
		name:string,
	type:string,
	enumName?:string,
	defaultValue?:ModelTypes["Json"],
	nullable:boolean,
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_OnDeleteBehaviour"]: GraphQLTypes["_OnDeleteBehaviour"];
	["_RelationSide"]: GraphQLTypes["_RelationSide"];
	["_OrderByDirection"]: GraphQLTypes["_OrderByDirection"];
	["_OrderBy"]: {
		path:string[],
	direction:ModelTypes["_OrderByDirection"]
};
	["_Relation"]: {
		name:string,
	type:string,
	side:ModelTypes["_RelationSide"],
	targetEntity:string,
	ownedBy?:string,
	inversedBy?:string,
	nullable?:boolean,
	onDelete?:ModelTypes["_OnDeleteBehaviour"],
	orphanRemoval?:boolean,
	orderBy?:ModelTypes["_OrderBy"][],
	rules:ModelTypes["_Rule"][],
	validators:ModelTypes["_Validator"][]
};
	["_Rule"]: {
		message?:ModelTypes["_RuleMessage"],
	validator:number
};
	["_Validator"]: {
		operation:string,
	arguments:ModelTypes["_Argument"][]
};
	["_Argument"]:ModelTypes["_ValidatorArgument"] | ModelTypes["_PathArgument"] | ModelTypes["_LiteralArgument"];
	["_ValidatorArgument"]: {
		validator:number
};
	["_PathArgument"]: {
		path:string[]
};
	["_LiteralArgument"]: {
		value?:ModelTypes["Json"]
};
	["_RuleMessage"]: {
		text?:string
};
	["_Enum"]: {
		name:string,
	values:string[]
};
	["S3SignedUpload"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string,
	publicUrl:string
};
	["S3Header"]: {
		key:string,
	value:string
};
	["S3SignedRead"]: {
		url:string,
	headers:ModelTypes["S3Header"][],
	method:string,
	/** Allowed patterns:
** */
	objectKey:string,
	bucket:string
}
    }

export type GraphQLTypes = {
    ["Query"]: {
	__typename: "Query",
	getContactPage?: GraphQLTypes["ContactPage"],
	listContactPage: Array<GraphQLTypes["ContactPage"]>,
	paginateContactPage: GraphQLTypes["ContactPageConnection"],
	validateCreateContactPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPage: GraphQLTypes["_ValidationResult"],
	getContactPageLocale?: GraphQLTypes["ContactPageLocale"],
	listContactPageLocale: Array<GraphQLTypes["ContactPageLocale"]>,
	paginateContactPageLocale: GraphQLTypes["ContactPageLocaleConnection"],
	validateCreateContactPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPageLocale: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"],
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"],
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getHomePageLocale?: GraphQLTypes["HomePageLocale"],
	listHomePageLocale: Array<GraphQLTypes["HomePageLocale"]>,
	paginateHomePageLocale: GraphQLTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLocale: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"],
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"],
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"],
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getSeoDefault?: GraphQLTypes["SeoDefault"],
	listSeoDefault: Array<GraphQLTypes["SeoDefault"]>,
	paginateSeoDefault: GraphQLTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefault: GraphQLTypes["_ValidationResult"],
	getSeoDefaultLocale?: GraphQLTypes["SeoDefaultLocale"],
	listSeoDefaultLocale: Array<GraphQLTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"],
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"],
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"],
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"],
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getBranches?: GraphQLTypes["Branches"],
	listBranches: Array<GraphQLTypes["Branches"]>,
	paginateBranches: GraphQLTypes["BranchesConnection"],
	validateCreateBranches: GraphQLTypes["_ValidationResult"],
	validateUpdateBranches: GraphQLTypes["_ValidationResult"],
	getGraphicDesigner?: GraphQLTypes["GraphicDesigner"],
	listGraphicDesigner: Array<GraphQLTypes["GraphicDesigner"]>,
	paginateGraphicDesigner: GraphQLTypes["GraphicDesignerConnection"],
	validateCreateGraphicDesigner: GraphQLTypes["_ValidationResult"],
	validateUpdateGraphicDesigner: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getEventLocale?: GraphQLTypes["EventLocale"],
	listEventLocale: Array<GraphQLTypes["EventLocale"]>,
	paginateEventLocale: GraphQLTypes["EventLocaleConnection"],
	validateCreateEventLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLocale: GraphQLTypes["_ValidationResult"],
	getArtwork?: GraphQLTypes["Artwork"],
	listArtwork: Array<GraphQLTypes["Artwork"]>,
	paginateArtwork: GraphQLTypes["ArtworkConnection"],
	validateCreateArtwork: GraphQLTypes["_ValidationResult"],
	validateUpdateArtwork: GraphQLTypes["_ValidationResult"],
	getArtworkLocale?: GraphQLTypes["ArtworkLocale"],
	listArtworkLocale: Array<GraphQLTypes["ArtworkLocale"]>,
	paginateArtworkLocale: GraphQLTypes["ArtworkLocaleConnection"],
	validateCreateArtworkLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkLocale: GraphQLTypes["_ValidationResult"],
	getDropDownItem?: GraphQLTypes["DropDownItem"],
	listDropDownItem: Array<GraphQLTypes["DropDownItem"]>,
	paginateDropDownItem: GraphQLTypes["DropDownItemConnection"],
	validateCreateDropDownItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDropDownItem: GraphQLTypes["_ValidationResult"],
	getDropDownList?: GraphQLTypes["DropDownList"],
	listDropDownList: Array<GraphQLTypes["DropDownList"]>,
	paginateDropDownList: GraphQLTypes["DropDownListConnection"],
	validateCreateDropDownList: GraphQLTypes["_ValidationResult"],
	validateUpdateDropDownList: GraphQLTypes["_ValidationResult"],
	getArtworkItem?: GraphQLTypes["ArtworkItem"],
	listArtworkItem: Array<GraphQLTypes["ArtworkItem"]>,
	paginateArtworkItem: GraphQLTypes["ArtworkItemConnection"],
	validateCreateArtworkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkItem: GraphQLTypes["_ValidationResult"],
	getArtworkList?: GraphQLTypes["ArtworkList"],
	listArtworkList: Array<GraphQLTypes["ArtworkList"]>,
	paginateArtworkList: GraphQLTypes["ArtworkListConnection"],
	validateCreateArtworkList: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkList: GraphQLTypes["_ValidationResult"],
	getArtworkSelection?: GraphQLTypes["ArtworkSelection"],
	listArtworkSelection: Array<GraphQLTypes["ArtworkSelection"]>,
	paginateArtworkSelection: GraphQLTypes["ArtworkSelectionConnection"],
	validateCreateArtworkSelection: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelection: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionItem?: GraphQLTypes["ArtworkSelectionItem"],
	listArtworkSelectionItem: Array<GraphQLTypes["ArtworkSelectionItem"]>,
	paginateArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemConnection"],
	validateCreateArtworkSelectionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionItem: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionList?: GraphQLTypes["ArtworkSelectionList"],
	listArtworkSelectionList: Array<GraphQLTypes["ArtworkSelectionList"]>,
	paginateArtworkSelectionList: GraphQLTypes["ArtworkSelectionListConnection"],
	validateCreateArtworkSelectionList: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionList: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionLocale?: GraphQLTypes["ArtworkSelectionLocale"],
	listArtworkSelectionLocale: Array<GraphQLTypes["ArtworkSelectionLocale"]>,
	paginateArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleConnection"],
	validateCreateArtworkSelectionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionLocale: GraphQLTypes["_ValidationResult"],
	getEventItem?: GraphQLTypes["EventItem"],
	listEventItem: Array<GraphQLTypes["EventItem"]>,
	paginateEventItem: GraphQLTypes["EventItemConnection"],
	validateCreateEventItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEventItem: GraphQLTypes["_ValidationResult"],
	getEventList?: GraphQLTypes["EventList"],
	listEventList: Array<GraphQLTypes["EventList"]>,
	paginateEventList: GraphQLTypes["EventListConnection"],
	validateCreateEventList: GraphQLTypes["_ValidationResult"],
	validateUpdateEventList: GraphQLTypes["_ValidationResult"],
	getBoxItem?: GraphQLTypes["BoxItem"],
	listBoxItem: Array<GraphQLTypes["BoxItem"]>,
	paginateBoxItem: GraphQLTypes["BoxItemConnection"],
	validateCreateBoxItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBoxItem: GraphQLTypes["_ValidationResult"],
	getBoxList?: GraphQLTypes["BoxList"],
	listBoxList: Array<GraphQLTypes["BoxList"]>,
	paginateBoxList: GraphQLTypes["BoxListConnection"],
	validateCreateBoxList: GraphQLTypes["_ValidationResult"],
	validateUpdateBoxList: GraphQLTypes["_ValidationResult"],
	getNewsletterForm?: GraphQLTypes["NewsletterForm"],
	listNewsletterForm: Array<GraphQLTypes["NewsletterForm"]>,
	paginateNewsletterForm: GraphQLTypes["NewsletterFormConnection"],
	validateCreateNewsletterForm: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterForm: GraphQLTypes["_ValidationResult"],
	getNewsletterTypeItem?: GraphQLTypes["NewsletterTypeItem"],
	listNewsletterTypeItem: Array<GraphQLTypes["NewsletterTypeItem"]>,
	paginateNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemConnection"],
	validateCreateNewsletterTypeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterTypeItem: GraphQLTypes["_ValidationResult"],
	getNewsletterFormLocale?: GraphQLTypes["NewsletterFormLocale"],
	listNewsletterFormLocale: Array<GraphQLTypes["NewsletterFormLocale"]>,
	paginateNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleConnection"],
	validateCreateNewsletterFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterFormLocale: GraphQLTypes["_ValidationResult"],
	getNewsletterSubscription?: GraphQLTypes["NewsletterSubscription"],
	listNewsletterSubscription: Array<GraphQLTypes["NewsletterSubscription"]>,
	paginateNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionConnection"],
	validateCreateNewsletterSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterSubscription: GraphQLTypes["_ValidationResult"],
	getChart?: GraphQLTypes["Chart"],
	listChart: Array<GraphQLTypes["Chart"]>,
	paginateChart: GraphQLTypes["ChartConnection"],
	validateCreateChart: GraphQLTypes["_ValidationResult"],
	validateUpdateChart: GraphQLTypes["_ValidationResult"],
	getChartData?: GraphQLTypes["ChartData"],
	listChartData: Array<GraphQLTypes["ChartData"]>,
	paginateChartData: GraphQLTypes["ChartDataConnection"],
	validateCreateChartData: GraphQLTypes["_ValidationResult"],
	validateUpdateChartData: GraphQLTypes["_ValidationResult"],
	getEmployee?: GraphQLTypes["Employee"],
	listEmployee: Array<GraphQLTypes["Employee"]>,
	paginateEmployee: GraphQLTypes["EmployeeConnection"],
	validateCreateEmployee: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployee: GraphQLTypes["_ValidationResult"],
	getEmployeeItem?: GraphQLTypes["EmployeeItem"],
	listEmployeeItem: Array<GraphQLTypes["EmployeeItem"]>,
	paginateEmployeeItem: GraphQLTypes["EmployeeItemConnection"],
	validateCreateEmployeeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeItem: GraphQLTypes["_ValidationResult"],
	getEmployeeList?: GraphQLTypes["EmployeeList"],
	listEmployeeList: Array<GraphQLTypes["EmployeeList"]>,
	paginateEmployeeList: GraphQLTypes["EmployeeListConnection"],
	validateCreateEmployeeList: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeList: GraphQLTypes["_ValidationResult"],
	getEmployeeLocale?: GraphQLTypes["EmployeeLocale"],
	listEmployeeLocale: Array<GraphQLTypes["EmployeeLocale"]>,
	paginateEmployeeLocale: GraphQLTypes["EmployeeLocaleConnection"],
	validateCreateEmployeeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeLocale: GraphQLTypes["_ValidationResult"],
	getPhotographer?: GraphQLTypes["Photographer"],
	listPhotographer: Array<GraphQLTypes["Photographer"]>,
	paginatePhotographer: GraphQLTypes["PhotographerConnection"],
	validateCreatePhotographer: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographer: GraphQLTypes["_ValidationResult"],
	getDefinitionItem?: GraphQLTypes["DefinitionItem"],
	listDefinitionItem: Array<GraphQLTypes["DefinitionItem"]>,
	paginateDefinitionItem: GraphQLTypes["DefinitionItemConnection"],
	validateCreateDefinitionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDefinitionItem: GraphQLTypes["_ValidationResult"],
	getDefinitionList?: GraphQLTypes["DefinitionList"],
	listDefinitionList: Array<GraphQLTypes["DefinitionList"]>,
	paginateDefinitionList: GraphQLTypes["DefinitionListConnection"],
	validateCreateDefinitionList: GraphQLTypes["_ValidationResult"],
	validateUpdateDefinitionList: GraphQLTypes["_ValidationResult"],
	getLogoItem?: GraphQLTypes["LogoItem"],
	listLogoItem: Array<GraphQLTypes["LogoItem"]>,
	paginateLogoItem: GraphQLTypes["LogoItemConnection"],
	validateCreateLogoItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLogoItem: GraphQLTypes["_ValidationResult"],
	getLogoList?: GraphQLTypes["LogoList"],
	listLogoList: Array<GraphQLTypes["LogoList"]>,
	paginateLogoList: GraphQLTypes["LogoListConnection"],
	validateCreateLogoList: GraphQLTypes["_ValidationResult"],
	validateUpdateLogoList: GraphQLTypes["_ValidationResult"],
	getStrategySchema?: GraphQLTypes["StrategySchema"],
	listStrategySchema: Array<GraphQLTypes["StrategySchema"]>,
	paginateStrategySchema: GraphQLTypes["StrategySchemaConnection"],
	validateCreateStrategySchema: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchema: GraphQLTypes["_ValidationResult"],
	getStrategySchemaGroup?: GraphQLTypes["StrategySchemaGroup"],
	listStrategySchemaGroup: Array<GraphQLTypes["StrategySchemaGroup"]>,
	paginateStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupConnection"],
	validateCreateStrategySchemaGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroup: GraphQLTypes["_ValidationResult"],
	getStrategySchemaGroupItem?: GraphQLTypes["StrategySchemaGroupItem"],
	listStrategySchemaGroupItem: Array<GraphQLTypes["StrategySchemaGroupItem"]>,
	paginateStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemConnection"],
	validateCreateStrategySchemaGroupItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroupItem: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getContactForm?: GraphQLTypes["ContactForm"],
	listContactForm: Array<GraphQLTypes["ContactForm"]>,
	paginateContactForm: GraphQLTypes["ContactFormConnection"],
	validateCreateContactForm: GraphQLTypes["_ValidationResult"],
	validateUpdateContactForm: GraphQLTypes["_ValidationResult"],
	getContactFormLocale?: GraphQLTypes["ContactFormLocale"],
	listContactFormLocale: Array<GraphQLTypes["ContactFormLocale"]>,
	paginateContactFormLocale: GraphQLTypes["ContactFormLocaleConnection"],
	validateCreateContactFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContactFormLocale: GraphQLTypes["_ValidationResult"],
	getContactSubscription?: GraphQLTypes["ContactSubscription"],
	listContactSubscription: Array<GraphQLTypes["ContactSubscription"]>,
	paginateContactSubscription: GraphQLTypes["ContactSubscriptionConnection"],
	validateCreateContactSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateContactSubscription: GraphQLTypes["_ValidationResult"],
	getContactTypeItem?: GraphQLTypes["ContactTypeItem"],
	listContactTypeItem: Array<GraphQLTypes["ContactTypeItem"]>,
	paginateContactTypeItem: GraphQLTypes["ContactTypeItemConnection"],
	validateCreateContactTypeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContactTypeItem: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"],
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"],
	transaction?: GraphQLTypes["QueryTransaction"],
	_info?: GraphQLTypes["Info"],
	schema?: GraphQLTypes["_Schema"],
	s3DummyQuery?: string
};
	["ContactPage"]: {
	__typename: "ContactPage",
	_meta?: GraphQLTypes["ContactPageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["ContactPageLocale"]>,
	localesByLocale?: GraphQLTypes["ContactPageLocale"],
	localesByLink?: GraphQLTypes["ContactPageLocale"],
	localesBySeo?: GraphQLTypes["ContactPageLocale"],
	localesByAddressLink?: GraphQLTypes["ContactPageLocale"],
	paginateLocales: GraphQLTypes["ContactPageLocaleConnection"]
};
	["ContactPageMeta"]: {
	__typename: "ContactPageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["FieldMeta"]: {
	__typename: "FieldMeta",
	readable?: boolean,
	updatable?: boolean
};
	["UUID"]:string;
	["One"]: One;
	["ContactPageLocale"]: {
	__typename: "ContactPageLocale",
	_meta?: GraphQLTypes["ContactPageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ContactPage"],
	locale?: GraphQLTypes["Locale"],
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["Link"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string
};
	["ContactPageLocaleMeta"]: {
	__typename: "ContactPageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	youtube?: GraphQLTypes["FieldMeta"],
	instagram?: GraphQLTypes["FieldMeta"],
	facebook?: GraphQLTypes["FieldMeta"],
	databox?: GraphQLTypes["FieldMeta"],
	databoxNumber?: GraphQLTypes["FieldMeta"],
	addressLink?: GraphQLTypes["FieldMeta"],
	socialsLabel?: GraphQLTypes["FieldMeta"],
	openingHours?: GraphQLTypes["FieldMeta"],
	identificationsLabel?: GraphQLTypes["FieldMeta"],
	ico?: GraphQLTypes["FieldMeta"],
	dic?: GraphQLTypes["FieldMeta"],
	phoneLabel?: GraphQLTypes["FieldMeta"],
	emailLabel?: GraphQLTypes["FieldMeta"],
	linkedIn?: GraphQLTypes["FieldMeta"],
	securities?: GraphQLTypes["FieldMeta"],
	securitiesNumber?: GraphQLTypes["FieldMeta"]
};
	["ContactPageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["ContactPageLocaleWhere"],
	and?: Array<GraphQLTypes["ContactPageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactPageWhere"] | undefined>,
	not?: GraphQLTypes["ContactPageWhere"]
};
	["UUIDCondition"]: {
		and?: Array<GraphQLTypes["UUIDCondition"]>,
	or?: Array<GraphQLTypes["UUIDCondition"]>,
	not?: GraphQLTypes["UUIDCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["UUID"],
	notEq?: GraphQLTypes["UUID"],
	in?: Array<GraphQLTypes["UUID"]>,
	notIn?: Array<GraphQLTypes["UUID"]>,
	lt?: GraphQLTypes["UUID"],
	lte?: GraphQLTypes["UUID"],
	gt?: GraphQLTypes["UUID"],
	gte?: GraphQLTypes["UUID"]
};
	["OneCondition"]: {
		and?: Array<GraphQLTypes["OneCondition"]>,
	or?: Array<GraphQLTypes["OneCondition"]>,
	not?: GraphQLTypes["OneCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["One"],
	notEq?: GraphQLTypes["One"],
	in?: Array<GraphQLTypes["One"]>,
	notIn?: Array<GraphQLTypes["One"]>,
	lt?: GraphQLTypes["One"],
	lte?: GraphQLTypes["One"],
	gt?: GraphQLTypes["One"],
	gte?: GraphQLTypes["One"]
};
	["ContactPageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["ContactPageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	address?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	youtube?: GraphQLTypes["StringCondition"],
	instagram?: GraphQLTypes["StringCondition"],
	facebook?: GraphQLTypes["StringCondition"],
	databox?: GraphQLTypes["StringCondition"],
	databoxNumber?: GraphQLTypes["StringCondition"],
	addressLink?: GraphQLTypes["LinkWhere"],
	socialsLabel?: GraphQLTypes["StringCondition"],
	openingHours?: GraphQLTypes["StringCondition"],
	identificationsLabel?: GraphQLTypes["StringCondition"],
	ico?: GraphQLTypes["StringCondition"],
	dic?: GraphQLTypes["StringCondition"],
	phoneLabel?: GraphQLTypes["StringCondition"],
	emailLabel?: GraphQLTypes["StringCondition"],
	linkedIn?: GraphQLTypes["StringCondition"],
	securities?: GraphQLTypes["StringCondition"],
	securitiesNumber?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContactPageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactPageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["ContactPageLocaleWhere"]
};
	["StringCondition"]: {
		and?: Array<GraphQLTypes["StringCondition"]>,
	or?: Array<GraphQLTypes["StringCondition"]>,
	not?: GraphQLTypes["StringCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: string,
	notEq?: string,
	in?: Array<string>,
	notIn?: Array<string>,
	lt?: string,
	lte?: string,
	gt?: string,
	gte?: string,
	contains?: string,
	startsWith?: string,
	endsWith?: string,
	containsCI?: string,
	startsWithCI?: string,
	endsWithCI?: string
};
	["LocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	code?: GraphQLTypes["StringCondition"],
	label?: GraphQLTypes["StringCondition"],
	contactPages?: GraphQLTypes["ContactPageLocaleWhere"],
	footers?: GraphQLTypes["FooterLocaleWhere"],
	headers?: GraphQLTypes["HeaderLocaleWhere"],
	homePages?: GraphQLTypes["HomePageLocaleWhere"],
	pages?: GraphQLTypes["PageLocaleWhere"],
	seoDefaults?: GraphQLTypes["SeoDefaultLocaleWhere"],
	events?: GraphQLTypes["EventLocaleWhere"],
	artworks?: GraphQLTypes["ArtworkLocaleWhere"],
	artworkSelections?: GraphQLTypes["ArtworkSelectionLocaleWhere"],
	newsletterForms?: GraphQLTypes["NewsletterFormLocaleWhere"],
	employees?: GraphQLTypes["EmployeeLocaleWhere"],
	contactForms?: GraphQLTypes["ContactFormLocaleWhere"],
	and?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["LocaleWhere"] | undefined>,
	not?: GraphQLTypes["LocaleWhere"]
};
	["FooterLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	address?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	youtube?: GraphQLTypes["StringCondition"],
	instagram?: GraphQLTypes["StringCondition"],
	facebook?: GraphQLTypes["StringCondition"],
	graphicDesign?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["FooterWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	graphicDesigners?: GraphQLTypes["GraphicDesignerWhere"],
	developerLink?: GraphQLTypes["LinkWhere"],
	development?: GraphQLTypes["StringCondition"],
	linkedIn?: GraphQLTypes["StringCondition"],
	photography?: GraphQLTypes["StringCondition"],
	photographers?: GraphQLTypes["PhotographerWhere"],
	and?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterLocaleWhere"] | undefined>,
	not?: GraphQLTypes["FooterLocaleWhere"]
};
	["FooterWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	logo?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["FooterLocaleWhere"],
	and?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	or?: Array<GraphQLTypes["FooterWhere"] | undefined>,
	not?: GraphQLTypes["FooterWhere"]
};
	["ImageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	alt?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	or?: Array<GraphQLTypes["ImageWhere"] | undefined>,
	not?: GraphQLTypes["ImageWhere"]
};
	["IntCondition"]: {
		and?: Array<GraphQLTypes["IntCondition"]>,
	or?: Array<GraphQLTypes["IntCondition"]>,
	not?: GraphQLTypes["IntCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["GraphicDesignerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["GraphicDesignerWhere"] | undefined>,
	or?: Array<GraphQLTypes["GraphicDesignerWhere"] | undefined>,
	not?: GraphQLTypes["GraphicDesignerWhere"]
};
	["LinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["LinkTypeCondition"],
	title?: GraphQLTypes["StringCondition"],
	externalLink?: GraphQLTypes["StringCondition"],
	internalLink?: GraphQLTypes["LinkableWhere"],
	anchorLink?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkWhere"] | undefined>,
	not?: GraphQLTypes["LinkWhere"]
};
	["LinkTypeCondition"]: {
		and?: Array<GraphQLTypes["LinkTypeCondition"]>,
	or?: Array<GraphQLTypes["LinkTypeCondition"]>,
	not?: GraphQLTypes["LinkTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["LinkType"],
	notEq?: GraphQLTypes["LinkType"],
	in?: Array<GraphQLTypes["LinkType"]>,
	notIn?: Array<GraphQLTypes["LinkType"]>,
	lt?: GraphQLTypes["LinkType"],
	lte?: GraphQLTypes["LinkType"],
	gt?: GraphQLTypes["LinkType"],
	gte?: GraphQLTypes["LinkType"]
};
	["LinkType"]: LinkType;
	["LinkableWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	homePage?: GraphQLTypes["HomePageLocaleWhere"],
	contactPage?: GraphQLTypes["ContactPageLocaleWhere"],
	page?: GraphQLTypes["PageLocaleWhere"],
	event?: GraphQLTypes["EventLocaleWhere"],
	artwork?: GraphQLTypes["ArtworkLocaleWhere"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionLocaleWhere"],
	redirect?: GraphQLTypes["RedirectWhere"],
	and?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	or?: Array<GraphQLTypes["LinkableWhere"] | undefined>,
	not?: GraphQLTypes["LinkableWhere"]
};
	["HomePageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["HomePageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	content?: GraphQLTypes["ContentWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	branches?: GraphQLTypes["BranchesWhere"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["HomePageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["HomePageLocaleWhere"]
};
	["HomePageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["HomePageLocaleWhere"],
	media?: GraphQLTypes["MediumListWhere"],
	and?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	or?: Array<GraphQLTypes["HomePageWhere"] | undefined>,
	not?: GraphQLTypes["HomePageWhere"]
};
	["MediumListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["MediumItemWhere"],
	and?: Array<GraphQLTypes["MediumListWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumListWhere"] | undefined>,
	not?: GraphQLTypes["MediumListWhere"]
};
	["MediumItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["MediumListWhere"],
	medium?: GraphQLTypes["MediumWhere"],
	and?: Array<GraphQLTypes["MediumItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumItemWhere"] | undefined>,
	not?: GraphQLTypes["MediumItemWhere"]
};
	["MediumWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["MediumTypeCondition"],
	image?: GraphQLTypes["ImageWhere"],
	video?: GraphQLTypes["VideoWhere"],
	youtubeEmbed?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	or?: Array<GraphQLTypes["MediumWhere"] | undefined>,
	not?: GraphQLTypes["MediumWhere"]
};
	["MediumTypeCondition"]: {
		and?: Array<GraphQLTypes["MediumTypeCondition"]>,
	or?: Array<GraphQLTypes["MediumTypeCondition"]>,
	not?: GraphQLTypes["MediumTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["MediumType"],
	notEq?: GraphQLTypes["MediumType"],
	in?: Array<GraphQLTypes["MediumType"]>,
	notIn?: Array<GraphQLTypes["MediumType"]>,
	lt?: GraphQLTypes["MediumType"],
	lte?: GraphQLTypes["MediumType"],
	gt?: GraphQLTypes["MediumType"],
	gte?: GraphQLTypes["MediumType"]
};
	["MediumType"]: MediumType;
	["VideoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	src?: GraphQLTypes["StringCondition"],
	width?: GraphQLTypes["IntCondition"],
	height?: GraphQLTypes["IntCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	duration?: GraphQLTypes["FloatCondition"],
	poster?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	or?: Array<GraphQLTypes["VideoWhere"] | undefined>,
	not?: GraphQLTypes["VideoWhere"]
};
	["FloatCondition"]: {
		and?: Array<GraphQLTypes["FloatCondition"]>,
	or?: Array<GraphQLTypes["FloatCondition"]>,
	not?: GraphQLTypes["FloatCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: number,
	notEq?: number,
	in?: Array<number>,
	notIn?: Array<number>,
	lt?: number,
	lte?: number,
	gt?: number,
	gte?: number
};
	["ContentWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	blocks?: GraphQLTypes["ContentBlockWhere"],
	and?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentWhere"] | undefined>,
	not?: GraphQLTypes["ContentWhere"]
};
	["ContentBlockWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	json?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	references?: GraphQLTypes["ContentReferenceWhere"],
	and?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentBlockWhere"] | undefined>,
	not?: GraphQLTypes["ContentBlockWhere"]
};
	["ContentReferenceWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ContentReferenceTypeCondition"],
	primaryText?: GraphQLTypes["StringCondition"],
	block?: GraphQLTypes["ContentBlockWhere"],
	media?: GraphQLTypes["MediumListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	secondaryText?: GraphQLTypes["StringCondition"],
	dropDownList?: GraphQLTypes["DropDownListWhere"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionWhere"],
	eventList?: GraphQLTypes["EventListWhere"],
	boxList?: GraphQLTypes["BoxListWhere"],
	isVisible?: GraphQLTypes["BooleanCondition"],
	chart?: GraphQLTypes["ChartWhere"],
	definitionList?: GraphQLTypes["DefinitionListWhere"],
	logoList?: GraphQLTypes["LogoListWhere"],
	strategySchema?: GraphQLTypes["StrategySchemaWhere"],
	image?: GraphQLTypes["ImageWhere"],
	employeeList?: GraphQLTypes["EmployeeListWhere"],
	imageSecond?: GraphQLTypes["ImageWhere"],
	contactForm?: GraphQLTypes["ContactFormWhere"],
	newsletterForm?: GraphQLTypes["NewsletterFormWhere"],
	and?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContentReferenceWhere"] | undefined>,
	not?: GraphQLTypes["ContentReferenceWhere"]
};
	["ContentReferenceTypeCondition"]: {
		and?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	or?: Array<GraphQLTypes["ContentReferenceTypeCondition"]>,
	not?: GraphQLTypes["ContentReferenceTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ContentReferenceType"],
	notEq?: GraphQLTypes["ContentReferenceType"],
	in?: Array<GraphQLTypes["ContentReferenceType"]>,
	notIn?: Array<GraphQLTypes["ContentReferenceType"]>,
	lt?: GraphQLTypes["ContentReferenceType"],
	lte?: GraphQLTypes["ContentReferenceType"],
	gt?: GraphQLTypes["ContentReferenceType"],
	gte?: GraphQLTypes["ContentReferenceType"]
};
	["ContentReferenceType"]: ContentReferenceType;
	["DropDownListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["DropDownItemWhere"],
	dropDownType?: GraphQLTypes["DropDownTypeCondition"],
	employees?: GraphQLTypes["EmployeeListWhere"],
	and?: Array<GraphQLTypes["DropDownListWhere"] | undefined>,
	or?: Array<GraphQLTypes["DropDownListWhere"] | undefined>,
	not?: GraphQLTypes["DropDownListWhere"]
};
	["DropDownItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["DropDownListWhere"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["DropDownItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["DropDownItemWhere"] | undefined>,
	not?: GraphQLTypes["DropDownItemWhere"]
};
	["DropDownTypeCondition"]: {
		and?: Array<GraphQLTypes["DropDownTypeCondition"]>,
	or?: Array<GraphQLTypes["DropDownTypeCondition"]>,
	not?: GraphQLTypes["DropDownTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DropDownType"],
	notEq?: GraphQLTypes["DropDownType"],
	in?: Array<GraphQLTypes["DropDownType"]>,
	notIn?: Array<GraphQLTypes["DropDownType"]>,
	lt?: GraphQLTypes["DropDownType"],
	lte?: GraphQLTypes["DropDownType"],
	gt?: GraphQLTypes["DropDownType"],
	gte?: GraphQLTypes["DropDownType"]
};
	["DropDownType"]: DropDownType;
	["EmployeeListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["EmployeeItemWhere"],
	and?: Array<GraphQLTypes["EmployeeListWhere"] | undefined>,
	or?: Array<GraphQLTypes["EmployeeListWhere"] | undefined>,
	not?: GraphQLTypes["EmployeeListWhere"]
};
	["EmployeeItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["EmployeeListWhere"],
	employee?: GraphQLTypes["EmployeeWhere"],
	and?: Array<GraphQLTypes["EmployeeItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["EmployeeItemWhere"] | undefined>,
	not?: GraphQLTypes["EmployeeItemWhere"]
};
	["EmployeeWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	name?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	locales?: GraphQLTypes["EmployeeLocaleWhere"],
	and?: Array<GraphQLTypes["EmployeeWhere"] | undefined>,
	or?: Array<GraphQLTypes["EmployeeWhere"] | undefined>,
	not?: GraphQLTypes["EmployeeWhere"]
};
	["EmployeeLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	position?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["EmployeeWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	and?: Array<GraphQLTypes["EmployeeLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["EmployeeLocaleWhere"] | undefined>,
	not?: GraphQLTypes["EmployeeLocaleWhere"]
};
	["ArtworkSelectionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["ArtworkSelectionLocaleWhere"],
	artworks?: GraphQLTypes["ArtworkSelectionListWhere"],
	and?: Array<GraphQLTypes["ArtworkSelectionWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkSelectionWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkSelectionWhere"]
};
	["ArtworkSelectionLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["ArtworkSelectionWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["ArtworkSelectionLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkSelectionLocaleWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkSelectionLocaleWhere"]
};
	["SeoWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	description?: GraphQLTypes["StringCondition"],
	ogTitle?: GraphQLTypes["StringCondition"],
	ogDescription?: GraphQLTypes["StringCondition"],
	noIndex?: GraphQLTypes["BooleanCondition"],
	noFollow?: GraphQLTypes["BooleanCondition"],
	ogImage?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoWhere"] | undefined>,
	not?: GraphQLTypes["SeoWhere"]
};
	["BooleanCondition"]: {
		and?: Array<GraphQLTypes["BooleanCondition"]>,
	or?: Array<GraphQLTypes["BooleanCondition"]>,
	not?: GraphQLTypes["BooleanCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: boolean,
	notEq?: boolean,
	in?: Array<boolean>,
	notIn?: Array<boolean>,
	lt?: boolean,
	lte?: boolean,
	gt?: boolean,
	gte?: boolean
};
	["ArtworkSelectionListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ArtworkSelectionItemWhere"],
	and?: Array<GraphQLTypes["ArtworkSelectionListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkSelectionListWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkSelectionListWhere"]
};
	["ArtworkSelectionItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ArtworkSelectionListWhere"],
	artwork?: GraphQLTypes["ArtworkWhere"],
	and?: Array<GraphQLTypes["ArtworkSelectionItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkSelectionItemWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkSelectionItemWhere"]
};
	["ArtworkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	locales?: GraphQLTypes["ArtworkLocaleWhere"],
	image?: GraphQLTypes["ImageWhere"],
	gallery?: GraphQLTypes["GalleryWhere"],
	and?: Array<GraphQLTypes["ArtworkWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkWhere"]
};
	["ArtworkLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	label?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["ArtworkWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	artist?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ArtworkLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkLocaleWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkLocaleWhere"]
};
	["GalleryWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["GalleryItemWhere"],
	and?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryWhere"] | undefined>,
	not?: GraphQLTypes["GalleryWhere"]
};
	["GalleryItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["GalleryWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["GalleryItemWhere"] | undefined>,
	not?: GraphQLTypes["GalleryItemWhere"]
};
	["EventListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["EventItemWhere"],
	and?: Array<GraphQLTypes["EventListWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventListWhere"] | undefined>,
	not?: GraphQLTypes["EventListWhere"]
};
	["EventItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["EventListWhere"],
	event?: GraphQLTypes["EventWhere"],
	and?: Array<GraphQLTypes["EventItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventItemWhere"] | undefined>,
	not?: GraphQLTypes["EventItemWhere"]
};
	["EventWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	locales?: GraphQLTypes["EventLocaleWhere"],
	order?: GraphQLTypes["IntCondition"],
	dateStart?: GraphQLTypes["DateTimeCondition"],
	dateFinish?: GraphQLTypes["DateTimeCondition"],
	and?: Array<GraphQLTypes["EventWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventWhere"] | undefined>,
	not?: GraphQLTypes["EventWhere"]
};
	["EventLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["EventWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	image?: GraphQLTypes["ImageWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	link?: GraphQLTypes["LinkableWhere"],
	venue?: GraphQLTypes["StringCondition"],
	venueNote?: GraphQLTypes["StringCondition"],
	content?: GraphQLTypes["ContentWhere"],
	date?: GraphQLTypes["StringCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	isDark?: GraphQLTypes["BooleanCondition"],
	and?: Array<GraphQLTypes["EventLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["EventLocaleWhere"] | undefined>,
	not?: GraphQLTypes["EventLocaleWhere"]
};
	["DateTimeCondition"]: {
		and?: Array<GraphQLTypes["DateTimeCondition"]>,
	or?: Array<GraphQLTypes["DateTimeCondition"]>,
	not?: GraphQLTypes["DateTimeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["DateTime"],
	notEq?: GraphQLTypes["DateTime"],
	in?: Array<GraphQLTypes["DateTime"]>,
	notIn?: Array<GraphQLTypes["DateTime"]>,
	lt?: GraphQLTypes["DateTime"],
	lte?: GraphQLTypes["DateTime"],
	gt?: GraphQLTypes["DateTime"],
	gte?: GraphQLTypes["DateTime"]
};
	["DateTime"]:string;
	["BoxListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["BoxItemWhere"],
	and?: Array<GraphQLTypes["BoxListWhere"] | undefined>,
	or?: Array<GraphQLTypes["BoxListWhere"] | undefined>,
	not?: GraphQLTypes["BoxListWhere"]
};
	["BoxItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["StringCondition"],
	date?: GraphQLTypes["StringCondition"],
	type?: GraphQLTypes["StringCondition"],
	title?: GraphQLTypes["StringCondition"],
	text?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["BoxListWhere"],
	and?: Array<GraphQLTypes["BoxItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["BoxItemWhere"] | undefined>,
	not?: GraphQLTypes["BoxItemWhere"]
};
	["ChartWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	type?: GraphQLTypes["ChartTypeCondition"],
	items?: GraphQLTypes["ChartDataWhere"],
	and?: Array<GraphQLTypes["ChartWhere"] | undefined>,
	or?: Array<GraphQLTypes["ChartWhere"] | undefined>,
	not?: GraphQLTypes["ChartWhere"]
};
	["ChartTypeCondition"]: {
		and?: Array<GraphQLTypes["ChartTypeCondition"]>,
	or?: Array<GraphQLTypes["ChartTypeCondition"]>,
	not?: GraphQLTypes["ChartTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["ChartType"],
	notEq?: GraphQLTypes["ChartType"],
	in?: Array<GraphQLTypes["ChartType"]>,
	notIn?: Array<GraphQLTypes["ChartType"]>,
	lt?: GraphQLTypes["ChartType"],
	lte?: GraphQLTypes["ChartType"],
	gt?: GraphQLTypes["ChartType"],
	gte?: GraphQLTypes["ChartType"]
};
	["ChartType"]: ChartType;
	["ChartDataWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ChartWhere"],
	date?: GraphQLTypes["DateCondition"],
	number?: GraphQLTypes["FloatCondition"],
	text?: GraphQLTypes["StringCondition"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["ChartDataWhere"] | undefined>,
	or?: Array<GraphQLTypes["ChartDataWhere"] | undefined>,
	not?: GraphQLTypes["ChartDataWhere"]
};
	["DateCondition"]: {
		and?: Array<GraphQLTypes["DateCondition"]>,
	or?: Array<GraphQLTypes["DateCondition"]>,
	not?: GraphQLTypes["DateCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["Date"],
	notEq?: GraphQLTypes["Date"],
	in?: Array<GraphQLTypes["Date"]>,
	notIn?: Array<GraphQLTypes["Date"]>,
	lt?: GraphQLTypes["Date"],
	lte?: GraphQLTypes["Date"],
	gt?: GraphQLTypes["Date"],
	gte?: GraphQLTypes["Date"]
};
	["Date"]:string;
	["DefinitionListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["DefinitionItemWhere"],
	and?: Array<GraphQLTypes["DefinitionListWhere"] | undefined>,
	or?: Array<GraphQLTypes["DefinitionListWhere"] | undefined>,
	not?: GraphQLTypes["DefinitionListWhere"]
};
	["DefinitionItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	key?: GraphQLTypes["StringCondition"],
	value?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["DefinitionListWhere"],
	and?: Array<GraphQLTypes["DefinitionItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["DefinitionItemWhere"] | undefined>,
	not?: GraphQLTypes["DefinitionItemWhere"]
};
	["LogoListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["LogoItemWhere"],
	and?: Array<GraphQLTypes["LogoListWhere"] | undefined>,
	or?: Array<GraphQLTypes["LogoListWhere"] | undefined>,
	not?: GraphQLTypes["LogoListWhere"]
};
	["LogoItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["LogoListWhere"],
	image?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["LogoItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["LogoItemWhere"] | undefined>,
	not?: GraphQLTypes["LogoItemWhere"]
};
	["StrategySchemaWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	inputFirst?: GraphQLTypes["StringCondition"],
	inputSecond?: GraphQLTypes["StringCondition"],
	inputThird?: GraphQLTypes["StringCondition"],
	outputFirst?: GraphQLTypes["StringCondition"],
	outputSecond?: GraphQLTypes["StringCondition"],
	outputThird?: GraphQLTypes["StringCondition"],
	itemsFirst?: GraphQLTypes["StrategySchemaGroupWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	itemsSecond?: GraphQLTypes["StrategySchemaGroupWhere"],
	and?: Array<GraphQLTypes["StrategySchemaWhere"] | undefined>,
	or?: Array<GraphQLTypes["StrategySchemaWhere"] | undefined>,
	not?: GraphQLTypes["StrategySchemaWhere"]
};
	["StrategySchemaGroupWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["StrategySchemaGroupItemWhere"],
	and?: Array<GraphQLTypes["StrategySchemaGroupWhere"] | undefined>,
	or?: Array<GraphQLTypes["StrategySchemaGroupWhere"] | undefined>,
	not?: GraphQLTypes["StrategySchemaGroupWhere"]
};
	["StrategySchemaGroupItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	text?: GraphQLTypes["StringCondition"],
	schema?: GraphQLTypes["StrategySchemaGroupWhere"],
	and?: Array<GraphQLTypes["StrategySchemaGroupItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["StrategySchemaGroupItemWhere"] | undefined>,
	not?: GraphQLTypes["StrategySchemaGroupItemWhere"]
};
	["ContactFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["ContactFormLocaleWhere"],
	and?: Array<GraphQLTypes["ContactFormWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactFormWhere"] | undefined>,
	not?: GraphQLTypes["ContactFormWhere"]
};
	["ContactFormLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	message?: GraphQLTypes["StringCondition"],
	submit?: GraphQLTypes["StringCondition"],
	successMessage?: GraphQLTypes["StringCondition"],
	genericErrorMessage?: GraphQLTypes["StringCondition"],
	contactTypeErrorMessage?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["ContactFormWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	items?: GraphQLTypes["ContactTypeItemWhere"],
	file?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["ContactFormLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactFormLocaleWhere"] | undefined>,
	not?: GraphQLTypes["ContactFormLocaleWhere"]
};
	["ContactTypeItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	subscriptions?: GraphQLTypes["ContactSubscriptionWhere"],
	list?: GraphQLTypes["ContactFormLocaleWhere"],
	and?: Array<GraphQLTypes["ContactTypeItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactTypeItemWhere"] | undefined>,
	not?: GraphQLTypes["ContactTypeItemWhere"]
};
	["ContactSubscriptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	email?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	phone?: GraphQLTypes["StringCondition"],
	message?: GraphQLTypes["StringCondition"],
	file?: GraphQLTypes["FileWhere"],
	contactType?: GraphQLTypes["ContactTypeItemWhere"],
	and?: Array<GraphQLTypes["ContactSubscriptionWhere"] | undefined>,
	or?: Array<GraphQLTypes["ContactSubscriptionWhere"] | undefined>,
	not?: GraphQLTypes["ContactSubscriptionWhere"]
};
	["FileWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	url?: GraphQLTypes["StringCondition"],
	size?: GraphQLTypes["IntCondition"],
	type?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["FileWhere"] | undefined>,
	or?: Array<GraphQLTypes["FileWhere"] | undefined>,
	not?: GraphQLTypes["FileWhere"]
};
	["NewsletterFormWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["NewsletterFormLocaleWhere"],
	and?: Array<GraphQLTypes["NewsletterFormWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterFormWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterFormWhere"]
};
	["NewsletterFormLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	newsletterTypeNote?: GraphQLTypes["StringCondition"],
	email?: GraphQLTypes["StringCondition"],
	emailNote?: GraphQLTypes["StringCondition"],
	submit?: GraphQLTypes["StringCondition"],
	root?: GraphQLTypes["NewsletterFormWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	items?: GraphQLTypes["NewsletterTypeItemWhere"],
	title?: GraphQLTypes["StringCondition"],
	successMessage?: GraphQLTypes["StringCondition"],
	genericErrorMessage?: GraphQLTypes["StringCondition"],
	newsletterTypeErrorMessage?: GraphQLTypes["StringCondition"],
	and?: Array<GraphQLTypes["NewsletterFormLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterFormLocaleWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterFormLocaleWhere"]
};
	["NewsletterTypeItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	title?: GraphQLTypes["StringCondition"],
	list?: GraphQLTypes["NewsletterFormLocaleWhere"],
	subscriptions?: GraphQLTypes["NewsletterSubscriptionWhere"],
	and?: Array<GraphQLTypes["NewsletterTypeItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterTypeItemWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterTypeItemWhere"]
};
	["NewsletterSubscriptionWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	createdAt?: GraphQLTypes["DateTimeCondition"],
	email?: GraphQLTypes["StringCondition"],
	newsletterType?: GraphQLTypes["NewsletterTypeItemWhere"],
	and?: Array<GraphQLTypes["NewsletterSubscriptionWhere"] | undefined>,
	or?: Array<GraphQLTypes["NewsletterSubscriptionWhere"] | undefined>,
	not?: GraphQLTypes["NewsletterSubscriptionWhere"]
};
	["BranchesWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	leadParagraph?: GraphQLTypes["StringCondition"],
	more?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["BranchesWhere"] | undefined>,
	or?: Array<GraphQLTypes["BranchesWhere"] | undefined>,
	not?: GraphQLTypes["BranchesWhere"]
};
	["PageLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	title?: GraphQLTypes["StringCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	root?: GraphQLTypes["PageWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	content?: GraphQLTypes["ContentWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["PageLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageLocaleWhere"] | undefined>,
	not?: GraphQLTypes["PageLocaleWhere"]
};
	["PageWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	locales?: GraphQLTypes["PageLocaleWhere"],
	and?: Array<GraphQLTypes["PageWhere"] | undefined>,
	or?: Array<GraphQLTypes["PageWhere"] | undefined>,
	not?: GraphQLTypes["PageWhere"]
};
	["RedirectWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	link?: GraphQLTypes["LinkableWhere"],
	target?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	or?: Array<GraphQLTypes["RedirectWhere"] | undefined>,
	not?: GraphQLTypes["RedirectWhere"]
};
	["PhotographerWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["PhotographerWhere"] | undefined>,
	or?: Array<GraphQLTypes["PhotographerWhere"] | undefined>,
	not?: GraphQLTypes["PhotographerWhere"]
};
	["HeaderLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	root?: GraphQLTypes["HeaderWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	links?: GraphQLTypes["HeaderLinkWhere"],
	artworkBreadcrumbParentLink?: GraphQLTypes["LinkableWhere"],
	and?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderLocaleWhere"] | undefined>,
	not?: GraphQLTypes["HeaderLocaleWhere"]
};
	["HeaderWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["HeaderLocaleWhere"],
	logo?: GraphQLTypes["ImageWhere"],
	and?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderWhere"] | undefined>,
	not?: GraphQLTypes["HeaderWhere"]
};
	["HeaderLinkWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	link?: GraphQLTypes["LinkWhere"],
	and?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	or?: Array<GraphQLTypes["HeaderLinkWhere"] | undefined>,
	not?: GraphQLTypes["HeaderLinkWhere"]
};
	["SeoDefaultLocaleWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	root?: GraphQLTypes["SeoDefaultWhere"],
	locale?: GraphQLTypes["LocaleWhere"],
	seo?: GraphQLTypes["SeoWhere"],
	and?: Array<GraphQLTypes["SeoDefaultLocaleWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoDefaultLocaleWhere"] | undefined>,
	not?: GraphQLTypes["SeoDefaultLocaleWhere"]
};
	["SeoDefaultWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	unique?: GraphQLTypes["OneCondition"],
	locales?: GraphQLTypes["SeoDefaultLocaleWhere"],
	and?: Array<GraphQLTypes["SeoDefaultWhere"] | undefined>,
	or?: Array<GraphQLTypes["SeoDefaultWhere"] | undefined>,
	not?: GraphQLTypes["SeoDefaultWhere"]
};
	["Locale"]: {
	__typename: "Locale",
	_meta?: GraphQLTypes["LocaleMeta"],
	id: GraphQLTypes["UUID"],
	code: string,
	label?: string,
	contactPages: Array<GraphQLTypes["ContactPageLocale"]>,
	footers: Array<GraphQLTypes["FooterLocale"]>,
	headers: Array<GraphQLTypes["HeaderLocale"]>,
	homePages: Array<GraphQLTypes["HomePageLocale"]>,
	pages: Array<GraphQLTypes["PageLocale"]>,
	seoDefaults: Array<GraphQLTypes["SeoDefaultLocale"]>,
	events: Array<GraphQLTypes["EventLocale"]>,
	artworks: Array<GraphQLTypes["ArtworkLocale"]>,
	artworkSelections: Array<GraphQLTypes["ArtworkSelectionLocale"]>,
	newsletterForms: Array<GraphQLTypes["NewsletterFormLocale"]>,
	employees: Array<GraphQLTypes["EmployeeLocale"]>,
	contactForms: Array<GraphQLTypes["ContactFormLocale"]>,
	contactPagesByRoot?: GraphQLTypes["ContactPageLocale"],
	contactPagesByLink?: GraphQLTypes["ContactPageLocale"],
	contactPagesBySeo?: GraphQLTypes["ContactPageLocale"],
	contactPagesByAddressLink?: GraphQLTypes["ContactPageLocale"],
	footersByRoot?: GraphQLTypes["FooterLocale"],
	footersByDeveloperLink?: GraphQLTypes["FooterLocale"],
	headersByRoot?: GraphQLTypes["HeaderLocale"],
	headersByArtworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocale"],
	homePagesByRoot?: GraphQLTypes["HomePageLocale"],
	homePagesByContent?: GraphQLTypes["HomePageLocale"],
	homePagesByLink?: GraphQLTypes["HomePageLocale"],
	homePagesBySeo?: GraphQLTypes["HomePageLocale"],
	pagesByRoot?: GraphQLTypes["PageLocale"],
	pagesByLink?: GraphQLTypes["PageLocale"],
	pagesByContent?: GraphQLTypes["PageLocale"],
	pagesBySeo?: GraphQLTypes["PageLocale"],
	seoDefaultsByRoot?: GraphQLTypes["SeoDefaultLocale"],
	seoDefaultsBySeo?: GraphQLTypes["SeoDefaultLocale"],
	eventsByRoot?: GraphQLTypes["EventLocale"],
	eventsByImage?: GraphQLTypes["EventLocale"],
	eventsBySeo?: GraphQLTypes["EventLocale"],
	eventsByLink?: GraphQLTypes["EventLocale"],
	eventsByContent?: GraphQLTypes["EventLocale"],
	artworksByRoot?: GraphQLTypes["ArtworkLocale"],
	artworksByContent?: GraphQLTypes["ArtworkLocale"],
	artworksBySeo?: GraphQLTypes["ArtworkLocale"],
	artworksByLink?: GraphQLTypes["ArtworkLocale"],
	artworkSelectionsByRoot?: GraphQLTypes["ArtworkSelectionLocale"],
	artworkSelectionsBySeo?: GraphQLTypes["ArtworkSelectionLocale"],
	artworkSelectionsByLink?: GraphQLTypes["ArtworkSelectionLocale"],
	newsletterFormsByRoot?: GraphQLTypes["NewsletterFormLocale"],
	newsletterFormsByItems?: GraphQLTypes["NewsletterFormLocale"],
	employeesByRoot?: GraphQLTypes["EmployeeLocale"],
	contactFormsByRoot?: GraphQLTypes["ContactFormLocale"],
	contactFormsByItems?: GraphQLTypes["ContactFormLocale"],
	paginateContactPages: GraphQLTypes["ContactPageLocaleConnection"],
	paginateFooters: GraphQLTypes["FooterLocaleConnection"],
	paginateHeaders: GraphQLTypes["HeaderLocaleConnection"],
	paginateHomePages: GraphQLTypes["HomePageLocaleConnection"],
	paginatePages: GraphQLTypes["PageLocaleConnection"],
	paginateSeoDefaults: GraphQLTypes["SeoDefaultLocaleConnection"],
	paginateEvents: GraphQLTypes["EventLocaleConnection"],
	paginateArtworks: GraphQLTypes["ArtworkLocaleConnection"],
	paginateArtworkSelections: GraphQLTypes["ArtworkSelectionLocaleConnection"],
	paginateNewsletterForms: GraphQLTypes["NewsletterFormLocaleConnection"],
	paginateEmployees: GraphQLTypes["EmployeeLocaleConnection"],
	paginateContactForms: GraphQLTypes["ContactFormLocaleConnection"]
};
	["LocaleMeta"]: {
	__typename: "LocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	contactPages?: GraphQLTypes["FieldMeta"],
	footers?: GraphQLTypes["FieldMeta"],
	headers?: GraphQLTypes["FieldMeta"],
	homePages?: GraphQLTypes["FieldMeta"],
	pages?: GraphQLTypes["FieldMeta"],
	seoDefaults?: GraphQLTypes["FieldMeta"],
	events?: GraphQLTypes["FieldMeta"],
	artworks?: GraphQLTypes["FieldMeta"],
	artworkSelections?: GraphQLTypes["FieldMeta"],
	newsletterForms?: GraphQLTypes["FieldMeta"],
	employees?: GraphQLTypes["FieldMeta"],
	contactForms?: GraphQLTypes["FieldMeta"]
};
	["ContactPageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["ContactPageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	address?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	youtube?: GraphQLTypes["OrderDirection"],
	instagram?: GraphQLTypes["OrderDirection"],
	facebook?: GraphQLTypes["OrderDirection"],
	databox?: GraphQLTypes["OrderDirection"],
	databoxNumber?: GraphQLTypes["OrderDirection"],
	addressLink?: GraphQLTypes["LinkOrderBy"],
	socialsLabel?: GraphQLTypes["OrderDirection"],
	openingHours?: GraphQLTypes["OrderDirection"],
	identificationsLabel?: GraphQLTypes["OrderDirection"],
	ico?: GraphQLTypes["OrderDirection"],
	dic?: GraphQLTypes["OrderDirection"],
	phoneLabel?: GraphQLTypes["OrderDirection"],
	emailLabel?: GraphQLTypes["OrderDirection"],
	linkedIn?: GraphQLTypes["OrderDirection"],
	securities?: GraphQLTypes["OrderDirection"],
	securitiesNumber?: GraphQLTypes["OrderDirection"]
};
	["OrderDirection"]: OrderDirection;
	["ContactPageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["LocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"]
};
	["LinkableOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	homePage?: GraphQLTypes["HomePageLocaleOrderBy"],
	contactPage?: GraphQLTypes["ContactPageLocaleOrderBy"],
	page?: GraphQLTypes["PageLocaleOrderBy"],
	event?: GraphQLTypes["EventLocaleOrderBy"],
	artwork?: GraphQLTypes["ArtworkLocaleOrderBy"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionLocaleOrderBy"],
	redirect?: GraphQLTypes["RedirectOrderBy"]
};
	["HomePageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["HomePageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	leadParagraph?: GraphQLTypes["OrderDirection"]
};
	["HomePageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	media?: GraphQLTypes["MediumListOrderBy"]
};
	["MediumListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ContentOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["SeoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	description?: GraphQLTypes["OrderDirection"],
	ogTitle?: GraphQLTypes["OrderDirection"],
	ogDescription?: GraphQLTypes["OrderDirection"],
	noIndex?: GraphQLTypes["OrderDirection"],
	noFollow?: GraphQLTypes["OrderDirection"],
	ogImage?: GraphQLTypes["ImageOrderBy"]
};
	["ImageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	alt?: GraphQLTypes["OrderDirection"]
};
	["PageLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	root?: GraphQLTypes["PageOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["PageOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["EventLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["EventOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	venue?: GraphQLTypes["OrderDirection"],
	venueNote?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"],
	date?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	isDark?: GraphQLTypes["OrderDirection"]
};
	["EventOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	dateStart?: GraphQLTypes["OrderDirection"],
	dateFinish?: GraphQLTypes["OrderDirection"]
};
	["ArtworkLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	label?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["ArtworkOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	content?: GraphQLTypes["ContentOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"],
	artist?: GraphQLTypes["OrderDirection"]
};
	["ArtworkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	gallery?: GraphQLTypes["GalleryOrderBy"]
};
	["GalleryOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ArtworkSelectionLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["ArtworkSelectionOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"],
	link?: GraphQLTypes["LinkableOrderBy"]
};
	["ArtworkSelectionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	artworks?: GraphQLTypes["ArtworkSelectionListOrderBy"]
};
	["ArtworkSelectionListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["RedirectOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkableOrderBy"],
	target?: GraphQLTypes["LinkableOrderBy"]
};
	["LinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	externalLink?: GraphQLTypes["OrderDirection"],
	internalLink?: GraphQLTypes["LinkableOrderBy"],
	anchorLink?: GraphQLTypes["OrderDirection"]
};
	["FooterLocale"]: {
	__typename: "FooterLocale",
	_meta?: GraphQLTypes["FooterLocaleMeta"],
	id: GraphQLTypes["UUID"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	root?: GraphQLTypes["Footer"],
	locale?: GraphQLTypes["Locale"],
	graphicDesigners: Array<GraphQLTypes["GraphicDesigner"]>,
	developerLink?: GraphQLTypes["Link"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers: Array<GraphQLTypes["Photographer"]>,
	paginateGraphicDesigners: GraphQLTypes["GraphicDesignerConnection"],
	paginatePhotographers: GraphQLTypes["PhotographerConnection"]
};
	["FooterLocaleMeta"]: {
	__typename: "FooterLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	address?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	youtube?: GraphQLTypes["FieldMeta"],
	instagram?: GraphQLTypes["FieldMeta"],
	facebook?: GraphQLTypes["FieldMeta"],
	graphicDesign?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	graphicDesigners?: GraphQLTypes["FieldMeta"],
	developerLink?: GraphQLTypes["FieldMeta"],
	development?: GraphQLTypes["FieldMeta"],
	linkedIn?: GraphQLTypes["FieldMeta"],
	photography?: GraphQLTypes["FieldMeta"],
	photographers?: GraphQLTypes["FieldMeta"]
};
	["Footer"]: {
	__typename: "Footer",
	_meta?: GraphQLTypes["FooterMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	logo?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["FooterLocale"]>,
	localesByLocale?: GraphQLTypes["FooterLocale"],
	localesByDeveloperLink?: GraphQLTypes["FooterLocale"],
	paginateLocales: GraphQLTypes["FooterLocaleConnection"]
};
	["FooterMeta"]: {
	__typename: "FooterMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["Image"]: {
	__typename: "Image",
	_meta?: GraphQLTypes["ImageMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string
};
	["ImageMeta"]: {
	__typename: "ImageMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	alt?: GraphQLTypes["FieldMeta"]
};
	["FooterLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	address?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	youtube?: GraphQLTypes["OrderDirection"],
	instagram?: GraphQLTypes["OrderDirection"],
	facebook?: GraphQLTypes["OrderDirection"],
	graphicDesign?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["FooterOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	developerLink?: GraphQLTypes["LinkOrderBy"],
	development?: GraphQLTypes["OrderDirection"],
	linkedIn?: GraphQLTypes["OrderDirection"],
	photography?: GraphQLTypes["OrderDirection"]
};
	["FooterOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["FooterLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["LocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	contactPages?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	footers?: GraphQLTypes["FooterLocaleUniqueWhere"],
	headers?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	homePages?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	pages?: GraphQLTypes["PageLocaleUniqueWhere"],
	seoDefaults?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	events?: GraphQLTypes["EventLocaleUniqueWhere"],
	artworks?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	artworkSelections?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	newsletterForms?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	employees?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	contactForms?: GraphQLTypes["ContactFormLocaleUniqueWhere"]
};
	["ContactPageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["ContactPageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	addressLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContactPageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["ContactPageLocaleUniqueWhere"]
};
	["LinkableUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	contactPage?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	page?: GraphQLTypes["PageLocaleUniqueWhere"],
	event?: GraphQLTypes["EventLocaleUniqueWhere"],
	artwork?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	redirect?: GraphQLTypes["RedirectUniqueWhere"]
};
	["HomePageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["HomePageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["HomePageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	media?: GraphQLTypes["MediumListUniqueWhere"]
};
	["MediumListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["MediumItemUniqueWhere"]
};
	["MediumItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ContentUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: GraphQLTypes["ContentBlockUniqueWhere"]
};
	["ContentBlockUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentReferenceUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	media?: GraphQLTypes["MediumListUniqueWhere"],
	link?: GraphQLTypes["LinkUniqueWhere"],
	dropDownList?: GraphQLTypes["DropDownListUniqueWhere"],
	eventList?: GraphQLTypes["EventListUniqueWhere"],
	boxList?: GraphQLTypes["BoxListUniqueWhere"],
	chart?: GraphQLTypes["ChartUniqueWhere"],
	definitionList?: GraphQLTypes["DefinitionListUniqueWhere"],
	logoList?: GraphQLTypes["LogoListUniqueWhere"],
	strategySchema?: GraphQLTypes["StrategySchemaUniqueWhere"],
	employeeList?: GraphQLTypes["EmployeeListUniqueWhere"]
};
	["LinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["DropDownListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["DropDownItemUniqueWhere"],
	employees?: GraphQLTypes["EmployeeListUniqueWhere"]
};
	["DropDownItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["EmployeeListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["EmployeeItemUniqueWhere"]
};
	["EmployeeItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["EventListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["EventItemUniqueWhere"]
};
	["EventItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["BoxListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["BoxItemUniqueWhere"]
};
	["BoxItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ChartUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ChartDataUniqueWhere"]
};
	["ChartDataUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["DefinitionListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["DefinitionItemUniqueWhere"]
};
	["DefinitionItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["LogoListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["LogoItemUniqueWhere"]
};
	["LogoItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["StrategySchemaUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	itemsFirst?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	itemsSecond?: GraphQLTypes["StrategySchemaGroupUniqueWhere"]
};
	["StrategySchemaGroupUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"]
};
	["StrategySchemaGroupItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ImageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["SeoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	ogImage?: GraphQLTypes["ImageUniqueWhere"]
};
	["PageLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["PageUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["PageUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["PageLocaleUniqueWhere"]
};
	["EventLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EventUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"]
};
	["EventUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["EventLocaleUniqueWhere"]
};
	["ArtworkLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["ArtworkUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	content?: GraphQLTypes["ContentUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ArtworkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	gallery?: GraphQLTypes["GalleryUniqueWhere"]
};
	["GalleryUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["GalleryItemUniqueWhere"]
};
	["GalleryItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ArtworkSelectionLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["ArtworkSelectionUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ArtworkSelectionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	locales?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	artworks?: GraphQLTypes["ArtworkSelectionListUniqueWhere"]
};
	["ArtworkSelectionListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"]
};
	["ArtworkSelectionItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["RedirectUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["FooterLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["FooterUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	developerLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["ImageUniqueWhere"],
	locales?: GraphQLTypes["FooterLocaleUniqueWhere"]
};
	["HeaderLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["HeaderUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	artworkBreadcrumbParentLink?: GraphQLTypes["LinkableUniqueWhere"]
};
	["HeaderUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	logo?: GraphQLTypes["ImageUniqueWhere"]
};
	["SeoDefaultLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoDefaultUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SeoDefaultUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"]
};
	["NewsletterFormLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["NewsletterFormUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	items?: GraphQLTypes["NewsletterTypeItemUniqueWhere"]
};
	["NewsletterFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"]
};
	["NewsletterTypeItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	subscriptions?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"]
};
	["NewsletterSubscriptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["EmployeeLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["EmployeeUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["EmployeeUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	image?: GraphQLTypes["ImageUniqueWhere"],
	locales?: GraphQLTypes["EmployeeLocaleUniqueWhere"]
};
	["ContactFormLocaleUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["ContactFormUniqueWhere"],
	locale?: GraphQLTypes["LocaleUniqueWhere"],
	items?: GraphQLTypes["ContactTypeItemUniqueWhere"]
};
	["ContactFormUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: GraphQLTypes["ContactFormLocaleUniqueWhere"]
};
	["ContactTypeItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	subscriptions?: GraphQLTypes["ContactSubscriptionUniqueWhere"]
};
	["ContactSubscriptionUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	file?: GraphQLTypes["FileUniqueWhere"]
};
	["FileUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["FooterLocalesByDeveloperLinkUniqueWhere"]: {
		developerLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["FooterLocaleConnection"]: {
	__typename: "FooterLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterLocaleEdge"]>
};
	["PageInfo"]: {
	__typename: "PageInfo",
	totalCount: number
};
	["FooterLocaleEdge"]: {
	__typename: "FooterLocaleEdge",
	node: GraphQLTypes["FooterLocale"]
};
	["GraphicDesigner"]: {
	__typename: "GraphicDesigner",
	_meta?: GraphQLTypes["GraphicDesignerMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["GraphicDesignerMeta"]: {
	__typename: "GraphicDesignerMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["Link"]: {
	__typename: "Link",
	_meta?: GraphQLTypes["LinkMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["Linkable"],
	anchorLink?: string
};
	["LinkMeta"]: {
	__typename: "LinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	externalLink?: GraphQLTypes["FieldMeta"],
	internalLink?: GraphQLTypes["FieldMeta"],
	anchorLink?: GraphQLTypes["FieldMeta"]
};
	["Linkable"]: {
	__typename: "Linkable",
	_meta?: GraphQLTypes["LinkableMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	homePage?: GraphQLTypes["HomePageLocale"],
	contactPage?: GraphQLTypes["ContactPageLocale"],
	page?: GraphQLTypes["PageLocale"],
	event?: GraphQLTypes["EventLocale"],
	artwork?: GraphQLTypes["ArtworkLocale"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionLocale"],
	redirect?: GraphQLTypes["Redirect"]
};
	["LinkableMeta"]: {
	__typename: "LinkableMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	homePage?: GraphQLTypes["FieldMeta"],
	contactPage?: GraphQLTypes["FieldMeta"],
	page?: GraphQLTypes["FieldMeta"],
	event?: GraphQLTypes["FieldMeta"],
	artwork?: GraphQLTypes["FieldMeta"],
	artworkSelection?: GraphQLTypes["FieldMeta"],
	redirect?: GraphQLTypes["FieldMeta"]
};
	["HomePageLocale"]: {
	__typename: "HomePageLocale",
	_meta?: GraphQLTypes["HomePageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["HomePage"],
	locale?: GraphQLTypes["Locale"],
	content?: GraphQLTypes["Content"],
	link?: GraphQLTypes["Linkable"],
	seo?: GraphQLTypes["Seo"],
	branches: Array<GraphQLTypes["Branches"]>,
	leadParagraph?: string,
	paginateBranches: GraphQLTypes["BranchesConnection"]
};
	["HomePageLocaleMeta"]: {
	__typename: "HomePageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	branches?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"]
};
	["HomePage"]: {
	__typename: "HomePage",
	_meta?: GraphQLTypes["HomePageMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["HomePageLocale"]>,
	media?: GraphQLTypes["MediumList"],
	localesByLocale?: GraphQLTypes["HomePageLocale"],
	localesByContent?: GraphQLTypes["HomePageLocale"],
	localesByLink?: GraphQLTypes["HomePageLocale"],
	localesBySeo?: GraphQLTypes["HomePageLocale"],
	paginateLocales: GraphQLTypes["HomePageLocaleConnection"]
};
	["HomePageMeta"]: {
	__typename: "HomePageMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	media?: GraphQLTypes["FieldMeta"]
};
	["MediumList"]: {
	__typename: "MediumList",
	_meta?: GraphQLTypes["MediumListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["MediumItem"]>,
	paginateItems: GraphQLTypes["MediumItemConnection"]
};
	["MediumListMeta"]: {
	__typename: "MediumListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["MediumItem"]: {
	__typename: "MediumItem",
	_meta?: GraphQLTypes["MediumItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["MediumList"],
	medium?: GraphQLTypes["Medium"]
};
	["MediumItemMeta"]: {
	__typename: "MediumItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	medium?: GraphQLTypes["FieldMeta"]
};
	["Medium"]: {
	__typename: "Medium",
	_meta?: GraphQLTypes["MediumMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["Image"],
	video?: GraphQLTypes["Video"],
	youtubeEmbed?: string
};
	["MediumMeta"]: {
	__typename: "MediumMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	video?: GraphQLTypes["FieldMeta"],
	youtubeEmbed?: GraphQLTypes["FieldMeta"]
};
	["Video"]: {
	__typename: "Video",
	_meta?: GraphQLTypes["VideoMeta"],
	id: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["Image"]
};
	["VideoMeta"]: {
	__typename: "VideoMeta",
	id?: GraphQLTypes["FieldMeta"],
	src?: GraphQLTypes["FieldMeta"],
	width?: GraphQLTypes["FieldMeta"],
	height?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	duration?: GraphQLTypes["FieldMeta"],
	poster?: GraphQLTypes["FieldMeta"]
};
	["MediumItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["MediumListOrderBy"],
	medium?: GraphQLTypes["MediumOrderBy"]
};
	["MediumOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"],
	video?: GraphQLTypes["VideoOrderBy"],
	youtubeEmbed?: GraphQLTypes["OrderDirection"]
};
	["VideoOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	src?: GraphQLTypes["OrderDirection"],
	width?: GraphQLTypes["OrderDirection"],
	height?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	duration?: GraphQLTypes["OrderDirection"],
	poster?: GraphQLTypes["ImageOrderBy"]
};
	["MediumItemConnection"]: {
	__typename: "MediumItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumItemEdge"]>
};
	["MediumItemEdge"]: {
	__typename: "MediumItemEdge",
	node: GraphQLTypes["MediumItem"]
};
	["HomePageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["HomePageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["HomePageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["HomePageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["HomePageLocaleConnection"]: {
	__typename: "HomePageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageLocaleEdge"]>
};
	["HomePageLocaleEdge"]: {
	__typename: "HomePageLocaleEdge",
	node: GraphQLTypes["HomePageLocale"]
};
	["Content"]: {
	__typename: "Content",
	_meta?: GraphQLTypes["ContentMeta"],
	id: GraphQLTypes["UUID"],
	blocks: Array<GraphQLTypes["ContentBlock"]>,
	blocksByReferences?: GraphQLTypes["ContentBlock"],
	paginateBlocks: GraphQLTypes["ContentBlockConnection"]
};
	["ContentMeta"]: {
	__typename: "ContentMeta",
	id?: GraphQLTypes["FieldMeta"],
	blocks?: GraphQLTypes["FieldMeta"]
};
	["ContentBlock"]: {
	__typename: "ContentBlock",
	_meta?: GraphQLTypes["ContentBlockMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	json: string,
	content?: GraphQLTypes["Content"],
	references: Array<GraphQLTypes["ContentReference"]>,
	referencesByMedia?: GraphQLTypes["ContentReference"],
	referencesByLink?: GraphQLTypes["ContentReference"],
	referencesByDropDownList?: GraphQLTypes["ContentReference"],
	referencesByEventList?: GraphQLTypes["ContentReference"],
	referencesByBoxList?: GraphQLTypes["ContentReference"],
	referencesByChart?: GraphQLTypes["ContentReference"],
	referencesByDefinitionList?: GraphQLTypes["ContentReference"],
	referencesByLogoList?: GraphQLTypes["ContentReference"],
	referencesByStrategySchema?: GraphQLTypes["ContentReference"],
	referencesByEmployeeList?: GraphQLTypes["ContentReference"],
	paginateReferences: GraphQLTypes["ContentReferenceConnection"]
};
	["ContentBlockMeta"]: {
	__typename: "ContentBlockMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	json?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	references?: GraphQLTypes["FieldMeta"]
};
	["ContentReference"]: {
	__typename: "ContentReference",
	_meta?: GraphQLTypes["ContentReferenceMeta"],
	id: GraphQLTypes["UUID"],
	type: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	block?: GraphQLTypes["ContentBlock"],
	media?: GraphQLTypes["MediumList"],
	link?: GraphQLTypes["Link"],
	secondaryText?: string,
	dropDownList?: GraphQLTypes["DropDownList"],
	artworkSelection?: GraphQLTypes["ArtworkSelection"],
	eventList?: GraphQLTypes["EventList"],
	boxList?: GraphQLTypes["BoxList"],
	isVisible?: boolean,
	chart?: GraphQLTypes["Chart"],
	definitionList?: GraphQLTypes["DefinitionList"],
	logoList?: GraphQLTypes["LogoList"],
	strategySchema?: GraphQLTypes["StrategySchema"],
	image?: GraphQLTypes["Image"],
	employeeList?: GraphQLTypes["EmployeeList"],
	imageSecond?: GraphQLTypes["Image"],
	contactForm?: GraphQLTypes["ContactForm"],
	newsletterForm?: GraphQLTypes["NewsletterForm"]
};
	["ContentReferenceMeta"]: {
	__typename: "ContentReferenceMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	primaryText?: GraphQLTypes["FieldMeta"],
	block?: GraphQLTypes["FieldMeta"],
	media?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	secondaryText?: GraphQLTypes["FieldMeta"],
	dropDownList?: GraphQLTypes["FieldMeta"],
	artworkSelection?: GraphQLTypes["FieldMeta"],
	eventList?: GraphQLTypes["FieldMeta"],
	boxList?: GraphQLTypes["FieldMeta"],
	isVisible?: GraphQLTypes["FieldMeta"],
	chart?: GraphQLTypes["FieldMeta"],
	definitionList?: GraphQLTypes["FieldMeta"],
	logoList?: GraphQLTypes["FieldMeta"],
	strategySchema?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	employeeList?: GraphQLTypes["FieldMeta"],
	imageSecond?: GraphQLTypes["FieldMeta"],
	contactForm?: GraphQLTypes["FieldMeta"],
	newsletterForm?: GraphQLTypes["FieldMeta"]
};
	["DropDownList"]: {
	__typename: "DropDownList",
	_meta?: GraphQLTypes["DropDownListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["DropDownItem"]>,
	dropDownType?: GraphQLTypes["DropDownType"],
	employees?: GraphQLTypes["EmployeeList"],
	itemsByLink?: GraphQLTypes["DropDownItem"],
	paginateItems: GraphQLTypes["DropDownItemConnection"]
};
	["DropDownListMeta"]: {
	__typename: "DropDownListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	dropDownType?: GraphQLTypes["FieldMeta"],
	employees?: GraphQLTypes["FieldMeta"]
};
	["DropDownItem"]: {
	__typename: "DropDownItem",
	_meta?: GraphQLTypes["DropDownItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["DropDownList"],
	link?: GraphQLTypes["Link"]
};
	["DropDownItemMeta"]: {
	__typename: "DropDownItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["DropDownItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["DropDownListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["DropDownListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	dropDownType?: GraphQLTypes["OrderDirection"],
	employees?: GraphQLTypes["EmployeeListOrderBy"]
};
	["EmployeeListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["EmployeeList"]: {
	__typename: "EmployeeList",
	_meta?: GraphQLTypes["EmployeeListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["EmployeeItem"]>,
	paginateItems: GraphQLTypes["EmployeeItemConnection"]
};
	["EmployeeListMeta"]: {
	__typename: "EmployeeListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["EmployeeItem"]: {
	__typename: "EmployeeItem",
	_meta?: GraphQLTypes["EmployeeItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["EmployeeList"],
	employee?: GraphQLTypes["Employee"]
};
	["EmployeeItemMeta"]: {
	__typename: "EmployeeItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	employee?: GraphQLTypes["FieldMeta"]
};
	["Employee"]: {
	__typename: "Employee",
	_meta?: GraphQLTypes["EmployeeMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	name?: string,
	image?: GraphQLTypes["Image"],
	locales: Array<GraphQLTypes["EmployeeLocale"]>,
	localesByLocale?: GraphQLTypes["EmployeeLocale"],
	paginateLocales: GraphQLTypes["EmployeeLocaleConnection"]
};
	["EmployeeMeta"]: {
	__typename: "EmployeeMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["EmployeeLocale"]: {
	__typename: "EmployeeLocale",
	_meta?: GraphQLTypes["EmployeeLocaleMeta"],
	id: GraphQLTypes["UUID"],
	position?: string,
	text?: string,
	email?: string,
	phone?: string,
	root?: GraphQLTypes["Employee"],
	locale?: GraphQLTypes["Locale"]
};
	["EmployeeLocaleMeta"]: {
	__typename: "EmployeeLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	position?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"]
};
	["EmployeeLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	position?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["EmployeeOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"]
};
	["EmployeeOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["EmployeeLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["EmployeeLocaleConnection"]: {
	__typename: "EmployeeLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeLocaleEdge"]>
};
	["EmployeeLocaleEdge"]: {
	__typename: "EmployeeLocaleEdge",
	node: GraphQLTypes["EmployeeLocale"]
};
	["EmployeeItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["EmployeeListOrderBy"],
	employee?: GraphQLTypes["EmployeeOrderBy"]
};
	["EmployeeItemConnection"]: {
	__typename: "EmployeeItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeItemEdge"]>
};
	["EmployeeItemEdge"]: {
	__typename: "EmployeeItemEdge",
	node: GraphQLTypes["EmployeeItem"]
};
	["DropDownListItemsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["DropDownItemConnection"]: {
	__typename: "DropDownItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DropDownItemEdge"]>
};
	["DropDownItemEdge"]: {
	__typename: "DropDownItemEdge",
	node: GraphQLTypes["DropDownItem"]
};
	["ArtworkSelection"]: {
	__typename: "ArtworkSelection",
	_meta?: GraphQLTypes["ArtworkSelectionMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["ArtworkSelectionLocale"]>,
	artworks?: GraphQLTypes["ArtworkSelectionList"],
	localesByLocale?: GraphQLTypes["ArtworkSelectionLocale"],
	localesBySeo?: GraphQLTypes["ArtworkSelectionLocale"],
	localesByLink?: GraphQLTypes["ArtworkSelectionLocale"],
	paginateLocales: GraphQLTypes["ArtworkSelectionLocaleConnection"]
};
	["ArtworkSelectionMeta"]: {
	__typename: "ArtworkSelectionMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	artworks?: GraphQLTypes["FieldMeta"]
};
	["ArtworkSelectionLocale"]: {
	__typename: "ArtworkSelectionLocale",
	_meta?: GraphQLTypes["ArtworkSelectionLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ArtworkSelection"],
	locale?: GraphQLTypes["Locale"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"]
};
	["ArtworkSelectionLocaleMeta"]: {
	__typename: "ArtworkSelectionLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["Seo"]: {
	__typename: "Seo",
	_meta?: GraphQLTypes["SeoMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	noIndex?: boolean,
	noFollow?: boolean,
	ogImage?: GraphQLTypes["Image"]
};
	["SeoMeta"]: {
	__typename: "SeoMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	description?: GraphQLTypes["FieldMeta"],
	ogTitle?: GraphQLTypes["FieldMeta"],
	ogDescription?: GraphQLTypes["FieldMeta"],
	noIndex?: GraphQLTypes["FieldMeta"],
	noFollow?: GraphQLTypes["FieldMeta"],
	ogImage?: GraphQLTypes["FieldMeta"]
};
	["ArtworkSelectionList"]: {
	__typename: "ArtworkSelectionList",
	_meta?: GraphQLTypes["ArtworkSelectionListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ArtworkSelectionItem"]>,
	paginateItems: GraphQLTypes["ArtworkSelectionItemConnection"]
};
	["ArtworkSelectionListMeta"]: {
	__typename: "ArtworkSelectionListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ArtworkSelectionItem"]: {
	__typename: "ArtworkSelectionItem",
	_meta?: GraphQLTypes["ArtworkSelectionItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ArtworkSelectionList"],
	artwork?: GraphQLTypes["Artwork"]
};
	["ArtworkSelectionItemMeta"]: {
	__typename: "ArtworkSelectionItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	artwork?: GraphQLTypes["FieldMeta"]
};
	["Artwork"]: {
	__typename: "Artwork",
	_meta?: GraphQLTypes["ArtworkMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	locales: Array<GraphQLTypes["ArtworkLocale"]>,
	image?: GraphQLTypes["Image"],
	gallery?: GraphQLTypes["Gallery"],
	localesByLocale?: GraphQLTypes["ArtworkLocale"],
	localesByContent?: GraphQLTypes["ArtworkLocale"],
	localesBySeo?: GraphQLTypes["ArtworkLocale"],
	localesByLink?: GraphQLTypes["ArtworkLocale"],
	paginateLocales: GraphQLTypes["ArtworkLocaleConnection"]
};
	["ArtworkMeta"]: {
	__typename: "ArtworkMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	gallery?: GraphQLTypes["FieldMeta"]
};
	["ArtworkLocale"]: {
	__typename: "ArtworkLocale",
	_meta?: GraphQLTypes["ArtworkLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["Artwork"],
	locale?: GraphQLTypes["Locale"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	artist?: string
};
	["ArtworkLocaleMeta"]: {
	__typename: "ArtworkLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	label?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	artist?: GraphQLTypes["FieldMeta"]
};
	["Gallery"]: {
	__typename: "Gallery",
	_meta?: GraphQLTypes["GalleryMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["GalleryItem"]>,
	paginateItems: GraphQLTypes["GalleryItemConnection"]
};
	["GalleryMeta"]: {
	__typename: "GalleryMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["GalleryItem"]: {
	__typename: "GalleryItem",
	_meta?: GraphQLTypes["GalleryItemMeta"],
	id: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["Gallery"],
	image?: GraphQLTypes["Image"]
};
	["GalleryItemMeta"]: {
	__typename: "GalleryItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["GalleryItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["GalleryOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["GalleryItemConnection"]: {
	__typename: "GalleryItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryItemEdge"]>
};
	["GalleryItemEdge"]: {
	__typename: "GalleryItemEdge",
	node: GraphQLTypes["GalleryItem"]
};
	["ArtworkLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["ArtworkLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["ArtworkLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ArtworkLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ArtworkLocaleConnection"]: {
	__typename: "ArtworkLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkLocaleEdge"]>
};
	["ArtworkLocaleEdge"]: {
	__typename: "ArtworkLocaleEdge",
	node: GraphQLTypes["ArtworkLocale"]
};
	["ArtworkSelectionItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ArtworkSelectionListOrderBy"],
	artwork?: GraphQLTypes["ArtworkOrderBy"]
};
	["ArtworkSelectionItemConnection"]: {
	__typename: "ArtworkSelectionItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkSelectionItemEdge"]>
};
	["ArtworkSelectionItemEdge"]: {
	__typename: "ArtworkSelectionItemEdge",
	node: GraphQLTypes["ArtworkSelectionItem"]
};
	["ArtworkSelectionLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["ArtworkSelectionLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ArtworkSelectionLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ArtworkSelectionLocaleConnection"]: {
	__typename: "ArtworkSelectionLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkSelectionLocaleEdge"]>
};
	["ArtworkSelectionLocaleEdge"]: {
	__typename: "ArtworkSelectionLocaleEdge",
	node: GraphQLTypes["ArtworkSelectionLocale"]
};
	["EventList"]: {
	__typename: "EventList",
	_meta?: GraphQLTypes["EventListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["EventItem"]>,
	paginateItems: GraphQLTypes["EventItemConnection"]
};
	["EventListMeta"]: {
	__typename: "EventListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["EventItem"]: {
	__typename: "EventItem",
	_meta?: GraphQLTypes["EventItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["EventList"],
	event?: GraphQLTypes["Event"]
};
	["EventItemMeta"]: {
	__typename: "EventItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	event?: GraphQLTypes["FieldMeta"]
};
	["Event"]: {
	__typename: "Event",
	_meta?: GraphQLTypes["EventMeta"],
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["EventLocale"]>,
	order: number,
	dateStart?: GraphQLTypes["DateTime"],
	dateFinish?: GraphQLTypes["DateTime"],
	localesByLocale?: GraphQLTypes["EventLocale"],
	localesByImage?: GraphQLTypes["EventLocale"],
	localesBySeo?: GraphQLTypes["EventLocale"],
	localesByLink?: GraphQLTypes["EventLocale"],
	localesByContent?: GraphQLTypes["EventLocale"],
	paginateLocales: GraphQLTypes["EventLocaleConnection"]
};
	["EventMeta"]: {
	__typename: "EventMeta",
	id?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	dateStart?: GraphQLTypes["FieldMeta"],
	dateFinish?: GraphQLTypes["FieldMeta"]
};
	["EventLocale"]: {
	__typename: "EventLocale",
	_meta?: GraphQLTypes["EventLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["Event"],
	locale?: GraphQLTypes["Locale"],
	image?: GraphQLTypes["Image"],
	seo?: GraphQLTypes["Seo"],
	link?: GraphQLTypes["Linkable"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["Content"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean
};
	["EventLocaleMeta"]: {
	__typename: "EventLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	venue?: GraphQLTypes["FieldMeta"],
	venueNote?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	date?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	isDark?: GraphQLTypes["FieldMeta"]
};
	["EventLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["EventLocalesByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["EventLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["EventLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["EventLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["EventLocaleConnection"]: {
	__typename: "EventLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventLocaleEdge"]>
};
	["EventLocaleEdge"]: {
	__typename: "EventLocaleEdge",
	node: GraphQLTypes["EventLocale"]
};
	["EventItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["EventListOrderBy"],
	event?: GraphQLTypes["EventOrderBy"]
};
	["EventListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["EventItemConnection"]: {
	__typename: "EventItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventItemEdge"]>
};
	["EventItemEdge"]: {
	__typename: "EventItemEdge",
	node: GraphQLTypes["EventItem"]
};
	["BoxList"]: {
	__typename: "BoxList",
	_meta?: GraphQLTypes["BoxListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["BoxItem"]>,
	paginateItems: GraphQLTypes["BoxItemConnection"]
};
	["BoxListMeta"]: {
	__typename: "BoxListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["BoxItem"]: {
	__typename: "BoxItem",
	_meta?: GraphQLTypes["BoxItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: string,
	date?: string,
	type?: string,
	title?: string,
	text?: string,
	list?: GraphQLTypes["BoxList"]
};
	["BoxItemMeta"]: {
	__typename: "BoxItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	date?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["BoxItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["OrderDirection"],
	date?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["BoxListOrderBy"]
};
	["BoxListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["BoxItemConnection"]: {
	__typename: "BoxItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BoxItemEdge"]>
};
	["BoxItemEdge"]: {
	__typename: "BoxItemEdge",
	node: GraphQLTypes["BoxItem"]
};
	["Chart"]: {
	__typename: "Chart",
	_meta?: GraphQLTypes["ChartMeta"],
	id: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ChartType"],
	items: Array<GraphQLTypes["ChartData"]>,
	paginateItems: GraphQLTypes["ChartDataConnection"]
};
	["ChartMeta"]: {
	__typename: "ChartMeta",
	id?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ChartData"]: {
	__typename: "ChartData",
	_meta?: GraphQLTypes["ChartDataMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["Chart"],
	date?: GraphQLTypes["Date"],
	number?: number,
	text?: string,
	image?: GraphQLTypes["Image"]
};
	["ChartDataMeta"]: {
	__typename: "ChartDataMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	date?: GraphQLTypes["FieldMeta"],
	number?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["ChartDataOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ChartOrderBy"],
	date?: GraphQLTypes["OrderDirection"],
	number?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["ChartOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"]
};
	["ChartDataConnection"]: {
	__typename: "ChartDataConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChartDataEdge"]>
};
	["ChartDataEdge"]: {
	__typename: "ChartDataEdge",
	node: GraphQLTypes["ChartData"]
};
	["DefinitionList"]: {
	__typename: "DefinitionList",
	_meta?: GraphQLTypes["DefinitionListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["DefinitionItem"]>,
	paginateItems: GraphQLTypes["DefinitionItemConnection"]
};
	["DefinitionListMeta"]: {
	__typename: "DefinitionListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["DefinitionItem"]: {
	__typename: "DefinitionItem",
	_meta?: GraphQLTypes["DefinitionItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	key?: string,
	value?: string,
	list?: GraphQLTypes["DefinitionList"]
};
	["DefinitionItemMeta"]: {
	__typename: "DefinitionItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["DefinitionItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	key?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["DefinitionListOrderBy"]
};
	["DefinitionListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["DefinitionItemConnection"]: {
	__typename: "DefinitionItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DefinitionItemEdge"]>
};
	["DefinitionItemEdge"]: {
	__typename: "DefinitionItemEdge",
	node: GraphQLTypes["DefinitionItem"]
};
	["LogoList"]: {
	__typename: "LogoList",
	_meta?: GraphQLTypes["LogoListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["LogoItem"]>,
	paginateItems: GraphQLTypes["LogoItemConnection"]
};
	["LogoListMeta"]: {
	__typename: "LogoListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["LogoItem"]: {
	__typename: "LogoItem",
	_meta?: GraphQLTypes["LogoItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["LogoList"],
	image?: GraphQLTypes["Image"]
};
	["LogoItemMeta"]: {
	__typename: "LogoItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	image?: GraphQLTypes["FieldMeta"]
};
	["LogoItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["LogoListOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"]
};
	["LogoListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["LogoItemConnection"]: {
	__typename: "LogoItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LogoItemEdge"]>
};
	["LogoItemEdge"]: {
	__typename: "LogoItemEdge",
	node: GraphQLTypes["LogoItem"]
};
	["StrategySchema"]: {
	__typename: "StrategySchema",
	_meta?: GraphQLTypes["StrategySchemaMeta"],
	id: GraphQLTypes["UUID"],
	inputFirst?: string,
	inputSecond?: string,
	inputThird?: string,
	outputFirst?: string,
	outputSecond?: string,
	outputThird?: string,
	itemsFirst?: GraphQLTypes["StrategySchemaGroup"],
	logo?: GraphQLTypes["Image"],
	itemsSecond?: GraphQLTypes["StrategySchemaGroup"]
};
	["StrategySchemaMeta"]: {
	__typename: "StrategySchemaMeta",
	id?: GraphQLTypes["FieldMeta"],
	inputFirst?: GraphQLTypes["FieldMeta"],
	inputSecond?: GraphQLTypes["FieldMeta"],
	inputThird?: GraphQLTypes["FieldMeta"],
	outputFirst?: GraphQLTypes["FieldMeta"],
	outputSecond?: GraphQLTypes["FieldMeta"],
	outputThird?: GraphQLTypes["FieldMeta"],
	itemsFirst?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"],
	itemsSecond?: GraphQLTypes["FieldMeta"]
};
	["StrategySchemaGroup"]: {
	__typename: "StrategySchemaGroup",
	_meta?: GraphQLTypes["StrategySchemaGroupMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["StrategySchemaGroupItem"]>,
	paginateItems: GraphQLTypes["StrategySchemaGroupItemConnection"]
};
	["StrategySchemaGroupMeta"]: {
	__typename: "StrategySchemaGroupMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["StrategySchemaGroupItem"]: {
	__typename: "StrategySchemaGroupItem",
	_meta?: GraphQLTypes["StrategySchemaGroupItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	text?: string,
	schema?: GraphQLTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupItemMeta"]: {
	__typename: "StrategySchemaGroupItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	text?: GraphQLTypes["FieldMeta"],
	schema?: GraphQLTypes["FieldMeta"]
};
	["StrategySchemaGroupItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	text?: GraphQLTypes["OrderDirection"],
	schema?: GraphQLTypes["StrategySchemaGroupOrderBy"]
};
	["StrategySchemaGroupOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["StrategySchemaGroupItemConnection"]: {
	__typename: "StrategySchemaGroupItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StrategySchemaGroupItemEdge"]>
};
	["StrategySchemaGroupItemEdge"]: {
	__typename: "StrategySchemaGroupItemEdge",
	node: GraphQLTypes["StrategySchemaGroupItem"]
};
	["ContactForm"]: {
	__typename: "ContactForm",
	_meta?: GraphQLTypes["ContactFormMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["ContactFormLocale"]>,
	localesByLocale?: GraphQLTypes["ContactFormLocale"],
	localesByItems?: GraphQLTypes["ContactFormLocale"],
	paginateLocales: GraphQLTypes["ContactFormLocaleConnection"]
};
	["ContactFormMeta"]: {
	__typename: "ContactFormMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["ContactFormLocale"]: {
	__typename: "ContactFormLocale",
	_meta?: GraphQLTypes["ContactFormLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactForm"],
	locale?: GraphQLTypes["Locale"],
	items: Array<GraphQLTypes["ContactTypeItem"]>,
	file?: string,
	itemsBySubscriptions?: GraphQLTypes["ContactTypeItem"],
	paginateItems: GraphQLTypes["ContactTypeItemConnection"]
};
	["ContactFormLocaleMeta"]: {
	__typename: "ContactFormLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	message?: GraphQLTypes["FieldMeta"],
	submit?: GraphQLTypes["FieldMeta"],
	successMessage?: GraphQLTypes["FieldMeta"],
	genericErrorMessage?: GraphQLTypes["FieldMeta"],
	contactTypeErrorMessage?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	file?: GraphQLTypes["FieldMeta"]
};
	["ContactTypeItem"]: {
	__typename: "ContactTypeItem",
	_meta?: GraphQLTypes["ContactTypeItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	subscriptions: Array<GraphQLTypes["ContactSubscription"]>,
	list?: GraphQLTypes["ContactFormLocale"],
	subscriptionsByFile?: GraphQLTypes["ContactSubscription"],
	paginateSubscriptions: GraphQLTypes["ContactSubscriptionConnection"]
};
	["ContactTypeItemMeta"]: {
	__typename: "ContactTypeItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	subscriptions?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"]
};
	["ContactSubscription"]: {
	__typename: "ContactSubscription",
	_meta?: GraphQLTypes["ContactSubscriptionMeta"],
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	email?: string,
	name?: string,
	phone?: string,
	message?: string,
	file?: GraphQLTypes["File"],
	contactType?: GraphQLTypes["ContactTypeItem"]
};
	["ContactSubscriptionMeta"]: {
	__typename: "ContactSubscriptionMeta",
	id?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	phone?: GraphQLTypes["FieldMeta"],
	message?: GraphQLTypes["FieldMeta"],
	file?: GraphQLTypes["FieldMeta"],
	contactType?: GraphQLTypes["FieldMeta"]
};
	["File"]: {
	__typename: "File",
	_meta?: GraphQLTypes["FileMeta"],
	id: GraphQLTypes["UUID"],
	url: string,
	size?: number,
	type?: string
};
	["FileMeta"]: {
	__typename: "FileMeta",
	id?: GraphQLTypes["FieldMeta"],
	url?: GraphQLTypes["FieldMeta"],
	size?: GraphQLTypes["FieldMeta"],
	type?: GraphQLTypes["FieldMeta"]
};
	["ContactSubscriptionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	message?: GraphQLTypes["OrderDirection"],
	file?: GraphQLTypes["FileOrderBy"],
	contactType?: GraphQLTypes["ContactTypeItemOrderBy"]
};
	["FileOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	url?: GraphQLTypes["OrderDirection"],
	size?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"]
};
	["ContactTypeItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ContactFormLocaleOrderBy"]
};
	["ContactFormLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	phone?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	message?: GraphQLTypes["OrderDirection"],
	submit?: GraphQLTypes["OrderDirection"],
	successMessage?: GraphQLTypes["OrderDirection"],
	genericErrorMessage?: GraphQLTypes["OrderDirection"],
	contactTypeErrorMessage?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["ContactFormOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	file?: GraphQLTypes["OrderDirection"]
};
	["ContactFormOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["ContactTypeItemSubscriptionsByFileUniqueWhere"]: {
		file?: GraphQLTypes["FileUniqueWhere"]
};
	["ContactSubscriptionConnection"]: {
	__typename: "ContactSubscriptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactSubscriptionEdge"]>
};
	["ContactSubscriptionEdge"]: {
	__typename: "ContactSubscriptionEdge",
	node: GraphQLTypes["ContactSubscription"]
};
	["ContactFormLocaleItemsBySubscriptionsUniqueWhere"]: {
		subscriptions?: GraphQLTypes["ContactSubscriptionUniqueWhere"]
};
	["ContactTypeItemConnection"]: {
	__typename: "ContactTypeItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactTypeItemEdge"]>
};
	["ContactTypeItemEdge"]: {
	__typename: "ContactTypeItemEdge",
	node: GraphQLTypes["ContactTypeItem"]
};
	["ContactFormLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["ContactFormLocalesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ContactTypeItemUniqueWhere"]
};
	["ContactFormLocaleConnection"]: {
	__typename: "ContactFormLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactFormLocaleEdge"]>
};
	["ContactFormLocaleEdge"]: {
	__typename: "ContactFormLocaleEdge",
	node: GraphQLTypes["ContactFormLocale"]
};
	["NewsletterForm"]: {
	__typename: "NewsletterForm",
	_meta?: GraphQLTypes["NewsletterFormMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["NewsletterFormLocale"]>,
	localesByLocale?: GraphQLTypes["NewsletterFormLocale"],
	localesByItems?: GraphQLTypes["NewsletterFormLocale"],
	paginateLocales: GraphQLTypes["NewsletterFormLocaleConnection"]
};
	["NewsletterFormMeta"]: {
	__typename: "NewsletterFormMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["NewsletterFormLocale"]: {
	__typename: "NewsletterFormLocale",
	_meta?: GraphQLTypes["NewsletterFormLocaleMeta"],
	id: GraphQLTypes["UUID"],
	newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterForm"],
	locale?: GraphQLTypes["Locale"],
	items: Array<GraphQLTypes["NewsletterTypeItem"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	itemsBySubscriptions?: GraphQLTypes["NewsletterTypeItem"],
	paginateItems: GraphQLTypes["NewsletterTypeItemConnection"]
};
	["NewsletterFormLocaleMeta"]: {
	__typename: "NewsletterFormLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	newsletterTypeNote?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	emailNote?: GraphQLTypes["FieldMeta"],
	submit?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	successMessage?: GraphQLTypes["FieldMeta"],
	genericErrorMessage?: GraphQLTypes["FieldMeta"],
	newsletterTypeErrorMessage?: GraphQLTypes["FieldMeta"]
};
	["NewsletterTypeItem"]: {
	__typename: "NewsletterTypeItem",
	_meta?: GraphQLTypes["NewsletterTypeItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	title?: string,
	list?: GraphQLTypes["NewsletterFormLocale"],
	subscriptions: Array<GraphQLTypes["NewsletterSubscription"]>,
	paginateSubscriptions: GraphQLTypes["NewsletterSubscriptionConnection"]
};
	["NewsletterTypeItemMeta"]: {
	__typename: "NewsletterTypeItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	subscriptions?: GraphQLTypes["FieldMeta"]
};
	["NewsletterSubscription"]: {
	__typename: "NewsletterSubscription",
	_meta?: GraphQLTypes["NewsletterSubscriptionMeta"],
	id: GraphQLTypes["UUID"],
	createdAt: GraphQLTypes["DateTime"],
	email?: string,
	newsletterType?: GraphQLTypes["NewsletterTypeItem"]
};
	["NewsletterSubscriptionMeta"]: {
	__typename: "NewsletterSubscriptionMeta",
	id?: GraphQLTypes["FieldMeta"],
	createdAt?: GraphQLTypes["FieldMeta"],
	email?: GraphQLTypes["FieldMeta"],
	newsletterType?: GraphQLTypes["FieldMeta"]
};
	["NewsletterSubscriptionOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	createdAt?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	newsletterType?: GraphQLTypes["NewsletterTypeItemOrderBy"]
};
	["NewsletterTypeItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	title?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["NewsletterFormLocaleOrderBy"]
};
	["NewsletterFormLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	newsletterTypeNote?: GraphQLTypes["OrderDirection"],
	email?: GraphQLTypes["OrderDirection"],
	emailNote?: GraphQLTypes["OrderDirection"],
	submit?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["NewsletterFormOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	title?: GraphQLTypes["OrderDirection"],
	successMessage?: GraphQLTypes["OrderDirection"],
	genericErrorMessage?: GraphQLTypes["OrderDirection"],
	newsletterTypeErrorMessage?: GraphQLTypes["OrderDirection"]
};
	["NewsletterFormOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["NewsletterSubscriptionConnection"]: {
	__typename: "NewsletterSubscriptionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterSubscriptionEdge"]>
};
	["NewsletterSubscriptionEdge"]: {
	__typename: "NewsletterSubscriptionEdge",
	node: GraphQLTypes["NewsletterSubscription"]
};
	["NewsletterFormLocaleItemsBySubscriptionsUniqueWhere"]: {
		subscriptions?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"]
};
	["NewsletterTypeItemConnection"]: {
	__typename: "NewsletterTypeItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterTypeItemEdge"]>
};
	["NewsletterTypeItemEdge"]: {
	__typename: "NewsletterTypeItemEdge",
	node: GraphQLTypes["NewsletterTypeItem"]
};
	["NewsletterFormLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["NewsletterFormLocalesByItemsUniqueWhere"]: {
		items?: GraphQLTypes["NewsletterTypeItemUniqueWhere"]
};
	["NewsletterFormLocaleConnection"]: {
	__typename: "NewsletterFormLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterFormLocaleEdge"]>
};
	["NewsletterFormLocaleEdge"]: {
	__typename: "NewsletterFormLocaleEdge",
	node: GraphQLTypes["NewsletterFormLocale"]
};
	["ContentReferenceOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	type?: GraphQLTypes["OrderDirection"],
	primaryText?: GraphQLTypes["OrderDirection"],
	block?: GraphQLTypes["ContentBlockOrderBy"],
	media?: GraphQLTypes["MediumListOrderBy"],
	link?: GraphQLTypes["LinkOrderBy"],
	secondaryText?: GraphQLTypes["OrderDirection"],
	dropDownList?: GraphQLTypes["DropDownListOrderBy"],
	artworkSelection?: GraphQLTypes["ArtworkSelectionOrderBy"],
	eventList?: GraphQLTypes["EventListOrderBy"],
	boxList?: GraphQLTypes["BoxListOrderBy"],
	isVisible?: GraphQLTypes["OrderDirection"],
	chart?: GraphQLTypes["ChartOrderBy"],
	definitionList?: GraphQLTypes["DefinitionListOrderBy"],
	logoList?: GraphQLTypes["LogoListOrderBy"],
	strategySchema?: GraphQLTypes["StrategySchemaOrderBy"],
	image?: GraphQLTypes["ImageOrderBy"],
	employeeList?: GraphQLTypes["EmployeeListOrderBy"],
	imageSecond?: GraphQLTypes["ImageOrderBy"],
	contactForm?: GraphQLTypes["ContactFormOrderBy"],
	newsletterForm?: GraphQLTypes["NewsletterFormOrderBy"]
};
	["ContentBlockOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	json?: GraphQLTypes["OrderDirection"],
	content?: GraphQLTypes["ContentOrderBy"]
};
	["StrategySchemaOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	inputFirst?: GraphQLTypes["OrderDirection"],
	inputSecond?: GraphQLTypes["OrderDirection"],
	inputThird?: GraphQLTypes["OrderDirection"],
	outputFirst?: GraphQLTypes["OrderDirection"],
	outputSecond?: GraphQLTypes["OrderDirection"],
	outputThird?: GraphQLTypes["OrderDirection"],
	itemsFirst?: GraphQLTypes["StrategySchemaGroupOrderBy"],
	logo?: GraphQLTypes["ImageOrderBy"],
	itemsSecond?: GraphQLTypes["StrategySchemaGroupOrderBy"]
};
	["ContentBlockReferencesByMediaUniqueWhere"]: {
		media?: GraphQLTypes["MediumListUniqueWhere"]
};
	["ContentBlockReferencesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContentBlockReferencesByDropDownListUniqueWhere"]: {
		dropDownList?: GraphQLTypes["DropDownListUniqueWhere"]
};
	["ContentBlockReferencesByEventListUniqueWhere"]: {
		eventList?: GraphQLTypes["EventListUniqueWhere"]
};
	["ContentBlockReferencesByBoxListUniqueWhere"]: {
		boxList?: GraphQLTypes["BoxListUniqueWhere"]
};
	["ContentBlockReferencesByChartUniqueWhere"]: {
		chart?: GraphQLTypes["ChartUniqueWhere"]
};
	["ContentBlockReferencesByDefinitionListUniqueWhere"]: {
		definitionList?: GraphQLTypes["DefinitionListUniqueWhere"]
};
	["ContentBlockReferencesByLogoListUniqueWhere"]: {
		logoList?: GraphQLTypes["LogoListUniqueWhere"]
};
	["ContentBlockReferencesByStrategySchemaUniqueWhere"]: {
		strategySchema?: GraphQLTypes["StrategySchemaUniqueWhere"]
};
	["ContentBlockReferencesByEmployeeListUniqueWhere"]: {
		employeeList?: GraphQLTypes["EmployeeListUniqueWhere"]
};
	["ContentReferenceConnection"]: {
	__typename: "ContentReferenceConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentReferenceEdge"]>
};
	["ContentReferenceEdge"]: {
	__typename: "ContentReferenceEdge",
	node: GraphQLTypes["ContentReference"]
};
	["ContentBlocksByReferencesUniqueWhere"]: {
		references?: GraphQLTypes["ContentReferenceUniqueWhere"]
};
	["ContentBlockConnection"]: {
	__typename: "ContentBlockConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentBlockEdge"]>
};
	["ContentBlockEdge"]: {
	__typename: "ContentBlockEdge",
	node: GraphQLTypes["ContentBlock"]
};
	["Branches"]: {
	__typename: "Branches",
	_meta?: GraphQLTypes["BranchesMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	leadParagraph?: string,
	more?: string,
	link?: GraphQLTypes["Link"]
};
	["BranchesMeta"]: {
	__typename: "BranchesMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	leadParagraph?: GraphQLTypes["FieldMeta"],
	more?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["BranchesOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	leadParagraph?: GraphQLTypes["OrderDirection"],
	more?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["BranchesConnection"]: {
	__typename: "BranchesConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BranchesEdge"]>
};
	["BranchesEdge"]: {
	__typename: "BranchesEdge",
	node: GraphQLTypes["Branches"]
};
	["PageLocale"]: {
	__typename: "PageLocale",
	_meta?: GraphQLTypes["PageLocaleMeta"],
	id: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["Linkable"],
	root?: GraphQLTypes["Page"],
	locale?: GraphQLTypes["Locale"],
	content?: GraphQLTypes["Content"],
	seo?: GraphQLTypes["Seo"]
};
	["PageLocaleMeta"]: {
	__typename: "PageLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	title?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	content?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["Page"]: {
	__typename: "Page",
	_meta?: GraphQLTypes["PageMeta"],
	id: GraphQLTypes["UUID"],
	locales: Array<GraphQLTypes["PageLocale"]>,
	localesByLocale?: GraphQLTypes["PageLocale"],
	localesByLink?: GraphQLTypes["PageLocale"],
	localesByContent?: GraphQLTypes["PageLocale"],
	localesBySeo?: GraphQLTypes["PageLocale"],
	paginateLocales: GraphQLTypes["PageLocaleConnection"]
};
	["PageMeta"]: {
	__typename: "PageMeta",
	id?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["PageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["PageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["PageLocalesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["PageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["PageLocaleConnection"]: {
	__typename: "PageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageLocaleEdge"]>
};
	["PageLocaleEdge"]: {
	__typename: "PageLocaleEdge",
	node: GraphQLTypes["PageLocale"]
};
	["Redirect"]: {
	__typename: "Redirect",
	_meta?: GraphQLTypes["RedirectMeta"],
	id: GraphQLTypes["UUID"],
	link?: GraphQLTypes["Linkable"],
	target?: GraphQLTypes["Linkable"]
};
	["RedirectMeta"]: {
	__typename: "RedirectMeta",
	id?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"],
	target?: GraphQLTypes["FieldMeta"]
};
	["GraphicDesignerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["Photographer"]: {
	__typename: "Photographer",
	_meta?: GraphQLTypes["PhotographerMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["PhotographerMeta"]: {
	__typename: "PhotographerMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["PhotographerOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["GraphicDesignerConnection"]: {
	__typename: "GraphicDesignerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GraphicDesignerEdge"]>
};
	["GraphicDesignerEdge"]: {
	__typename: "GraphicDesignerEdge",
	node: GraphQLTypes["GraphicDesigner"]
};
	["PhotographerConnection"]: {
	__typename: "PhotographerConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PhotographerEdge"]>
};
	["PhotographerEdge"]: {
	__typename: "PhotographerEdge",
	node: GraphQLTypes["Photographer"]
};
	["HeaderLocale"]: {
	__typename: "HeaderLocale",
	_meta?: GraphQLTypes["HeaderLocaleMeta"],
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["Header"],
	locale?: GraphQLTypes["Locale"],
	links: Array<GraphQLTypes["HeaderLink"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["Linkable"],
	paginateLinks: GraphQLTypes["HeaderLinkConnection"]
};
	["HeaderLocaleMeta"]: {
	__typename: "HeaderLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	links?: GraphQLTypes["FieldMeta"],
	artworkBreadcrumbParentLink?: GraphQLTypes["FieldMeta"]
};
	["Header"]: {
	__typename: "Header",
	_meta?: GraphQLTypes["HeaderMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["HeaderLocale"]>,
	logo?: GraphQLTypes["Image"],
	localesByLocale?: GraphQLTypes["HeaderLocale"],
	localesByArtworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocale"],
	paginateLocales: GraphQLTypes["HeaderLocaleConnection"]
};
	["HeaderMeta"]: {
	__typename: "HeaderMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"],
	logo?: GraphQLTypes["FieldMeta"]
};
	["HeaderLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["HeaderOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	artworkBreadcrumbParentLink?: GraphQLTypes["LinkableOrderBy"]
};
	["HeaderOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"],
	logo?: GraphQLTypes["ImageOrderBy"]
};
	["HeaderLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["HeaderLocalesByArtworkBreadcrumbParentLinkUniqueWhere"]: {
		artworkBreadcrumbParentLink?: GraphQLTypes["LinkableUniqueWhere"]
};
	["HeaderLocaleConnection"]: {
	__typename: "HeaderLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLocaleEdge"]>
};
	["HeaderLocaleEdge"]: {
	__typename: "HeaderLocaleEdge",
	node: GraphQLTypes["HeaderLocale"]
};
	["HeaderLink"]: {
	__typename: "HeaderLink",
	_meta?: GraphQLTypes["HeaderLinkMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	link?: GraphQLTypes["Link"]
};
	["HeaderLinkMeta"]: {
	__typename: "HeaderLinkMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	link?: GraphQLTypes["FieldMeta"]
};
	["HeaderLinkOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	link?: GraphQLTypes["LinkOrderBy"]
};
	["HeaderLinkConnection"]: {
	__typename: "HeaderLinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderLinkEdge"]>
};
	["HeaderLinkEdge"]: {
	__typename: "HeaderLinkEdge",
	node: GraphQLTypes["HeaderLink"]
};
	["SeoDefaultLocale"]: {
	__typename: "SeoDefaultLocale",
	_meta?: GraphQLTypes["SeoDefaultLocaleMeta"],
	id: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoDefault"],
	locale?: GraphQLTypes["Locale"],
	seo?: GraphQLTypes["Seo"]
};
	["SeoDefaultLocaleMeta"]: {
	__typename: "SeoDefaultLocaleMeta",
	id?: GraphQLTypes["FieldMeta"],
	root?: GraphQLTypes["FieldMeta"],
	locale?: GraphQLTypes["FieldMeta"],
	seo?: GraphQLTypes["FieldMeta"]
};
	["SeoDefault"]: {
	__typename: "SeoDefault",
	_meta?: GraphQLTypes["SeoDefaultMeta"],
	id: GraphQLTypes["UUID"],
	unique: GraphQLTypes["One"],
	locales: Array<GraphQLTypes["SeoDefaultLocale"]>,
	localesByLocale?: GraphQLTypes["SeoDefaultLocale"],
	localesBySeo?: GraphQLTypes["SeoDefaultLocale"],
	paginateLocales: GraphQLTypes["SeoDefaultLocaleConnection"]
};
	["SeoDefaultMeta"]: {
	__typename: "SeoDefaultMeta",
	id?: GraphQLTypes["FieldMeta"],
	unique?: GraphQLTypes["FieldMeta"],
	locales?: GraphQLTypes["FieldMeta"]
};
	["SeoDefaultLocaleOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	root?: GraphQLTypes["SeoDefaultOrderBy"],
	locale?: GraphQLTypes["LocaleOrderBy"],
	seo?: GraphQLTypes["SeoOrderBy"]
};
	["SeoDefaultOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	unique?: GraphQLTypes["OrderDirection"]
};
	["SeoDefaultLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["SeoDefaultLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["SeoDefaultLocaleConnection"]: {
	__typename: "SeoDefaultLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoDefaultLocaleEdge"]>
};
	["SeoDefaultLocaleEdge"]: {
	__typename: "SeoDefaultLocaleEdge",
	node: GraphQLTypes["SeoDefaultLocale"]
};
	["LocaleContactPagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["ContactPageUniqueWhere"]
};
	["LocaleContactPagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleContactPagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleContactPagesByAddressLinkUniqueWhere"]: {
		addressLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["LocaleFootersByRootUniqueWhere"]: {
		root?: GraphQLTypes["FooterUniqueWhere"]
};
	["LocaleFootersByDeveloperLinkUniqueWhere"]: {
		developerLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["LocaleHeadersByRootUniqueWhere"]: {
		root?: GraphQLTypes["HeaderUniqueWhere"]
};
	["LocaleHeadersByArtworkBreadcrumbParentLinkUniqueWhere"]: {
		artworkBreadcrumbParentLink?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleHomePagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["HomePageUniqueWhere"]
};
	["LocaleHomePagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocaleHomePagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleHomePagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocalePagesByRootUniqueWhere"]: {
		root?: GraphQLTypes["PageUniqueWhere"]
};
	["LocalePagesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocalePagesByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocalePagesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleSeoDefaultsByRootUniqueWhere"]: {
		root?: GraphQLTypes["SeoDefaultUniqueWhere"]
};
	["LocaleSeoDefaultsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleEventsByRootUniqueWhere"]: {
		root?: GraphQLTypes["EventUniqueWhere"]
};
	["LocaleEventsByImageUniqueWhere"]: {
		image?: GraphQLTypes["ImageUniqueWhere"]
};
	["LocaleEventsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleEventsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleEventsByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocaleArtworksByRootUniqueWhere"]: {
		root?: GraphQLTypes["ArtworkUniqueWhere"]
};
	["LocaleArtworksByContentUniqueWhere"]: {
		content?: GraphQLTypes["ContentUniqueWhere"]
};
	["LocaleArtworksBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleArtworksByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleArtworkSelectionsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ArtworkSelectionUniqueWhere"]
};
	["LocaleArtworkSelectionsBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["LocaleArtworkSelectionsByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["LocaleNewsletterFormsByRootUniqueWhere"]: {
		root?: GraphQLTypes["NewsletterFormUniqueWhere"]
};
	["LocaleNewsletterFormsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["NewsletterTypeItemUniqueWhere"]
};
	["LocaleEmployeesByRootUniqueWhere"]: {
		root?: GraphQLTypes["EmployeeUniqueWhere"]
};
	["LocaleContactFormsByRootUniqueWhere"]: {
		root?: GraphQLTypes["ContactFormUniqueWhere"]
};
	["LocaleContactFormsByItemsUniqueWhere"]: {
		items?: GraphQLTypes["ContactTypeItemUniqueWhere"]
};
	["ContactPageLocaleConnection"]: {
	__typename: "ContactPageLocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactPageLocaleEdge"]>
};
	["ContactPageLocaleEdge"]: {
	__typename: "ContactPageLocaleEdge",
	node: GraphQLTypes["ContactPageLocale"]
};
	["ContactPageLocalesByLocaleUniqueWhere"]: {
		locale?: GraphQLTypes["LocaleUniqueWhere"]
};
	["ContactPageLocalesByLinkUniqueWhere"]: {
		link?: GraphQLTypes["LinkableUniqueWhere"]
};
	["ContactPageLocalesBySeoUniqueWhere"]: {
		seo?: GraphQLTypes["SeoUniqueWhere"]
};
	["ContactPageLocalesByAddressLinkUniqueWhere"]: {
		addressLink?: GraphQLTypes["LinkUniqueWhere"]
};
	["ContactPageConnection"]: {
	__typename: "ContactPageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactPageEdge"]>
};
	["ContactPageEdge"]: {
	__typename: "ContactPageEdge",
	node: GraphQLTypes["ContactPage"]
};
	["_ValidationResult"]: {
	__typename: "_ValidationResult",
	valid: boolean,
	errors: Array<GraphQLTypes["_ValidationError"]>
};
	["_ValidationError"]: {
	__typename: "_ValidationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	message: GraphQLTypes["_ValidationMessage"]
};
	["_PathFragment"]:{
	__typename:"_FieldPathFragment" | "_IndexPathFragment"
	['...on _FieldPathFragment']: '__union' & GraphQLTypes["_FieldPathFragment"];
	['...on _IndexPathFragment']: '__union' & GraphQLTypes["_IndexPathFragment"];
};
	["_FieldPathFragment"]: {
	__typename: "_FieldPathFragment",
	field: string
};
	["_IndexPathFragment"]: {
	__typename: "_IndexPathFragment",
	index: number,
	alias?: string
};
	["_ValidationMessage"]: {
	__typename: "_ValidationMessage",
	text: string
};
	["ContactPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["ContactPageCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactPageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactPageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["ContactPageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["ContactPageLocaleCreateLocaleEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleCreateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutContactPagesCreateInput"]
};
	["LocaleWithoutContactPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateFootersEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["FooterLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleCreatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterUniqueWhere"],
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ImageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["FooterLocaleCreateGraphicDesignersEntityRelationInput"]: {
		connect?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	create?: GraphQLTypes["GraphicDesignerCreateInput"],
	alias?: string
};
	["GraphicDesignerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["GraphicDesignerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["GraphicDesignerCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GraphicDesignerCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkCreateInternalLinkEntityRelationInput"],
	anchorLink?: string,
	_dummy_field_?: boolean
};
	["LinkCreateInternalLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateHomePageEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create?: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["HomePageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleCreateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageUniqueWhere"],
	create?: GraphQLTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	media?: GraphQLTypes["HomePageCreateMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"],
	create?: GraphQLTypes["MediumListCreateInput"]
};
	["MediumListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["MediumListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumItemUniqueWhere"],
	create?: GraphQLTypes["MediumItemWithoutListCreateInput"],
	alias?: string
};
	["MediumItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumItemCreateMediumEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumUniqueWhere"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["MediumUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["MediumCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["MediumCreateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumCreateVideoEntityRelationInput"],
	youtubeEmbed?: string,
	_dummy_field_?: boolean
};
	["MediumCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumCreateVideoEntityRelationInput"]: {
		connect?: GraphQLTypes["VideoUniqueWhere"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["VideoUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["VideoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoCreatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoCreatePosterEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HomePageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutHomePagesCreateInput"]
};
	["LocaleWithoutHomePagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateContactPagesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactPageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["ContactPageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ContactPageLocaleCreateRootEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleCreateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageUniqueWhere"],
	create?: GraphQLTypes["ContactPageWithoutLocalesCreateInput"]
};
	["ContactPageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["ContactPageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutContactPageCreateInput"]
};
	["LinkableWithoutContactPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreatePageEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"]
};
	["PageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["PageUniqueWhere"],
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"]
};
	["PageWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"]
};
	["LocaleWithoutPagesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateHeadersEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["HeaderLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderUniqueWhere"],
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleCreateLinksEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	create?: GraphQLTypes["HeaderLinkCreateInput"],
	alias?: string
};
	["HeaderLinkUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["HeaderLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["HeaderLinkCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LocaleCreateHomePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create?: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["HomePageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleCreateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	blocks?: Array<GraphQLTypes["ContentCreateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentCreateBlocksEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	alias?: string
};
	["ContentBlockWithoutContentCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateReferencesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	alias?: string
};
	["ContentReferenceWithoutBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	secondaryText?: string,
	dropDownList?: GraphQLTypes["ContentReferenceCreateDropDownListEntityRelationInput"],
	artworkSelection?: GraphQLTypes["ContentReferenceCreateArtworkSelectionEntityRelationInput"],
	eventList?: GraphQLTypes["ContentReferenceCreateEventListEntityRelationInput"],
	boxList?: GraphQLTypes["ContentReferenceCreateBoxListEntityRelationInput"],
	isVisible?: boolean,
	chart?: GraphQLTypes["ContentReferenceCreateChartEntityRelationInput"],
	definitionList?: GraphQLTypes["ContentReferenceCreateDefinitionListEntityRelationInput"],
	logoList?: GraphQLTypes["ContentReferenceCreateLogoListEntityRelationInput"],
	strategySchema?: GraphQLTypes["ContentReferenceCreateStrategySchemaEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	employeeList?: GraphQLTypes["ContentReferenceCreateEmployeeListEntityRelationInput"],
	imageSecond?: GraphQLTypes["ContentReferenceCreateImageSecondEntityRelationInput"],
	contactForm?: GraphQLTypes["ContentReferenceCreateContactFormEntityRelationInput"],
	newsletterForm?: GraphQLTypes["ContentReferenceCreateNewsletterFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateMediaEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"],
	create?: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceCreateDropDownListEntityRelationInput"]: {
		connect?: GraphQLTypes["DropDownListUniqueWhere"],
	create?: GraphQLTypes["DropDownListCreateInput"]
};
	["DropDownListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["DropDownListCreateItemsEntityRelationInput"]>,
	dropDownType?: GraphQLTypes["DropDownType"],
	employees?: GraphQLTypes["DropDownListCreateEmployeesEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DropDownItemUniqueWhere"],
	create?: GraphQLTypes["DropDownItemWithoutListCreateInput"],
	alias?: string
};
	["DropDownItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	text?: string,
	link?: GraphQLTypes["DropDownItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["DropDownListCreateEmployeesEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	create?: GraphQLTypes["EmployeeListCreateInput"]
};
	["EmployeeListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["EmployeeListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EmployeeListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeItemUniqueWhere"],
	create?: GraphQLTypes["EmployeeItemWithoutListCreateInput"],
	alias?: string
};
	["EmployeeItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	employee?: GraphQLTypes["EmployeeItemCreateEmployeeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeItemCreateEmployeeEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeUniqueWhere"],
	create?: GraphQLTypes["EmployeeCreateInput"]
};
	["EmployeeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	image?: GraphQLTypes["EmployeeCreateImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["EmployeeCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EmployeeCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EmployeeCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	create?: GraphQLTypes["EmployeeLocaleWithoutRootCreateInput"],
	alias?: string
};
	["EmployeeLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	position?: string,
	text?: string,
	email?: string,
	phone?: string,
	locale?: GraphQLTypes["EmployeeLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutEmployeesCreateInput"]
};
	["LocaleWithoutEmployeesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreatePagesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["PageLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["LinkableWithoutPageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateContactPageEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactPageLocaleWithoutLinkCreateInput"]
};
	["ContactPageLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ContactPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactPageLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleCreateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["SeoCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	noIndex?: boolean,
	noFollow?: boolean,
	ogImage?: GraphQLTypes["SeoCreateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoCreateOgImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContactPageLocaleCreateAddressLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkableCreateEventEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"]
};
	["EventLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["EventUniqueWhere"],
	create?: GraphQLTypes["EventWithoutLocalesCreateInput"]
};
	["EventWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	dateStart?: GraphQLTypes["DateTime"],
	dateFinish?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["EventLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutEventsCreateInput"]
};
	["LocaleWithoutEventsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateSeoDefaultsEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	create?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["SeoDefaultLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoDefaultLocaleCreateRootEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultUniqueWhere"],
	create?: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LocaleCreateArtworksEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["ArtworkLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleCreateRootEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleCreateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["ArtworkLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkUniqueWhere"],
	create?: GraphQLTypes["ArtworkWithoutLocalesCreateInput"]
};
	["ArtworkWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["ArtworkCreateImageEntityRelationInput"],
	gallery?: GraphQLTypes["ArtworkCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ArtworkCreateGalleryEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["GalleryCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["GalleryCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	alias?: string
};
	["GalleryItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ArtworkLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArtworkLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ArtworkLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutArtworkCreateInput"]
};
	["LinkableWithoutArtworkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateArtworkSelectionEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"]
};
	["ArtworkSelectionLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionWithoutLocalesCreateInput"]
};
	["ArtworkSelectionWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	artworks?: GraphQLTypes["ArtworkSelectionCreateArtworksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionCreateArtworksEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionListUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionListCreateInput"]
};
	["ArtworkSelectionListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ArtworkSelectionListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArtworkSelectionListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionItemWithoutListCreateInput"],
	alias?: string
};
	["ArtworkSelectionItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	artwork?: GraphQLTypes["ArtworkSelectionItemCreateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionItemCreateArtworkEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkUniqueWhere"],
	create?: GraphQLTypes["ArtworkCreateInput"]
};
	["ArtworkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["ArtworkCreateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["ArtworkCreateImageEntityRelationInput"],
	gallery?: GraphQLTypes["ArtworkCreateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkLocaleWithoutRootCreateInput"],
	alias?: string
};
	["ArtworkLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	label?: string,
	leadParagraph?: string,
	locale?: GraphQLTypes["ArtworkLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleCreateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["ArtworkLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutArtworksCreateInput"]
};
	["LocaleWithoutArtworksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleCreateEventsEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["EventLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventLocaleCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["EventLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["LinkableWithoutEventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableCreateArtworkEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkLocaleWithoutLinkCreateInput"]
};
	["ArtworkLocaleWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleCreateSeoEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["LinkableCreateRedirectEntityRelationInput"]: {
		connect?: GraphQLTypes["RedirectUniqueWhere"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["RedirectWithoutLinkCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateTargetEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["EventLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LocaleCreateArtworkSelectionsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["ArtworkSelectionLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ArtworkSelectionLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutArtworkSelectionCreateInput"]
};
	["LinkableWithoutArtworkSelectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LocaleCreateNewsletterFormsEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["NewsletterFormLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleCreateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterFormUniqueWhere"],
	create?: GraphQLTypes["NewsletterFormWithoutLocalesCreateInput"]
};
	["NewsletterFormWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	create?: GraphQLTypes["NewsletterTypeItemWithoutListCreateInput"],
	alias?: string
};
	["NewsletterTypeItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	create?: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"],
	alias?: string
};
	["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	_dummy_field_?: boolean
};
	["LocaleCreateEmployeesEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	create?: GraphQLTypes["EmployeeLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["EmployeeLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	position?: string,
	text?: string,
	email?: string,
	phone?: string,
	root?: GraphQLTypes["EmployeeLocaleCreateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeUniqueWhere"],
	create?: GraphQLTypes["EmployeeWithoutLocalesCreateInput"]
};
	["EmployeeWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	name?: string,
	image?: GraphQLTypes["EmployeeCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LocaleCreateContactFormsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactFormLocaleWithoutLocaleCreateInput"],
	alias?: string
};
	["ContactFormLocaleWithoutLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleCreateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleCreateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactFormLocaleCreateRootEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormUniqueWhere"],
	create?: GraphQLTypes["ContactFormWithoutLocalesCreateInput"]
};
	["ContactFormWithoutLocalesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["ContactFormLocaleCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	create?: GraphQLTypes["ContactTypeItemWithoutListCreateInput"],
	alias?: string
};
	["ContactTypeItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["ContactTypeItemCreateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactTypeItemCreateSubscriptionsEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	create?: GraphQLTypes["ContactSubscriptionWithoutContactTypeCreateInput"],
	alias?: string
};
	["ContactSubscriptionWithoutContactTypeCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	name?: string,
	phone?: string,
	message?: string,
	file?: GraphQLTypes["ContactSubscriptionCreateFileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactSubscriptionCreateFileEntityRelationInput"]: {
		connect?: GraphQLTypes["FileUniqueWhere"],
	create?: GraphQLTypes["FileCreateInput"]
};
	["FileCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	size?: number,
	type?: string,
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutArtworkSelectionsCreateInput"]
};
	["LocaleWithoutArtworkSelectionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PageLocaleCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ContentReferenceCreateArtworkSelectionEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionCreateInput"]
};
	["ArtworkSelectionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	locales?: Array<GraphQLTypes["ArtworkSelectionCreateLocalesEntityRelationInput"]>,
	artworks?: GraphQLTypes["ArtworkSelectionCreateArtworksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutRootCreateInput"],
	alias?: string
};
	["ArtworkSelectionLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateEventListEntityRelationInput"]: {
		connect?: GraphQLTypes["EventListUniqueWhere"],
	create?: GraphQLTypes["EventListCreateInput"]
};
	["EventListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["EventListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["EventItemUniqueWhere"],
	create?: GraphQLTypes["EventItemWithoutListCreateInput"],
	alias?: string
};
	["EventItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	event?: GraphQLTypes["EventItemCreateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventItemCreateEventEntityRelationInput"]: {
		connect?: GraphQLTypes["EventUniqueWhere"],
	create?: GraphQLTypes["EventCreateInput"]
};
	["EventCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["EventCreateLocalesEntityRelationInput"]>,
	order?: number,
	dateStart?: GraphQLTypes["DateTime"],
	dateFinish?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["EventCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"],
	alias?: string
};
	["EventLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBoxListEntityRelationInput"]: {
		connect?: GraphQLTypes["BoxListUniqueWhere"],
	create?: GraphQLTypes["BoxListCreateInput"]
};
	["BoxListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["BoxListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BoxListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["BoxItemUniqueWhere"],
	create?: GraphQLTypes["BoxItemWithoutListCreateInput"],
	alias?: string
};
	["BoxItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: string,
	date?: string,
	type?: string,
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateChartEntityRelationInput"]: {
		connect?: GraphQLTypes["ChartUniqueWhere"],
	create?: GraphQLTypes["ChartCreateInput"]
};
	["ChartCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ChartType"],
	items?: Array<GraphQLTypes["ChartCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ChartCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ChartDataUniqueWhere"],
	create?: GraphQLTypes["ChartDataWithoutListCreateInput"],
	alias?: string
};
	["ChartDataWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	date?: GraphQLTypes["Date"],
	number?: number,
	text?: string,
	image?: GraphQLTypes["ChartDataCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ChartDataCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateDefinitionListEntityRelationInput"]: {
		connect?: GraphQLTypes["DefinitionListUniqueWhere"],
	create?: GraphQLTypes["DefinitionListCreateInput"]
};
	["DefinitionListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["DefinitionListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["DefinitionListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["DefinitionItemUniqueWhere"],
	create?: GraphQLTypes["DefinitionItemWithoutListCreateInput"],
	alias?: string
};
	["DefinitionItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	key?: string,
	value?: string,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateLogoListEntityRelationInput"]: {
		connect?: GraphQLTypes["LogoListUniqueWhere"],
	create?: GraphQLTypes["LogoListCreateInput"]
};
	["LogoListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["LogoListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LogoListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["LogoItemUniqueWhere"],
	create?: GraphQLTypes["LogoItemWithoutListCreateInput"],
	alias?: string
};
	["LogoItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	image?: GraphQLTypes["LogoItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LogoItemCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateStrategySchemaEntityRelationInput"]: {
		connect?: GraphQLTypes["StrategySchemaUniqueWhere"],
	create?: GraphQLTypes["StrategySchemaCreateInput"]
};
	["StrategySchemaCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	inputFirst?: string,
	inputSecond?: string,
	inputThird?: string,
	outputFirst?: string,
	outputSecond?: string,
	outputThird?: string,
	itemsFirst?: GraphQLTypes["StrategySchemaCreateItemsFirstEntityRelationInput"],
	logo?: GraphQLTypes["StrategySchemaCreateLogoEntityRelationInput"],
	itemsSecond?: GraphQLTypes["StrategySchemaCreateItemsSecondEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StrategySchemaCreateItemsFirstEntityRelationInput"]: {
		connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	create?: GraphQLTypes["StrategySchemaGroupCreateInput"]
};
	["StrategySchemaGroupCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["StrategySchemaGroupCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StrategySchemaGroupCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	create?: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"],
	alias?: string
};
	["StrategySchemaGroupItemWithoutSchemaCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["StrategySchemaCreateLogoEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["StrategySchemaCreateItemsSecondEntityRelationInput"]: {
		connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	create?: GraphQLTypes["StrategySchemaGroupCreateInput"]
};
	["ContentReferenceCreateImageEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateEmployeeListEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	create?: GraphQLTypes["EmployeeListCreateInput"]
};
	["ContentReferenceCreateImageSecondEntityRelationInput"]: {
		connect?: GraphQLTypes["ImageUniqueWhere"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceCreateContactFormEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormUniqueWhere"],
	create?: GraphQLTypes["ContactFormCreateInput"]
};
	["ContactFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["ContactFormCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactFormCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactFormLocaleWithoutRootCreateInput"],
	alias?: string
};
	["ContactFormLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	locale?: GraphQLTypes["ContactFormLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleCreateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactFormLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutContactFormsCreateInput"]
};
	["LocaleWithoutContactFormsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentReferenceCreateNewsletterFormEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterFormUniqueWhere"],
	create?: GraphQLTypes["NewsletterFormCreateInput"]
};
	["NewsletterFormCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["NewsletterFormCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterFormCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutRootCreateInput"],
	alias?: string
};
	["NewsletterFormLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	locale?: GraphQLTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutNewsletterFormsCreateInput"]
};
	["LocaleWithoutNewsletterFormsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HomePageLocaleCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["LinkableWithoutHomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableCreateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageLocaleCreateSeoEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoUniqueWhere"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLocaleCreateBranchesEntityRelationInput"]: {
		connect?: GraphQLTypes["BranchesUniqueWhere"],
	create?: GraphQLTypes["BranchesCreateInput"],
	alias?: string
};
	["BranchesUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["BranchesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	leadParagraph?: string,
	more?: string,
	link?: GraphQLTypes["BranchesCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BranchesCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreateDeveloperLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleCreatePhotographersEntityRelationInput"]: {
		connect?: GraphQLTypes["PhotographerUniqueWhere"],
	create?: GraphQLTypes["PhotographerCreateInput"],
	alias?: string
};
	["PhotographerUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["LinkUniqueWhere"]
};
	["PhotographerCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: GraphQLTypes["PhotographerCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkUniqueWhere"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContactPageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["ContactPageUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactPageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ContactPageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["ContactPageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["ContactPageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	alias?: string
};
	["ContactPageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	data?: GraphQLTypes["ContactPageLocaleWithoutRootUpdateInput"]
};
	["ContactPageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleUpdateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutContactPagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutContactPagesUpdateInput"],
	upsert?: GraphQLTypes["ContactPageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutContactPagesUpdateInput"]: {
		code?: string,
	label?: string,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateFootersEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateFootersRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertFootersRelationInput"],
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateFootersRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	data?: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"]
};
	["FooterLocaleWithoutLocaleUpdateInput"]: {
		address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleUpdatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["FooterWithoutLocalesCreateInput"],
	update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["FooterUniqueWhere"],
	delete?: boolean
};
	["FooterWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FooterUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["FooterUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ImageUpdateInput"]: {
		url?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	alt?: string,
	_dummy_field_?: boolean
};
	["FooterUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["FooterLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["FooterWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["FooterWithoutLocalesCreateInput"]
};
	["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]: {
		create?: GraphQLTypes["GraphicDesignerCreateInput"],
	update?: GraphQLTypes["FooterLocaleUpdateGraphicDesignersRelationInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertGraphicDesignersRelationInput"],
	connect?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	disconnect?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	delete?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	alias?: string
};
	["FooterLocaleUpdateGraphicDesignersRelationInput"]: {
		by?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	data?: GraphQLTypes["GraphicDesignerUpdateInput"]
};
	["GraphicDesignerUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["GraphicDesignerUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GraphicDesignerUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["GraphicDesignerUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkUpdateInput"]: {
		type?: GraphQLTypes["LinkType"],
	title?: string,
	externalLink?: string,
	internalLink?: GraphQLTypes["LinkUpdateInternalLinkEntityRelationInput"],
	anchorLink?: string,
	_dummy_field_?: boolean
};
	["LinkUpdateInternalLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["LinkUpsertInternalLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateHomePageEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["HomePageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertHomePageRelationInput"],
	connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleUpdateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["HomePageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["HomePageUniqueWhere"],
	delete?: boolean
};
	["HomePageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	media?: GraphQLTypes["HomePageUpdateMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateMediaEntityRelationInput"]: {
		create?: GraphQLTypes["MediumListCreateInput"],
	update?: GraphQLTypes["MediumListUpdateInput"],
	upsert?: GraphQLTypes["HomePageUpsertMediaRelationInput"],
	connect?: GraphQLTypes["MediumListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumListUpdateInput"]: {
		items?: Array<GraphQLTypes["MediumListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["MediumItemWithoutListCreateInput"],
	update?: GraphQLTypes["MediumListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["MediumListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["MediumItemUniqueWhere"],
	disconnect?: GraphQLTypes["MediumItemUniqueWhere"],
	delete?: GraphQLTypes["MediumItemUniqueWhere"],
	alias?: string
};
	["MediumListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["MediumItemUniqueWhere"],
	data?: GraphQLTypes["MediumItemWithoutListUpdateInput"]
};
	["MediumItemWithoutListUpdateInput"]: {
		order?: number,
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumItemUpdateMediumEntityRelationInput"]: {
		create?: GraphQLTypes["MediumCreateInput"],
	update?: GraphQLTypes["MediumUpdateInput"],
	upsert?: GraphQLTypes["MediumItemUpsertMediumRelationInput"],
	connect?: GraphQLTypes["MediumUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumUpdateInput"]: {
		type?: GraphQLTypes["MediumType"],
	image?: GraphQLTypes["MediumUpdateImageEntityRelationInput"],
	video?: GraphQLTypes["MediumUpdateVideoEntityRelationInput"],
	youtubeEmbed?: string,
	_dummy_field_?: boolean
};
	["MediumUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpdateVideoEntityRelationInput"]: {
		create?: GraphQLTypes["VideoCreateInput"],
	update?: GraphQLTypes["VideoUpdateInput"],
	upsert?: GraphQLTypes["MediumUpsertVideoRelationInput"],
	connect?: GraphQLTypes["VideoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpdateInput"]: {
		src?: string,
	width?: number,
	height?: number,
	size?: number,
	type?: string,
	duration?: number,
	poster?: GraphQLTypes["VideoUpdatePosterEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoUpdatePosterEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["VideoUpsertPosterRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["VideoUpsertPosterRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["MediumUpsertVideoRelationInput"]: {
		update?: GraphQLTypes["VideoUpdateInput"],
	create?: GraphQLTypes["VideoCreateInput"]
};
	["MediumItemUpsertMediumRelationInput"]: {
		update?: GraphQLTypes["MediumUpdateInput"],
	create?: GraphQLTypes["MediumCreateInput"]
};
	["MediumListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["MediumItemUniqueWhere"],
	update?: GraphQLTypes["MediumItemWithoutListUpdateInput"],
	create?: GraphQLTypes["MediumItemWithoutListCreateInput"]
};
	["HomePageUpsertMediaRelationInput"]: {
		update?: GraphQLTypes["MediumListUpdateInput"],
	create?: GraphQLTypes["MediumListCreateInput"]
};
	["HomePageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["HomePageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["HomePageWithoutLocalesCreateInput"]
};
	["HomePageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutHomePagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutHomePagesUpdateInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutHomePagesUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateContactPagesEntityRelationInput"]: {
		create?: GraphQLTypes["ContactPageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateContactPagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertContactPagesRelationInput"],
	connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	delete?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateContactPagesRelationInput"]: {
		by?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	data?: GraphQLTypes["ContactPageLocaleWithoutLocaleUpdateInput"]
};
	["ContactPageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ContactPageLocaleUpdateRootEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleUpdateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ContactPageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["ContactPageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["ContactPageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["ContactPageUniqueWhere"],
	delete?: boolean
};
	["ContactPageWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["ContactPageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ContactPageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["ContactPageWithoutLocalesCreateInput"]
};
	["ContactPageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutContactPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutContactPageUpdateInput"],
	upsert?: GraphQLTypes["ContactPageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutContactPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdatePageEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertPageRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["PageWithoutLocalesCreateInput"],
	update?: GraphQLTypes["PageWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["PageUniqueWhere"],
	delete?: boolean
};
	["PageWithoutLocalesUpdateInput"]: {
		_dummy_field_?: boolean
};
	["PageLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["PageWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["PageWithoutLocalesCreateInput"]
};
	["PageLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutPagesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutPagesUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateHeadersEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateHeadersRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertHeadersRelationInput"],
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateHeadersRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data?: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"]
};
	["HeaderLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"],
	update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["HeaderUniqueWhere"],
	delete?: boolean
};
	["HeaderWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["HeaderUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["HeaderLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["HeaderWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["HeaderWithoutLocalesCreateInput"]
};
	["HeaderLocaleUpdateLinksEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLinkCreateInput"],
	update?: GraphQLTypes["HeaderLocaleUpdateLinksRelationInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertLinksRelationInput"],
	connect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLinkUniqueWhere"],
	delete?: GraphQLTypes["HeaderLinkUniqueWhere"],
	alias?: string
};
	["HeaderLocaleUpdateLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	data?: GraphQLTypes["HeaderLinkUpdateInput"]
};
	["HeaderLinkUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["HeaderLinkUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLinkUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["HeaderLinkUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderLinkUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HeaderLocaleUpsertLinksRelationInput"]: {
		by?: GraphQLTypes["HeaderLinkUniqueWhere"],
	update?: GraphQLTypes["HeaderLinkUpdateInput"],
	create?: GraphQLTypes["HeaderLinkCreateInput"]
};
	["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HeaderLocaleUpsertArtworkBreadcrumbParentLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LocaleUpsertHeadersRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update?: GraphQLTypes["HeaderLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["HeaderLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateHomePagesEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateHomePagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertHomePagesRelationInput"],
	connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	delete?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateHomePagesRelationInput"]: {
		by?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	data?: GraphQLTypes["HomePageLocaleWithoutLocaleUpdateInput"]
};
	["HomePageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleUpdateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentUpdateInput"]: {
		blocks?: Array<GraphQLTypes["ContentUpdateBlocksEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentUpdateBlocksEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateBlocksRelationInput"],
	upsert?: GraphQLTypes["ContentUpsertBlocksRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	disconnect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: GraphQLTypes["ContentBlockUniqueWhere"],
	alias?: string
};
	["ContentUpdateBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	data?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"]
};
	["ContentBlockWithoutContentUpdateInput"]: {
		order?: number,
	json?: string,
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateReferencesEntityRelationInput"]: {
		create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"],
	update?: GraphQLTypes["ContentBlockUpdateReferencesRelationInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertReferencesRelationInput"],
	connect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	disconnect?: GraphQLTypes["ContentReferenceUniqueWhere"],
	delete?: GraphQLTypes["ContentReferenceUniqueWhere"],
	alias?: string
};
	["ContentBlockUpdateReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	data?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"]
};
	["ContentReferenceWithoutBlockUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	secondaryText?: string,
	dropDownList?: GraphQLTypes["ContentReferenceUpdateDropDownListEntityRelationInput"],
	artworkSelection?: GraphQLTypes["ContentReferenceUpdateArtworkSelectionEntityRelationInput"],
	eventList?: GraphQLTypes["ContentReferenceUpdateEventListEntityRelationInput"],
	boxList?: GraphQLTypes["ContentReferenceUpdateBoxListEntityRelationInput"],
	isVisible?: boolean,
	chart?: GraphQLTypes["ContentReferenceUpdateChartEntityRelationInput"],
	definitionList?: GraphQLTypes["ContentReferenceUpdateDefinitionListEntityRelationInput"],
	logoList?: GraphQLTypes["ContentReferenceUpdateLogoListEntityRelationInput"],
	strategySchema?: GraphQLTypes["ContentReferenceUpdateStrategySchemaEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	employeeList?: GraphQLTypes["ContentReferenceUpdateEmployeeListEntityRelationInput"],
	imageSecond?: GraphQLTypes["ContentReferenceUpdateImageSecondEntityRelationInput"],
	contactForm?: GraphQLTypes["ContentReferenceUpdateContactFormEntityRelationInput"],
	newsletterForm?: GraphQLTypes["ContentReferenceUpdateNewsletterFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateMediaEntityRelationInput"]: {
		create?: GraphQLTypes["MediumListCreateInput"],
	update?: GraphQLTypes["MediumListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertMediaRelationInput"],
	connect?: GraphQLTypes["MediumListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertMediaRelationInput"]: {
		update?: GraphQLTypes["MediumListUpdateInput"],
	create?: GraphQLTypes["MediumListCreateInput"]
};
	["ContentReferenceUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["ContentReferenceUpdateDropDownListEntityRelationInput"]: {
		create?: GraphQLTypes["DropDownListCreateInput"],
	update?: GraphQLTypes["DropDownListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertDropDownListRelationInput"],
	connect?: GraphQLTypes["DropDownListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DropDownListUpdateInput"]: {
		items?: Array<GraphQLTypes["DropDownListUpdateItemsEntityRelationInput"]>,
	dropDownType?: GraphQLTypes["DropDownType"],
	employees?: GraphQLTypes["DropDownListUpdateEmployeesEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DropDownItemWithoutListCreateInput"],
	update?: GraphQLTypes["DropDownListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["DropDownListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["DropDownItemUniqueWhere"],
	disconnect?: GraphQLTypes["DropDownItemUniqueWhere"],
	delete?: GraphQLTypes["DropDownItemUniqueWhere"],
	alias?: string
};
	["DropDownListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["DropDownItemUniqueWhere"],
	data?: GraphQLTypes["DropDownItemWithoutListUpdateInput"]
};
	["DropDownItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	text?: string,
	link?: GraphQLTypes["DropDownItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["DropDownItemUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DropDownItemUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["DropDownListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["DropDownItemUniqueWhere"],
	update?: GraphQLTypes["DropDownItemWithoutListUpdateInput"],
	create?: GraphQLTypes["DropDownItemWithoutListCreateInput"]
};
	["DropDownListUpdateEmployeesEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeListCreateInput"],
	update?: GraphQLTypes["EmployeeListUpdateInput"],
	upsert?: GraphQLTypes["DropDownListUpsertEmployeesRelationInput"],
	connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EmployeeListUpdateInput"]: {
		items?: Array<GraphQLTypes["EmployeeListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EmployeeListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeItemWithoutListCreateInput"],
	update?: GraphQLTypes["EmployeeListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["EmployeeListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["EmployeeItemUniqueWhere"],
	disconnect?: GraphQLTypes["EmployeeItemUniqueWhere"],
	delete?: GraphQLTypes["EmployeeItemUniqueWhere"],
	alias?: string
};
	["EmployeeListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeItemUniqueWhere"],
	data?: GraphQLTypes["EmployeeItemWithoutListUpdateInput"]
};
	["EmployeeItemWithoutListUpdateInput"]: {
		order?: number,
	employee?: GraphQLTypes["EmployeeItemUpdateEmployeeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeItemUpdateEmployeeEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeCreateInput"],
	update?: GraphQLTypes["EmployeeUpdateInput"],
	upsert?: GraphQLTypes["EmployeeItemUpsertEmployeeRelationInput"],
	connect?: GraphQLTypes["EmployeeUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EmployeeUpdateInput"]: {
		order?: number,
	name?: string,
	image?: GraphQLTypes["EmployeeUpdateImageEntityRelationInput"],
	locales?: Array<GraphQLTypes["EmployeeUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EmployeeUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["EmployeeUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EmployeeUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EmployeeUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["EmployeeUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["EmployeeUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	delete?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	alias?: string
};
	["EmployeeUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	data?: GraphQLTypes["EmployeeLocaleWithoutRootUpdateInput"]
};
	["EmployeeLocaleWithoutRootUpdateInput"]: {
		position?: string,
	text?: string,
	email?: string,
	phone?: string,
	locale?: GraphQLTypes["EmployeeLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutEmployeesCreateInput"],
	update?: GraphQLTypes["LocaleWithoutEmployeesUpdateInput"],
	upsert?: GraphQLTypes["EmployeeLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutEmployeesUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdatePagesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdatePagesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertPagesRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"],
	delete?: GraphQLTypes["PageLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdatePagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	data?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"]
};
	["PageLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutPageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutPageUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateContactPageEntityRelationInput"]: {
		create?: GraphQLTypes["ContactPageLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["ContactPageLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertContactPageRelationInput"],
	connect?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ContactPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleUpdateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ContactPageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpdateInput"]: {
		title?: string,
	description?: string,
	ogTitle?: string,
	ogDescription?: string,
	noIndex?: boolean,
	noFollow?: boolean,
	ogImage?: GraphQLTypes["SeoUpdateOgImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoUpdateOgImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["SeoUpsertOgImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoUpsertOgImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContactPageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ContactPageLocaleUpdateAddressLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["ContactPageLocaleUpsertAddressLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactPageLocaleUpsertAddressLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["LinkableUpsertContactPageRelationInput"]: {
		update?: GraphQLTypes["ContactPageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ContactPageLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateEventEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertEventRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["EventWithoutLocalesCreateInput"],
	update?: GraphQLTypes["EventWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["EventUniqueWhere"],
	delete?: boolean
};
	["EventWithoutLocalesUpdateInput"]: {
		order?: number,
	dateStart?: GraphQLTypes["DateTime"],
	dateFinish?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["EventLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["EventWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["EventWithoutLocalesCreateInput"]
};
	["EventLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutEventsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutEventsUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutEventsUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateSeoDefaultsEntityRelationInput"]: {
		create?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateSeoDefaultsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertSeoDefaultsRelationInput"],
	connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	delete?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateSeoDefaultsRelationInput"]: {
		by?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	data?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"]
};
	["SeoDefaultLocaleWithoutLocaleUpdateInput"]: {
		root?: GraphQLTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"],
	update?: GraphQLTypes["SeoDefaultWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["SeoDefaultUniqueWhere"],
	delete?: boolean
};
	["SeoDefaultWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["SeoDefaultWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["SeoDefaultWithoutLocalesCreateInput"]
};
	["SeoDefaultLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["SeoDefaultLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LocaleUpsertSeoDefaultsRelationInput"]: {
		by?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	update?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["SeoDefaultLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateArtworksEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateArtworksRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertArtworksRelationInput"],
	connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	delete?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateArtworksRelationInput"]: {
		by?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	data?: GraphQLTypes["ArtworkLocaleWithoutLocaleUpdateInput"]
};
	["ArtworkLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleUpdateRootEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleUpdateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["ArtworkLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkWithoutLocalesCreateInput"],
	update?: GraphQLTypes["ArtworkWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["ArtworkLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["ArtworkUniqueWhere"],
	delete?: boolean
};
	["ArtworkWithoutLocalesUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["ArtworkUpdateImageEntityRelationInput"],
	gallery?: GraphQLTypes["ArtworkUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ArtworkUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ArtworkUpdateGalleryEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryCreateInput"],
	update?: GraphQLTypes["GalleryUpdateInput"],
	upsert?: GraphQLTypes["ArtworkUpsertGalleryRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryUpdateInput"]: {
		items?: Array<GraphQLTypes["GalleryUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["GalleryUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryItemWithoutListCreateInput"],
	update?: GraphQLTypes["GalleryUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["GalleryUpsertItemsRelationInput"],
	connect?: GraphQLTypes["GalleryItemUniqueWhere"],
	disconnect?: GraphQLTypes["GalleryItemUniqueWhere"],
	delete?: GraphQLTypes["GalleryItemUniqueWhere"],
	alias?: string
};
	["GalleryUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	data?: GraphQLTypes["GalleryItemWithoutListUpdateInput"]
};
	["GalleryItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["GalleryUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["GalleryItemUniqueWhere"],
	update?: GraphQLTypes["GalleryItemWithoutListUpdateInput"],
	create?: GraphQLTypes["GalleryItemWithoutListCreateInput"]
};
	["ArtworkUpsertGalleryRelationInput"]: {
		update?: GraphQLTypes["GalleryUpdateInput"],
	create?: GraphQLTypes["GalleryCreateInput"]
};
	["ArtworkLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ArtworkWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["ArtworkWithoutLocalesCreateInput"]
};
	["ArtworkLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["ArtworkLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["ArtworkLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ArtworkLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ArtworkLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutArtworkCreateInput"],
	update?: GraphQLTypes["LinkableWithoutArtworkUpdateInput"],
	upsert?: GraphQLTypes["ArtworkLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutArtworkUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateArtworkSelectionEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertArtworkSelectionRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkSelectionLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionWithoutLocalesCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionUniqueWhere"],
	delete?: boolean
};
	["ArtworkSelectionWithoutLocalesUpdateInput"]: {
		order?: number,
	artworks?: GraphQLTypes["ArtworkSelectionUpdateArtworksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionUpdateArtworksEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionListCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionListUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionUpsertArtworksRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkSelectionListUpdateInput"]: {
		items?: Array<GraphQLTypes["ArtworkSelectionListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArtworkSelectionListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionItemWithoutListCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ArtworkSelectionListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	delete?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	alias?: string
};
	["ArtworkSelectionListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	data?: GraphQLTypes["ArtworkSelectionItemWithoutListUpdateInput"]
};
	["ArtworkSelectionItemWithoutListUpdateInput"]: {
		order?: number,
	artwork?: GraphQLTypes["ArtworkSelectionItemUpdateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionItemUpdateArtworkEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkCreateInput"],
	update?: GraphQLTypes["ArtworkUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionItemUpsertArtworkRelationInput"],
	connect?: GraphQLTypes["ArtworkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["ArtworkUpdateLocalesEntityRelationInput"]>,
	image?: GraphQLTypes["ArtworkUpdateImageEntityRelationInput"],
	gallery?: GraphQLTypes["ArtworkUpdateGalleryEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["ArtworkUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["ArtworkUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	delete?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	alias?: string
};
	["ArtworkUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	data?: GraphQLTypes["ArtworkLocaleWithoutRootUpdateInput"]
};
	["ArtworkLocaleWithoutRootUpdateInput"]: {
		title?: string,
	label?: string,
	leadParagraph?: string,
	locale?: GraphQLTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleUpdateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["ArtworkLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutArtworksCreateInput"],
	update?: GraphQLTypes["LocaleWithoutArtworksUpdateInput"],
	upsert?: GraphQLTypes["ArtworkLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutArtworksUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateEventsEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateEventsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertEventsRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EventLocaleUniqueWhere"],
	delete?: GraphQLTypes["EventLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateEventsRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	data?: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"]
};
	["EventLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventLocaleUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["EventLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["EventLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutEventCreateInput"],
	update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutEventUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LinkableUpdateArtworkEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkLocaleWithoutLinkCreateInput"],
	update?: GraphQLTypes["ArtworkLocaleWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertArtworkRelationInput"],
	connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkLocaleWithoutLinkUpdateInput"]: {
		title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleUpdateSeoEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["LinkableUpsertArtworkRelationInput"]: {
		update?: GraphQLTypes["ArtworkLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ArtworkLocaleWithoutLinkCreateInput"]
};
	["LinkableUpdateRedirectEntityRelationInput"]: {
		create?: GraphQLTypes["RedirectWithoutLinkCreateInput"],
	update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	upsert?: GraphQLTypes["LinkableUpsertRedirectRelationInput"],
	connect?: GraphQLTypes["RedirectUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["RedirectWithoutLinkUpdateInput"]: {
		target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateTargetEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableCreateInput"],
	update?: GraphQLTypes["LinkableUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertTargetRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"]
};
	["RedirectUpsertTargetRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["LinkableUpsertRedirectRelationInput"]: {
		update?: GraphQLTypes["RedirectWithoutLinkUpdateInput"],
	create?: GraphQLTypes["RedirectWithoutLinkCreateInput"]
};
	["EventLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutEventUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutEventCreateInput"]
};
	["EventLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["EventLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["LocaleUpsertEventsRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	update?: GraphQLTypes["EventLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateArtworkSelectionsEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateArtworkSelectionsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertArtworkSelectionsRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	delete?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateArtworkSelectionsRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	data?: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleUpdateInput"]
};
	["ArtworkSelectionLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkSelectionLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutArtworkSelectionCreateInput"],
	update?: GraphQLTypes["LinkableWithoutArtworkSelectionUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutArtworkSelectionUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutArtworkSelectionUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutArtworkSelectionCreateInput"]
};
	["LocaleUpsertArtworkSelectionsRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	update?: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateNewsletterFormsEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterFormLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateNewsletterFormsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertNewsletterFormsRelationInput"],
	connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	delete?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateNewsletterFormsRelationInput"]: {
		by?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	data?: GraphQLTypes["NewsletterFormLocaleWithoutLocaleUpdateInput"]
};
	["NewsletterFormLocaleWithoutLocaleUpdateInput"]: {
		newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterFormWithoutLocalesCreateInput"],
	update?: GraphQLTypes["NewsletterFormWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["NewsletterFormLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["NewsletterFormUniqueWhere"],
	delete?: boolean
};
	["NewsletterFormWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["NewsletterFormWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["NewsletterFormWithoutLocalesCreateInput"]
};
	["NewsletterFormLocaleUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterTypeItemWithoutListCreateInput"],
	update?: GraphQLTypes["NewsletterFormLocaleUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["NewsletterFormLocaleUpsertItemsRelationInput"],
	connect?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	disconnect?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	delete?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	alias?: string
};
	["NewsletterFormLocaleUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	data?: GraphQLTypes["NewsletterTypeItemWithoutListUpdateInput"]
};
	["NewsletterTypeItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"],
	update?: GraphQLTypes["NewsletterTypeItemUpdateSubscriptionsRelationInput"],
	upsert?: GraphQLTypes["NewsletterTypeItemUpsertSubscriptionsRelationInput"],
	connect?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	disconnect?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	delete?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	alias?: string
};
	["NewsletterTypeItemUpdateSubscriptionsRelationInput"]: {
		by?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	data?: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"]
};
	["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemUpsertSubscriptionsRelationInput"]: {
		by?: GraphQLTypes["NewsletterSubscriptionUniqueWhere"],
	update?: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeUpdateInput"],
	create?: GraphQLTypes["NewsletterSubscriptionWithoutNewsletterTypeCreateInput"]
};
	["NewsletterFormLocaleUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	update?: GraphQLTypes["NewsletterTypeItemWithoutListUpdateInput"],
	create?: GraphQLTypes["NewsletterTypeItemWithoutListCreateInput"]
};
	["LocaleUpsertNewsletterFormsRelationInput"]: {
		by?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	update?: GraphQLTypes["NewsletterFormLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateEmployeesEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateEmployeesRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertEmployeesRelationInput"],
	connect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	delete?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateEmployeesRelationInput"]: {
		by?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	data?: GraphQLTypes["EmployeeLocaleWithoutLocaleUpdateInput"]
};
	["EmployeeLocaleWithoutLocaleUpdateInput"]: {
		position?: string,
	text?: string,
	email?: string,
	phone?: string,
	root?: GraphQLTypes["EmployeeLocaleUpdateRootEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeWithoutLocalesCreateInput"],
	update?: GraphQLTypes["EmployeeWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["EmployeeLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["EmployeeUniqueWhere"],
	delete?: boolean
};
	["EmployeeWithoutLocalesUpdateInput"]: {
		order?: number,
	name?: string,
	image?: GraphQLTypes["EmployeeUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["EmployeeWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["EmployeeWithoutLocalesCreateInput"]
};
	["LocaleUpsertEmployeesRelationInput"]: {
		by?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	update?: GraphQLTypes["EmployeeLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["EmployeeLocaleWithoutLocaleCreateInput"]
};
	["LocaleUpdateContactFormsEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormLocaleWithoutLocaleCreateInput"],
	update?: GraphQLTypes["LocaleUpdateContactFormsRelationInput"],
	upsert?: GraphQLTypes["LocaleUpsertContactFormsRelationInput"],
	connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	delete?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	alias?: string
};
	["LocaleUpdateContactFormsRelationInput"]: {
		by?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	data?: GraphQLTypes["ContactFormLocaleWithoutLocaleUpdateInput"]
};
	["ContactFormLocaleWithoutLocaleUpdateInput"]: {
		title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleUpdateRootEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleUpdateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactFormLocaleUpdateRootEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormWithoutLocalesCreateInput"],
	update?: GraphQLTypes["ContactFormWithoutLocalesUpdateInput"],
	upsert?: GraphQLTypes["ContactFormLocaleUpsertRootRelationInput"],
	connect?: GraphQLTypes["ContactFormUniqueWhere"],
	delete?: boolean
};
	["ContactFormWithoutLocalesUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	_dummy_field_?: boolean
};
	["ContactFormLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ContactFormWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["ContactFormWithoutLocalesCreateInput"]
};
	["ContactFormLocaleUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ContactTypeItemWithoutListCreateInput"],
	update?: GraphQLTypes["ContactFormLocaleUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ContactFormLocaleUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	disconnect?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	delete?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	alias?: string
};
	["ContactFormLocaleUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	data?: GraphQLTypes["ContactTypeItemWithoutListUpdateInput"]
};
	["ContactTypeItemWithoutListUpdateInput"]: {
		order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["ContactTypeItemUpdateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactTypeItemUpdateSubscriptionsEntityRelationInput"]: {
		create?: GraphQLTypes["ContactSubscriptionWithoutContactTypeCreateInput"],
	update?: GraphQLTypes["ContactTypeItemUpdateSubscriptionsRelationInput"],
	upsert?: GraphQLTypes["ContactTypeItemUpsertSubscriptionsRelationInput"],
	connect?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	disconnect?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	delete?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	alias?: string
};
	["ContactTypeItemUpdateSubscriptionsRelationInput"]: {
		by?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	data?: GraphQLTypes["ContactSubscriptionWithoutContactTypeUpdateInput"]
};
	["ContactSubscriptionWithoutContactTypeUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	name?: string,
	phone?: string,
	message?: string,
	file?: GraphQLTypes["ContactSubscriptionUpdateFileEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactSubscriptionUpdateFileEntityRelationInput"]: {
		create?: GraphQLTypes["FileCreateInput"],
	update?: GraphQLTypes["FileUpdateInput"],
	upsert?: GraphQLTypes["ContactSubscriptionUpsertFileRelationInput"],
	connect?: GraphQLTypes["FileUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FileUpdateInput"]: {
		url?: string,
	size?: number,
	type?: string,
	_dummy_field_?: boolean
};
	["ContactSubscriptionUpsertFileRelationInput"]: {
		update?: GraphQLTypes["FileUpdateInput"],
	create?: GraphQLTypes["FileCreateInput"]
};
	["ContactTypeItemUpsertSubscriptionsRelationInput"]: {
		by?: GraphQLTypes["ContactSubscriptionUniqueWhere"],
	update?: GraphQLTypes["ContactSubscriptionWithoutContactTypeUpdateInput"],
	create?: GraphQLTypes["ContactSubscriptionWithoutContactTypeCreateInput"]
};
	["ContactFormLocaleUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	update?: GraphQLTypes["ContactTypeItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ContactTypeItemWithoutListCreateInput"]
};
	["LocaleUpsertContactFormsRelationInput"]: {
		by?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	update?: GraphQLTypes["ContactFormLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["ContactFormLocaleWithoutLocaleCreateInput"]
};
	["ArtworkLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutArtworksUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutArtworksCreateInput"]
};
	["ArtworkUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	update?: GraphQLTypes["ArtworkLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["ArtworkLocaleWithoutRootCreateInput"]
};
	["ArtworkSelectionItemUpsertArtworkRelationInput"]: {
		update?: GraphQLTypes["ArtworkUpdateInput"],
	create?: GraphQLTypes["ArtworkCreateInput"]
};
	["ArtworkSelectionListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionItemUniqueWhere"],
	update?: GraphQLTypes["ArtworkSelectionItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionItemWithoutListCreateInput"]
};
	["ArtworkSelectionUpsertArtworksRelationInput"]: {
		update?: GraphQLTypes["ArtworkSelectionListUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionListCreateInput"]
};
	["ArtworkSelectionLocaleUpsertRootRelationInput"]: {
		update?: GraphQLTypes["ArtworkSelectionWithoutLocalesUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionWithoutLocalesCreateInput"]
};
	["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutArtworkSelectionsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutArtworkSelectionsUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutArtworkSelectionsUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutArtworkSelectionsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutArtworkSelectionsCreateInput"]
};
	["LinkableUpsertArtworkSelectionRelationInput"]: {
		update?: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutLinkCreateInput"]
};
	["ArtworkLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutArtworkUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutArtworkCreateInput"]
};
	["LocaleUpsertArtworksRelationInput"]: {
		by?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	update?: GraphQLTypes["ArtworkLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["ArtworkLocaleWithoutLocaleCreateInput"]
};
	["EventLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutEventsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutEventsCreateInput"]
};
	["LinkableUpsertEventRelationInput"]: {
		update?: GraphQLTypes["EventLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutLinkCreateInput"]
};
	["PageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutPageCreateInput"]
};
	["PageLocaleUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentCreateInput"],
	update?: GraphQLTypes["ContentUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["PageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["PageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["LocaleUpsertPagesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	update?: GraphQLTypes["PageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutLocaleCreateInput"]
};
	["EmployeeLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutEmployeesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutEmployeesCreateInput"]
};
	["EmployeeUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["EmployeeLocaleUniqueWhere"],
	update?: GraphQLTypes["EmployeeLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["EmployeeLocaleWithoutRootCreateInput"]
};
	["EmployeeItemUpsertEmployeeRelationInput"]: {
		update?: GraphQLTypes["EmployeeUpdateInput"],
	create?: GraphQLTypes["EmployeeCreateInput"]
};
	["EmployeeListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["EmployeeItemUniqueWhere"],
	update?: GraphQLTypes["EmployeeItemWithoutListUpdateInput"],
	create?: GraphQLTypes["EmployeeItemWithoutListCreateInput"]
};
	["DropDownListUpsertEmployeesRelationInput"]: {
		update?: GraphQLTypes["EmployeeListUpdateInput"],
	create?: GraphQLTypes["EmployeeListCreateInput"]
};
	["ContentReferenceUpsertDropDownListRelationInput"]: {
		update?: GraphQLTypes["DropDownListUpdateInput"],
	create?: GraphQLTypes["DropDownListCreateInput"]
};
	["ContentReferenceUpdateArtworkSelectionEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertArtworkSelectionRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkSelectionUpdateInput"]: {
		order?: number,
	locales?: Array<GraphQLTypes["ArtworkSelectionUpdateLocalesEntityRelationInput"]>,
	artworks?: GraphQLTypes["ArtworkSelectionUpdateArtworksEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["ArtworkSelectionUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	delete?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	alias?: string
};
	["ArtworkSelectionUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	data?: GraphQLTypes["ArtworkSelectionLocaleWithoutRootUpdateInput"]
};
	["ArtworkSelectionLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ArtworkSelectionLocaleUniqueWhere"],
	update?: GraphQLTypes["ArtworkSelectionLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionLocaleWithoutRootCreateInput"]
};
	["ContentReferenceUpsertArtworkSelectionRelationInput"]: {
		update?: GraphQLTypes["ArtworkSelectionUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionCreateInput"]
};
	["ContentReferenceUpdateEventListEntityRelationInput"]: {
		create?: GraphQLTypes["EventListCreateInput"],
	update?: GraphQLTypes["EventListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertEventListRelationInput"],
	connect?: GraphQLTypes["EventListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventListUpdateInput"]: {
		items?: Array<GraphQLTypes["EventListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["EventListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["EventItemWithoutListCreateInput"],
	update?: GraphQLTypes["EventListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["EventListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["EventItemUniqueWhere"],
	disconnect?: GraphQLTypes["EventItemUniqueWhere"],
	delete?: GraphQLTypes["EventItemUniqueWhere"],
	alias?: string
};
	["EventListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["EventItemUniqueWhere"],
	data?: GraphQLTypes["EventItemWithoutListUpdateInput"]
};
	["EventItemWithoutListUpdateInput"]: {
		order?: number,
	event?: GraphQLTypes["EventItemUpdateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventItemUpdateEventEntityRelationInput"]: {
		create?: GraphQLTypes["EventCreateInput"],
	update?: GraphQLTypes["EventUpdateInput"],
	upsert?: GraphQLTypes["EventItemUpsertEventRelationInput"],
	connect?: GraphQLTypes["EventUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EventUpdateInput"]: {
		locales?: Array<GraphQLTypes["EventUpdateLocalesEntityRelationInput"]>,
	order?: number,
	dateStart?: GraphQLTypes["DateTime"],
	dateFinish?: GraphQLTypes["DateTime"],
	_dummy_field_?: boolean
};
	["EventUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["EventUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["EventUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["EventLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["EventLocaleUniqueWhere"],
	delete?: GraphQLTypes["EventLocaleUniqueWhere"],
	alias?: string
};
	["EventUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	data?: GraphQLTypes["EventLocaleWithoutRootUpdateInput"]
};
	["EventLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["EventLocaleUniqueWhere"],
	update?: GraphQLTypes["EventLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["EventLocaleWithoutRootCreateInput"]
};
	["EventItemUpsertEventRelationInput"]: {
		update?: GraphQLTypes["EventUpdateInput"],
	create?: GraphQLTypes["EventCreateInput"]
};
	["EventListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["EventItemUniqueWhere"],
	update?: GraphQLTypes["EventItemWithoutListUpdateInput"],
	create?: GraphQLTypes["EventItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertEventListRelationInput"]: {
		update?: GraphQLTypes["EventListUpdateInput"],
	create?: GraphQLTypes["EventListCreateInput"]
};
	["ContentReferenceUpdateBoxListEntityRelationInput"]: {
		create?: GraphQLTypes["BoxListCreateInput"],
	update?: GraphQLTypes["BoxListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBoxListRelationInput"],
	connect?: GraphQLTypes["BoxListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["BoxListUpdateInput"]: {
		items?: Array<GraphQLTypes["BoxListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["BoxListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["BoxItemWithoutListCreateInput"],
	update?: GraphQLTypes["BoxListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["BoxListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["BoxItemUniqueWhere"],
	disconnect?: GraphQLTypes["BoxItemUniqueWhere"],
	delete?: GraphQLTypes["BoxItemUniqueWhere"],
	alias?: string
};
	["BoxListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["BoxItemUniqueWhere"],
	data?: GraphQLTypes["BoxItemWithoutListUpdateInput"]
};
	["BoxItemWithoutListUpdateInput"]: {
		order?: number,
	link?: string,
	date?: string,
	type?: string,
	title?: string,
	text?: string,
	_dummy_field_?: boolean
};
	["BoxListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["BoxItemUniqueWhere"],
	update?: GraphQLTypes["BoxItemWithoutListUpdateInput"],
	create?: GraphQLTypes["BoxItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertBoxListRelationInput"]: {
		update?: GraphQLTypes["BoxListUpdateInput"],
	create?: GraphQLTypes["BoxListCreateInput"]
};
	["ContentReferenceUpdateChartEntityRelationInput"]: {
		create?: GraphQLTypes["ChartCreateInput"],
	update?: GraphQLTypes["ChartUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertChartRelationInput"],
	connect?: GraphQLTypes["ChartUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ChartUpdateInput"]: {
		type?: GraphQLTypes["ChartType"],
	items?: Array<GraphQLTypes["ChartUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ChartUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ChartDataWithoutListCreateInput"],
	update?: GraphQLTypes["ChartUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ChartUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ChartDataUniqueWhere"],
	disconnect?: GraphQLTypes["ChartDataUniqueWhere"],
	delete?: GraphQLTypes["ChartDataUniqueWhere"],
	alias?: string
};
	["ChartUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ChartDataUniqueWhere"],
	data?: GraphQLTypes["ChartDataWithoutListUpdateInput"]
};
	["ChartDataWithoutListUpdateInput"]: {
		order?: number,
	date?: GraphQLTypes["Date"],
	number?: number,
	text?: string,
	image?: GraphQLTypes["ChartDataUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ChartDataUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ChartDataUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ChartDataUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ChartUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ChartDataUniqueWhere"],
	update?: GraphQLTypes["ChartDataWithoutListUpdateInput"],
	create?: GraphQLTypes["ChartDataWithoutListCreateInput"]
};
	["ContentReferenceUpsertChartRelationInput"]: {
		update?: GraphQLTypes["ChartUpdateInput"],
	create?: GraphQLTypes["ChartCreateInput"]
};
	["ContentReferenceUpdateDefinitionListEntityRelationInput"]: {
		create?: GraphQLTypes["DefinitionListCreateInput"],
	update?: GraphQLTypes["DefinitionListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertDefinitionListRelationInput"],
	connect?: GraphQLTypes["DefinitionListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["DefinitionListUpdateInput"]: {
		items?: Array<GraphQLTypes["DefinitionListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["DefinitionListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["DefinitionItemWithoutListCreateInput"],
	update?: GraphQLTypes["DefinitionListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["DefinitionListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["DefinitionItemUniqueWhere"],
	disconnect?: GraphQLTypes["DefinitionItemUniqueWhere"],
	delete?: GraphQLTypes["DefinitionItemUniqueWhere"],
	alias?: string
};
	["DefinitionListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["DefinitionItemUniqueWhere"],
	data?: GraphQLTypes["DefinitionItemWithoutListUpdateInput"]
};
	["DefinitionItemWithoutListUpdateInput"]: {
		order?: number,
	key?: string,
	value?: string,
	_dummy_field_?: boolean
};
	["DefinitionListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["DefinitionItemUniqueWhere"],
	update?: GraphQLTypes["DefinitionItemWithoutListUpdateInput"],
	create?: GraphQLTypes["DefinitionItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertDefinitionListRelationInput"]: {
		update?: GraphQLTypes["DefinitionListUpdateInput"],
	create?: GraphQLTypes["DefinitionListCreateInput"]
};
	["ContentReferenceUpdateLogoListEntityRelationInput"]: {
		create?: GraphQLTypes["LogoListCreateInput"],
	update?: GraphQLTypes["LogoListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertLogoListRelationInput"],
	connect?: GraphQLTypes["LogoListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LogoListUpdateInput"]: {
		items?: Array<GraphQLTypes["LogoListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LogoListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["LogoItemWithoutListCreateInput"],
	update?: GraphQLTypes["LogoListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["LogoListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["LogoItemUniqueWhere"],
	disconnect?: GraphQLTypes["LogoItemUniqueWhere"],
	delete?: GraphQLTypes["LogoItemUniqueWhere"],
	alias?: string
};
	["LogoListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["LogoItemUniqueWhere"],
	data?: GraphQLTypes["LogoItemWithoutListUpdateInput"]
};
	["LogoItemWithoutListUpdateInput"]: {
		order?: number,
	image?: GraphQLTypes["LogoItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LogoItemUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["LogoItemUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LogoItemUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["LogoListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["LogoItemUniqueWhere"],
	update?: GraphQLTypes["LogoItemWithoutListUpdateInput"],
	create?: GraphQLTypes["LogoItemWithoutListCreateInput"]
};
	["ContentReferenceUpsertLogoListRelationInput"]: {
		update?: GraphQLTypes["LogoListUpdateInput"],
	create?: GraphQLTypes["LogoListCreateInput"]
};
	["ContentReferenceUpdateStrategySchemaEntityRelationInput"]: {
		create?: GraphQLTypes["StrategySchemaCreateInput"],
	update?: GraphQLTypes["StrategySchemaUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertStrategySchemaRelationInput"],
	connect?: GraphQLTypes["StrategySchemaUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StrategySchemaUpdateInput"]: {
		inputFirst?: string,
	inputSecond?: string,
	inputThird?: string,
	outputFirst?: string,
	outputSecond?: string,
	outputThird?: string,
	itemsFirst?: GraphQLTypes["StrategySchemaUpdateItemsFirstEntityRelationInput"],
	logo?: GraphQLTypes["StrategySchemaUpdateLogoEntityRelationInput"],
	itemsSecond?: GraphQLTypes["StrategySchemaUpdateItemsSecondEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StrategySchemaUpdateItemsFirstEntityRelationInput"]: {
		create?: GraphQLTypes["StrategySchemaGroupCreateInput"],
	update?: GraphQLTypes["StrategySchemaGroupUpdateInput"],
	upsert?: GraphQLTypes["StrategySchemaUpsertItemsFirstRelationInput"],
	connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StrategySchemaGroupUpdateInput"]: {
		items?: Array<GraphQLTypes["StrategySchemaGroupUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["StrategySchemaGroupUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"],
	update?: GraphQLTypes["StrategySchemaGroupUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["StrategySchemaGroupUpsertItemsRelationInput"],
	connect?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	disconnect?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	delete?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	alias?: string
};
	["StrategySchemaGroupUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	data?: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaUpdateInput"]
};
	["StrategySchemaGroupItemWithoutSchemaUpdateInput"]: {
		order?: number,
	text?: string,
	_dummy_field_?: boolean
};
	["StrategySchemaGroupUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["StrategySchemaGroupItemUniqueWhere"],
	update?: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaUpdateInput"],
	create?: GraphQLTypes["StrategySchemaGroupItemWithoutSchemaCreateInput"]
};
	["StrategySchemaUpsertItemsFirstRelationInput"]: {
		update?: GraphQLTypes["StrategySchemaGroupUpdateInput"],
	create?: GraphQLTypes["StrategySchemaGroupCreateInput"]
};
	["StrategySchemaUpdateLogoEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["StrategySchemaUpsertLogoRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StrategySchemaUpsertLogoRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["StrategySchemaUpdateItemsSecondEntityRelationInput"]: {
		create?: GraphQLTypes["StrategySchemaGroupCreateInput"],
	update?: GraphQLTypes["StrategySchemaGroupUpdateInput"],
	upsert?: GraphQLTypes["StrategySchemaUpsertItemsSecondRelationInput"],
	connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["StrategySchemaUpsertItemsSecondRelationInput"]: {
		update?: GraphQLTypes["StrategySchemaGroupUpdateInput"],
	create?: GraphQLTypes["StrategySchemaGroupCreateInput"]
};
	["ContentReferenceUpsertStrategySchemaRelationInput"]: {
		update?: GraphQLTypes["StrategySchemaUpdateInput"],
	create?: GraphQLTypes["StrategySchemaCreateInput"]
};
	["ContentReferenceUpdateImageEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertImageRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateEmployeeListEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeListCreateInput"],
	update?: GraphQLTypes["EmployeeListUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertEmployeeListRelationInput"],
	connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertEmployeeListRelationInput"]: {
		update?: GraphQLTypes["EmployeeListUpdateInput"],
	create?: GraphQLTypes["EmployeeListCreateInput"]
};
	["ContentReferenceUpdateImageSecondEntityRelationInput"]: {
		create?: GraphQLTypes["ImageCreateInput"],
	update?: GraphQLTypes["ImageUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertImageSecondRelationInput"],
	connect?: GraphQLTypes["ImageUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContentReferenceUpsertImageSecondRelationInput"]: {
		update?: GraphQLTypes["ImageUpdateInput"],
	create?: GraphQLTypes["ImageCreateInput"]
};
	["ContentReferenceUpdateContactFormEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormCreateInput"],
	update?: GraphQLTypes["ContactFormUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertContactFormRelationInput"],
	connect?: GraphQLTypes["ContactFormUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactFormUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["ContactFormUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactFormUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["ContactFormUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["ContactFormUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	delete?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	alias?: string
};
	["ContactFormUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	data?: GraphQLTypes["ContactFormLocaleWithoutRootUpdateInput"]
};
	["ContactFormLocaleWithoutRootUpdateInput"]: {
		title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	locale?: GraphQLTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleUpdateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactFormLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutContactFormsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutContactFormsUpdateInput"],
	upsert?: GraphQLTypes["ContactFormLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutContactFormsUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContactFormLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutContactFormsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutContactFormsCreateInput"]
};
	["ContactFormUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	update?: GraphQLTypes["ContactFormLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["ContactFormLocaleWithoutRootCreateInput"]
};
	["ContentReferenceUpsertContactFormRelationInput"]: {
		update?: GraphQLTypes["ContactFormUpdateInput"],
	create?: GraphQLTypes["ContactFormCreateInput"]
};
	["ContentReferenceUpdateNewsletterFormEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterFormCreateInput"],
	update?: GraphQLTypes["NewsletterFormUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertNewsletterFormRelationInput"],
	connect?: GraphQLTypes["NewsletterFormUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsletterFormUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["NewsletterFormUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterFormUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterFormLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["NewsletterFormUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["NewsletterFormUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	delete?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	alias?: string
};
	["NewsletterFormUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	data?: GraphQLTypes["NewsletterFormLocaleWithoutRootUpdateInput"]
};
	["NewsletterFormLocaleWithoutRootUpdateInput"]: {
		newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	locale?: GraphQLTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutNewsletterFormsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutNewsletterFormsUpdateInput"],
	upsert?: GraphQLTypes["NewsletterFormLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutNewsletterFormsUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutNewsletterFormsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutNewsletterFormsCreateInput"]
};
	["NewsletterFormUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	update?: GraphQLTypes["NewsletterFormLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutRootCreateInput"]
};
	["ContentReferenceUpsertNewsletterFormRelationInput"]: {
		update?: GraphQLTypes["NewsletterFormUpdateInput"],
	create?: GraphQLTypes["NewsletterFormCreateInput"]
};
	["ContentBlockUpsertReferencesRelationInput"]: {
		by?: GraphQLTypes["ContentReferenceUniqueWhere"],
	update?: GraphQLTypes["ContentReferenceWithoutBlockUpdateInput"],
	create?: GraphQLTypes["ContentReferenceWithoutBlockCreateInput"]
};
	["ContentUpsertBlocksRelationInput"]: {
		by?: GraphQLTypes["ContentBlockUniqueWhere"],
	update?: GraphQLTypes["ContentBlockWithoutContentUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutContentCreateInput"]
};
	["HomePageLocaleUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentUpdateInput"],
	create?: GraphQLTypes["ContentCreateInput"]
};
	["HomePageLocaleUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"],
	update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutHomePageUpdateInput"]: {
		url?: string,
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	redirect?: GraphQLTypes["LinkableUpdateRedirectEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutHomePageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutHomePageCreateInput"]
};
	["HomePageLocaleUpdateSeoEntityRelationInput"]: {
		create?: GraphQLTypes["SeoCreateInput"],
	update?: GraphQLTypes["SeoUpdateInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertSeoRelationInput"],
	connect?: GraphQLTypes["SeoUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["HomePageLocaleUpsertSeoRelationInput"]: {
		update?: GraphQLTypes["SeoUpdateInput"],
	create?: GraphQLTypes["SeoCreateInput"]
};
	["HomePageLocaleUpdateBranchesEntityRelationInput"]: {
		create?: GraphQLTypes["BranchesCreateInput"],
	update?: GraphQLTypes["HomePageLocaleUpdateBranchesRelationInput"],
	upsert?: GraphQLTypes["HomePageLocaleUpsertBranchesRelationInput"],
	connect?: GraphQLTypes["BranchesUniqueWhere"],
	disconnect?: GraphQLTypes["BranchesUniqueWhere"],
	delete?: GraphQLTypes["BranchesUniqueWhere"],
	alias?: string
};
	["HomePageLocaleUpdateBranchesRelationInput"]: {
		by?: GraphQLTypes["BranchesUniqueWhere"],
	data?: GraphQLTypes["BranchesUpdateInput"]
};
	["BranchesUpdateInput"]: {
		order?: number,
	leadParagraph?: string,
	more?: string,
	link?: GraphQLTypes["BranchesUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BranchesUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["BranchesUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["BranchesUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["HomePageLocaleUpsertBranchesRelationInput"]: {
		by?: GraphQLTypes["BranchesUniqueWhere"],
	update?: GraphQLTypes["BranchesUpdateInput"],
	create?: GraphQLTypes["BranchesCreateInput"]
};
	["LocaleUpsertHomePagesRelationInput"]: {
		by?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	update?: GraphQLTypes["HomePageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["HomePageLocaleWithoutLocaleCreateInput"]
};
	["PageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutPagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutPagesCreateInput"]
};
	["LinkableUpsertPageRelationInput"]: {
		update?: GraphQLTypes["PageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutLinkCreateInput"]
};
	["ContactPageLocaleUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutContactPageUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutContactPageCreateInput"]
};
	["LocaleUpsertContactPagesRelationInput"]: {
		by?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	update?: GraphQLTypes["ContactPageLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["ContactPageLocaleWithoutLocaleCreateInput"]
};
	["HomePageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutHomePagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutHomePagesCreateInput"]
};
	["LinkableUpsertHomePageRelationInput"]: {
		update?: GraphQLTypes["HomePageLocaleWithoutLinkUpdateInput"],
	create?: GraphQLTypes["HomePageLocaleWithoutLinkCreateInput"]
};
	["LinkUpsertInternalLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableUpdateInput"],
	create?: GraphQLTypes["LinkableCreateInput"]
};
	["GraphicDesignerUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpsertGraphicDesignersRelationInput"]: {
		by?: GraphQLTypes["GraphicDesignerUniqueWhere"],
	update?: GraphQLTypes["GraphicDesignerUpdateInput"],
	create?: GraphQLTypes["GraphicDesignerCreateInput"]
};
	["FooterLocaleUpdateDeveloperLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertDeveloperLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["FooterLocaleUpsertDeveloperLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpdatePhotographersEntityRelationInput"]: {
		create?: GraphQLTypes["PhotographerCreateInput"],
	update?: GraphQLTypes["FooterLocaleUpdatePhotographersRelationInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertPhotographersRelationInput"],
	connect?: GraphQLTypes["PhotographerUniqueWhere"],
	disconnect?: GraphQLTypes["PhotographerUniqueWhere"],
	delete?: GraphQLTypes["PhotographerUniqueWhere"],
	alias?: string
};
	["FooterLocaleUpdatePhotographersRelationInput"]: {
		by?: GraphQLTypes["PhotographerUniqueWhere"],
	data?: GraphQLTypes["PhotographerUpdateInput"]
};
	["PhotographerUpdateInput"]: {
		order?: number,
	link?: GraphQLTypes["PhotographerUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PhotographerUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkCreateInput"],
	update?: GraphQLTypes["LinkUpdateInput"],
	upsert?: GraphQLTypes["PhotographerUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["PhotographerUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkUpdateInput"],
	create?: GraphQLTypes["LinkCreateInput"]
};
	["FooterLocaleUpsertPhotographersRelationInput"]: {
		by?: GraphQLTypes["PhotographerUniqueWhere"],
	update?: GraphQLTypes["PhotographerUpdateInput"],
	create?: GraphQLTypes["PhotographerCreateInput"]
};
	["LocaleUpsertFootersRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	update?: GraphQLTypes["FooterLocaleWithoutLocaleUpdateInput"],
	create?: GraphQLTypes["FooterLocaleWithoutLocaleCreateInput"]
};
	["ContactPageLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutContactPagesUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutContactPagesCreateInput"]
};
	["ContactPageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["ContactPageLocaleUniqueWhere"],
	update?: GraphQLTypes["ContactPageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["ContactPageLocaleWithoutRootCreateInput"]
};
	["ContactPageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ContactPageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactPageLocaleCreateLocaleEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleCreateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleCreateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContactPageLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ContactPageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactPageLocaleUpdateLocaleEntityRelationInput"],
	link?: GraphQLTypes["ContactPageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["ContactPageLocaleUpdateSeoEntityRelationInput"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	databox?: string,
	databoxNumber?: string,
	addressLink?: GraphQLTypes["ContactPageLocaleUpdateAddressLinkEntityRelationInput"],
	socialsLabel?: string,
	openingHours?: string,
	identificationsLabel?: string,
	ico?: string,
	dic?: string,
	phoneLabel?: string,
	emailLabel?: string,
	linkedIn?: string,
	securities?: string,
	securitiesNumber?: string,
	_dummy_field_?: boolean
};
	["ContentConnection"]: {
	__typename: "ContentConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContentEdge"]>
};
	["ContentEdge"]: {
	__typename: "ContentEdge",
	node: GraphQLTypes["Content"]
};
	["ContentBlockCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockCreateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockCreateContentEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentUniqueWhere"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentWithoutBlocksCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ContentBlockUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	references?: Array<GraphQLTypes["ContentBlockUpdateReferencesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ContentBlockUpdateContentEntityRelationInput"]: {
		create?: GraphQLTypes["ContentWithoutBlocksCreateInput"],
	update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	upsert?: GraphQLTypes["ContentBlockUpsertContentRelationInput"],
	connect?: GraphQLTypes["ContentUniqueWhere"],
	delete?: boolean
};
	["ContentWithoutBlocksUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ContentBlockUpsertContentRelationInput"]: {
		update?: GraphQLTypes["ContentWithoutBlocksUpdateInput"],
	create?: GraphQLTypes["ContentWithoutBlocksCreateInput"]
};
	["ContentReferenceCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	block?: GraphQLTypes["ContentReferenceCreateBlockEntityRelationInput"],
	media?: GraphQLTypes["ContentReferenceCreateMediaEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceCreateLinkEntityRelationInput"],
	secondaryText?: string,
	dropDownList?: GraphQLTypes["ContentReferenceCreateDropDownListEntityRelationInput"],
	artworkSelection?: GraphQLTypes["ContentReferenceCreateArtworkSelectionEntityRelationInput"],
	eventList?: GraphQLTypes["ContentReferenceCreateEventListEntityRelationInput"],
	boxList?: GraphQLTypes["ContentReferenceCreateBoxListEntityRelationInput"],
	isVisible?: boolean,
	chart?: GraphQLTypes["ContentReferenceCreateChartEntityRelationInput"],
	definitionList?: GraphQLTypes["ContentReferenceCreateDefinitionListEntityRelationInput"],
	logoList?: GraphQLTypes["ContentReferenceCreateLogoListEntityRelationInput"],
	strategySchema?: GraphQLTypes["ContentReferenceCreateStrategySchemaEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceCreateImageEntityRelationInput"],
	employeeList?: GraphQLTypes["ContentReferenceCreateEmployeeListEntityRelationInput"],
	imageSecond?: GraphQLTypes["ContentReferenceCreateImageSecondEntityRelationInput"],
	contactForm?: GraphQLTypes["ContentReferenceCreateContactFormEntityRelationInput"],
	newsletterForm?: GraphQLTypes["ContentReferenceCreateNewsletterFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceCreateBlockEntityRelationInput"]: {
		connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["ContentBlockWithoutReferencesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockCreateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateInput"]: {
		type?: GraphQLTypes["ContentReferenceType"],
	primaryText?: string,
	block?: GraphQLTypes["ContentReferenceUpdateBlockEntityRelationInput"],
	media?: GraphQLTypes["ContentReferenceUpdateMediaEntityRelationInput"],
	link?: GraphQLTypes["ContentReferenceUpdateLinkEntityRelationInput"],
	secondaryText?: string,
	dropDownList?: GraphQLTypes["ContentReferenceUpdateDropDownListEntityRelationInput"],
	artworkSelection?: GraphQLTypes["ContentReferenceUpdateArtworkSelectionEntityRelationInput"],
	eventList?: GraphQLTypes["ContentReferenceUpdateEventListEntityRelationInput"],
	boxList?: GraphQLTypes["ContentReferenceUpdateBoxListEntityRelationInput"],
	isVisible?: boolean,
	chart?: GraphQLTypes["ContentReferenceUpdateChartEntityRelationInput"],
	definitionList?: GraphQLTypes["ContentReferenceUpdateDefinitionListEntityRelationInput"],
	logoList?: GraphQLTypes["ContentReferenceUpdateLogoListEntityRelationInput"],
	strategySchema?: GraphQLTypes["ContentReferenceUpdateStrategySchemaEntityRelationInput"],
	image?: GraphQLTypes["ContentReferenceUpdateImageEntityRelationInput"],
	employeeList?: GraphQLTypes["ContentReferenceUpdateEmployeeListEntityRelationInput"],
	imageSecond?: GraphQLTypes["ContentReferenceUpdateImageSecondEntityRelationInput"],
	contactForm?: GraphQLTypes["ContentReferenceUpdateContactFormEntityRelationInput"],
	newsletterForm?: GraphQLTypes["ContentReferenceUpdateNewsletterFormEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpdateBlockEntityRelationInput"]: {
		create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"],
	update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	upsert?: GraphQLTypes["ContentReferenceUpsertBlockRelationInput"],
	connect?: GraphQLTypes["ContentBlockUniqueWhere"],
	delete?: boolean
};
	["ContentBlockWithoutReferencesUpdateInput"]: {
		order?: number,
	json?: string,
	content?: GraphQLTypes["ContentBlockUpdateContentEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContentReferenceUpsertBlockRelationInput"]: {
		update?: GraphQLTypes["ContentBlockWithoutReferencesUpdateInput"],
	create?: GraphQLTypes["ContentBlockWithoutReferencesCreateInput"]
};
	["FooterConnection"]: {
	__typename: "FooterConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FooterEdge"]>
};
	["FooterEdge"]: {
	__typename: "FooterEdge",
	node: GraphQLTypes["Footer"]
};
	["FooterCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterCreateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["FooterCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"],
	alias?: string
};
	["FooterLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleCreatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["LocaleWithoutFootersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	logo?: GraphQLTypes["FooterUpdateLogoEntityRelationInput"],
	locales?: Array<GraphQLTypes["FooterUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["FooterUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["FooterUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["FooterLocaleUniqueWhere"],
	delete?: GraphQLTypes["FooterLocaleUniqueWhere"],
	alias?: string
};
	["FooterUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	data?: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"]
};
	["FooterLocaleWithoutRootUpdateInput"]: {
		address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleUpdatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutFootersCreateInput"],
	update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	upsert?: GraphQLTypes["FooterLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutFootersUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutFootersUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutFootersCreateInput"]
};
	["FooterUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["FooterLocaleUniqueWhere"],
	update?: GraphQLTypes["FooterLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["FooterLocaleWithoutRootCreateInput"]
};
	["FooterLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	root?: GraphQLTypes["FooterLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["FooterLocaleCreateLocaleEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleCreateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleCreateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleCreatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["FooterLocaleUpdateInput"]: {
		address?: string,
	phone?: string,
	email?: string,
	youtube?: string,
	instagram?: string,
	facebook?: string,
	graphicDesign?: string,
	root?: GraphQLTypes["FooterLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["FooterLocaleUpdateLocaleEntityRelationInput"],
	graphicDesigners?: Array<GraphQLTypes["FooterLocaleUpdateGraphicDesignersEntityRelationInput"]>,
	developerLink?: GraphQLTypes["FooterLocaleUpdateDeveloperLinkEntityRelationInput"],
	development?: string,
	linkedIn?: string,
	photography?: string,
	photographers?: Array<GraphQLTypes["FooterLocaleUpdatePhotographersEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderConnection"]: {
	__typename: "HeaderConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HeaderEdge"]>
};
	["HeaderEdge"]: {
	__typename: "HeaderEdge",
	node: GraphQLTypes["Header"]
};
	["HeaderCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["HeaderCreateLocalesEntityRelationInput"]>,
	logo?: GraphQLTypes["HeaderCreateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"],
	alias?: string
};
	["HeaderLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["LocaleWithoutHeadersCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["HeaderUpdateLocalesEntityRelationInput"]>,
	logo?: GraphQLTypes["HeaderUpdateLogoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["HeaderUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["HeaderUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	delete?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	alias?: string
};
	["HeaderUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	data?: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"]
};
	["HeaderLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"],
	update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	upsert?: GraphQLTypes["HeaderLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutHeadersUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["HeaderLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutHeadersUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutHeadersCreateInput"]
};
	["HeaderUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["HeaderLocaleUniqueWhere"],
	update?: GraphQLTypes["HeaderLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["HeaderLocaleWithoutRootCreateInput"]
};
	["HeaderLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["HeaderLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleCreateLocaleEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleCreateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleCreateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HeaderLocaleUpdateInput"]: {
		root?: GraphQLTypes["HeaderLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["HeaderLocaleUpdateLocaleEntityRelationInput"],
	links?: Array<GraphQLTypes["HeaderLocaleUpdateLinksEntityRelationInput"]>,
	artworkBreadcrumbParentLink?: GraphQLTypes["HeaderLocaleUpdateArtworkBreadcrumbParentLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageConnection"]: {
	__typename: "HomePageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["HomePageEdge"]>
};
	["HomePageEdge"]: {
	__typename: "HomePageEdge",
	node: GraphQLTypes["HomePage"]
};
	["HomePageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["HomePageCreateLocalesEntityRelationInput"]>,
	media?: GraphQLTypes["HomePageCreateMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	create?: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["HomePageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleCreateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["HomePageUpdateLocalesEntityRelationInput"]>,
	media?: GraphQLTypes["HomePageUpdateMediaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["HomePageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["HomePageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["HomePageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	delete?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	alias?: string
};
	["HomePageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	data?: GraphQLTypes["HomePageLocaleWithoutRootUpdateInput"]
};
	["HomePageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleUpdateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["HomePageLocaleUniqueWhere"],
	update?: GraphQLTypes["HomePageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["HomePageLocaleWithoutRootCreateInput"]
};
	["HomePageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["HomePageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["HomePageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleCreateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleCreateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleCreateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleCreateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["HomePageLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["HomePageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["HomePageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["HomePageLocaleUpdateContentEntityRelationInput"],
	link?: GraphQLTypes["HomePageLocaleUpdateLinkEntityRelationInput"],
	seo?: GraphQLTypes["HomePageLocaleUpdateSeoEntityRelationInput"],
	branches?: Array<GraphQLTypes["HomePageLocaleUpdateBranchesEntityRelationInput"]>,
	leadParagraph?: string,
	_dummy_field_?: boolean
};
	["LinkConnection"]: {
	__typename: "LinkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkEdge"]>
};
	["LinkEdge"]: {
	__typename: "LinkEdge",
	node: GraphQLTypes["Link"]
};
	["LinkableConnection"]: {
	__typename: "LinkableConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LinkableEdge"]>
};
	["LinkableEdge"]: {
	__typename: "LinkableEdge",
	node: GraphQLTypes["Linkable"]
};
	["LocaleConnection"]: {
	__typename: "LocaleConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LocaleEdge"]>
};
	["LocaleEdge"]: {
	__typename: "LocaleEdge",
	node: GraphQLTypes["Locale"]
};
	["LocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleCreateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["LocaleUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	seoDefaults?: Array<GraphQLTypes["LocaleUpdateSeoDefaultsEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["MediumConnection"]: {
	__typename: "MediumConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumEdge"]>
};
	["MediumEdge"]: {
	__typename: "MediumEdge",
	node: GraphQLTypes["Medium"]
};
	["MediumItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["MediumItemCreateListEntityRelationInput"],
	medium?: GraphQLTypes["MediumItemCreateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["MediumListUniqueWhere"],
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["MediumItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["MediumItemUpdateListEntityRelationInput"],
	medium?: GraphQLTypes["MediumItemUpdateMediumEntityRelationInput"],
	_dummy_field_?: boolean
};
	["MediumItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["MediumListWithoutItemsCreateInput"],
	update?: GraphQLTypes["MediumListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["MediumItemUpsertListRelationInput"],
	connect?: GraphQLTypes["MediumListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["MediumListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["MediumItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["MediumListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["MediumListWithoutItemsCreateInput"]
};
	["MediumListConnection"]: {
	__typename: "MediumListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["MediumListEdge"]>
};
	["MediumListEdge"]: {
	__typename: "MediumListEdge",
	node: GraphQLTypes["MediumList"]
};
	["PageConnection"]: {
	__typename: "PageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["PageEdge"]>
};
	["PageEdge"]: {
	__typename: "PageEdge",
	node: GraphQLTypes["Page"]
};
	["PageCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locales?: Array<GraphQLTypes["PageCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PageCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"],
	alias?: string
};
	["PageLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpdateInput"]: {
		locales?: Array<GraphQLTypes["PageUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["PageUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["PageUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["PageUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["PageLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["PageLocaleUniqueWhere"],
	delete?: GraphQLTypes["PageLocaleUniqueWhere"],
	alias?: string
};
	["PageUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	data?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"]
};
	["PageLocaleWithoutRootUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["PageLocaleUniqueWhere"],
	update?: GraphQLTypes["PageLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["PageLocaleWithoutRootCreateInput"]
};
	["PageLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	link?: GraphQLTypes["PageLocaleCreateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["PageLocaleUpdateInput"]: {
		title?: string,
	link?: GraphQLTypes["PageLocaleUpdateLinkEntityRelationInput"],
	root?: GraphQLTypes["PageLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["PageLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["PageLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["PageLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultConnection"]: {
	__typename: "SeoDefaultConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoDefaultEdge"]>
};
	["SeoDefaultEdge"]: {
	__typename: "SeoDefaultEdge",
	node: GraphQLTypes["SeoDefault"]
};
	["SeoDefaultCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["SeoDefaultCreateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoDefaultCreateLocalesEntityRelationInput"]: {
		connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	create?: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"],
	alias?: string
};
	["SeoDefaultLocaleWithoutRootCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	locale?: GraphQLTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleCreateLocaleEntityRelationInput"]: {
		connect?: GraphQLTypes["LocaleUniqueWhere"],
	create?: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["LocaleWithoutSeoDefaultsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleCreateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleCreateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleCreateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleCreateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleCreatePagesEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleCreateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleCreateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleCreateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleCreateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleCreateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleCreateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoDefaultUpdateInput"]: {
		unique?: GraphQLTypes["One"],
	locales?: Array<GraphQLTypes["SeoDefaultUpdateLocalesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoDefaultUpdateLocalesEntityRelationInput"]: {
		create?: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"],
	update?: GraphQLTypes["SeoDefaultUpdateLocalesRelationInput"],
	upsert?: GraphQLTypes["SeoDefaultUpsertLocalesRelationInput"],
	connect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	disconnect?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	delete?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	alias?: string
};
	["SeoDefaultUpdateLocalesRelationInput"]: {
		by?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	data?: GraphQLTypes["SeoDefaultLocaleWithoutRootUpdateInput"]
};
	["SeoDefaultLocaleWithoutRootUpdateInput"]: {
		locale?: GraphQLTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleUpdateLocaleEntityRelationInput"]: {
		create?: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"],
	update?: GraphQLTypes["LocaleWithoutSeoDefaultsUpdateInput"],
	upsert?: GraphQLTypes["SeoDefaultLocaleUpsertLocaleRelationInput"],
	connect?: GraphQLTypes["LocaleUniqueWhere"],
	delete?: boolean
};
	["LocaleWithoutSeoDefaultsUpdateInput"]: {
		code?: string,
	label?: string,
	contactPages?: Array<GraphQLTypes["LocaleUpdateContactPagesEntityRelationInput"]>,
	footers?: Array<GraphQLTypes["LocaleUpdateFootersEntityRelationInput"]>,
	headers?: Array<GraphQLTypes["LocaleUpdateHeadersEntityRelationInput"]>,
	homePages?: Array<GraphQLTypes["LocaleUpdateHomePagesEntityRelationInput"]>,
	pages?: Array<GraphQLTypes["LocaleUpdatePagesEntityRelationInput"]>,
	events?: Array<GraphQLTypes["LocaleUpdateEventsEntityRelationInput"]>,
	artworks?: Array<GraphQLTypes["LocaleUpdateArtworksEntityRelationInput"]>,
	artworkSelections?: Array<GraphQLTypes["LocaleUpdateArtworkSelectionsEntityRelationInput"]>,
	newsletterForms?: Array<GraphQLTypes["LocaleUpdateNewsletterFormsEntityRelationInput"]>,
	employees?: Array<GraphQLTypes["LocaleUpdateEmployeesEntityRelationInput"]>,
	contactForms?: Array<GraphQLTypes["LocaleUpdateContactFormsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleUpsertLocaleRelationInput"]: {
		update?: GraphQLTypes["LocaleWithoutSeoDefaultsUpdateInput"],
	create?: GraphQLTypes["LocaleWithoutSeoDefaultsCreateInput"]
};
	["SeoDefaultUpsertLocalesRelationInput"]: {
		by?: GraphQLTypes["SeoDefaultLocaleUniqueWhere"],
	update?: GraphQLTypes["SeoDefaultLocaleWithoutRootUpdateInput"],
	create?: GraphQLTypes["SeoDefaultLocaleWithoutRootCreateInput"]
};
	["SeoDefaultLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	root?: GraphQLTypes["SeoDefaultLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["SeoDefaultLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleCreateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["SeoDefaultLocaleUpdateInput"]: {
		root?: GraphQLTypes["SeoDefaultLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["SeoDefaultLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["SeoDefaultLocaleUpdateSeoEntityRelationInput"],
	_dummy_field_?: boolean
};
	["VideoConnection"]: {
	__typename: "VideoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["VideoEdge"]>
};
	["VideoEdge"]: {
	__typename: "VideoEdge",
	node: GraphQLTypes["Video"]
};
	["ImageConnection"]: {
	__typename: "ImageConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ImageEdge"]>
};
	["ImageEdge"]: {
	__typename: "ImageEdge",
	node: GraphQLTypes["Image"]
};
	["SeoConnection"]: {
	__typename: "SeoConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["SeoEdge"]>
};
	["SeoEdge"]: {
	__typename: "SeoEdge",
	node: GraphQLTypes["Seo"]
};
	["TranslationDomain"]: {
	__typename: "TranslationDomain",
	_meta?: GraphQLTypes["TranslationDomainMeta"],
	id: GraphQLTypes["UUID"],
	identifier: string,
	name: string,
	catalogues: Array<GraphQLTypes["TranslationCatalogue"]>,
	keys: Array<GraphQLTypes["TranslationKey"]>,
	cataloguesByIdentifier?: GraphQLTypes["TranslationCatalogue"],
	cataloguesByValues?: GraphQLTypes["TranslationCatalogue"],
	keysByIdentifier?: GraphQLTypes["TranslationKey"],
	keysByValues?: GraphQLTypes["TranslationKey"],
	paginateCatalogues: GraphQLTypes["TranslationCatalogueConnection"],
	paginateKeys: GraphQLTypes["TranslationKeyConnection"]
};
	["TranslationDomainMeta"]: {
	__typename: "TranslationDomainMeta",
	id?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	catalogues?: GraphQLTypes["FieldMeta"],
	keys?: GraphQLTypes["FieldMeta"]
};
	["TranslationCatalogue"]: {
	__typename: "TranslationCatalogue",
	_meta?: GraphQLTypes["TranslationCatalogueMeta"],
	id: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomain"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	fallback?: GraphQLTypes["TranslationCatalogue"],
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByKey?: GraphQLTypes["TranslationValue"],
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationCatalogueMeta"]: {
	__typename: "TranslationCatalogueMeta",
	id?: GraphQLTypes["FieldMeta"],
	domain?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	fallback?: GraphQLTypes["FieldMeta"],
	values?: GraphQLTypes["FieldMeta"]
};
	["TranslationDomainWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	identifier?: GraphQLTypes["StringCondition"],
	name?: GraphQLTypes["StringCondition"],
	catalogues?: GraphQLTypes["TranslationCatalogueWhere"],
	keys?: GraphQLTypes["TranslationKeyWhere"],
	and?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationDomainWhere"] | undefined>,
	not?: GraphQLTypes["TranslationDomainWhere"]
};
	["TranslationCatalogueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	domain?: GraphQLTypes["TranslationDomainWhere"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierWhere"],
	fallback?: GraphQLTypes["TranslationCatalogueWhere"],
	values?: GraphQLTypes["TranslationValueWhere"],
	and?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationCatalogueWhere"] | undefined>,
	not?: GraphQLTypes["TranslationCatalogueWhere"]
};
	["TranslationCataloguesIdentifierWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	name?: GraphQLTypes["StringCondition"],
	code?: GraphQLTypes["StringCondition"],
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"],
	and?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationCataloguesIdentifierWhere"] | undefined>,
	not?: GraphQLTypes["TranslationCataloguesIdentifierWhere"]
};
	["TranslationValueWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	value?: GraphQLTypes["StringCondition"],
	catalogue?: GraphQLTypes["TranslationCatalogueWhere"],
	key?: GraphQLTypes["TranslationKeyWhere"],
	and?: Array<GraphQLTypes["TranslationValueWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationValueWhere"] | undefined>,
	not?: GraphQLTypes["TranslationValueWhere"]
};
	["TranslationKeyWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	identifier?: GraphQLTypes["StringCondition"],
	contentType?: GraphQLTypes["TranslationContentTypeCondition"],
	note?: GraphQLTypes["StringCondition"],
	domain?: GraphQLTypes["TranslationDomainWhere"],
	values?: GraphQLTypes["TranslationValueWhere"],
	and?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined>,
	or?: Array<GraphQLTypes["TranslationKeyWhere"] | undefined>,
	not?: GraphQLTypes["TranslationKeyWhere"]
};
	["TranslationContentTypeCondition"]: {
		and?: Array<GraphQLTypes["TranslationContentTypeCondition"]>,
	or?: Array<GraphQLTypes["TranslationContentTypeCondition"]>,
	not?: GraphQLTypes["TranslationContentTypeCondition"],
	null?: boolean,
	isNull?: boolean,
	eq?: GraphQLTypes["TranslationContentType"],
	notEq?: GraphQLTypes["TranslationContentType"],
	in?: Array<GraphQLTypes["TranslationContentType"]>,
	notIn?: Array<GraphQLTypes["TranslationContentType"]>,
	lt?: GraphQLTypes["TranslationContentType"],
	lte?: GraphQLTypes["TranslationContentType"],
	gt?: GraphQLTypes["TranslationContentType"],
	gte?: GraphQLTypes["TranslationContentType"]
};
	["TranslationContentType"]: TranslationContentType;
	["TranslationCataloguesIdentifier"]: {
	__typename: "TranslationCataloguesIdentifier",
	_meta?: GraphQLTypes["TranslationCataloguesIdentifierMeta"],
	id: GraphQLTypes["UUID"],
	name: string,
	code: string,
	catalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	catalogueByDomain?: GraphQLTypes["TranslationCatalogue"],
	catalogueByValues?: GraphQLTypes["TranslationCatalogue"],
	paginateCatalogue: GraphQLTypes["TranslationCatalogueConnection"]
};
	["TranslationCataloguesIdentifierMeta"]: {
	__typename: "TranslationCataloguesIdentifierMeta",
	id?: GraphQLTypes["FieldMeta"],
	name?: GraphQLTypes["FieldMeta"],
	code?: GraphQLTypes["FieldMeta"],
	catalogue?: GraphQLTypes["FieldMeta"]
};
	["TranslationCatalogueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	domain?: GraphQLTypes["TranslationDomainOrderBy"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierOrderBy"],
	fallback?: GraphQLTypes["TranslationCatalogueOrderBy"]
};
	["TranslationDomainOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	identifier?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"]
};
	["TranslationCataloguesIdentifierOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	name?: GraphQLTypes["OrderDirection"],
	code?: GraphQLTypes["OrderDirection"]
};
	["TranslationCataloguesIdentifierCatalogueByDomainUniqueWhere"]: {
		domain?: GraphQLTypes["TranslationDomainUniqueWhere"]
};
	["TranslationDomainUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	catalogues?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	keys?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationCatalogueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"],
	identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCataloguesIdentifierUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	code?: string,
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"]
};
	["TranslationValueUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	key?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationKeyUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationDomainUniqueWhere"],
	identifier?: string,
	values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCataloguesIdentifierCatalogueByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationCatalogueConnection"]: {
	__typename: "TranslationCatalogueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCatalogueEdge"]>
};
	["TranslationCatalogueEdge"]: {
	__typename: "TranslationCatalogueEdge",
	node: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationValue"]: {
	__typename: "TranslationValue",
	_meta?: GraphQLTypes["TranslationValueMeta"],
	id: GraphQLTypes["UUID"],
	value: string,
	catalogue?: GraphQLTypes["TranslationCatalogue"],
	key?: GraphQLTypes["TranslationKey"]
};
	["TranslationValueMeta"]: {
	__typename: "TranslationValueMeta",
	id?: GraphQLTypes["FieldMeta"],
	value?: GraphQLTypes["FieldMeta"],
	catalogue?: GraphQLTypes["FieldMeta"],
	key?: GraphQLTypes["FieldMeta"]
};
	["TranslationKey"]: {
	__typename: "TranslationKey",
	_meta?: GraphQLTypes["TranslationKeyMeta"],
	id: GraphQLTypes["UUID"],
	identifier: string,
	contentType: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationDomain"],
	values: Array<GraphQLTypes["TranslationValue"]>,
	valuesByCatalogue?: GraphQLTypes["TranslationValue"],
	paginateValues: GraphQLTypes["TranslationValueConnection"]
};
	["TranslationKeyMeta"]: {
	__typename: "TranslationKeyMeta",
	id?: GraphQLTypes["FieldMeta"],
	identifier?: GraphQLTypes["FieldMeta"],
	contentType?: GraphQLTypes["FieldMeta"],
	note?: GraphQLTypes["FieldMeta"],
	domain?: GraphQLTypes["FieldMeta"],
	values?: GraphQLTypes["FieldMeta"]
};
	["TranslationValueOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	value?: GraphQLTypes["OrderDirection"],
	catalogue?: GraphQLTypes["TranslationCatalogueOrderBy"],
	key?: GraphQLTypes["TranslationKeyOrderBy"]
};
	["TranslationKeyOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	identifier?: GraphQLTypes["OrderDirection"],
	contentType?: GraphQLTypes["OrderDirection"],
	note?: GraphQLTypes["OrderDirection"],
	domain?: GraphQLTypes["TranslationDomainOrderBy"]
};
	["TranslationKeyValuesByCatalogueUniqueWhere"]: {
		catalogue?: GraphQLTypes["TranslationCatalogueUniqueWhere"]
};
	["TranslationValueConnection"]: {
	__typename: "TranslationValueConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationValueEdge"]>
};
	["TranslationValueEdge"]: {
	__typename: "TranslationValueEdge",
	node: GraphQLTypes["TranslationValue"]
};
	["TranslationCatalogueValuesByKeyUniqueWhere"]: {
		key?: GraphQLTypes["TranslationKeyUniqueWhere"]
};
	["TranslationDomainCataloguesByIdentifierUniqueWhere"]: {
		identifier?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"]
};
	["TranslationDomainCataloguesByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationDomainKeysByIdentifierUniqueWhere"]: {
		identifier?: string
};
	["TranslationDomainKeysByValuesUniqueWhere"]: {
		values?: GraphQLTypes["TranslationValueUniqueWhere"]
};
	["TranslationKeyConnection"]: {
	__typename: "TranslationKeyConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationKeyEdge"]>
};
	["TranslationKeyEdge"]: {
	__typename: "TranslationKeyEdge",
	node: GraphQLTypes["TranslationKey"]
};
	["TranslationDomainConnection"]: {
	__typename: "TranslationDomainConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationDomainEdge"]>
};
	["TranslationDomainEdge"]: {
	__typename: "TranslationDomainEdge",
	node: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]>,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainCreateCataloguesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"],
	alias?: string
};
	["TranslationCatalogueWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateIdentifierEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateFallbackEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationDomainWithoutCataloguesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	keys?: Array<GraphQLTypes["TranslationDomainCreateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainCreateKeysEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"],
	alias?: string
};
	["TranslationKeyWithoutDomainCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"],
	alias?: string
};
	["TranslationValueWithoutKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationCatalogueWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueCreateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationCatalogueCreateValuesEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"],
	alias?: string
};
	["TranslationValueWithoutCatalogueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueCreateKeyEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationKeyWithoutValuesCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationKeyCreateDomainEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationDomainWithoutKeysCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainCreateCataloguesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateInput"]: {
		identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]>,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateCataloguesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"],
	update?: GraphQLTypes["TranslationDomainUpdateCataloguesRelationInput"],
	upsert?: GraphQLTypes["TranslationDomainUpsertCataloguesRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	alias?: string
};
	["TranslationDomainUpdateCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"]
};
	["TranslationCatalogueWithoutDomainUpdateInput"]: {
		identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpdateIdentifierEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertIdentifierRelationInput"],
	connect?: GraphQLTypes["TranslationCataloguesIdentifierUniqueWhere"],
	delete?: boolean
};
	["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"]: {
		name?: string,
	code?: string,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpsertIdentifierRelationInput"]: {
		update?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationCataloguesIdentifierWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpdateFallbackEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertFallbackRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["TranslationCatalogueUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCatalogueUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"],
	update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertDomainRelationInput"],
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	delete?: boolean
};
	["TranslationDomainWithoutCataloguesUpdateInput"]: {
		identifier?: string,
	name?: string,
	keys?: Array<GraphQLTypes["TranslationDomainUpdateKeysEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationDomainUpdateKeysEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"],
	update?: GraphQLTypes["TranslationDomainUpdateKeysRelationInput"],
	upsert?: GraphQLTypes["TranslationDomainUpsertKeysRelationInput"],
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	delete?: GraphQLTypes["TranslationKeyUniqueWhere"],
	alias?: string
};
	["TranslationDomainUpdateKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"],
	data?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"]
};
	["TranslationKeyWithoutDomainUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"],
	update?: GraphQLTypes["TranslationKeyUpdateValuesRelationInput"],
	upsert?: GraphQLTypes["TranslationKeyUpsertValuesRelationInput"],
	connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"],
	delete?: GraphQLTypes["TranslationValueUniqueWhere"],
	alias?: string
};
	["TranslationKeyUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	data?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"]
};
	["TranslationValueWithoutKeyUpdateInput"]: {
		value?: string,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	upsert?: GraphQLTypes["TranslationValueUpsertCatalogueRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: boolean
};
	["TranslationCatalogueWithoutValuesUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	identifier?: GraphQLTypes["TranslationCatalogueUpdateIdentifierEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpsertCatalogueRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueWithoutValuesUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutValuesCreateInput"]
};
	["TranslationKeyUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	update?: GraphQLTypes["TranslationValueWithoutKeyUpdateInput"],
	create?: GraphQLTypes["TranslationValueWithoutKeyCreateInput"]
};
	["TranslationDomainUpsertKeysRelationInput"]: {
		by?: GraphQLTypes["TranslationKeyUniqueWhere"],
	update?: GraphQLTypes["TranslationKeyWithoutDomainUpdateInput"],
	create?: GraphQLTypes["TranslationKeyWithoutDomainCreateInput"]
};
	["TranslationCatalogueUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutCataloguesUpdateInput"],
	create?: GraphQLTypes["TranslationDomainWithoutCataloguesCreateInput"]
};
	["TranslationCatalogueUpdateValuesEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"],
	update?: GraphQLTypes["TranslationCatalogueUpdateValuesRelationInput"],
	upsert?: GraphQLTypes["TranslationCatalogueUpsertValuesRelationInput"],
	connect?: GraphQLTypes["TranslationValueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationValueUniqueWhere"],
	delete?: GraphQLTypes["TranslationValueUniqueWhere"],
	alias?: string
};
	["TranslationCatalogueUpdateValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	data?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"]
};
	["TranslationValueWithoutCatalogueUpdateInput"]: {
		value?: string,
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateKeyEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"],
	update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"],
	upsert?: GraphQLTypes["TranslationValueUpsertKeyRelationInput"],
	connect?: GraphQLTypes["TranslationKeyUniqueWhere"],
	delete?: boolean
};
	["TranslationKeyWithoutValuesUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateDomainEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"],
	update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"],
	upsert?: GraphQLTypes["TranslationKeyUpsertDomainRelationInput"],
	connect?: GraphQLTypes["TranslationDomainUniqueWhere"],
	delete?: boolean
};
	["TranslationDomainWithoutKeysUpdateInput"]: {
		identifier?: string,
	name?: string,
	catalogues?: Array<GraphQLTypes["TranslationDomainUpdateCataloguesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpsertDomainRelationInput"]: {
		update?: GraphQLTypes["TranslationDomainWithoutKeysUpdateInput"],
	create?: GraphQLTypes["TranslationDomainWithoutKeysCreateInput"]
};
	["TranslationValueUpsertKeyRelationInput"]: {
		update?: GraphQLTypes["TranslationKeyWithoutValuesUpdateInput"],
	create?: GraphQLTypes["TranslationKeyWithoutValuesCreateInput"]
};
	["TranslationCatalogueUpsertValuesRelationInput"]: {
		by?: GraphQLTypes["TranslationValueUniqueWhere"],
	update?: GraphQLTypes["TranslationValueWithoutCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationValueWithoutCatalogueCreateInput"]
};
	["TranslationCatalogueUpsertFallbackRelationInput"]: {
		update?: GraphQLTypes["TranslationCatalogueUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueCreateInput"]
};
	["TranslationDomainUpsertCataloguesRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update?: GraphQLTypes["TranslationCatalogueWithoutDomainUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutDomainCreateInput"]
};
	["TranslationCataloguesIdentifierConnection"]: {
	__typename: "TranslationCataloguesIdentifierConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["TranslationCataloguesIdentifierEdge"]>
};
	["TranslationCataloguesIdentifierEdge"]: {
	__typename: "TranslationCataloguesIdentifierEdge",
	node: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	name?: string,
	code?: string,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierCreateCatalogueEntityRelationInput"]: {
		connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"],
	alias?: string
};
	["TranslationCatalogueWithoutIdentifierCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	domain?: GraphQLTypes["TranslationCatalogueCreateDomainEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueCreateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpdateInput"]: {
		name?: string,
	code?: string,
	catalogue?: Array<GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpdateCatalogueEntityRelationInput"]: {
		create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"],
	update?: GraphQLTypes["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"],
	upsert?: GraphQLTypes["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"],
	connect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	disconnect?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	delete?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	alias?: string
};
	["TranslationCataloguesIdentifierUpdateCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	data?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"]
};
	["TranslationCatalogueWithoutIdentifierUpdateInput"]: {
		domain?: GraphQLTypes["TranslationCatalogueUpdateDomainEntityRelationInput"],
	fallback?: GraphQLTypes["TranslationCatalogueUpdateFallbackEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationCatalogueUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationCataloguesIdentifierUpsertCatalogueRelationInput"]: {
		by?: GraphQLTypes["TranslationCatalogueUniqueWhere"],
	update?: GraphQLTypes["TranslationCatalogueWithoutIdentifierUpdateInput"],
	create?: GraphQLTypes["TranslationCatalogueWithoutIdentifierCreateInput"]
};
	["TranslationKeyCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyCreateDomainEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationKeyCreateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationKeyUpdateInput"]: {
		identifier?: string,
	contentType?: GraphQLTypes["TranslationContentType"],
	note?: string,
	domain?: GraphQLTypes["TranslationKeyUpdateDomainEntityRelationInput"],
	values?: Array<GraphQLTypes["TranslationKeyUpdateValuesEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["TranslationValueCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	value?: string,
	catalogue?: GraphQLTypes["TranslationValueCreateCatalogueEntityRelationInput"],
	key?: GraphQLTypes["TranslationValueCreateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["TranslationValueUpdateInput"]: {
		value?: string,
	catalogue?: GraphQLTypes["TranslationValueUpdateCatalogueEntityRelationInput"],
	key?: GraphQLTypes["TranslationValueUpdateKeyEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventConnection"]: {
	__typename: "EventConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventEdge"]>
};
	["EventEdge"]: {
	__typename: "EventEdge",
	node: GraphQLTypes["Event"]
};
	["EventLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["EventLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleCreateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleCreateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleCreateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleCreateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["EventLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["EventLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["EventLocaleUpdateLocaleEntityRelationInput"],
	image?: GraphQLTypes["EventLocaleUpdateImageEntityRelationInput"],
	seo?: GraphQLTypes["EventLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["EventLocaleUpdateLinkEntityRelationInput"],
	venue?: string,
	venueNote?: string,
	content?: GraphQLTypes["EventLocaleUpdateContentEntityRelationInput"],
	date?: string,
	leadParagraph?: string,
	isDark?: boolean,
	_dummy_field_?: boolean
};
	["ArtworkConnection"]: {
	__typename: "ArtworkConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkEdge"]>
};
	["ArtworkEdge"]: {
	__typename: "ArtworkEdge",
	node: GraphQLTypes["Artwork"]
};
	["ArtworkLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkLocaleCreateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleCreateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleCreateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["ArtworkLocaleUpdateInput"]: {
		title?: string,
	label?: string,
	leadParagraph?: string,
	root?: GraphQLTypes["ArtworkLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkLocaleUpdateLocaleEntityRelationInput"],
	content?: GraphQLTypes["ArtworkLocaleUpdateContentEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkLocaleUpdateLinkEntityRelationInput"],
	artist?: string,
	_dummy_field_?: boolean
};
	["DropDownItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["DropDownItemCreateListEntityRelationInput"],
	link?: GraphQLTypes["DropDownItemCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["DropDownListUniqueWhere"],
	create?: GraphQLTypes["DropDownListWithoutItemsCreateInput"]
};
	["DropDownListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	dropDownType?: GraphQLTypes["DropDownType"],
	employees?: GraphQLTypes["DropDownListCreateEmployeesEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemUpdateInput"]: {
		order?: number,
	title?: string,
	text?: string,
	list?: GraphQLTypes["DropDownItemUpdateListEntityRelationInput"],
	link?: GraphQLTypes["DropDownItemUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["DropDownListWithoutItemsCreateInput"],
	update?: GraphQLTypes["DropDownListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["DropDownItemUpsertListRelationInput"],
	connect?: GraphQLTypes["DropDownListUniqueWhere"],
	delete?: boolean
};
	["DropDownListWithoutItemsUpdateInput"]: {
		dropDownType?: GraphQLTypes["DropDownType"],
	employees?: GraphQLTypes["DropDownListUpdateEmployeesEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DropDownItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["DropDownListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["DropDownListWithoutItemsCreateInput"]
};
	["DropDownListConnection"]: {
	__typename: "DropDownListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DropDownListEdge"]>
};
	["DropDownListEdge"]: {
	__typename: "DropDownListEdge",
	node: GraphQLTypes["DropDownList"]
};
	["ArtworkItem"]: {
	__typename: "ArtworkItem",
	_meta?: GraphQLTypes["ArtworkItemMeta"],
	id: GraphQLTypes["UUID"],
	order: number,
	list?: GraphQLTypes["ArtworkList"],
	artwork?: GraphQLTypes["ArtworkLocale"]
};
	["ArtworkItemMeta"]: {
	__typename: "ArtworkItemMeta",
	id?: GraphQLTypes["FieldMeta"],
	order?: GraphQLTypes["FieldMeta"],
	list?: GraphQLTypes["FieldMeta"],
	artwork?: GraphQLTypes["FieldMeta"]
};
	["ArtworkList"]: {
	__typename: "ArtworkList",
	_meta?: GraphQLTypes["ArtworkListMeta"],
	id: GraphQLTypes["UUID"],
	items: Array<GraphQLTypes["ArtworkItem"]>,
	paginateItems: GraphQLTypes["ArtworkItemConnection"]
};
	["ArtworkListMeta"]: {
	__typename: "ArtworkListMeta",
	id?: GraphQLTypes["FieldMeta"],
	items?: GraphQLTypes["FieldMeta"]
};
	["ArtworkItemWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	order?: GraphQLTypes["IntCondition"],
	list?: GraphQLTypes["ArtworkListWhere"],
	artwork?: GraphQLTypes["ArtworkLocaleWhere"],
	and?: Array<GraphQLTypes["ArtworkItemWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkItemWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkItemWhere"]
};
	["ArtworkListWhere"]: {
		id?: GraphQLTypes["UUIDCondition"],
	items?: GraphQLTypes["ArtworkItemWhere"],
	and?: Array<GraphQLTypes["ArtworkListWhere"] | undefined>,
	or?: Array<GraphQLTypes["ArtworkListWhere"] | undefined>,
	not?: GraphQLTypes["ArtworkListWhere"]
};
	["ArtworkItemOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"],
	order?: GraphQLTypes["OrderDirection"],
	list?: GraphQLTypes["ArtworkListOrderBy"],
	artwork?: GraphQLTypes["ArtworkLocaleOrderBy"]
};
	["ArtworkListOrderBy"]: {
		_random?: boolean,
	_randomSeeded?: number,
	id?: GraphQLTypes["OrderDirection"]
};
	["ArtworkItemConnection"]: {
	__typename: "ArtworkItemConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkItemEdge"]>
};
	["ArtworkItemEdge"]: {
	__typename: "ArtworkItemEdge",
	node: GraphQLTypes["ArtworkItem"]
};
	["ArtworkItemUniqueWhere"]: {
		id?: GraphQLTypes["UUID"]
};
	["ArtworkItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ArtworkItemCreateListEntityRelationInput"],
	artwork?: GraphQLTypes["ArtworkItemCreateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkListUniqueWhere"],
	create?: GraphQLTypes["ArtworkListWithoutItemsCreateInput"]
};
	["ArtworkListUniqueWhere"]: {
		id?: GraphQLTypes["UUID"],
	items?: GraphQLTypes["ArtworkItemUniqueWhere"]
};
	["ArtworkListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ArtworkItemCreateArtworkEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	create?: GraphQLTypes["ArtworkLocaleCreateInput"]
};
	["ArtworkItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ArtworkItemUpdateListEntityRelationInput"],
	artwork?: GraphQLTypes["ArtworkItemUpdateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ArtworkListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ArtworkItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ArtworkListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ArtworkItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ArtworkListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ArtworkListWithoutItemsCreateInput"]
};
	["ArtworkItemUpdateArtworkEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkLocaleCreateInput"],
	update?: GraphQLTypes["ArtworkLocaleUpdateInput"],
	upsert?: GraphQLTypes["ArtworkItemUpsertArtworkRelationInput"],
	connect?: GraphQLTypes["ArtworkLocaleUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ArtworkItemUpsertArtworkRelationInput"]: {
		update?: GraphQLTypes["ArtworkLocaleUpdateInput"],
	create?: GraphQLTypes["ArtworkLocaleCreateInput"]
};
	["ArtworkListConnection"]: {
	__typename: "ArtworkListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkListEdge"]>
};
	["ArtworkListEdge"]: {
	__typename: "ArtworkListEdge",
	node: GraphQLTypes["ArtworkList"]
};
	["ArtworkListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	items?: Array<GraphQLTypes["ArtworkListCreateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArtworkListCreateItemsEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkItemUniqueWhere"],
	create?: GraphQLTypes["ArtworkItemWithoutListCreateInput"],
	alias?: string
};
	["ArtworkItemWithoutListCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	artwork?: GraphQLTypes["ArtworkItemCreateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkListUpdateInput"]: {
		items?: Array<GraphQLTypes["ArtworkListUpdateItemsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["ArtworkListUpdateItemsEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkItemWithoutListCreateInput"],
	update?: GraphQLTypes["ArtworkListUpdateItemsRelationInput"],
	upsert?: GraphQLTypes["ArtworkListUpsertItemsRelationInput"],
	connect?: GraphQLTypes["ArtworkItemUniqueWhere"],
	disconnect?: GraphQLTypes["ArtworkItemUniqueWhere"],
	delete?: GraphQLTypes["ArtworkItemUniqueWhere"],
	alias?: string
};
	["ArtworkListUpdateItemsRelationInput"]: {
		by?: GraphQLTypes["ArtworkItemUniqueWhere"],
	data?: GraphQLTypes["ArtworkItemWithoutListUpdateInput"]
};
	["ArtworkItemWithoutListUpdateInput"]: {
		order?: number,
	artwork?: GraphQLTypes["ArtworkItemUpdateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkListUpsertItemsRelationInput"]: {
		by?: GraphQLTypes["ArtworkItemUniqueWhere"],
	update?: GraphQLTypes["ArtworkItemWithoutListUpdateInput"],
	create?: GraphQLTypes["ArtworkItemWithoutListCreateInput"]
};
	["ArtworkSelectionConnection"]: {
	__typename: "ArtworkSelectionConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkSelectionEdge"]>
};
	["ArtworkSelectionEdge"]: {
	__typename: "ArtworkSelectionEdge",
	node: GraphQLTypes["ArtworkSelection"]
};
	["ArtworkSelectionItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ArtworkSelectionItemCreateListEntityRelationInput"],
	artwork?: GraphQLTypes["ArtworkSelectionItemCreateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ArtworkSelectionListUniqueWhere"],
	create?: GraphQLTypes["ArtworkSelectionListWithoutItemsCreateInput"]
};
	["ArtworkSelectionListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ArtworkSelectionItemUpdateListEntityRelationInput"],
	artwork?: GraphQLTypes["ArtworkSelectionItemUpdateArtworkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ArtworkSelectionListWithoutItemsCreateInput"],
	update?: GraphQLTypes["ArtworkSelectionListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ArtworkSelectionItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ArtworkSelectionListUniqueWhere"],
	delete?: boolean
};
	["ArtworkSelectionListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["ArtworkSelectionItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ArtworkSelectionListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ArtworkSelectionListWithoutItemsCreateInput"]
};
	["ArtworkSelectionListConnection"]: {
	__typename: "ArtworkSelectionListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ArtworkSelectionListEdge"]>
};
	["ArtworkSelectionListEdge"]: {
	__typename: "ArtworkSelectionListEdge",
	node: GraphQLTypes["ArtworkSelectionList"]
};
	["ArtworkSelectionLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkSelectionLocaleCreateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleCreateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleCreateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ArtworkSelectionLocaleUpdateInput"]: {
		title?: string,
	root?: GraphQLTypes["ArtworkSelectionLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ArtworkSelectionLocaleUpdateLocaleEntityRelationInput"],
	seo?: GraphQLTypes["ArtworkSelectionLocaleUpdateSeoEntityRelationInput"],
	link?: GraphQLTypes["ArtworkSelectionLocaleUpdateLinkEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["EventItemCreateListEntityRelationInput"],
	event?: GraphQLTypes["EventItemCreateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["EventListUniqueWhere"],
	create?: GraphQLTypes["EventListWithoutItemsCreateInput"]
};
	["EventListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["EventItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["EventItemUpdateListEntityRelationInput"],
	event?: GraphQLTypes["EventItemUpdateEventEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EventItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["EventListWithoutItemsCreateInput"],
	update?: GraphQLTypes["EventListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["EventItemUpsertListRelationInput"],
	connect?: GraphQLTypes["EventListUniqueWhere"],
	delete?: boolean
};
	["EventListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["EventItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["EventListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["EventListWithoutItemsCreateInput"]
};
	["EventListConnection"]: {
	__typename: "EventListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EventListEdge"]>
};
	["EventListEdge"]: {
	__typename: "EventListEdge",
	node: GraphQLTypes["EventList"]
};
	["BoxItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	link?: string,
	date?: string,
	type?: string,
	title?: string,
	text?: string,
	list?: GraphQLTypes["BoxItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BoxItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["BoxListUniqueWhere"],
	create?: GraphQLTypes["BoxListWithoutItemsCreateInput"]
};
	["BoxListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["BoxItemUpdateInput"]: {
		order?: number,
	link?: string,
	date?: string,
	type?: string,
	title?: string,
	text?: string,
	list?: GraphQLTypes["BoxItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["BoxItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["BoxListWithoutItemsCreateInput"],
	update?: GraphQLTypes["BoxListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["BoxItemUpsertListRelationInput"],
	connect?: GraphQLTypes["BoxListUniqueWhere"],
	delete?: boolean
};
	["BoxListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["BoxItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["BoxListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["BoxListWithoutItemsCreateInput"]
};
	["BoxListConnection"]: {
	__typename: "BoxListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["BoxListEdge"]>
};
	["BoxListEdge"]: {
	__typename: "BoxListEdge",
	node: GraphQLTypes["BoxList"]
};
	["NewsletterFormConnection"]: {
	__typename: "NewsletterFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["NewsletterFormEdge"]>
};
	["NewsletterFormEdge"]: {
	__typename: "NewsletterFormEdge",
	node: GraphQLTypes["NewsletterForm"]
};
	["NewsletterTypeItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	list?: GraphQLTypes["NewsletterTypeItemCreateListEntityRelationInput"],
	subscriptions?: Array<GraphQLTypes["NewsletterTypeItemCreateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutItemsCreateInput"]
};
	["NewsletterFormLocaleWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"],
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemUpdateInput"]: {
		order?: number,
	title?: string,
	list?: GraphQLTypes["NewsletterTypeItemUpdateListEntityRelationInput"],
	subscriptions?: Array<GraphQLTypes["NewsletterTypeItemUpdateSubscriptionsEntityRelationInput"]>,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterFormLocaleWithoutItemsCreateInput"],
	update?: GraphQLTypes["NewsletterFormLocaleWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["NewsletterTypeItemUpsertListRelationInput"],
	connect?: GraphQLTypes["NewsletterFormLocaleUniqueWhere"],
	delete?: boolean
};
	["NewsletterFormLocaleWithoutItemsUpdateInput"]: {
		newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"],
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterTypeItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["NewsletterFormLocaleWithoutItemsUpdateInput"],
	create?: GraphQLTypes["NewsletterFormLocaleWithoutItemsCreateInput"]
};
	["NewsletterFormLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["NewsletterFormLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleCreateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterFormLocaleUpdateInput"]: {
		newsletterTypeNote?: string,
	email?: string,
	emailNote?: string,
	submit?: string,
	root?: GraphQLTypes["NewsletterFormLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["NewsletterFormLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["NewsletterFormLocaleUpdateItemsEntityRelationInput"]>,
	title?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	newsletterTypeErrorMessage?: string,
	_dummy_field_?: boolean
};
	["NewsletterSubscriptionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	newsletterType?: GraphQLTypes["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSubscriptionCreateNewsletterTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	create?: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"]
};
	["NewsletterTypeItemWithoutSubscriptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	list?: GraphQLTypes["NewsletterTypeItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSubscriptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	newsletterType?: GraphQLTypes["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSubscriptionUpdateNewsletterTypeEntityRelationInput"]: {
		create?: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"],
	update?: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsUpdateInput"],
	upsert?: GraphQLTypes["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"],
	connect?: GraphQLTypes["NewsletterTypeItemUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["NewsletterTypeItemWithoutSubscriptionsUpdateInput"]: {
		order?: number,
	title?: string,
	list?: GraphQLTypes["NewsletterTypeItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["NewsletterSubscriptionUpsertNewsletterTypeRelationInput"]: {
		update?: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsUpdateInput"],
	create?: GraphQLTypes["NewsletterTypeItemWithoutSubscriptionsCreateInput"]
};
	["ChartConnection"]: {
	__typename: "ChartConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ChartEdge"]>
};
	["ChartEdge"]: {
	__typename: "ChartEdge",
	node: GraphQLTypes["Chart"]
};
	["ChartDataCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["ChartDataCreateListEntityRelationInput"],
	date?: GraphQLTypes["Date"],
	number?: number,
	text?: string,
	image?: GraphQLTypes["ChartDataCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ChartDataCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ChartUniqueWhere"],
	create?: GraphQLTypes["ChartWithoutItemsCreateInput"]
};
	["ChartWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	type?: GraphQLTypes["ChartType"],
	_dummy_field_?: boolean
};
	["ChartDataUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["ChartDataUpdateListEntityRelationInput"],
	date?: GraphQLTypes["Date"],
	number?: number,
	text?: string,
	image?: GraphQLTypes["ChartDataUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ChartDataUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ChartWithoutItemsCreateInput"],
	update?: GraphQLTypes["ChartWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ChartDataUpsertListRelationInput"],
	connect?: GraphQLTypes["ChartUniqueWhere"],
	delete?: boolean
};
	["ChartWithoutItemsUpdateInput"]: {
		type?: GraphQLTypes["ChartType"],
	_dummy_field_?: boolean
};
	["ChartDataUpsertListRelationInput"]: {
		update?: GraphQLTypes["ChartWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ChartWithoutItemsCreateInput"]
};
	["EmployeeConnection"]: {
	__typename: "EmployeeConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeEdge"]>
};
	["EmployeeEdge"]: {
	__typename: "EmployeeEdge",
	node: GraphQLTypes["Employee"]
};
	["EmployeeItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["EmployeeItemCreateListEntityRelationInput"],
	employee?: GraphQLTypes["EmployeeItemCreateEmployeeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	create?: GraphQLTypes["EmployeeListWithoutItemsCreateInput"]
};
	["EmployeeListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["EmployeeItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["EmployeeItemUpdateListEntityRelationInput"],
	employee?: GraphQLTypes["EmployeeItemUpdateEmployeeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["EmployeeListWithoutItemsCreateInput"],
	update?: GraphQLTypes["EmployeeListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["EmployeeItemUpsertListRelationInput"],
	connect?: GraphQLTypes["EmployeeListUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["EmployeeListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["EmployeeItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["EmployeeListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["EmployeeListWithoutItemsCreateInput"]
};
	["EmployeeListConnection"]: {
	__typename: "EmployeeListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["EmployeeListEdge"]>
};
	["EmployeeListEdge"]: {
	__typename: "EmployeeListEdge",
	node: GraphQLTypes["EmployeeList"]
};
	["EmployeeLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	position?: string,
	text?: string,
	email?: string,
	phone?: string,
	root?: GraphQLTypes["EmployeeLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["EmployeeLocaleCreateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["EmployeeLocaleUpdateInput"]: {
		position?: string,
	text?: string,
	email?: string,
	phone?: string,
	root?: GraphQLTypes["EmployeeLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["EmployeeLocaleUpdateLocaleEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DefinitionItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	key?: string,
	value?: string,
	list?: GraphQLTypes["DefinitionItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DefinitionItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["DefinitionListUniqueWhere"],
	create?: GraphQLTypes["DefinitionListWithoutItemsCreateInput"]
};
	["DefinitionListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["DefinitionItemUpdateInput"]: {
		order?: number,
	key?: string,
	value?: string,
	list?: GraphQLTypes["DefinitionItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["DefinitionItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["DefinitionListWithoutItemsCreateInput"],
	update?: GraphQLTypes["DefinitionListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["DefinitionItemUpsertListRelationInput"],
	connect?: GraphQLTypes["DefinitionListUniqueWhere"],
	delete?: boolean
};
	["DefinitionListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["DefinitionItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["DefinitionListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["DefinitionListWithoutItemsCreateInput"]
};
	["DefinitionListConnection"]: {
	__typename: "DefinitionListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["DefinitionListEdge"]>
};
	["DefinitionListEdge"]: {
	__typename: "DefinitionListEdge",
	node: GraphQLTypes["DefinitionList"]
};
	["LogoItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["LogoItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["LogoItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LogoItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["LogoListUniqueWhere"],
	create?: GraphQLTypes["LogoListWithoutItemsCreateInput"]
};
	["LogoListWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["LogoItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["LogoItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["LogoItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["LogoItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["LogoListWithoutItemsCreateInput"],
	update?: GraphQLTypes["LogoListWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["LogoItemUpsertListRelationInput"],
	connect?: GraphQLTypes["LogoListUniqueWhere"],
	delete?: boolean
};
	["LogoListWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["LogoItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["LogoListWithoutItemsUpdateInput"],
	create?: GraphQLTypes["LogoListWithoutItemsCreateInput"]
};
	["LogoListConnection"]: {
	__typename: "LogoListConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["LogoListEdge"]>
};
	["LogoListEdge"]: {
	__typename: "LogoListEdge",
	node: GraphQLTypes["LogoList"]
};
	["StrategySchemaConnection"]: {
	__typename: "StrategySchemaConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StrategySchemaEdge"]>
};
	["StrategySchemaEdge"]: {
	__typename: "StrategySchemaEdge",
	node: GraphQLTypes["StrategySchema"]
};
	["StrategySchemaGroupConnection"]: {
	__typename: "StrategySchemaGroupConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["StrategySchemaGroupEdge"]>
};
	["StrategySchemaGroupEdge"]: {
	__typename: "StrategySchemaGroupEdge",
	node: GraphQLTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	text?: string,
	schema?: GraphQLTypes["StrategySchemaGroupItemCreateSchemaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StrategySchemaGroupItemCreateSchemaEntityRelationInput"]: {
		connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	create?: GraphQLTypes["StrategySchemaGroupWithoutItemsCreateInput"]
};
	["StrategySchemaGroupWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["StrategySchemaGroupItemUpdateInput"]: {
		order?: number,
	text?: string,
	schema?: GraphQLTypes["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"],
	_dummy_field_?: boolean
};
	["StrategySchemaGroupItemUpdateSchemaEntityRelationInput"]: {
		create?: GraphQLTypes["StrategySchemaGroupWithoutItemsCreateInput"],
	update?: GraphQLTypes["StrategySchemaGroupWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["StrategySchemaGroupItemUpsertSchemaRelationInput"],
	connect?: GraphQLTypes["StrategySchemaGroupUniqueWhere"],
	delete?: boolean
};
	["StrategySchemaGroupWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["StrategySchemaGroupItemUpsertSchemaRelationInput"]: {
		update?: GraphQLTypes["StrategySchemaGroupWithoutItemsUpdateInput"],
	create?: GraphQLTypes["StrategySchemaGroupWithoutItemsCreateInput"]
};
	["RedirectConnection"]: {
	__typename: "RedirectConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["RedirectEdge"]>
};
	["RedirectEdge"]: {
	__typename: "RedirectEdge",
	node: GraphQLTypes["Redirect"]
};
	["RedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	link?: GraphQLTypes["RedirectCreateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectCreateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectCreateLinkEntityRelationInput"]: {
		connect?: GraphQLTypes["LinkableUniqueWhere"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["LinkableWithoutRedirectCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	url?: string,
	homePage?: GraphQLTypes["LinkableCreateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableCreateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableCreatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableCreateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableCreateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableCreateArtworkSelectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateInput"]: {
		link?: GraphQLTypes["RedirectUpdateLinkEntityRelationInput"],
	target?: GraphQLTypes["RedirectUpdateTargetEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpdateLinkEntityRelationInput"]: {
		create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"],
	update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	upsert?: GraphQLTypes["RedirectUpsertLinkRelationInput"],
	connect?: GraphQLTypes["LinkableUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["LinkableWithoutRedirectUpdateInput"]: {
		url?: string,
	homePage?: GraphQLTypes["LinkableUpdateHomePageEntityRelationInput"],
	contactPage?: GraphQLTypes["LinkableUpdateContactPageEntityRelationInput"],
	page?: GraphQLTypes["LinkableUpdatePageEntityRelationInput"],
	event?: GraphQLTypes["LinkableUpdateEventEntityRelationInput"],
	artwork?: GraphQLTypes["LinkableUpdateArtworkEntityRelationInput"],
	artworkSelection?: GraphQLTypes["LinkableUpdateArtworkSelectionEntityRelationInput"],
	_dummy_field_?: boolean
};
	["RedirectUpsertLinkRelationInput"]: {
		update?: GraphQLTypes["LinkableWithoutRedirectUpdateInput"],
	create?: GraphQLTypes["LinkableWithoutRedirectCreateInput"]
};
	["GalleryConnection"]: {
	__typename: "GalleryConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["GalleryEdge"]>
};
	["GalleryEdge"]: {
	__typename: "GalleryEdge",
	node: GraphQLTypes["Gallery"]
};
	["GalleryItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	list?: GraphQLTypes["GalleryItemCreateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemCreateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["GalleryUniqueWhere"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["GalleryWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateInput"]: {
		order?: number,
	list?: GraphQLTypes["GalleryItemUpdateListEntityRelationInput"],
	image?: GraphQLTypes["GalleryItemUpdateImageEntityRelationInput"],
	_dummy_field_?: boolean
};
	["GalleryItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["GalleryWithoutItemsCreateInput"],
	update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["GalleryItemUpsertListRelationInput"],
	connect?: GraphQLTypes["GalleryUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["GalleryWithoutItemsUpdateInput"]: {
		_dummy_field_?: boolean
};
	["GalleryItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["GalleryWithoutItemsUpdateInput"],
	create?: GraphQLTypes["GalleryWithoutItemsCreateInput"]
};
	["ContactFormConnection"]: {
	__typename: "ContactFormConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["ContactFormEdge"]>
};
	["ContactFormEdge"]: {
	__typename: "ContactFormEdge",
	node: GraphQLTypes["ContactForm"]
};
	["ContactFormLocaleCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactFormLocaleCreateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleCreateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactFormLocaleUpdateInput"]: {
		title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"],
	items?: Array<GraphQLTypes["ContactFormLocaleUpdateItemsEntityRelationInput"]>,
	file?: string,
	_dummy_field_?: boolean
};
	["ContactSubscriptionCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	name?: string,
	phone?: string,
	message?: string,
	file?: GraphQLTypes["ContactSubscriptionCreateFileEntityRelationInput"],
	contactType?: GraphQLTypes["ContactSubscriptionCreateContactTypeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactSubscriptionCreateContactTypeEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	create?: GraphQLTypes["ContactTypeItemWithoutSubscriptionsCreateInput"]
};
	["ContactTypeItemWithoutSubscriptionsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	list?: GraphQLTypes["ContactTypeItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactTypeItemCreateListEntityRelationInput"]: {
		connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	create?: GraphQLTypes["ContactFormLocaleWithoutItemsCreateInput"]
};
	["ContactFormLocaleWithoutItemsCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleCreateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactFormLocaleCreateLocaleEntityRelationInput"],
	file?: string,
	_dummy_field_?: boolean
};
	["ContactSubscriptionUpdateInput"]: {
		createdAt?: GraphQLTypes["DateTime"],
	email?: string,
	name?: string,
	phone?: string,
	message?: string,
	file?: GraphQLTypes["ContactSubscriptionUpdateFileEntityRelationInput"],
	contactType?: GraphQLTypes["ContactSubscriptionUpdateContactTypeEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactSubscriptionUpdateContactTypeEntityRelationInput"]: {
		create?: GraphQLTypes["ContactTypeItemWithoutSubscriptionsCreateInput"],
	update?: GraphQLTypes["ContactTypeItemWithoutSubscriptionsUpdateInput"],
	upsert?: GraphQLTypes["ContactSubscriptionUpsertContactTypeRelationInput"],
	connect?: GraphQLTypes["ContactTypeItemUniqueWhere"],
	disconnect?: boolean,
	delete?: boolean
};
	["ContactTypeItemWithoutSubscriptionsUpdateInput"]: {
		order?: number,
	title?: string,
	list?: GraphQLTypes["ContactTypeItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactTypeItemUpdateListEntityRelationInput"]: {
		create?: GraphQLTypes["ContactFormLocaleWithoutItemsCreateInput"],
	update?: GraphQLTypes["ContactFormLocaleWithoutItemsUpdateInput"],
	upsert?: GraphQLTypes["ContactTypeItemUpsertListRelationInput"],
	connect?: GraphQLTypes["ContactFormLocaleUniqueWhere"],
	delete?: boolean
};
	["ContactFormLocaleWithoutItemsUpdateInput"]: {
		title?: string,
	name?: string,
	phone?: string,
	email?: string,
	message?: string,
	submit?: string,
	successMessage?: string,
	genericErrorMessage?: string,
	contactTypeErrorMessage?: string,
	root?: GraphQLTypes["ContactFormLocaleUpdateRootEntityRelationInput"],
	locale?: GraphQLTypes["ContactFormLocaleUpdateLocaleEntityRelationInput"],
	file?: string,
	_dummy_field_?: boolean
};
	["ContactTypeItemUpsertListRelationInput"]: {
		update?: GraphQLTypes["ContactFormLocaleWithoutItemsUpdateInput"],
	create?: GraphQLTypes["ContactFormLocaleWithoutItemsCreateInput"]
};
	["ContactSubscriptionUpsertContactTypeRelationInput"]: {
		update?: GraphQLTypes["ContactTypeItemWithoutSubscriptionsUpdateInput"],
	create?: GraphQLTypes["ContactTypeItemWithoutSubscriptionsCreateInput"]
};
	["ContactTypeItemCreateInput"]: {
		id?: GraphQLTypes["UUID"],
	order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["ContactTypeItemCreateSubscriptionsEntityRelationInput"]>,
	list?: GraphQLTypes["ContactTypeItemCreateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["ContactTypeItemUpdateInput"]: {
		order?: number,
	title?: string,
	subscriptions?: Array<GraphQLTypes["ContactTypeItemUpdateSubscriptionsEntityRelationInput"]>,
	list?: GraphQLTypes["ContactTypeItemUpdateListEntityRelationInput"],
	_dummy_field_?: boolean
};
	["FileConnection"]: {
	__typename: "FileConnection",
	pageInfo: GraphQLTypes["PageInfo"],
	edges: Array<GraphQLTypes["FileEdge"]>
};
	["FileEdge"]: {
	__typename: "FileEdge",
	node: GraphQLTypes["File"]
};
	["QueryTransaction"]: {
	__typename: "QueryTransaction",
	getContactPage?: GraphQLTypes["ContactPage"],
	listContactPage: Array<GraphQLTypes["ContactPage"]>,
	paginateContactPage: GraphQLTypes["ContactPageConnection"],
	validateCreateContactPage: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPage: GraphQLTypes["_ValidationResult"],
	getContactPageLocale?: GraphQLTypes["ContactPageLocale"],
	listContactPageLocale: Array<GraphQLTypes["ContactPageLocale"]>,
	paginateContactPageLocale: GraphQLTypes["ContactPageLocaleConnection"],
	validateCreateContactPageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContactPageLocale: GraphQLTypes["_ValidationResult"],
	getContent?: GraphQLTypes["Content"],
	listContent: Array<GraphQLTypes["Content"]>,
	paginateContent: GraphQLTypes["ContentConnection"],
	validateCreateContent: GraphQLTypes["_ValidationResult"],
	validateUpdateContent: GraphQLTypes["_ValidationResult"],
	getContentBlock?: GraphQLTypes["ContentBlock"],
	listContentBlock: Array<GraphQLTypes["ContentBlock"]>,
	paginateContentBlock: GraphQLTypes["ContentBlockConnection"],
	validateCreateContentBlock: GraphQLTypes["_ValidationResult"],
	validateUpdateContentBlock: GraphQLTypes["_ValidationResult"],
	getContentReference?: GraphQLTypes["ContentReference"],
	listContentReference: Array<GraphQLTypes["ContentReference"]>,
	paginateContentReference: GraphQLTypes["ContentReferenceConnection"],
	validateCreateContentReference: GraphQLTypes["_ValidationResult"],
	validateUpdateContentReference: GraphQLTypes["_ValidationResult"],
	getFooter?: GraphQLTypes["Footer"],
	listFooter: Array<GraphQLTypes["Footer"]>,
	paginateFooter: GraphQLTypes["FooterConnection"],
	validateCreateFooter: GraphQLTypes["_ValidationResult"],
	validateUpdateFooter: GraphQLTypes["_ValidationResult"],
	getFooterLocale?: GraphQLTypes["FooterLocale"],
	listFooterLocale: Array<GraphQLTypes["FooterLocale"]>,
	paginateFooterLocale: GraphQLTypes["FooterLocaleConnection"],
	validateCreateFooterLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateFooterLocale: GraphQLTypes["_ValidationResult"],
	getHeader?: GraphQLTypes["Header"],
	listHeader: Array<GraphQLTypes["Header"]>,
	paginateHeader: GraphQLTypes["HeaderConnection"],
	validateCreateHeader: GraphQLTypes["_ValidationResult"],
	validateUpdateHeader: GraphQLTypes["_ValidationResult"],
	getHeaderLink?: GraphQLTypes["HeaderLink"],
	listHeaderLink: Array<GraphQLTypes["HeaderLink"]>,
	paginateHeaderLink: GraphQLTypes["HeaderLinkConnection"],
	validateCreateHeaderLink: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLink: GraphQLTypes["_ValidationResult"],
	getHeaderLocale?: GraphQLTypes["HeaderLocale"],
	listHeaderLocale: Array<GraphQLTypes["HeaderLocale"]>,
	paginateHeaderLocale: GraphQLTypes["HeaderLocaleConnection"],
	validateCreateHeaderLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHeaderLocale: GraphQLTypes["_ValidationResult"],
	getHomePage?: GraphQLTypes["HomePage"],
	listHomePage: Array<GraphQLTypes["HomePage"]>,
	paginateHomePage: GraphQLTypes["HomePageConnection"],
	validateCreateHomePage: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePage: GraphQLTypes["_ValidationResult"],
	getHomePageLocale?: GraphQLTypes["HomePageLocale"],
	listHomePageLocale: Array<GraphQLTypes["HomePageLocale"]>,
	paginateHomePageLocale: GraphQLTypes["HomePageLocaleConnection"],
	validateCreateHomePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateHomePageLocale: GraphQLTypes["_ValidationResult"],
	getLink?: GraphQLTypes["Link"],
	listLink: Array<GraphQLTypes["Link"]>,
	paginateLink: GraphQLTypes["LinkConnection"],
	validateCreateLink: GraphQLTypes["_ValidationResult"],
	validateUpdateLink: GraphQLTypes["_ValidationResult"],
	getLinkable?: GraphQLTypes["Linkable"],
	listLinkable: Array<GraphQLTypes["Linkable"]>,
	paginateLinkable: GraphQLTypes["LinkableConnection"],
	validateCreateLinkable: GraphQLTypes["_ValidationResult"],
	validateUpdateLinkable: GraphQLTypes["_ValidationResult"],
	getLocale?: GraphQLTypes["Locale"],
	listLocale: Array<GraphQLTypes["Locale"]>,
	paginateLocale: GraphQLTypes["LocaleConnection"],
	validateCreateLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateLocale: GraphQLTypes["_ValidationResult"],
	getMedium?: GraphQLTypes["Medium"],
	listMedium: Array<GraphQLTypes["Medium"]>,
	paginateMedium: GraphQLTypes["MediumConnection"],
	validateCreateMedium: GraphQLTypes["_ValidationResult"],
	validateUpdateMedium: GraphQLTypes["_ValidationResult"],
	getMediumItem?: GraphQLTypes["MediumItem"],
	listMediumItem: Array<GraphQLTypes["MediumItem"]>,
	paginateMediumItem: GraphQLTypes["MediumItemConnection"],
	validateCreateMediumItem: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumItem: GraphQLTypes["_ValidationResult"],
	getMediumList?: GraphQLTypes["MediumList"],
	listMediumList: Array<GraphQLTypes["MediumList"]>,
	paginateMediumList: GraphQLTypes["MediumListConnection"],
	validateCreateMediumList: GraphQLTypes["_ValidationResult"],
	validateUpdateMediumList: GraphQLTypes["_ValidationResult"],
	getPage?: GraphQLTypes["Page"],
	listPage: Array<GraphQLTypes["Page"]>,
	paginatePage: GraphQLTypes["PageConnection"],
	validateCreatePage: GraphQLTypes["_ValidationResult"],
	validateUpdatePage: GraphQLTypes["_ValidationResult"],
	getPageLocale?: GraphQLTypes["PageLocale"],
	listPageLocale: Array<GraphQLTypes["PageLocale"]>,
	paginatePageLocale: GraphQLTypes["PageLocaleConnection"],
	validateCreatePageLocale: GraphQLTypes["_ValidationResult"],
	validateUpdatePageLocale: GraphQLTypes["_ValidationResult"],
	getSeoDefault?: GraphQLTypes["SeoDefault"],
	listSeoDefault: Array<GraphQLTypes["SeoDefault"]>,
	paginateSeoDefault: GraphQLTypes["SeoDefaultConnection"],
	validateCreateSeoDefault: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefault: GraphQLTypes["_ValidationResult"],
	getSeoDefaultLocale?: GraphQLTypes["SeoDefaultLocale"],
	listSeoDefaultLocale: Array<GraphQLTypes["SeoDefaultLocale"]>,
	paginateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleConnection"],
	validateCreateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateSeoDefaultLocale: GraphQLTypes["_ValidationResult"],
	getVideo?: GraphQLTypes["Video"],
	listVideo: Array<GraphQLTypes["Video"]>,
	paginateVideo: GraphQLTypes["VideoConnection"],
	validateCreateVideo: GraphQLTypes["_ValidationResult"],
	validateUpdateVideo: GraphQLTypes["_ValidationResult"],
	getImage?: GraphQLTypes["Image"],
	listImage: Array<GraphQLTypes["Image"]>,
	paginateImage: GraphQLTypes["ImageConnection"],
	validateCreateImage: GraphQLTypes["_ValidationResult"],
	validateUpdateImage: GraphQLTypes["_ValidationResult"],
	getSeo?: GraphQLTypes["Seo"],
	listSeo: Array<GraphQLTypes["Seo"]>,
	paginateSeo: GraphQLTypes["SeoConnection"],
	validateCreateSeo: GraphQLTypes["_ValidationResult"],
	validateUpdateSeo: GraphQLTypes["_ValidationResult"],
	getTranslationDomain?: GraphQLTypes["TranslationDomain"],
	listTranslationDomain: Array<GraphQLTypes["TranslationDomain"]>,
	paginateTranslationDomain: GraphQLTypes["TranslationDomainConnection"],
	validateCreateTranslationDomain: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationDomain: GraphQLTypes["_ValidationResult"],
	getTranslationCatalogue?: GraphQLTypes["TranslationCatalogue"],
	listTranslationCatalogue: Array<GraphQLTypes["TranslationCatalogue"]>,
	paginateTranslationCatalogue: GraphQLTypes["TranslationCatalogueConnection"],
	validateCreateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCatalogue: GraphQLTypes["_ValidationResult"],
	getTranslationCataloguesIdentifier?: GraphQLTypes["TranslationCataloguesIdentifier"],
	listTranslationCataloguesIdentifier: Array<GraphQLTypes["TranslationCataloguesIdentifier"]>,
	paginateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierConnection"],
	validateCreateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationCataloguesIdentifier: GraphQLTypes["_ValidationResult"],
	getTranslationKey?: GraphQLTypes["TranslationKey"],
	listTranslationKey: Array<GraphQLTypes["TranslationKey"]>,
	paginateTranslationKey: GraphQLTypes["TranslationKeyConnection"],
	validateCreateTranslationKey: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationKey: GraphQLTypes["_ValidationResult"],
	getTranslationValue?: GraphQLTypes["TranslationValue"],
	listTranslationValue: Array<GraphQLTypes["TranslationValue"]>,
	paginateTranslationValue: GraphQLTypes["TranslationValueConnection"],
	validateCreateTranslationValue: GraphQLTypes["_ValidationResult"],
	validateUpdateTranslationValue: GraphQLTypes["_ValidationResult"],
	getBranches?: GraphQLTypes["Branches"],
	listBranches: Array<GraphQLTypes["Branches"]>,
	paginateBranches: GraphQLTypes["BranchesConnection"],
	validateCreateBranches: GraphQLTypes["_ValidationResult"],
	validateUpdateBranches: GraphQLTypes["_ValidationResult"],
	getGraphicDesigner?: GraphQLTypes["GraphicDesigner"],
	listGraphicDesigner: Array<GraphQLTypes["GraphicDesigner"]>,
	paginateGraphicDesigner: GraphQLTypes["GraphicDesignerConnection"],
	validateCreateGraphicDesigner: GraphQLTypes["_ValidationResult"],
	validateUpdateGraphicDesigner: GraphQLTypes["_ValidationResult"],
	getEvent?: GraphQLTypes["Event"],
	listEvent: Array<GraphQLTypes["Event"]>,
	paginateEvent: GraphQLTypes["EventConnection"],
	validateCreateEvent: GraphQLTypes["_ValidationResult"],
	validateUpdateEvent: GraphQLTypes["_ValidationResult"],
	getEventLocale?: GraphQLTypes["EventLocale"],
	listEventLocale: Array<GraphQLTypes["EventLocale"]>,
	paginateEventLocale: GraphQLTypes["EventLocaleConnection"],
	validateCreateEventLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEventLocale: GraphQLTypes["_ValidationResult"],
	getArtwork?: GraphQLTypes["Artwork"],
	listArtwork: Array<GraphQLTypes["Artwork"]>,
	paginateArtwork: GraphQLTypes["ArtworkConnection"],
	validateCreateArtwork: GraphQLTypes["_ValidationResult"],
	validateUpdateArtwork: GraphQLTypes["_ValidationResult"],
	getArtworkLocale?: GraphQLTypes["ArtworkLocale"],
	listArtworkLocale: Array<GraphQLTypes["ArtworkLocale"]>,
	paginateArtworkLocale: GraphQLTypes["ArtworkLocaleConnection"],
	validateCreateArtworkLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkLocale: GraphQLTypes["_ValidationResult"],
	getDropDownItem?: GraphQLTypes["DropDownItem"],
	listDropDownItem: Array<GraphQLTypes["DropDownItem"]>,
	paginateDropDownItem: GraphQLTypes["DropDownItemConnection"],
	validateCreateDropDownItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDropDownItem: GraphQLTypes["_ValidationResult"],
	getDropDownList?: GraphQLTypes["DropDownList"],
	listDropDownList: Array<GraphQLTypes["DropDownList"]>,
	paginateDropDownList: GraphQLTypes["DropDownListConnection"],
	validateCreateDropDownList: GraphQLTypes["_ValidationResult"],
	validateUpdateDropDownList: GraphQLTypes["_ValidationResult"],
	getArtworkItem?: GraphQLTypes["ArtworkItem"],
	listArtworkItem: Array<GraphQLTypes["ArtworkItem"]>,
	paginateArtworkItem: GraphQLTypes["ArtworkItemConnection"],
	validateCreateArtworkItem: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkItem: GraphQLTypes["_ValidationResult"],
	getArtworkList?: GraphQLTypes["ArtworkList"],
	listArtworkList: Array<GraphQLTypes["ArtworkList"]>,
	paginateArtworkList: GraphQLTypes["ArtworkListConnection"],
	validateCreateArtworkList: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkList: GraphQLTypes["_ValidationResult"],
	getArtworkSelection?: GraphQLTypes["ArtworkSelection"],
	listArtworkSelection: Array<GraphQLTypes["ArtworkSelection"]>,
	paginateArtworkSelection: GraphQLTypes["ArtworkSelectionConnection"],
	validateCreateArtworkSelection: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelection: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionItem?: GraphQLTypes["ArtworkSelectionItem"],
	listArtworkSelectionItem: Array<GraphQLTypes["ArtworkSelectionItem"]>,
	paginateArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemConnection"],
	validateCreateArtworkSelectionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionItem: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionList?: GraphQLTypes["ArtworkSelectionList"],
	listArtworkSelectionList: Array<GraphQLTypes["ArtworkSelectionList"]>,
	paginateArtworkSelectionList: GraphQLTypes["ArtworkSelectionListConnection"],
	validateCreateArtworkSelectionList: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionList: GraphQLTypes["_ValidationResult"],
	getArtworkSelectionLocale?: GraphQLTypes["ArtworkSelectionLocale"],
	listArtworkSelectionLocale: Array<GraphQLTypes["ArtworkSelectionLocale"]>,
	paginateArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleConnection"],
	validateCreateArtworkSelectionLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateArtworkSelectionLocale: GraphQLTypes["_ValidationResult"],
	getEventItem?: GraphQLTypes["EventItem"],
	listEventItem: Array<GraphQLTypes["EventItem"]>,
	paginateEventItem: GraphQLTypes["EventItemConnection"],
	validateCreateEventItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEventItem: GraphQLTypes["_ValidationResult"],
	getEventList?: GraphQLTypes["EventList"],
	listEventList: Array<GraphQLTypes["EventList"]>,
	paginateEventList: GraphQLTypes["EventListConnection"],
	validateCreateEventList: GraphQLTypes["_ValidationResult"],
	validateUpdateEventList: GraphQLTypes["_ValidationResult"],
	getBoxItem?: GraphQLTypes["BoxItem"],
	listBoxItem: Array<GraphQLTypes["BoxItem"]>,
	paginateBoxItem: GraphQLTypes["BoxItemConnection"],
	validateCreateBoxItem: GraphQLTypes["_ValidationResult"],
	validateUpdateBoxItem: GraphQLTypes["_ValidationResult"],
	getBoxList?: GraphQLTypes["BoxList"],
	listBoxList: Array<GraphQLTypes["BoxList"]>,
	paginateBoxList: GraphQLTypes["BoxListConnection"],
	validateCreateBoxList: GraphQLTypes["_ValidationResult"],
	validateUpdateBoxList: GraphQLTypes["_ValidationResult"],
	getNewsletterForm?: GraphQLTypes["NewsletterForm"],
	listNewsletterForm: Array<GraphQLTypes["NewsletterForm"]>,
	paginateNewsletterForm: GraphQLTypes["NewsletterFormConnection"],
	validateCreateNewsletterForm: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterForm: GraphQLTypes["_ValidationResult"],
	getNewsletterTypeItem?: GraphQLTypes["NewsletterTypeItem"],
	listNewsletterTypeItem: Array<GraphQLTypes["NewsletterTypeItem"]>,
	paginateNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemConnection"],
	validateCreateNewsletterTypeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterTypeItem: GraphQLTypes["_ValidationResult"],
	getNewsletterFormLocale?: GraphQLTypes["NewsletterFormLocale"],
	listNewsletterFormLocale: Array<GraphQLTypes["NewsletterFormLocale"]>,
	paginateNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleConnection"],
	validateCreateNewsletterFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterFormLocale: GraphQLTypes["_ValidationResult"],
	getNewsletterSubscription?: GraphQLTypes["NewsletterSubscription"],
	listNewsletterSubscription: Array<GraphQLTypes["NewsletterSubscription"]>,
	paginateNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionConnection"],
	validateCreateNewsletterSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateNewsletterSubscription: GraphQLTypes["_ValidationResult"],
	getChart?: GraphQLTypes["Chart"],
	listChart: Array<GraphQLTypes["Chart"]>,
	paginateChart: GraphQLTypes["ChartConnection"],
	validateCreateChart: GraphQLTypes["_ValidationResult"],
	validateUpdateChart: GraphQLTypes["_ValidationResult"],
	getChartData?: GraphQLTypes["ChartData"],
	listChartData: Array<GraphQLTypes["ChartData"]>,
	paginateChartData: GraphQLTypes["ChartDataConnection"],
	validateCreateChartData: GraphQLTypes["_ValidationResult"],
	validateUpdateChartData: GraphQLTypes["_ValidationResult"],
	getEmployee?: GraphQLTypes["Employee"],
	listEmployee: Array<GraphQLTypes["Employee"]>,
	paginateEmployee: GraphQLTypes["EmployeeConnection"],
	validateCreateEmployee: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployee: GraphQLTypes["_ValidationResult"],
	getEmployeeItem?: GraphQLTypes["EmployeeItem"],
	listEmployeeItem: Array<GraphQLTypes["EmployeeItem"]>,
	paginateEmployeeItem: GraphQLTypes["EmployeeItemConnection"],
	validateCreateEmployeeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeItem: GraphQLTypes["_ValidationResult"],
	getEmployeeList?: GraphQLTypes["EmployeeList"],
	listEmployeeList: Array<GraphQLTypes["EmployeeList"]>,
	paginateEmployeeList: GraphQLTypes["EmployeeListConnection"],
	validateCreateEmployeeList: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeList: GraphQLTypes["_ValidationResult"],
	getEmployeeLocale?: GraphQLTypes["EmployeeLocale"],
	listEmployeeLocale: Array<GraphQLTypes["EmployeeLocale"]>,
	paginateEmployeeLocale: GraphQLTypes["EmployeeLocaleConnection"],
	validateCreateEmployeeLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateEmployeeLocale: GraphQLTypes["_ValidationResult"],
	getPhotographer?: GraphQLTypes["Photographer"],
	listPhotographer: Array<GraphQLTypes["Photographer"]>,
	paginatePhotographer: GraphQLTypes["PhotographerConnection"],
	validateCreatePhotographer: GraphQLTypes["_ValidationResult"],
	validateUpdatePhotographer: GraphQLTypes["_ValidationResult"],
	getDefinitionItem?: GraphQLTypes["DefinitionItem"],
	listDefinitionItem: Array<GraphQLTypes["DefinitionItem"]>,
	paginateDefinitionItem: GraphQLTypes["DefinitionItemConnection"],
	validateCreateDefinitionItem: GraphQLTypes["_ValidationResult"],
	validateUpdateDefinitionItem: GraphQLTypes["_ValidationResult"],
	getDefinitionList?: GraphQLTypes["DefinitionList"],
	listDefinitionList: Array<GraphQLTypes["DefinitionList"]>,
	paginateDefinitionList: GraphQLTypes["DefinitionListConnection"],
	validateCreateDefinitionList: GraphQLTypes["_ValidationResult"],
	validateUpdateDefinitionList: GraphQLTypes["_ValidationResult"],
	getLogoItem?: GraphQLTypes["LogoItem"],
	listLogoItem: Array<GraphQLTypes["LogoItem"]>,
	paginateLogoItem: GraphQLTypes["LogoItemConnection"],
	validateCreateLogoItem: GraphQLTypes["_ValidationResult"],
	validateUpdateLogoItem: GraphQLTypes["_ValidationResult"],
	getLogoList?: GraphQLTypes["LogoList"],
	listLogoList: Array<GraphQLTypes["LogoList"]>,
	paginateLogoList: GraphQLTypes["LogoListConnection"],
	validateCreateLogoList: GraphQLTypes["_ValidationResult"],
	validateUpdateLogoList: GraphQLTypes["_ValidationResult"],
	getStrategySchema?: GraphQLTypes["StrategySchema"],
	listStrategySchema: Array<GraphQLTypes["StrategySchema"]>,
	paginateStrategySchema: GraphQLTypes["StrategySchemaConnection"],
	validateCreateStrategySchema: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchema: GraphQLTypes["_ValidationResult"],
	getStrategySchemaGroup?: GraphQLTypes["StrategySchemaGroup"],
	listStrategySchemaGroup: Array<GraphQLTypes["StrategySchemaGroup"]>,
	paginateStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupConnection"],
	validateCreateStrategySchemaGroup: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroup: GraphQLTypes["_ValidationResult"],
	getStrategySchemaGroupItem?: GraphQLTypes["StrategySchemaGroupItem"],
	listStrategySchemaGroupItem: Array<GraphQLTypes["StrategySchemaGroupItem"]>,
	paginateStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemConnection"],
	validateCreateStrategySchemaGroupItem: GraphQLTypes["_ValidationResult"],
	validateUpdateStrategySchemaGroupItem: GraphQLTypes["_ValidationResult"],
	getRedirect?: GraphQLTypes["Redirect"],
	listRedirect: Array<GraphQLTypes["Redirect"]>,
	paginateRedirect: GraphQLTypes["RedirectConnection"],
	validateCreateRedirect: GraphQLTypes["_ValidationResult"],
	validateUpdateRedirect: GraphQLTypes["_ValidationResult"],
	getGallery?: GraphQLTypes["Gallery"],
	listGallery: Array<GraphQLTypes["Gallery"]>,
	paginateGallery: GraphQLTypes["GalleryConnection"],
	validateCreateGallery: GraphQLTypes["_ValidationResult"],
	validateUpdateGallery: GraphQLTypes["_ValidationResult"],
	getGalleryItem?: GraphQLTypes["GalleryItem"],
	listGalleryItem: Array<GraphQLTypes["GalleryItem"]>,
	paginateGalleryItem: GraphQLTypes["GalleryItemConnection"],
	validateCreateGalleryItem: GraphQLTypes["_ValidationResult"],
	validateUpdateGalleryItem: GraphQLTypes["_ValidationResult"],
	getContactForm?: GraphQLTypes["ContactForm"],
	listContactForm: Array<GraphQLTypes["ContactForm"]>,
	paginateContactForm: GraphQLTypes["ContactFormConnection"],
	validateCreateContactForm: GraphQLTypes["_ValidationResult"],
	validateUpdateContactForm: GraphQLTypes["_ValidationResult"],
	getContactFormLocale?: GraphQLTypes["ContactFormLocale"],
	listContactFormLocale: Array<GraphQLTypes["ContactFormLocale"]>,
	paginateContactFormLocale: GraphQLTypes["ContactFormLocaleConnection"],
	validateCreateContactFormLocale: GraphQLTypes["_ValidationResult"],
	validateUpdateContactFormLocale: GraphQLTypes["_ValidationResult"],
	getContactSubscription?: GraphQLTypes["ContactSubscription"],
	listContactSubscription: Array<GraphQLTypes["ContactSubscription"]>,
	paginateContactSubscription: GraphQLTypes["ContactSubscriptionConnection"],
	validateCreateContactSubscription: GraphQLTypes["_ValidationResult"],
	validateUpdateContactSubscription: GraphQLTypes["_ValidationResult"],
	getContactTypeItem?: GraphQLTypes["ContactTypeItem"],
	listContactTypeItem: Array<GraphQLTypes["ContactTypeItem"]>,
	paginateContactTypeItem: GraphQLTypes["ContactTypeItemConnection"],
	validateCreateContactTypeItem: GraphQLTypes["_ValidationResult"],
	validateUpdateContactTypeItem: GraphQLTypes["_ValidationResult"],
	getFile?: GraphQLTypes["File"],
	listFile: Array<GraphQLTypes["File"]>,
	paginateFile: GraphQLTypes["FileConnection"],
	validateCreateFile: GraphQLTypes["_ValidationResult"],
	validateUpdateFile: GraphQLTypes["_ValidationResult"]
};
	["Info"]: {
	__typename: "Info",
	description?: string
};
	["Mutation"]: {
	__typename: "Mutation",
	createContactPage: GraphQLTypes["ContactPageCreateResult"],
	deleteContactPage: GraphQLTypes["ContactPageDeleteResult"],
	updateContactPage: GraphQLTypes["ContactPageUpdateResult"],
	upsertContactPage: GraphQLTypes["ContactPageUpsertResult"],
	createContactPageLocale: GraphQLTypes["ContactPageLocaleCreateResult"],
	deleteContactPageLocale: GraphQLTypes["ContactPageLocaleDeleteResult"],
	updateContactPageLocale: GraphQLTypes["ContactPageLocaleUpdateResult"],
	upsertContactPageLocale: GraphQLTypes["ContactPageLocaleUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createHomePageLocale: GraphQLTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: GraphQLTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: GraphQLTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: GraphQLTypes["HomePageLocaleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createSeoDefault: GraphQLTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: GraphQLTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: GraphQLTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: GraphQLTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createBranches: GraphQLTypes["BranchesCreateResult"],
	deleteBranches: GraphQLTypes["BranchesDeleteResult"],
	updateBranches: GraphQLTypes["BranchesUpdateResult"],
	upsertBranches: GraphQLTypes["BranchesUpsertResult"],
	createGraphicDesigner: GraphQLTypes["GraphicDesignerCreateResult"],
	deleteGraphicDesigner: GraphQLTypes["GraphicDesignerDeleteResult"],
	updateGraphicDesigner: GraphQLTypes["GraphicDesignerUpdateResult"],
	upsertGraphicDesigner: GraphQLTypes["GraphicDesignerUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createEventLocale: GraphQLTypes["EventLocaleCreateResult"],
	deleteEventLocale: GraphQLTypes["EventLocaleDeleteResult"],
	updateEventLocale: GraphQLTypes["EventLocaleUpdateResult"],
	upsertEventLocale: GraphQLTypes["EventLocaleUpsertResult"],
	createArtwork: GraphQLTypes["ArtworkCreateResult"],
	deleteArtwork: GraphQLTypes["ArtworkDeleteResult"],
	updateArtwork: GraphQLTypes["ArtworkUpdateResult"],
	upsertArtwork: GraphQLTypes["ArtworkUpsertResult"],
	createArtworkLocale: GraphQLTypes["ArtworkLocaleCreateResult"],
	deleteArtworkLocale: GraphQLTypes["ArtworkLocaleDeleteResult"],
	updateArtworkLocale: GraphQLTypes["ArtworkLocaleUpdateResult"],
	upsertArtworkLocale: GraphQLTypes["ArtworkLocaleUpsertResult"],
	createDropDownItem: GraphQLTypes["DropDownItemCreateResult"],
	deleteDropDownItem: GraphQLTypes["DropDownItemDeleteResult"],
	updateDropDownItem: GraphQLTypes["DropDownItemUpdateResult"],
	upsertDropDownItem: GraphQLTypes["DropDownItemUpsertResult"],
	createDropDownList: GraphQLTypes["DropDownListCreateResult"],
	deleteDropDownList: GraphQLTypes["DropDownListDeleteResult"],
	updateDropDownList: GraphQLTypes["DropDownListUpdateResult"],
	upsertDropDownList: GraphQLTypes["DropDownListUpsertResult"],
	createArtworkItem: GraphQLTypes["ArtworkItemCreateResult"],
	deleteArtworkItem: GraphQLTypes["ArtworkItemDeleteResult"],
	updateArtworkItem: GraphQLTypes["ArtworkItemUpdateResult"],
	upsertArtworkItem: GraphQLTypes["ArtworkItemUpsertResult"],
	createArtworkList: GraphQLTypes["ArtworkListCreateResult"],
	deleteArtworkList: GraphQLTypes["ArtworkListDeleteResult"],
	updateArtworkList: GraphQLTypes["ArtworkListUpdateResult"],
	upsertArtworkList: GraphQLTypes["ArtworkListUpsertResult"],
	createArtworkSelection: GraphQLTypes["ArtworkSelectionCreateResult"],
	deleteArtworkSelection: GraphQLTypes["ArtworkSelectionDeleteResult"],
	updateArtworkSelection: GraphQLTypes["ArtworkSelectionUpdateResult"],
	upsertArtworkSelection: GraphQLTypes["ArtworkSelectionUpsertResult"],
	createArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemCreateResult"],
	deleteArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemDeleteResult"],
	updateArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemUpdateResult"],
	upsertArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemUpsertResult"],
	createArtworkSelectionList: GraphQLTypes["ArtworkSelectionListCreateResult"],
	deleteArtworkSelectionList: GraphQLTypes["ArtworkSelectionListDeleteResult"],
	updateArtworkSelectionList: GraphQLTypes["ArtworkSelectionListUpdateResult"],
	upsertArtworkSelectionList: GraphQLTypes["ArtworkSelectionListUpsertResult"],
	createArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleCreateResult"],
	deleteArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleDeleteResult"],
	updateArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleUpdateResult"],
	upsertArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleUpsertResult"],
	createEventItem: GraphQLTypes["EventItemCreateResult"],
	deleteEventItem: GraphQLTypes["EventItemDeleteResult"],
	updateEventItem: GraphQLTypes["EventItemUpdateResult"],
	upsertEventItem: GraphQLTypes["EventItemUpsertResult"],
	createEventList: GraphQLTypes["EventListCreateResult"],
	deleteEventList: GraphQLTypes["EventListDeleteResult"],
	updateEventList: GraphQLTypes["EventListUpdateResult"],
	upsertEventList: GraphQLTypes["EventListUpsertResult"],
	createBoxItem: GraphQLTypes["BoxItemCreateResult"],
	deleteBoxItem: GraphQLTypes["BoxItemDeleteResult"],
	updateBoxItem: GraphQLTypes["BoxItemUpdateResult"],
	upsertBoxItem: GraphQLTypes["BoxItemUpsertResult"],
	createBoxList: GraphQLTypes["BoxListCreateResult"],
	deleteBoxList: GraphQLTypes["BoxListDeleteResult"],
	updateBoxList: GraphQLTypes["BoxListUpdateResult"],
	upsertBoxList: GraphQLTypes["BoxListUpsertResult"],
	createNewsletterForm: GraphQLTypes["NewsletterFormCreateResult"],
	deleteNewsletterForm: GraphQLTypes["NewsletterFormDeleteResult"],
	updateNewsletterForm: GraphQLTypes["NewsletterFormUpdateResult"],
	upsertNewsletterForm: GraphQLTypes["NewsletterFormUpsertResult"],
	createNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemCreateResult"],
	deleteNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemDeleteResult"],
	updateNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemUpdateResult"],
	upsertNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemUpsertResult"],
	createNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleCreateResult"],
	deleteNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleDeleteResult"],
	updateNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleUpdateResult"],
	upsertNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleUpsertResult"],
	createNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionCreateResult"],
	deleteNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionDeleteResult"],
	updateNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionUpdateResult"],
	upsertNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionUpsertResult"],
	createChart: GraphQLTypes["ChartCreateResult"],
	deleteChart: GraphQLTypes["ChartDeleteResult"],
	updateChart: GraphQLTypes["ChartUpdateResult"],
	upsertChart: GraphQLTypes["ChartUpsertResult"],
	createChartData: GraphQLTypes["ChartDataCreateResult"],
	deleteChartData: GraphQLTypes["ChartDataDeleteResult"],
	updateChartData: GraphQLTypes["ChartDataUpdateResult"],
	upsertChartData: GraphQLTypes["ChartDataUpsertResult"],
	createEmployee: GraphQLTypes["EmployeeCreateResult"],
	deleteEmployee: GraphQLTypes["EmployeeDeleteResult"],
	updateEmployee: GraphQLTypes["EmployeeUpdateResult"],
	upsertEmployee: GraphQLTypes["EmployeeUpsertResult"],
	createEmployeeItem: GraphQLTypes["EmployeeItemCreateResult"],
	deleteEmployeeItem: GraphQLTypes["EmployeeItemDeleteResult"],
	updateEmployeeItem: GraphQLTypes["EmployeeItemUpdateResult"],
	upsertEmployeeItem: GraphQLTypes["EmployeeItemUpsertResult"],
	createEmployeeList: GraphQLTypes["EmployeeListCreateResult"],
	deleteEmployeeList: GraphQLTypes["EmployeeListDeleteResult"],
	updateEmployeeList: GraphQLTypes["EmployeeListUpdateResult"],
	upsertEmployeeList: GraphQLTypes["EmployeeListUpsertResult"],
	createEmployeeLocale: GraphQLTypes["EmployeeLocaleCreateResult"],
	deleteEmployeeLocale: GraphQLTypes["EmployeeLocaleDeleteResult"],
	updateEmployeeLocale: GraphQLTypes["EmployeeLocaleUpdateResult"],
	upsertEmployeeLocale: GraphQLTypes["EmployeeLocaleUpsertResult"],
	createPhotographer: GraphQLTypes["PhotographerCreateResult"],
	deletePhotographer: GraphQLTypes["PhotographerDeleteResult"],
	updatePhotographer: GraphQLTypes["PhotographerUpdateResult"],
	upsertPhotographer: GraphQLTypes["PhotographerUpsertResult"],
	createDefinitionItem: GraphQLTypes["DefinitionItemCreateResult"],
	deleteDefinitionItem: GraphQLTypes["DefinitionItemDeleteResult"],
	updateDefinitionItem: GraphQLTypes["DefinitionItemUpdateResult"],
	upsertDefinitionItem: GraphQLTypes["DefinitionItemUpsertResult"],
	createDefinitionList: GraphQLTypes["DefinitionListCreateResult"],
	deleteDefinitionList: GraphQLTypes["DefinitionListDeleteResult"],
	updateDefinitionList: GraphQLTypes["DefinitionListUpdateResult"],
	upsertDefinitionList: GraphQLTypes["DefinitionListUpsertResult"],
	createLogoItem: GraphQLTypes["LogoItemCreateResult"],
	deleteLogoItem: GraphQLTypes["LogoItemDeleteResult"],
	updateLogoItem: GraphQLTypes["LogoItemUpdateResult"],
	upsertLogoItem: GraphQLTypes["LogoItemUpsertResult"],
	createLogoList: GraphQLTypes["LogoListCreateResult"],
	deleteLogoList: GraphQLTypes["LogoListDeleteResult"],
	updateLogoList: GraphQLTypes["LogoListUpdateResult"],
	upsertLogoList: GraphQLTypes["LogoListUpsertResult"],
	createStrategySchema: GraphQLTypes["StrategySchemaCreateResult"],
	deleteStrategySchema: GraphQLTypes["StrategySchemaDeleteResult"],
	updateStrategySchema: GraphQLTypes["StrategySchemaUpdateResult"],
	upsertStrategySchema: GraphQLTypes["StrategySchemaUpsertResult"],
	createStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupCreateResult"],
	deleteStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupDeleteResult"],
	updateStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupUpdateResult"],
	upsertStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupUpsertResult"],
	createStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemCreateResult"],
	deleteStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemDeleteResult"],
	updateStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemUpdateResult"],
	upsertStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createContactForm: GraphQLTypes["ContactFormCreateResult"],
	deleteContactForm: GraphQLTypes["ContactFormDeleteResult"],
	updateContactForm: GraphQLTypes["ContactFormUpdateResult"],
	upsertContactForm: GraphQLTypes["ContactFormUpsertResult"],
	createContactFormLocale: GraphQLTypes["ContactFormLocaleCreateResult"],
	deleteContactFormLocale: GraphQLTypes["ContactFormLocaleDeleteResult"],
	updateContactFormLocale: GraphQLTypes["ContactFormLocaleUpdateResult"],
	upsertContactFormLocale: GraphQLTypes["ContactFormLocaleUpsertResult"],
	createContactSubscription: GraphQLTypes["ContactSubscriptionCreateResult"],
	deleteContactSubscription: GraphQLTypes["ContactSubscriptionDeleteResult"],
	updateContactSubscription: GraphQLTypes["ContactSubscriptionUpdateResult"],
	upsertContactSubscription: GraphQLTypes["ContactSubscriptionUpsertResult"],
	createContactTypeItem: GraphQLTypes["ContactTypeItemCreateResult"],
	deleteContactTypeItem: GraphQLTypes["ContactTypeItemDeleteResult"],
	updateContactTypeItem: GraphQLTypes["ContactTypeItemUpdateResult"],
	upsertContactTypeItem: GraphQLTypes["ContactTypeItemUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	transaction: GraphQLTypes["MutationTransaction"],
	query: GraphQLTypes["Query"],
	generateUploadUrl: GraphQLTypes["S3SignedUpload"],
	generateReadUrl: GraphQLTypes["S3SignedRead"]
};
	["ContactPageCreateResult"]: {
	__typename: "ContactPageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationResult"]: {
	__typename:"ContactPageCreateResult" | "ContactPageDeleteResult" | "ContactPageUpdateResult" | "ContactPageUpsertResult" | "ContactPageLocaleCreateResult" | "ContactPageLocaleDeleteResult" | "ContactPageLocaleUpdateResult" | "ContactPageLocaleUpsertResult" | "ContentCreateResult" | "ContentDeleteResult" | "ContentUpdateResult" | "ContentUpsertResult" | "ContentBlockCreateResult" | "ContentBlockDeleteResult" | "ContentBlockUpdateResult" | "ContentBlockUpsertResult" | "ContentReferenceCreateResult" | "ContentReferenceDeleteResult" | "ContentReferenceUpdateResult" | "ContentReferenceUpsertResult" | "FooterCreateResult" | "FooterDeleteResult" | "FooterUpdateResult" | "FooterUpsertResult" | "FooterLocaleCreateResult" | "FooterLocaleDeleteResult" | "FooterLocaleUpdateResult" | "FooterLocaleUpsertResult" | "HeaderCreateResult" | "HeaderDeleteResult" | "HeaderUpdateResult" | "HeaderUpsertResult" | "HeaderLinkCreateResult" | "HeaderLinkDeleteResult" | "HeaderLinkUpdateResult" | "HeaderLinkUpsertResult" | "HeaderLocaleCreateResult" | "HeaderLocaleDeleteResult" | "HeaderLocaleUpdateResult" | "HeaderLocaleUpsertResult" | "HomePageCreateResult" | "HomePageDeleteResult" | "HomePageUpdateResult" | "HomePageUpsertResult" | "HomePageLocaleCreateResult" | "HomePageLocaleDeleteResult" | "HomePageLocaleUpdateResult" | "HomePageLocaleUpsertResult" | "LinkCreateResult" | "LinkDeleteResult" | "LinkUpdateResult" | "LinkUpsertResult" | "LinkableCreateResult" | "LinkableDeleteResult" | "LinkableUpdateResult" | "LinkableUpsertResult" | "LocaleCreateResult" | "LocaleDeleteResult" | "LocaleUpdateResult" | "LocaleUpsertResult" | "MediumCreateResult" | "MediumDeleteResult" | "MediumUpdateResult" | "MediumUpsertResult" | "MediumItemCreateResult" | "MediumItemDeleteResult" | "MediumItemUpdateResult" | "MediumItemUpsertResult" | "MediumListCreateResult" | "MediumListDeleteResult" | "MediumListUpdateResult" | "MediumListUpsertResult" | "PageCreateResult" | "PageDeleteResult" | "PageUpdateResult" | "PageUpsertResult" | "PageLocaleCreateResult" | "PageLocaleDeleteResult" | "PageLocaleUpdateResult" | "PageLocaleUpsertResult" | "SeoDefaultCreateResult" | "SeoDefaultDeleteResult" | "SeoDefaultUpdateResult" | "SeoDefaultUpsertResult" | "SeoDefaultLocaleCreateResult" | "SeoDefaultLocaleDeleteResult" | "SeoDefaultLocaleUpdateResult" | "SeoDefaultLocaleUpsertResult" | "VideoCreateResult" | "VideoDeleteResult" | "VideoUpdateResult" | "VideoUpsertResult" | "ImageCreateResult" | "ImageDeleteResult" | "ImageUpdateResult" | "ImageUpsertResult" | "SeoCreateResult" | "SeoDeleteResult" | "SeoUpdateResult" | "SeoUpsertResult" | "TranslationDomainCreateResult" | "TranslationDomainDeleteResult" | "TranslationDomainUpdateResult" | "TranslationDomainUpsertResult" | "TranslationCatalogueCreateResult" | "TranslationCatalogueDeleteResult" | "TranslationCatalogueUpdateResult" | "TranslationCatalogueUpsertResult" | "TranslationCataloguesIdentifierCreateResult" | "TranslationCataloguesIdentifierDeleteResult" | "TranslationCataloguesIdentifierUpdateResult" | "TranslationCataloguesIdentifierUpsertResult" | "TranslationKeyCreateResult" | "TranslationKeyDeleteResult" | "TranslationKeyUpdateResult" | "TranslationKeyUpsertResult" | "TranslationValueCreateResult" | "TranslationValueDeleteResult" | "TranslationValueUpdateResult" | "TranslationValueUpsertResult" | "BranchesCreateResult" | "BranchesDeleteResult" | "BranchesUpdateResult" | "BranchesUpsertResult" | "GraphicDesignerCreateResult" | "GraphicDesignerDeleteResult" | "GraphicDesignerUpdateResult" | "GraphicDesignerUpsertResult" | "EventCreateResult" | "EventDeleteResult" | "EventUpdateResult" | "EventUpsertResult" | "EventLocaleCreateResult" | "EventLocaleDeleteResult" | "EventLocaleUpdateResult" | "EventLocaleUpsertResult" | "ArtworkCreateResult" | "ArtworkDeleteResult" | "ArtworkUpdateResult" | "ArtworkUpsertResult" | "ArtworkLocaleCreateResult" | "ArtworkLocaleDeleteResult" | "ArtworkLocaleUpdateResult" | "ArtworkLocaleUpsertResult" | "DropDownItemCreateResult" | "DropDownItemDeleteResult" | "DropDownItemUpdateResult" | "DropDownItemUpsertResult" | "DropDownListCreateResult" | "DropDownListDeleteResult" | "DropDownListUpdateResult" | "DropDownListUpsertResult" | "ArtworkItemCreateResult" | "ArtworkItemDeleteResult" | "ArtworkItemUpdateResult" | "ArtworkItemUpsertResult" | "ArtworkListCreateResult" | "ArtworkListDeleteResult" | "ArtworkListUpdateResult" | "ArtworkListUpsertResult" | "ArtworkSelectionCreateResult" | "ArtworkSelectionDeleteResult" | "ArtworkSelectionUpdateResult" | "ArtworkSelectionUpsertResult" | "ArtworkSelectionItemCreateResult" | "ArtworkSelectionItemDeleteResult" | "ArtworkSelectionItemUpdateResult" | "ArtworkSelectionItemUpsertResult" | "ArtworkSelectionListCreateResult" | "ArtworkSelectionListDeleteResult" | "ArtworkSelectionListUpdateResult" | "ArtworkSelectionListUpsertResult" | "ArtworkSelectionLocaleCreateResult" | "ArtworkSelectionLocaleDeleteResult" | "ArtworkSelectionLocaleUpdateResult" | "ArtworkSelectionLocaleUpsertResult" | "EventItemCreateResult" | "EventItemDeleteResult" | "EventItemUpdateResult" | "EventItemUpsertResult" | "EventListCreateResult" | "EventListDeleteResult" | "EventListUpdateResult" | "EventListUpsertResult" | "BoxItemCreateResult" | "BoxItemDeleteResult" | "BoxItemUpdateResult" | "BoxItemUpsertResult" | "BoxListCreateResult" | "BoxListDeleteResult" | "BoxListUpdateResult" | "BoxListUpsertResult" | "NewsletterFormCreateResult" | "NewsletterFormDeleteResult" | "NewsletterFormUpdateResult" | "NewsletterFormUpsertResult" | "NewsletterTypeItemCreateResult" | "NewsletterTypeItemDeleteResult" | "NewsletterTypeItemUpdateResult" | "NewsletterTypeItemUpsertResult" | "NewsletterFormLocaleCreateResult" | "NewsletterFormLocaleDeleteResult" | "NewsletterFormLocaleUpdateResult" | "NewsletterFormLocaleUpsertResult" | "NewsletterSubscriptionCreateResult" | "NewsletterSubscriptionDeleteResult" | "NewsletterSubscriptionUpdateResult" | "NewsletterSubscriptionUpsertResult" | "ChartCreateResult" | "ChartDeleteResult" | "ChartUpdateResult" | "ChartUpsertResult" | "ChartDataCreateResult" | "ChartDataDeleteResult" | "ChartDataUpdateResult" | "ChartDataUpsertResult" | "EmployeeCreateResult" | "EmployeeDeleteResult" | "EmployeeUpdateResult" | "EmployeeUpsertResult" | "EmployeeItemCreateResult" | "EmployeeItemDeleteResult" | "EmployeeItemUpdateResult" | "EmployeeItemUpsertResult" | "EmployeeListCreateResult" | "EmployeeListDeleteResult" | "EmployeeListUpdateResult" | "EmployeeListUpsertResult" | "EmployeeLocaleCreateResult" | "EmployeeLocaleDeleteResult" | "EmployeeLocaleUpdateResult" | "EmployeeLocaleUpsertResult" | "PhotographerCreateResult" | "PhotographerDeleteResult" | "PhotographerUpdateResult" | "PhotographerUpsertResult" | "DefinitionItemCreateResult" | "DefinitionItemDeleteResult" | "DefinitionItemUpdateResult" | "DefinitionItemUpsertResult" | "DefinitionListCreateResult" | "DefinitionListDeleteResult" | "DefinitionListUpdateResult" | "DefinitionListUpsertResult" | "LogoItemCreateResult" | "LogoItemDeleteResult" | "LogoItemUpdateResult" | "LogoItemUpsertResult" | "LogoListCreateResult" | "LogoListDeleteResult" | "LogoListUpdateResult" | "LogoListUpsertResult" | "StrategySchemaCreateResult" | "StrategySchemaDeleteResult" | "StrategySchemaUpdateResult" | "StrategySchemaUpsertResult" | "StrategySchemaGroupCreateResult" | "StrategySchemaGroupDeleteResult" | "StrategySchemaGroupUpdateResult" | "StrategySchemaGroupUpsertResult" | "StrategySchemaGroupItemCreateResult" | "StrategySchemaGroupItemDeleteResult" | "StrategySchemaGroupItemUpdateResult" | "StrategySchemaGroupItemUpsertResult" | "RedirectCreateResult" | "RedirectDeleteResult" | "RedirectUpdateResult" | "RedirectUpsertResult" | "GalleryCreateResult" | "GalleryDeleteResult" | "GalleryUpdateResult" | "GalleryUpsertResult" | "GalleryItemCreateResult" | "GalleryItemDeleteResult" | "GalleryItemUpdateResult" | "GalleryItemUpsertResult" | "ContactFormCreateResult" | "ContactFormDeleteResult" | "ContactFormUpdateResult" | "ContactFormUpsertResult" | "ContactFormLocaleCreateResult" | "ContactFormLocaleDeleteResult" | "ContactFormLocaleUpdateResult" | "ContactFormLocaleUpsertResult" | "ContactSubscriptionCreateResult" | "ContactSubscriptionDeleteResult" | "ContactSubscriptionUpdateResult" | "ContactSubscriptionUpsertResult" | "ContactTypeItemCreateResult" | "ContactTypeItemDeleteResult" | "ContactTypeItemUpdateResult" | "ContactTypeItemUpsertResult" | "FileCreateResult" | "FileDeleteResult" | "FileUpdateResult" | "FileUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>
	['...on ContactPageCreateResult']: '__union' & GraphQLTypes["ContactPageCreateResult"];
	['...on ContactPageDeleteResult']: '__union' & GraphQLTypes["ContactPageDeleteResult"];
	['...on ContactPageUpdateResult']: '__union' & GraphQLTypes["ContactPageUpdateResult"];
	['...on ContactPageUpsertResult']: '__union' & GraphQLTypes["ContactPageUpsertResult"];
	['...on ContactPageLocaleCreateResult']: '__union' & GraphQLTypes["ContactPageLocaleCreateResult"];
	['...on ContactPageLocaleDeleteResult']: '__union' & GraphQLTypes["ContactPageLocaleDeleteResult"];
	['...on ContactPageLocaleUpdateResult']: '__union' & GraphQLTypes["ContactPageLocaleUpdateResult"];
	['...on ContactPageLocaleUpsertResult']: '__union' & GraphQLTypes["ContactPageLocaleUpsertResult"];
	['...on ContentCreateResult']: '__union' & GraphQLTypes["ContentCreateResult"];
	['...on ContentDeleteResult']: '__union' & GraphQLTypes["ContentDeleteResult"];
	['...on ContentUpdateResult']: '__union' & GraphQLTypes["ContentUpdateResult"];
	['...on ContentUpsertResult']: '__union' & GraphQLTypes["ContentUpsertResult"];
	['...on ContentBlockCreateResult']: '__union' & GraphQLTypes["ContentBlockCreateResult"];
	['...on ContentBlockDeleteResult']: '__union' & GraphQLTypes["ContentBlockDeleteResult"];
	['...on ContentBlockUpdateResult']: '__union' & GraphQLTypes["ContentBlockUpdateResult"];
	['...on ContentBlockUpsertResult']: '__union' & GraphQLTypes["ContentBlockUpsertResult"];
	['...on ContentReferenceCreateResult']: '__union' & GraphQLTypes["ContentReferenceCreateResult"];
	['...on ContentReferenceDeleteResult']: '__union' & GraphQLTypes["ContentReferenceDeleteResult"];
	['...on ContentReferenceUpdateResult']: '__union' & GraphQLTypes["ContentReferenceUpdateResult"];
	['...on ContentReferenceUpsertResult']: '__union' & GraphQLTypes["ContentReferenceUpsertResult"];
	['...on FooterCreateResult']: '__union' & GraphQLTypes["FooterCreateResult"];
	['...on FooterDeleteResult']: '__union' & GraphQLTypes["FooterDeleteResult"];
	['...on FooterUpdateResult']: '__union' & GraphQLTypes["FooterUpdateResult"];
	['...on FooterUpsertResult']: '__union' & GraphQLTypes["FooterUpsertResult"];
	['...on FooterLocaleCreateResult']: '__union' & GraphQLTypes["FooterLocaleCreateResult"];
	['...on FooterLocaleDeleteResult']: '__union' & GraphQLTypes["FooterLocaleDeleteResult"];
	['...on FooterLocaleUpdateResult']: '__union' & GraphQLTypes["FooterLocaleUpdateResult"];
	['...on FooterLocaleUpsertResult']: '__union' & GraphQLTypes["FooterLocaleUpsertResult"];
	['...on HeaderCreateResult']: '__union' & GraphQLTypes["HeaderCreateResult"];
	['...on HeaderDeleteResult']: '__union' & GraphQLTypes["HeaderDeleteResult"];
	['...on HeaderUpdateResult']: '__union' & GraphQLTypes["HeaderUpdateResult"];
	['...on HeaderUpsertResult']: '__union' & GraphQLTypes["HeaderUpsertResult"];
	['...on HeaderLinkCreateResult']: '__union' & GraphQLTypes["HeaderLinkCreateResult"];
	['...on HeaderLinkDeleteResult']: '__union' & GraphQLTypes["HeaderLinkDeleteResult"];
	['...on HeaderLinkUpdateResult']: '__union' & GraphQLTypes["HeaderLinkUpdateResult"];
	['...on HeaderLinkUpsertResult']: '__union' & GraphQLTypes["HeaderLinkUpsertResult"];
	['...on HeaderLocaleCreateResult']: '__union' & GraphQLTypes["HeaderLocaleCreateResult"];
	['...on HeaderLocaleDeleteResult']: '__union' & GraphQLTypes["HeaderLocaleDeleteResult"];
	['...on HeaderLocaleUpdateResult']: '__union' & GraphQLTypes["HeaderLocaleUpdateResult"];
	['...on HeaderLocaleUpsertResult']: '__union' & GraphQLTypes["HeaderLocaleUpsertResult"];
	['...on HomePageCreateResult']: '__union' & GraphQLTypes["HomePageCreateResult"];
	['...on HomePageDeleteResult']: '__union' & GraphQLTypes["HomePageDeleteResult"];
	['...on HomePageUpdateResult']: '__union' & GraphQLTypes["HomePageUpdateResult"];
	['...on HomePageUpsertResult']: '__union' & GraphQLTypes["HomePageUpsertResult"];
	['...on HomePageLocaleCreateResult']: '__union' & GraphQLTypes["HomePageLocaleCreateResult"];
	['...on HomePageLocaleDeleteResult']: '__union' & GraphQLTypes["HomePageLocaleDeleteResult"];
	['...on HomePageLocaleUpdateResult']: '__union' & GraphQLTypes["HomePageLocaleUpdateResult"];
	['...on HomePageLocaleUpsertResult']: '__union' & GraphQLTypes["HomePageLocaleUpsertResult"];
	['...on LinkCreateResult']: '__union' & GraphQLTypes["LinkCreateResult"];
	['...on LinkDeleteResult']: '__union' & GraphQLTypes["LinkDeleteResult"];
	['...on LinkUpdateResult']: '__union' & GraphQLTypes["LinkUpdateResult"];
	['...on LinkUpsertResult']: '__union' & GraphQLTypes["LinkUpsertResult"];
	['...on LinkableCreateResult']: '__union' & GraphQLTypes["LinkableCreateResult"];
	['...on LinkableDeleteResult']: '__union' & GraphQLTypes["LinkableDeleteResult"];
	['...on LinkableUpdateResult']: '__union' & GraphQLTypes["LinkableUpdateResult"];
	['...on LinkableUpsertResult']: '__union' & GraphQLTypes["LinkableUpsertResult"];
	['...on LocaleCreateResult']: '__union' & GraphQLTypes["LocaleCreateResult"];
	['...on LocaleDeleteResult']: '__union' & GraphQLTypes["LocaleDeleteResult"];
	['...on LocaleUpdateResult']: '__union' & GraphQLTypes["LocaleUpdateResult"];
	['...on LocaleUpsertResult']: '__union' & GraphQLTypes["LocaleUpsertResult"];
	['...on MediumCreateResult']: '__union' & GraphQLTypes["MediumCreateResult"];
	['...on MediumDeleteResult']: '__union' & GraphQLTypes["MediumDeleteResult"];
	['...on MediumUpdateResult']: '__union' & GraphQLTypes["MediumUpdateResult"];
	['...on MediumUpsertResult']: '__union' & GraphQLTypes["MediumUpsertResult"];
	['...on MediumItemCreateResult']: '__union' & GraphQLTypes["MediumItemCreateResult"];
	['...on MediumItemDeleteResult']: '__union' & GraphQLTypes["MediumItemDeleteResult"];
	['...on MediumItemUpdateResult']: '__union' & GraphQLTypes["MediumItemUpdateResult"];
	['...on MediumItemUpsertResult']: '__union' & GraphQLTypes["MediumItemUpsertResult"];
	['...on MediumListCreateResult']: '__union' & GraphQLTypes["MediumListCreateResult"];
	['...on MediumListDeleteResult']: '__union' & GraphQLTypes["MediumListDeleteResult"];
	['...on MediumListUpdateResult']: '__union' & GraphQLTypes["MediumListUpdateResult"];
	['...on MediumListUpsertResult']: '__union' & GraphQLTypes["MediumListUpsertResult"];
	['...on PageCreateResult']: '__union' & GraphQLTypes["PageCreateResult"];
	['...on PageDeleteResult']: '__union' & GraphQLTypes["PageDeleteResult"];
	['...on PageUpdateResult']: '__union' & GraphQLTypes["PageUpdateResult"];
	['...on PageUpsertResult']: '__union' & GraphQLTypes["PageUpsertResult"];
	['...on PageLocaleCreateResult']: '__union' & GraphQLTypes["PageLocaleCreateResult"];
	['...on PageLocaleDeleteResult']: '__union' & GraphQLTypes["PageLocaleDeleteResult"];
	['...on PageLocaleUpdateResult']: '__union' & GraphQLTypes["PageLocaleUpdateResult"];
	['...on PageLocaleUpsertResult']: '__union' & GraphQLTypes["PageLocaleUpsertResult"];
	['...on SeoDefaultCreateResult']: '__union' & GraphQLTypes["SeoDefaultCreateResult"];
	['...on SeoDefaultDeleteResult']: '__union' & GraphQLTypes["SeoDefaultDeleteResult"];
	['...on SeoDefaultUpdateResult']: '__union' & GraphQLTypes["SeoDefaultUpdateResult"];
	['...on SeoDefaultUpsertResult']: '__union' & GraphQLTypes["SeoDefaultUpsertResult"];
	['...on SeoDefaultLocaleCreateResult']: '__union' & GraphQLTypes["SeoDefaultLocaleCreateResult"];
	['...on SeoDefaultLocaleDeleteResult']: '__union' & GraphQLTypes["SeoDefaultLocaleDeleteResult"];
	['...on SeoDefaultLocaleUpdateResult']: '__union' & GraphQLTypes["SeoDefaultLocaleUpdateResult"];
	['...on SeoDefaultLocaleUpsertResult']: '__union' & GraphQLTypes["SeoDefaultLocaleUpsertResult"];
	['...on VideoCreateResult']: '__union' & GraphQLTypes["VideoCreateResult"];
	['...on VideoDeleteResult']: '__union' & GraphQLTypes["VideoDeleteResult"];
	['...on VideoUpdateResult']: '__union' & GraphQLTypes["VideoUpdateResult"];
	['...on VideoUpsertResult']: '__union' & GraphQLTypes["VideoUpsertResult"];
	['...on ImageCreateResult']: '__union' & GraphQLTypes["ImageCreateResult"];
	['...on ImageDeleteResult']: '__union' & GraphQLTypes["ImageDeleteResult"];
	['...on ImageUpdateResult']: '__union' & GraphQLTypes["ImageUpdateResult"];
	['...on ImageUpsertResult']: '__union' & GraphQLTypes["ImageUpsertResult"];
	['...on SeoCreateResult']: '__union' & GraphQLTypes["SeoCreateResult"];
	['...on SeoDeleteResult']: '__union' & GraphQLTypes["SeoDeleteResult"];
	['...on SeoUpdateResult']: '__union' & GraphQLTypes["SeoUpdateResult"];
	['...on SeoUpsertResult']: '__union' & GraphQLTypes["SeoUpsertResult"];
	['...on TranslationDomainCreateResult']: '__union' & GraphQLTypes["TranslationDomainCreateResult"];
	['...on TranslationDomainDeleteResult']: '__union' & GraphQLTypes["TranslationDomainDeleteResult"];
	['...on TranslationDomainUpdateResult']: '__union' & GraphQLTypes["TranslationDomainUpdateResult"];
	['...on TranslationDomainUpsertResult']: '__union' & GraphQLTypes["TranslationDomainUpsertResult"];
	['...on TranslationCatalogueCreateResult']: '__union' & GraphQLTypes["TranslationCatalogueCreateResult"];
	['...on TranslationCatalogueDeleteResult']: '__union' & GraphQLTypes["TranslationCatalogueDeleteResult"];
	['...on TranslationCatalogueUpdateResult']: '__union' & GraphQLTypes["TranslationCatalogueUpdateResult"];
	['...on TranslationCatalogueUpsertResult']: '__union' & GraphQLTypes["TranslationCatalogueUpsertResult"];
	['...on TranslationCataloguesIdentifierCreateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierCreateResult"];
	['...on TranslationCataloguesIdentifierDeleteResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"];
	['...on TranslationCataloguesIdentifierUpdateResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"];
	['...on TranslationCataloguesIdentifierUpsertResult']: '__union' & GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"];
	['...on TranslationKeyCreateResult']: '__union' & GraphQLTypes["TranslationKeyCreateResult"];
	['...on TranslationKeyDeleteResult']: '__union' & GraphQLTypes["TranslationKeyDeleteResult"];
	['...on TranslationKeyUpdateResult']: '__union' & GraphQLTypes["TranslationKeyUpdateResult"];
	['...on TranslationKeyUpsertResult']: '__union' & GraphQLTypes["TranslationKeyUpsertResult"];
	['...on TranslationValueCreateResult']: '__union' & GraphQLTypes["TranslationValueCreateResult"];
	['...on TranslationValueDeleteResult']: '__union' & GraphQLTypes["TranslationValueDeleteResult"];
	['...on TranslationValueUpdateResult']: '__union' & GraphQLTypes["TranslationValueUpdateResult"];
	['...on TranslationValueUpsertResult']: '__union' & GraphQLTypes["TranslationValueUpsertResult"];
	['...on BranchesCreateResult']: '__union' & GraphQLTypes["BranchesCreateResult"];
	['...on BranchesDeleteResult']: '__union' & GraphQLTypes["BranchesDeleteResult"];
	['...on BranchesUpdateResult']: '__union' & GraphQLTypes["BranchesUpdateResult"];
	['...on BranchesUpsertResult']: '__union' & GraphQLTypes["BranchesUpsertResult"];
	['...on GraphicDesignerCreateResult']: '__union' & GraphQLTypes["GraphicDesignerCreateResult"];
	['...on GraphicDesignerDeleteResult']: '__union' & GraphQLTypes["GraphicDesignerDeleteResult"];
	['...on GraphicDesignerUpdateResult']: '__union' & GraphQLTypes["GraphicDesignerUpdateResult"];
	['...on GraphicDesignerUpsertResult']: '__union' & GraphQLTypes["GraphicDesignerUpsertResult"];
	['...on EventCreateResult']: '__union' & GraphQLTypes["EventCreateResult"];
	['...on EventDeleteResult']: '__union' & GraphQLTypes["EventDeleteResult"];
	['...on EventUpdateResult']: '__union' & GraphQLTypes["EventUpdateResult"];
	['...on EventUpsertResult']: '__union' & GraphQLTypes["EventUpsertResult"];
	['...on EventLocaleCreateResult']: '__union' & GraphQLTypes["EventLocaleCreateResult"];
	['...on EventLocaleDeleteResult']: '__union' & GraphQLTypes["EventLocaleDeleteResult"];
	['...on EventLocaleUpdateResult']: '__union' & GraphQLTypes["EventLocaleUpdateResult"];
	['...on EventLocaleUpsertResult']: '__union' & GraphQLTypes["EventLocaleUpsertResult"];
	['...on ArtworkCreateResult']: '__union' & GraphQLTypes["ArtworkCreateResult"];
	['...on ArtworkDeleteResult']: '__union' & GraphQLTypes["ArtworkDeleteResult"];
	['...on ArtworkUpdateResult']: '__union' & GraphQLTypes["ArtworkUpdateResult"];
	['...on ArtworkUpsertResult']: '__union' & GraphQLTypes["ArtworkUpsertResult"];
	['...on ArtworkLocaleCreateResult']: '__union' & GraphQLTypes["ArtworkLocaleCreateResult"];
	['...on ArtworkLocaleDeleteResult']: '__union' & GraphQLTypes["ArtworkLocaleDeleteResult"];
	['...on ArtworkLocaleUpdateResult']: '__union' & GraphQLTypes["ArtworkLocaleUpdateResult"];
	['...on ArtworkLocaleUpsertResult']: '__union' & GraphQLTypes["ArtworkLocaleUpsertResult"];
	['...on DropDownItemCreateResult']: '__union' & GraphQLTypes["DropDownItemCreateResult"];
	['...on DropDownItemDeleteResult']: '__union' & GraphQLTypes["DropDownItemDeleteResult"];
	['...on DropDownItemUpdateResult']: '__union' & GraphQLTypes["DropDownItemUpdateResult"];
	['...on DropDownItemUpsertResult']: '__union' & GraphQLTypes["DropDownItemUpsertResult"];
	['...on DropDownListCreateResult']: '__union' & GraphQLTypes["DropDownListCreateResult"];
	['...on DropDownListDeleteResult']: '__union' & GraphQLTypes["DropDownListDeleteResult"];
	['...on DropDownListUpdateResult']: '__union' & GraphQLTypes["DropDownListUpdateResult"];
	['...on DropDownListUpsertResult']: '__union' & GraphQLTypes["DropDownListUpsertResult"];
	['...on ArtworkItemCreateResult']: '__union' & GraphQLTypes["ArtworkItemCreateResult"];
	['...on ArtworkItemDeleteResult']: '__union' & GraphQLTypes["ArtworkItemDeleteResult"];
	['...on ArtworkItemUpdateResult']: '__union' & GraphQLTypes["ArtworkItemUpdateResult"];
	['...on ArtworkItemUpsertResult']: '__union' & GraphQLTypes["ArtworkItemUpsertResult"];
	['...on ArtworkListCreateResult']: '__union' & GraphQLTypes["ArtworkListCreateResult"];
	['...on ArtworkListDeleteResult']: '__union' & GraphQLTypes["ArtworkListDeleteResult"];
	['...on ArtworkListUpdateResult']: '__union' & GraphQLTypes["ArtworkListUpdateResult"];
	['...on ArtworkListUpsertResult']: '__union' & GraphQLTypes["ArtworkListUpsertResult"];
	['...on ArtworkSelectionCreateResult']: '__union' & GraphQLTypes["ArtworkSelectionCreateResult"];
	['...on ArtworkSelectionDeleteResult']: '__union' & GraphQLTypes["ArtworkSelectionDeleteResult"];
	['...on ArtworkSelectionUpdateResult']: '__union' & GraphQLTypes["ArtworkSelectionUpdateResult"];
	['...on ArtworkSelectionUpsertResult']: '__union' & GraphQLTypes["ArtworkSelectionUpsertResult"];
	['...on ArtworkSelectionItemCreateResult']: '__union' & GraphQLTypes["ArtworkSelectionItemCreateResult"];
	['...on ArtworkSelectionItemDeleteResult']: '__union' & GraphQLTypes["ArtworkSelectionItemDeleteResult"];
	['...on ArtworkSelectionItemUpdateResult']: '__union' & GraphQLTypes["ArtworkSelectionItemUpdateResult"];
	['...on ArtworkSelectionItemUpsertResult']: '__union' & GraphQLTypes["ArtworkSelectionItemUpsertResult"];
	['...on ArtworkSelectionListCreateResult']: '__union' & GraphQLTypes["ArtworkSelectionListCreateResult"];
	['...on ArtworkSelectionListDeleteResult']: '__union' & GraphQLTypes["ArtworkSelectionListDeleteResult"];
	['...on ArtworkSelectionListUpdateResult']: '__union' & GraphQLTypes["ArtworkSelectionListUpdateResult"];
	['...on ArtworkSelectionListUpsertResult']: '__union' & GraphQLTypes["ArtworkSelectionListUpsertResult"];
	['...on ArtworkSelectionLocaleCreateResult']: '__union' & GraphQLTypes["ArtworkSelectionLocaleCreateResult"];
	['...on ArtworkSelectionLocaleDeleteResult']: '__union' & GraphQLTypes["ArtworkSelectionLocaleDeleteResult"];
	['...on ArtworkSelectionLocaleUpdateResult']: '__union' & GraphQLTypes["ArtworkSelectionLocaleUpdateResult"];
	['...on ArtworkSelectionLocaleUpsertResult']: '__union' & GraphQLTypes["ArtworkSelectionLocaleUpsertResult"];
	['...on EventItemCreateResult']: '__union' & GraphQLTypes["EventItemCreateResult"];
	['...on EventItemDeleteResult']: '__union' & GraphQLTypes["EventItemDeleteResult"];
	['...on EventItemUpdateResult']: '__union' & GraphQLTypes["EventItemUpdateResult"];
	['...on EventItemUpsertResult']: '__union' & GraphQLTypes["EventItemUpsertResult"];
	['...on EventListCreateResult']: '__union' & GraphQLTypes["EventListCreateResult"];
	['...on EventListDeleteResult']: '__union' & GraphQLTypes["EventListDeleteResult"];
	['...on EventListUpdateResult']: '__union' & GraphQLTypes["EventListUpdateResult"];
	['...on EventListUpsertResult']: '__union' & GraphQLTypes["EventListUpsertResult"];
	['...on BoxItemCreateResult']: '__union' & GraphQLTypes["BoxItemCreateResult"];
	['...on BoxItemDeleteResult']: '__union' & GraphQLTypes["BoxItemDeleteResult"];
	['...on BoxItemUpdateResult']: '__union' & GraphQLTypes["BoxItemUpdateResult"];
	['...on BoxItemUpsertResult']: '__union' & GraphQLTypes["BoxItemUpsertResult"];
	['...on BoxListCreateResult']: '__union' & GraphQLTypes["BoxListCreateResult"];
	['...on BoxListDeleteResult']: '__union' & GraphQLTypes["BoxListDeleteResult"];
	['...on BoxListUpdateResult']: '__union' & GraphQLTypes["BoxListUpdateResult"];
	['...on BoxListUpsertResult']: '__union' & GraphQLTypes["BoxListUpsertResult"];
	['...on NewsletterFormCreateResult']: '__union' & GraphQLTypes["NewsletterFormCreateResult"];
	['...on NewsletterFormDeleteResult']: '__union' & GraphQLTypes["NewsletterFormDeleteResult"];
	['...on NewsletterFormUpdateResult']: '__union' & GraphQLTypes["NewsletterFormUpdateResult"];
	['...on NewsletterFormUpsertResult']: '__union' & GraphQLTypes["NewsletterFormUpsertResult"];
	['...on NewsletterTypeItemCreateResult']: '__union' & GraphQLTypes["NewsletterTypeItemCreateResult"];
	['...on NewsletterTypeItemDeleteResult']: '__union' & GraphQLTypes["NewsletterTypeItemDeleteResult"];
	['...on NewsletterTypeItemUpdateResult']: '__union' & GraphQLTypes["NewsletterTypeItemUpdateResult"];
	['...on NewsletterTypeItemUpsertResult']: '__union' & GraphQLTypes["NewsletterTypeItemUpsertResult"];
	['...on NewsletterFormLocaleCreateResult']: '__union' & GraphQLTypes["NewsletterFormLocaleCreateResult"];
	['...on NewsletterFormLocaleDeleteResult']: '__union' & GraphQLTypes["NewsletterFormLocaleDeleteResult"];
	['...on NewsletterFormLocaleUpdateResult']: '__union' & GraphQLTypes["NewsletterFormLocaleUpdateResult"];
	['...on NewsletterFormLocaleUpsertResult']: '__union' & GraphQLTypes["NewsletterFormLocaleUpsertResult"];
	['...on NewsletterSubscriptionCreateResult']: '__union' & GraphQLTypes["NewsletterSubscriptionCreateResult"];
	['...on NewsletterSubscriptionDeleteResult']: '__union' & GraphQLTypes["NewsletterSubscriptionDeleteResult"];
	['...on NewsletterSubscriptionUpdateResult']: '__union' & GraphQLTypes["NewsletterSubscriptionUpdateResult"];
	['...on NewsletterSubscriptionUpsertResult']: '__union' & GraphQLTypes["NewsletterSubscriptionUpsertResult"];
	['...on ChartCreateResult']: '__union' & GraphQLTypes["ChartCreateResult"];
	['...on ChartDeleteResult']: '__union' & GraphQLTypes["ChartDeleteResult"];
	['...on ChartUpdateResult']: '__union' & GraphQLTypes["ChartUpdateResult"];
	['...on ChartUpsertResult']: '__union' & GraphQLTypes["ChartUpsertResult"];
	['...on ChartDataCreateResult']: '__union' & GraphQLTypes["ChartDataCreateResult"];
	['...on ChartDataDeleteResult']: '__union' & GraphQLTypes["ChartDataDeleteResult"];
	['...on ChartDataUpdateResult']: '__union' & GraphQLTypes["ChartDataUpdateResult"];
	['...on ChartDataUpsertResult']: '__union' & GraphQLTypes["ChartDataUpsertResult"];
	['...on EmployeeCreateResult']: '__union' & GraphQLTypes["EmployeeCreateResult"];
	['...on EmployeeDeleteResult']: '__union' & GraphQLTypes["EmployeeDeleteResult"];
	['...on EmployeeUpdateResult']: '__union' & GraphQLTypes["EmployeeUpdateResult"];
	['...on EmployeeUpsertResult']: '__union' & GraphQLTypes["EmployeeUpsertResult"];
	['...on EmployeeItemCreateResult']: '__union' & GraphQLTypes["EmployeeItemCreateResult"];
	['...on EmployeeItemDeleteResult']: '__union' & GraphQLTypes["EmployeeItemDeleteResult"];
	['...on EmployeeItemUpdateResult']: '__union' & GraphQLTypes["EmployeeItemUpdateResult"];
	['...on EmployeeItemUpsertResult']: '__union' & GraphQLTypes["EmployeeItemUpsertResult"];
	['...on EmployeeListCreateResult']: '__union' & GraphQLTypes["EmployeeListCreateResult"];
	['...on EmployeeListDeleteResult']: '__union' & GraphQLTypes["EmployeeListDeleteResult"];
	['...on EmployeeListUpdateResult']: '__union' & GraphQLTypes["EmployeeListUpdateResult"];
	['...on EmployeeListUpsertResult']: '__union' & GraphQLTypes["EmployeeListUpsertResult"];
	['...on EmployeeLocaleCreateResult']: '__union' & GraphQLTypes["EmployeeLocaleCreateResult"];
	['...on EmployeeLocaleDeleteResult']: '__union' & GraphQLTypes["EmployeeLocaleDeleteResult"];
	['...on EmployeeLocaleUpdateResult']: '__union' & GraphQLTypes["EmployeeLocaleUpdateResult"];
	['...on EmployeeLocaleUpsertResult']: '__union' & GraphQLTypes["EmployeeLocaleUpsertResult"];
	['...on PhotographerCreateResult']: '__union' & GraphQLTypes["PhotographerCreateResult"];
	['...on PhotographerDeleteResult']: '__union' & GraphQLTypes["PhotographerDeleteResult"];
	['...on PhotographerUpdateResult']: '__union' & GraphQLTypes["PhotographerUpdateResult"];
	['...on PhotographerUpsertResult']: '__union' & GraphQLTypes["PhotographerUpsertResult"];
	['...on DefinitionItemCreateResult']: '__union' & GraphQLTypes["DefinitionItemCreateResult"];
	['...on DefinitionItemDeleteResult']: '__union' & GraphQLTypes["DefinitionItemDeleteResult"];
	['...on DefinitionItemUpdateResult']: '__union' & GraphQLTypes["DefinitionItemUpdateResult"];
	['...on DefinitionItemUpsertResult']: '__union' & GraphQLTypes["DefinitionItemUpsertResult"];
	['...on DefinitionListCreateResult']: '__union' & GraphQLTypes["DefinitionListCreateResult"];
	['...on DefinitionListDeleteResult']: '__union' & GraphQLTypes["DefinitionListDeleteResult"];
	['...on DefinitionListUpdateResult']: '__union' & GraphQLTypes["DefinitionListUpdateResult"];
	['...on DefinitionListUpsertResult']: '__union' & GraphQLTypes["DefinitionListUpsertResult"];
	['...on LogoItemCreateResult']: '__union' & GraphQLTypes["LogoItemCreateResult"];
	['...on LogoItemDeleteResult']: '__union' & GraphQLTypes["LogoItemDeleteResult"];
	['...on LogoItemUpdateResult']: '__union' & GraphQLTypes["LogoItemUpdateResult"];
	['...on LogoItemUpsertResult']: '__union' & GraphQLTypes["LogoItemUpsertResult"];
	['...on LogoListCreateResult']: '__union' & GraphQLTypes["LogoListCreateResult"];
	['...on LogoListDeleteResult']: '__union' & GraphQLTypes["LogoListDeleteResult"];
	['...on LogoListUpdateResult']: '__union' & GraphQLTypes["LogoListUpdateResult"];
	['...on LogoListUpsertResult']: '__union' & GraphQLTypes["LogoListUpsertResult"];
	['...on StrategySchemaCreateResult']: '__union' & GraphQLTypes["StrategySchemaCreateResult"];
	['...on StrategySchemaDeleteResult']: '__union' & GraphQLTypes["StrategySchemaDeleteResult"];
	['...on StrategySchemaUpdateResult']: '__union' & GraphQLTypes["StrategySchemaUpdateResult"];
	['...on StrategySchemaUpsertResult']: '__union' & GraphQLTypes["StrategySchemaUpsertResult"];
	['...on StrategySchemaGroupCreateResult']: '__union' & GraphQLTypes["StrategySchemaGroupCreateResult"];
	['...on StrategySchemaGroupDeleteResult']: '__union' & GraphQLTypes["StrategySchemaGroupDeleteResult"];
	['...on StrategySchemaGroupUpdateResult']: '__union' & GraphQLTypes["StrategySchemaGroupUpdateResult"];
	['...on StrategySchemaGroupUpsertResult']: '__union' & GraphQLTypes["StrategySchemaGroupUpsertResult"];
	['...on StrategySchemaGroupItemCreateResult']: '__union' & GraphQLTypes["StrategySchemaGroupItemCreateResult"];
	['...on StrategySchemaGroupItemDeleteResult']: '__union' & GraphQLTypes["StrategySchemaGroupItemDeleteResult"];
	['...on StrategySchemaGroupItemUpdateResult']: '__union' & GraphQLTypes["StrategySchemaGroupItemUpdateResult"];
	['...on StrategySchemaGroupItemUpsertResult']: '__union' & GraphQLTypes["StrategySchemaGroupItemUpsertResult"];
	['...on RedirectCreateResult']: '__union' & GraphQLTypes["RedirectCreateResult"];
	['...on RedirectDeleteResult']: '__union' & GraphQLTypes["RedirectDeleteResult"];
	['...on RedirectUpdateResult']: '__union' & GraphQLTypes["RedirectUpdateResult"];
	['...on RedirectUpsertResult']: '__union' & GraphQLTypes["RedirectUpsertResult"];
	['...on GalleryCreateResult']: '__union' & GraphQLTypes["GalleryCreateResult"];
	['...on GalleryDeleteResult']: '__union' & GraphQLTypes["GalleryDeleteResult"];
	['...on GalleryUpdateResult']: '__union' & GraphQLTypes["GalleryUpdateResult"];
	['...on GalleryUpsertResult']: '__union' & GraphQLTypes["GalleryUpsertResult"];
	['...on GalleryItemCreateResult']: '__union' & GraphQLTypes["GalleryItemCreateResult"];
	['...on GalleryItemDeleteResult']: '__union' & GraphQLTypes["GalleryItemDeleteResult"];
	['...on GalleryItemUpdateResult']: '__union' & GraphQLTypes["GalleryItemUpdateResult"];
	['...on GalleryItemUpsertResult']: '__union' & GraphQLTypes["GalleryItemUpsertResult"];
	['...on ContactFormCreateResult']: '__union' & GraphQLTypes["ContactFormCreateResult"];
	['...on ContactFormDeleteResult']: '__union' & GraphQLTypes["ContactFormDeleteResult"];
	['...on ContactFormUpdateResult']: '__union' & GraphQLTypes["ContactFormUpdateResult"];
	['...on ContactFormUpsertResult']: '__union' & GraphQLTypes["ContactFormUpsertResult"];
	['...on ContactFormLocaleCreateResult']: '__union' & GraphQLTypes["ContactFormLocaleCreateResult"];
	['...on ContactFormLocaleDeleteResult']: '__union' & GraphQLTypes["ContactFormLocaleDeleteResult"];
	['...on ContactFormLocaleUpdateResult']: '__union' & GraphQLTypes["ContactFormLocaleUpdateResult"];
	['...on ContactFormLocaleUpsertResult']: '__union' & GraphQLTypes["ContactFormLocaleUpsertResult"];
	['...on ContactSubscriptionCreateResult']: '__union' & GraphQLTypes["ContactSubscriptionCreateResult"];
	['...on ContactSubscriptionDeleteResult']: '__union' & GraphQLTypes["ContactSubscriptionDeleteResult"];
	['...on ContactSubscriptionUpdateResult']: '__union' & GraphQLTypes["ContactSubscriptionUpdateResult"];
	['...on ContactSubscriptionUpsertResult']: '__union' & GraphQLTypes["ContactSubscriptionUpsertResult"];
	['...on ContactTypeItemCreateResult']: '__union' & GraphQLTypes["ContactTypeItemCreateResult"];
	['...on ContactTypeItemDeleteResult']: '__union' & GraphQLTypes["ContactTypeItemDeleteResult"];
	['...on ContactTypeItemUpdateResult']: '__union' & GraphQLTypes["ContactTypeItemUpdateResult"];
	['...on ContactTypeItemUpsertResult']: '__union' & GraphQLTypes["ContactTypeItemUpsertResult"];
	['...on FileCreateResult']: '__union' & GraphQLTypes["FileCreateResult"];
	['...on FileDeleteResult']: '__union' & GraphQLTypes["FileDeleteResult"];
	['...on FileUpdateResult']: '__union' & GraphQLTypes["FileUpdateResult"];
	['...on FileUpsertResult']: '__union' & GraphQLTypes["FileUpsertResult"];
};
	["_MutationError"]: {
	__typename: "_MutationError",
	path: Array<GraphQLTypes["_PathFragment"]>,
	paths: Array<GraphQLTypes["_PathFragment"]>,
	type: GraphQLTypes["_MutationErrorType"],
	message?: string
};
	["_MutationErrorType"]: _MutationErrorType;
	["ContactPageDeleteResult"]: {
	__typename: "ContactPageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"]
};
	["ContactPageUpdateResult"]: {
	__typename: "ContactPageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageUpsertResult"]: {
	__typename: "ContactPageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageLocaleCreateResult"]: {
	__typename: "ContactPageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageLocaleDeleteResult"]: {
	__typename: "ContactPageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPageLocale"]
};
	["ContactPageLocaleUpdateResult"]: {
	__typename: "ContactPageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactPageLocaleUpsertResult"]: {
	__typename: "ContactPageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactPageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentCreateResult"]: {
	__typename: "ContentCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentDeleteResult"]: {
	__typename: "ContentDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"]
};
	["ContentUpdateResult"]: {
	__typename: "ContentUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentUpsertResult"]: {
	__typename: "ContentUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Content"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockCreateResult"]: {
	__typename: "ContentBlockCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockDeleteResult"]: {
	__typename: "ContentBlockDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"]
};
	["ContentBlockUpdateResult"]: {
	__typename: "ContentBlockUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentBlockUpsertResult"]: {
	__typename: "ContentBlockUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentBlock"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceCreateResult"]: {
	__typename: "ContentReferenceCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceDeleteResult"]: {
	__typename: "ContentReferenceDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"]
};
	["ContentReferenceUpdateResult"]: {
	__typename: "ContentReferenceUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContentReferenceUpsertResult"]: {
	__typename: "ContentReferenceUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContentReference"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterCreateResult"]: {
	__typename: "FooterCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterDeleteResult"]: {
	__typename: "FooterDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"]
};
	["FooterUpdateResult"]: {
	__typename: "FooterUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterUpsertResult"]: {
	__typename: "FooterUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Footer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleCreateResult"]: {
	__typename: "FooterLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleDeleteResult"]: {
	__typename: "FooterLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"]
};
	["FooterLocaleUpdateResult"]: {
	__typename: "FooterLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FooterLocaleUpsertResult"]: {
	__typename: "FooterLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["FooterLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderCreateResult"]: {
	__typename: "HeaderCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderDeleteResult"]: {
	__typename: "HeaderDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"]
};
	["HeaderUpdateResult"]: {
	__typename: "HeaderUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderUpsertResult"]: {
	__typename: "HeaderUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Header"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkCreateResult"]: {
	__typename: "HeaderLinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkDeleteResult"]: {
	__typename: "HeaderLinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"]
};
	["HeaderLinkUpdateResult"]: {
	__typename: "HeaderLinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLinkUpsertResult"]: {
	__typename: "HeaderLinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLink"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleCreateResult"]: {
	__typename: "HeaderLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleDeleteResult"]: {
	__typename: "HeaderLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"]
};
	["HeaderLocaleUpdateResult"]: {
	__typename: "HeaderLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HeaderLocaleUpsertResult"]: {
	__typename: "HeaderLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HeaderLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageCreateResult"]: {
	__typename: "HomePageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageDeleteResult"]: {
	__typename: "HomePageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"]
};
	["HomePageUpdateResult"]: {
	__typename: "HomePageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageUpsertResult"]: {
	__typename: "HomePageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePage"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleCreateResult"]: {
	__typename: "HomePageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleDeleteResult"]: {
	__typename: "HomePageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"]
};
	["HomePageLocaleUpdateResult"]: {
	__typename: "HomePageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["HomePageLocaleUpsertResult"]: {
	__typename: "HomePageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["HomePageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkCreateResult"]: {
	__typename: "LinkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkDeleteResult"]: {
	__typename: "LinkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"]
};
	["LinkUpdateResult"]: {
	__typename: "LinkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkUpsertResult"]: {
	__typename: "LinkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Link"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableCreateResult"]: {
	__typename: "LinkableCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableDeleteResult"]: {
	__typename: "LinkableDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"]
};
	["LinkableUpdateResult"]: {
	__typename: "LinkableUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LinkableUpsertResult"]: {
	__typename: "LinkableUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Linkable"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleCreateResult"]: {
	__typename: "LocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleDeleteResult"]: {
	__typename: "LocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"]
};
	["LocaleUpdateResult"]: {
	__typename: "LocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LocaleUpsertResult"]: {
	__typename: "LocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Locale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumCreateResult"]: {
	__typename: "MediumCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumDeleteResult"]: {
	__typename: "MediumDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"]
};
	["MediumUpdateResult"]: {
	__typename: "MediumUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumUpsertResult"]: {
	__typename: "MediumUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Medium"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemCreateResult"]: {
	__typename: "MediumItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemDeleteResult"]: {
	__typename: "MediumItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"]
};
	["MediumItemUpdateResult"]: {
	__typename: "MediumItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumItemUpsertResult"]: {
	__typename: "MediumItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListCreateResult"]: {
	__typename: "MediumListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListDeleteResult"]: {
	__typename: "MediumListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"]
};
	["MediumListUpdateResult"]: {
	__typename: "MediumListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MediumListUpsertResult"]: {
	__typename: "MediumListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["MediumList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageCreateResult"]: {
	__typename: "PageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageDeleteResult"]: {
	__typename: "PageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"]
};
	["PageUpdateResult"]: {
	__typename: "PageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageUpsertResult"]: {
	__typename: "PageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Page"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleCreateResult"]: {
	__typename: "PageLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleDeleteResult"]: {
	__typename: "PageLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"]
};
	["PageLocaleUpdateResult"]: {
	__typename: "PageLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PageLocaleUpsertResult"]: {
	__typename: "PageLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["PageLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultCreateResult"]: {
	__typename: "SeoDefaultCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultDeleteResult"]: {
	__typename: "SeoDefaultDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"]
};
	["SeoDefaultUpdateResult"]: {
	__typename: "SeoDefaultUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultUpsertResult"]: {
	__typename: "SeoDefaultUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefault"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleCreateResult"]: {
	__typename: "SeoDefaultLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleDeleteResult"]: {
	__typename: "SeoDefaultLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"]
};
	["SeoDefaultLocaleUpdateResult"]: {
	__typename: "SeoDefaultLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDefaultLocaleUpsertResult"]: {
	__typename: "SeoDefaultLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["SeoDefaultLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoCreateResult"]: {
	__typename: "VideoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoDeleteResult"]: {
	__typename: "VideoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"]
};
	["VideoUpdateResult"]: {
	__typename: "VideoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["VideoUpsertResult"]: {
	__typename: "VideoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Video"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageCreateResult"]: {
	__typename: "ImageCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageDeleteResult"]: {
	__typename: "ImageDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"]
};
	["ImageUpdateResult"]: {
	__typename: "ImageUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ImageUpsertResult"]: {
	__typename: "ImageUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Image"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoCreateResult"]: {
	__typename: "SeoCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoDeleteResult"]: {
	__typename: "SeoDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"]
};
	["SeoUpdateResult"]: {
	__typename: "SeoUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["SeoUpsertResult"]: {
	__typename: "SeoUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Seo"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainCreateResult"]: {
	__typename: "TranslationDomainCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainDeleteResult"]: {
	__typename: "TranslationDomainDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"]
};
	["TranslationDomainUpdateResult"]: {
	__typename: "TranslationDomainUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationDomainUpsertResult"]: {
	__typename: "TranslationDomainUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationDomain"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueCreateResult"]: {
	__typename: "TranslationCatalogueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueDeleteResult"]: {
	__typename: "TranslationCatalogueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"]
};
	["TranslationCatalogueUpdateResult"]: {
	__typename: "TranslationCatalogueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCatalogueUpsertResult"]: {
	__typename: "TranslationCatalogueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCatalogue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierCreateResult"]: {
	__typename: "TranslationCataloguesIdentifierCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierDeleteResult"]: {
	__typename: "TranslationCataloguesIdentifierDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"]
};
	["TranslationCataloguesIdentifierUpdateResult"]: {
	__typename: "TranslationCataloguesIdentifierUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationCataloguesIdentifierUpsertResult"]: {
	__typename: "TranslationCataloguesIdentifierUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationCataloguesIdentifier"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyCreateResult"]: {
	__typename: "TranslationKeyCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyDeleteResult"]: {
	__typename: "TranslationKeyDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"]
};
	["TranslationKeyUpdateResult"]: {
	__typename: "TranslationKeyUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationKeyUpsertResult"]: {
	__typename: "TranslationKeyUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationKey"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueCreateResult"]: {
	__typename: "TranslationValueCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueDeleteResult"]: {
	__typename: "TranslationValueDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"]
};
	["TranslationValueUpdateResult"]: {
	__typename: "TranslationValueUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["TranslationValueUpsertResult"]: {
	__typename: "TranslationValueUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["TranslationValue"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BranchesCreateResult"]: {
	__typename: "BranchesCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Branches"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BranchesDeleteResult"]: {
	__typename: "BranchesDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Branches"]
};
	["BranchesUpdateResult"]: {
	__typename: "BranchesUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Branches"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BranchesUpsertResult"]: {
	__typename: "BranchesUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Branches"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GraphicDesignerCreateResult"]: {
	__typename: "GraphicDesignerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GraphicDesigner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GraphicDesignerDeleteResult"]: {
	__typename: "GraphicDesignerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GraphicDesigner"]
};
	["GraphicDesignerUpdateResult"]: {
	__typename: "GraphicDesignerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GraphicDesigner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GraphicDesignerUpsertResult"]: {
	__typename: "GraphicDesignerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GraphicDesigner"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventCreateResult"]: {
	__typename: "EventCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventDeleteResult"]: {
	__typename: "EventDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"]
};
	["EventUpdateResult"]: {
	__typename: "EventUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventUpsertResult"]: {
	__typename: "EventUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Event"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleCreateResult"]: {
	__typename: "EventLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleDeleteResult"]: {
	__typename: "EventLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"]
};
	["EventLocaleUpdateResult"]: {
	__typename: "EventLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventLocaleUpsertResult"]: {
	__typename: "EventLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkCreateResult"]: {
	__typename: "ArtworkCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Artwork"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkDeleteResult"]: {
	__typename: "ArtworkDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Artwork"]
};
	["ArtworkUpdateResult"]: {
	__typename: "ArtworkUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Artwork"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkUpsertResult"]: {
	__typename: "ArtworkUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Artwork"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkLocaleCreateResult"]: {
	__typename: "ArtworkLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkLocaleDeleteResult"]: {
	__typename: "ArtworkLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkLocale"]
};
	["ArtworkLocaleUpdateResult"]: {
	__typename: "ArtworkLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkLocaleUpsertResult"]: {
	__typename: "ArtworkLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownItemCreateResult"]: {
	__typename: "DropDownItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownItemDeleteResult"]: {
	__typename: "DropDownItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownItem"]
};
	["DropDownItemUpdateResult"]: {
	__typename: "DropDownItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownItemUpsertResult"]: {
	__typename: "DropDownItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownListCreateResult"]: {
	__typename: "DropDownListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownListDeleteResult"]: {
	__typename: "DropDownListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownList"]
};
	["DropDownListUpdateResult"]: {
	__typename: "DropDownListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DropDownListUpsertResult"]: {
	__typename: "DropDownListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DropDownList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkItemCreateResult"]: {
	__typename: "ArtworkItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkItemDeleteResult"]: {
	__typename: "ArtworkItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkItem"]
};
	["ArtworkItemUpdateResult"]: {
	__typename: "ArtworkItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkItemUpsertResult"]: {
	__typename: "ArtworkItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkListCreateResult"]: {
	__typename: "ArtworkListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkListDeleteResult"]: {
	__typename: "ArtworkListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkList"]
};
	["ArtworkListUpdateResult"]: {
	__typename: "ArtworkListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkListUpsertResult"]: {
	__typename: "ArtworkListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionCreateResult"]: {
	__typename: "ArtworkSelectionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionDeleteResult"]: {
	__typename: "ArtworkSelectionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelection"]
};
	["ArtworkSelectionUpdateResult"]: {
	__typename: "ArtworkSelectionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionUpsertResult"]: {
	__typename: "ArtworkSelectionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelection"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionItemCreateResult"]: {
	__typename: "ArtworkSelectionItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionItemDeleteResult"]: {
	__typename: "ArtworkSelectionItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionItem"]
};
	["ArtworkSelectionItemUpdateResult"]: {
	__typename: "ArtworkSelectionItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionItemUpsertResult"]: {
	__typename: "ArtworkSelectionItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionListCreateResult"]: {
	__typename: "ArtworkSelectionListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionListDeleteResult"]: {
	__typename: "ArtworkSelectionListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionList"]
};
	["ArtworkSelectionListUpdateResult"]: {
	__typename: "ArtworkSelectionListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionListUpsertResult"]: {
	__typename: "ArtworkSelectionListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleCreateResult"]: {
	__typename: "ArtworkSelectionLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleDeleteResult"]: {
	__typename: "ArtworkSelectionLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionLocale"]
};
	["ArtworkSelectionLocaleUpdateResult"]: {
	__typename: "ArtworkSelectionLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ArtworkSelectionLocaleUpsertResult"]: {
	__typename: "ArtworkSelectionLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ArtworkSelectionLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventItemCreateResult"]: {
	__typename: "EventItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventItemDeleteResult"]: {
	__typename: "EventItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventItem"]
};
	["EventItemUpdateResult"]: {
	__typename: "EventItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventItemUpsertResult"]: {
	__typename: "EventItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventListCreateResult"]: {
	__typename: "EventListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventListDeleteResult"]: {
	__typename: "EventListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventList"]
};
	["EventListUpdateResult"]: {
	__typename: "EventListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EventListUpsertResult"]: {
	__typename: "EventListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EventList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxItemCreateResult"]: {
	__typename: "BoxItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxItemDeleteResult"]: {
	__typename: "BoxItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxItem"]
};
	["BoxItemUpdateResult"]: {
	__typename: "BoxItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxItemUpsertResult"]: {
	__typename: "BoxItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxListCreateResult"]: {
	__typename: "BoxListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxListDeleteResult"]: {
	__typename: "BoxListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxList"]
};
	["BoxListUpdateResult"]: {
	__typename: "BoxListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["BoxListUpsertResult"]: {
	__typename: "BoxListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["BoxList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormCreateResult"]: {
	__typename: "NewsletterFormCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormDeleteResult"]: {
	__typename: "NewsletterFormDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterForm"]
};
	["NewsletterFormUpdateResult"]: {
	__typename: "NewsletterFormUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormUpsertResult"]: {
	__typename: "NewsletterFormUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterTypeItemCreateResult"]: {
	__typename: "NewsletterTypeItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterTypeItemDeleteResult"]: {
	__typename: "NewsletterTypeItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterTypeItem"]
};
	["NewsletterTypeItemUpdateResult"]: {
	__typename: "NewsletterTypeItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterTypeItemUpsertResult"]: {
	__typename: "NewsletterTypeItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormLocaleCreateResult"]: {
	__typename: "NewsletterFormLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormLocaleDeleteResult"]: {
	__typename: "NewsletterFormLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterFormLocale"]
};
	["NewsletterFormLocaleUpdateResult"]: {
	__typename: "NewsletterFormLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterFormLocaleUpsertResult"]: {
	__typename: "NewsletterFormLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSubscriptionCreateResult"]: {
	__typename: "NewsletterSubscriptionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSubscriptionDeleteResult"]: {
	__typename: "NewsletterSubscriptionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSubscription"]
};
	["NewsletterSubscriptionUpdateResult"]: {
	__typename: "NewsletterSubscriptionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["NewsletterSubscriptionUpsertResult"]: {
	__typename: "NewsletterSubscriptionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["NewsletterSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartCreateResult"]: {
	__typename: "ChartCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Chart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartDeleteResult"]: {
	__typename: "ChartDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Chart"]
};
	["ChartUpdateResult"]: {
	__typename: "ChartUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Chart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartUpsertResult"]: {
	__typename: "ChartUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Chart"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartDataCreateResult"]: {
	__typename: "ChartDataCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChartData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartDataDeleteResult"]: {
	__typename: "ChartDataDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChartData"]
};
	["ChartDataUpdateResult"]: {
	__typename: "ChartDataUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChartData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ChartDataUpsertResult"]: {
	__typename: "ChartDataUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ChartData"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeCreateResult"]: {
	__typename: "EmployeeCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Employee"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeDeleteResult"]: {
	__typename: "EmployeeDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Employee"]
};
	["EmployeeUpdateResult"]: {
	__typename: "EmployeeUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Employee"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeUpsertResult"]: {
	__typename: "EmployeeUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Employee"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeItemCreateResult"]: {
	__typename: "EmployeeItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeItemDeleteResult"]: {
	__typename: "EmployeeItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeItem"]
};
	["EmployeeItemUpdateResult"]: {
	__typename: "EmployeeItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeItemUpsertResult"]: {
	__typename: "EmployeeItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeListCreateResult"]: {
	__typename: "EmployeeListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeListDeleteResult"]: {
	__typename: "EmployeeListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeList"]
};
	["EmployeeListUpdateResult"]: {
	__typename: "EmployeeListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeListUpsertResult"]: {
	__typename: "EmployeeListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeLocaleCreateResult"]: {
	__typename: "EmployeeLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeLocaleDeleteResult"]: {
	__typename: "EmployeeLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeLocale"]
};
	["EmployeeLocaleUpdateResult"]: {
	__typename: "EmployeeLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["EmployeeLocaleUpsertResult"]: {
	__typename: "EmployeeLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["EmployeeLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerCreateResult"]: {
	__typename: "PhotographerCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerDeleteResult"]: {
	__typename: "PhotographerDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"]
};
	["PhotographerUpdateResult"]: {
	__typename: "PhotographerUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["PhotographerUpsertResult"]: {
	__typename: "PhotographerUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Photographer"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionItemCreateResult"]: {
	__typename: "DefinitionItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionItemDeleteResult"]: {
	__typename: "DefinitionItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionItem"]
};
	["DefinitionItemUpdateResult"]: {
	__typename: "DefinitionItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionItemUpsertResult"]: {
	__typename: "DefinitionItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionListCreateResult"]: {
	__typename: "DefinitionListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionListDeleteResult"]: {
	__typename: "DefinitionListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionList"]
};
	["DefinitionListUpdateResult"]: {
	__typename: "DefinitionListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["DefinitionListUpsertResult"]: {
	__typename: "DefinitionListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["DefinitionList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoItemCreateResult"]: {
	__typename: "LogoItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoItemDeleteResult"]: {
	__typename: "LogoItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoItem"]
};
	["LogoItemUpdateResult"]: {
	__typename: "LogoItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoItemUpsertResult"]: {
	__typename: "LogoItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoListCreateResult"]: {
	__typename: "LogoListCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoListDeleteResult"]: {
	__typename: "LogoListDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoList"]
};
	["LogoListUpdateResult"]: {
	__typename: "LogoListUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["LogoListUpsertResult"]: {
	__typename: "LogoListUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["LogoList"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaCreateResult"]: {
	__typename: "StrategySchemaCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchema"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaDeleteResult"]: {
	__typename: "StrategySchemaDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchema"]
};
	["StrategySchemaUpdateResult"]: {
	__typename: "StrategySchemaUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchema"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaUpsertResult"]: {
	__typename: "StrategySchemaUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchema"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupCreateResult"]: {
	__typename: "StrategySchemaGroupCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupDeleteResult"]: {
	__typename: "StrategySchemaGroupDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroup"]
};
	["StrategySchemaGroupUpdateResult"]: {
	__typename: "StrategySchemaGroupUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupUpsertResult"]: {
	__typename: "StrategySchemaGroupUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroup"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemCreateResult"]: {
	__typename: "StrategySchemaGroupItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroupItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemDeleteResult"]: {
	__typename: "StrategySchemaGroupItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroupItem"]
};
	["StrategySchemaGroupItemUpdateResult"]: {
	__typename: "StrategySchemaGroupItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroupItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["StrategySchemaGroupItemUpsertResult"]: {
	__typename: "StrategySchemaGroupItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["StrategySchemaGroupItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectCreateResult"]: {
	__typename: "RedirectCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectDeleteResult"]: {
	__typename: "RedirectDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"]
};
	["RedirectUpdateResult"]: {
	__typename: "RedirectUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["RedirectUpsertResult"]: {
	__typename: "RedirectUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Redirect"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryCreateResult"]: {
	__typename: "GalleryCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryDeleteResult"]: {
	__typename: "GalleryDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"]
};
	["GalleryUpdateResult"]: {
	__typename: "GalleryUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryUpsertResult"]: {
	__typename: "GalleryUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["Gallery"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemCreateResult"]: {
	__typename: "GalleryItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemDeleteResult"]: {
	__typename: "GalleryItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"]
};
	["GalleryItemUpdateResult"]: {
	__typename: "GalleryItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["GalleryItemUpsertResult"]: {
	__typename: "GalleryItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["GalleryItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormCreateResult"]: {
	__typename: "ContactFormCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormDeleteResult"]: {
	__typename: "ContactFormDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactForm"]
};
	["ContactFormUpdateResult"]: {
	__typename: "ContactFormUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormUpsertResult"]: {
	__typename: "ContactFormUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactForm"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormLocaleCreateResult"]: {
	__typename: "ContactFormLocaleCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormLocaleDeleteResult"]: {
	__typename: "ContactFormLocaleDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormLocale"]
};
	["ContactFormLocaleUpdateResult"]: {
	__typename: "ContactFormLocaleUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactFormLocaleUpsertResult"]: {
	__typename: "ContactFormLocaleUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactFormLocale"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubscriptionCreateResult"]: {
	__typename: "ContactSubscriptionCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubscriptionDeleteResult"]: {
	__typename: "ContactSubscriptionDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubscription"]
};
	["ContactSubscriptionUpdateResult"]: {
	__typename: "ContactSubscriptionUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactSubscriptionUpsertResult"]: {
	__typename: "ContactSubscriptionUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactSubscription"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactTypeItemCreateResult"]: {
	__typename: "ContactTypeItemCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactTypeItemDeleteResult"]: {
	__typename: "ContactTypeItemDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactTypeItem"]
};
	["ContactTypeItemUpdateResult"]: {
	__typename: "ContactTypeItemUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["ContactTypeItemUpsertResult"]: {
	__typename: "ContactTypeItemUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["ContactTypeItem"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileCreateResult"]: {
	__typename: "FileCreateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileDeleteResult"]: {
	__typename: "FileDeleteResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"]
};
	["FileUpdateResult"]: {
	__typename: "FileUpdateResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["FileUpsertResult"]: {
	__typename: "FileUpsertResult",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	node?: GraphQLTypes["File"],
	validation: GraphQLTypes["_ValidationResult"]
};
	["MutationTransaction"]: {
	__typename: "MutationTransaction",
	ok: boolean,
	errorMessage?: string,
	errors: Array<GraphQLTypes["_MutationError"]>,
	validation: GraphQLTypes["_ValidationResult"],
	createContactPage: GraphQLTypes["ContactPageCreateResult"],
	deleteContactPage: GraphQLTypes["ContactPageDeleteResult"],
	updateContactPage: GraphQLTypes["ContactPageUpdateResult"],
	upsertContactPage: GraphQLTypes["ContactPageUpsertResult"],
	createContactPageLocale: GraphQLTypes["ContactPageLocaleCreateResult"],
	deleteContactPageLocale: GraphQLTypes["ContactPageLocaleDeleteResult"],
	updateContactPageLocale: GraphQLTypes["ContactPageLocaleUpdateResult"],
	upsertContactPageLocale: GraphQLTypes["ContactPageLocaleUpsertResult"],
	createContent: GraphQLTypes["ContentCreateResult"],
	deleteContent: GraphQLTypes["ContentDeleteResult"],
	updateContent: GraphQLTypes["ContentUpdateResult"],
	upsertContent: GraphQLTypes["ContentUpsertResult"],
	createContentBlock: GraphQLTypes["ContentBlockCreateResult"],
	deleteContentBlock: GraphQLTypes["ContentBlockDeleteResult"],
	updateContentBlock: GraphQLTypes["ContentBlockUpdateResult"],
	upsertContentBlock: GraphQLTypes["ContentBlockUpsertResult"],
	createContentReference: GraphQLTypes["ContentReferenceCreateResult"],
	deleteContentReference: GraphQLTypes["ContentReferenceDeleteResult"],
	updateContentReference: GraphQLTypes["ContentReferenceUpdateResult"],
	upsertContentReference: GraphQLTypes["ContentReferenceUpsertResult"],
	createFooter: GraphQLTypes["FooterCreateResult"],
	deleteFooter: GraphQLTypes["FooterDeleteResult"],
	updateFooter: GraphQLTypes["FooterUpdateResult"],
	upsertFooter: GraphQLTypes["FooterUpsertResult"],
	createFooterLocale: GraphQLTypes["FooterLocaleCreateResult"],
	deleteFooterLocale: GraphQLTypes["FooterLocaleDeleteResult"],
	updateFooterLocale: GraphQLTypes["FooterLocaleUpdateResult"],
	upsertFooterLocale: GraphQLTypes["FooterLocaleUpsertResult"],
	createHeader: GraphQLTypes["HeaderCreateResult"],
	deleteHeader: GraphQLTypes["HeaderDeleteResult"],
	updateHeader: GraphQLTypes["HeaderUpdateResult"],
	upsertHeader: GraphQLTypes["HeaderUpsertResult"],
	createHeaderLink: GraphQLTypes["HeaderLinkCreateResult"],
	deleteHeaderLink: GraphQLTypes["HeaderLinkDeleteResult"],
	updateHeaderLink: GraphQLTypes["HeaderLinkUpdateResult"],
	upsertHeaderLink: GraphQLTypes["HeaderLinkUpsertResult"],
	createHeaderLocale: GraphQLTypes["HeaderLocaleCreateResult"],
	deleteHeaderLocale: GraphQLTypes["HeaderLocaleDeleteResult"],
	updateHeaderLocale: GraphQLTypes["HeaderLocaleUpdateResult"],
	upsertHeaderLocale: GraphQLTypes["HeaderLocaleUpsertResult"],
	createHomePage: GraphQLTypes["HomePageCreateResult"],
	deleteHomePage: GraphQLTypes["HomePageDeleteResult"],
	updateHomePage: GraphQLTypes["HomePageUpdateResult"],
	upsertHomePage: GraphQLTypes["HomePageUpsertResult"],
	createHomePageLocale: GraphQLTypes["HomePageLocaleCreateResult"],
	deleteHomePageLocale: GraphQLTypes["HomePageLocaleDeleteResult"],
	updateHomePageLocale: GraphQLTypes["HomePageLocaleUpdateResult"],
	upsertHomePageLocale: GraphQLTypes["HomePageLocaleUpsertResult"],
	createLink: GraphQLTypes["LinkCreateResult"],
	deleteLink: GraphQLTypes["LinkDeleteResult"],
	updateLink: GraphQLTypes["LinkUpdateResult"],
	upsertLink: GraphQLTypes["LinkUpsertResult"],
	createLinkable: GraphQLTypes["LinkableCreateResult"],
	deleteLinkable: GraphQLTypes["LinkableDeleteResult"],
	updateLinkable: GraphQLTypes["LinkableUpdateResult"],
	upsertLinkable: GraphQLTypes["LinkableUpsertResult"],
	createLocale: GraphQLTypes["LocaleCreateResult"],
	deleteLocale: GraphQLTypes["LocaleDeleteResult"],
	updateLocale: GraphQLTypes["LocaleUpdateResult"],
	upsertLocale: GraphQLTypes["LocaleUpsertResult"],
	createMedium: GraphQLTypes["MediumCreateResult"],
	deleteMedium: GraphQLTypes["MediumDeleteResult"],
	updateMedium: GraphQLTypes["MediumUpdateResult"],
	upsertMedium: GraphQLTypes["MediumUpsertResult"],
	createMediumItem: GraphQLTypes["MediumItemCreateResult"],
	deleteMediumItem: GraphQLTypes["MediumItemDeleteResult"],
	updateMediumItem: GraphQLTypes["MediumItemUpdateResult"],
	upsertMediumItem: GraphQLTypes["MediumItemUpsertResult"],
	createMediumList: GraphQLTypes["MediumListCreateResult"],
	deleteMediumList: GraphQLTypes["MediumListDeleteResult"],
	updateMediumList: GraphQLTypes["MediumListUpdateResult"],
	upsertMediumList: GraphQLTypes["MediumListUpsertResult"],
	createPage: GraphQLTypes["PageCreateResult"],
	deletePage: GraphQLTypes["PageDeleteResult"],
	updatePage: GraphQLTypes["PageUpdateResult"],
	upsertPage: GraphQLTypes["PageUpsertResult"],
	createPageLocale: GraphQLTypes["PageLocaleCreateResult"],
	deletePageLocale: GraphQLTypes["PageLocaleDeleteResult"],
	updatePageLocale: GraphQLTypes["PageLocaleUpdateResult"],
	upsertPageLocale: GraphQLTypes["PageLocaleUpsertResult"],
	createSeoDefault: GraphQLTypes["SeoDefaultCreateResult"],
	deleteSeoDefault: GraphQLTypes["SeoDefaultDeleteResult"],
	updateSeoDefault: GraphQLTypes["SeoDefaultUpdateResult"],
	upsertSeoDefault: GraphQLTypes["SeoDefaultUpsertResult"],
	createSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleCreateResult"],
	deleteSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleDeleteResult"],
	updateSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpdateResult"],
	upsertSeoDefaultLocale: GraphQLTypes["SeoDefaultLocaleUpsertResult"],
	createVideo: GraphQLTypes["VideoCreateResult"],
	deleteVideo: GraphQLTypes["VideoDeleteResult"],
	updateVideo: GraphQLTypes["VideoUpdateResult"],
	upsertVideo: GraphQLTypes["VideoUpsertResult"],
	createImage: GraphQLTypes["ImageCreateResult"],
	deleteImage: GraphQLTypes["ImageDeleteResult"],
	updateImage: GraphQLTypes["ImageUpdateResult"],
	upsertImage: GraphQLTypes["ImageUpsertResult"],
	createSeo: GraphQLTypes["SeoCreateResult"],
	deleteSeo: GraphQLTypes["SeoDeleteResult"],
	updateSeo: GraphQLTypes["SeoUpdateResult"],
	upsertSeo: GraphQLTypes["SeoUpsertResult"],
	createTranslationDomain: GraphQLTypes["TranslationDomainCreateResult"],
	deleteTranslationDomain: GraphQLTypes["TranslationDomainDeleteResult"],
	updateTranslationDomain: GraphQLTypes["TranslationDomainUpdateResult"],
	upsertTranslationDomain: GraphQLTypes["TranslationDomainUpsertResult"],
	createTranslationCatalogue: GraphQLTypes["TranslationCatalogueCreateResult"],
	deleteTranslationCatalogue: GraphQLTypes["TranslationCatalogueDeleteResult"],
	updateTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpdateResult"],
	upsertTranslationCatalogue: GraphQLTypes["TranslationCatalogueUpsertResult"],
	createTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierCreateResult"],
	deleteTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierDeleteResult"],
	updateTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpdateResult"],
	upsertTranslationCataloguesIdentifier: GraphQLTypes["TranslationCataloguesIdentifierUpsertResult"],
	createTranslationKey: GraphQLTypes["TranslationKeyCreateResult"],
	deleteTranslationKey: GraphQLTypes["TranslationKeyDeleteResult"],
	updateTranslationKey: GraphQLTypes["TranslationKeyUpdateResult"],
	upsertTranslationKey: GraphQLTypes["TranslationKeyUpsertResult"],
	createTranslationValue: GraphQLTypes["TranslationValueCreateResult"],
	deleteTranslationValue: GraphQLTypes["TranslationValueDeleteResult"],
	updateTranslationValue: GraphQLTypes["TranslationValueUpdateResult"],
	upsertTranslationValue: GraphQLTypes["TranslationValueUpsertResult"],
	createBranches: GraphQLTypes["BranchesCreateResult"],
	deleteBranches: GraphQLTypes["BranchesDeleteResult"],
	updateBranches: GraphQLTypes["BranchesUpdateResult"],
	upsertBranches: GraphQLTypes["BranchesUpsertResult"],
	createGraphicDesigner: GraphQLTypes["GraphicDesignerCreateResult"],
	deleteGraphicDesigner: GraphQLTypes["GraphicDesignerDeleteResult"],
	updateGraphicDesigner: GraphQLTypes["GraphicDesignerUpdateResult"],
	upsertGraphicDesigner: GraphQLTypes["GraphicDesignerUpsertResult"],
	createEvent: GraphQLTypes["EventCreateResult"],
	deleteEvent: GraphQLTypes["EventDeleteResult"],
	updateEvent: GraphQLTypes["EventUpdateResult"],
	upsertEvent: GraphQLTypes["EventUpsertResult"],
	createEventLocale: GraphQLTypes["EventLocaleCreateResult"],
	deleteEventLocale: GraphQLTypes["EventLocaleDeleteResult"],
	updateEventLocale: GraphQLTypes["EventLocaleUpdateResult"],
	upsertEventLocale: GraphQLTypes["EventLocaleUpsertResult"],
	createArtwork: GraphQLTypes["ArtworkCreateResult"],
	deleteArtwork: GraphQLTypes["ArtworkDeleteResult"],
	updateArtwork: GraphQLTypes["ArtworkUpdateResult"],
	upsertArtwork: GraphQLTypes["ArtworkUpsertResult"],
	createArtworkLocale: GraphQLTypes["ArtworkLocaleCreateResult"],
	deleteArtworkLocale: GraphQLTypes["ArtworkLocaleDeleteResult"],
	updateArtworkLocale: GraphQLTypes["ArtworkLocaleUpdateResult"],
	upsertArtworkLocale: GraphQLTypes["ArtworkLocaleUpsertResult"],
	createDropDownItem: GraphQLTypes["DropDownItemCreateResult"],
	deleteDropDownItem: GraphQLTypes["DropDownItemDeleteResult"],
	updateDropDownItem: GraphQLTypes["DropDownItemUpdateResult"],
	upsertDropDownItem: GraphQLTypes["DropDownItemUpsertResult"],
	createDropDownList: GraphQLTypes["DropDownListCreateResult"],
	deleteDropDownList: GraphQLTypes["DropDownListDeleteResult"],
	updateDropDownList: GraphQLTypes["DropDownListUpdateResult"],
	upsertDropDownList: GraphQLTypes["DropDownListUpsertResult"],
	createArtworkItem: GraphQLTypes["ArtworkItemCreateResult"],
	deleteArtworkItem: GraphQLTypes["ArtworkItemDeleteResult"],
	updateArtworkItem: GraphQLTypes["ArtworkItemUpdateResult"],
	upsertArtworkItem: GraphQLTypes["ArtworkItemUpsertResult"],
	createArtworkList: GraphQLTypes["ArtworkListCreateResult"],
	deleteArtworkList: GraphQLTypes["ArtworkListDeleteResult"],
	updateArtworkList: GraphQLTypes["ArtworkListUpdateResult"],
	upsertArtworkList: GraphQLTypes["ArtworkListUpsertResult"],
	createArtworkSelection: GraphQLTypes["ArtworkSelectionCreateResult"],
	deleteArtworkSelection: GraphQLTypes["ArtworkSelectionDeleteResult"],
	updateArtworkSelection: GraphQLTypes["ArtworkSelectionUpdateResult"],
	upsertArtworkSelection: GraphQLTypes["ArtworkSelectionUpsertResult"],
	createArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemCreateResult"],
	deleteArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemDeleteResult"],
	updateArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemUpdateResult"],
	upsertArtworkSelectionItem: GraphQLTypes["ArtworkSelectionItemUpsertResult"],
	createArtworkSelectionList: GraphQLTypes["ArtworkSelectionListCreateResult"],
	deleteArtworkSelectionList: GraphQLTypes["ArtworkSelectionListDeleteResult"],
	updateArtworkSelectionList: GraphQLTypes["ArtworkSelectionListUpdateResult"],
	upsertArtworkSelectionList: GraphQLTypes["ArtworkSelectionListUpsertResult"],
	createArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleCreateResult"],
	deleteArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleDeleteResult"],
	updateArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleUpdateResult"],
	upsertArtworkSelectionLocale: GraphQLTypes["ArtworkSelectionLocaleUpsertResult"],
	createEventItem: GraphQLTypes["EventItemCreateResult"],
	deleteEventItem: GraphQLTypes["EventItemDeleteResult"],
	updateEventItem: GraphQLTypes["EventItemUpdateResult"],
	upsertEventItem: GraphQLTypes["EventItemUpsertResult"],
	createEventList: GraphQLTypes["EventListCreateResult"],
	deleteEventList: GraphQLTypes["EventListDeleteResult"],
	updateEventList: GraphQLTypes["EventListUpdateResult"],
	upsertEventList: GraphQLTypes["EventListUpsertResult"],
	createBoxItem: GraphQLTypes["BoxItemCreateResult"],
	deleteBoxItem: GraphQLTypes["BoxItemDeleteResult"],
	updateBoxItem: GraphQLTypes["BoxItemUpdateResult"],
	upsertBoxItem: GraphQLTypes["BoxItemUpsertResult"],
	createBoxList: GraphQLTypes["BoxListCreateResult"],
	deleteBoxList: GraphQLTypes["BoxListDeleteResult"],
	updateBoxList: GraphQLTypes["BoxListUpdateResult"],
	upsertBoxList: GraphQLTypes["BoxListUpsertResult"],
	createNewsletterForm: GraphQLTypes["NewsletterFormCreateResult"],
	deleteNewsletterForm: GraphQLTypes["NewsletterFormDeleteResult"],
	updateNewsletterForm: GraphQLTypes["NewsletterFormUpdateResult"],
	upsertNewsletterForm: GraphQLTypes["NewsletterFormUpsertResult"],
	createNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemCreateResult"],
	deleteNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemDeleteResult"],
	updateNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemUpdateResult"],
	upsertNewsletterTypeItem: GraphQLTypes["NewsletterTypeItemUpsertResult"],
	createNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleCreateResult"],
	deleteNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleDeleteResult"],
	updateNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleUpdateResult"],
	upsertNewsletterFormLocale: GraphQLTypes["NewsletterFormLocaleUpsertResult"],
	createNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionCreateResult"],
	deleteNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionDeleteResult"],
	updateNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionUpdateResult"],
	upsertNewsletterSubscription: GraphQLTypes["NewsletterSubscriptionUpsertResult"],
	createChart: GraphQLTypes["ChartCreateResult"],
	deleteChart: GraphQLTypes["ChartDeleteResult"],
	updateChart: GraphQLTypes["ChartUpdateResult"],
	upsertChart: GraphQLTypes["ChartUpsertResult"],
	createChartData: GraphQLTypes["ChartDataCreateResult"],
	deleteChartData: GraphQLTypes["ChartDataDeleteResult"],
	updateChartData: GraphQLTypes["ChartDataUpdateResult"],
	upsertChartData: GraphQLTypes["ChartDataUpsertResult"],
	createEmployee: GraphQLTypes["EmployeeCreateResult"],
	deleteEmployee: GraphQLTypes["EmployeeDeleteResult"],
	updateEmployee: GraphQLTypes["EmployeeUpdateResult"],
	upsertEmployee: GraphQLTypes["EmployeeUpsertResult"],
	createEmployeeItem: GraphQLTypes["EmployeeItemCreateResult"],
	deleteEmployeeItem: GraphQLTypes["EmployeeItemDeleteResult"],
	updateEmployeeItem: GraphQLTypes["EmployeeItemUpdateResult"],
	upsertEmployeeItem: GraphQLTypes["EmployeeItemUpsertResult"],
	createEmployeeList: GraphQLTypes["EmployeeListCreateResult"],
	deleteEmployeeList: GraphQLTypes["EmployeeListDeleteResult"],
	updateEmployeeList: GraphQLTypes["EmployeeListUpdateResult"],
	upsertEmployeeList: GraphQLTypes["EmployeeListUpsertResult"],
	createEmployeeLocale: GraphQLTypes["EmployeeLocaleCreateResult"],
	deleteEmployeeLocale: GraphQLTypes["EmployeeLocaleDeleteResult"],
	updateEmployeeLocale: GraphQLTypes["EmployeeLocaleUpdateResult"],
	upsertEmployeeLocale: GraphQLTypes["EmployeeLocaleUpsertResult"],
	createPhotographer: GraphQLTypes["PhotographerCreateResult"],
	deletePhotographer: GraphQLTypes["PhotographerDeleteResult"],
	updatePhotographer: GraphQLTypes["PhotographerUpdateResult"],
	upsertPhotographer: GraphQLTypes["PhotographerUpsertResult"],
	createDefinitionItem: GraphQLTypes["DefinitionItemCreateResult"],
	deleteDefinitionItem: GraphQLTypes["DefinitionItemDeleteResult"],
	updateDefinitionItem: GraphQLTypes["DefinitionItemUpdateResult"],
	upsertDefinitionItem: GraphQLTypes["DefinitionItemUpsertResult"],
	createDefinitionList: GraphQLTypes["DefinitionListCreateResult"],
	deleteDefinitionList: GraphQLTypes["DefinitionListDeleteResult"],
	updateDefinitionList: GraphQLTypes["DefinitionListUpdateResult"],
	upsertDefinitionList: GraphQLTypes["DefinitionListUpsertResult"],
	createLogoItem: GraphQLTypes["LogoItemCreateResult"],
	deleteLogoItem: GraphQLTypes["LogoItemDeleteResult"],
	updateLogoItem: GraphQLTypes["LogoItemUpdateResult"],
	upsertLogoItem: GraphQLTypes["LogoItemUpsertResult"],
	createLogoList: GraphQLTypes["LogoListCreateResult"],
	deleteLogoList: GraphQLTypes["LogoListDeleteResult"],
	updateLogoList: GraphQLTypes["LogoListUpdateResult"],
	upsertLogoList: GraphQLTypes["LogoListUpsertResult"],
	createStrategySchema: GraphQLTypes["StrategySchemaCreateResult"],
	deleteStrategySchema: GraphQLTypes["StrategySchemaDeleteResult"],
	updateStrategySchema: GraphQLTypes["StrategySchemaUpdateResult"],
	upsertStrategySchema: GraphQLTypes["StrategySchemaUpsertResult"],
	createStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupCreateResult"],
	deleteStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupDeleteResult"],
	updateStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupUpdateResult"],
	upsertStrategySchemaGroup: GraphQLTypes["StrategySchemaGroupUpsertResult"],
	createStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemCreateResult"],
	deleteStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemDeleteResult"],
	updateStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemUpdateResult"],
	upsertStrategySchemaGroupItem: GraphQLTypes["StrategySchemaGroupItemUpsertResult"],
	createRedirect: GraphQLTypes["RedirectCreateResult"],
	deleteRedirect: GraphQLTypes["RedirectDeleteResult"],
	updateRedirect: GraphQLTypes["RedirectUpdateResult"],
	upsertRedirect: GraphQLTypes["RedirectUpsertResult"],
	createGallery: GraphQLTypes["GalleryCreateResult"],
	deleteGallery: GraphQLTypes["GalleryDeleteResult"],
	updateGallery: GraphQLTypes["GalleryUpdateResult"],
	upsertGallery: GraphQLTypes["GalleryUpsertResult"],
	createGalleryItem: GraphQLTypes["GalleryItemCreateResult"],
	deleteGalleryItem: GraphQLTypes["GalleryItemDeleteResult"],
	updateGalleryItem: GraphQLTypes["GalleryItemUpdateResult"],
	upsertGalleryItem: GraphQLTypes["GalleryItemUpsertResult"],
	createContactForm: GraphQLTypes["ContactFormCreateResult"],
	deleteContactForm: GraphQLTypes["ContactFormDeleteResult"],
	updateContactForm: GraphQLTypes["ContactFormUpdateResult"],
	upsertContactForm: GraphQLTypes["ContactFormUpsertResult"],
	createContactFormLocale: GraphQLTypes["ContactFormLocaleCreateResult"],
	deleteContactFormLocale: GraphQLTypes["ContactFormLocaleDeleteResult"],
	updateContactFormLocale: GraphQLTypes["ContactFormLocaleUpdateResult"],
	upsertContactFormLocale: GraphQLTypes["ContactFormLocaleUpsertResult"],
	createContactSubscription: GraphQLTypes["ContactSubscriptionCreateResult"],
	deleteContactSubscription: GraphQLTypes["ContactSubscriptionDeleteResult"],
	updateContactSubscription: GraphQLTypes["ContactSubscriptionUpdateResult"],
	upsertContactSubscription: GraphQLTypes["ContactSubscriptionUpsertResult"],
	createContactTypeItem: GraphQLTypes["ContactTypeItemCreateResult"],
	deleteContactTypeItem: GraphQLTypes["ContactTypeItemDeleteResult"],
	updateContactTypeItem: GraphQLTypes["ContactTypeItemUpdateResult"],
	upsertContactTypeItem: GraphQLTypes["ContactTypeItemUpsertResult"],
	createFile: GraphQLTypes["FileCreateResult"],
	deleteFile: GraphQLTypes["FileDeleteResult"],
	updateFile: GraphQLTypes["FileUpdateResult"],
	upsertFile: GraphQLTypes["FileUpsertResult"],
	query?: GraphQLTypes["Query"]
};
	["MutationTransactionOptions"]: {
		deferForeignKeyConstraints?: boolean
};
	/** Json custom scalar type */
["Json"]:any;
	["_Schema"]: {
	__typename: "_Schema",
	enums: Array<GraphQLTypes["_Enum"]>,
	entities: Array<GraphQLTypes["_Entity"]>
};
	["_Entity"]: {
	__typename: "_Entity",
	name: string,
	customPrimaryAllowed: boolean,
	fields: Array<GraphQLTypes["_Field"]>,
	unique: Array<GraphQLTypes["_UniqueConstraint"]>
};
	["_UniqueConstraint"]: {
	__typename: "_UniqueConstraint",
	fields: Array<string>
};
	["_Field"]: {
	__typename:"_Column" | "_Relation",
	name: string,
	type: string,
	nullable?: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
	['...on _Column']: '__union' & GraphQLTypes["_Column"];
	['...on _Relation']: '__union' & GraphQLTypes["_Relation"];
};
	["_Column"]: {
	__typename: "_Column",
	name: string,
	type: string,
	enumName?: string,
	defaultValue?: GraphQLTypes["Json"],
	nullable: boolean,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_OnDeleteBehaviour"]: _OnDeleteBehaviour;
	["_RelationSide"]: _RelationSide;
	["_OrderByDirection"]: _OrderByDirection;
	["_OrderBy"]: {
	__typename: "_OrderBy",
	path: Array<string>,
	direction: GraphQLTypes["_OrderByDirection"]
};
	["_Relation"]: {
	__typename: "_Relation",
	name: string,
	type: string,
	side: GraphQLTypes["_RelationSide"],
	targetEntity: string,
	ownedBy?: string,
	inversedBy?: string,
	nullable?: boolean,
	onDelete?: GraphQLTypes["_OnDeleteBehaviour"],
	orphanRemoval?: boolean,
	orderBy?: Array<GraphQLTypes["_OrderBy"]>,
	rules: Array<GraphQLTypes["_Rule"]>,
	validators: Array<GraphQLTypes["_Validator"]>
};
	["_Rule"]: {
	__typename: "_Rule",
	message?: GraphQLTypes["_RuleMessage"],
	validator: number
};
	["_Validator"]: {
	__typename: "_Validator",
	operation: string,
	arguments: Array<GraphQLTypes["_Argument"]>
};
	["_Argument"]:{
	__typename:"_ValidatorArgument" | "_PathArgument" | "_LiteralArgument"
	['...on _ValidatorArgument']: '__union' & GraphQLTypes["_ValidatorArgument"];
	['...on _PathArgument']: '__union' & GraphQLTypes["_PathArgument"];
	['...on _LiteralArgument']: '__union' & GraphQLTypes["_LiteralArgument"];
};
	["_ValidatorArgument"]: {
	__typename: "_ValidatorArgument",
	validator: number
};
	["_PathArgument"]: {
	__typename: "_PathArgument",
	path: Array<string>
};
	["_LiteralArgument"]: {
	__typename: "_LiteralArgument",
	value?: GraphQLTypes["Json"]
};
	["_RuleMessage"]: {
	__typename: "_RuleMessage",
	text?: string
};
	["_Enum"]: {
	__typename: "_Enum",
	name: string,
	values: Array<string>
};
	["S3SignedUpload"]: {
	__typename: "S3SignedUpload",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string,
	publicUrl: string
};
	["S3Header"]: {
	__typename: "S3Header",
	key: string,
	value: string
};
	["S3SignedRead"]: {
	__typename: "S3SignedRead",
	url: string,
	headers: Array<GraphQLTypes["S3Header"]>,
	method: string,
	/** Allowed patterns:
** */
	objectKey: string,
	bucket: string
}
    }
export const enum One {
	One = "One"
}
export const enum LinkType {
	internal = "internal",
	external = "external",
	anchor = "anchor"
}
export const enum MediumType {
	image = "image",
	video = "video"
}
export const enum ContentReferenceType {
	gallery = "gallery",
	image = "image",
	dropDown = "dropDown",
	carouselWithArtworks = "carouselWithArtworks",
	button = "button",
	events = "events",
	boxes = "boxes",
	newsletter = "newsletter",
	contactForm = "contactForm",
	chart = "chart",
	link = "link",
	definitionList = "definitionList",
	sponsors = "sponsors",
	strategySchema = "strategySchema",
	vennDiagram = "vennDiagram",
	personCarousel = "personCarousel",
	galleryInfo = "galleryInfo"
}
export const enum DropDownType {
	link = "link",
	person = "person"
}
export const enum ChartType {
	pie = "pie",
	column = "column"
}
export const enum OrderDirection {
	asc = "asc",
	desc = "desc",
	ascNullsFirst = "ascNullsFirst",
	descNullsLast = "descNullsLast"
}
export const enum TranslationContentType {
	textPlain = "textPlain",
	textHtml = "textHtml"
}
export const enum _MutationErrorType {
	NotNullConstraintViolation = "NotNullConstraintViolation",
	UniqueConstraintViolation = "UniqueConstraintViolation",
	ForeignKeyConstraintViolation = "ForeignKeyConstraintViolation",
	NotFoundOrDenied = "NotFoundOrDenied",
	NonUniqueWhereInput = "NonUniqueWhereInput",
	InvalidDataInput = "InvalidDataInput",
	SqlError = "SqlError"
}
export const enum _OnDeleteBehaviour {
	restrict = "restrict",
	cascade = "cascade",
	setNull = "setNull"
}
export const enum _RelationSide {
	owning = "owning",
	inverse = "inverse"
}
export const enum _OrderByDirection {
	asc = "asc",
	desc = "desc"
}
export class GraphQLError extends Error {
    constructor(public response: GraphQLResponse) {
      super("");
      console.error(response);
    }
    override toString() {
      return "GraphQL Response Error";
    }
  }


export type UnwrapPromise<T> = T extends Promise<infer R> ? R : T;
export type ZeusState<T extends (...args: any[]) => Promise<any>> = NonNullable<
  UnwrapPromise<ReturnType<T>>
>;
export type ZeusHook<
  T extends (
    ...args: any[]
  ) => Record<string, (...args: any[]) => Promise<any>>,
  N extends keyof ReturnType<T>
> = ZeusState<ReturnType<T>[N]>;

type WithTypeNameValue<T> = T & {
  __typename?: true;
};
type AliasType<T> = WithTypeNameValue<T> & {
  __alias?: Record<string, WithTypeNameValue<T>>;
};
export interface GraphQLResponse {
  data?: Record<string, any>;
  errors?: Array<{
    message: string;
  }>;
}
type DeepAnify<T> = {
  [P in keyof T]?: any;
};
type IsPayLoad<T> = T extends [any, infer PayLoad] ? PayLoad : T;
type IsArray<T, U> = T extends Array<infer R> ? InputType<R, U>[] : InputType<T, U>;
type FlattenArray<T> = T extends Array<infer R> ? R : T;

type IsInterfaced<SRC extends DeepAnify<DST>, DST> = FlattenArray<SRC> extends ZEUS_INTERFACES | ZEUS_UNIONS
  ? {
      [P in keyof SRC]: SRC[P] extends '__union' & infer R
        ? P extends keyof DST
          ? IsArray<R, '__typename' extends keyof DST ? DST[P] & { __typename: true } : DST[P]>
          : {}
        : never;
    }[keyof DST] &
      {
        [P in keyof Omit<
          Pick<
            SRC,
            {
              [P in keyof DST]: SRC[P] extends '__union' & infer R ? never : P;
            }[keyof DST]
          >,
          '__typename'
        >]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
      }
  : {
      [P in keyof Pick<SRC, keyof DST>]: IsPayLoad<DST[P]> extends true ? SRC[P] : IsArray<SRC[P], DST[P]>;
    };

export type MapType<SRC, DST> = SRC extends DeepAnify<DST> ? IsInterfaced<SRC, DST> : never;
export type InputType<SRC, DST> = IsPayLoad<DST> extends { __alias: infer R }
  ? {
      [P in keyof R]: MapType<SRC, R[P]>;
    } &
      MapType<SRC, Omit<IsPayLoad<DST>, '__alias'>>
  : MapType<SRC, IsPayLoad<DST>>;
type Func<P extends any[], R> = (...args: P) => R;
type AnyFunc = Func<any, any>;
export type ArgsType<F extends AnyFunc> = F extends Func<infer P, any> ? P : never;
export type OperationOptions = {
  variables?: Record<string, any>;
  operationName?: string;
};
export type OperationToGraphQL<V, T> = <Z extends V>(o: Z | V, options?: OperationOptions) => Promise<InputType<T, Z>>;
export type SubscriptionToGraphQL<V, T> = <Z extends V>(
  o: Z | V,
  options?: OperationOptions,
) => {
  ws: WebSocket;
  on: (fn: (args: InputType<T, Z>) => void) => void;
  off: (fn: (e: { data?: InputType<T, Z>; code?: number; reason?: string; message?: string }) => void) => void;
  error: (fn: (e: { data?: InputType<T, Z>; errors?:string[] }) => void) => void;
  open: () => void;
};
export type SelectionFunction<V> = <T>(t: T | V) => T;
export type fetchOptions = ArgsType<typeof fetch>;
type websocketOptions = typeof WebSocket extends new (
  ...args: infer R
) => WebSocket
  ? R
  : never;
export type chainOptions =
  | [fetchOptions[0], fetchOptions[1] & {websocket?: websocketOptions}]
  | [fetchOptions[0]];
export type FetchFunction = (
  query: string,
  variables?: Record<string, any>,
) => Promise<any>;
export type SubscriptionFunction = (query: string) => void;
type NotUndefined<T> = T extends undefined ? never : T;
export type ResolverType<F> = NotUndefined<F extends [infer ARGS, any] ? ARGS : undefined>;



export const ZeusSelect = <T>() => ((t: any) => t) as SelectionFunction<T>;

export const ScalarResolver = (scalar: string, value: any) => {
  switch (scalar) {
    case 'String':
      return  `${JSON.stringify(value)}`;
    case 'Int':
      return `${value}`;
    case 'Float':
      return `${value}`;
    case 'Boolean':
      return `${value}`;
    case 'ID':
      return `"${value}"`;
    case 'enum':
      return `${value}`;
    case 'scalar':
      return `${value}`;
    default:
      return false;
  }
};


export const TypesPropsResolver = ({
    value,
    type,
    name,
    key,
    blockArrays
}: {
    value: any;
    type: string;
    name: string;
    key?: string;
    blockArrays?: boolean;
}): string => {
    if (value === null) {
        return `null`;
    }
    let resolvedValue = AllTypesProps[type][name];
    if (key) {
        resolvedValue = resolvedValue[key];
    }
    if (!resolvedValue) {
        throw new Error(`Cannot resolve ${type} ${name}${key ? ` ${key}` : ''}`)
    }
    const typeResolved = resolvedValue.type;
    const isArray = resolvedValue.array;
    const isArrayRequired = resolvedValue.arrayRequired;
    if (typeof value === 'string' && value.startsWith(`ZEUS_VAR$`)) {
        const isRequired = resolvedValue.required ? '!' : '';
        let t = `${typeResolved}`;
        if (isArray) {
          if (isRequired) {
              t = `${t}!`;
          }
          t = `[${t}]`;
          if(isArrayRequired){
            t = `${t}!`;
          }
        }else{
          if (isRequired) {
                t = `${t}!`;
          }
        }
        return `\$${value.split(`ZEUS_VAR$`)[1]}__ZEUS_VAR__${t}`;
    }
    if (isArray && !blockArrays) {
        return `[${value
        .map((v: any) => TypesPropsResolver({ value: v, type, name, key, blockArrays: true }))
        .join(',')}]`;
    }
    const reslovedScalar = ScalarResolver(typeResolved, value);
    if (!reslovedScalar) {
        const resolvedType = AllTypesProps[typeResolved];
        if (typeof resolvedType === 'object') {
        const argsKeys = Object.keys(resolvedType);
        return `{${argsKeys
            .filter((ak) => value[ak] !== undefined)
            .map(
            (ak) => `${ak}:${TypesPropsResolver({ value: value[ak], type: typeResolved, name: ak })}`
            )}}`;
        }
        return ScalarResolver(AllTypesProps[typeResolved], value) as string;
    }
    return reslovedScalar;
};


const isArrayFunction = (
  parent: string[],
  a: any[]
) => {
  const [values, r] = a;
  const [mainKey, key, ...keys] = parent;
  const keyValues = Object.keys(values).filter((k) => typeof values[k] !== 'undefined');

  if (!keys.length) {
      return keyValues.length > 0
        ? `(${keyValues
            .map(
              (v) =>
                `${v}:${TypesPropsResolver({
                  value: values[v],
                  type: mainKey,
                  name: key,
                  key: v
                })}`
            )
            .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
        : traverseToSeekArrays(parent, r);
    }

  const [typeResolverKey] = keys.splice(keys.length - 1, 1);
  let valueToResolve = ReturnTypes[mainKey][key];
  for (const k of keys) {
    valueToResolve = ReturnTypes[valueToResolve][k];
  }

  const argumentString =
    keyValues.length > 0
      ? `(${keyValues
          .map(
            (v) =>
              `${v}:${TypesPropsResolver({
                value: values[v],
                type: valueToResolve,
                name: typeResolverKey,
                key: v
              })}`
          )
          .join(',')})${r ? traverseToSeekArrays(parent, r) : ''}`
      : traverseToSeekArrays(parent, r);
  return argumentString;
};


const resolveKV = (k: string, v: boolean | string | { [x: string]: boolean | string }) =>
  typeof v === 'boolean' ? k : typeof v === 'object' ? `${k}{${objectToTree(v)}}` : `${k}${v}`;


const objectToTree = (o: { [x: string]: boolean | string }): string =>
  `{${Object.keys(o).map((k) => `${resolveKV(k, o[k])}`).join(' ')}}`;


const traverseToSeekArrays = (parent: string[], a?: any): string => {
  if (!a) return '';
  if (Object.keys(a).length === 0) {
    return '';
  }
  let b: Record<string, any> = {};
  if (Array.isArray(a)) {
    return isArrayFunction([...parent], a);
  } else {
    if (typeof a === 'object') {
      Object.keys(a)
        .filter((k) => typeof a[k] !== 'undefined')
        .forEach((k) => {
        if (k === '__alias') {
          Object.keys(a[k]).forEach((aliasKey) => {
            const aliasOperations = a[k][aliasKey];
            const aliasOperationName = Object.keys(aliasOperations)[0];
            const aliasOperation = aliasOperations[aliasOperationName];
            b[
              `${aliasOperationName}__alias__${aliasKey}: ${aliasOperationName}`
            ] = traverseToSeekArrays([...parent, aliasOperationName], aliasOperation);
          });
        } else {
          b[k] = traverseToSeekArrays([...parent, k], a[k]);
        }
      });
    } else {
      return '';
    }
  }
  return objectToTree(b);
};  


const buildQuery = (type: string, a?: Record<any, any>) => 
  traverseToSeekArrays([type], a);


const inspectVariables = (query: string) => {
  const regex = /\$\b\w*__ZEUS_VAR__\[?[^!^\]^\s^,^\)^\}]*[!]?[\]]?[!]?/g;
  let result;
  const AllVariables: string[] = [];
  while ((result = regex.exec(query))) {
    if (AllVariables.includes(result[0])) {
      continue;
    }
    AllVariables.push(result[0]);
  }
  if (!AllVariables.length) {
    return query;
  }
  let filteredQuery = query;
  AllVariables.forEach((variable) => {
    while (filteredQuery.includes(variable)) {
      filteredQuery = filteredQuery.replace(variable, variable.split('__ZEUS_VAR__')[0]);
    }
  });
  return `(${AllVariables.map((a) => a.split('__ZEUS_VAR__'))
    .map(([variableName, variableType]) => `${variableName}:${variableType}`)
    .join(', ')})${filteredQuery}`;
};


export const queryConstruct = (t: 'query' | 'mutation' | 'subscription', tName: string, operationName?: string) => (o: Record<any, any>) =>
  `${t.toLowerCase()}${operationName ? ' ' + operationName : ''}${inspectVariables(buildQuery(tName, o))}`;
  

const fullChainConstruct = (fn: FetchFunction) => (t: 'query' | 'mutation' | 'subscription', tName: string) => (
  o: Record<any, any>,
  options?: OperationOptions,
) => fn(queryConstruct(t, tName, options?.operationName)(o), options?.variables).then((r:any) => { 
  seekForAliases(r)
  return r
});

export const fullChainConstructor = <F extends FetchFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullChainConstruct(fn)(operation, key)(o as any, options)) as OperationToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const fullSubscriptionConstruct = (fn: SubscriptionFunction) => (
  t: 'query' | 'mutation' | 'subscription',
  tName: string,
) => (o: Record<any, any>, options?: OperationOptions) =>
  fn(queryConstruct(t, tName, options?.operationName)(o));

export const fullSubscriptionConstructor = <F extends SubscriptionFunction, R extends keyof ValueTypes>(
  fn: F,
  operation: 'query' | 'mutation' | 'subscription',
  key: R,
) =>
  ((o, options) => fullSubscriptionConstruct(fn)(operation, key)(o as any, options)) as SubscriptionToGraphQL<
    ValueTypes[R],
    GraphQLTypes[R]
  >;


const seekForAliases = (response: any) => {
  const traverseAlias = (value: any) => {
    if (Array.isArray(value)) {
      value.forEach(seekForAliases);
    } else {
      if (typeof value === 'object') {
        seekForAliases(value);
      }
    }
  };
  if (typeof response === 'object' && response) {
    const keys = Object.keys(response);
    if (keys.length < 1) {
      return;
    }
    keys.forEach((k) => {
      const value = response[k];
      if (k.indexOf('__alias__') !== -1) {
        const [operation, alias] = k.split('__alias__');
        response[alias] = {
          [operation]: value,
        };
        delete response[k];
      }
      traverseAlias(value);
    });
  }
};


export const $ = (t: TemplateStringsArray): any => `ZEUS_VAR$${t.join('')}`;


export const resolverFor = <
  X,
  T extends keyof ValueTypes,
  Z extends keyof ValueTypes[T],
>(
  type: T,
  field: Z,
  fn: (
    args: Required<ValueTypes[T]>[Z] extends [infer Input, any] ? Input : any,
    source: any,
  ) => Z extends keyof ModelTypes[T] ? ModelTypes[T][Z] | Promise<ModelTypes[T][Z]> | X : any,
) => fn as (args?: any,source?: any) => any;


const handleFetchResponse = (
  response: Parameters<Extract<Parameters<ReturnType<typeof fetch>['then']>[0], Function>>[0]
): Promise<GraphQLResponse> => {
  if (!response.ok) {
    return new Promise((_, reject) => {
      response.text().then(text => {
        try { reject(JSON.parse(text)); }
        catch (err) { reject(text); }
      }).catch(reject);
    });
  }
  return response.json();
};

export const apiFetch = (options: fetchOptions) => (query: string, variables: Record<string, any> = {}) => {
    let fetchFunction = fetch;
    let queryString = query;
    let fetchOptions = options[1] || {};
    if (fetchOptions.method && fetchOptions.method === 'GET') {
      queryString = encodeURIComponent(query);
      return fetchFunction(`${options[0]}?query=${queryString}`, fetchOptions)
        .then(handleFetchResponse)
        .then((response: GraphQLResponse) => {
          if (response.errors) {
            throw new GraphQLError(response);
          }
          return response.data;
        });
    }
    return fetchFunction(`${options[0]}`, {
      body: JSON.stringify({ query: queryString, variables }),
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      ...fetchOptions
    })
      .then(handleFetchResponse)
      .then((response: GraphQLResponse) => {
        if (response.errors) {
          throw new GraphQLError(response);
        }
        return response.data;
      });
  };
  

export const apiSubscription = (options: chainOptions) => (
    query: string,
  ) => {
    try {
      const queryString = options[0] + '?query=' + encodeURIComponent(query);
      const wsString = queryString.replace('http', 'ws');
      const host = (options.length > 1 && options[1]?.websocket?.[0]) || wsString;
      const webSocketOptions = options[1]?.websocket || [host];
      const ws = new WebSocket(...webSocketOptions);
      return {
        ws,
        on: (e: (args: any) => void) => {
          ws.onmessage = (event:any) => {
            if(event.data){
              const parsed = JSON.parse(event.data)
              const data = parsed.data
              if (data) {
                seekForAliases(data);
              }
              return e(data);
            }
          };
        },
        off: (e: (args: any) => void) => {
          ws.onclose = e;
        },
        error: (e: (args: any) => void) => {
          ws.onerror = e;
        },
        open: (e: () => void) => {
          ws.onopen = e;
        },
      };
    } catch {
      throw new Error('No websockets implemented');
    }
  };


export const Thunder = (fn: FetchFunction, subscriptionFn: SubscriptionFunction) => ({
  query: fullChainConstructor(fn,'query', 'Query'),
mutation: fullChainConstructor(fn,'mutation', 'Mutation')
});

export const Chain = (...options: chainOptions) => ({
  query: fullChainConstructor(apiFetch(options),'query', 'Query'),
mutation: fullChainConstructor(apiFetch(options),'mutation', 'Mutation')
});
export const Zeus = {
  query: (o:ValueTypes["Query"], operationName?: string) => queryConstruct('query', 'Query', operationName)(o),
mutation: (o:ValueTypes["Mutation"], operationName?: string) => queryConstruct('mutation', 'Mutation', operationName)(o)
};
export const Selectors = {
  query: ZeusSelect<ValueTypes["Query"]>(),
mutation: ZeusSelect<ValueTypes["Mutation"]>()
};
  
export type FragmentResult<K extends keyof GraphQLTypes, Q extends unknown | ((...args: any[]) => unknown)> = InputType<
	GraphQLTypes[K],
	Q extends (...args: any[]) => unknown ? ReturnType<Q> : Q
>